
import { immerable } from "immer";

export interface IReturn<T>
{
    createResponse(): T;
}

export interface IReturnVoid
{
    createResponse(): void;
}

export interface IHasSessionId
{
    sessionId: string|null;
}

export interface IHasBearerToken
{
    bearerToken: string|null;
}

export interface IGet
{
}

export interface IPost
{
}

export interface IPut
{
}

export class SquareCard
{
    public id: string|null;
    public card_brand: string|null;
    public exp_month: number|null;
    public exp_year: number|null;
    public last_4: string|null;
    public customer_id: string|null;
    public cardholder_name: string|null;

    public constructor(init?: Partial<SquareCard>) { (Object as any).assign(this, init); }
}
(SquareCard as unknown)[immerable] = true;

export class SquareMoneyAmount
{
    public amount: number|null;
    public currency: string|null;

    public constructor(init?: Partial<SquareMoneyAmount>) { (Object as any).assign(this, init); }
}
(SquareMoneyAmount as unknown)[immerable] = true;

export class SquareRefund
{
    public id: string|null;
    public created_at: string|null;
    public updated_at: string|null;
    public status: string|null;
    public amount_money: SquareMoneyAmount|null;
    public location_id: string|null;
    public payment_id: string|null;

    public constructor(init?: Partial<SquareRefund>) { (Object as any).assign(this, init); }
}
(SquareRefund as unknown)[immerable] = true;

export class SquareDeviceCode
{
    public code: string|null;
    public created_at: string|null;
    public device_id: string|null;
    public id: string|null;
    public location_id: string|null;
    public name: string|null;
    public paired_at: string|null;
    public product_type: string|null;
    public status: string|null;
    public status_changed_at: string|null;

    public constructor(init?: Partial<SquareDeviceCode>) { (Object as any).assign(this, init); }
}
(SquareDeviceCode as unknown)[immerable] = true;

export class SquareDeviceOptions
{
    public device_id: string|null;
    public skip_receipt_screen: boolean|null;

    public constructor(init?: Partial<SquareDeviceOptions>) { (Object as any).assign(this, init); }
}
(SquareDeviceOptions as unknown)[immerable] = true;

export class SquareTerminalCheckout
{
    public amount_money: SquareMoneyAmount|null;
    public created_at: string|null;
    public deadline_duration: string|null;
    public id: string|null;
    public note: string|null;
    public reference_id: string|null;
    public status: string|null;
    public updated_at: string|null;
    public payment_ids: string[]|null;
    public device_options: SquareDeviceOptions|null;

    public constructor(init?: Partial<SquareTerminalCheckout>) { (Object as any).assign(this, init); }
}
(SquareTerminalCheckout as unknown)[immerable] = true;

export class SquareData
{
    public card: SquareCard|null;
    public refund: SquareRefund|null;
    public device_code: SquareDeviceCode|null;
    public checkout: SquareTerminalCheckout|null;

    public constructor(init?: Partial<SquareData>) { (Object as any).assign(this, init); }
}
(SquareData as unknown)[immerable] = true;

export class SquareWebhookData
{
    public type: string|null;
    public id: string|null;
    public object: SquareData|null;

    public constructor(init?: Partial<SquareWebhookData>) { (Object as any).assign(this, init); }
}
(SquareWebhookData as unknown)[immerable] = true;

export class BillingItem implements IHasId, ILocationId
{
    public accountId: number|null;
    public customerId: number|null;
    public practitionerId: number|null;
    public appointmentId: number|null;
    public locationId: number|null;
    public invoiceId: number|null;
    public stockId: number|null;
    public date: string|null;
    public description: string|null;
    public total: number|null;
    public isPaid: boolean|null;
    public isMigrated: boolean|null;
    public totalExVat: number|null;
    public quantity: number|null;
    public price: number|null;
    public vatRate: number|null;
    public totalVat: number|null;
    public id: number|null;
    public category: string|null;
    public ledgerCode: string|null;
    public accountsExportId: number|null;
    public prontoServiceId: string|null;
    public parentId: number|null;
    public subscriptionId: number|null;
    public discountCodeId: string|null;

    public constructor(init?: Partial<BillingItem>) { (Object as any).assign(this, init); }
}
(BillingItem as unknown)[immerable] = true;

export enum DiscountType
{
    Amount = 'Amount',
    Percentage = 'Percentage',
}

export enum DiscountStatus
{
    Inactive = 'Inactive',
    Active = 'Active',
}

export interface ILocationId
{
    locationId: number|null;
}

export enum AlphaNumericFilterConditions
{
    Equals = 'Equals',
    DoesNotEqual = 'DoesNotEqual',
    StartsWith = 'StartsWith',
    EndsWith = 'EndsWith',
    DoesNotStartWith = 'DoesNotStartWith',
    DoesNotEndWith = 'DoesNotEndWith',
    Contains = 'Contains',
    DoesNotContain = 'DoesNotContain',
    IsSet = 'IsSet',
    IsNotSet = 'IsNotSet',
}

export class AlphaNumericSearch
{
    public selectedFilterOption: AlphaNumericFilterConditions|null;
    public alphaNumericSearchValue: string|null;
    public removeSpaces: boolean|null;

    public constructor(init?: Partial<AlphaNumericSearch>) { (Object as any).assign(this, init); }
}
(AlphaNumericSearch as unknown)[immerable] = true;

export enum LookUpFilterConditions
{
    Is = 'Is',
    IsNot = 'IsNot',
    IsOneOf = 'IsOneOf',
    IsNotOneOf = 'IsNotOneOf',
}

export enum LookUpSearchType
{
    Practitioners = 'Practitioners',
    PatientTags = 'PatientTags',
    Locations = 'Locations',
    Groups = 'Groups',
    PaymentMethod = 'PaymentMethod',
    PaymentStatus = 'PaymentStatus',
    InvoiceStatus = 'InvoiceStatus',
    InvoiceBatch = 'InvoiceBatch',
    StockCategory = 'StockCategory',
    StockTags = 'StockTags',
    LocationStatus = 'LocationStatus',
    BillingItemStatus = 'BillingItemStatus',
    InvoicePeriod = 'InvoicePeriod',
    CaseStatus = 'CaseStatus',
    BodySite = 'BodySite',
    Diagnosis = 'Diagnosis',
    Suppliers = 'Suppliers',
    ExpenditureCategory = 'ExpenditureCategory',
    GroupClassification = 'GroupClassification',
    PractitionerType = 'PractitionerType',
    AuditObjectTypes = 'AuditObjectTypes',
    AuditActions = 'AuditActions',
    AccountType = 'AccountType',
    DebtInvoiceStatus = 'DebtInvoiceStatus',
    DebtAge = 'DebtAge',
    CustomerStatus = 'CustomerStatus',
    Gender = 'Gender',
    Stock = 'Stock',
    AppointmentStatus = 'AppointmentStatus',
    AppointmentType = 'AppointmentType',
    RpUserType = 'RpUserType',
    Tags = 'Tags',
    Skills = 'Skills',
    GdsWorkSheetStatus = 'GdsWorkSheetStatus',
    TimelineType = 'TimelineType',
    Vehicle = 'Vehicle',
}

export class LookUpSearch
{
    public selectedFilterOption: LookUpFilterConditions|null;
    public lookUpSearchType: LookUpSearchType|null;
    public isJsonSearch: boolean|null;
    public lookUpDataType: string|null;
    public lookUpSearchValues: Object[]|null;

    public constructor(init?: Partial<LookUpSearch>) { (Object as any).assign(this, init); }
}
(LookUpSearch as unknown)[immerable] = true;

export enum DateTimeFilterConditions
{
    IsOn = 'IsOn',
    IsNotOn = 'IsNotOn',
    IsBetween = 'IsBetween',
    IsNotBetween = 'IsNotBetween',
    IsBefore = 'IsBefore',
    IsOnOrBefore = 'IsOnOrBefore',
    IsAfter = 'IsAfter',
    IsOnOrAfter = 'IsOnOrAfter',
}

export class DateRange
{
    public from: string|null;
    public to: string|null;

    public constructor(init?: Partial<DateRange>) { (Object as any).assign(this, init); }
}
(DateRange as unknown)[immerable] = true;

export class DateTimeSearch
{
    public selectedFilterOption: DateTimeFilterConditions|null;
    public dateRangeValue: DateRange|null;

    public constructor(init?: Partial<DateTimeSearch>) { (Object as any).assign(this, init); }
}
(DateTimeSearch as unknown)[immerable] = true;

export enum BooleanFilterConditions
{
    IsSet = 'IsSet',
    IsNotSet = 'IsNotSet',
}

export class BooleanSearch
{
    public selectedFilterOption: BooleanFilterConditions|null;
    public booleanSearchValue: boolean|null;

    public constructor(init?: Partial<BooleanSearch>) { (Object as any).assign(this, init); }
}
(BooleanSearch as unknown)[immerable] = true;

export class SearchFilterConditionItem
{
    public alphaNumericSearchFieldCondition: AlphaNumericSearch|null;
    public lookUpSearchFieldCondition: LookUpSearch|null;
    public dateTimeSearchFieldCondition: DateTimeSearch|null;
    public booleanSearchFieldCondition: BooleanSearch|null;
    public integerSearchFieldCondition: NumericSearch<number>|null;
    public decimalSearchFieldCondition: NumericSearch<number>|null;

    public constructor(init?: Partial<SearchFilterConditionItem>) { (Object as any).assign(this, init); }
}
(SearchFilterConditionItem as unknown)[immerable] = true;

export enum SearchFieldDataType
{
    StringField = 'StringField',
    AlphaNumericField = 'AlphaNumericField',
    LookUpField = 'LookUpField',
    BooleanField = 'BooleanField',
    DateTimeField = 'DateTimeField',
    JsonField = 'JsonField',
    IntegerField = 'IntegerField',
    DecimalField = 'DecimalField',
}

export enum Delimiters
{
    None = 'None',
    Space = 'Space',
    Comma = 'Comma',
}

export class SearchFilterCondition
{
    public conditions: SearchFilterConditionItem[]|null;
    public fieldName: string|null;
    public displayName: string|null;
    public fieldType: SearchFieldDataType|null;
    public displayOnGrid: boolean|null;
    public isFilterApplied: boolean|null;
    public isCustom: boolean|null;
    public delimiters: Delimiters|null;
    public customIsSetText: string|null;
    public customIsNotSetText: string|null;
    public module: string|null;

    public constructor(init?: Partial<SearchFilterCondition>) { (Object as any).assign(this, init); }
}
(SearchFilterCondition as unknown)[immerable] = true;

export class QueryField
{
    // @ApiMember(ExcludeInSchema=true)
    public customFieldNames: string[]|null;

    /** @description Field Name to sort by */
    // @ApiMember(Description="Field Name to sort by")
    public field: string|null;

    /** @description Sort order - `asc` or `desc` */
    // @ApiMember(Description="Sort order - `asc` or `desc`")
    public dir: string|null;

    public constructor(init?: Partial<QueryField>) { (Object as any).assign(this, init); }
}
(QueryField as unknown)[immerable] = true;

export class BaseAdvancedSearchRequest implements ILocationIds, IFilterServiceTypeManually
{
    public filterConditions: SearchFilterCondition[]|null;
    public appliedFilters: SearchFilterCondition[]|null;
    public appliedCustomFilters: SearchFilterCondition[]|null;
    public skip: number|null;
    public take: number|null;
    public groups: QueryField[]|null;
    public sort: QueryField[]|null;
    public term: string|null;
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;

    public constructor(init?: Partial<BaseAdvancedSearchRequest>) { (Object as any).assign(this, init); }
}
(BaseAdvancedSearchRequest as unknown)[immerable] = true;

export interface ILocationIds
{
    locationIds: number[]|null;
    requestLocationIds: number[]|null;
}

export interface IFilterServiceTypeManually
{
}

export interface ISecurityId
{
    securityId: number|null;
}

export enum ResetMode
{
    None = 'None',
    PassKey = 'PassKey',
    MFA = 'MFA',
    Password = 'Password',
}

export class UserRoleLocationDto
{
    public id: number|null;
    public locationId: number|null;
    public userId: number|null;
    public roleId: number|null;
    public globalGuid: string|null;

    public constructor(init?: Partial<UserRoleLocationDto>) { (Object as any).assign(this, init); }
}
(UserRoleLocationDto as unknown)[immerable] = true;

export interface IHasPath
{
    path: string|null;
    safeRoot: string|null;
}

export class CommandBarRequest implements ILocationIds
{
    public term: string|null;
    public limit: number|null;
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;

    public constructor(init?: Partial<CommandBarRequest>) { (Object as any).assign(this, init); }
}
(CommandBarRequest as unknown)[immerable] = true;

export enum MergeFieldType
{
    Workflow = 'Workflow',
    SubWorkflow = 'SubWorkflow',
    Network = 'Network',
    NetworkClinician = 'NetworkClinician',
    NetworkLocation = 'NetworkLocation',
}

export enum MergeFieldDataType
{
    Text = 'Text',
    Date = 'Date',
    DateTime = 'DateTime',
}

export class MergeFieldMappingDto
{
    public id: string|null;
    public type: MergeFieldType|null;
    public name: string|null;
    public field: string|null;
    public dataType: MergeFieldDataType|null;

    public constructor(init?: Partial<MergeFieldMappingDto>) { (Object as any).assign(this, init); }
}
(MergeFieldMappingDto as unknown)[immerable] = true;

export class BatchInvoiceMergeDataRequestObject
{
    public id: number|null;
    public template: string|null;

    public constructor(init?: Partial<BatchInvoiceMergeDataRequestObject>) { (Object as any).assign(this, init); }
}
(BatchInvoiceMergeDataRequestObject as unknown)[immerable] = true;

export interface ISecurityIds
{
    securityIds: number[]|null;
}

export class BatchMergeDataRequestObject
{
    public id: number|null;
    public template: string|null;
    public type: string|null;

    public constructor(init?: Partial<BatchMergeDataRequestObject>) { (Object as any).assign(this, init); }
}
(BatchMergeDataRequestObject as unknown)[immerable] = true;

export interface ISecurityType
{
    securityType: string|null;
}

export interface IDepartmentIds
{
    departmentIds: number[]|null;
}

export interface IAllowedDepartmentIds
{
    allowedDepartmentIds: number[]|null;
}

export interface ICustomerId
{
    customerId: number|null;
}

export enum PackageBundleItemType
{
    Consultancy = 'Consultancy',
    Stock = 'Stock',
    Course = 'Course',
    Class = 'Class',
}

export interface IInvoiceId
{
    invoiceId: number|null;
}

export class CustomerCSVHeaderOverrides
{
    public status: string|null;
    public reference: string|null;
    public name: string|null;
    public address: string|null;
    public postCode: string|null;
    public dateOfBirth: string|null;
    public number: string|null;
    public email: string|null;
    public registrationDate: string|null;
    public balanceInvoiced: string|null;
    public locationName: string|null;
    public groupName: string|null;
    public practitionerName: string|null;

    public constructor(init?: Partial<CustomerCSVHeaderOverrides>) { (Object as any).assign(this, init); }
}
(CustomerCSVHeaderOverrides as unknown)[immerable] = true;

export class MedicalContactsCSVHeaderOverrides
{
    public status: string|null;
    public reference: string|null;
    public forename: string|null;
    public surname: string|null;
    public businessName: string|null;
    public address: string|null;
    public telephone: string|null;
    public email: string|null;
    public web: string|null;
    public locationName: string|null;

    public constructor(init?: Partial<MedicalContactsCSVHeaderOverrides>) { (Object as any).assign(this, init); }
}
(MedicalContactsCSVHeaderOverrides as unknown)[immerable] = true;

export interface IServiceTypeId
{
    serviceTypeId: number|null;
}

export class DiaryListBase extends BaseAdvancedSearchRequest
{
    public date: string|null;
    public isWeek: boolean|null;
    public practitionerIds: number[]|null;
    public locationId: number|null;
    public appointmentId: number|null;

    public constructor(init?: Partial<DiaryListBase>) { super(init); (Object as any).assign(this, init); }
}
(DiaryListBase as unknown)[immerable] = true;

export interface IHasAutoRefresh
{
    autoRefresh: boolean|null;
}

export enum ResourceMode
{
    Room = 'Room',
    Practitioner = 'Practitioner',
}

export enum RecurrenceType
{
    None = 'None',
    Day = 'Day',
    Week = 'Week',
    Fortnight = 'Fortnight',
    Month = 'Month',
    Quarter = 'Quarter',
    Year = 'Year',
    Custom = 'Custom',
    WorkingDay = 'WorkingDay',
}

export enum InvoicePeriod
{
    All = 'All',
    Monthly = 'Monthly',
    AfterEachAppointment = 'AfterEachAppointment',
    AdHoc = 'AdHoc',
    Manual = 'Manual',
    Discharge = 'Discharge',
}

export enum ChargeSearchMode
{
    All = 'All',
    PrivateOnly = 'PrivateOnly',
    AllGroups = 'AllGroups',
    SelectedGroups = 'SelectedGroups',
    HealthcodeGroups = 'HealthcodeGroups',
}

export enum InvoicedStatusToInclude
{
    All = 'All',
    Uninvoiced = 'Uninvoiced',
    Invoiced = 'Invoiced',
}

export class CurrencyRange
{
    public min: number|null;
    public max: number|null;

    public constructor(init?: Partial<CurrencyRange>) { (Object as any).assign(this, init); }
}
(CurrencyRange as unknown)[immerable] = true;

export interface IChargeSearchRequest extends ILocationIds
{
    sort: QueryField[]|null;
    invoicePeriod: InvoicePeriod|null;
    mode: ChargeSearchMode|null;
    invoicedStatus: InvoicedStatusToInclude|null;
    groupIds: number[]|null;
    date: DateRange|null;
    addressTo: string|null;
    description: string|null;
    amount: CurrencyRange|null;
    term: string|null;
    locked: boolean|null;
    displayDiscountCodes: boolean|null;
}

export class ChargeGroup
{
    public accountId: number|null;
    public type: string|null;
    public charges: number[]|null;

    public constructor(init?: Partial<ChargeGroup>) { (Object as any).assign(this, init); }
}
(ChargeGroup as unknown)[immerable] = true;

export class InvoiceBatch implements IHasId
{
    public id: number|null;
    public date: string|null;

    public constructor(init?: Partial<InvoiceBatch>) { (Object as any).assign(this, init); }
}
(InvoiceBatch as unknown)[immerable] = true;

export class Charge
{
    public locationId: number|null;
    public accountId: number|null;
    public customerId: number|null;
    public appointmentId: number|null;
    public practitionerId: number|null;
    public invoiceId: number|null;
    public stockId: number|null;
    public paid: number|null;
    public migrated: number|null;
    public transferred: number|null;
    public roomId: number|null;
    public accountsExportId: number|null;
    public createdByUserId: number|null;
    public description: string|null;
    public category: string|null;
    public ledgerCode: string|null;
    public discriminatorType: string|null;
    public totalExVat: number|null;
    public quantity: number|null;
    public price: number|null;
    public vatRate: number|null;
    public totalVat: number|null;
    public total: number|null;
    public date: string|null;
    public parentId: number|null;

    public constructor(init?: Partial<Charge>) { (Object as any).assign(this, init); }
}
(Charge as unknown)[immerable] = true;

export class Invoice implements ILocationId, IHasReference, IHasDocuments
{
    public id: number|null;
    public status: string|null;
    public reference: string|null;
    public date: string|null;
    public dueDate: string|null;
    public fullyPaidDate: string|null;
    public grandTotal: number|null;
    public amountPaid: number|null;
    public customerId: number|null;
    public locationId: number|null;
    public accountId: number|null;
    public addressTo: string|null;
    public addressLine1: string|null;
    public addressLine2: string|null;
    public addressLine3: string|null;
    public addressLine4: string|null;
    public addressLine5: string|null;
    public postCode: string|null;
    public reminder: string|null;
    public secondReminder: string|null;
    public totalExcludingVat: number|null;
    public vatAmount: number|null;
    public batchId: number|null;
    public notes: string|null;
    public globalId: string|null;
    public globalType: number|null;
    public paymentStatus: string|null;
    public medipassTransactionId: string|null;
    public medipassStatus: string|null;
    public purchaseOrderNumber: string|null;
    public medicalContactId: number|null;
    public referralDate: string|null;
    public documentsLoaded: boolean|null;
    public isSquarePrepayment: boolean|null;
    // @Ignore()
    public documentsSubDirectory: string|null;

    public constructor(init?: Partial<Invoice>) { (Object as any).assign(this, init); }
}
(Invoice as unknown)[immerable] = true;

export class Income implements ILocationId, IHasReference
{
    public id: number|null;
    public amount: number|null;
    public paymentMethod: string|null;
    public otherPaymentMethod: string|null;
    public customerId: number|null;
    public status: string|null;
    public date: string|null;
    public reference: string|null;
    public lodgementRef: string|null;
    public accountId: number|null;
    public accountsExportId: number|null;
    public locationId: number|null;
    public receivedAtLocationId: number|null;
    public notes: string|null;
    public cardType: string|null;
    public cardNumber: string|null;
    public expiry: string|null;
    public chequeNumber: string|null;
    public migrated: boolean|null;
    public transferred: boolean|null;
    public paidBy: string|null;
    public refundReason: string|null;
    public paymentIntentId: string|null;
    public electronicPaymentDate: string|null;
    public importDate: string|null;
    public importBatchId: string|null;
    public merchantReference: string|null;
    public authorisationCode: string|null;
    public squarePaymentId: string|null;
    // @Ignore()
    public meta: { [index:string]: Object; }|null;

    public data: { [index:string]: string; }|null;

    public constructor(init?: Partial<Income>) { (Object as any).assign(this, init); }
}
(Income as unknown)[immerable] = true;

export interface IHasId extends IHasIdMarker
{
    id: number|null;
}

export interface IHasIdMarker
{
}

export interface IHasReference extends IHasId
{
    reference: string|null;
}

export class ReconciliationResponse
{
    public id: number|null;
    public status: string|null;
    public date: string|null;
    public paymentId: number|null;
    public reference: string|null;
    public name: string|null;
    public total: number|null;
    public paid: number|null;
    public reconciled: number|null;
    public customerName: string|null;

    public constructor(init?: Partial<ReconciliationResponse>) { (Object as any).assign(this, init); }
}
(ReconciliationResponse as unknown)[immerable] = true;

export enum QuickBillMode
{
    Patient = 'Patient',
    Appointment = 'Appointment',
    MyClinics = 'MyClinics',
}

// @Flags()
export enum EPrePaidType
{
    Items = 0,
    Credits = 1,
}

export enum QuickPayType
{
    Customer = 'Customer',
    Group = 'Group',
    Medipass = 'Medipass',
}

export enum QuickPayMode
{
    PayLater = 'PayLater',
    DoNotBill = 'DoNotBill',
    InvoiceAndDoMore = 'InvoiceAndDoMore',
    Cash = 'Cash',
    Cheque = 'Cheque',
    Card = 'Card',
    Chase = 'Chase',
    Token = 'Token',
    Medipass = 'Medipass',
    Terminal = 'Terminal',
    Prepayment = 'Prepayment',
}

export enum PaymentProviderName
{
    None = 'None',
    Stripe = 'Stripe',
    Worldpay = 'Worldpay',
    Square = 'Square',
    ClearAccept = 'ClearAccept',
}

export enum TerminalPaymentProviderPaymentStatus
{
    None = 'None',
    InProgress = 'InProgress',
    Complete = 'Complete',
    Error = 'Error',
    Cancelled = 'Cancelled',
}

export enum PaymentProviderPaymentStatus
{
    None = 'None',
    NotFound = 'NotFound',
    Pending = 'Pending',
    Success = 'Success',
    Error = 'Error',
    Cancelled = 'Cancelled',
    Refunded = 'Refunded',
    Voided = 'Voided',
}

export class TerminalPaymentDto
{
    public provider: PaymentProviderName|null;
    public data: { [index:string]: string; }|null;
    public merchantReference: string|null;
    public terminalStatus: TerminalPaymentProviderPaymentStatus|null;
    public status: PaymentProviderPaymentStatus|null;
    public message: string|null;
    public invoiceId: number|null;
    public terminalId: string|null;
    public cardType: string|null;
    public transactionId: string|null;
    public incomeId: number|null;

    public constructor(init?: Partial<TerminalPaymentDto>) { (Object as any).assign(this, init); }
}
(TerminalPaymentDto as unknown)[immerable] = true;

export class QuickPayment
{
    public type: QuickPayType|null;
    public mode: QuickPayMode|null;
    public amount: number|null;
    public locationId: number|null;
    public receivedAtLocationId: number|null;
    public invoicePeriod: string|null;
    public accountId: number|null;
    public chequeNo: string|null;
    public token: string|null;
    public customerId: number|null;
    public isNewCard: boolean|null;
    public terminalPayment: TerminalPaymentDto|null;
    public meta: { [index:string]: Object; }|null;

    public constructor(init?: Partial<QuickPayment>) { (Object as any).assign(this, init); }
}
(QuickPayment as unknown)[immerable] = true;

export interface IHasNewPath
{
    newName: string|null;
    safeRoot: string|null;
}

export interface ICookies
{
    collection: Cookie[]|null;
}

export interface IHttpResponse
{
    cookies: ICookies|null;
}

export interface IHttpRequest
{
    httpResponse: IHttpResponse|null;
    httpMethod: string|null;
    xForwardedFor: string|null;
    xForwardedPort: number|null;
    xForwardedProtocol: string|null;
    xRealIp: string|null;
    accept: string|null;
}

// @DataContract
export class ResponseError
{
    // @DataMember(Order=1)
    public errorCode: string|null;

    // @DataMember(Order=2)
    public fieldName: string|null;

    // @DataMember(Order=3)
    public message: string|null;

    // @DataMember(Order=4)
    public meta: { [index:string]: string; }|null;

    public constructor(init?: Partial<ResponseError>) { (Object as any).assign(this, init); }
}
(ResponseError as unknown)[immerable] = true;

// @DataContract
export class ResponseStatus
{
    // @DataMember(Order=1)
    public errorCode: string|null;

    // @DataMember(Order=2)
    public message: string|null;

    // @DataMember(Order=3)
    public stackTrace: string|null;

    // @DataMember(Order=4)
    public errors: ResponseError[]|null;

    // @DataMember(Order=5)
    public meta: { [index:string]: string; }|null;

    public constructor(init?: Partial<ResponseStatus>) { (Object as any).assign(this, init); }
}
(ResponseStatus as unknown)[immerable] = true;

export class DownloadBatchRequestObject
{
    public path: string|null;
    public fileName: string|null;

    public constructor(init?: Partial<DownloadBatchRequestObject>) { (Object as any).assign(this, init); }
}
(DownloadBatchRequestObject as unknown)[immerable] = true;

export interface IHasPaths
{
    securityPaths: string[]|null;
}

export enum DocumentType
{
    Letter = 'Letter',
    SMS = 'SMS',
    Email = 'Email',
}

export class GroupsCSVHeaderOverrides
{
    public status: string|null;
    public reference: string|null;
    public name: string|null;
    public contact: string|null;
    public address: string|null;
    public telephone: string|null;
    public email: string|null;
    public web: string|null;
    public balanceInvoiced: string|null;
    public locations: string|null;

    public constructor(init?: Partial<GroupsCSVHeaderOverrides>) { (Object as any).assign(this, init); }
}
(GroupsCSVHeaderOverrides as unknown)[immerable] = true;

export class StockLocationItem
{
    public locId: number|null;
    public stockId: number|null;

    public constructor(init?: Partial<StockLocationItem>) { (Object as any).assign(this, init); }
}
(StockLocationItem as unknown)[immerable] = true;

export class GroupProfileDto implements IHasId
{
    public id: number|null;
    public profileField1: boolean|null;
    public profileField2: boolean|null;
    public profileField3: boolean|null;
    public profileField4: boolean|null;
    public profileField5: boolean|null;
    public profileField6: boolean|null;
    public profileField7: boolean|null;
    public profileField8: boolean|null;

    public constructor(init?: Partial<GroupProfileDto>) { (Object as any).assign(this, init); }
}
(GroupProfileDto as unknown)[immerable] = true;

export class NotificationSubscription implements IHasId
{
    public id: number|null;
    public type: string|null;
    public typeId: number|null;
    public handlerId: string|null;

    public constructor(init?: Partial<NotificationSubscription>) { (Object as any).assign(this, init); }
}
(NotificationSubscription as unknown)[immerable] = true;

export class GroupStockResponse
{
    public id: number|null;
    public stockId: number|null;
    public reference: string|null;
    public totalPrice: number|null;
    public description: string|null;
    public appointmentLength: number|null;
    public groupLocationLocationId: number|null;
    public serviceTypeId: number|null;
    public stockIsCancel: boolean|null;
    public stockIsFirst: boolean|null;
    public stockIsFollowUp: boolean|null;
    public stockIsDNA: boolean|null;
    public category: string|null;
    public onlineGuid: string|null;
    public isMultiLocation: boolean|null;

    public constructor(init?: Partial<GroupStockResponse>) { (Object as any).assign(this, init); }
}
(GroupStockResponse as unknown)[immerable] = true;

export class LocResponse
{
    public id: number|null;
    public groupLocationId: number|null;
    public groupId: number|null;
    public locationId: number|null;
    public firstAppointmentStockId: number|null;
    public nextAppointmentStockId: number|null;
    public providerNo: string|null;
    public name: string|null;
    public addressLine1: string|null;
    public addressLine2: string|null;
    public addressLine3: string|null;
    public addressLine4: string|null;
    public addressLine5: string|null;
    public address: string|null;
    public postCode: string|null;
    public fax: string|null;
    public web: string|null;
    public telephone: string|null;
    public email: string|null;
    public stock: GroupStockResponse[]|null;
    public specificStock: GroupStockResponse[]|null;

    public constructor(init?: Partial<LocResponse>) { (Object as any).assign(this, init); }
}
(LocResponse as unknown)[immerable] = true;

export class AddBusinessModel
{
    public id: number|null;
    public name: string|null;
    public isActive: boolean|null;

    public constructor(init?: Partial<AddBusinessModel>) { (Object as any).assign(this, init); }
}
(AddBusinessModel as unknown)[immerable] = true;

export class PractitionerLocationPair
{
    public locationId: number|null;
    public practitionerId: number|null;

    public constructor(init?: Partial<PractitionerLocationPair>) { (Object as any).assign(this, init); }
}
(PractitionerLocationPair as unknown)[immerable] = true;

export enum PractitionerStatus
{
    Inactive = 'Inactive',
    Active = 'Active',
    PayAsYouGo = 'PayAsYouGo',
}

export class PractitionerStatusUpdate
{
    public id: number|null;
    public status: PractitionerStatus|null;

    public constructor(init?: Partial<PractitionerStatusUpdate>) { (Object as any).assign(this, init); }
}
(PractitionerStatusUpdate as unknown)[immerable] = true;

export class PractitionerSkillBaseRequest
{
    public practitionerGuid: string|null;
    public specialismId: string|null;

    public constructor(init?: Partial<PractitionerSkillBaseRequest>) { (Object as any).assign(this, init); }
}
(PractitionerSkillBaseRequest as unknown)[immerable] = true;

export class BulkUpdateField
{
    public name: string|null;
    public propertyName: string|null;
    public type: string|null;
    public searchType: LookUpSearchType|null;
    public isCustom: boolean|null;
    public includeNone: boolean|null;

    public constructor(init?: Partial<BulkUpdateField>) { (Object as any).assign(this, init); }
}
(BulkUpdateField as unknown)[immerable] = true;

export enum BulkActionRecordType
{
    Patient = 'Patient',
    Diary = 'Diary',
    Stock = 'Stock',
    Practitioner = 'Practitioner',
    Record = 'Record',
}

export class BulkActionBaseRequest<T> implements ILocationIds, IBulkAction
{
    public recordType: BulkActionRecordType|null;
    public selectedIds: number[]|null;
    public selectAll: boolean|null;
    public searchRequest: T|null;
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;

    public constructor(init?: Partial<BulkActionBaseRequest<T>>) { (Object as any).assign(this, init); }
}

export class AlertResponse implements IHasId
{
    public title: string|null;
    public notes: string|null;
    public objectId: number|null;
    public userId: number|null;
    public future: boolean|null;
    public startDateTime: string|null;
    public flagType: number|null;
    public id: number|null;
    public discriminatorType: string|null;
    public complete: boolean|null;
    public requiresAcknowledgement: boolean|null;
    public serviceTypeId: number|null;

    public constructor(init?: Partial<AlertResponse>) { (Object as any).assign(this, init); }
}
(AlertResponse as unknown)[immerable] = true;

export class GeneralPractitionerResponse
{
    public id: number|null;
    public fullName: string|null;
    public name: string|null;
    public defaultRoomId: number|null;
    public code: string|null;
    public fullAddress: string|null;
    public locationName: string|null;
    public title: string|null;
    public forename: string|null;
    public surname: string|null;
    public gender: string|null;
    public addressLine1: string|null;
    public addressLine2: string|null;
    public addressLine3: string|null;
    public addressLine4: string|null;
    public addressLine5: string|null;
    public postCode: string|null;
    public telephone: string|null;
    public mobile: string|null;
    public homeTelephone: string|null;
    public email: string|null;
    public fax: string|null;
    public web: string|null;
    public online: boolean|null;
    public status: number|null;
    public type: string|null;
    public contractNumber: string|null;
    public onlineGuid: string|null;
    public physitrackToken: string|null;
    public defaultLocationId: number|null;
    public serviceTypeId: number|null;
    public regNumber: string|null;
    public commissionFlatRate: number|null;
    public commissionPercent: number|null;
    public employmentStatus: string|null;
    public timeSlot: number|null;
    public providerNo: string|null;
    public taxNo: string|null;
    public alerts: AlertResponse[]|null;
    public locationIds: number[]|null;
    public skills: string[]|null;
    public zoomUserId: string|null;
    public orderId: number|null;

    public constructor(init?: Partial<GeneralPractitionerResponse>) { (Object as any).assign(this, init); }
}

// @Route("/practitioners/all")
export class AllPractitionersRequest extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<GeneralPractitionerResponse>>
{
    public fullname: string|null;
    public code: string|null;
    public status: number|null;
    public address: string|null;

    public constructor(init?: Partial<AllPractitionersRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'AllPractitionersRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<GeneralPractitionerResponse>(); }
}
(AllPractitionersRequest as unknown)[immerable] = true;

export class PractitionerBulkActionBaseRequest extends BulkActionBaseRequest<AllPractitionersRequest>
{

    public constructor(init?: Partial<PractitionerBulkActionBaseRequest>) { super(init); (Object as any).assign(this, init); }
}
(PractitionerBulkActionBaseRequest as unknown)[immerable] = true;

export interface IBulkAction
{
    selectedIds: number[]|null;
    selectAll: boolean|null;
}

export class RestrictedCustomerAlertDetails
{
    public title: string|null;
    public notes: string|null;
    public objectId: number|null;
    public userId: number|null;
    public future: boolean|null;
    public startDateTime: string|null;
    public flagType: number|null;
    public id: number|null;
    public discriminatorType: string|null;
    public complete: boolean|null;
    public requiresAcknowledgement: boolean|null;

    public constructor(init?: Partial<RestrictedCustomerAlertDetails>) { (Object as any).assign(this, init); }
}
(RestrictedCustomerAlertDetails as unknown)[immerable] = true;

export class RestrictedCustomerDetails
{
    public id: number|null;
    public title: string|null;
    public forename: string|null;
    public surname: string|null;
    public gender: string|null;
    public status: number|null;
    public locationId: number|null;
    public smsEnabled: boolean|null;
    public reference: string|null;
    public email: string|null;
    public mobileTelephone: string|null;
    public dateOfBirth: string|null;
    public alerts: RestrictedCustomerAlertDetails[]|null;

    public constructor(init?: Partial<RestrictedCustomerDetails>) { (Object as any).assign(this, init); }
}
(RestrictedCustomerDetails as unknown)[immerable] = true;

export class AppointmentResponse
{
    public id: number|null;
    public startDateTime: string|null;
    public endDateTime: string|null;
    public name: string|null;
    public status: number|null;
    public type: string|null;
    public reference: string|null;
    public bookingMethod: string|null;
    public bookedByName: string|null;
    public bookingDateTime: string|null;
    public duration: number|null;
    public firstAppointment: boolean|null;
    public comment: string|null;
    public title: string|null;
    public customerId: number|null;
    public practitionerId: number|null;
    public locationId: number|null;
    public roomId: number|null;
    public stockId: number|null;
    public practitioner: string|null;
    public practitionerStatus: number|null;
    public location: string|null;
    public roomName: string|null;
    public stock: string|null;
    public inDebt: boolean|null;
    public colour: number|null;
    public stockColour: number|null;
    public description: string|null;
    public hexColour: string|null;
    public classMax: number|null;
    public classAttendees: number|null;
    public customerAlert: boolean|null;
    public customerLastAppointment: string|null;
    public reminderSentType: string|null;
    public reminderType: string|null;
    public payAtEachAppt: boolean|null;
    public authId: number|null;
    public groupId: number|null;
    public groupName: string|null;
    public groupAddressTo: string|null;
    public authCode: string|null;
    public caseId: number|null;
    public auditId: string|null;
    public prontoAuditId: string|null;
    public prontoAppointmentId: string|null;
    public prontoServiceId: string|null;
    public patient: RestrictedCustomerDetails|null;
    public meta: { [index:string]: Object; }|null;
    public serviceTypeId: number|null;
    public serviceType: string|null;
    public isVideo: boolean|null;
    public videoCode: string|null;
    public discountCodeId: string|null;
    public discountCodeAppliedDate: string|null;
    public discountCodeAdvance: boolean|null;
    public cancellationReason: string|null;
    public videoLink: string|null;
    public videoMeetingParticipantJoinUrl: string|null;
    public videoMeetingPassword: string|null;
    public creditUsage: number|null;

    public constructor(init?: Partial<AppointmentResponse>) { (Object as any).assign(this, init); }
}
(AppointmentResponse as unknown)[immerable] = true;

export enum NetworkServiceType
{
    Appointment = 'Appointment',
    Cancellation = 'Cancellation',
    DNA = 'DNA',
}

export class ServiceCharge
{
    public exVat: number|null;
    public vatRate: number|null;
    public canBillCXX: boolean|null;
    public canBillDNA: boolean|null;
    public cancellationChargeServiceId: string|null;
    public dnaChargeServiceId: string|null;
    public id: string|null;
    public name: string|null;
    public stockOnlineGuid: string|null;
    public overrides: { [index:string]: string; }|null;
    public serviceType: NetworkServiceType|null;
    public serviceNextAppointmentType: string|null;

    public constructor(init?: Partial<ServiceCharge>) { (Object as any).assign(this, init); }
}
(ServiceCharge as unknown)[immerable] = true;

export class ReferralAppointment
{
    public id: string|null;
    public date: string|null;
    public status: number|null;
    public invoiced: boolean|null;
    public serviceId: string|null;
    public locationId: string|null;
    public practitionerId: string|null;
    public appointmentId: string|null;
    public tm3AppointmentId: number|null;
    public authCode: string|null;
    public imported: boolean|null;
    public isLocked: boolean|null;
    public success: boolean|null;
    public errors: string[]|null;
    public warnings: string[]|null;

    public constructor(init?: Partial<ReferralAppointment>) { (Object as any).assign(this, init); }
}
(ReferralAppointment as unknown)[immerable] = true;

export class ReferralAppointmentResponse extends ReferralAppointment
{
    public exVat: number|null;
    public vatRate: number|null;
    public description: string|null;

    public constructor(init?: Partial<ReferralAppointmentResponse>) { super(init); (Object as any).assign(this, init); }
}
(ReferralAppointmentResponse as unknown)[immerable] = true;

export class ReferralAuthorisation
{
    public id: string|null;
    public amount: number|null;
    public reportId: string|null;
    public timeStamp: string|null;
    public isNewAdditionalAuth: boolean|null;
    public isRevoked: boolean|null;
    public initialAmount: number|null;
    public revokedAmount: number|null;
    public revokedTimeStamp: string|null;

    public constructor(init?: Partial<ReferralAuthorisation>) { (Object as any).assign(this, init); }
}
(ReferralAuthorisation as unknown)[immerable] = true;

export class PractitionerDto
{
    public id: string|null;
    public title: string|null;
    public forename: string|null;
    public surname: string|null;
    public gender: string|null;
    public addressLine1: string|null;
    public addressLine2: string|null;
    public addressLine3: string|null;
    public addressLine4: string|null;
    public addressLine5: string|null;
    public postCode: string|null;
    public telephone: string|null;
    public mobile: string|null;
    public email: string|null;
    public fax: string|null;
    public web: string|null;
    public online: boolean|null;
    public status: boolean|null;
    public type: string|null;
    public contractNumber: string|null;
    public onlineGuid: string|null;
    public defaultLocation: string|null;
    public disciplines: string[]|null;
    public name: string|null;
    public shortName: string|null;

    public constructor(init?: Partial<PractitionerDto>) { (Object as any).assign(this, init); }
}
(PractitionerDto as unknown)[immerable] = true;

export class BookingAuditResponse
{
    public id: string|null;
    public userId: number|null;
    public appointmentId: string|null;
    public appointmentStartDateTime: string|null;
    public appointmentBookingDateTime: string|null;
    public appointmentCustomerId: string|null;
    public customerReference: string|null;
    public bookingType: string|null;
    public serviceId: string|null;
    public clinicReference: string|null;
    public referrerReference: string|null;
    public targetId: string|null;
    public bookerId: string|null;
    public systemType: string|null;
    public referralStatus: number|null;
    public triageReport: string|null;
    public initialReport: string|null;
    public rfatReport: string|null;
    public dischargeReport: string|null;
    public triageReportName: string|null;
    public initialReportName: string|null;
    public rfatReportName: string|null;
    public dischargeReportName: string|null;
    public needsAction: boolean|null;
    public serviceCharges: { [index:string]: ServiceCharge; }|null;
    public appointments: ReferralAppointmentResponse[]|null;
    public authorisations: ReferralAuthorisation[]|null;
    public practitioners: PractitionerDto[]|null;
    public workflowId: number|null;
    public reminderSentType: number|null;
    public initialReportSubmissionDueDate: string|null;
    public firstReminderSentDate: string|null;
    public finalReminderSentDate: string|null;
    public expiredReminderSentDate: string|null;

    public constructor(init?: Partial<BookingAuditResponse>) { (Object as any).assign(this, init); }
}
(BookingAuditResponse as unknown)[immerable] = true;

export class Dictionary<T> { [Key: string]: T; }

export class JsonField extends Dictionary<Object>
{

    public constructor(init?: Partial<JsonField>) { super(); (Object as any).assign(this, init); }
}
(JsonField as unknown)[immerable] = true;

export enum ReportTemplateType
{
    D = 68,
    M = 77,
}

export class ReferralReport
{
    public id: string|null;
    public rootId: string|null;
    public templateId: string|null;
    public bookerId: string|null;
    public targetId: string|null;
    public data: JsonField|null;
    public timeStamp: string|null;
    public auditId: string|null;
    public status: number|null;
    public message: string|null;
    public title: string|null;
    public reportTemplateType: ReportTemplateType|null;

    public constructor(init?: Partial<ReferralReport>) { (Object as any).assign(this, init); }
}
(ReferralReport as unknown)[immerable] = true;

export enum VideoMeetingProvider
{
    Twilio = 0,
    Zoom = 1,
    Other = 99,
}

export class Appointment implements ILocationId, IHasReference
{
    public id: number|null;
    public startDateTime: string|null;
    public endDateTime: string|null;
    public name: string|null;
    public customerId: number|null;
    public practitionerId: number|null;
    public locationId: number|null;
    public status: number|null;
    public type: string|null;
    public reference: string|null;
    public roomId: number|null;
    public stockId: number|null;
    public groupId: number|null;
    public bookedBy: number|null;
    public authId: number|null;
    public serviceTypeId: number|null;
    public firstAppointment: boolean|null;
    public bookingDateTime: string|null;
    public arrivalDateTime: string|null;
    public comment: string|null;
    public colour: number|null;
    public billingItemID: number|null;
    public location: string|null;
    public equipment: string|null;
    public reminderType: string|null;
    public reminderDate: string|null;
    // @Ignore()
    public title: string|null;

    public auditId: string|null;
    public prontoAppointmentId: string|null;
    public prontoServiceId: string|null;
    public discountCodeId: string|null;
    public discountCodeAppliedDate: string|null;
    public discountCodeAdvance: boolean|null;
    public prePaidId: number|null;
    public prePaymentIncomeId: number|null;
    public connectServiceId: string|null;
    public owesCredit: boolean|null;
    public isVideo: boolean|null;
    public videoCode: string|null;
    public videoMeetingHostJoinUrl: string|null;
    public videoMeetingProvider: VideoMeetingProvider|null;
    public videoMeetingPassword: string|null;
    public videoMeetingParticipantJoinUrl: string|null;
    public videoMeetingId: string|null;
    public batchNo: number|null;
    // @Ignore()
    public videoLink: string|null;

    public cancelUsesAuth: boolean|null;
    public dnaUsesAuth: boolean|null;
    public prepaymentStatus: string|null;
    public cancelMethod: string|null;
    public recallStatus: string|null;

    public constructor(init?: Partial<Appointment>) { (Object as any).assign(this, init); }
}
(Appointment as unknown)[immerable] = true;

export class ProntoBillingItem
{
    public apptGuid: string|null;
    public id: number|null;
    public date: string|null;
    public service: { [index:string]: string; }|null;
    public location: { [index:string]: string; }|null;
    public practitioner: { [index:string]: string; }|null;
    public vatRate: number|null;
    public amount: number|null;
    public amountExVat: number|null;
    public metadata: string|null;
    public appointment: Appointment|null;
    public isPreviouslyBilledFromTM3: boolean|null;
    public isBillingPartOfFailedInvoice: boolean|null;

    public constructor(init?: Partial<ProntoBillingItem>) { (Object as any).assign(this, init); }
}
(ProntoBillingItem as unknown)[immerable] = true;

export class ProntoInvoice
{
    public id: string|null;
    public auditId: string|null;
    public bookerId: string|null;
    public targetId: string|null;
    public templateId: string|null;
    public timeStamp: string|null;
    public status: number|null;
    public message: string|null;
    public authCode: string|null;
    public admissionDate: string|null;
    public ref: string|null;
    public date: string|null;
    public locationId: string|null;
    public primaryPracitionerId: string|null;
    public patientMemberId: string|null;
    public patientPostcode: string|null;
    public patientForename: string|null;
    public patientSurname: string|null;
    public patientDateOfBirth: string|null;
    public totalAmount: number|null;
    public items: ProntoBillingItem[]|null;
    public metadata: string|null;
    public mappings: string|null;

    public constructor(init?: Partial<ProntoInvoice>) { (Object as any).assign(this, init); }
}
(ProntoInvoice as unknown)[immerable] = true;

export class LocationInfo
{
    public id: string|null;
    public exclude: boolean|null;
    public cancellationPolicy: string|null;
    public generalInfo: string|null;

    public constructor(init?: Partial<LocationInfo>) { (Object as any).assign(this, init); }
}
(LocationInfo as unknown)[immerable] = true;

// @Flags()
export enum ESSocialSignOn
{
    Apple = 1,
    Google = 2,
    Microsoft = 4,
    Facebook = 8,
}

export class OnlineSettings implements IHasId
{
    public id: number|null;
    public siteTitle: string|null;
    public showSiteTitle: boolean|null;
    public title: string|null;
    public logoUrl: string|null;
    public appIconUrl: string|null;
    public skin: string|null;
    public customColourPrimary: string|null;
    public customColourSecondary: string|null;
    public customColourNav: string|null;
    public customColourNavText: string|null;
    public message: string|null;
    public confirmSubject: string|null;
    public clinicFromEmail: string|null;
    public clinicNumber: string|null;
    public minBookingDays: number|null;
    public maxBookingDays: number|null;
    public isSiteLive: boolean|null;
    public registerProvisional: boolean|null;
    public maxBookings: number|null;
    public allowClassBooking: boolean|null;
    public allowRegister: boolean|null;
    public allowPayAtClinic: boolean|null;
    public locationInfo: LocationInfo[]|null;
    public googleTrackingId: string|null;
    public googleTagManagerContainerId: string|null;
    public useAllDeliveryMethodsForAccessCode: boolean|null;
    // @Ignore()
    public businessId: number|null;

    // @Ignore()
    public isCustom: boolean|null;

    public classes: boolean|null;
    public payments: boolean|null;
    public clinical: boolean|null;
    public generalInfo: string|null;
    public cancellationPolicy: string|null;
    public privacyPolicy: string|null;
    public termsAndConditions: string|null;
    public shareCancellationPolicy: boolean|null;
    public shareGeneralInfo: boolean|null;
    public url: string|null;
    public notifyOfAppointments: boolean|null;
    public unauthenticatedMessage: string|null;
    public sso: ESSocialSignOn|null;

    public constructor(init?: Partial<OnlineSettings>) { (Object as any).assign(this, init); }
}
(OnlineSettings as unknown)[immerable] = true;

export class ClinicSettings
{
    public url: string|null;
    public shareCancellationPolicy: boolean|null;
    public shareGeneralInfo: boolean|null;
    public referrerName: string|null;
    public receptionName: string|null;
    public clinicEmail: string|null;
    public allowClinicProntoEmails: boolean|null;
    public clinicNumber: string|null;
    public onlineSettings: OnlineSettings|null;
    public onlineBookingMinimumDays: number|null;
    public onlineBookingMaximumDays: number|null;
    public classOrder: number[]|null;
    public serviceOrder: string[]|null;
    public cancellationPolicy: string|null;
    public generalInfo: string|null;
    public noAppointmentsFoundText: string|null;
    public locationInfo: LocationInfo[]|null;
    public excludeLocations: { [index:string]: string[]; }|null;
    public excludePractitioners: { [index:string]: string[]; }|null;
    public excludeSessionIds: { [index:string]: number[]; }|null;
    public excludeNormalSessionIds: { [index:string]: number[]; }|null;
    public defaultServices: { [index:string]: string; }|null;
    public clientId: string|null;
    public ppsId: string|null;
    public ppsUserName: string|null;
    public ppsKey: string|null;
    public ppsUrl: string|null;
    public remoteProxyUrl: string|null;
    public remoteSecret: string|null;
    public clinicCurrency: string|null;

    public constructor(init?: Partial<ClinicSettings>) { (Object as any).assign(this, init); }
}
(ClinicSettings as unknown)[immerable] = true;

export class GroupLinker
{
    public globalId: string|null;
    public onlineGuid: string|null;

    public constructor(init?: Partial<GroupLinker>) { (Object as any).assign(this, init); }
}
(GroupLinker as unknown)[immerable] = true;

export class StockOverrideDto
{
    public stockId: number|null;
    public locationId: string|null;
    public locId: number|null;
    public price: number|null;
    public priceExVat: number|null;
    public meta: { [index:string]: string; }|null;

    public constructor(init?: Partial<StockOverrideDto>) { (Object as any).assign(this, init); }
}
(StockOverrideDto as unknown)[immerable] = true;

export class ProntoStockDto
{
    public id: string|null;
    public reference: string|null;
    public description: string|null;
    public locationGuid: string|null;
    public priceExVat: number|null;
    public vatRate: number|null;
    public vatAmount: number|null;
    public totalPrice: number|null;
    public price: number|null;
    public colourCss: string|null;
    public colour: number|null;
    public onlineGuid: string|null;
    public appointmentLength: number|null;
    public consultancyTime: number|null;
    public overrides: StockOverrideDto[]|null;
    public ledgerCode: string|null;
    // @Ignore()
    public objId: string|null;

    public category: string|null;

    public constructor(init?: Partial<ProntoStockDto>) { (Object as any).assign(this, init); }
}
(ProntoStockDto as unknown)[immerable] = true;

export class AvailabilitySummary
{
    public next: string|null;
    public nextLocations: string[]|null;
    public otherLocations: string[]|null;
    public price: number|null;

    public constructor(init?: Partial<AvailabilitySummary>) { (Object as any).assign(this, init); }
}
(AvailabilitySummary as unknown)[immerable] = true;

export class ClinicService
{
    public networkServiceId: string|null;
    public networkId: string|null;
    public name: string|null;
    public description: string|null;
    public discipline: string|null;
    public colour: string|null;
    public isOnline: boolean|null;
    public sortIndex: number|null;
    public availability: AvailabilitySummary|null;
    public meta: { [index:string]: string; }|null;
    public excludeGroups: string[]|null;
    public excludeLocations: string[]|null;
    public excludePractitioners: string[]|null;
    public overrides: { [index:string]: string; }|null;
    public stockId: string|null;
    public excludeSessionIds: number[]|null;
    public excludeNormalSessionIds: number[]|null;

    public constructor(init?: Partial<ClinicService>) { (Object as any).assign(this, init); }
}
(ClinicService as unknown)[immerable] = true;

export class StockResponse
{
    public id: number|null;
    public reference: string|null;
    public totalPrice: number|null;
    public description: string|null;
    public appointmentLength: number|null;
    public groupLocationLocationId: number|null;
    public locationId: number|null;
    public colour: number|null;
    public online: boolean|null;
    public onlineGuid: string|null;
    public inUse: boolean|null;
    public priceExVAT: number|null;
    public vatRate: number|null;
    public vatAmount: number|null;
    public costAmount: number|null;
    public costVATRate: number|null;
    public costExVAT: number|null;
    public costVATAmount: number|null;
    public longDescription: string|null;
    public category: string|null;
    public ledgerCode: string|null;
    public level: number|null;
    public minimumLevel: number|null;
    public displayInPriceList: boolean|null;
    public totalWorth: number|null;
    public supplierId: number|null;
    public serviceTypeId: number|null;
    public isPrivateCharge: boolean|null;
    public stockIsCancel: boolean|null;
    public stockIsFirst: boolean|null;
    public stockIsFollowUp: boolean|null;
    public stockIsDNA: boolean|null;
    public isMultiple: boolean|null;
    public groupName: string|null;
    public isVideo: boolean|null;
    public managementFee: boolean|null;
    public cancellationCharge: number|null;
    public didNotAttendCharge: number|null;
    public cancellationStockId: number|null;
    public didNotAttendStockId: number|null;
    public notes: string|null;
    public colourCss: string|null;
    public ccsd: string|null;
    public iscCodeID: number|null;
    public classification: string|null;
    public tags: string[]|null;
    public specialismId: string|null;
    public credits: number|null;
    public eligibleForTaxExemption: boolean|null;

    public constructor(init?: Partial<StockResponse>) { (Object as any).assign(this, init); }
}
(StockResponse as unknown)[immerable] = true;

export class LocationFacilities
{
    public allFacilities: string[]|null;
    public selectedFacilities: string[]|null;

    public constructor(init?: Partial<LocationFacilities>) { (Object as any).assign(this, init); }
}
(LocationFacilities as unknown)[immerable] = true;

export class LocationResponse
{
    public id: number|null;
    public name: string|null;
    public addressLine1: string|null;
    public addressLine2: string|null;
    public addressLine3: string|null;
    public addressLine4: string|null;
    public addressLine5: string|null;
    public postCode: string|null;
    public fullAddressMultiLine: string|null;
    public telephone: string|null;
    public fax: string|null;
    public email: string|null;
    public web: string|null;
    public dnaStockId: number|null;
    public cancelStockId: number|null;
    public status: string|null;
    public directions: string|null;
    public reminderTemplateEmail_TM3: string|null;
    public reminderTemplateSMS_TM3: string|null;
    public onlineGuid: string|null;
    public facilities: LocationFacilities|null;
    public isMainLocation: boolean|null;
    public merchantReference: string|null;
    public locationLong: number|null;
    public locationLat: number|null;
    public trackingCategory: string|null;

    public constructor(init?: Partial<LocationResponse>) { (Object as any).assign(this, init); }
}
(LocationResponse as unknown)[immerable] = true;

export class StockOverrideResponse
{
    public id: number|null;
    public locationId: number|null;
    public locationGuid: string|null;
    public stockId: number|null;
    public stockGuid: string|null;
    public priceExVAT: number|null;
    public totalPrice: number|null;
    public stockLevel: number|null;
    public stockMinimum: number|null;

    public constructor(init?: Partial<StockOverrideResponse>) { (Object as any).assign(this, init); }
}
(StockOverrideResponse as unknown)[immerable] = true;

export class PackageBundleItemWithQuantity
{
    public quantity: number|null;
    public typeId: number|null;
    public packageId: string|null;

    public constructor(init?: Partial<PackageBundleItemWithQuantity>) { (Object as any).assign(this, init); }
}
(PackageBundleItemWithQuantity as unknown)[immerable] = true;

export enum AccountingSystemProviderName
{
    None = 'None',
    Xero = 'Xero',
    Quickbooks = 'Quickbooks',
    Sage = 'Sage',
}

export class AccountingStockLedgerLookup implements IHasId
{
    public id: number|null;
    public stockId: number|null;
    public systemId: string|null;
    public systemName: AccountingSystemProviderName|null;
    public accountingSystemLedgerId: string|null;
    public accountingSystemLedgerCode: string|null;

    public constructor(init?: Partial<AccountingStockLedgerLookup>) { (Object as any).assign(this, init); }
}
(AccountingStockLedgerLookup as unknown)[immerable] = true;

export class StockWithLocationResponse extends StockResponse
{
    public locationName: string|null;
    public groups: number[]|null;
    public locations: LocationResponse[]|null;
    public overrides: StockOverrideResponse[]|null;
    public packageItems: PackageBundleItemWithQuantity[]|null;
    public ledgerCodeOverrides: AccountingStockLedgerLookup[]|null;
    public legderCodeAccountId: string|null;
    public accountingSystemLedgerCode: string|null;

    public constructor(init?: Partial<StockWithLocationResponse>) { super(init); (Object as any).assign(this, init); }
}
(StockWithLocationResponse as unknown)[immerable] = true;

// @Route("/all/stock")
export class AllStockRequest extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<StockWithLocationResponse>>
{
    public description: string|null;
    public reference: string|null;
    public category: string|null;
    public type: string|null;
    public private: boolean|null;
    public status: boolean|null;
    public amount: CurrencyRange|null;
    public includeTags: string[]|null;
    public excludeTags: string[]|null;

    public constructor(init?: Partial<AllStockRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'AllStockRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<StockWithLocationResponse>(); }
}
(AllStockRequest as unknown)[immerable] = true;

export class StockBulkActionBaseRequest extends BulkActionBaseRequest<AllStockRequest>
{

    public constructor(init?: Partial<StockBulkActionBaseRequest>) { super(init); (Object as any).assign(this, init); }
}
(StockBulkActionBaseRequest as unknown)[immerable] = true;

export class SingleCacheRequest
{
    public version: string|null;

    public constructor(init?: Partial<SingleCacheRequest>) { (Object as any).assign(this, init); }
}

export class LabelItem
{
    public id: string|null;
    public text: string|null;

    public constructor(init?: Partial<LabelItem>) { (Object as any).assign(this, init); }
}
(LabelItem as unknown)[immerable] = true;

export interface IClientSpecificCacheService
{
}

export interface IClientDbAccess
{
    cache: IClientSpecificCacheService|null;
}

export class SecurityDto implements ISecurityId, ISecurityType, ISecurityGuid
{
    public securityId: number|null;
    public securityType: string|null;
    public securityGuid: string|null;

    public constructor(init?: Partial<SecurityDto>) { (Object as any).assign(this, init); }
}
(SecurityDto as unknown)[immerable] = true;

export interface ISecurityLocator
{
    securityLocator: Func<Object, IClientDbAccess, SecurityDto>|null;
}

export enum TimelineContextObjectType
{
    Default = 'Default',
    Vehicle = 'Vehicle',
}

export enum TimelineLinkedObjectType
{
    Default = 'Default',
    Payment = 'Payment',
    Invoice = 'Invoice',
    Charge = 'Charge',
    Appointment = 'Appointment',
    Class = 'Class',
    Document = 'Document',
    Form = 'Form',
    Download = 'Download',
    Worksheet = 'Worksheet',
    Vehicle = 'Vehicle',
}

export interface ISecurityGuid
{
    securityGuid: string|null;
}

export class DynamicLabelRequest
{

    public constructor(init?: Partial<DynamicLabelRequest>) { (Object as any).assign(this, init); }
}
(DynamicLabelRequest as unknown)[immerable] = true;

export class TaskForUser implements IHasId
{
    public id: number|null;
    public createdDate: string|null;
    public dueDate: string|null;
    public description: string|null;
    public status: string|null;
    public userId: number|null;
    public reminder: boolean|null;
    public priority: boolean|null;
    public createdUserId: number|null;
    public dateCompleted: string|null;
    public patientId: number|null;
    public private: boolean|null;
    // @Ignore()
    public recur: boolean|null;

    // @Ignore()
    public recurFreq: string|null;

    // @Ignore()
    public recurDate: string|null;

    public tags: string[]|null;

    public constructor(init?: Partial<TaskForUser>) { (Object as any).assign(this, init); }
}
(TaskForUser as unknown)[immerable] = true;

export class ScoresGoalsSettingsRequest
{
    public id: number|null;
    public type: string|null;
    public name: string|null;
    public max: number|null;
    public min: number|null;
    public enabled: boolean|null;
    public inUse: boolean|null;

    public constructor(init?: Partial<ScoresGoalsSettingsRequest>) { (Object as any).assign(this, init); }
}
(ScoresGoalsSettingsRequest as unknown)[immerable] = true;

export enum ReportPatientType
{
    AllPatients = 1,
    GroupPatientsOnly = 2,
    SelfFunding = 3,
}

export enum ReportLocationType
{
    AllLocations = 'AllLocations',
    ActiveAndViewOnly = 'ActiveAndViewOnly',
    InactiveHidden = 'InactiveHidden',
}

export enum ReportPractitionerType
{
    Inactive = 'Inactive',
    ActiveAndPAYG = 'ActiveAndPAYG',
    AllPractitioners = 'AllPractitioners',
}

export class BaseParamsForAllReports implements ILocationIds, ILocationId
{
    public displayAll: boolean|null;
    public skip: number|null;
    public take: number|null;
    public requestLocationIds: number[]|null;
    public locationIds: number[]|null;
    public practitionerIds: number[]|null;
    public groupIds: number[]|null;
    public userId: number|null;
    public term: string|null;
    public name: string|null;
    public date: DateRange|null;
    public locationId: number|null;
    public patientType: ReportPatientType|null;
    public locationType: ReportLocationType|null;
    public practitionerType: ReportPractitionerType|null;

    public constructor(init?: Partial<BaseParamsForAllReports>) { (Object as any).assign(this, init); }
}
(BaseParamsForAllReports as unknown)[immerable] = true;

export enum InvoiceStatus
{
    All = 1,
    Invoiced = 2,
    Uninvoiced = 3,
}

export enum RemainingAuthorisationOption
{
    Both = 'Both',
    Yes = 'Yes',
    No = 'No',
}

export class DatePart
{
    public date: number|null;
    public month: number|null;

    public constructor(init?: Partial<DatePart>) { (Object as any).assign(this, init); }
}
(DatePart as unknown)[immerable] = true;

export class DatePartRange
{
    public from: DatePart|null;
    public to: DatePart|null;

    public constructor(init?: Partial<DatePartRange>) { (Object as any).assign(this, init); }
}
(DatePartRange as unknown)[immerable] = true;

export class RegistrationRequest
{
    public subdomain: string|null;
    public title: string|null;
    public forename: string|null;
    public surname: string|null;
    public email: string|null;
    public businessName: string|null;
    public address: string|null;
    public town: string|null;
    public postCode: string|null;
    public locationId: number|null;
    public password: string|null;
    public marketingConsent: boolean|null;
    public enquirySource: string|null;

    public constructor(init?: Partial<RegistrationRequest>) { (Object as any).assign(this, init); }
}
(RegistrationRequest as unknown)[immerable] = true;

export enum EnquiryType
{
    Healthcode = 'Healthcode',
    Reception = 'Reception',
}

export class QuickStartWizardGroupStock
{
    public stockId: number|null;
    public groupStockId: number|null;
    public hasChanged: boolean|null;

    public constructor(init?: Partial<QuickStartWizardGroupStock>) { (Object as any).assign(this, init); }
}
(QuickStartWizardGroupStock as unknown)[immerable] = true;

export enum TemplatePackOptions
{
    None = 'None',
    Physiotherapy = 'Physiotherapy',
    Osteopathy = 'Osteopathy',
    Chiropractic = 'Chiropractic',
    Podiatry = 'Podiatry',
}

export class ClinicServiceSetupDto
{
    public networkServiceId: string|null;
    public networkId: string|null;
    public name: string|null;
    public description: string|null;
    public discipline: string|null;
    public colour: string|null;
    public isOnline: boolean|null;
    // @Ignore()
    public sortIndex: number|null;

    public meta: { [index:string]: string; }|null;
    public excludeGroups: string[]|null;
    public excludeLocations: string[]|null;
    public excludePractitioners: string[]|null;
    public overrides: { [index:string]: string; }|null;
    public stockId: string|null;
    public stockName: string|null;
    public stockLength: number|null;
    public stockPrice: number|null;
    public existingCharge: number|null;
    public excludeSessionIds: number[]|null;
    public excludeNormalSessionIds: number[]|null;

    public constructor(init?: Partial<ClinicServiceSetupDto>) { (Object as any).assign(this, init); }
}
(ClinicServiceSetupDto as unknown)[immerable] = true;

export enum PrescriptionActions
{
    draft = 'draft',
    issueForCollection = 'issueForCollection',
    issueToContact = 'issueToContact',
    issueForDelivery = 'issueForDelivery',
    issueOnly = 'issueOnly',
    printPrescription = 'printPrescription',
}

export class Update
{
    public type: string|null;
    public data: string|null;
    public local: string|null;

    public constructor(init?: Partial<Update>) { (Object as any).assign(this, init); }
}
(Update as unknown)[immerable] = true;

// @Flags()
export enum FormStatus
{
    Sent = 1,
    Draft = 2,
    Submitted = 3,
    Completed = 4,
    Cancelled = 5,
    Declined = 6,
}

export enum FileAreaType
{
    All = 'All',
    Customer = 'Customer',
    Group = 'Group',
    Case = 'Case',
    Invoice = 'Invoice',
    Practitioner = 'Practitioner',
    MedicalContact = 'MedicalContact',
    NM_Business = 'NM_Business',
}

export enum TimelineType
{
    Log = 'Log',
    Note = 'Note',
    Alert = 'Alert',
}

export class OnlineConsent
{
    public emailConsent: boolean|null;
    public smsConsent: boolean|null;
    public phoneConsent: boolean|null;
    public generalConsent: boolean|null;
    public smsEnabled: boolean|null;

    public constructor(init?: Partial<OnlineConsent>) { (Object as any).assign(this, init); }
}
(OnlineConsent as unknown)[immerable] = true;

export class BatchEmailRequestObject
{
    public id: number|null;
    public template: string|null;

    public constructor(init?: Partial<BatchEmailRequestObject>) { (Object as any).assign(this, init); }
}
(BatchEmailRequestObject as unknown)[immerable] = true;

export class Attachment
{
    public name: string|null;
    public path: string|null;
    public content: string|null;

    public constructor(init?: Partial<Attachment>) { (Object as any).assign(this, init); }
}
(Attachment as unknown)[immerable] = true;

export class AttachmentGroup
{
    public files: Attachment[]|null;
    public templates: Attachment[]|null;
    public mergedTemplates: Attachment[]|null;

    public constructor(init?: Partial<AttachmentGroup>) { (Object as any).assign(this, init); }
}
(AttachmentGroup as unknown)[immerable] = true;

export enum BlockTemplateFormat
{
    Draft = 'Draft',
    Block = 'Block',
}

export class SystemConfig implements IHasId
{
    public id: number|null;
    public description: string|null;
    public value: string|null;

    public constructor(init?: Partial<SystemConfig>) { (Object as any).assign(this, init); }
}
(SystemConfig as unknown)[immerable] = true;

export enum FromMode
{
    OurNumber = 'OurNumber',
    TheirNumber = 'TheirNumber',
    FromText = 'FromText',
}

export class CasePrintingItem
{
    public id: number|null;
    public type: string|null;

    public constructor(init?: Partial<CasePrintingItem>) { (Object as any).assign(this, init); }
}
(CasePrintingItem as unknown)[immerable] = true;

export class CaseReport
{
    public id: string|null;
    public rootId: string|null;
    public templateId: string|null;
    public bookerId: string|null;
    public targetId: string|null;
    public data: string|null;
    public timeStamp: string|null;
    public auditId: string|null;
    public status: number|null;
    public message: string|null;

    public constructor(init?: Partial<CaseReport>) { (Object as any).assign(this, init); }
}
(CaseReport as unknown)[immerable] = true;

export interface IHasCaseId
{
    caseId: number|null;
}

export class AutoSaveUpdate
{
    public id: number|null;
    public type: string|null;
    public local: string|null;
    public data: { [index:string]: Object; }|null;

    public constructor(init?: Partial<AutoSaveUpdate>) { (Object as any).assign(this, init); }
}
(AutoSaveUpdate as unknown)[immerable] = true;

export class Case implements ICascade, ILocationId, IHasReference, IHasDocuments
{
    public id: number|null;
    public customerId: number|null;
    public practitionerId: number|null;
    public createdByUserId: number|null;
    public dischargedByUserId: number|null;
    public medicalContactId: number|null;
    public admissionDate: string|null;
    public referralReason: string|null;
    public diagnosis: string|null;
    public diagnosisKey: string|null;
    public diagnosisCode: string|null;
    public dischargeDate: string|null;
    public patientOutcome: string|null;
    public practitionerOutcome: string|null;
    public dischargeStatus: string|null;
    public numberOfAppointments: number|null;
    public reference: string|null;
    public admissionCode: string|null;
    public reviewDate: string|null;
    public referralDate: string|null;
    public bodySite: string|null;
    public bodySide: string|null;
    public timePresent: number|null;
    public timePresentUnit: string|null;
    public injuryCause: string|null;
    public preExistingConditions: string|null;
    public admissionPainScale: number|null;
    public admissionLetterDate: string|null;
    public dischargePainScale: number|null;
    public dischargeLetterDate: string|null;
    public clinicNotes: string|null;
    public agreedFunctionalOutcome: string|null;
    public closed: boolean|null;
    public closedUser: string|null;
    public closedDateTime: string|null;
    public patientType: string|null;
    public auditUser: string|null;
    public auditNotes: string|null;
    public auditDate: string|null;
    public standardPathwayFollowed: boolean|null;
    public locationId: number|null;
    public ofInterest: boolean|null;
    public firstAppointmentId: number|null;
    public serviceTypeId: number|null;
    public linkedCaseId: number|null;
    public status: number|null;
    public autoSaved: boolean|null;
    public data: { [index:string]: Object; }|null;
    public admissionTemplateId: string|null;
    public dischargeTemplateId: string|null;
    public admissionHighlight: { [index:string]: number[]; }|null;
    public dischargeHighlight: { [index:string]: number[]; }|null;
    public type: string|null;
    public bookingAuditId: string|null;
    public goalOrder: number[]|null;
    public scoreOrder: number[]|null;
    public viewed: boolean|null;
    public documentsLoaded: boolean|null;
    public consent: boolean|null;
    public taxExempt: boolean|null;
    // @Ignore()
    public documentsSubDirectory: string|null;

    public constructor(init?: Partial<Case>) { (Object as any).assign(this, init); }
}
(Case as unknown)[immerable] = true;

export class Psfs implements IHasId
{
    public id: number|null;
    public caseId: number|null;
    public activity: string|null;
    public linkedGoalId: number|null;

    public constructor(init?: Partial<Psfs>) { (Object as any).assign(this, init); }
}
(Psfs as unknown)[immerable] = true;

export class CaseWithCustomerPractitionerLocationDetails extends Case
{
    public customerForename: string|null;
    public customerSurname: string|null;
    public customerTitle: string|null;
    public customerHomeTelephone: string|null;
    public customerWorkTelephone: string|null;
    public customerMobileTelephone: string|null;
    public customerEmail: string|null;
    public customerCategory: string|null;
    public customerDateOfBirth: string|null;
    public addressLine1: string|null;
    public addressLine2: string|null;
    public addressLine3: string|null;
    public addressLine4: string|null;
    public addressLine5: string|null;
    public postCode: string|null;
    public location: string|null;
    public practitionerTitle: string|null;
    public practitionerForename: string|null;
    public practitionerSurname: string|null;
    public practitionerEmail: string|null;
    public practitionerCode: string|null;
    public contractNumber: string|null;
    public regNumber: string|null;
    // @Ignore()
    public practitionerName: string|null;

    // @Ignore()
    public practitionerNameWithAwards: string|null;

    // @Ignore()
    public createdByName: string|null;

    // @Ignore()
    public dischargedByName: string|null;

    // @Ignore()
    public isAudited: boolean|null;

    // @Ignore()
    public auditUserName: string|null;

    public serviceType: string|null;
    // @Ignore()
    public psfs: Psfs[]|null;

    public constructor(init?: Partial<CaseWithCustomerPractitionerLocationDetails>) { super(init); (Object as any).assign(this, init); }
}
(CaseWithCustomerPractitionerLocationDetails as unknown)[immerable] = true;

export class GraphicResult
{
    public id: number|null;
    public caseId: number|null;
    public date: string|null;
    public value: string|null;

    public constructor(init?: Partial<GraphicResult>) { (Object as any).assign(this, init); }
}
(GraphicResult as unknown)[immerable] = true;

export class PainAnnotation
{
    public id: number|null;
    public chartId: number|null;
    public annotation: string|null;
    public x: number|null;
    public y: number|null;
    public rectX: number|null;
    public rectY: number|null;
    public title: string|null;
    public treatmentId: number|null;
    public point: number|null;
    public caseId: number|null;
    public painType: string|null;
    public dateTime: string|null;

    public constructor(init?: Partial<PainAnnotation>) { (Object as any).assign(this, init); }
}
(PainAnnotation as unknown)[immerable] = true;

export class ImageResult
{
    public id: number|null;
    public caseId: number|null;
    public date: string|null;
    public filename: string|null;
    public type: string|null;
    public closed: boolean|null;
    public closedUser: string|null;
    public closedDateTime: string|null;
    public annotations: PainAnnotation[]|null;

    public constructor(init?: Partial<ImageResult>) { (Object as any).assign(this, init); }
}
(ImageResult as unknown)[immerable] = true;

export class CaseSummaryResult
{
    public id: number|null;
    public admissionDate: string|null;
    public reference: string|null;
    public diagnosis: string|null;
    public bodySite: string|null;
    public dischargeDate: string|null;
    public treatments: number|null;

    public constructor(init?: Partial<CaseSummaryResult>) { (Object as any).assign(this, init); }
}
(CaseSummaryResult as unknown)[immerable] = true;

export enum ConsultationItemType
{
    Assessment = 'Assessment',
    Modality = 'Modality',
    Goal = 'Goal',
    Score = 'Score',
    Image = 'Image',
}

export class ConsultationItem implements IHasId, ICascade
{
    public id: number|null;
    public treatmentId: number|null;
    public type: ConsultationItemType|null;
    public title: string|null;
    public data: { [index:string]: Object; }|null;
    public date: string|null;
    public templateId: string|null;
    public highlights: { [index:string]: number[]; }|null;

    public constructor(init?: Partial<ConsultationItem>) { (Object as any).assign(this, init); }
}
(ConsultationItem as unknown)[immerable] = true;

export class PostCloseNotes implements IHasId
{
    public id: number|null;
    public caseId: number|null;
    public treatmentId: number|null;
    public userId: number|null;
    public notes: string|null;
    public date: string|null;
    public type: string|null;

    public constructor(init?: Partial<PostCloseNotes>) { (Object as any).assign(this, init); }
}
(PostCloseNotes as unknown)[immerable] = true;

export class PostCloseNotesWithUser extends PostCloseNotes
{
    public userName: string|null;
    public userFullName: string|null;

    public constructor(init?: Partial<PostCloseNotesWithUser>) { super(init); (Object as any).assign(this, init); }
}
(PostCloseNotesWithUser as unknown)[immerable] = true;

export class CaseScoreGoalResponse
{
    public id: number|null;
    public name: string|null;

    public constructor(init?: Partial<CaseScoreGoalResponse>) { (Object as any).assign(this, init); }
}
(CaseScoreGoalResponse as unknown)[immerable] = true;

export class NewPsfs
{
    public id: number|null;
    public activity: string|null;
    public initialValue: number|null;
    public linkedGoalId: number|null;

    public constructor(init?: Partial<NewPsfs>) { (Object as any).assign(this, init); }
}
(NewPsfs as unknown)[immerable] = true;

export class TreatmentDetails
{
    public id: number|null;
    public caseId: number|null;
    public appointmentId: number|null;
    public dateTime: string|null;
    public initials: string|null;
    public notes: string|null;
    public length: number|null;
    public assessLength: number|null;
    public cost: number|null;
    public locationId: number|null;
    public practitionerId: number|null;
    public migrated: boolean|null;
    public closed: boolean|null;
    public closedUser: string|null;
    public closedDate: string|null;
    public scale: number|null;
    public measure: string|null;
    public type: string|null;

    public constructor(init?: Partial<TreatmentDetails>) { (Object as any).assign(this, init); }
}
(TreatmentDetails as unknown)[immerable] = true;

export class DynamicUpdate
{
    public id: number|null;
    public type: string|null;
    public json: string|null;

    public constructor(init?: Partial<DynamicUpdate>) { (Object as any).assign(this, init); }
}
(DynamicUpdate as unknown)[immerable] = true;

export class ScoreEntryRequest implements ILocationId, ISecurityId
{
    public id: number|null;
    public dateAdded: string|null;
    public scoreId: number|null;
    public score: number|null;
    public locationId: number|null;
    public caseId: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<ScoreEntryRequest>) { (Object as any).assign(this, init); }
}
(ScoreEntryRequest as unknown)[immerable] = true;

export class ScoreRequest implements ILocationId, ISecurityId
{
    public id: number|null;
    public securityId: number|null;
    public title: string|null;
    public dateAdded: string|null;
    public dateCompleted: string|null;
    public caseId: number|null;
    public settingId: number|null;
    public locationId: number|null;

    public constructor(init?: Partial<ScoreRequest>) { (Object as any).assign(this, init); }
}
(ScoreRequest as unknown)[immerable] = true;

export class GoalEntryRequest implements ISecurityId
{
    public title: string|null;
    public id: number|null;
    public notes: string|null;
    public caseId: number|null;
    public securityId: number|null;
    public goalId: number|null;
    public completionPercentage: number|null;
    public dateAdded: string|null;
    public locationId: number|null;

    public constructor(init?: Partial<GoalEntryRequest>) { (Object as any).assign(this, init); }
}
(GoalEntryRequest as unknown)[immerable] = true;

export class GoalRequest implements ISecurityId
{
    public id: number|null;
    public caseId: number|null;
    public securityId: number|null;
    public title: string|null;
    public averaged: boolean|null;
    public dateAdded: string|null;
    public dateCompleted: string|null;
    public settingId: number|null;
    public locationId: number|null;

    public constructor(init?: Partial<GoalRequest>) { (Object as any).assign(this, init); }
}
(GoalRequest as unknown)[immerable] = true;

export class DiaryListResponse implements IHasId
{
    public id: number|null;
    public name: string|null;
    public startDateTime: string|null;
    public endDateTime: string|null;
    public type: string|null;
    public status: number|null;
    public practitionerId: number|null;
    public locationId: number|null;
    public stockId: number|null;
    public comment: string|null;
    public customerId: number|null;
    public customerReference: string|null;
    public customerAltRef: string|null;
    public customerMobileTelephone: string|null;
    public customerEmail: string|null;
    public customerSMSEnabled: boolean|null;
    public customerTitle: string|null;
    public customerForename: string|null;
    public customerSurname: string|null;
    public customerDateOfBirth: string|null;
    public customerGender: string|null;
    public insuranceNumber: string|null;
    public groupReference: string|null;
    public customerStatus: number|null;
    public customerRegistrationDate: string|null;
    public registrationNumber: string|null;

    public constructor(init?: Partial<DiaryListResponse>) { (Object as any).assign(this, init); }
}
(DiaryListResponse as unknown)[immerable] = true;

export class DiaryListRequest extends DiaryListBase implements IReturn<ResponseBase<DiaryListResponse>>
{

    public constructor(init?: Partial<DiaryListRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'DiaryListRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<DiaryListResponse>(); }
}
(DiaryListRequest as unknown)[immerable] = true;

export class DiaryBulkActionBaseRequest extends BulkActionBaseRequest<DiaryListRequest>
{

    public constructor(init?: Partial<DiaryBulkActionBaseRequest>) { super(init); (Object as any).assign(this, init); }
}
(DiaryBulkActionBaseRequest as unknown)[immerable] = true;

// @Flags()
export enum TagActionType
{
    AddTag = 0,
    RemoveTag = 1,
}

export class GuardDeleteResponse
{
    public cases: number|null;
    public appointments: number|null;
    public invoices: number|null;
    public payments: number|null;
    public billingItems: number|null;
    public classes: number|null;

    public constructor(init?: Partial<GuardDeleteResponse>) { (Object as any).assign(this, init); }
}
(GuardDeleteResponse as unknown)[immerable] = true;

export class GeneralCustomerResponse
{
    public id: number|null;
    public reference: string|null;
    public forename: string|null;
    public surname: string|null;
    public title: string|null;
    public name: string|null;
    public gender: string|null;
    public addressLine1: string|null;
    public addressLine2: string|null;
    public addressLine3: string|null;
    public addressLine4: string|null;
    public addressLine5: string|null;
    public invoiceAddressLine1: string|null;
    public invoiceAddressLine2: string|null;
    public invoiceAddressLine3: string|null;
    public invoiceAddressLine4: string|null;
    public invoiceAddressLine5: string|null;
    public invoicePostCode: string|null;
    public useInvoiceAddress: boolean|null;
    public address: string|null;
    public invoiceAddress: string|null;
    public groupAddressTo: string|null;
    public postCode: string|null;
    public registrationDate: string|null;
    public homeTelephone: string|null;
    public workTelephone: string|null;
    public mobileTelephone: string|null;
    public email: string|null;
    public dateOfBirth: string|null;
    public locationId: number|null;
    public groupId: number|null;
    public locationName: string|null;
    public practitionerId: number|null;
    public practitionerEmail: string|null;
    public practitionerTitle: string|null;
    public practitionerForename: string|null;
    public practitionerSurname: string|null;
    public practitionerName: string|null;
    public practitionerStatus: number|null;
    public groupName: string|null;
    public patientGroup: string|null;
    public status: string|null;
    public provisional: boolean|null;
    public height: number|null;
    public weight: number|null;
    public employer: string|null;
    public niNumber: string|null;
    public hospitalNumber: string|null;
    public insuranceNumber: string|null;
    public alternativeRef1: string|null;
    public groupReference: string|null;
    public consent: string|null;
    public category: string|null;
    public enquiry: string|null;
    public invoicePeriod: string|null;
    public balanceInvoiced: number|null;
    public balanceOwed: number|null;
    public billTo: string|null;
    public online: boolean|null;
    public smsEnabled: boolean|null;
    public sarStatus: string|null;
    public alerts: AlertResponse[]|null;
    public guardDelete: GuardDeleteResponse[]|null;
    public givenConsent: boolean|null;
    public emailConsent: boolean|null;
    public smsConsent: boolean|null;
    public phoneConsent: boolean|null;
    public meta: { [index:string]: Object; }|null;
    public cardName: string|null;
    public lastFourDigits: string|null;
    public brand: string|null;
    public expiryMonth: number|null;
    public expiryYear: number|null;
    public flag: string|null;
    public irn: string|null;
    public medicareCardNo: string|null;
    public dvaNumber: string|null;
    public accountId: number|null;
    public accountType: string|null;
    public tags: string[]|null;
    public overridePayAtClinic: boolean|null;
    public isBusiness: boolean|null;

    public constructor(init?: Partial<GeneralCustomerResponse>) { (Object as any).assign(this, init); }
}

// @Route("/customers/search")
export class CustomerAdvancedSearchRequest extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<GeneralCustomerResponse>>
{
    public name: string|null;
    public address: string|null;
    public email: string|null;
    public phoneNumbers: string|null;
    public reference: string|null;
    public status: number|null;
    public provisional: boolean|null;
    public gender: string[]|null;
    public dateOfBirth: DateRange|null;
    public registrationDate: DateRange|null;
    public lastAppointmentDate: DateRange|null;
    public practitionerIds: number[]|null;
    public includeTags: string[]|null;
    public excludeTags: string[]|null;

    public constructor(init?: Partial<CustomerAdvancedSearchRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomerAdvancedSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<GeneralCustomerResponse>(); }
}
(CustomerAdvancedSearchRequest as unknown)[immerable] = true;

export class CustomerBulkActionBaseRequest extends BulkActionBaseRequest<CustomerAdvancedSearchRequest>
{

    public constructor(init?: Partial<CustomerBulkActionBaseRequest>) { super(init); (Object as any).assign(this, init); }
}
(CustomerBulkActionBaseRequest as unknown)[immerable] = true;

export enum AutomationEventEntityType
{
    Appointment = 'Appointment',
    Patient = 'Patient',
    Invoice = 'Invoice',
    Case = 'Case',
    Task = 'Task',
    ClassAttendance = 'ClassAttendance',
    Charge = 'Charge',
    Form = 'Form',
    Stock = 'Stock',
    Authorisation = 'Authorisation',
    Vehicle = 'Vehicle',
}

export enum AutomationEventName
{
    Booked = 'Booked',
    Completed = 'Completed',
    Cancelled = 'Cancelled',
    DNAed = 'DNAed',
    Created = 'Created',
    Updated = 'Updated',
    Discharged = 'Discharged',
    Attended = 'Attended',
    Birthday = 'Birthday',
    PackageItemsExpiring = 'PackageItemsExpiring',
    BulkAction = 'BulkAction',
    Sent = 'Sent',
    AuthAdded = 'AuthAdded',
    ExpiringAuth = 'ExpiringAuth',
    FallsBelowAuthThreshold = 'FallsBelowAuthThreshold',
    FallsBelowTreatmentThreshold = 'FallsBelowTreatmentThreshold',
    HasReminder = 'HasReminder',
    FallsBelowCreditThreshold = 'FallsBelowCreditThreshold',
    PackageLinkedToCaseIsConsumed = 'PackageLinkedToCaseIsConsumed',
    HasExpiredPackageLinkedToCase = 'HasExpiredPackageLinkedToCase',
}

export enum AppointmentConditions
{
    IsFirstAppointment = 'IsFirstAppointment',
    IsFirstAppointmentAfterRegistration = 'IsFirstAppointmentAfterRegistration',
    HasCase = 'HasCase',
    LinkedToDischargedCase = 'LinkedToDischargedCase',
    LinkedToUndischargedCase = 'LinkedToUndischargedCase',
    HasFutureAuthorisations = 'HasFutureAuthorisations',
    IsLinkedToSpecificGroups = 'IsLinkedToSpecificGroups',
    IsLinkedToGroupWithClassifications = 'IsLinkedToGroupWithClassifications',
    IsLinkedToGroup = 'IsLinkedToGroup',
    AppointmentChargeHasAllTheTags = 'AppointmentChargeHasAllTheTags',
    AppointmentChargeHasNoneOfTheTags = 'AppointmentChargeHasNoneOfTheTags',
    AppointmentChargeHasAnyOfTheTags = 'AppointmentChargeHasAnyOfTheTags',
    HasNoFutureAppointments = 'HasNoFutureAppointments',
    HasFutureAppointments = 'HasFutureAppointments',
    IsNotLinkedToGroup = 'IsNotLinkedToGroup',
    HasBeenRecalled = 'HasBeenRecalled',
    HasNotBeenRecalled = 'HasNotBeenRecalled',
    IsAtLocation = 'IsAtLocation',
}

export enum TaskConditions
{
    HasAllTheTags = 'HasAllTheTags',
    HasAnyOfTheTags = 'HasAnyOfTheTags',
    HasNoneOfTheTags = 'HasNoneOfTheTags',
}

export enum InvoiceConditions
{
    InvoiceHasTheStatus = 'InvoiceHasTheStatus',
    IsAtLocation = 'IsAtLocation',
}

export enum CaseConditions
{
    IsDischarged = 'IsDischarged',
    IsNotDischarged = 'IsNotDischarged',
}

export enum CustomerConditions
{
    HasNoneOfTheTags = 'HasNoneOfTheTags',
    HasAnyOfTheTags = 'HasAnyOfTheTags',
    HasAllTheTags = 'HasAllTheTags',
    HasTheStatus = 'HasTheStatus',
    IsLinkedToGroup = 'IsLinkedToGroup',
    HasNoFutureAppointments = 'HasNoFutureAppointments',
    HasFutureAppointments = 'HasFutureAppointments',
    IsLinkedToSpecificGroups = 'IsLinkedToSpecificGroups',
    IsNotLinkedToGroup = 'IsNotLinkedToGroup',
    IsLinkedToGroupWithClassifications = 'IsLinkedToGroupWithClassifications',
    HasFutureAuthorisations = 'HasFutureAuthorisations',
    HasNoFutureAuthorisations = 'HasNoFutureAuthorisations',
    HasFutureClasses = 'HasFutureClasses',
    HasNoFutureClasses = 'HasNoFutureClasses',
    HasConsentedToEmails = 'HasConsentedToEmails',
    HasConsentedToTextMessages = 'HasConsentedToTextMessages',
    HasConsentedToPhoneCalls = 'HasConsentedToPhoneCalls',
    HasConsentedToTreatment = 'HasConsentedToTreatment',
    IsAtLocation = 'IsAtLocation',
    HasSomeCompletedAppointments = 'HasSomeCompletedAppointments',
    HasAttendedSomeClasses = 'HasAttendedSomeClasses',
    HasHad = 'HasHad',
    HasNotHad = 'HasNotHad',
}

export enum ClassAttendanceConditions
{
    HasAttended = 'HasAttended',
    HasNotAttended = 'HasNotAttended',
    HasCancelled = 'HasCancelled',
    HasNotCancelled = 'HasNotCancelled',
    HasNotBeenRecalled = 'HasNotBeenRecalled',
    HasBeenRecalled = 'HasBeenRecalled',
    IsAtLocation = 'IsAtLocation',
}

export enum ChargeConditions
{
    IsDiscount = 'IsDiscount',
    IsWriteOff = 'IsWriteOff',
    IsCredit = 'IsCredit',
    IsForPhysicalStock = 'IsForPhysicalStock',
    IsForConnectPackage = 'IsForConnectPackage',
    IsASubscription = 'IsASubscription',
    IsNotASubscription = 'IsNotASubscription',
    StockItemIs = 'StockItemIs',
    HasAllTheTags = 'HasAllTheTags',
    HasAnyOfTheTags = 'HasAnyOfTheTags',
    HasNoneOfTheTags = 'HasNoneOfTheTags',
    IsAtLocation = 'IsAtLocation',
    IsTransfer = 'IsTransfer',
}

export enum FormConditions
{
    IsComplete = 'IsComplete',
    IsIncomplete = 'IsIncomplete',
}

export enum StockConditions
{
    HasAllTheTags = 'HasAllTheTags',
    HasAnyOfTheTags = 'HasAnyOfTheTags',
    HasNoneOfTheTags = 'HasNoneOfTheTags',
}

export class EventCondition
{
    public type: AutomationEventEntityType|null;
    public appointmentFunction: AppointmentConditions|null;
    public taskFunction: TaskConditions|null;
    public invoiceFunction: InvoiceConditions|null;
    public caseFunction: CaseConditions|null;
    public patientFunction: CustomerConditions|null;
    public classattendanceFunction: ClassAttendanceConditions|null;
    public parameters: { [index:string]: Object; }|null;
    public chargeFunction: ChargeConditions|null;
    public formFunction: FormConditions|null;
    public stockFunction: StockConditions|null;

    public constructor(init?: Partial<EventCondition>) { (Object as any).assign(this, init); }
}
(EventCondition as unknown)[immerable] = true;

export enum EventActionType
{
    Task = 'Task',
    AddTag = 'AddTag',
    RemoveTag = 'RemoveTag',
    Email = 'Email',
    SMS = 'SMS',
    Form = 'Form',
    AddTagsFromCharge = 'AddTagsFromCharge',
    UpdateField = 'UpdateField',
    Mailchimp = 'Mailchimp',
    AddAlert = 'AddAlert',
    AddNote = 'AddNote',
}

export enum TimeUnit
{
    Immediate = 'Immediate',
    Hours = 'Hours',
    Days = 'Days',
    Weeks = 'Weeks',
    Months = 'Months',
}

export class FutureDateSpecifier
{
    public value: number|null;
    public unit: TimeUnit|null;

    public constructor(init?: Partial<FutureDateSpecifier>) { (Object as any).assign(this, init); }
}
(FutureDateSpecifier as unknown)[immerable] = true;

export class FutureTimeSpecifier
{
    public hour: number|null;
    public minutes: number|null;

    public constructor(init?: Partial<FutureTimeSpecifier>) { (Object as any).assign(this, init); }
}
(FutureTimeSpecifier as unknown)[immerable] = true;

export enum EEventActionTarget
{
    EventLinkedPractitioner = 'EventLinkedPractitioner',
    Patient = 'Patient',
    PatientLinkedBusiness = 'PatientLinkedBusiness',
    PatientLinkedPractitioner = 'PatientLinkedPractitioner',
    Specified = 'Specified',
    EventObject = 'EventObject',
    EventLinkedPatient = 'EventLinkedPatient',
}

// @Flags()
export enum EAlertForUser
{
    Everyone = 0,
    Specific = 1,
}

// @Flags()
export enum NoteLockMode
{
    Location = 76,
    Me = 77,
    None = 78,
    Role = 82,
}

export class EventAction
{
    public eventType: AutomationEventEntityType|null;
    public actionType: EventActionType|null;
    public due: FutureDateSpecifier|null;
    public time: FutureTimeSpecifier|null;
    public conditions: EventCondition[]|null;
    public template: string|null;
    public taskDescription: string|null;
    public tags: string[]|null;
    public taskDue: FutureDateSpecifier|null;
    public taskFor: number|null;
    public taskPriority: boolean|null;
    public taskReminder: boolean|null;
    public taskStatus: string|null;
    public formTemplateId: string|null;
    public customMessage: string|null;
    public audienceId: string|null;
    public target: EEventActionTarget|null;
    public emailAddress: string|null;
    public title: string|null;
    public notes: string|null;
    public alertRequiresAcknowledgement: boolean|null;
    public alertForUser: EAlertForUser|null;
    public userId: number|null;
    public noteLockMode: NoteLockMode|null;
    public noteLockValue: number|null;
    public isAlert: boolean|null;

    public constructor(init?: Partial<EventAction>) { (Object as any).assign(this, init); }
}
(EventAction as unknown)[immerable] = true;

export class AutomationEvent implements IHasGuidId
{
    public id: string|null;
    public type: AutomationEventEntityType|null;
    public eventName: AutomationEventName|null;
    public name: string|null;
    public description: string|null;
    public isActive: boolean|null;
    public isArchived: boolean|null;
    public conditions: EventCondition[]|null;
    public actions: EventAction[]|null;
    public isBulkAction: boolean|null;
    public createdDate: string|null;
    public lookupValue: string|null;
    public beforeDays: number|null;

    public constructor(init?: Partial<AutomationEvent>) { (Object as any).assign(this, init); }
}
(AutomationEvent as unknown)[immerable] = true;

export interface IHasGuidId extends IHasIdMarker
{
    id: string|null;
}

export enum TagEntityType
{
    General = 'General',
    Patient = 'Patient',
    Stock = 'Stock',
}

export class Tag implements IHasGuidId
{
    public id: string|null;
    public name: string|null;
    public type: TagEntityType|null;
    public colour: string|null;
    public isActive: boolean|null;
    public isInverted: boolean|null;
    public showInLists: boolean|null;

    public constructor(init?: Partial<Tag>) { (Object as any).assign(this, init); }
}
(Tag as unknown)[immerable] = true;

export class AssertionResponse
{
    public authenticatorData: string|null;
    public signature: string|null;
    public clientDataJson: string|null;
    public userHandle: string|null;

    public constructor(init?: Partial<AssertionResponse>) { (Object as any).assign(this, init); }
}

export enum PublicKeyCredentialType
{
    PublicKey = 'public-key',
}

export class AuthenticationExtensionsClientOutputs
{
    public appID: boolean|null;
    public authenticatorSelection: boolean|null;

    public constructor(init?: Partial<AuthenticationExtensionsClientOutputs>) { (Object as any).assign(this, init); }
}
(AuthenticationExtensionsClientOutputs as unknown)[immerable] = true;

export class ResponseData
{
    public attestationObject: string|null;
    public clientDataJson: string|null;

    public constructor(init?: Partial<ResponseData>) { (Object as any).assign(this, init); }
}

export class AssignedCustomAttributeDto
{
    public id: string|null;
    public objectId: number|null;
    public objectType: string|null;
    public customAttributeType: string|null;
    public customAttributeId: string|null;
    public objectGuid: string|null;
    public name: string|null;

    public constructor(init?: Partial<AssignedCustomAttributeDto>) { (Object as any).assign(this, init); }
}
(AssignedCustomAttributeDto as unknown)[immerable] = true;

export enum AccessMode
{
    Private = 'Private',
    ViewOnly = 'ViewOnly',
    FullAccess = 'FullAccess',
}

export enum DefaultStockTypes
{
    First = 'First',
    FollowUp = 'FollowUp',
    Dna = 'Dna',
    Cancel = 'Cancel',
    Unknown = 'Unknown',
}

export class TreatmentAuthResponse
{
    public id: number|null;
    public authCode: string|null;
    public expired: string|null;
    public isExpired: boolean|null;
    public maxTreatments: number|null;
    public maxValue: number|null;
    public expiryDate: string|null;
    public usedTreatments: number|null;
    public usedValue: number|null;
    public usedFor: string|null;
    public startDate: string|null;
    public groupId: number|null;
    public caseId: number|null;
    public customerId: number|null;
    public contactId: number|null;
    public valueRemaining: number|null;
    public appointmentsRemaining: number|null;
    public bodySite: string|null;
    public groupName: string|null;
    public serviceType: string|null;
    public serviceTypeId: number|null;
    public prontoBookingAuditId: string|null;
    public authCodeCustomerReference: string|null;

    public constructor(init?: Partial<TreatmentAuthResponse>) { (Object as any).assign(this, init); }
}
(TreatmentAuthResponse as unknown)[immerable] = true;

export enum PrepaymentType
{
    PayLater = 'PayLater',
    Autopay = 'Autopay',
}

export interface IAlertRequest
{
}

export class IdDescriminatorType
{
    public objectId: number|null;
    public descriminatorType: string|null;

    public constructor(init?: Partial<IdDescriminatorType>) { (Object as any).assign(this, init); }
}
(IdDescriminatorType as unknown)[immerable] = true;

export enum SearchModuleEntityType
{
    Audit = 'Audit',
    AutomationRules = 'AutomationRules',
    Business = 'Business',
    Case = 'Case',
    Charge = 'Charge',
    Debtor = 'Debtor',
    Diary = 'Diary',
    Expenditure = 'Expenditure',
    GdsEstimate = 'GdsEstimate',
    Invoice = 'Invoice',
    JobSheet = 'JobSheet',
    Patient = 'Patient',
    Location = 'Location',
    MedicalContact = 'MedicalContact',
    Payment = 'Payment',
    Practitioner = 'Practitioner',
    Room = 'Room',
    RpReferrals = 'RpReferrals',
    RpReferralsAction = 'RpReferralsAction',
    RpFiles = 'RpFiles',
    Supplier = 'Supplier',
    Subscription = 'Subscription',
    RpUser = 'RpUser',
    Stock = 'Stock',
    Timeline = 'Timeline',
    User = 'User',
    Vehicle = 'Vehicle',
}

export class SearchFilter implements IHasGuidId
{
    public id: string|null;
    public filterModule: SearchModuleEntityType|null;
    public filterName: string|null;
    public filterDescription: string|null;
    public isActive: boolean|null;
    public filterConditions: string|null;
    // @Ignore()
    public parsedFilterConditions: SearchFilterCondition[]|null;

    public constructor(init?: Partial<SearchFilter>) { (Object as any).assign(this, init); }
}
(SearchFilter as unknown)[immerable] = true;

export class LedgerAccountInfo
{
    public id: string|null;
    public accountName: string|null;
    public code: string|null;
    public type: string|null;
    public override: boolean|null;

    public constructor(init?: Partial<LedgerAccountInfo>) { (Object as any).assign(this, init); }
}
(LedgerAccountInfo as unknown)[immerable] = true;

export enum LedgerCodeCategory
{
    DefaultSales = 'DefaultSales',
    DefaultIncome = 'DefaultIncome',
    Stock = 'Stock',
    Consultation = 'Consultation',
    Class = 'Class',
    Package = 'Package',
    CreditNote = 'CreditNote',
    WriteOff = 'WriteOff',
    Discount = 'Discount',
    Transfer = 'Transfer',
    Cancellation = 'Cancellation',
    Dna = 'Dna',
}

export class LedgerAccountInfoWithCategory extends LedgerAccountInfo
{
    public ledgerCategory: LedgerCodeCategory|null;

    public constructor(init?: Partial<LedgerAccountInfoWithCategory>) { super(init); (Object as any).assign(this, init); }
}
(LedgerAccountInfoWithCategory as unknown)[immerable] = true;

export class TaxRateInfo
{
    public id: string|null;
    public name: string|null;
    public code: string|null;
    public totalTaxRate: number|null;

    public constructor(init?: Partial<TaxRateInfo>) { (Object as any).assign(this, init); }
}
(TaxRateInfo as unknown)[immerable] = true;

export enum TaxRateCategory
{
    Taxable = 'Taxable',
    NonTaxable = 'NonTaxable',
}

export class TaxRateInfoWithCategory extends TaxRateInfo
{
    public taxCategory: TaxRateCategory|null;

    public constructor(init?: Partial<TaxRateInfoWithCategory>) { super(init); (Object as any).assign(this, init); }
}
(TaxRateInfoWithCategory as unknown)[immerable] = true;

export class AccountingSettingInfo
{
    public tenantId: string|null;
    public status: string|null;
    public systemName: AccountingSystemProviderName|null;
    public serviceId: string|null;
    public salesLedgerCodeId: string|null;
    public incomeLedgerCodeId: string|null;
    public nonTaxableRateId: string|null;
    public taxableRateId: string|null;
    public appointmentItemsLedgerCodeId: string|null;
    public classItemsLedgerCodeId: string|null;
    public packageItemsLedgerCodeId: string|null;
    public stockItemsLedgerCodeId: string|null;
    public discountItemsLedgerCodeId: string|null;
    public creditItemsLedgerCodeId: string|null;
    public transferItemsLedgerCodeId: string|null;
    public writeoffItemsLedgerCodeId: string|null;
    public cancellationItemsLedgerCodeId: string|null;
    public dnaItemsLedgerCodeId: string|null;
    public syncStartDate: string|null;
    public deactivationDate: string|null;
    public setupComplete: boolean|null;
    public deactivated: boolean|null;
    public ledgerAccountInfos: LedgerAccountInfoWithCategory[]|null;
    public taxRateInfos: TaxRateInfoWithCategory[]|null;
    public activationHistory: string[]|null;

    public constructor(init?: Partial<AccountingSettingInfo>) { (Object as any).assign(this, init); }
}
(AccountingSettingInfo as unknown)[immerable] = true;

export enum SubscriptionStatus
{
    Active = 1,
    Cancelled = 2,
    Expired = 3,
    Removed = 4,
}

export enum SubscriptionBillingMode
{
    Now = 'Now',
    Later = 'Later',
}

export enum SubscriptionPaymentMode
{
    Now = 'Now',
    Later = 'Later',
}

export enum SubscriptionPaymentMethod
{
    Cash = 'Cash',
    ExistingCard = 'ExistingCard',
    Other = 'Other',
    SynchronousTempCardOnly = 'SynchronousTempCardOnly',
    SquareTerminal = 'SquareTerminal',
}

export enum SubscriptionRecurrenceInterval
{
    Day = 'Day',
    Week = 'Week',
    Fortnight = 'Fortnight',
    Month = 'Month',
    Quarter = 'Quarter',
    Year = 'Year',
}

export class PackageBundleItemResponse
{
    public id: string|null;
    public bundleId: string|null;
    public type: PackageBundleItemType|null;
    public typeId: number|null;
    public description: string|null;

    public constructor(init?: Partial<PackageBundleItemResponse>) { (Object as any).assign(this, init); }
}
(PackageBundleItemResponse as unknown)[immerable] = true;

export class PackageBundleResponse
{
    public id: string|null;
    public quantity: number|null;
    public type: PackageBundleItemType|null;
    public items: PackageBundleItemResponse[]|null;
    public packageId: string|null;

    public constructor(init?: Partial<PackageBundleResponse>) { (Object as any).assign(this, init); }
}
(PackageBundleResponse as unknown)[immerable] = true;

// @Flags()
export enum PackageType
{
    ITEM = 0,
    CREDIT = 1,
}

export enum WaitListGender
{
    Unspecified = 'Unspecified',
    Male = 'Male',
    Female = 'Female',
    Specified = 'Specified',
}

export enum TimeOfDay
{
    AnyTime = 'AnyTime',
    Morning = 'Morning',
    Afternoon = 'Afternoon',
    Evening = 'Evening',
    Custom = 'Custom',
}

export enum WaitingListType
{
    Appointment = 'Appointment',
    Class = 'Class',
    Course = 'Course',
}

export enum LocationType
{
    Any = 'Any',
    Specific = 'Specific',
}

export enum WaitingListUrgency
{
    Normal = 'Normal',
    High = 'High',
}

export enum WaitingListStatus
{
    Waiting = 'Waiting',
    AwaitingConfirmation = 'AwaitingConfirmation',
    Booked = 'Booked',
    Declined = 'Declined',
    Expired = 'Expired',
}

export enum WaitingListSubStatus
{
    Awaiting = 'Awaiting',
    Confirmed = 'Confirmed',
    Declined = 'Declined',
    DidNotRespond = 'DidNotRespond',
    RespondedButNotBooked = 'RespondedButNotBooked',
}

export enum WaitingListNotificationType
{
    KeepNotifying = 'KeepNotifying',
    Pause = 'Pause',
    Remove = 'Remove',
}

export enum WaitingListBookingType
{
    TM3 = 'TM3',
    ONLINE = 'ONLINE',
}

export class Qualification
{
    public id: string|null;
    public isSet: boolean|null;
    public name: string|null;
    public body: string|null;
    public expiryDate: string|null;
    public startDate: string|null;

    public constructor(init?: Partial<Qualification>) { (Object as any).assign(this, init); }
}
(Qualification as unknown)[immerable] = true;

export class AppointmentPractitionerObject
{
    public title: string|null;
    public forename: string|null;
    public surname: string|null;
    public gender: string|null;
    public id: string|null;
    public practitionerId: number|null;
    public name: string|null;
    public shortName: string|null;
    public qualifications: Qualification[]|null;

    public constructor(init?: Partial<AppointmentPractitionerObject>) { (Object as any).assign(this, init); }
}
(AppointmentPractitionerObject as unknown)[immerable] = true;

export class AppointmentLocationObject
{
    public name: string|null;
    public id: string|null;
    public locationId: number|null;

    public constructor(init?: Partial<AppointmentLocationObject>) { (Object as any).assign(this, init); }
}
(AppointmentLocationObject as unknown)[immerable] = true;

export class AppointmentRoomObject
{
    public id: number|null;

    public constructor(init?: Partial<AppointmentRoomObject>) { (Object as any).assign(this, init); }
}
(AppointmentRoomObject as unknown)[immerable] = true;

export enum AppointmentType
{
    Pronto = 'Pronto',
    Internal = 'Internal',
}

export class AppointmentSearchResult
{
    public price: number|null;
    public priceExVat: number|null;
    public creditValue: number|null;
    public vatRate: number|null;
    public bookingMethod: string|null;
    public startDateTime: string|null;
    public endDateTime: string|null;
    public practitioner: AppointmentPractitionerObject|null;
    public location: AppointmentLocationObject|null;
    public room: AppointmentRoomObject|null;
    public patientId: string|null;
    public stockId: string|null;
    public networkId: string|null;
    public serviceId: string|null;
    public serviceTypeId: number|null;
    public appointmentType: AppointmentType|null;
    public returnAppointmentTimesAsUnspecified: boolean|null;
    public isFollowUp: boolean|null;

    public constructor(init?: Partial<AppointmentSearchResult>) { (Object as any).assign(this, init); }
}
(AppointmentSearchResult as unknown)[immerable] = true;

export enum PaymentMode
{
    Credit = 1,
    Card = 2,
    SubscriptionPackage = 3,
    Clinic = 4,
    PrePaid = 5,
    FutureCredit = 6,
    CreditBasedPackage = 7,
}

export class CustomerCardDemographics
{
    public name: string|null;
    public addressLine1: string|null;
    public addressLine2: string|null;
    public addressLine3: string|null;
    public addressLine4: string|null;
    public addressLine5: string|null;
    public postCode: string|null;

    public constructor(init?: Partial<CustomerCardDemographics>) { (Object as any).assign(this, init); }
}
(CustomerCardDemographics as unknown)[immerable] = true;

export class TakePaymentRequest
{
    public provider: PaymentProviderName|null;
    public data: { [index:string]: string; }|null;
    public saveCard: boolean|null;
    public useSavedCard: boolean|null;
    public customerDetails: CustomerCardDemographics|null;

    public constructor(init?: Partial<TakePaymentRequest>) { (Object as any).assign(this, init); }
}
(TakePaymentRequest as unknown)[immerable] = true;

export class OnlineGroupDto
{
    public id: number|null;
    public name: string|null;

    public constructor(init?: Partial<OnlineGroupDto>) { (Object as any).assign(this, init); }
}
(OnlineGroupDto as unknown)[immerable] = true;

export class CardDetails
{
    public brand: string|null;
    public elementType: string|null;
    public cardName: string|null;
    public expiryMonth: number|null;
    public expiryYear: number|null;
    public lastFourDigits: string|null;

    public constructor(init?: Partial<CardDetails>) { (Object as any).assign(this, init); }
}
(CardDetails as unknown)[immerable] = true;

export class MsContact
{
    public name: string|null;
    public email: string|null;

    public constructor(init?: Partial<MsContact>) { (Object as any).assign(this, init); }
}
(MsContact as unknown)[immerable] = true;

export class StripeEntity implements IStripeEntity
{

    public constructor(init?: Partial<StripeEntity>) { (Object as any).assign(this, init); }
}

export class StripeEntity_1<T> extends StripeEntity
{

    public constructor(init?: Partial<StripeEntity_1<T>>) { super(init); (Object as any).assign(this, init); }
}

export class PaymentMethodAcssDebit extends StripeEntity_1<PaymentMethodAcssDebit>
{
    public bankName: string|null;
    public fingerprint: string|null;
    public institutionNumber: string|null;
    public last4: string|null;
    public transitNumber: string|null;

    public constructor(init?: Partial<PaymentMethodAcssDebit>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodAcssDebit as unknown)[immerable] = true;

export class PaymentMethodAffirm extends StripeEntity_1<PaymentMethodAffirm>
{

    public constructor(init?: Partial<PaymentMethodAffirm>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodAffirm as unknown)[immerable] = true;

export class PaymentMethodAfterpayClearpay extends StripeEntity_1<PaymentMethodAfterpayClearpay>
{

    public constructor(init?: Partial<PaymentMethodAfterpayClearpay>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodAfterpayClearpay as unknown)[immerable] = true;

export class PaymentMethodAlipay extends StripeEntity_1<PaymentMethodAlipay>
{

    public constructor(init?: Partial<PaymentMethodAlipay>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodAlipay as unknown)[immerable] = true;

export class PaymentMethodAlma extends StripeEntity_1<PaymentMethodAlma>
{

    public constructor(init?: Partial<PaymentMethodAlma>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodAlma as unknown)[immerable] = true;

export class PaymentMethodAmazonPay extends StripeEntity_1<PaymentMethodAmazonPay>
{

    public constructor(init?: Partial<PaymentMethodAmazonPay>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodAmazonPay as unknown)[immerable] = true;

export class PaymentMethodAuBecsDebit extends StripeEntity_1<PaymentMethodAuBecsDebit>
{
    public bsbNumber: string|null;
    public fingerprint: string|null;
    public last4: string|null;

    public constructor(init?: Partial<PaymentMethodAuBecsDebit>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodAuBecsDebit as unknown)[immerable] = true;

export class PaymentMethodBacsDebit extends StripeEntity_1<PaymentMethodBacsDebit>
{
    public fingerprint: string|null;
    public last4: string|null;
    public sortCode: string|null;

    public constructor(init?: Partial<PaymentMethodBacsDebit>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodBacsDebit as unknown)[immerable] = true;

export class PaymentMethodBancontact extends StripeEntity_1<PaymentMethodBancontact>
{

    public constructor(init?: Partial<PaymentMethodBancontact>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodBancontact as unknown)[immerable] = true;

export class Address extends StripeEntity_1<Address>
{
    public city: string|null;
    public country: string|null;
    public line1: string|null;
    public line2: string|null;
    public postalCode: string|null;
    public state: string|null;

    public constructor(init?: Partial<Address>) { super(init); (Object as any).assign(this, init); }
}
(Address as unknown)[immerable] = true;

export class PaymentMethodBillingDetails extends StripeEntity_1<PaymentMethodBillingDetails>
{
    public address: Address|null;
    public email: string|null;
    public name: string|null;
    public phone: string|null;

    public constructor(init?: Partial<PaymentMethodBillingDetails>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodBillingDetails as unknown)[immerable] = true;

export class PaymentMethodBlik extends StripeEntity_1<PaymentMethodBlik>
{

    public constructor(init?: Partial<PaymentMethodBlik>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodBlik as unknown)[immerable] = true;

export class PaymentMethodBoleto extends StripeEntity_1<PaymentMethodBoleto>
{
    public taxId: string|null;

    public constructor(init?: Partial<PaymentMethodBoleto>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodBoleto as unknown)[immerable] = true;

export class PaymentMethodCardChecks extends StripeEntity_1<PaymentMethodCardChecks>
{
    public addressLine1Check: string|null;
    public addressPostalCodeCheck: string|null;
    public cvcCheck: string|null;

    public constructor(init?: Partial<PaymentMethodCardChecks>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodCardChecks as unknown)[immerable] = true;

export class PaymentMethodCardGeneratedFromPaymentMethodDetailsCardPresentOffline extends StripeEntity_1<PaymentMethodCardGeneratedFromPaymentMethodDetailsCardPresentOffline>
{
    public storedAt: string|null;
    public type: string|null;

    public constructor(init?: Partial<PaymentMethodCardGeneratedFromPaymentMethodDetailsCardPresentOffline>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodCardGeneratedFromPaymentMethodDetailsCardPresentOffline as unknown)[immerable] = true;

export class PaymentMethodCardGeneratedFromPaymentMethodDetailsCardPresentReceipt extends StripeEntity_1<PaymentMethodCardGeneratedFromPaymentMethodDetailsCardPresentReceipt>
{
    public accountType: string|null;
    public applicationCryptogram: string|null;
    public applicationPreferredName: string|null;
    public authorizationCode: string|null;
    public authorizationResponseCode: string|null;
    public cardholderVerificationMethod: string|null;
    public dedicatedFileName: string|null;
    public terminalVerificationResults: string|null;
    public transactionStatusInformation: string|null;

    public constructor(init?: Partial<PaymentMethodCardGeneratedFromPaymentMethodDetailsCardPresentReceipt>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodCardGeneratedFromPaymentMethodDetailsCardPresentReceipt as unknown)[immerable] = true;

export class PaymentMethodCardGeneratedFromPaymentMethodDetailsCardPresentWallet extends StripeEntity_1<PaymentMethodCardGeneratedFromPaymentMethodDetailsCardPresentWallet>
{
    public type: string|null;

    public constructor(init?: Partial<PaymentMethodCardGeneratedFromPaymentMethodDetailsCardPresentWallet>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodCardGeneratedFromPaymentMethodDetailsCardPresentWallet as unknown)[immerable] = true;

export class PaymentMethodCardGeneratedFromPaymentMethodDetailsCardPresent extends StripeEntity_1<PaymentMethodCardGeneratedFromPaymentMethodDetailsCardPresent>
{
    public amountAuthorized: number|null;
    public brand: string|null;
    public brandProduct: string|null;
    public captureBefore: string|null;
    public cardholderName: string|null;
    public country: string|null;
    public description: string|null;
    public emvAuthData: string|null;
    public expMonth: number|null;
    public expYear: number|null;
    public fingerprint: string|null;
    public funding: string|null;
    public generatedCard: string|null;
    public iin: string|null;
    public incrementalAuthorizationSupported: boolean|null;
    public issuer: string|null;
    public last4: string|null;
    public network: string|null;
    public networkTransactionId: string|null;
    public offline: PaymentMethodCardGeneratedFromPaymentMethodDetailsCardPresentOffline|null;
    public overcaptureSupported: boolean|null;
    public preferredLocales: string[]|null;
    public readMethod: string|null;
    public receipt: PaymentMethodCardGeneratedFromPaymentMethodDetailsCardPresentReceipt|null;
    public wallet: PaymentMethodCardGeneratedFromPaymentMethodDetailsCardPresentWallet|null;

    public constructor(init?: Partial<PaymentMethodCardGeneratedFromPaymentMethodDetailsCardPresent>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodCardGeneratedFromPaymentMethodDetailsCardPresent as unknown)[immerable] = true;

export class PaymentMethodCardGeneratedFromPaymentMethodDetails extends StripeEntity_1<PaymentMethodCardGeneratedFromPaymentMethodDetails>
{
    public cardPresent: PaymentMethodCardGeneratedFromPaymentMethodDetailsCardPresent|null;
    public type: string|null;

    public constructor(init?: Partial<PaymentMethodCardGeneratedFromPaymentMethodDetails>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodCardGeneratedFromPaymentMethodDetails as unknown)[immerable] = true;

export class PaymentMethodCardGeneratedFrom extends StripeEntity_1<PaymentMethodCardGeneratedFrom>
{
    public charge: string|null;
    public paymentMethodDetails: PaymentMethodCardGeneratedFromPaymentMethodDetails|null;

    public constructor(init?: Partial<PaymentMethodCardGeneratedFrom>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodCardGeneratedFrom as unknown)[immerable] = true;

export class PaymentMethodCardNetworks extends StripeEntity_1<PaymentMethodCardNetworks>
{
    public available: string[]|null;
    public preferred: string|null;

    public constructor(init?: Partial<PaymentMethodCardNetworks>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodCardNetworks as unknown)[immerable] = true;

export class PaymentMethodCardThreeDSecureUsage extends StripeEntity_1<PaymentMethodCardThreeDSecureUsage>
{
    public supported: boolean|null;

    public constructor(init?: Partial<PaymentMethodCardThreeDSecureUsage>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodCardThreeDSecureUsage as unknown)[immerable] = true;

export class PaymentMethodCardWalletAmexExpressCheckout extends StripeEntity_1<PaymentMethodCardWalletAmexExpressCheckout>
{

    public constructor(init?: Partial<PaymentMethodCardWalletAmexExpressCheckout>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodCardWalletAmexExpressCheckout as unknown)[immerable] = true;

export class PaymentMethodCardWalletApplePay extends StripeEntity_1<PaymentMethodCardWalletApplePay>
{

    public constructor(init?: Partial<PaymentMethodCardWalletApplePay>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodCardWalletApplePay as unknown)[immerable] = true;

export class PaymentMethodCardWalletGooglePay extends StripeEntity_1<PaymentMethodCardWalletGooglePay>
{

    public constructor(init?: Partial<PaymentMethodCardWalletGooglePay>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodCardWalletGooglePay as unknown)[immerable] = true;

export class PaymentMethodCardWalletLink extends StripeEntity_1<PaymentMethodCardWalletLink>
{

    public constructor(init?: Partial<PaymentMethodCardWalletLink>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodCardWalletLink as unknown)[immerable] = true;

export class PaymentMethodCardWalletMasterpass extends StripeEntity_1<PaymentMethodCardWalletMasterpass>
{
    public billingAddress: Address|null;
    public email: string|null;
    public name: string|null;
    public shippingAddress: Address|null;

    public constructor(init?: Partial<PaymentMethodCardWalletMasterpass>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodCardWalletMasterpass as unknown)[immerable] = true;

export class PaymentMethodCardWalletSamsungPay extends StripeEntity_1<PaymentMethodCardWalletSamsungPay>
{

    public constructor(init?: Partial<PaymentMethodCardWalletSamsungPay>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodCardWalletSamsungPay as unknown)[immerable] = true;

export class PaymentMethodCardWalletVisaCheckout extends StripeEntity_1<PaymentMethodCardWalletVisaCheckout>
{
    public billingAddress: Address|null;
    public email: string|null;
    public name: string|null;
    public shippingAddress: Address|null;

    public constructor(init?: Partial<PaymentMethodCardWalletVisaCheckout>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodCardWalletVisaCheckout as unknown)[immerable] = true;

export class PaymentMethodCardWallet extends StripeEntity_1<PaymentMethodCardWallet>
{
    public amexExpressCheckout: PaymentMethodCardWalletAmexExpressCheckout|null;
    public applePay: PaymentMethodCardWalletApplePay|null;
    public dynamicLast4: string|null;
    public googlePay: PaymentMethodCardWalletGooglePay|null;
    public link: PaymentMethodCardWalletLink|null;
    public masterpass: PaymentMethodCardWalletMasterpass|null;
    public samsungPay: PaymentMethodCardWalletSamsungPay|null;
    public type: string|null;
    public visaCheckout: PaymentMethodCardWalletVisaCheckout|null;

    public constructor(init?: Partial<PaymentMethodCardWallet>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodCardWallet as unknown)[immerable] = true;

export class PaymentMethodCard extends StripeEntity_1<PaymentMethodCard>
{
    public brand: string|null;
    public checks: PaymentMethodCardChecks|null;
    public country: string|null;
    public description: string|null;
    public displayBrand: string|null;
    public expMonth: number|null;
    public expYear: number|null;
    public fingerprint: string|null;
    public funding: string|null;
    public generatedFrom: PaymentMethodCardGeneratedFrom|null;
    public iin: string|null;
    public issuer: string|null;
    public last4: string|null;
    public networks: PaymentMethodCardNetworks|null;
    public regulatedStatus: string|null;
    public threeDSecureUsage: PaymentMethodCardThreeDSecureUsage|null;
    public wallet: PaymentMethodCardWallet|null;

    public constructor(init?: Partial<PaymentMethodCard>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodCard as unknown)[immerable] = true;

export class PaymentMethodCardPresentNetworks extends StripeEntity_1<PaymentMethodCardPresentNetworks>
{
    public available: string[]|null;
    public preferred: string|null;

    public constructor(init?: Partial<PaymentMethodCardPresentNetworks>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodCardPresentNetworks as unknown)[immerable] = true;

export class PaymentMethodCardPresentOffline extends StripeEntity_1<PaymentMethodCardPresentOffline>
{
    public storedAt: string|null;
    public type: string|null;

    public constructor(init?: Partial<PaymentMethodCardPresentOffline>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodCardPresentOffline as unknown)[immerable] = true;

export class PaymentMethodCardPresentWallet extends StripeEntity_1<PaymentMethodCardPresentWallet>
{
    public type: string|null;

    public constructor(init?: Partial<PaymentMethodCardPresentWallet>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodCardPresentWallet as unknown)[immerable] = true;

export class PaymentMethodCardPresent extends StripeEntity_1<PaymentMethodCardPresent>
{
    public brand: string|null;
    public brandProduct: string|null;
    public cardholderName: string|null;
    public country: string|null;
    public description: string|null;
    public expMonth: number|null;
    public expYear: number|null;
    public fingerprint: string|null;
    public funding: string|null;
    public iin: string|null;
    public issuer: string|null;
    public last4: string|null;
    public networks: PaymentMethodCardPresentNetworks|null;
    public offline: PaymentMethodCardPresentOffline|null;
    public preferredLocales: string[]|null;
    public readMethod: string|null;
    public wallet: PaymentMethodCardPresentWallet|null;

    public constructor(init?: Partial<PaymentMethodCardPresent>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodCardPresent as unknown)[immerable] = true;

export class PaymentMethodCashapp extends StripeEntity_1<PaymentMethodCashapp>
{
    public buyerId: string|null;
    public cashtag: string|null;

    public constructor(init?: Partial<PaymentMethodCashapp>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodCashapp as unknown)[immerable] = true;

export class PaymentMethodCustomerBalance extends StripeEntity_1<PaymentMethodCustomerBalance>
{

    public constructor(init?: Partial<PaymentMethodCustomerBalance>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodCustomerBalance as unknown)[immerable] = true;

export class PaymentMethodEps extends StripeEntity_1<PaymentMethodEps>
{
    public bank: string|null;

    public constructor(init?: Partial<PaymentMethodEps>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodEps as unknown)[immerable] = true;

export class PaymentMethodFpx extends StripeEntity_1<PaymentMethodFpx>
{
    public accountHolderType: string|null;
    public bank: string|null;

    public constructor(init?: Partial<PaymentMethodFpx>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodFpx as unknown)[immerable] = true;

export class PaymentMethodGiropay extends StripeEntity_1<PaymentMethodGiropay>
{

    public constructor(init?: Partial<PaymentMethodGiropay>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodGiropay as unknown)[immerable] = true;

export class PaymentMethodGrabpay extends StripeEntity_1<PaymentMethodGrabpay>
{

    public constructor(init?: Partial<PaymentMethodGrabpay>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodGrabpay as unknown)[immerable] = true;

export class PaymentMethodIdeal extends StripeEntity_1<PaymentMethodIdeal>
{
    public bank: string|null;
    public bic: string|null;

    public constructor(init?: Partial<PaymentMethodIdeal>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodIdeal as unknown)[immerable] = true;

export class PaymentMethodInteracPresentNetworks extends StripeEntity_1<PaymentMethodInteracPresentNetworks>
{
    public available: string[]|null;
    public preferred: string|null;

    public constructor(init?: Partial<PaymentMethodInteracPresentNetworks>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodInteracPresentNetworks as unknown)[immerable] = true;

export class PaymentMethodInteracPresent extends StripeEntity_1<PaymentMethodInteracPresent>
{
    public brand: string|null;
    public cardholderName: string|null;
    public country: string|null;
    public description: string|null;
    public expMonth: number|null;
    public expYear: number|null;
    public fingerprint: string|null;
    public funding: string|null;
    public iin: string|null;
    public issuer: string|null;
    public last4: string|null;
    public networks: PaymentMethodInteracPresentNetworks|null;
    public preferredLocales: string[]|null;
    public readMethod: string|null;

    public constructor(init?: Partial<PaymentMethodInteracPresent>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodInteracPresent as unknown)[immerable] = true;

export class PaymentMethodKakaoPay extends StripeEntity_1<PaymentMethodKakaoPay>
{

    public constructor(init?: Partial<PaymentMethodKakaoPay>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodKakaoPay as unknown)[immerable] = true;

export class PaymentMethodKlarnaDob extends StripeEntity_1<PaymentMethodKlarnaDob>
{
    public day: number|null;
    public month: number|null;
    public year: number|null;

    public constructor(init?: Partial<PaymentMethodKlarnaDob>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodKlarnaDob as unknown)[immerable] = true;

export class PaymentMethodKlarna extends StripeEntity_1<PaymentMethodKlarna>
{
    public dob: PaymentMethodKlarnaDob|null;

    public constructor(init?: Partial<PaymentMethodKlarna>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodKlarna as unknown)[immerable] = true;

export class PaymentMethodKonbini extends StripeEntity_1<PaymentMethodKonbini>
{

    public constructor(init?: Partial<PaymentMethodKonbini>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodKonbini as unknown)[immerable] = true;

export class PaymentMethodKrCard extends StripeEntity_1<PaymentMethodKrCard>
{
    public brand: string|null;
    public last4: string|null;

    public constructor(init?: Partial<PaymentMethodKrCard>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodKrCard as unknown)[immerable] = true;

export class PaymentMethodLink extends StripeEntity_1<PaymentMethodLink>
{
    public email: string|null;
    public persistentToken: string|null;

    public constructor(init?: Partial<PaymentMethodLink>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodLink as unknown)[immerable] = true;

export class PaymentMethodMobilepay extends StripeEntity_1<PaymentMethodMobilepay>
{

    public constructor(init?: Partial<PaymentMethodMobilepay>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodMobilepay as unknown)[immerable] = true;

export class PaymentMethodMultibanco extends StripeEntity_1<PaymentMethodMultibanco>
{

    public constructor(init?: Partial<PaymentMethodMultibanco>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodMultibanco as unknown)[immerable] = true;

export class PaymentMethodNaverPay extends StripeEntity_1<PaymentMethodNaverPay>
{
    public funding: string|null;

    public constructor(init?: Partial<PaymentMethodNaverPay>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodNaverPay as unknown)[immerable] = true;

export class PaymentMethodOxxo extends StripeEntity_1<PaymentMethodOxxo>
{

    public constructor(init?: Partial<PaymentMethodOxxo>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodOxxo as unknown)[immerable] = true;

export class PaymentMethodP24 extends StripeEntity_1<PaymentMethodP24>
{
    public bank: string|null;

    public constructor(init?: Partial<PaymentMethodP24>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodP24 as unknown)[immerable] = true;

export class PaymentMethodPayByBank extends StripeEntity_1<PaymentMethodPayByBank>
{

    public constructor(init?: Partial<PaymentMethodPayByBank>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodPayByBank as unknown)[immerable] = true;

export class PaymentMethodPayco extends StripeEntity_1<PaymentMethodPayco>
{

    public constructor(init?: Partial<PaymentMethodPayco>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodPayco as unknown)[immerable] = true;

export class PaymentMethodPaynow extends StripeEntity_1<PaymentMethodPaynow>
{

    public constructor(init?: Partial<PaymentMethodPaynow>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodPaynow as unknown)[immerable] = true;

export class PaymentMethodPaypal extends StripeEntity_1<PaymentMethodPaypal>
{
    public country: string|null;
    public payerEmail: string|null;
    public payerId: string|null;

    public constructor(init?: Partial<PaymentMethodPaypal>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodPaypal as unknown)[immerable] = true;

export class PaymentMethodPix extends StripeEntity_1<PaymentMethodPix>
{

    public constructor(init?: Partial<PaymentMethodPix>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodPix as unknown)[immerable] = true;

export class PaymentMethodPromptpay extends StripeEntity_1<PaymentMethodPromptpay>
{

    public constructor(init?: Partial<PaymentMethodPromptpay>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodPromptpay as unknown)[immerable] = true;

export class PaymentMethodRadarOptions extends StripeEntity_1<PaymentMethodRadarOptions>
{
    public session: string|null;

    public constructor(init?: Partial<PaymentMethodRadarOptions>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodRadarOptions as unknown)[immerable] = true;

export class PaymentMethodRevolutPay extends StripeEntity_1<PaymentMethodRevolutPay>
{

    public constructor(init?: Partial<PaymentMethodRevolutPay>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodRevolutPay as unknown)[immerable] = true;

export class PaymentMethodSamsungPay extends StripeEntity_1<PaymentMethodSamsungPay>
{

    public constructor(init?: Partial<PaymentMethodSamsungPay>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodSamsungPay as unknown)[immerable] = true;

export class PaymentMethodSepaDebitGeneratedFrom extends StripeEntity_1<PaymentMethodSepaDebitGeneratedFrom>
{

    public constructor(init?: Partial<PaymentMethodSepaDebitGeneratedFrom>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodSepaDebitGeneratedFrom as unknown)[immerable] = true;

export class PaymentMethodSepaDebit extends StripeEntity_1<PaymentMethodSepaDebit>
{
    public bankCode: string|null;
    public branchCode: string|null;
    public country: string|null;
    public fingerprint: string|null;
    public generatedFrom: PaymentMethodSepaDebitGeneratedFrom|null;
    public last4: string|null;

    public constructor(init?: Partial<PaymentMethodSepaDebit>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodSepaDebit as unknown)[immerable] = true;

export class PaymentMethodSofort extends StripeEntity_1<PaymentMethodSofort>
{
    public country: string|null;

    public constructor(init?: Partial<PaymentMethodSofort>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodSofort as unknown)[immerable] = true;

export class PaymentMethodSwish extends StripeEntity_1<PaymentMethodSwish>
{

    public constructor(init?: Partial<PaymentMethodSwish>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodSwish as unknown)[immerable] = true;

export class PaymentMethodTwint extends StripeEntity_1<PaymentMethodTwint>
{

    public constructor(init?: Partial<PaymentMethodTwint>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodTwint as unknown)[immerable] = true;

export class PaymentMethodUsBankAccountNetworks extends StripeEntity_1<PaymentMethodUsBankAccountNetworks>
{
    public preferred: string|null;
    public supported: string[]|null;

    public constructor(init?: Partial<PaymentMethodUsBankAccountNetworks>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodUsBankAccountNetworks as unknown)[immerable] = true;

export class PaymentMethodUsBankAccountStatusDetailsBlocked extends StripeEntity_1<PaymentMethodUsBankAccountStatusDetailsBlocked>
{
    public networkCode: string|null;
    public reason: string|null;

    public constructor(init?: Partial<PaymentMethodUsBankAccountStatusDetailsBlocked>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodUsBankAccountStatusDetailsBlocked as unknown)[immerable] = true;

export class PaymentMethodUsBankAccountStatusDetails extends StripeEntity_1<PaymentMethodUsBankAccountStatusDetails>
{
    public blocked: PaymentMethodUsBankAccountStatusDetailsBlocked|null;

    public constructor(init?: Partial<PaymentMethodUsBankAccountStatusDetails>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodUsBankAccountStatusDetails as unknown)[immerable] = true;

export class PaymentMethodUsBankAccount extends StripeEntity_1<PaymentMethodUsBankAccount>
{
    public accountHolderType: string|null;
    public accountType: string|null;
    public bankName: string|null;
    public financialConnectionsAccount: string|null;
    public fingerprint: string|null;
    public last4: string|null;
    public networks: PaymentMethodUsBankAccountNetworks|null;
    public routingNumber: string|null;
    public statusDetails: PaymentMethodUsBankAccountStatusDetails|null;

    public constructor(init?: Partial<PaymentMethodUsBankAccount>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodUsBankAccount as unknown)[immerable] = true;

export class PaymentMethodWechatPay extends StripeEntity_1<PaymentMethodWechatPay>
{

    public constructor(init?: Partial<PaymentMethodWechatPay>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodWechatPay as unknown)[immerable] = true;

export class PaymentMethodZip extends StripeEntity_1<PaymentMethodZip>
{

    public constructor(init?: Partial<PaymentMethodZip>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodZip as unknown)[immerable] = true;

export class PaymentMethod extends StripeEntity_1<PaymentMethod> implements IHasId, IHasMetadata, IHasObject
{
    public id: string|null;
    public object: string|null;
    public acssDebit: PaymentMethodAcssDebit|null;
    public affirm: PaymentMethodAffirm|null;
    public afterpayClearpay: PaymentMethodAfterpayClearpay|null;
    public alipay: PaymentMethodAlipay|null;
    public allowRedisplay: string|null;
    public alma: PaymentMethodAlma|null;
    public amazonPay: PaymentMethodAmazonPay|null;
    public auBecsDebit: PaymentMethodAuBecsDebit|null;
    public bacsDebit: PaymentMethodBacsDebit|null;
    public bancontact: PaymentMethodBancontact|null;
    public billingDetails: PaymentMethodBillingDetails|null;
    public blik: PaymentMethodBlik|null;
    public boleto: PaymentMethodBoleto|null;
    public card: PaymentMethodCard|null;
    public cardPresent: PaymentMethodCardPresent|null;
    public cashapp: PaymentMethodCashapp|null;
    public created: string|null;
    public customerBalance: PaymentMethodCustomerBalance|null;
    public eps: PaymentMethodEps|null;
    public fpx: PaymentMethodFpx|null;
    public giropay: PaymentMethodGiropay|null;
    public grabpay: PaymentMethodGrabpay|null;
    public ideal: PaymentMethodIdeal|null;
    public interacPresent: PaymentMethodInteracPresent|null;
    public kakaoPay: PaymentMethodKakaoPay|null;
    public klarna: PaymentMethodKlarna|null;
    public konbini: PaymentMethodKonbini|null;
    public krCard: PaymentMethodKrCard|null;
    public link: PaymentMethodLink|null;
    public livemode: boolean|null;
    public metadata: { [index:string]: string; }|null;
    public mobilepay: PaymentMethodMobilepay|null;
    public multibanco: PaymentMethodMultibanco|null;
    public naverPay: PaymentMethodNaverPay|null;
    public oxxo: PaymentMethodOxxo|null;
    public p24: PaymentMethodP24|null;
    public payByBank: PaymentMethodPayByBank|null;
    public payco: PaymentMethodPayco|null;
    public paynow: PaymentMethodPaynow|null;
    public paypal: PaymentMethodPaypal|null;
    public pix: PaymentMethodPix|null;
    public promptpay: PaymentMethodPromptpay|null;
    public radarOptions: PaymentMethodRadarOptions|null;
    public revolutPay: PaymentMethodRevolutPay|null;
    public samsungPay: PaymentMethodSamsungPay|null;
    public sepaDebit: PaymentMethodSepaDebit|null;
    public sofort: PaymentMethodSofort|null;
    public swish: PaymentMethodSwish|null;
    public twint: PaymentMethodTwint|null;
    public type: string|null;
    public usBankAccount: PaymentMethodUsBankAccount|null;
    public wechatPay: PaymentMethodWechatPay|null;
    public zip: PaymentMethodZip|null;

    public constructor(init?: Partial<PaymentMethod>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethod as unknown)[immerable] = true;

export enum ItemType
{
    ClassSessionDelete = 'ClassSessionDelete',
    AppointmentDelete = 'AppointmentDelete',
    Appointment = 'Appointment',
    ClassSession = 'ClassSession',
    StripeCommission = 'StripeCommission',
    OnlineAppointment = 'OnlineAppointment',
    OnlineClassSession = 'OnlineClassSession',
    VideoCall = 'VideoCall',
    ClickVideoCall = 'ClickVideoCall',
    AutomationAction = 'AutomationAction',
    FormSent = 'FormSent',
    ProntoReferral = 'ProntoReferral',
    SMS = 'SMS',
    AddressLookup = 'AddressLookup',
    ReferralPortalReferral = 'ReferralPortalReferral',
    PatientPortalReferral = 'PatientPortalReferral',
    ManualReferral = 'ManualReferral',
    APIReferral = 'APIReferral',
    ApiUsage = 'ApiUsage',
    SystemCredit = 'SystemCredit',
}

export enum TrafficReportOrdering
{
    All = 1,
    Appointments = 2,
    Classes = 3,
}

export class OnlineClinicService implements IHasGuidId
{
    public hidden: boolean|null;
    public networkServiceId: string|null;
    public networkId: string|null;
    public name: string|null;
    public description: string|null;
    public longDescription: string|null;
    public imageUrl: string|null;
    public discipline: string|null;
    public colour: string|null;
    public isOnline: boolean|null;
    public isClassService: boolean|null;
    public isCaseflowService: boolean|null;
    // @Ignore()
    public isCourse: boolean|null;

    public isMultiClass: boolean|null;
    public classTypeIds: number[]|null;
    public classTypeId: number|null;
    public excludeLocations: string[]|null;
    public excludePractitioners: string[]|null;
    public excludeDiscountCodes: string[]|null;
    public stockId: string|null;
    public excludeSessionIds: number[]|null;
    public excludeNormalSessionIds: number[]|null;
    public sortIndex: Object|null;
    public urlSlug: string|null;
    public canCancel: boolean|null;
    public isHidden: boolean|null;
    public businessId: number|null;
    public contractId: string|null;
    public productId: string|null;
    public productServiceId: string|null;
    public expiryDate: string|null;
    public accessCode: string|null;
    public cfBookingAction: string|null;
    // @Ignore()
    public hasAccessCode: boolean|null;

    // @Ignore()
    public accessCodeLength: number|null;

    // @Ignore()
    public isLocationBased: boolean|null;

    // @Ignore()
    public isDigitalTriage: boolean|null;

    // @Ignore()
    public serviceName: string|null;

    // @Ignore()
    public isPlaceholderService: boolean|null;

    public id: string|null;

    public constructor(init?: Partial<OnlineClinicService>) { (Object as any).assign(this, init); }
}
(OnlineClinicService as unknown)[immerable] = true;

export class OnlineServiceCategory implements IHasGuidId
{
    public id: string|null;
    public parentId: string|null;
    public title: string|null;
    public urlSlug: string|null;
    public description: string|null;
    public longDescription: string|null;
    public imageUrl: string|null;
    public isOnline: boolean|null;
    public sortIndex: number|null;
    public orderedServices: string[]|null;
    public businessId: number|null;
    // @Ignore()
    public hasClasses: boolean|null;

    // @Ignore()
    public hasAppointments: boolean|null;

    // @Ignore()
    public rootSlug: string|null;

    public hideFromExplore: boolean|null;

    public constructor(init?: Partial<OnlineServiceCategory>) { (Object as any).assign(this, init); }
}
(OnlineServiceCategory as unknown)[immerable] = true;

export enum OnlineSectionTypes
{
    Header = 'Header',
    Search = 'Search',
    AppointmentSearch = 'AppointmentSearch',
    ClassSearch = 'ClassSearch',
    Categories = 'Categories',
    Services = 'Services',
    Offers = 'Offers',
    Packages = 'Packages',
}

export class OnlineSection implements IHasId
{
    public sortIndex: number|null;
    public type: OnlineSectionTypes|null;
    public params: { [index:string]: string; }|null;
    public mode: string|null;
    public id: number|null;

    public constructor(init?: Partial<OnlineSection>) { (Object as any).assign(this, init); }
}
(OnlineSection as unknown)[immerable] = true;

export class BookingClassResponse
{
    public success: boolean|null;
    public isFull: boolean|null;
    public attendanceIds: number[]|null;
    public attendeeId: number|null;
    public backgroundJobId: string|null;

    public constructor(init?: Partial<BookingClassResponse>) { (Object as any).assign(this, init); }
}
(BookingClassResponse as unknown)[immerable] = true;

export class WaitingList implements IHasId
{
    public id: number|null;
    public createdDate: string|null;
    public waitingListGlobalId: string|null;
    public customerId: number|null;
    public description: string|null;
    public nextAppointment: string|null;
    public expiryDate: string|null;
    public practitionerId: number|null;
    public practitionerGender: WaitListGender|null;
    public locationId: number|null;
    public timeOfDay: TimeOfDay|null;
    public listType: WaitingListType|null;
    public locationPreference: LocationType|null;
    public dayPreference: string|null;
    public stockId: number|null;
    public classTypeId: number|null;
    public classSessionId: number|null;
    public temporaryAppointmentId: number|null;
    public temporaryClassSessionId: number|null;
    public temporaryCourseId: number|null;
    public dateTimeBookingOffered: string|null;
    public urgency: WaitingListUrgency|null;
    public status: WaitingListStatus|null;
    public subStatus: WaitingListSubStatus|null;
    public notificationType: WaitingListNotificationType|null;
    public dateTimeOfferDeclined: string|null;
    public pauseUntilDateTime: string|null;
    public dateTimeNotResponded: string|null;
    public bookingType: WaitingListBookingType|null;
    public dateTimeBookingDone: string|null;
    public linkedToAppointmentId: number|null;
    public startDate: string|null;

    public constructor(init?: Partial<WaitingList>) { (Object as any).assign(this, init); }
}
(WaitingList as unknown)[immerable] = true;

export enum SentryApmAction
{
    on = 'on',
    off = 'off',
}

export enum AppointmentStatus
{
    Booked = 0,
    Arrived = 1,
    Completed = 2,
    DNA = 3,
    Cancelled = 4,
    Temporary = 6,
    Provisional = 7,
}

export class ClickInvoiceReqBase
{
    public invoiceId: number|null;

    public constructor(init?: Partial<ClickInvoiceReqBase>) { (Object as any).assign(this, init); }
}
(ClickInvoiceReqBase as unknown)[immerable] = true;

export enum CommunicationMode
{
    Email = 'Email',
    SMS = 'SMS',
}

export enum ClassDateCreationMode
{
    WeeklyRecurrence = 'WeeklyRecurrence',
    DateRange = 'DateRange',
    CustomDates = 'CustomDates',
}

export enum ClashMode
{
    UpdateOnlyIfNoClashes = 'UpdateOnlyIfNoClashes',
    UpdateNonClashing = 'UpdateNonClashing',
    UpdateAllAnyway = 'UpdateAllAnyway',
    NeverUpdate = 'NeverUpdate',
    CreateExcludingClashes = 'CreateExcludingClashes',
}

export enum ClassBillingMode
{
    Attendance = 'Attendance',
    BillNow = 'BillNow',
    NewPackage = 'NewPackage',
    ExistingPackage = 'ExistingPackage',
    NewSubscription = 'NewSubscription',
    Autopay = 'Autopay',
    ExistingCreditPackage = 'ExistingCreditPackage',
}

export enum ClassPaymentMode
{
    DoNotBill = 'DoNotBill',
    PayLater = 'PayLater',
    PayNowCash = 'PayNowCash',
    PayNowCard = 'PayNowCard',
    UsePrePayment = 'UsePrePayment',
    PayNowMerchant = 'PayNowMerchant',
    PayNowMerchantTerminal = 'PayNowMerchantTerminal',
}

export enum SessionUpdateAppliesTo
{
    ThisSessionOnly = 'ThisSessionOnly',
    SameTimeEachWeek = 'SameTimeEachWeek',
    Custom = 'Custom',
}

export enum ClassEditType
{
    Practitioner = 'Practitioner',
    Room = 'Room',
    EditSessionDate = 'EditSessionDate',
    EditSessionTime = 'EditSessionTime',
    Space = 'Space',
}

export class ClassPackageResponse
{
    public id: string|null;
    public name: string|null;
    public price: number|null;
    public classTypeId: number|null;
    public stockId: number|null;
    public validForDaysFromPurchase: number|null;
    public credits: number|null;
    public creditPackageStockExclusions: number[]|null;
    public creditPackageClassTypeExclusions: number[]|null;
    public restrictToPrivateCharges: boolean|null;

    public constructor(init?: Partial<ClassPackageResponse>) { (Object as any).assign(this, init); }
}
(ClassPackageResponse as unknown)[immerable] = true;

export enum CourseBillingMode
{
    FirstAttendance = 'FirstAttendance',
    BillNow = 'BillNow',
    NewPackage = 'NewPackage',
    ExistingPackage = 'ExistingPackage',
    NewSubscription = 'NewSubscription',
    ExistingCredits = 'ExistingCredits',
    ExistingCreditPackage = 'ExistingCreditPackage',
}

export enum CourseEditAppliesTo
{
    ThisSessionOnly = 'ThisSessionOnly',
    ThisAndAllSubsequentSessions = 'ThisAndAllSubsequentSessions',
}

export enum WorkSheetType
{
    Estimate = 69,
    InvoiceOnly = 73,
    JobSheet = 74,
}

export class VehicleRemindersDetails implements IHasId
{
    public id: number|null;
    public vehicleId: number|null;
    public lookupValue: string;
    public reminderDate: string|null;

    public constructor(init?: Partial<VehicleRemindersDetails>) { (Object as any).assign(this, init); }
}
(VehicleRemindersDetails as unknown)[immerable] = true;

export class MOTHistory
{
    public testDate: string|null;
    public expiryDate: string|null;
    public testResult: string;
    public odometer: string;
    public testNumber: string;
    public advisoryNotice: string;

    public constructor(init?: Partial<MOTHistory>) { (Object as any).assign(this, init); }
}
(MOTHistory as unknown)[immerable] = true;

export class MOTHistoryResponse
{
    public lookupDate: string|null;
    public motHistory: MOTHistory[] = [];

    public constructor(init?: Partial<MOTHistoryResponse>) { (Object as any).assign(this, init); }
}
(MOTHistoryResponse as unknown)[immerable] = true;

// @Flags()
export enum WorkSheetOrderStatus
{
    Unassigned = 0,
    InBasket = 1,
    OnOrder = 2,
    Delivered = 3,
}

export class WorkSheetItem implements IHasGuidId
{
    public id: string|null;
    public date: string|null;
    public stockId: number|null;
    public sheetId: number|null;
    public description: string;
    public price: number|null;
    public totalExVat: number|null;
    public vatRate: number|null;
    public quantity: number|null;
    public totalVat: number|null;
    public total: number|null;
    public ledgerCode: string;
    public parentId: number|null;
    public category: string;
    public billingItemId: number|null;
    public sequence: number|null;
    public packageSequence: number|null;
    public packageId: string|null;
    // @Ignore()
    public isPackageItem: boolean|null;

    public isHeader: boolean|null;
    public orderArticleCode: string;
    public basketId: string;
    public orderId: string;
    public orderStatus: WorkSheetOrderStatus|null;
    public orderServiceId: number|null;

    public constructor(init?: Partial<WorkSheetItem>) { (Object as any).assign(this, init); }
}
(WorkSheetItem as unknown)[immerable] = true;

export class WorkSheetItemExpanded extends WorkSheetItem
{
    public deleted: boolean|null;

    public constructor(init?: Partial<WorkSheetItemExpanded>) { super(init); (Object as any).assign(this, init); }
}
(WorkSheetItemExpanded as unknown)[immerable] = true;

// @Flags()
export enum WorkSheetStatus
{
    Unassigned = 1,
    NotStarted = 2,
    Completed = 3,
    Converted = 4,
}

export class WorkSheet implements IHasId, ILocationId
{
    public id: number|null;
    public status: WorkSheetStatus|null;
    public customerId: number|null;
    public vehicleId: number|null;
    public date: string|null;
    public createdDate: string|null;
    public addressedTo: string;
    public mileage: number|null;
    public mechanicId: number|null;
    public locationId: number|null;
    public appointmentId: number|null;
    public adviserId: number|null;
    public reference: string;
    public total: number|null;
    public type: WorkSheetType|null;
    public invoiceId: number|null;
    public idClonedFrom: number|null;

    public constructor(init?: Partial<WorkSheet>) { (Object as any).assign(this, init); }
}
(WorkSheet as unknown)[immerable] = true;

export class SubmitProducts
{
    public articleCode: string;
    public qty: number|null;

    public constructor(init?: Partial<SubmitProducts>) { (Object as any).assign(this, init); }
}
(SubmitProducts as unknown)[immerable] = true;

export class RepairTimeItem
{
    public description: string;
    public awNumber: string;
    public time: number|null;

    public constructor(init?: Partial<RepairTimeItem>) { (Object as any).assign(this, init); }
}
(RepairTimeItem as unknown)[immerable] = true;

export class RepairTimeData
{
    public id: string;
    public description: string;
    public preliminaryList: RepairTimeItem[] = [];
    public includedList: RepairTimeItem[] = [];
    public notIncludedList: RepairTimeItem[] = [];
    public followUpWorkList: RepairTimeItem[] = [];
    public repairTimeTotal: number|null;

    public constructor(init?: Partial<RepairTimeData>) { (Object as any).assign(this, init); }
}
(RepairTimeData as unknown)[immerable] = true;

export class DigitalPrescriptionDMDResponse
{
    public name: string|null;
    public productId: BigInteger|null;

    public constructor(init?: Partial<DigitalPrescriptionDMDResponse>) { (Object as any).assign(this, init); }
}
(DigitalPrescriptionDMDResponse as unknown)[immerable] = true;

export class TwilioRoomResponse
{
    public roomId: string|null;
    public roomName: string|null;
    public token: string|null;
    public startDateTime: string|null;
    public endDateTime: string|null;
    public practitionerName: string|null;
    public status: number|null;
    public roomCreated: boolean|null;
    public videoCode: string|null;
    public smsEnabled: boolean|null;

    public constructor(init?: Partial<TwilioRoomResponse>) { (Object as any).assign(this, init); }
}
(TwilioRoomResponse as unknown)[immerable] = true;

export interface IVirtualDirectory
{
}

export interface IVirtualPathProvider
{
    rootDirectory: IVirtualDirectory|null;
    virtualPathSeparator: string|null;
    realPathSeparator: string|null;
}

export interface IVirtualFile
{
    virtualPathProvider: IVirtualPathProvider|null;
    extension: string|null;
    length: number|null;
}

// @Flags()
export enum CacheControl
{
    None = 0,
    Public = 1,
    Private = 2,
    MustRevalidate = 4,
    NoCache = 8,
    NoStore = 16,
    NoTransform = 32,
    ProxyRevalidate = 64,
}

export interface IContentTypeWriter
{
}

// @Flags()
export enum RequestAttributes
{
    None = 0,
    Localhost = 1,
    LocalSubnet = 2,
    External = 4,
    Secure = 8,
    InSecure = 16,
    AnySecurityMode = 24,
    HttpHead = 32,
    HttpGet = 64,
    HttpPost = 128,
    HttpPut = 256,
    HttpDelete = 512,
    HttpPatch = 1024,
    HttpOptions = 2048,
    HttpOther = 4096,
    AnyHttpMethod = 8160,
    OneWay = 8192,
    Reply = 16384,
    AnyCallStyle = 24576,
    Soap11 = 32768,
    Soap12 = 65536,
    Xml = 131072,
    Json = 262144,
    Jsv = 524288,
    ProtoBuf = 1048576,
    Csv = 2097152,
    Html = 4194304,
    Jsonl = 8388608,
    MsgPack = 16777216,
    FormatOther = 33554432,
    AnyFormat = 67076096,
    Http = 67108864,
    MessageQueue = 134217728,
    Tcp = 268435456,
    Grpc = 536870912,
    EndpointOther = 1073741824,
    AnyEndpoint = 2080374784,
    InProcess = -2147483648,
    InternalNetworkAccess = -2147483645,
    AnyNetworkAccessType = -2147483641,
    Any = -1,
}

export interface IRequestPreferences
{
    acceptsBrotli: boolean|null;
    acceptsDeflate: boolean|null;
    acceptsGzip: boolean|null;
}

export interface IHttpFile
{
    name: string|null;
    fileName: string|null;
    contentLength: number|null;
    contentType: string|null;
    inputStream: string|null;
}

export interface IRequest
{
    originalRequest: Object|null;
    response: IResponse|null;
    operationName: string|null;
    verb: string|null;
    requestAttributes: RequestAttributes|null;
    requestPreferences: IRequestPreferences|null;
    dto: Object|null;
    contentType: string|null;
    isLocal: boolean|null;
    userAgent: string|null;
    cookies: { [index:string]: Cookie; }|null;
    responseContentType: string|null;
    hasExplicitResponseContentType: boolean|null;
    items: { [index:string]: Object; }|null;
    headers: NameValueCollection|null;
    queryString: NameValueCollection|null;
    formData: NameValueCollection|null;
    useBufferedStream: boolean|null;
    rawUrl: string|null;
    absoluteUri: string|null;
    userHostAddress: string|null;
    remoteIp: string|null;
    authorization: string|null;
    isSecureConnection: boolean|null;
    acceptTypes: string[]|null;
    pathInfo: string|null;
    originalPathInfo: string|null;
    inputStream: string|null;
    contentLength: number|null;
    files: IHttpFile[]|null;
    urlReferrer: string|null;
}

export interface IResponse
{
    originalResponse: Object|null;
    request: IRequest|null;
    statusCode: number|null;
    statusDescription: string|null;
    contentType: string|null;
    outputStream: string|null;
    dto: Object|null;
    useBufferedStream: boolean|null;
    isClosed: boolean|null;
    keepAlive: boolean|null;
    hasStarted: boolean|null;
    items: { [index:string]: Object; }|null;
}

export class WorldPayResponse
{
    public success: boolean|null;
    public errorCode: string|null;
    public errorMessage: string|null;
    public pgtr: string|null;
    public paymentPageUrl: string|null;
    public authorisationCode: string|null;

    public constructor(init?: Partial<WorldPayResponse>) { (Object as any).assign(this, init); }
}
(WorldPayResponse as unknown)[immerable] = true;

export class StripeTerminal
{
    public id: string|null;
    public displayName: string|null;
    public locationId: string|null;

    public constructor(init?: Partial<StripeTerminal>) { (Object as any).assign(this, init); }
}
(StripeTerminal as unknown)[immerable] = true;

export class StripeTerminalLocation
{
    public id: string|null;
    public displayName: string|null;
    public locationTerminals: StripeTerminal[]|null;
    public hasTerminals: boolean|null;

    public constructor(init?: Partial<StripeTerminalLocation>) { (Object as any).assign(this, init); }
}
(StripeTerminalLocation as unknown)[immerable] = true;

export class StripeTerminalLocationsResponse
{
    public terminalLocations: StripeTerminalLocation[]|null;

    public constructor(init?: Partial<StripeTerminalLocationsResponse>) { (Object as any).assign(this, init); }
}
(StripeTerminalLocationsResponse as unknown)[immerable] = true;

export enum AutoPayStatus
{
    InProgress = 'InProgress',
    PaidbyAutoPay = 'PaidbyAutoPay',
    Failed = 'Failed',
    Paid = 'Paid',
}

export class AutoPayResponse
{
    public status: AutoPayStatus|null;

    public constructor(init?: Partial<AutoPayResponse>) { (Object as any).assign(this, init); }
}
(AutoPayResponse as unknown)[immerable] = true;

export class AddressFindResponse
{
    public id: string|null;
    public type: string|null;
    public text: string|null;
    public highlight: string|null;
    public description: string|null;

    public constructor(init?: Partial<AddressFindResponse>) { (Object as any).assign(this, init); }
}
(AddressFindResponse as unknown)[immerable] = true;

export class AddressRetrieveResponse
{
    public id: string|null;
    public domesticId: string|null;
    public language: string|null;
    public languageAlternative: string|null;
    public department: string|null;
    public company: string|null;
    public subBuilding: string|null;
    public buildingNumber: string|null;
    public buildingName: string|null;
    public secondaryStreet: string|null;
    public street: string|null;
    public block: string|null;
    public neighbourhood: string|null;
    public district: string|null;
    public city: string|null;
    public line1: string|null;
    public line2: string|null;
    public line3: string|null;
    public line4: string|null;
    public line5: string|null;
    public adminAreaName: string|null;
    public adminAreaCode: string|null;
    public province: string|null;
    public provinceName: string|null;
    public provinceCode: string|null;
    public postalCode: string|null;
    public countryName: string|null;
    public countryIso2: string|null;
    public countryIso3: string|null;
    public countryIsoNumber: string|null;
    public sortingNumber1: string|null;
    public sortingNumber2: string|null;
    public barcode: string|null;
    public poBoxNumber: string|null;
    public label: string|null;
    public type: string|null;
    public dataLevel: string|null;

    public constructor(init?: Partial<AddressRetrieveResponse>) { (Object as any).assign(this, init); }
}
(AddressRetrieveResponse as unknown)[immerable] = true;

export class JsonPermissionResponse
{
    public id: number|null;
    public shortDescription: string|null;
    public type: string|null;
    public level: string|null;

    public constructor(init?: Partial<JsonPermissionResponse>) { (Object as any).assign(this, init); }
}
(JsonPermissionResponse as unknown)[immerable] = true;

export class JsonPermissionGetResponse
{
    public id: number|null;
    public shortDescription: string|null;
    public jsonPermissions: string[]|null;
    public readOnly: boolean|null;

    public constructor(init?: Partial<JsonPermissionGetResponse>) { (Object as any).assign(this, init); }
}
(JsonPermissionGetResponse as unknown)[immerable] = true;

export class Permission
{
    public description: string|null;
    public hiddenFromNonAdmin: boolean|null;
    public allowed: string[]|null;
    public revoked: string[]|null;
    public reports: string[]|null;
    public accessablePractitioners: number[]|null;
    public multiDiaryRestricted: boolean|null;
    public autoLogout: number|null;

    public constructor(init?: Partial<Permission>) { (Object as any).assign(this, init); }
}
(Permission as unknown)[immerable] = true;

export class JsonPermission implements IHasId, IHasGlobalGuid
{
    public id: number|null;
    public type: string|null;
    public permission: Permission|null;
    public level: string|null;
    public readOnly: boolean|null;
    public globalGuid: string|null;
    // @Ignore()
    public shortDescription: string|null;

    // @Ignore()
    public jsonPermissions: string[]|null;

    public constructor(init?: Partial<JsonPermission>) { (Object as any).assign(this, init); }
}
(JsonPermission as unknown)[immerable] = true;

export class UsersSearchResponse
{
    public id: number|null;
    public name: string|null;
    public fullName: string|null;
    public firstName: string|null;
    public lastName: string|null;
    public current: boolean|null;
    public email: string|null;
    public mobileNumber: string|null;
    public position: string|null;
    public locationId: number|null;
    public locationName: string|null;
    public practitionerId: number|null;
    public migrated: boolean|null;
    public accessiblePractitioners: number[]|null;
    public practitionerTitle: string|null;
    public practitionerForename: string|null;
    public practitionerSurname: string|null;
    public departments: number[]|null;
    public permissionId: number|null;
    public practitioner: string|null;
    public globalGuid: string|null;
    public avatar: string|null;

    public constructor(init?: Partial<UsersSearchResponse>) { (Object as any).assign(this, init); }
}
(UsersSearchResponse as unknown)[immerable] = true;

export class UserRoleLocation implements IHasId, IHasGlobalGuid
{
    public id: number|null;
    public locationId: number|null;
    // @Ignore()
    public locationGuid: string|null;

    public userId: number|null;
    // @Ignore()
    public userGuid: string|null;

    public roleId: number|null;
    // @Ignore()
    public roleGuid: string|null;

    public globalGuid: string|null;

    public constructor(init?: Partial<UserRoleLocation>) { (Object as any).assign(this, init); }
}
(UserRoleLocation as unknown)[immerable] = true;

export class UserRoleLocationWithDetails extends UserRoleLocation
{
    public userName: string|null;
    public fullName: string|null;
    public locationName: string|null;
    public userType: string|null;
    public userCurrent: boolean|null;
    public roleName: string|null;

    public constructor(init?: Partial<UserRoleLocationWithDetails>) { super(init); (Object as any).assign(this, init); }
}
(UserRoleLocationWithDetails as unknown)[immerable] = true;

export class UserLocationsResponse
{
    public id: number|null;
    public userId: number|null;
    public locationId: number|null;
    public roleId: number|null;
    public locationName: string|null;
    public globalGuid: string|null;

    public constructor(init?: Partial<UserLocationsResponse>) { (Object as any).assign(this, init); }
}
(UserLocationsResponse as unknown)[immerable] = true;

export class BusinessProfileResponse
{
    public id: number|null;
    public businessName: string|null;
    public tradingName: string|null;
    public description: string|null;
    public termsAndConditions: string|null;
    public privacyPolicy: string|null;
    public cancellationPolicy: string|null;

    public constructor(init?: Partial<BusinessProfileResponse>) { (Object as any).assign(this, init); }
}
(BusinessProfileResponse as unknown)[immerable] = true;

export class ExtractionResponse
{
    public signature: string|null;
    public creation: string|null;
    public completion: string|null;

    public constructor(init?: Partial<ExtractionResponse>) { (Object as any).assign(this, init); }
}
(ExtractionResponse as unknown)[immerable] = true;

// @DataContract
export class Folder
{
    // @DataMember(Order=1)
    public name: string|null;

    // @DataMember(Order=2)
    public modifiedDate: string|null;

    // @DataMember(Order=3)
    public path: string|null;

    // @DataMember(Order=4)
    public isGlobal: boolean|null;

    // @DataMember(Order=5)
    public isOverride: boolean|null;

    public constructor(init?: Partial<Folder>) { (Object as any).assign(this, init); }
}
(Folder as unknown)[immerable] = true;

// @DataContract
export class File
{
    // @DataMember(Order=1)
    public name: string|null;

    // @DataMember(Order=2)
    public extension: string|null;

    // @DataMember(Order=3)
    public fileSizeBytes: number|null;

    // @DataMember(Order=4)
    public createdDate: string|null;

    // @DataMember(Order=5)
    public modifiedDate: string|null;

    // @DataMember(Order=6)
    public accessedDate: string|null;

    // @DataMember(Order=7)
    public path: string|null;

    // @DataMember(Order=8)
    public isGlobal: boolean|null;

    // @DataMember(Order=9)
    public isOverride: boolean|null;

    // @DataMember(Order=10)
    public description: string|null;

    // @DataMember(Order=11)
    public createdBy: string|null;

    public constructor(init?: Partial<File>) { (Object as any).assign(this, init); }
}
(File as unknown)[immerable] = true;

// @DataContract
export class FolderResult
{
    // @DataMember(Order=1)
    public folders: Folder[]|null;

    // @DataMember(Order=2)
    public files: File[]|null;

    public constructor(init?: Partial<FolderResult>) { (Object as any).assign(this, init); }
}
(FolderResult as unknown)[immerable] = true;

export class CaseImagingResult
{
    public width: number|null;
    public height: number|null;
    public src: string|null;
    public signature: string|null;

    public constructor(init?: Partial<CaseImagingResult>) { (Object as any).assign(this, init); }
}
(CaseImagingResult as unknown)[immerable] = true;

export class CommandBarResponse
{
    public id: string|null;
    public name: string|null;
    public description: string|null;

    public constructor(init?: Partial<CommandBarResponse>) { (Object as any).assign(this, init); }
}
(CommandBarResponse as unknown)[immerable] = true;

export class BatchMergeDataResponse
{
    public data: Object|null;
    public template: string|null;
    public id: number|null;

    public constructor(init?: Partial<BatchMergeDataResponse>) { (Object as any).assign(this, init); }
}
(BatchMergeDataResponse as unknown)[immerable] = true;

export class ContactMergeCheckResponse
{
    public contactId: number|null;
    public contactTitle: string|null;
    public contactForename: string|null;
    public contactSurname: string|null;
    public contactBusinessName: string|null;
    public contactcategory: string|null;

    public constructor(init?: Partial<ContactMergeCheckResponse>) { (Object as any).assign(this, init); }
}
(ContactMergeCheckResponse as unknown)[immerable] = true;

export enum svcResponse
{
    Success = 'Success',
    GeneralException = 'GeneralException',
    InvalidClientID = 'InvalidClientID',
    EncryptionError = 'EncryptionError',
    DBError = 'DBError',
    LicenceNotActive = 'LicenceNotActive',
}

export class MedicalContactResponse
{
    public id: number|null;
    public current: boolean|null;
    public defaultContact: boolean|null;
    public contactable: boolean|null;
    public category: string|null;
    public title: string|null;
    public forename: string|null;
    public surname: string|null;
    public name: string|null;
    public businessName: string|null;
    public relationship: string|null;
    public address: string|null;
    public addressLine1: string|null;
    public addressLine2: string|null;
    public addressLine3: string|null;
    public addressLine4: string|null;
    public addressLine5: string|null;
    public mobile: string|null;
    public postCode: string|null;
    public telephone: string|null;
    public altTelephone1: string|null;
    public altTelephone2: string|null;
    public fax: string|null;
    public web: string|null;
    public email: string|null;
    public locationId: number|null;
    public locationName: string|null;
    public providerNumber: string|null;
    public alerts: AlertResponse[]|null;

    public constructor(init?: Partial<MedicalContactResponse>) { (Object as any).assign(this, init); }
}
(MedicalContactResponse as unknown)[immerable] = true;

export class PaymentCard implements IHasId
{
    public id: number|null;
    public cardObjectID: number|null;
    public cardObjectType: string|null;
    public cardExpiry: string|null;
    public cardIssue: string|null;
    public cardType: string|null;
    public cardFrom: string|null;
    public cardSecurity: string|null;
    public cardNotes: string|null;
    public cardNumber: string|null;
    public cardName: string|null;
    public cardUseAddress: number|null;
    public cardAddress1: string|null;
    public cardAddress2: string|null;
    public cardAddress3: string|null;
    public cardAddress4: string|null;
    public cardPostCode: string|null;
    public cardVerified: string|null;
    public lastFourDigits: string|null;
    public expiryMonth: number|null;
    public expiryYear: number|null;
    public brand: string|null;

    public constructor(init?: Partial<PaymentCard>) { (Object as any).assign(this, init); }
}
(PaymentCard as unknown)[immerable] = true;

export class CustomerLiteDto
{
    public id: number|null;
    public reference: string|null;
    public forename: string|null;
    public surname: string|null;
    public title: string|null;
    public name: string|null;
    public address: string|null;
    public practitionerName: string|null;
    public addressLine1: string|null;
    public addressLine2: string|null;
    public addressLine3: string|null;
    public addressLine4: string|null;
    public addressLine5: string|null;
    public smsEnabled: boolean|null;
    public groupName: string|null;
    public locationName: string|null;
    public locationId: number|null;
    public groupId: number|null;
    public practitionerId: number|null;
    public groupAddressTo: string|null;
    public postCode: string|null;
    public mobileTelephone: string|null;
    public email: string|null;
    public smsEnabled: boolean|null;
    public dateOfBirth: string|null;
    public alerts: AlertResponse[]|null;
    public billTo: string|null;
    public practitionerForename: string|null;
    public practitionerSurname: string|null;
    public cardID: number|null;
    public paymentCard: PaymentCard|null;

    public constructor(init?: Partial<CustomerLiteDto>) { (Object as any).assign(this, init); }
}
(CustomerLiteDto as unknown)[immerable] = true;

export class CustomerBatchConsentResponse
{
    public updated: boolean|null;

    public constructor(init?: Partial<CustomerBatchConsentResponse>) { (Object as any).assign(this, init); }
}
(CustomerBatchConsentResponse as unknown)[immerable] = true;

export class Customer implements IHasAddressDetails, IHasReference, IHasDocuments
{
    public title: string|null;
    public forename: string|null;
    public surname: string|null;
    public gender: string|null;
    public addressLine1: string|null;
    public addressLine2: string|null;
    public addressLine3: string|null;
    public addressLine4: string|null;
    public addressLine5: string|null;
    public postCode: string|null;
    public invoiceAddressLine1: string|null;
    public invoiceAddressLine2: string|null;
    public invoiceAddressLine3: string|null;
    public invoiceAddressLine4: string|null;
    public invoiceAddressLine5: string|null;
    public invoicePostCode: string|null;
    public dateOfBirth: string|null;
    public registrationDate: string|null;
    public locationId: number|null;
    public practitionerId: number|null;
    public accountId: number|null;
    public groupId: number|null;
    public homeTelephone: string|null;
    public workTelephone: string|null;
    public mobileTelephone: string|null;
    public email: string|null;
    public reference: string|null;
    public insuranceNumber: string|null;
    public groupReference: string|null;
    public smsEnabled: boolean|null;
    public defaultCharge: string|null;
    public invoicePeriod: string|null;
    public status: number|null;
    public useInvoiceAddress: boolean|null;
    public enquiry: string|null;
    public category: string|null;
    public employer: string|null;
    public height: number|null;
    public weight: number|null;
    public hospitalNumber: string|null;
    public niNumber: string|null;
    public medication: string|null;
    public previousInjuries: string|null;
    public alternativeRef1: string|null;
    public alternativeRef2: string|null;
    public alternativeRef3: string|null;
    public alternativeRef4: string|null;
    public lastAppointmentDate: string|null;
    public notes: string|null;
    public billTo: string|null;
    public online: boolean|null;
    public cardNo: string|null;
    public invoiceFrequency: number|null;
    public invoiceDeadline: string|null;
    public consent: string|null;
    public groupDepartment: string|null;
    public id: number|null;
    public provisional: boolean|null;
    public givenConsent: boolean|null;
    public emailConsent: boolean|null;
    public smsConsent: boolean|null;
    public phoneConsent: boolean|null;
    public stripeCustomerId: string|null;
    public paymentMethodId: string|null;
    public cardID: number|null;
    public tempPaymentMethodId: string|null;
    public medicareCardNo: string|null;
    public irn: string|null;
    public dvaNumber: string|null;
    public flag: string|null;
    public documentsLoaded: boolean|null;
    // @Ignore()
    public documentsSubDirectory: string|null;

    public squareCustomerId: string|null;
    public squareCardId: string|null;
    // @Ignore()
    public name: string|null;

    public merchantCardId: string|null;
    public merchantCustomerId: string|null;
    public merchantCardToken: string|null;
    public tags: string[]|null;
    public overridePayAtClinic: boolean|null;
    public isBusiness: boolean|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<Customer>) { (Object as any).assign(this, init); }
}
(Customer as unknown)[immerable] = true;

export class DupEmailResponse
{
    public consent: boolean|null;
    public customers: Customer[]|null;
    public patient: Customer|null;

    public constructor(init?: Partial<DupEmailResponse>) { (Object as any).assign(this, init); }
}
(DupEmailResponse as unknown)[immerable] = true;

export class CustomerSaveResponse
{
    public patient: GeneralCustomerResponse|null;
    public suggested: boolean|null;
    public result: DupEmailResponse|null;

    public constructor(init?: Partial<CustomerSaveResponse>) { (Object as any).assign(this, init); }
}
(CustomerSaveResponse as unknown)[immerable] = true;

export interface IHasAddressDetails
{
    addressLine1: string|null;
    addressLine2: string|null;
    addressLine3: string|null;
    addressLine4: string|null;
    addressLine5: string|null;
    postCode: string|null;
}

export interface IHasDocuments
{
    documentsLoaded: boolean|null;
    documentsSubDirectory: string|null;
}

export class TransactionItemResponse
{
    public date: string|null;
    public type: string|null;
    public status: string|null;
    public amount: number|null;
    public displayName: string|null;

    public constructor(init?: Partial<TransactionItemResponse>) { (Object as any).assign(this, init); }
}
(TransactionItemResponse as unknown)[immerable] = true;

export class CaseSearchResponse
{
    public admissionDate: string|null;
    public appointmentCount: number|null;
    public appointmentsWithoutConsultations: number|null;
    public alerts: number|null;
    public nextAppointmentDate: string|null;
    public auth: string|null;
    public authExpiryDate: string|null;
    public bodySite: string|null;
    public bodySiteText: string|null;
    public closed: boolean|null;
    public closedDateTime: string|null;
    public customerForename: string|null;
    public customerId: number|null;
    public customerSurname: string|null;
    public customerTitle: string|null;
    public diagnosis: string|null;
    public diagnosisCode: string|null;
    public dischargeDate: string|null;
    public dischargeStatus: string|null;
    public statusText: string|null;
    public expired: boolean|null;
    public firstAppointmentId: number|null;
    public groupName: string|null;
    public id: number|null;
    public incompleteNotes: boolean|null;
    public location: string|null;
    public locationId: number|null;
    public practitionerTitle: string|null;
    public practitionerForename: string|null;
    public practitionerSurname: string|null;
    public practitionerName: string|null;
    public practitionerId: number|null;
    public patientName: string|null;
    public reference: number|null;
    public restricted: boolean|null;
    public statusValue: string|null;
    public status: number|null;
    public unclosedConsultations: number|null;
    public lastConsultationDate: string|null;
    public type: string|null;
    public serviceType: string|null;

    public constructor(init?: Partial<CaseSearchResponse>) { (Object as any).assign(this, init); }
}
(CaseSearchResponse as unknown)[immerable] = true;

export class JoinedContactResponse
{
    public id: number|null;
    public reference: string|null;
    public forename: string|null;
    public surname: string|null;
    public title: string|null;
    public email: string|null;
    public type: string|null;
    public relationship: string|null;
    public number: string|null;
    public name: string|null;

    public constructor(init?: Partial<JoinedContactResponse>) { (Object as any).assign(this, init); }
}
(JoinedContactResponse as unknown)[immerable] = true;

export class AccountStatementResponse
{
    public id: number|null;
    public idKey: string|null;
    public date: string|null;
    public ref: string|null;
    public type: string|null;
    public location: string|null;
    public debit: number|null;
    public credit: number|null;
    public status: string|null;
    public reason: string|null;
    public totalRows: number|null;
    public meta: { [index:string]: Object; }|null;

    public constructor(init?: Partial<AccountStatementResponse>) { (Object as any).assign(this, init); }
}
(AccountStatementResponse as unknown)[immerable] = true;

export class GroupAccountStatementResponse
{
    public id: number|null;
    public reference: string|null;
    public date: string|null;
    public debitAmount: number|null;
    public creditAmount: number|null;
    public status: string|null;
    public groupName: string|null;
    public paymentType: string|null;
    public transactionType: string|null;
    public locationName: string|null;

    public constructor(init?: Partial<GroupAccountStatementResponse>) { (Object as any).assign(this, init); }
}
(GroupAccountStatementResponse as unknown)[immerable] = true;

export class BillingItemsResponse
{
    public id: number|null;
    public date: string|null;
    public description: string|null;
    public total: number|null;
    public accountName: string|null;
    public groupOrPatientReference: string|null;
    public isPaid: boolean|null;
    public invoiceRef: string|null;
    public paidDate: string|null;
    public invoiceId: number|null;
    public stockType: string|null;
    public locationName: string|null;
    public practitionerName: string|null;
    public totalExVat: number|null;
    public quantity: number|null;
    public price: number|null;
    public vatRate: number|null;
    public totalVat: number|null;
    public category: string|null;

    public constructor(init?: Partial<BillingItemsResponse>) { (Object as any).assign(this, init); }
}
(BillingItemsResponse as unknown)[immerable] = true;

export enum PrePaidStatus
{
    Active = 'Active',
    Expired = 'Expired',
    Used = 'Used',
    Removed = 'Removed',
}

export class GroupedPrePaidItems
{
    public id: number|null;
    public description: string|null;
    public items: string[]|null;
    public classTypeIds: number[]|null;
    public status: PrePaidStatus|null;
    public isCourse: boolean|null;
    public itemsLeft: number|null;
    public itemsUsed: number|null;
    public used: number|null;
    public totalQuantity: number|null;
    public names: string|null;
    public expires: string|null;
    public remaining: string|null;

    public constructor(init?: Partial<GroupedPrePaidItems>) { (Object as any).assign(this, init); }
}
(GroupedPrePaidItems as unknown)[immerable] = true;

export class PrePaidItems
{
    public billingItemId: number|null;
    public packageId: string|null;
    public packageName: string|null;
    public totalPrice: number|null;
    public items: GroupedPrePaidItems[]|null;
    public itemIds: number[]|null;
    public date: string|null;
    public expiryDate: string|null;
    public status: number|null;
    public totalCredits: number|null;
    public creditsRemaining: number|null;

    public constructor(init?: Partial<PrePaidItems>) { (Object as any).assign(this, init); }
}
(PrePaidItems as unknown)[immerable] = true;

export class InvoicePaymentsResponse
{
    public id: number|null;
    public invoiceId: number|null;
    public refundId: number|null;
    public amount: number|null;
    public paymentMethod: string|null;
    public otherPaymentMethod: string|null;
    public actualPaymentMethod: string|null;
    public customerId: number|null;
    public status: string|null;
    public date: string|null;
    public reference: string|null;
    public lodgementRef: string|null;
    public paymentId: number|null;
    public paidBy: string|null;
    public notes: string|null;
    public cardType: string|null;
    public cardNumber: string|null;
    public expiry: string|null;
    public chequeNumber: string|null;
    public migrated: boolean|null;
    public paymentAmount: number|null;
    public transferred: string|null;

    public constructor(init?: Partial<InvoicePaymentsResponse>) { (Object as any).assign(this, init); }
}
(InvoicePaymentsResponse as unknown)[immerable] = true;

export class ClickContactSearchResult
{
    public typeId: number|null;
    public id: string|null;
    public title: string|null;
    public forename: string|null;
    public surname: string|null;
    public addR1: string|null;
    public addR2: string|null;
    public addR3: string|null;
    public addR4: string|null;
    public addR5: string|null;
    public postcode: string|null;
    public isMedical: boolean|null;
    // @Ignore()
    public name: string|null;

    public category: string|null;

    public constructor(init?: Partial<ClickContactSearchResult>) { (Object as any).assign(this, init); }
}
(ClickContactSearchResult as unknown)[immerable] = true;

export class ClickCustomerNotesCheckResponse
{
    public caseId: number|null;

    public constructor(init?: Partial<ClickCustomerNotesCheckResponse>) { (Object as any).assign(this, init); }
}
(ClickCustomerNotesCheckResponse as unknown)[immerable] = true;

export class Treatment implements IHasId, ICascade
{
    public id: number|null;
    public caseId: number|null;
    public appointmentId: number|null;
    public dateTime: string|null;
    public initials: string|null;
    public notes: string|null;
    public length: number|null;
    public assessLength: number|null;
    public cost: number|null;
    public locationId: number|null;
    public practitionerId: number|null;
    public migrated: boolean|null;
    public closed: boolean|null;
    public closedUser: string|null;
    public closedDate: string|null;
    public scale: number|null;
    public measure: string|null;
    public data: { [index:string]: Object; }|null;
    public autoSaved: boolean|null;
    public templateId: string|null;
    public highlights: { [index:string]: number[]; }|null;
    public type: string|null;
    public createdByUserId: number|null;
    public createdDate: string|null;
    public lastUpdatedDate: string|null;
    public validated: boolean|null;

    public constructor(init?: Partial<Treatment>) { (Object as any).assign(this, init); }
}
(Treatment as unknown)[immerable] = true;

export enum CaseStatus
{
    AwaitingFirstAppointment = 1,
    InTreatment = 3,
    OnHold = 7,
    Discharged = 8,
    ClosedButWaitingForReview = 12,
    ClosedAndReviewed = 14,
}

export class AppointmentCaseResponse
{
    public id: number|null;
    public bodySite: string|null;
    public admissionDate: string|null;
    public practitionerId: string|null;
    public description: string|null;
    public consultations: Treatment[]|null;
    public dischargeDate: string|null;
    public discharged: boolean|null;
    public bookingAuditId: string|null;
    public status: CaseStatus|null;
    public firstAppointmentStatus: number|null;

    public constructor(init?: Partial<AppointmentCaseResponse>) { (Object as any).assign(this, init); }
}
(AppointmentCaseResponse as unknown)[immerable] = true;

export class CustomerServiceResponse
{
    public id: number|null;
    public customerSecurityLevel: number|null;
    public customerSecurityKeyWord: string|null;

    public constructor(init?: Partial<CustomerServiceResponse>) { (Object as any).assign(this, init); }
}
(CustomerServiceResponse as unknown)[immerable] = true;

export class PatientLogResponse
{
    public id: number|null;
    public customerId: number|null;
    public dateTime: string|null;
    public entry: string|null;
    public serviceTypeId: number|null;

    public constructor(init?: Partial<PatientLogResponse>) { (Object as any).assign(this, init); }
}
(PatientLogResponse as unknown)[immerable] = true;

export class Patientlog implements IHasId
{
    public id: number|null;
    public customerId: number|null;
    public dateTime: string|null;
    public entry: string|null;
    public user: number|null;
    public type: string|null;
    public activityArea: string|null;
    public serviceTypeId: number|null;
    public linkedObjectType: TimelineLinkedObjectType|null;
    public linkedObjectId: number|null;
    public contextId: number|null;
    public context: TimelineContextObjectType|null;
    public linkedDocumentId: string|null;
    public documentLinkedToObjectType: TimelineLinkedObjectType|null;
    public documentLinkedToObjectId: number|null;

    public constructor(init?: Partial<Patientlog>) { (Object as any).assign(this, init); }
}
(Patientlog as unknown)[immerable] = true;

export class PatientInfoLogResponse implements IPatientInfoResponse
{
    public id: number|null;
    public responseType: string|null;
    public date: string|null;
    public description: string|null;
    public title: string|null;
    public pinned: boolean|null;
    public dateTime: string|null;
    public entry: string|null;
    public userName: string|null;
    public customerId: number|null;
    public type: string|null;
    public activityArea: string|null;
    public serviceTypeId: number|null;

    public constructor(init?: Partial<PatientInfoLogResponse>) { (Object as any).assign(this, init); }
}
(PatientInfoLogResponse as unknown)[immerable] = true;

export class RoomResponse
{
    public id: number|null;
    public description: string|null;
    public locationId: number|null;
    public locationName: string|null;
    public status: boolean|null;
    public colour: number|null;
    public hexColour: string|null;

    public constructor(init?: Partial<RoomResponse>) { (Object as any).assign(this, init); }
}
(RoomResponse as unknown)[immerable] = true;

export class PractitionerLocation
{
    public id: number|null;
    public practitionerId: number|null;
    public locationId: number|null;

    public constructor(init?: Partial<PractitionerLocation>) { (Object as any).assign(this, init); }
}

export class NonWorkingDate implements IHasId
{
    public id: number|null;
    public date: string|null;
    public practitionerId: number|null;
    public title: string|null;

    public constructor(init?: Partial<NonWorkingDate>) { (Object as any).assign(this, init); }
}
(NonWorkingDate as unknown)[immerable] = true;

export class NonWorkingDateResponse implements IHasId
{
    public id: number|null;
    public date: string|null;
    public practitionerId: number|null;
    public endDate: string|null;
    public title: string|null;

    public constructor(init?: Partial<NonWorkingDateResponse>) { (Object as any).assign(this, init); }
}
(NonWorkingDateResponse as unknown)[immerable] = true;

export class DiarySessionResponse
{
    public startDateTime: string|null;
    public endDateTime: string|null;
    public locationDescription: string|null;
    public practitionerDescription: string|null;
    public roomDescription: string|null;
    public isSpecialSession: boolean|null;
    public practitionerId: number|null;
    public roomId: number|null;
    public usedFor: string|null;
    public locationId: number|null;
    public hexColour: string|null;
    public online: boolean|null;
    public occurrences: string[]|null;
    public id: number|null;

    public constructor(init?: Partial<DiarySessionResponse>) { (Object as any).assign(this, init); }
}
(DiarySessionResponse as unknown)[immerable] = true;

export class ScheduleSession
{
    public id: number|null;
    public roomId: number|null;
    public type: string|null;
    public isOnline: boolean|null;
    public isSpecial: boolean|null;
    public locationId: number|null;
    public usedFor: string|null;
    public hexColour: string|null;
    public scheduleId: string|null;
    public practitionerId: number|null;
    public endDateTime: string|null;
    public startDateTime: string|null;
    public dateDiff: number|null;
    public startTimeMinutes: number|null;
    public isBatch: boolean|null;
    public isFirstInBatch: boolean|null;
    public batchNo: number|null;
    public multiUsedFor: string[]|null;
    public skillRestrictions: string[]|null;

    public constructor(init?: Partial<ScheduleSession>) { (Object as any).assign(this, init); }
}
(ScheduleSession as unknown)[immerable] = true;

export class ScheduleAppointment
{
    public id: number|null;
    public locationId: number|null;
    public name: string|null;
    public authId: number|null;
    public authLeft: number|null;
    public startDateTime: string|null;
    public endDateTime: string|null;
    public actualStartDateTime: string|null;
    public actualEndDateTime: string|null;
    public dateDiff: number|null;
    public startTimeMinutes: number|null;
    public scheduleId: string|null;
    public hexColour: string|null;
    public type: string|null;
    public reminderType: string|null;
    public status: number|null;
    public isMulti: boolean|null;
    public isMultiFirst: boolean|null;
    public inDebt: boolean|null;
    public payAtEachAppt: string|null;
    public comment: string|null;
    public caseId: number|null;
    public firstAppointment: boolean|null;
    public stockDescription: string|null;
    public meta: { [index:string]: Object; }|null;
    public serviceTypeId: number|null;
    public alert: boolean|null;
    public prontoAuditId: string|null;
    public prontoAppointmentId: string|null;
    public prontoServiceId: string|null;
    public practitionerId: number|null;
    public roomId: number|null;
    public stockId: number|null;
    public customerId: number|null;
    public customerReference: string|null;
    public customerAltRef: string|null;
    public customerMobileTelephone: string|null;
    public customerEmail: string|null;
    public customerSMSEnabled: boolean|null;
    public customerTitle: string|null;
    public customerForename: string|null;
    public customerSurname: string|null;
    public customerName: string|null;
    public customerDateOfBirth: string|null;
    public customerGender: string|null;
    public customerStatus: number|null;
    public customerRegistrationDate: string|null;
    public insuranceNumber: string|null;
    public groupReference: string|null;
    public groupId: number|null;
    public batchNo: number|null;
    public isFirstInBatch: boolean|null;
    public isBatch: boolean|null;
    public customerIsBusiness: boolean|null;

    public constructor(init?: Partial<ScheduleAppointment>) { (Object as any).assign(this, init); }
}
(ScheduleAppointment as unknown)[immerable] = true;

export class Schedule
{
    public id: number|null;
    public name: string|null;
    public sessions: { [index:string]: ScheduleSession; }|null;
    public appointments: { [index:string]: ScheduleAppointment; }|null;

    public constructor(init?: Partial<Schedule>) { (Object as any).assign(this, init); }
}
(Schedule as unknown)[immerable] = true;

export class ScheduleBlock
{
    public count: number|null;
    public holiday: boolean|null;
    public keys: string[]|null;
    public values: { [index:string]: Schedule; }|null;

    public constructor(init?: Partial<ScheduleBlock>) { (Object as any).assign(this, init); }
}
(ScheduleBlock as unknown)[immerable] = true;

export class ScheduleResponse
{
    public columns: number|null;
    public count: number|null;
    public keys: string[]|null;
    public blocks: { [index:string]: ScheduleBlock; }|null;

    public constructor(init?: Partial<ScheduleResponse>) { (Object as any).assign(this, init); }
}
(ScheduleResponse as unknown)[immerable] = true;

export class DayOverview
{
    public availableHours: number|null;
    public noOfAppointments: number|null;
    public noOfClasses: number|null;
    public noOfMeetings: number|null;
    public noOfOtherEvents: number|null;
    public noOfHolidays: number|null;
    public date: string|null;
    public nonWorkingDate: boolean|null;
    public utilizationPercentage: number|null;
    public noOfCancelled: number|null;

    public constructor(init?: Partial<DayOverview>) { (Object as any).assign(this, init); }
}
(DayOverview as unknown)[immerable] = true;

export class MonthlyScheduleResponse
{
    public days: DayOverview[]|null;

    public constructor(init?: Partial<MonthlyScheduleResponse>) { (Object as any).assign(this, init); }
}
(MonthlyScheduleResponse as unknown)[immerable] = true;

export class OccurrenceResponse
{
    public occurrences: string[]|null;
    public isLastInBatch: boolean|null;

    public constructor(init?: Partial<OccurrenceResponse>) { (Object as any).assign(this, init); }
}
(OccurrenceResponse as unknown)[immerable] = true;

export interface IHasGlobalGuid
{
    globalGuid: string|null;
}

export class PaymentResponse extends Income
{
    public accountName: string|null;
    public smsEnabled: boolean|null;
    public customerMobileTelephone: string|null;
    public accountType: string|null;
    public accountTypeId: number|null;
    public locationName: string|null;
    public emailReceipt: boolean|null;
    public receiptTemplate: string|null;
    public statusName: string|null;
    public method: string|null;
    public accountingSystemPaymentId: string|null;

    public constructor(init?: Partial<PaymentResponse>) { super(init); (Object as any).assign(this, init); }
}
(PaymentResponse as unknown)[immerable] = true;

export class PaymentsResponse extends PaymentResponse
{
    public invoiceId: number|null;
    public refundId: number|null;
    public paymentAmount: number|null;
    public description: string|null;
    public type: string|null;
    public debit: number|null;
    public credit: number|null;
    public customerName: string|null;
    public remainingAmount: number|null;

    public constructor(init?: Partial<PaymentsResponse>) { super(init); (Object as any).assign(this, init); }
}
(PaymentsResponse as unknown)[immerable] = true;

export class BillingItemWithNames extends BillingItem
{
    public practitionerForename: string|null;
    public practitionerTitle: string|null;
    public practitionerSurname: string|null;
    public practitionerCode: string|null;
    public practitionerLocationCode: string|null;
    public practitionerGroupProviderNo: string|null;
    // @Ignore()
    public providerNo: string|null;

    public employmentStatus: string|null;
    // @Ignore()
    public practitionerName: string|null;

    public customerForename: string|null;
    public customerTitle: string|null;
    public customerSurname: string|null;
    // @Ignore()
    public customerName: string|null;

    public auditId: string|null;

    public constructor(init?: Partial<BillingItemWithNames>) { super(init); (Object as any).assign(this, init); }
}
(BillingItemWithNames as unknown)[immerable] = true;

export class BillingItemWithNamesExtended extends BillingItemWithNames
{
    public customerReference: string|null;
    public customerAddressLine1: string|null;
    public customerAddressLine2: string|null;
    public customerAddressLine3: string|null;
    public customerAddressLine4: string|null;
    public customerAddressLine5: string|null;
    public customerPostcode: string|null;
    public customerDateOfBirth: string|null;
    public customerGroupReference: string|null;
    public customerInsuranceNumber: string|null;
    public regNumber: string|null;

    public constructor(init?: Partial<BillingItemWithNamesExtended>) { super(init); (Object as any).assign(this, init); }
}
(BillingItemWithNamesExtended as unknown)[immerable] = true;

export class BillingItemWithNamesAuth extends BillingItemWithNamesExtended
{
    public authId: number|null;
    public authCode: string|null;

    public constructor(init?: Partial<BillingItemWithNamesAuth>) { super(init); (Object as any).assign(this, init); }
}
(BillingItemWithNamesAuth as unknown)[immerable] = true;

export class AccountsExportChargesPreviewResponse
{
    public ledgerCode: string|null;
    public location: string|null;
    public amount: number|null;
    public exVat: number|null;
    public vat: number|null;

    public constructor(init?: Partial<AccountsExportChargesPreviewResponse>) { (Object as any).assign(this, init); }
}
(AccountsExportChargesPreviewResponse as unknown)[immerable] = true;

export class AccountsExportPaymentsAlertsResponse
{
    public id: number|null;
    public date: string|null;
    public amount: number|null;
    public method: string|null;
    public reference: string|null;
    public name: string|null;
    public locationId: number|null;

    public constructor(init?: Partial<AccountsExportPaymentsAlertsResponse>) { (Object as any).assign(this, init); }
}
(AccountsExportPaymentsAlertsResponse as unknown)[immerable] = true;

export class AccountsExportPaymentsFilePreviewResponse
{
    public type: string|null;
    public reference: string|null;
    public location: string|null;
    public date: string|null;
    public amount: number|null;
    public paymentMethod: string|null;

    public constructor(init?: Partial<AccountsExportPaymentsFilePreviewResponse>) { (Object as any).assign(this, init); }
}
(AccountsExportPaymentsFilePreviewResponse as unknown)[immerable] = true;

export class AccountsExportPaymentsPreviewResponse
{
    public a: AccountsExportPaymentsAlertsResponse[]|null;
    public b: AccountsExportPaymentsFilePreviewResponse[]|null;

    public constructor(init?: Partial<AccountsExportPaymentsPreviewResponse>) { (Object as any).assign(this, init); }
}
(AccountsExportPaymentsPreviewResponse as unknown)[immerable] = true;

export class AccountExportHistoryResponse
{
    public id: number|null;
    public fromDate: string|null;
    public toDate: string|null;
    public type: string|null;
    public dateTime: string|null;

    public constructor(init?: Partial<AccountExportHistoryResponse>) { (Object as any).assign(this, init); }
}
(AccountExportHistoryResponse as unknown)[immerable] = true;

export class GroupBillingItemsResponse
{
    public id: number|null;
    public date: string|null;
    public description: string|null;
    public total: number|null;
    public accountName: string|null;
    public accountsExportId: number|null;
    public groupOrPatientReference: string|null;
    public customerInvoicePeriod: string|null;
    public groupInvoicePeriod: string|null;
    public invoicePeriod: string|null;
    public isPaid: boolean|null;
    public invoiceRef: string|null;
    public paidDate: string|null;
    public invoiceId: number|null;
    public stockType: string|null;
    public locationName: string|null;
    public practitionerName: string|null;
    public customerName: string|null;
    public customerId: number|null;
    public status: string|null;
    public parentId: number|null;
    public totalExVat: number|null;
    public groupId: number|null;
    public groupName: string|null;
    public accountingSystemLineItemId: string|null;
    public accountingSystemCreditNoteId: string|null;

    public constructor(init?: Partial<GroupBillingItemsResponse>) { (Object as any).assign(this, init); }
}
(GroupBillingItemsResponse as unknown)[immerable] = true;

export class GroupingResponse
{
    public total: number|null;
    public grouping: ChargeGroup[]|null;

    public constructor(init?: Partial<GroupingResponse>) { (Object as any).assign(this, init); }
}
(GroupingResponse as unknown)[immerable] = true;

export class InvoiceGroupingResponse
{
    public batch: InvoiceBatch|null;
    public manifest: GroupingResponse[]|null;

    public constructor(init?: Partial<InvoiceGroupingResponse>) { (Object as any).assign(this, init); }
}
(InvoiceGroupingResponse as unknown)[immerable] = true;

export class InvoiceWizardResponse
{
    public invoices: number[]|null;

    public constructor(init?: Partial<InvoiceWizardResponse>) { (Object as any).assign(this, init); }
}
(InvoiceWizardResponse as unknown)[immerable] = true;

export class DebtsResponse
{
    public id: number|null;
    public reference: string|null;
    public date: string|null;
    public dueDate: string|null;
    public grandTotal: number|null;
    public amountPaid: number|null;
    public amountRemaining: number|null;
    public debtAge: string|null;
    public accountTypeName: string|null;
    public accountName: string|null;
    public mobileNumber: string|null;
    public smsEnabled: boolean|null;
    public status: string|null;
    public statusName: string|null;
    public customerId: number|null;
    public customerName: string|null;
    public locationId: number|null;
    public accountId: number|null;
    public groupAccountId: number|null;
    public patientAccountId: number|null;
    public patientFullName: string|null;
    public template: string|null;
    public email: string|null;
    public paymentCardAvailability: boolean|null;
    public accountType: string|null;
    public paymentStatus: string|null;

    public constructor(init?: Partial<DebtsResponse>) { (Object as any).assign(this, init); }
}
(DebtsResponse as unknown)[immerable] = true;

export class ExpenditureResponse
{
    public id: number|null;
    public date: string|null;
    public description: string|null;
    public reference: string|null;
    public amountExVAT: number|null;
    public vatRate: number|null;
    public vatAmount: number|null;
    public total: number|null;
    public category: string|null;
    public supplierId: number|null;
    public supplierName: string|null;
    public expenditureName: string|null;
    public locationId: number|null;
    public locationName: string|null;
    public otherPaymentMethod: string|null;
    public chequeNumber: string|null;
    public cardType: string|null;

    public constructor(init?: Partial<ExpenditureResponse>) { (Object as any).assign(this, init); }
}
(ExpenditureResponse as unknown)[immerable] = true;

export class InvoicesResponse
{
    public id: number|null;
    public reference: string|null;
    public date: string|null;
    public dueDate: string|null;
    public fullyPaidDate: string|null;
    public grandTotal: number|null;
    public amountPaid: number|null;
    public mobileNumber: string|null;
    public smsEnabled: boolean|null;
    public status: string|null;
    public statusName: string|null;
    public customerId: number|null;
    public locationId: number|null;
    public accountId: number|null;
    public patientAccountId: number|null;
    public healthCodeId: number|null;
    public accountType: string|null;
    public accountTypeId: number|null;
    public groupAccountId: number|null;
    public groupName: string|null;
    public addressTo: string|null;
    public addressLine1: string|null;
    public addressLine2: string|null;
    public addressLine3: string|null;
    public addressLine4: string|null;
    public addressLine5: string|null;
    public postCode: string|null;
    public invoiceAddress: string|null;
    public invoiceReminder: number|null;
    public invoiceSecondReminder: number|null;
    public notes: string|null;
    public customerForename: string|null;
    public customerSurname: string|null;
    public customerName: string|null;
    public customerAddress1: string|null;
    public customerPostCode: string|null;
    public patientPractitionerId: number|null;
    public otherAmountAvailable: number|null;
    public locationName: string|null;
    public template: string|null;
    public email: string|null;
    public globalId: string|null;
    public globalType: number|null;
    public metadata: ProntoInvoice|null;
    public paymentCard: PaymentCard|null;
    public paymentCardAvailability: boolean|null;
    public meta: { [index:string]: Object; }|null;
    public paymentStatus: string|null;
    public medipassStatus: string|null;
    public purchaseOrderNumber: string|null;
    public medicalContactId: number|null;
    public medicalContactName: string|null;
    public referralDate: string|null;
    public uninvoicedBillingItemCount: number|null;
    public patientAmountAvailable: number|null;
    public accountingSystemInvoiceId: string|null;
    public registrationNumber: string|null;
    public vehicleId: number|null;
    public registrationOrigin: string|null;

    public constructor(init?: Partial<InvoicesResponse>) { (Object as any).assign(this, init); }
}
(InvoicesResponse as unknown)[immerable] = true;

export class InvoiceDto
{
    public id: string|null;

    public constructor(init?: Partial<InvoiceDto>) { (Object as any).assign(this, init); }
}
(InvoiceDto as unknown)[immerable] = true;

export class ProntoInvoiceResponse
{
    public invoice: InvoiceDto|null;
    public responseStatus: ResponseStatus|null;

    public constructor(init?: Partial<ProntoInvoiceResponse>) { (Object as any).assign(this, init); }
}
(ProntoInvoiceResponse as unknown)[immerable] = true;

export class TransactionResponse
{
    public id: number|null;
    public type: string|null;
    public date: string|null;
    public description: string|null;
    public total: number|null;
    public totalExVat: number|null;
    public totalVat: number|null;
    public practitioner: string|null;
    public practitionerId: number|null;
    public customer: string|null;
    public reference: string|null;
    public method: string|null;
    public status: string|null;
    public paymentId: number|null;
    public itemPrice: number|null;
    public ledgerCode: string|null;
    public lodgementRef: string|null;
    public category: string|null;
    public accountId: number|null;
    public customerId: number|null;
    public accountsExportId: number|null;
    public locationId: number|null;
    public invoiceStatus: string|null;
    public invoiceId: number|null;
    public invoiceStatusName: string|null;
    public prontoServiceId: string|null;

    public constructor(init?: Partial<TransactionResponse>) { (Object as any).assign(this, init); }
}
(TransactionResponse as unknown)[immerable] = true;

export class InvoiceBatchResponse
{
    public id: number|null;
    public date: string|null;

    public constructor(init?: Partial<InvoiceBatchResponse>) { (Object as any).assign(this, init); }
}
(InvoiceBatchResponse as unknown)[immerable] = true;

// @Flags()
export enum EGroupsAccountSearchResponseType
{
    Invoice = 0,
    Payment = 1,
}

// @Flags()
export enum EGroupsAccountSearchResponseStatus
{
    InvoicePaid = 0,
    InvoiceUnpaid = 1,
    InvoicePartPaid = 2,
    InvoiceWrittenOff = 3,
    PaymentReconciled = 4,
    PaymentUnreconciled = 5,
    PaymentPartReconciled = 6,
    PaymentVoided = 7,
}

export class GroupsAccountSearchResponse
{
    public id: number|null;
    public reference: string|null;
    public date: string|null;
    public customerName: string|null;
    public customerId: number|null;
    public locationId: number|null;
    public locationName: string|null;
    public debit: number|null;
    public credit: number|null;
    public type: EGroupsAccountSearchResponseType|null;
    public eStatus: EGroupsAccountSearchResponseStatus|null;

    public constructor(init?: Partial<GroupsAccountSearchResponse>) { (Object as any).assign(this, init); }
}
(GroupsAccountSearchResponse as unknown)[immerable] = true;

export class PaymentDetailsResponse
{
    public refundId: number|null;
    public isLocked: boolean|null;
    public refund: number|null;
    public available: number[]|null;
    public reconciled: number[]|null;
    public payment: PaymentResponse|null;
    public reconciliations: ReconciliationResponse[]|null;

    public constructor(init?: Partial<PaymentDetailsResponse>) { (Object as any).assign(this, init); }
}
(PaymentDetailsResponse as unknown)[immerable] = true;

export class RemainingAuths
{
    public id: number|null;
    public remaining: number|null;

    public constructor(init?: Partial<RemainingAuths>) { (Object as any).assign(this, init); }
}
(RemainingAuths as unknown)[immerable] = true;

export class CancellationReasonResponse
{
    public appointmentAuthRemaining: RemainingAuths[]|null;

    public constructor(init?: Partial<CancellationReasonResponse>) { (Object as any).assign(this, init); }
}
(CancellationReasonResponse as unknown)[immerable] = true;

export interface IHangfireJobQueueService
{
}

export class QuickBill extends Customer
{
    public name: string|null;
    public paymentsAvailable: boolean|null;
    public cardDetails: CardDetails|null;

    public constructor(init?: Partial<QuickBill>) { super(init); (Object as any).assign(this, init); }
}

export class Group implements IHasId, IHasAddressDetails, IHasGlobalGuid, IHasDocuments
{
    public id: number|null;
    public name: string|null;
    public contact: string|null;
    public addressLine1: string|null;
    public addressLine2: string|null;
    public addressLine3: string|null;
    public addressLine4: string|null;
    public addressLine5: string|null;
    public postCode: string|null;
    public telephone: string|null;
    public fax: string|null;
    public email: string|null;
    public web: string|null;
    public accountId: number|null;
    // @Ignore()
    public accountGuid: string|null;

    public profileId: number|null;
    public locationId: number|null;
    // @Ignore()
    public locationGuid: string|null;

    public showReferrals: boolean|null;
    public groupInvoices: string|null;
    public addressTo: string|null;
    public invoicePeriod: string|null;
    public contractNumber: string|null;
    public invoiceFrequency: number|null;
    public invoiceWPID: number|null;
    public showVAT: boolean|null;
    public authorisationCode: string|null;
    public defaultMaxTreatments: number|null;
    public classification: string|null;
    public cancellationHours: number|null;
    public paysForDNA: boolean|null;
    public paysForCancel: boolean|null;
    public notificationEmail: string|null;
    public abbreviationPrefix: string|null;
    public online: boolean|null;
    public globalId: string|null;
    public accountCode: string|null;
    public dueDaysOverride: number|null;
    public invoiceTemplate: string|null;
    public onlineGuid: string|null;
    public tm3InvoiceTemplate: string|null;
    public invoicePaymentTerms: string|null;
    public useInvoicePaymentTerms: boolean|null;
    public groupInvoiceByStockId: boolean|null;
    public financialAddress: string|null;
    public medipassFunder: string|null;
    public medipassFunderCode: string|null;
    public isVatExempt: boolean|null;
    public vatExemptionNumber: string|null;
    public vatExemptionExpiryDate: string|null;
    public allowedEmails: string|null;
    public onlineSettingsId: number|null;
    public documentsLoaded: boolean|null;
    public businessPortalTwoFactorAuthenticationEnabled: boolean|null;
    public authorisationExpiryInDays: number|null;
    public authorisationExpiryTriggerInDays: number|null;
    public remainingAuthorisationThreshold: number|null;
    // @Ignore()
    public documentsSubDirectory: string|null;

    // @Ignore()
    public reference: string|null;

    // @Ignore()
    public globalGuid: string|null;

    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<Group>) { (Object as any).assign(this, init); }
}
(Group as unknown)[immerable] = true;

export class PrePaid implements IHasId
{
    public id: number|null;
    public accountId: number|null;
    public customerId: number|null;
    public billingItemId: number|null;
    public quantity: number|null;
    public used: number|null;
    public status: PrePaidStatus|null;
    public prePaidLastUsedOn: string|null;
    public expiryDate: string|null;

    public constructor(init?: Partial<PrePaid>) { (Object as any).assign(this, init); }
}
(PrePaid as unknown)[immerable] = true;

export class PrePaidLegacy extends PrePaid
{
    public stockId: number|null;

    public constructor(init?: Partial<PrePaidLegacy>) { super(init); (Object as any).assign(this, init); }
}
(PrePaidLegacy as unknown)[immerable] = true;

export class PrePaidWithBillingDescription extends PrePaidLegacy
{
    public billingItemDescription: string|null;
    public billingItemStockId: number|null;
    public type: EPrePaidType|null;

    public constructor(init?: Partial<PrePaidWithBillingDescription>) { super(init); (Object as any).assign(this, init); }
}
(PrePaidWithBillingDescription as unknown)[immerable] = true;

export class Stock implements IHasId, IHasGlobalGuid
{
    public id: number|null;
    public totalPrice: number|null;
    public description: string|null;
    public appointmentLength: number|null;
    public serviceTypeId: number|null;
    // @Ignore()
    public serviceTypeGuid: string|null;

    public crossLocationThreadId: string|null;
    public locationId: number|null;
    // @Ignore()
    public locationGuid: string|null;

    public colour: number|null;
    public inUse: boolean|null;
    public priceExVAT: number|null;
    public vatRate: number|null;
    public vatAmount: number|null;
    public costAmount: number|null;
    public costVATRate: number|null;
    public costExVAT: number|null;
    public costVATAmount: number|null;
    public longDescription: string|null;
    public ledgerCode: string|null;
    public barCodeReference: string|null;
    public reference: string|null;
    public category: string|null;
    public level: number|null;
    public minimumLevel: number|null;
    public displayInPriceList: boolean|null;
    public isMultiple: boolean|null;
    public isClass: boolean|null;
    public migrated: boolean|null;
    public supplierId: number|null;
    public isPrivateCharge: boolean|null;
    public groupName: string|null;
    public classification: string|null;
    public online: boolean|null;
    public onlineGuid: string|null;
    public ccsd: string|null;
    public iscCodeID: number|null;
    public templateSetId: number|null;
    public isVideo: boolean|null;
    public managementFee: boolean|null;
    public cancellationStockId: number|null;
    public didNotAttendStockId: number|null;
    public notes: string|null;
    // @Ignore()
    public globalGuid: string|null;

    public tags: string[]|null;
    public specialismId: string|null;
    public credits: number|null;
    public eligibleForTaxExemption: boolean|null;

    public constructor(init?: Partial<Stock>) { (Object as any).assign(this, init); }
}
(Stock as unknown)[immerable] = true;

export class GeneralBillingItemResponse extends BillingItem
{
    public accountName: string|null;
    public practitionerName: string|null;
    public reference: string|null;
    public accountType: string|null;
    public auditId: string|null;
    public prontoAppointmentId: string|null;
    public apptProntoServiceId: string|null;
    public apptStockId: number|null;
    public apptBillingItemID: number|null;

    public constructor(init?: Partial<GeneralBillingItemResponse>) { super(init); (Object as any).assign(this, init); }
}

export class ProntoServiceStock
{
    public id: string|null;
    public name: string|null;
    public exVat: number|null;
    public vatRate: number|null;
    public stockOnlineGuid: string|null;
    public overrides: { [index:string]: string; }|null;
    public canBillCXX: boolean|null;
    public canBillDNA: boolean|null;
    public cancellationChargeServiceId: string|null;
    public dnaChargeServiceId: string|null;
    public serviceType: NetworkServiceType|null;
    public serviceNextAppointmentType: string|null;

    public constructor(init?: Partial<ProntoServiceStock>) { (Object as any).assign(this, init); }
}
(ProntoServiceStock as unknown)[immerable] = true;

export class InvoiceTemplate
{
    public id: string|null;
    public type: number|null;
    public title: string|null;
    public bookerId: string|null;
    public template: string|null;
    public itemTemplate: string|null;
    public timeStamp: string|null;

    public constructor(init?: Partial<InvoiceTemplate>) { (Object as any).assign(this, init); }
}
(InvoiceTemplate as unknown)[immerable] = true;

export class ServiceStock extends ServiceCharge
{
    public id: string|null;
    public name: string|null;
    public serviceType: NetworkServiceType|null;
    public serviceNextAppointmentType: string|null;
    public stockOnlineGuid: string|null;
    public overrides: { [index:string]: string; }|null;

    public constructor(init?: Partial<ServiceStock>) { super(init); (Object as any).assign(this, init); }
}
(ServiceStock as unknown)[immerable] = true;

export class ProntoInvoiceSearchResponse
{
    public invoice: ProntoInvoice|null;
    public schema: InvoiceTemplate|null;
    public inventory: ServiceStock[]|null;

    public constructor(init?: Partial<ProntoInvoiceSearchResponse>) { (Object as any).assign(this, init); }
}
(ProntoInvoiceSearchResponse as unknown)[immerable] = true;

export class QuickBillResponse
{
    public appointment: Appointment|null;
    public customer: QuickBill|null;
    public group: Group|null;
    public stockId: number|null;
    public ownerPractitionerId: number|null;
    public filterMode: string|null;
    public unpaidInvoices: Invoice[]|null;
    public prePaid: PrePaidWithBillingDescription[]|null;
    public prePaidInventory: Stock[]|null;
    public uninvoicedBillingItems: GeneralBillingItemResponse[]|null;
    public selfEmployed: boolean|null;
    public defaultBillTo: number|null;
    public fee: number|null;
    public creditFee: number|null;
    public config: Object|null;
    public userLocationId: number|null;
    public prontoServices: { [index:string]: ProntoServiceStock; }|null;
    public cardDetails: CardDetails|null;
    public clientSecret: string|null;
    public paymentMethodId: string|null;
    public paymentIntentId: string|null;
    public showMedipass: boolean|null;
    public isMyClinicIntegration: boolean|null;
    public prontoInvoiceSearchResponse: ProntoInvoiceSearchResponse|null;
    public meta: { [index:string]: Object; }|null;
    public failedProntoInvoices: number[]|null;
    public isProntoReferralBooking: boolean|null;
    public prontoBillToReferrer: boolean|null;

    public constructor(init?: Partial<QuickBillResponse>) { (Object as any).assign(this, init); }
}
(QuickBillResponse as unknown)[immerable] = true;

export class QuickbillMedipassResponse
{
    public invoiceId: number|null;

    public constructor(init?: Partial<QuickbillMedipassResponse>) { (Object as any).assign(this, init); }
}
(QuickbillMedipassResponse as unknown)[immerable] = true;

export class AppointmentPrePaidResponse
{

    public constructor(init?: Partial<AppointmentPrePaidResponse>) { (Object as any).assign(this, init); }
}
(AppointmentPrePaidResponse as unknown)[immerable] = true;

export class ReferralAttachment
{
    public name: string|null;
    public extension: string|null;
    public fileSize: number|null;
    public dateCreated: string|null;
    public path: string|null;

    public constructor(init?: Partial<ReferralAttachment>) { (Object as any).assign(this, init); }
}
(ReferralAttachment as unknown)[immerable] = true;

export class AuditListDto
{
    public auditId: string|null;
    public id: string|null;
    public type: number|null;
    public status: number|null;
    public message: string|null;
    public timeStamp: string|null;
    public metadata: { [index:string]: string; }|null;
    public attachments: ReferralAttachment[]|null;
    public title: string|null;
    public templateId: string|null;
    public workflowId: number|null;

    public constructor(init?: Partial<AuditListDto>) { (Object as any).assign(this, init); }
}
(AuditListDto as unknown)[immerable] = true;

export class MyClinicInvoiceResponse
{
    public invoice: AuditListDto|null;
    public appointments: ReferralAppointmentResponse[]|null;

    public constructor(init?: Partial<MyClinicInvoiceResponse>) { (Object as any).assign(this, init); }
}
(MyClinicInvoiceResponse as unknown)[immerable] = true;

export class QuickBillCompleteResponse
{
    public customerInvoiceId: number|null;
    public groupInvoiceId: number|null;
    public customerPaymentId: number|null;
    public customerInDebt: boolean|null;
    public groupPaymentId: number|null;
    public groupInvoiceTemplate: string|null;
    public appointmentAuthRemaining: RemainingAuths[]|null;
    public medipassPaymentInfo: { [index:string]: Object; }|null;
    public showMedipass: boolean|null;
    public prontoInvoiceResponse: MyClinicInvoiceResponse|null;

    public constructor(init?: Partial<QuickBillCompleteResponse>) { (Object as any).assign(this, init); }
}
(QuickBillCompleteResponse as unknown)[immerable] = true;

export class GroupServiceTypeOptions implements IHasId, IHasGlobalGuid
{
    public id: number|null;
    public serviceTypeID: number|null;
    // @Ignore()
    public serviceTypeGuid: string|null;

    public groupID: number|null;
    // @Ignore()
    public groupGuid: string|null;

    public useAuthCodes: boolean|null;
    public useDummyAuthCodes: boolean|null;
    public dummyCodePrefix: string|null;
    public cancelAffectsAuthCount: boolean|null;
    public dnaAffectsAuthCount: boolean|null;
    public authCodeGenerateMode: number|null;
    public authCodeGenerateAssess: number|null;
    public authCodeGenerateTreat: number|null;
    public authCodeGenerateAll: number|null;
    public globalGuid: string|null;
    public cancelAlwaysAffectsAuthCount: boolean|null;
    public cancelAffectsAuthCountDays: number|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GroupServiceTypeOptions>) { (Object as any).assign(this, init); }
}
(GroupServiceTypeOptions as unknown)[immerable] = true;

export class GroupResponse
{
    public id: number|null;
    public name: string|null;
    public contact: string|null;
    public addressLine1: string|null;
    public addressLine2: string|null;
    public addressLine3: string|null;
    public addressLine4: string|null;
    public addressLine5: string|null;
    public address: string|null;
    public postCode: string|null;
    public telephone: string|null;
    public fax: string|null;
    public web: string|null;
    public email: string|null;
    public locationId: number|null;
    public showReferrals: boolean|null;
    public groupInvoices: string|null;
    public addressTo: string|null;
    public invoicePeriod: string|null;
    public contractNumber: string|null;
    public accountId: number|null;
    public accountType: string|null;
    public profileId: number|null;
    public invoiceFrequency: number|null;
    public invoiceWPID: number|null;
    public showVAT: boolean|null;
    public authorisationCode: string|null;
    public defaultMaxTreatments: number|null;
    public classification: string|null;
    public cancellationHours: number|null;
    public paysForDNA: boolean|null;
    public paysForCancel: boolean|null;
    public notificationEmail: string|null;
    public abbreviationPrefix: string|null;
    public online: boolean|null;
    public globalId: string|null;
    public cancelId: number|null;
    public dnaId: number|null;
    public alerts: AlertResponse[]|null;
    public locationIds: number[]|null;
    public balanceOwed: number|null;
    public balanceInvoiced: number|null;
    public uninvoicedCharges: number|null;
    public tm3InvoiceTemplate: string|null;
    public locationName: string|null;
    public meta: { [index:string]: Object; }|null;
    public dueDaysOverride: number|null;
    public serviceTypes: GroupServiceTypeOptions[]|null;
    public distributorGroupId: number|null;
    public isDistributor: boolean|null;
    public invoicePaymentTerms: string|null;
    public useInvoicePaymentTerms: boolean|null;
    public groupInvoiceByStockId: boolean|null;
    public billDistributor: boolean|null;
    public healthcodeEnabled: boolean|null;
    public minorUpperAgeLimit: number|null;
    public adolescentUpperAgeLimit: number|null;
    public medipassFunder: string|null;
    public medipassFunderCode: string|null;
    public isVatExempt: boolean|null;
    public financialAddress: string|null;
    public vatExemptionNumber: string|null;
    public vatExemptionExpiryDate: string|null;
    public allowedEmails: string|null;
    public onlineGuid: string|null;
    public referralPortalEnabled: boolean|null;
    public businessPortalTwoFactorAuthenticationEnabled: boolean|null;
    public childGroups: number[]|null;
    public authorisationExpiryInDays: number|null;
    public authorisationExpiryTriggerInDays: number|null;
    public remainingAuthorisationThreshold: number|null;

    public constructor(init?: Partial<GroupResponse>) { (Object as any).assign(this, init); }
}
(GroupResponse as unknown)[immerable] = true;

export class GroupServiceTypeOptionsResponse
{
    public id: number|null;
    public serviceTypeID: number|null;
    public groupID: number|null;
    public useAuthCodes: boolean|null;
    public useDummyAuthCodes: boolean|null;
    public dummyCodePrefix: string|null;
    public groupDefaultAuthCount: number|null;
    public nextDummyCode: string|null;
    public cancelAffectsAuthCount: boolean|null;
    public dnaAffectsAuthCount: boolean|null;
    public authCodeGenerateMode: number|null;
    public authCodeGenerateAssess: number|null;
    public authCodeGenerateTreat: number|null;
    public authCodeGenerateAll: number|null;
    public cancelAlwaysAffectsAuthCount: boolean|null;
    public cancelAffectsAuthCountDays: number|null;

    public constructor(init?: Partial<GroupServiceTypeOptionsResponse>) { (Object as any).assign(this, init); }
}
(GroupServiceTypeOptionsResponse as unknown)[immerable] = true;

export class AppointmentEventBase
{
    public id: string|null;
    public name: string|null;

    public constructor(init?: Partial<AppointmentEventBase>) { (Object as any).assign(this, init); }
}

export class BusinessResponse
{
    public name: string|null;
    public isActive: boolean|null;
    public id: number|null;

    public constructor(init?: Partial<BusinessResponse>) { (Object as any).assign(this, init); }
}
(BusinessResponse as unknown)[immerable] = true;

export class HealthcodeSettingsResponse
{
    public groups: BusinessResponse[]|null;
    public username: string|null;
    public password: string|null;
    public siteId: string|null;
    public senderCode: string|null;

    public constructor(init?: Partial<HealthcodeSettingsResponse>) { (Object as any).assign(this, init); }
}
(HealthcodeSettingsResponse as unknown)[immerable] = true;

export class ExportIssueBillingItem
{
    public billingItemDate: string|null;
    public billingItemDescription: string|null;
    public billingItemTotal: number|null;
    public locationName: string|null;
    public problems: string[]|null;

    public constructor(init?: Partial<ExportIssueBillingItem>) { (Object as any).assign(this, init); }
}
(ExportIssueBillingItem as unknown)[immerable] = true;

export class ExportIssueInvoice
{
    public invoiceReference: number|null;
    public customer: string|null;
    public problems: string[]|null;
    public billingItems: ExportIssueBillingItem[]|null;
    public problemCount: number|null;

    public constructor(init?: Partial<ExportIssueInvoice>) { (Object as any).assign(this, init); }
}
(ExportIssueInvoice as unknown)[immerable] = true;

export class ExportIssueResponse
{
    public accountName: string|null;
    public problemCount: number|null;
    public invoices: ExportIssueInvoice[]|null;

    public constructor(init?: Partial<ExportIssueResponse>) { (Object as any).assign(this, init); }
}
(ExportIssueResponse as unknown)[immerable] = true;

export class ExportedInvoiceFileResponse
{
    public name: string|null;
    public date: string|null;

    public constructor(init?: Partial<ExportedInvoiceFileResponse>) { (Object as any).assign(this, init); }
}
(ExportedInvoiceFileResponse as unknown)[immerable] = true;

export class HealthcodeImportSummaryResponse
{
    public account: string|null;
    public type: string|null;
    public reference: string|null;
    public message: string|null;
    public status: string|null;

    public constructor(init?: Partial<HealthcodeImportSummaryResponse>) { (Object as any).assign(this, init); }
}
(HealthcodeImportSummaryResponse as unknown)[immerable] = true;

export class HealthcodeExportSummaryResponse
{
    public invoiceReference: number|null;
    public date: string|null;
    public location: string|null;
    public patient: string|null;
    public total: number|null;

    public constructor(init?: Partial<HealthcodeExportSummaryResponse>) { (Object as any).assign(this, init); }
}
(HealthcodeExportSummaryResponse as unknown)[immerable] = true;

export class MailChimpLoginResponse
{
    public apiKey: string|null;
    public username: string|null;

    public constructor(init?: Partial<MailChimpLoginResponse>) { (Object as any).assign(this, init); }
}
(MailChimpLoginResponse as unknown)[immerable] = true;

export class MailchimpList
{
    public id: string|null;
    public name: string|null;
    public status: number|null;

    public constructor(init?: Partial<MailchimpList>) { (Object as any).assign(this, init); }
}
(MailchimpList as unknown)[immerable] = true;

export class AudiencesResponse
{
    public lists: MailchimpList[]|null;
    public total: number|null;
    public success: number|null;
    public error: string|null;

    public constructor(init?: Partial<AudiencesResponse>) { (Object as any).assign(this, init); }
}
(AudiencesResponse as unknown)[immerable] = true;

export class MailChimpDuplicatesResponse
{
    public customers: { [index:string]: AudienceMember[]; }|null;

    public constructor(init?: Partial<MailChimpDuplicatesResponse>) { (Object as any).assign(this, init); }
}
(MailChimpDuplicatesResponse as unknown)[immerable] = true;

export class PostcodeLookupResponse
{
    public fullAddress: string|null;
    public addressLine1: string|null;
    public addressLine2: string|null;
    public addressLine3: string|null;
    public addressLine4: string|null;
    public addressLine5: string|null;
    public postCode: string|null;

    public constructor(init?: Partial<PostcodeLookupResponse>) { (Object as any).assign(this, init); }
}
(PostcodeLookupResponse as unknown)[immerable] = true;

export class CustomListItem
{
    public text: string|null;
    public order: number|null;
    public id: number|null;
    public inUse: boolean|null;

    public constructor(init?: Partial<CustomListItem>) { (Object as any).assign(this, init); }
}
(CustomListItem as unknown)[immerable] = true;

export class CustomListItemResponse
{
    public id: number|null;
    public category: string|null;
    public values: CustomListItem[]|null;

    public constructor(init?: Partial<CustomListItemResponse>) { (Object as any).assign(this, init); }
}
(CustomListItemResponse as unknown)[immerable] = true;

export class PractitionerGroupResponse
{
    public id: number|null;
    public groupId: number|null;
    public providerNo: string|null;
    public groupName: string|null;

    public constructor(init?: Partial<PractitionerGroupResponse>) { (Object as any).assign(this, init); }
}
(PractitionerGroupResponse as unknown)[immerable] = true;

export class GroupLocationsResponse
{
    public groupId: number|null;
    public groupName: string|null;

    public constructor(init?: Partial<GroupLocationsResponse>) { (Object as any).assign(this, init); }
}
(GroupLocationsResponse as unknown)[immerable] = true;

export class AddPractitionerResponse
{
    public currentPractitioners: number|null;
    public licensedPractitioners: number|null;
    public canAddPractitioner: boolean|null;

    public constructor(init?: Partial<AddPractitionerResponse>) { (Object as any).assign(this, init); }
}
(AddPractitionerResponse as unknown)[immerable] = true;

export class MinimalPractitioner
{
    public id: number|null;
    public forename: string|null;
    public surname: string|null;
    public title: string|null;
    public name: string|null;
    public status: number|null;
    public serviceTypeId: number|null;

    public constructor(init?: Partial<MinimalPractitioner>) { (Object as any).assign(this, init); }
}

export class PracStockLoc
{
    public locationName: string|null;
    public locationId: number|null;
    public practitionerLocationLocationId: number|null;
    public practitionerServiceStockFirstStockId: number|null;
    public practitionerServiceStockFollowupStockId: number|null;
    public code: string|null;
    public firstStockDesc: string|null;
    public followUpStockDesc: string|null;
    public firstStockRef: string|null;
    public followUpStockRef: string|null;
    public firstStockTotalPrice: number|null;
    public followUpTotalPrice: number|null;
    public firstStockAppointmentLength: number|null;
    public followUpStockAppointmentLength: number|null;
    public firstServiceTypeId: number|null;
    public followUpServiceTypeId: number|null;
    public practitionerServiceTypeId: number|null;

    public constructor(init?: Partial<PracStockLoc>) { (Object as any).assign(this, init); }
}
(PracStockLoc as unknown)[immerable] = true;

export class PractitionerDiaryOrder
{
    public practitionerId: number|null;
    public name: string|null;
    public order: number|null;

    public constructor(init?: Partial<PractitionerDiaryOrder>) { (Object as any).assign(this, init); }
}

export class PractitionerDiaryOrderResponse
{
    public locationId: number|null;
    public orderedPractitioners: PractitionerDiaryOrder[]|null;
    public total: number|null;

    public constructor(init?: Partial<PractitionerDiaryOrderResponse>) { (Object as any).assign(this, init); }
}

export class SkillResponse
{
    public id: string|null;
    public name: string|null;
    public inUse: boolean|null;

    public constructor(init?: Partial<SkillResponse>) { (Object as any).assign(this, init); }
}
(SkillResponse as unknown)[immerable] = true;

export class UpdateFieldBulkActionResponse
{

    public constructor(init?: Partial<UpdateFieldBulkActionResponse>) { (Object as any).assign(this, init); }
}
(UpdateFieldBulkActionResponse as unknown)[immerable] = true;

export class AllowedReports
{
    public triage: string|null;
    public initial: string|null;
    public discharge: string|null;
    public rfat: string|null;

    public constructor(init?: Partial<AllowedReports>) { (Object as any).assign(this, init); }
}
(AllowedReports as unknown)[immerable] = true;

export class BookingAuditResult extends AllowedReports
{
    public id: string|null;
    public appointmentDate: string|null;
    public referralDate: string|null;
    public patient: string|null;
    public location: string|null;
    public practitioner: string|null;
    public group: string|null;
    public prontoStatus: string|null;
    public appointments: ReferralAppointment[]|null;
    public authorisations: ReferralAuthorisation[]|null;
    public serviceCharges: { [index:string]: ServiceCharge; }|null;
    public canReport: boolean|null;
    public canInvoice: boolean|null;
    public hasCharges: boolean|null;
    public needsAction: boolean|null;
    public bookerId: string|null;
    public appointmentId: string|null;
    public patientId: string|null;
    public bookingType: string|null;
    public referralStatus: number|null;
    public triageReportName: string|null;
    public initialReportName: string|null;
    public rfatReportName: string|null;
    public dischargeReportName: string|null;
    public customerForename: string|null;
    public customerTitle: string|null;
    public customerSurname: string|null;
    public customerName: string|null;
    public practitionerForename: string|null;
    public practitionerSurname: string|null;
    public practitionerTitle: string|null;
    // @Ignore()
    public practitionerName: string|null;

    public practitionerOnlineGuid: string|null;
    public workflowId: number|null;
    public referencePrefix: string|null;
    public workflowIdWithReferrerPrefix: string|null;
    public initialReportSubmissionDueDate: string|null;
    public hoursUntilReferralExpires: number|null;

    public constructor(init?: Partial<BookingAuditResult>) { super(init); (Object as any).assign(this, init); }
}
(BookingAuditResult as unknown)[immerable] = true;

export class MyBookingsResponse
{
    public results: BookingAuditResult[]|null;
    public total: number|null;
    public all: number|null;
    public online: number|null;
    public referrals: number|null;
    public reception: number|null;
    public received: number|null;
    public awaiting: number|null;
    public rejected: number|null;
    public booking: number|null;
    public enterFirstReport: number|null;
    public inTreatment: number|null;
    public discharged: number|null;
    public complete: number|null;
    public none: number|null;
    public needsAction: number|null;
    public requiresIAReportSubmission: number|null;
    public appointmentsInThePast: number|null;
    public additionalAuthsAdded: number|null;
    public authsRevoked: number|null;
    public page: number|null;
    public totalPages: number|null;
    public filteredResultCount: number|null;

    public constructor(init?: Partial<MyBookingsResponse>) { (Object as any).assign(this, init); }
}
(MyBookingsResponse as unknown)[immerable] = true;

export class LocationDto
{
    public name: string|null;
    public addressLine1: string|null;
    public addressLine2: string|null;
    public addressLine3: string|null;
    public addressLine4: string|null;
    public addressLine5: string|null;
    public postCode: string|null;
    public telephone: string|null;
    public email: string|null;
    public web: string|null;
    public fax: string|null;
    public status: number|null;
    public onlineGuid: string|null;
    public fullAddressMultiLine: string|null;

    public constructor(init?: Partial<LocationDto>) { (Object as any).assign(this, init); }
}
(LocationDto as unknown)[immerable] = true;

export class AttachmentFile
{
    public name: string|null;
    public extension: string|null;
    public fileSize: number|null;
    public dateCreated: string|null;
    public path: string|null;

    public constructor(init?: Partial<AttachmentFile>) { (Object as any).assign(this, init); }
}
(AttachmentFile as unknown)[immerable] = true;

export class SingleBookingAuditResponse
{
    public canReport: boolean|null;
    public canInvoice: boolean|null;
    public authorisations: number|null;
    public referrer: string|null;
    public audit: BookingAuditResponse|null;
    public reports: AuditListDto[]|null;
    public invoices: AuditListDto[]|null;
    public inventory: ServiceStock[]|null;
    public locations: LocationDto[]|null;
    public practitioners: PractitionerDto[]|null;
    public patient: { [index:string]: string; }|null;
    public defaults: { [index:string]: string; }|null;
    public attachments: AttachmentFile[]|null;
    public appointments: ReferralAppointment[]|null;
    public enableReportWizard: boolean|null;
    public isAppointmentLocationSelectionDisabled: boolean|null;
    public linkAppointmentsToReports: boolean|null;
    public linkInvoicesToReports: boolean|null;
    public onlyPastAppointmentsComplete: boolean|null;
    public disableInvoicingAppointmentsInThePast: boolean|null;
    public referencePrefix: string|null;
    public workflowIdWithReferrerPrefix: string|null;
    public referrerAlwaysRequiresAuthorisations: boolean|null;

    public constructor(init?: Partial<SingleBookingAuditResponse>) { (Object as any).assign(this, init); }
}
(SingleBookingAuditResponse as unknown)[immerable] = true;

export enum ProntoNetworkServiceType
{
    Appointment = 'Appointment',
    Cancellation = 'Cancellation',
    DNA = 'DNA',
}

export class ReferrerDto
{
    public id: string|null;
    public name: string|null;

    public constructor(init?: Partial<ReferrerDto>) { (Object as any).assign(this, init); }
}
(ReferrerDto as unknown)[immerable] = true;

export class ProntoClinicalService extends ClinicService
{
    public locations: LocationDto[]|null;
    public practitioners: PractitionerDto[]|null;
    public stock: string|null;
    public referrers: ReferrerDto[]|null;

    public constructor(init?: Partial<ProntoClinicalService>) { super(init); (Object as any).assign(this, init); }
}
(ProntoClinicalService as unknown)[immerable] = true;

export class ProntoServiceDto
{
    public id: string|null;
    public name: string|null;
    public order: number|null;
    public type: ProntoNetworkServiceType|null;
    public clinicalService: ProntoClinicalService|null;

    public constructor(init?: Partial<ProntoServiceDto>) { (Object as any).assign(this, init); }
}
(ProntoServiceDto as unknown)[immerable] = true;

export class ProntoDisciplineDto
{
    public id: string|null;
    public name: string|null;
    public networkId: string|null;
    public description: string|null;
    public meta: { [index:string]: string; }|null;
    public defaultService: string|null;
    public services: ProntoServiceDto[]|null;

    public constructor(init?: Partial<ProntoDisciplineDto>) { (Object as any).assign(this, init); }
}
(ProntoDisciplineDto as unknown)[immerable] = true;

export class ProntoNetworkDto
{
    public id: string|null;
    public name: string|null;
    public description: string|null;
    public disciplines: ProntoDisciplineDto[]|null;

    public constructor(init?: Partial<ProntoNetworkDto>) { (Object as any).assign(this, init); }
}
(ProntoNetworkDto as unknown)[immerable] = true;

export class ServiceDto
{
    public clinicalService: ClinicService|null;

    public constructor(init?: Partial<ServiceDto>) { (Object as any).assign(this, init); }
}
(ServiceDto as unknown)[immerable] = true;

export class ClinicPractitionerResponse
{
    public name: string|null;
    public practitionerProntoId: string|null;
    public responseStatus: ResponseStatus|null;

    public constructor(init?: Partial<ClinicPractitionerResponse>) { (Object as any).assign(this, init); }
}
(ClinicPractitionerResponse as unknown)[immerable] = true;

export class MyClinicSummaryResponse
{
    public networks: ProntoNetworkDto[]|null;
    public services: ServiceDto[]|null;
    public referrers: ReferrerDto[]|null;
    public practitioners: ClinicPractitionerResponse[]|null;
    public locations: LocationDto[]|null;
    public hasReferrals: boolean|null;
    public hasReception: boolean|null;
    public hasOnline: boolean|null;
    public referrals: number|null;
    public reception: number|null;
    public online: number|null;
    public dataPoints: { [index:string]: { [index:string]: DataPoint; }; }|null;
    public provisional: boolean|null;

    public constructor(init?: Partial<MyClinicSummaryResponse>) { (Object as any).assign(this, init); }
}
(MyClinicSummaryResponse as unknown)[immerable] = true;

export class NestedLookupDto
{
    public id: string|null;
    public name: string|null;
    public value: string|null;
    public timeStamp: string|null;
    public bookerId: string|null;

    public constructor(init?: Partial<NestedLookupDto>) { (Object as any).assign(this, init); }
}
(NestedLookupDto as unknown)[immerable] = true;

export class SectionDto
{
    public id: string|null;
    public name: string|null;
    public body: string|null;
    public timeStamp: string|null;
    public bookerId: string|null;

    public constructor(init?: Partial<SectionDto>) { (Object as any).assign(this, init); }
}
(SectionDto as unknown)[immerable] = true;

export class ReportTemplateDto
{
    public id: string|null;
    public type: number|null;
    public enabled: boolean|null;
    public title: string|null;
    public reportTemplateType: string|null;
    public bookerId: string|null;
    public template: string|null;
    public timeStamp: string|null;
    public lists: { [index:string]: NestedLookupDto; }|null;
    public sections: SectionDto[]|null;
    public mandatoryFieldOverrides: { [index:string]: { [index:string]: boolean; }; }|null;
    public labelOverrides: { [index:string]: { [index:string]: string; }; }|null;
    public customLists: { [index:string]: { [index:string]: string; }; }|null;
    public allowsAttachments: boolean|null;
    public requiresAttachment: boolean|null;
    public attachmentPromptText: string|null;

    public constructor(init?: Partial<ReportTemplateDto>) { (Object as any).assign(this, init); }
}
(ReportTemplateDto as unknown)[immerable] = true;

export class ReportSearchResponse
{
    public report: ReferralReport|null;
    public schema: ReportTemplateDto|null;

    public constructor(init?: Partial<ReportSearchResponse>) { (Object as any).assign(this, init); }
}
(ReportSearchResponse as unknown)[immerable] = true;

export class SubmitReportResponse
{
    public report: ReferralReport|null;
    public invoice: AuditListDto|null;
    public appointments: ReferralAppointment[]|null;

    public constructor(init?: Partial<SubmitReportResponse>) { (Object as any).assign(this, init); }
}
(SubmitReportResponse as unknown)[immerable] = true;

export class ClickLinkableAppointment extends ReferralAppointment
{
    public description: string|null;
    public length: number|null;

    public constructor(init?: Partial<ClickLinkableAppointment>) { super(init); (Object as any).assign(this, init); }
}
(ClickLinkableAppointment as unknown)[immerable] = true;

export class BookingAuthorization
{
    public applicationId: string|null;
    public bookerId: string|null;
    public extendedPermissions: { [index:string]: string; }|null;
    public clinicEnabled: boolean|null;
    public prontoActivated: boolean|null;
    public provisionals: boolean|null;

    public constructor(init?: Partial<BookingAuthorization>) { (Object as any).assign(this, init); }
}
(BookingAuthorization as unknown)[immerable] = true;

export class ClientWhoReceivesBookings implements IHasGuidId
{
    public id: string|null;
    public provisional: boolean|null;
    public clientId: string|null;
    public type: string|null;
    public name: string|null;
    public settings: ClinicSettings|null;
    public authorizations: BookingAuthorization[]|null;
    public prontoPortalLockDate: string|null;

    public constructor(init?: Partial<ClientWhoReceivesBookings>) { (Object as any).assign(this, init); }
}
(ClientWhoReceivesBookings as unknown)[immerable] = true;

export enum BookerType
{
    Reception = 'Reception',
    Referrer = 'Referrer',
    Online = 'Online',
    MyClinic = 'MyClinic',
    SysAdmin = 'SysAdmin',
}

export class UserActivations
{
    public userName: string|null;
    public userRole: string|null;
    public email: string|null;
    public displayName: string|null;
    public loginId: number|null;
    public enabled: boolean|null;
    public extendedPermissions: { [index:string]: string; }|null;

    public constructor(init?: Partial<UserActivations>) { (Object as any).assign(this, init); }
}
(UserActivations as unknown)[immerable] = true;

export enum InvoicingMode
{
    Off = 'Off',
    Fixed = 'Fixed',
    Flexable = 'Flexable',
}

export enum ReportingMode
{
    Off = 'Off',
    Bespoke = 'Bespoke',
    Default = 'Default',
}

export class CWBSettings
{
    public slaHours: number|null;
    public authCodeSessions: number|null;
    public clinicalDetails: boolean|null;
    public successURL: string|null;
    public hiddenFromThirdParties: boolean|null;
    public defaultNetworkId: string|null;
    public defaultServices: { [index:string]: string; }|null;
    public overridingClinicReferralCharge: { [index:string]: number; }|null;
    public onlineTitle: string|null;
    public onlineMessage: string|null;
    public onlineLogoUrl: string|null;
    public onlineEmail: string|null;
    public tempAllowFallbackToGroupCharges: boolean|null;
    public allInWeekRange: number|null;
    public confirmBooking: boolean|null;
    public sendPatientConfirmationEmail: boolean|null;
    public patientConfirmationTemplate: string|null;
    public invoicingMode: InvoicingMode|null;
    public reportingMode: ReportingMode|null;
    public sendOwnConfirmations: boolean|null;
    public referrerCurrency: string|null;
    public referralExpiryDays: number|null;

    public constructor(init?: Partial<CWBSettings>) { (Object as any).assign(this, init); }
}
(CWBSettings as unknown)[immerable] = true;

export class ClientWhoBooks implements IHasUsers
{
    public id: string|null;
    public clientID: string|null;
    public name: string|null;
    public title: string|null;
    public email: string|null;
    public description: string|null;
    public type: BookerType|null;
    public users: UserActivations[]|null;
    public settings: CWBSettings|null;
    public currentSecret: string|null;
    public previousSecret: string|null;
    public enableSignUp: boolean|null;
    public caseflowUrl: string|null;
    public isTestReferrer: boolean|null;
    public disableAppointmentLocationSelection: boolean|null;
    public canSelectStock: boolean|null;
    public receivesActivationDeActivationEmails: boolean|null;
    public linkAppointmentsToReports: boolean|null;
    public linkInvoicesToReports: boolean|null;
    public authorization: BookingAuthorization|null;
    public referencePrefix: string|null;

    public constructor(init?: Partial<ClientWhoBooks>) { (Object as any).assign(this, init); }
}
(ClientWhoBooks as unknown)[immerable] = true;

export class MyClinicLocationResponse
{
    public responseStatus: ResponseStatus|null;
    public result: LocationDto[]|null;

    public constructor(init?: Partial<MyClinicLocationResponse>) { (Object as any).assign(this, init); }
}
(MyClinicLocationResponse as unknown)[immerable] = true;

export class MyClinicPractitionerResponse
{
    public result: PractitionerDto[]|null;
    public responseStatus: ResponseStatus|null;

    public constructor(init?: Partial<MyClinicPractitionerResponse>) { (Object as any).assign(this, init); }
}
(MyClinicPractitionerResponse as unknown)[immerable] = true;

export class GroupListResult
{
    public id: number|null;
    public name: string|null;
    public globalId: string|null;
    public onlineGuid: string|null;

    public constructor(init?: Partial<GroupListResult>) { (Object as any).assign(this, init); }
}
(GroupListResult as unknown)[immerable] = true;

export class MyClinicGroupListResponse
{
    public result: GroupListResult[]|null;

    public constructor(init?: Partial<MyClinicGroupListResponse>) { (Object as any).assign(this, init); }
}
(MyClinicGroupListResponse as unknown)[immerable] = true;

export class MyClinicWhoReceivesBookingsResponse
{
    public clientWhoReceives: ClientWhoReceivesBookings|null;
    public clientsWhoBook: ClientWhoBooks[]|null;
    public locations: MyClinicLocationResponse|null;
    public practitioners: MyClinicPractitionerResponse|null;
    public groups: MyClinicGroupListResponse|null;

    public constructor(init?: Partial<MyClinicWhoReceivesBookingsResponse>) { (Object as any).assign(this, init); }
}
(MyClinicWhoReceivesBookingsResponse as unknown)[immerable] = true;

export class ProntoNetworkSettingsResponse
{
    public myClinicWhoReceivesBookings: MyClinicWhoReceivesBookingsResponse|null;
    public networks: ProntoNetworkDto[]|null;
    public stock: ProntoStockDto[]|null;
    public locations: LocationDto[]|null;
    public practitioners: PractitionerDto[]|null;
    public referrers: GroupListResult[]|null;

    public constructor(init?: Partial<ProntoNetworkSettingsResponse>) { (Object as any).assign(this, init); }
}
(ProntoNetworkSettingsResponse as unknown)[immerable] = true;

export class ClientWhoReceivesBookingsResponse extends ClientWhoReceivesBookings
{

    public constructor(init?: Partial<ClientWhoReceivesBookingsResponse>) { super(init); (Object as any).assign(this, init); }
}
(ClientWhoReceivesBookingsResponse as unknown)[immerable] = true;

export class ReportsResponse
{
    public id: string|null;
    public reportId: string|null;
    public category: string|null;
    public name: string|null;
    public isLive: boolean|null;
    public description: string|null;
    public data: string|null;
    public colour: number|null;
    public url: string|null;
    public isFavourite: boolean|null;
    public colourCss: string|null;

    public constructor(init?: Partial<ReportsResponse>) { (Object as any).assign(this, init); }
}
(ReportsResponse as unknown)[immerable] = true;

export class StockAtLocationResponse
{
    public id: number|null;
    public reference: string|null;
    public totalPrice: number|null;
    public priceExVAT: number|null;
    public vatAmount: number|null;
    public vatRate: number|null;
    public itemPrice: number|null;
    public description: string|null;
    public category: string|null;

    public constructor(init?: Partial<StockAtLocationResponse>) { (Object as any).assign(this, init); }
}
(StockAtLocationResponse as unknown)[immerable] = true;

export class StockOverride implements IHasId, IHasGlobalGuid
{
    public id: number|null;
    public stockId: number|null;
    // @Ignore()
    public stockGuid: string|null;

    public locationId: number|null;
    // @Ignore()
    public locationGuid: string|null;

    public priceExVAT: number|null;
    public totalPrice: number|null;
    public meta: { [index:string]: string; }|null;
    public globalGuid: string|null;
    public stockLevel: number|null;
    public stockMinimum: number|null;

    public constructor(init?: Partial<StockOverride>) { (Object as any).assign(this, init); }
}
(StockOverride as unknown)[immerable] = true;

export class StockListResponse
{
    public stock: StockWithLocationResponse[]|null;
    public overrides: StockOverride[]|null;

    public constructor(init?: Partial<StockListResponse>) { (Object as any).assign(this, init); }
}
(StockListResponse as unknown)[immerable] = true;

export class StockOnlineCategoryResponse
{
    public id: string|null;
    public title: string|null;

    public constructor(init?: Partial<StockOnlineCategoryResponse>) { (Object as any).assign(this, init); }
}
(StockOnlineCategoryResponse as unknown)[immerable] = true;

export class StockWithCategoryResponse
{
    public stock: StockWithLocationResponse|null;
    public category: OnlineServiceCategory|null;

    public constructor(init?: Partial<StockWithCategoryResponse>) { (Object as any).assign(this, init); }
}
(StockWithCategoryResponse as unknown)[immerable] = true;

export class SupplierResponse
{
    public id: number|null;
    public reference: string|null;
    public name: string|null;
    public contact: string|null;
    public telephone: string|null;
    public email: string|null;
    public address: string|null;
    public addressLine1: string|null;
    public addressLine2: string|null;
    public addressLine3: string|null;
    public addressLine4: string|null;
    public addressLine5: string|null;
    public postCode: string|null;
    public accountNo: string|null;
    public web: string|null;
    public locationName: string|null;
    public locationId: number|null;
    public current: boolean|null;
    public vatNumber: string|null;

    public constructor(init?: Partial<SupplierResponse>) { (Object as any).assign(this, init); }
}
(SupplierResponse as unknown)[immerable] = true;

export class AuditResponse
{
    public id: number|null;
    public objectId: number|null;
    public objectType: string|null;
    public objectTypeString: string|null;
    public action: string|null;
    public actionString: string|null;
    public actionDetail: string|null;
    public dateTime: string|null;
    public user: string|null;
    public title: string|null;
    public forename: string|null;
    public surname: string|null;
    public name: string|null;
    public oldRowData: string|null;
    public newRowData: string|null;

    public constructor(init?: Partial<AuditResponse>) { (Object as any).assign(this, init); }
}
(AuditResponse as unknown)[immerable] = true;

export class ServiceTypeResponse
{
    public id: number|null;
    public name: string|null;
    public clinicalAccessMode: AccessMode|null;
    public patientAccessMode: AccessMode|null;
    public isCurrent: boolean|null;
    public usesScores: boolean|null;
    public usesGoals: boolean|null;
    public usesImages: boolean|null;
    public labelOverrides: { [index:string]: string; }|null;
    public listOverrides: { [index:string]: string; }|null;
    public configOverrides: { [index:string]: string; }|null;
    public workflowAccessMode: AccessMode|null;
    public globalGuid: string|null;

    public constructor(init?: Partial<ServiceTypeResponse>) { (Object as any).assign(this, init); }
}
(ServiceTypeResponse as unknown)[immerable] = true;

export class ClassTypeResponse
{
    public id: number|null;
    public name: string|null;
    public description: string|null;
    public imageUrl: string|null;
    public termsAndConditionsFormId: string|null;
    public colour: number|null;
    public defaultSessionLength: number|null;
    public defaultMinAttendees: number|null;
    public defaultMaxAttendees: number|null;
    public isAvailableOnline: boolean|null;
    public cancellationChargeApplies: boolean|null;
    public cancellationHours: number|null;
    public cancellationCreditCharge: number|null;
    public isCurrent: boolean|null;
    public isCourse: boolean|null;
    public isFavourite: boolean|null;
    public lateTransferChargeApplies: boolean|null;
    public lateTransferHours: number|null;
    public allowPayPerSession: boolean|null;
    public stockId: number|null;
    public stockDesription: string|null;
    public stockPrice: number|null;
    public colourCss: string|null;
    public packages: ClassPackageResponse[]|null;
    public transferStockId: number|null;
    public cancellationStockId: number|null;
    public cancellationPrice: number|null;
    public serviceTypeId: number|null;
    public numberOfSessions: number|null;
    public isVideo: boolean|null;
    public stockCredits: number|null;
    public isPrivateCharge: boolean|null;

    public constructor(init?: Partial<ClassTypeResponse>) { (Object as any).assign(this, init); }
}
(ClassTypeResponse as unknown)[immerable] = true;

export class TagResponse
{
    public id: string|null;
    public name: string|null;
    public type: TagEntityType|null;
    public colour: string|null;
    public isActive: boolean|null;
    public isInverted: boolean|null;
    public showInLists: boolean|null;

    public constructor(init?: Partial<TagResponse>) { (Object as any).assign(this, init); }
}
(TagResponse as unknown)[immerable] = true;

export class LookupResponse
{
    public id: number|null;
    public name: string|null;
    public value: string|null;
    public niceName: string|null;
    public values: string[]|null;
    public order: number|null;

    public constructor(init?: Partial<LookupResponse>) { (Object as any).assign(this, init); }
}
(LookupResponse as unknown)[immerable] = true;

export class SecurityResponse
{
    public roleMap: { [index:number]: number; }|null;
    public roles: { [index:number]: { [index:string]: boolean; }; }|null;
    public editableServiceTypeIds: number[]|null;

    public constructor(init?: Partial<SecurityResponse>) { (Object as any).assign(this, init); }
}
(SecurityResponse as unknown)[immerable] = true;

export class NestedLookup implements IHasId, IHasGlobalGuid
{
    public id: number|null;
    public name: string|null;
    public value: string|null;
    public alternates: string[]|null;
    public groupId: number|null;
    public globalId: string|null;
    public syncToPronto: boolean|null;
    public lastSyncDate: string|null;
    public serviceTypeId: number|null;
    // @Ignore()
    public serviceTypeGuid: string|null;

    // @Ignore()
    public globalGuid: string|null;

    public constructor(init?: Partial<NestedLookup>) { (Object as any).assign(this, init); }
}
(NestedLookup as unknown)[immerable] = true;

export class DynamicLabelResponse
{
    public id: string|null;
    public languageSwitch: string|null;
    public text: string|null;
    public extraText: string|null;
    public extraTextType: string|null;

    public constructor(init?: Partial<DynamicLabelResponse>) { (Object as any).assign(this, init); }
}
(DynamicLabelResponse as unknown)[immerable] = true;

// @Route("/discountcode", "POST, PUT, DELETE")
export class DiscountCodeDto implements IReturn<DiscountCodeWithDiscountValueDto>
{
    public id: string|null;
    public code: string|null;
    public description: string|null;
    public value: number|null;
    public type: DiscountType|null;
    public validFrom: string|null;
    public validTo: string|null;
    public displayText: string|null;
    public isInUse: boolean|null;
    public enableForConnect: boolean|null;
    public enabledForAllServices: boolean|null;
    public status: DiscountStatus|null;
    public enforcePatientLimit: boolean|null;
    public limitPerPatient: number|null;

    public constructor(init?: Partial<DiscountCodeDto>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DiscountCodeDto'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new DiscountCodeWithDiscountValueDto(); }
}
(DiscountCodeDto as unknown)[immerable] = true;

export class DiscountCodeWithDiscountValueDto extends DiscountCodeDto
{
    public totalExVat: Object|null;
    public price: Object|null;
    public total: Object|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DiscountCodeWithDiscountValueDto>) { super(init); (Object as any).assign(this, init); }
}
(DiscountCodeWithDiscountValueDto as unknown)[immerable] = true;

export class CacheResponse
{
    public inventory: { [index:string]: StockWithLocationResponse; }|null;
    public locations: { [index:string]: LocationResponse; }|null;
    public customerLocations: { [index:string]: LocationResponse; }|null;
    public services: { [index:string]: ServiceTypeResponse; }|null;
    public classTypes: { [index:string]: ClassTypeResponse; }|null;
    public rooms: { [index:string]: RoomResponse; }|null;
    public groups: { [index:string]: GroupResponse; }|null;
    public tags: { [index:string]: TagResponse; }|null;
    public practitioners: { [index:string]: GeneralPractitionerResponse; }|null;
    public lookups: { [index:string]: LookupResponse; }|null;
    public permissions: SecurityResponse|null;
    public practitionerLocations: { [index:string]: PractitionerLocation; }|null;
    public suppliers: { [index:string]: SupplierResponse; }|null;
    public keys: { [index:string]: string; }|null;
    public currentUserId: string|null;
    public alphabetical: boolean|null;
    public nestedLookups: { [index:string]: NestedLookup; }|null;
    public dynamicLabels: { [index:string]: DynamicLabelResponse; }|null;
    public skills: { [index:string]: SkillResponse; }|null;
    public discountCodes: { [index:string]: DiscountCodeWithDiscountValueDto; }|null;

    public constructor(init?: Partial<CacheResponse>) { (Object as any).assign(this, init); }
}
(CacheResponse as unknown)[immerable] = true;

export class SingleCacheMapResponse<T>
{
    public version: string|null;
    public value: { [index:string]: T; }|null;

    public constructor(init?: Partial<SingleCacheMapResponse<T>>) { (Object as any).assign(this, init); }
}

export class LookupCacheResponse extends SingleCacheMapResponse<LookupResponse>
{

    public constructor(init?: Partial<LookupCacheResponse>) { super(init); (Object as any).assign(this, init); }
}
(LookupCacheResponse as unknown)[immerable] = true;

export class SystemDictionary implements IHasId, IHasGlobalGuid
{
    public id: number|null;
    public key: string|null;
    public value: string|null;
    public language: number|null;
    public visible: number|null;
    public keyID: number|null;
    public globalGuid: string|null;
    // @Ignore()
    public pluralKey: string|null;

    // @Ignore()
    public plural: string|null;

    // @Ignore()
    public possessiveKey: string|null;

    // @Ignore()
    public possessive: string|null;

    // @Ignore()
    public pluralPossessiveKey: string|null;

    // @Ignore()
    public pluralPossessive: string|null;

    public constructor(init?: Partial<SystemDictionary>) { (Object as any).assign(this, init); }
}
(SystemDictionary as unknown)[immerable] = true;

export class ExtendedNotesResponse
{
    public id: number|null;
    public type: string|null;
    public typeId: string|null;
    public typeGuid: string|null;
    public title: string|null;
    public entry: string|null;
    public lockMode: string|null;
    public lockValue: number|null;
    public lastModified: string|null;
    public date: string|null;
    public alert: boolean|null;
    public userName: string|null;
    public hidden: boolean|null;
    public serviceTypeId: number|null;
    public acknowledgementRequired: boolean|null;
    public alertStartDate: string|null;
    public alertExpiryDate: string|null;

    public constructor(init?: Partial<ExtendedNotesResponse>) { (Object as any).assign(this, init); }
}
(ExtendedNotesResponse as unknown)[immerable] = true;

export class ExtendedNotes implements IHasId
{
    public id: number|null;
    public type: string|null;
    public typeId: number|null;
    public icon: string|null;
    public colour: string|null;
    public title: string|null;
    public entry: string|null;
    public lockMode: string|null;
    public lockValue: number|null;
    public lastModified: string|null;
    public alert: boolean|null;
    public lastUserId: number|null;
    public typeGuid: string|null;
    public serviceTypeId: number|null;
    public acknowledgementRequired: boolean|null;
    public alertStartDate: string|null;
    public alertExpiryDate: string|null;
    public contextObjectType: TimelineContextObjectType|null;
    public contextId: number|null;
    public linkedObjectType: TimelineLinkedObjectType|null;
    public linkedObjectId: number|null;
    public noteType: string|null;
    public printOnDocument: boolean|null;

    public constructor(init?: Partial<ExtendedNotes>) { (Object as any).assign(this, init); }
}
(ExtendedNotes as unknown)[immerable] = true;

export class ExtendedNotesWithUserName extends ExtendedNotes
{
    public userName: string|null;
    public fullName: string|null;
    public roleLevel: string|null;
    // @Ignore()
    public hidden: boolean|null;

    public constructor(init?: Partial<ExtendedNotesWithUserName>) { super(init); (Object as any).assign(this, init); }
}
(ExtendedNotesWithUserName as unknown)[immerable] = true;

export class NestedLookupResponse
{
    public id: number|null;
    public name: string|null;
    public value: string|null;
    public alternates: string[]|null;
    public groupId: number|null;
    public globalId: string|null;
    public syncToPronto: boolean|null;
    public lastSyncDate: string|null;
    public serviceTypeId: number|null;

    public constructor(init?: Partial<NestedLookupResponse>) { (Object as any).assign(this, init); }
}
(NestedLookupResponse as unknown)[immerable] = true;

export class RegionalLookup implements IHasId, IHasGlobalGuid
{
    public id: number|null;
    public country: string|null;
    public city: string|null;
    public region: string|null;
    public globalGuid: string|null;

    public constructor(init?: Partial<RegionalLookup>) { (Object as any).assign(this, init); }
}
(RegionalLookup as unknown)[immerable] = true;

export class SecurityStat
{
    public requestName: string|null;
    public routes: string[]|null;
    public methods: string[]|null;
    public security: string[]|null;
    public implemented: boolean|null;
    public hasIReturn: boolean|null;
    public isAuthenticated: boolean|null;

    public constructor(init?: Partial<SecurityStat>) { (Object as any).assign(this, init); }
}
(SecurityStat as unknown)[immerable] = true;

export class TaskResponse
{
    public id: number|null;
    public createdDate: string|null;
    public dueDate: string|null;
    public dueTime: string|null;
    public description: string|null;
    public status: string|null;
    public userId: number|null;
    public reminder: boolean|null;
    public priority: boolean|null;
    public createdUserId: number|null;
    public dateCompleted: string|null;
    public patientId: number|null;
    public customerForename: string|null;
    public customerSurname: string|null;
    public patientName: string|null;
    public private: boolean|null;
    public tags: string[]|null;

    public constructor(init?: Partial<TaskResponse>) { (Object as any).assign(this, init); }
}
(TaskResponse as unknown)[immerable] = true;

export class UserRoleLocationWithUserName extends UserRoleLocation
{
    public userName: string|null;
    public type: string|null;
    public current: boolean|null;

    public constructor(init?: Partial<UserRoleLocationWithUserName>) { super(init); (Object as any).assign(this, init); }
}
(UserRoleLocationWithUserName as unknown)[immerable] = true;

export class ScoresGoalsSettingsResponse
{
    public id: number|null;
    public type: string|null;
    public name: string|null;
    public max: number|null;
    public min: number|null;
    public enabled: boolean|null;
    public inUse: boolean|null;

    public constructor(init?: Partial<ScoresGoalsSettingsResponse>) { (Object as any).assign(this, init); }
}
(ScoresGoalsSettingsResponse as unknown)[immerable] = true;

export class DnsInfo
{
    public valid: boolean|null;
    public type: string|null;
    public host: string|null;
    public data: string|null;

    public constructor(init?: Partial<DnsInfo>) { (Object as any).assign(this, init); }
}
(DnsInfo as unknown)[immerable] = true;

export class DomainAuthenticationStatusResponse
{
    public id: number|null;
    public user_id: number|null;
    public subdomain: string|null;
    public domain: string|null;
    public valid: boolean|null;
    public dns: { [index:string]: DnsInfo; }|null;

    public constructor(init?: Partial<DomainAuthenticationStatusResponse>) { (Object as any).assign(this, init); }
}
(DomainAuthenticationStatusResponse as unknown)[immerable] = true;

export class AuthenticateDomainResponse
{
    public id: number|null;
    public user_id: number|null;
    public subdomain: string|null;
    public domain: string|null;
    public username: string|null;

    public constructor(init?: Partial<AuthenticateDomainResponse>) { (Object as any).assign(this, init); }
}
(AuthenticateDomainResponse as unknown)[immerable] = true;

export class ValidationModel
{
    public valid: boolean|null;
    public reason: string|null;

    public constructor(init?: Partial<ValidationModel>) { (Object as any).assign(this, init); }
}
(ValidationModel as unknown)[immerable] = true;

export class ValidateDomainResponse
{
    public id: number|null;
    public valid: boolean|null;
    public validation_results: { [index:string]: ValidationModel; }|null;

    public constructor(init?: Partial<ValidateDomainResponse>) { (Object as any).assign(this, init); }
}
(ValidateDomainResponse as unknown)[immerable] = true;

// @Flags()
export enum LocationStatus
{
    Active = 0,
    ActiveViewOnly = 1,
    InactiveHidden = 2,
}

export class StockReorder
{
    public location: string|null;
    public locationStatus: LocationStatus|null;
    public stockDescription: string|null;
    public stockReference: string|null;
    public priceEXVAT: number|null;
    public vatRate: number|null;
    public vatAmount: number|null;
    public totalPrice: number|null;
    public costPrice: number|null;
    public minimumLevel: number|null;
    public currentLevel: number|null;
    public stockStatus: string|null;
    public reorder: string|null;
    public supplier: string|null;

    public constructor(init?: Partial<StockReorder>) { (Object as any).assign(this, init); }
}
(StockReorder as unknown)[immerable] = true;

export class StockSales
{
    public stockDescription: string|null;
    public stockReference: string|null;
    public priceEXVAT: number|null;
    public vatRate: number|null;
    public vatAmount: number|null;
    public totalPrice: number|null;
    public quantity: number|null;
    public chargeTotal: number|null;
    public chargeDate: string|null;
    public stockLocation: string|null;
    public ageGrouping: string|null;

    public constructor(init?: Partial<StockSales>) { (Object as any).assign(this, init); }
}
(StockSales as unknown)[immerable] = true;

export class InvoiceAnalysisReport
{
    public invoiceLocation: string|null;
    public invoiceReference: string|null;
    public accountName: string|null;
    public customerForename: string|null;
    public customerSurname: string|null;
    public accountType: string|null;
    public invoiceDate: string|null;
    public totalEXVAT: number|null;
    public vatAmount: number|null;
    public invoiceGrandTotal: number|null;
    public amountPaid: number|null;
    public remaining: number|null;
    public fullyPaidDate: string|null;
    public invoiceStatus: string|null;
    public patientsOnInvoice: string|null;
    public practitionersOnInvoice: string|null;
    public practitionerStatus: number|null;
    public locationStatus: LocationStatus|null;

    public constructor(init?: Partial<InvoiceAnalysisReport>) { (Object as any).assign(this, init); }
}
(InvoiceAnalysisReport as unknown)[immerable] = true;

export class IncomeAnalysisReport
{
    public incomeLocation: string|null;
    public practitionerStatus: number|null;
    public locationStatus: LocationStatus|null;
    public accountName: string|null;
    public customerForename: string|null;
    public customerSurname: string|null;
    public accountType: string|null;
    public incomeReference: string|null;
    public lodgementReference: string|null;
    public incomeDate: string|null;
    public incomeAmount: number|null;
    public amountUsed: number|null;
    public remaining: number|null;
    public incomeOtherPaymentMethod: string|null;
    public incomeStatus: string|null;
    public associatedInvoices: string|null;
    public associatedPractitioners: string|null;

    public constructor(init?: Partial<IncomeAnalysisReport>) { (Object as any).assign(this, init); }
}
(IncomeAnalysisReport as unknown)[immerable] = true;

export class ExpenditureMonthSummary
{
    public year: number|null;
    public monthNumber: number|null;
    public month: string|null;
    public totalExpenditure: number|null;

    public constructor(init?: Partial<ExpenditureMonthSummary>) { (Object as any).assign(this, init); }
}
(ExpenditureMonthSummary as unknown)[immerable] = true;

export class ExpenditureAnalysisReportDto
{
    public expenditureCategory: string|null;
    public expenditureOtherPaymentMethod: string|null;
    public supplierName: string|null;
    public expenditureDate: string|null;
    public expenditureReference: string|null;
    public description: string|null;
    public expenditureAmountExVAT: number|null;
    public expenditureVATRate: number|null;
    public expenditureVATAmount: number|null;
    public expenditureTotal: number|null;

    public constructor(init?: Partial<ExpenditureAnalysisReportDto>) { (Object as any).assign(this, init); }
}
(ExpenditureAnalysisReportDto as unknown)[immerable] = true;

export class AgedDebtors
{
    public accountName: string|null;
    public invoiceStatus: string|null;
    public invoiceStatusName: string|null;
    public invoiceGrandTotal: number|null;
    public invoiceAmountPaid: number|null;
    public invoiceAmountOutstanding: number|null;
    public invoiceAge: number|null;
    public ageCategory: string|null;
    public invoiceReference: string|null;
    public accountType: string|null;
    public accountAddressLine1: string|null;
    public accountAddressLine2: string|null;
    public accountAddressLine3: string|null;
    public accountAddressLine4: string|null;
    public accountAddressLine5: string|null;
    public customerAddress: string|null;
    public accountPostCode: string|null;
    public invoiceDate: string|null;
    public month: string|null;
    public year: string|null;
    public patientReference: string|null;
    public patientName: string|null;
    public customerForename: string|null;
    public customerSurname: string|null;
    public patientAge: number|null;
    public ageGrouping: string|null;
    public accountBalanceInvoiced: number|null;
    public locationName: string|null;
    public locationStatus: LocationStatus|null;
    public patientOnInvoice: string|null;

    public constructor(init?: Partial<AgedDebtors>) { (Object as any).assign(this, init); }
}
(AgedDebtors as unknown)[immerable] = true;

export class DebtorsByAccount
{
    public locationId: number|null;
    public locationStatus: LocationStatus|null;
    public accountLocation: string|null;
    public accountName: string|null;
    public invoiceStatus: string|null;
    public invoiceStatusName: string|null;
    public invoiceGrandTotal: number|null;
    public invoiceReference: string|null;
    public accountType: string|null;
    public accountTypeName: string|null;
    public accountAddressLine1: string|null;
    public accountAddressLine2: string|null;
    public accountAddressLine3: string|null;
    public accountAddressLine4: string|null;
    public accountAddressLine5: string|null;
    public customerAddress: string|null;
    public accountPostCode: string|null;
    public amountPaid: number|null;
    public invoiceDate: string|null;
    public month: string|null;
    public year: string|null;
    public patientReference: string|null;
    public patientId: number|null;
    public customerTitle: string|null;
    public customerForename: string|null;
    public customerSurname: string|null;
    public patientName: string|null;
    public accountBalanceInvoiced: number|null;
    public accountId: number|null;
    public accountDetails: string|null;
    public balanceText: string|null;
    public patientAge: number|null;
    public ageGrouping: string|null;
    public singlePatient: boolean|null;
    public invoiceAmountLeft: number|null;
    public patientOnInvoice: string|null;

    public constructor(init?: Partial<DebtorsByAccount>) { (Object as any).assign(this, init); }
}
(DebtorsByAccount as unknown)[immerable] = true;

export class DebtorsOnADate
{
    public accountID: number|null;
    public accountingDate: string|null;
    public accountingType: string|null;
    public accountType: string|null;
    public accountName: string|null;
    public accountTypeName: string|null;
    public ageGrouping: string|null;
    public daysInDebt: number|null;
    public groupID: number|null;
    public groupName: string|null;
    public incomeID: number|null;
    public incomeReference: string|null;
    public invoiceDescription: string|null;
    public invoiceID: number|null;
    public invoiceStatusOnDate: string|null;
    public itemDate: string|null;
    public date: string|null;
    public dob: string|null;
    public itemReference: string|null;
    public locationID: number|null;
    public locationName: string|null;
    public locationStatus: LocationStatus|null;
    public patientAge: number|null;
    public patientName: string|null;
    public customerForename: string|null;
    public customerSurname: string|null;
    public customerReference: string|null;
    public paymentAmount: number|null;
    public remaining: number|null;
    public total: number|null;
    public tType: string|null;

    public constructor(init?: Partial<DebtorsOnADate>) { (Object as any).assign(this, init); }
}
(DebtorsOnADate as unknown)[immerable] = true;

export class ChargesAnalysisReport
{
    public chargeLocation: string|null;
    public billingItemDate: string|null;
    public billingItemLedgerCode: string|null;
    public patientName: string|null;
    public customerID: number|null;
    public customerForename: string|null;
    public customerSurname: string|null;
    public billedTo: string|null;
    public accountType: string|null;
    public chargeDescription: string|null;
    public billingItemCategory: string|null;
    public chargeQuantity: number|null;
    public totalExVat: number|null;
    public totalVAT: number|null;
    public chargeTotal: number|null;
    public practitionerTitle: string|null;
    public practitionerForename: string|null;
    public practitionerSurname: string|null;
    public practitionerName: string|null;
    public practitionerStatus: number|null;
    public locationStatus: LocationStatus|null;
    public commissionType: string|null;
    public commissionValue: number|null;
    public stockReference: string|null;
    public invoiceReference: string|null;
    public authCode: string|null;

    public constructor(init?: Partial<ChargesAnalysisReport>) { (Object as any).assign(this, init); }
}
(ChargesAnalysisReport as unknown)[immerable] = true;

export class PractitionerAvailabilityReport
{
    public locationId: number|null;
    public location: string|null;
    public practitionerName: string|null;
    public totalSessionTime: number|null;
    public meetingDuration: number|null;
    public otherDuration: number|null;
    public holidayDuration: number|null;
    public completedAppointmentDuration: number|null;
    public cancelledAppointmentsDuration: number|null;
    public dnaAppointmentsDuration: number|null;
    public weekBeginning: string|null;
    public monthNumber: number|null;
    public year: number|null;
    public monthName: string|null;
    public actualAvailableTime: number|null;
    public completedClassesDuration: number|null;
    public diaryUtilisation: number|null;

    public constructor(init?: Partial<PractitionerAvailabilityReport>) { (Object as any).assign(this, init); }
}
(PractitionerAvailabilityReport as unknown)[immerable] = true;

export class PractitionerAvailabilityReportResponse
{
    public results: PractitionerAvailabilityReport[]|null;
    public totals: { [index:string]: number; }|null;
    public total: number|null;

    public constructor(init?: Partial<PractitionerAvailabilityReportResponse>) { (Object as any).assign(this, init); }
}
(PractitionerAvailabilityReportResponse as unknown)[immerable] = true;

export class AdmissionsAnalysisReport
{
    public admissionCode: string|null;
    public admissionDate: string|null;
    public referralDate: string|null;
    public ageGrouping: string|null;
    public bodySite: string|null;
    public customerCategory: string|null;
    public customerContact: string|null;
    public customerHomeTelephone: string|null;
    public customerWorkTelephone: string|null;
    public customerMobileTelephone: string|null;
    public customerEmail: string|null;
    public customerDateOfBirth: string|null;
    public customerId: number|null;
    public customerName: string|null;
    public medicalContact: string|null;
    public locationName: string|null;
    public contactTitle: string|null;
    public contactForename: string|null;
    public contactSurname: string|null;
    public customerTitle: string|null;
    public customerForename: string|null;
    public customerSurname: string|null;
    public diagnosisCode: string|null;
    public groupId: number|null;
    public locationId: number|null;
    public groupName: string|null;
    public id: number|null;
    public practitionerId: number|null;
    public practitionerForename: string|null;
    public practitionerSurname: string|null;
    public practitionerName: string|null;
    public practitionerTitle: string|null;
    public reference: number|null;

    public constructor(init?: Partial<AdmissionsAnalysisReport>) { (Object as any).assign(this, init); }
}
(AdmissionsAnalysisReport as unknown)[immerable] = true;

export class AverageTreatmentsReport
{
    public grouping: string|null;
    public locationId: number|null;
    public location: string|null;
    public totalCases: number|null;
    public totalTreatments: number|null;
    public averageTreatments: number|null;
    public averageDaysSpan: number|null;

    public constructor(init?: Partial<AverageTreatmentsReport>) { (Object as any).assign(this, init); }
}
(AverageTreatmentsReport as unknown)[immerable] = true;

export class AverageTreatmentsReportResponse
{
    public results: AverageTreatmentsReport[]|null;
    public total: number|null;
    public totals: { [index:string]: number; }|null;

    public constructor(init?: Partial<AverageTreatmentsReportResponse>) { (Object as any).assign(this, init); }
}
(AverageTreatmentsReportResponse as unknown)[immerable] = true;

export class CasesDueForReviewReport
{
    public locationName: string|null;
    public locationId: number|null;
    public caseReference: string|null;
    public customerReference: string|null;
    public clientName: string|null;
    public customerTitle: string|null;
    public customerForename: string|null;
    public customerSurname: string|null;
    public addressLine1: string|null;
    public postCode: string|null;
    public diagnosisCode: string|null;
    public dischargeDate: string|null;
    public reviewDate: string|null;
    public admissionDate: string|null;
    public numberOfAppointments: number|null;
    public practitionerTitle: string|null;
    public practitionerForename: string|null;
    public practitionerSurname: string|null;
    public practitionerName: string|null;
    public practitionerId: number|null;
    public customerMobileTelephone: string|null;
    public customerHomeTelephone: string|null;
    public customerWorkTelephone: string|null;
    public customerContact: string|null;

    public constructor(init?: Partial<CasesDueForReviewReport>) { (Object as any).assign(this, init); }
}
(CasesDueForReviewReport as unknown)[immerable] = true;

export class CurrentCaseLoadReport
{
    public id: number|null;
    public admissionDate: string|null;
    public addressLine1: string|null;
    public addressLine2: string|null;
    public addressLine3: string|null;
    public addressLine4: string|null;
    public addressLine5: string|null;
    public postCode: string|null;
    public diagnosisCode: string|null;
    public bodySite: string|null;
    public appointmentType: string|null;
    public customerAddress: string|null;
    public customerForename: string|null;
    public customerName: string|null;
    public customerSurname: string|null;
    public customerTitle: string|null;
    public customerEmail: string|null;
    public customerMobileTelephone: string|null;
    public customerHomeTelephone: string|null;
    public customerWorkTelephone: string|null;
    public customerContact: string|null;
    public groupName: string|null;
    public locationName: string|null;
    public locationId: number|null;
    public practitionerForename: string|null;
    public practitionerName: string|null;
    public practitionerSurname: string|null;
    public practitionerTitle: string|null;
    public practitionerId: number|null;
    public reference: string|null;
    public bookingMethod: string|null;
    public lastAppointmentDate: string|null;

    public constructor(init?: Partial<CurrentCaseLoadReport>) { (Object as any).assign(this, init); }
}
(CurrentCaseLoadReport as unknown)[immerable] = true;

export class CurrentCaseLoadReportResponse
{
    public results: CurrentCaseLoadReport[]|null;
    public total: number|null;
    public totals: { [index:string]: number; }|null;

    public constructor(init?: Partial<CurrentCaseLoadReportResponse>) { (Object as any).assign(this, init); }
}
(CurrentCaseLoadReportResponse as unknown)[immerable] = true;

export class DischargeAnalysisReport
{
    public locationId: number|null;
    public location: string|null;
    public admissionDate: string|null;
    public dischargeDate: string|null;
    public referralDate: string|null;
    public totalAppointments: string|null;
    public bodySite: string|null;
    public admissionCode: string|null;
    public diagnosisCode: string|null;
    public injuryCause: string|null;
    public dateOfBirth: string|null;
    public caseRef: string|null;
    public surname: string|null;
    public title: string|null;
    public forename: string|null;
    public customerName: string|null;
    public customerId: number|null;
    public addressLine1: string|null;
    public addressLine2: string|null;
    public addressLine3: string|null;
    public addressLine4: string|null;
    public addressLine5: string|null;
    public customerAddress: string|null;
    public mobile: string|null;
    public work: string|null;
    public home: string|null;
    public customerContact: string|null;
    public customerEmail: string|null;
    public postCode: string|null;
    public caseReferenceId: number|null;
    public groupName: string|null;
    public clientRef: string|null;
    public ageGrouping: string|null;
    public practitionerTitle: string|null;
    public practitionerForename: string|null;
    public practitionerSurname: string|null;
    public practitionerName: string|null;

    public constructor(init?: Partial<DischargeAnalysisReport>) { (Object as any).assign(this, init); }
}
(DischargeAnalysisReport as unknown)[immerable] = true;

export class DischargeAnalysisReportResponse
{
    public results: DischargeAnalysisReport[]|null;
    public totals: { [index:string]: number; }|null;

    public constructor(init?: Partial<DischargeAnalysisReportResponse>) { (Object as any).assign(this, init); }
}
(DischargeAnalysisReportResponse as unknown)[immerable] = true;

export class LapsedPatientsReport
{
    public groupName: string|null;
    public locationName: string|null;
    public locationId: number|null;
    public practitionerTitle: string|null;
    public practitionerForename: string|null;
    public practitionerSurname: string|null;
    public practitionerName: string|null;
    public practitionerId: number|null;
    public admissionDate: string|null;
    public caseReference: string|null;
    public customerId: number|null;
    public customerTitle: string|null;
    public customerForename: string|null;
    public customerSurname: string|null;
    public clientName: string|null;
    public email: string|null;
    public mobileTelephone: string|null;
    public homeTelephone: string|null;
    public workTelephone: string|null;
    public customerContact: string|null;
    public addressLine1: string|null;
    public addressLine2: string|null;
    public addressLine3: string|null;
    public addressLine4: string|null;
    public addressLine5: string|null;
    public customerReference: string|null;
    public customerAddress: string|null;
    public postCode: string|null;
    public diagnosisCode: string|null;
    public dischargeDate: string|null;
    public bodySite: string|null;
    public myProperty: number|null;
    public lastAppointment: string|null;
    public remainingAuthorisation: string|null;
    public authExpiryDate: string|null;

    public constructor(init?: Partial<LapsedPatientsReport>) { (Object as any).assign(this, init); }
}
(LapsedPatientsReport as unknown)[immerable] = true;

export class ClientAnalysisReport
{
    public registeredLocation: string|null;
    public patientReference: string|null;
    public patientName: string|null;
    public customerForename: string|null;
    public customerSurname: string|null;
    public customerEmail: string|null;
    public mobile: string|null;
    public work: string|null;
    public home: string|null;
    public customerContact: string|null;
    public gender: string|null;
    public addressLine1: string|null;
    public addressLine2: string|null;
    public addressLine3: string|null;
    public addressLine4: string|null;
    public addressLine5: string|null;
    public customerAddress: string|null;
    public patientPostCode: string|null;
    public patientDateOfBirth: string|null;
    public customerRegistrationDate: string|null;
    public ageGrouping: string|null;
    public practitionerTitle: string|null;
    public practitionerForename: string|null;
    public practitionerSurname: string|null;
    public practitionerName: string|null;
    public practitionerStatus: number|null;
    public locationStatus: LocationStatus|null;
    public patientGroup: string|null;
    public enquirySource: string|null;
    public futureBookedAppointments: number|null;
    public futureBookedAppointmentsText: string|null;
    public customerGivenConsent: boolean|null;
    public customerSMSConsent: boolean|null;
    public customerEmailConsent: boolean|null;
    public customerPhoneConsent: boolean|null;

    public constructor(init?: Partial<ClientAnalysisReport>) { (Object as any).assign(this, init); }
}
(ClientAnalysisReport as unknown)[immerable] = true;

export class ClientAnalysisResponse
{
    public results: ClientAnalysisReport[]|null;
    public totals: { [index:string]: number; }|null;

    public constructor(init?: Partial<ClientAnalysisResponse>) { (Object as any).assign(this, init); }
}
(ClientAnalysisResponse as unknown)[immerable] = true;

export class ClientBirthdayReport
{
    public registeredLocation: string|null;
    public dateOfBirth: string|null;
    public ageAsOfToday: number|null;
    public patientReference: string|null;
    public patientName: string|null;
    public customerForename: string|null;
    public customerSurname: string|null;
    public addressLine1: string|null;
    public addressLine2: string|null;
    public addressLine3: string|null;
    public addressLine4: string|null;
    public addressLine5: string|null;
    public customerAddress: string|null;
    public patientPostCode: string|null;
    public patientEmail: string|null;
    public mobile: string|null;
    public work: string|null;
    public home: string|null;
    public customerContact: string|null;
    public lastAppointmentDate: string|null;
    public locationStatus: LocationStatus|null;

    public constructor(init?: Partial<ClientBirthdayReport>) { (Object as any).assign(this, init); }
}
(ClientBirthdayReport as unknown)[immerable] = true;

export class ClientTrackingReport
{
    public ageGrouping: string|null;
    public appointmentClassification: string|null;
    public appointmentDate: string|null;
    public appointmentLocation: string|null;
    public appointmentStatus: string|null;
    public appointmentType: string|null;
    public chargeCreated: string|null;
    public chargeTotal: number|null;
    public futureAppointment: string|null;
    public futureAppointmentDate: string|null;
    public hasFutureAppointment: string|null;
    public patientName: string|null;
    public customerForename: string|null;
    public customerSurname: string|null;
    public customerID: number|null;
    public customerMobileTelephone: string|null;
    public customerHomeTelephone: string|null;
    public customerWorkTelephone: string|null;
    public customerContact: string|null;
    public customerEmail: string|null;
    public patientReference: string|null;
    public patientStatus: string|null;
    public practitioner: string|null;
    public practitionerStatus: number|null;
    public locationStatus: LocationStatus|null;
    public practitionerName: string|null;
    public stockDescription: string|null;

    public constructor(init?: Partial<ClientTrackingReport>) { (Object as any).assign(this, init); }
}
(ClientTrackingReport as unknown)[immerable] = true;

export class ClientTrackingResponse
{
    public results: ClientTrackingReport[]|null;
    public totals: { [index:string]: number; }|null;

    public constructor(init?: Partial<ClientTrackingResponse>) { (Object as any).assign(this, init); }
}
(ClientTrackingResponse as unknown)[immerable] = true;

export class ClickReferrerImagePath
{
    public name: string|null;
    public path: string|null;

    public constructor(init?: Partial<ClickReferrerImagePath>) { (Object as any).assign(this, init); }
}
(ClickReferrerImagePath as unknown)[immerable] = true;

export class QuickStartWizardGroupResponse
{
    public id: number|null;
    public name: string|null;
    public email: string|null;
    public showReferrals: boolean|null;
    public useAuthCode: boolean|null;

    public constructor(init?: Partial<QuickStartWizardGroupResponse>) { (Object as any).assign(this, init); }
}
(QuickStartWizardGroupResponse as unknown)[immerable] = true;

export class QuickStartWizardPractitionerResponse
{
    public id: number|null;
    public email: string|null;
    public title: string|null;
    public forename: string|null;
    public surname: string|null;
    public gender: string|null;
    public isActive: boolean|null;
    public mobile: string|null;
    public firstStockId: number|null;
    public followupStockId: number|null;
    public locations: number[]|null;
    public defaultLocationId: number|null;
    public name: string|null;
    public onlineGuid: string|null;

    public constructor(init?: Partial<QuickStartWizardPractitionerResponse>) { (Object as any).assign(this, init); }
}
(QuickStartWizardPractitionerResponse as unknown)[immerable] = true;

export class ServiceType implements IHasId, IHasGlobalGuid
{
    public id: number|null;
    public name: string|null;
    public isCurrent: boolean|null;
    public clinicalAccessMode: AccessMode|null;
    public patientAccessMode: AccessMode|null;
    public usesScores: boolean|null;
    public usesGoals: boolean|null;
    public usesImages: boolean|null;
    public labelOverrides: { [index:string]: string; }|null;
    public listOverrides: { [index:string]: string; }|null;
    public configOverrides: { [index:string]: string; }|null;
    public workflowAccessMode: AccessMode|null;
    public globalGuid: string|null;

    public constructor(init?: Partial<ServiceType>) { (Object as any).assign(this, init); }
}
(ServiceType as unknown)[immerable] = true;

export class QuickStartWizardGetStocksResponse
{
    public consultations: Stock[]|null;
    public cancellations: Stock[]|null;

    public constructor(init?: Partial<QuickStartWizardGetStocksResponse>) { (Object as any).assign(this, init); }
}
(QuickStartWizardGetStocksResponse as unknown)[immerable] = true;

export class QuickStartWizardStock
{
    public id: number|null;
    public appointmentLength: number|null;
    public totalPrice: number|null;
    public isFirst: boolean|null;
    public isFollowup: boolean|null;
    public description: string|null;
    public reference: string|null;

    public constructor(init?: Partial<QuickStartWizardStock>) { (Object as any).assign(this, init); }
}
(QuickStartWizardStock as unknown)[immerable] = true;

export class Template implements IHasId, IHasGlobalGuid
{
    public id: number|null;
    public name: string|null;
    public description: string|null;
    public body: string|null;
    public type: string|null;
    public lastModified: string|null;
    public globalId: string|null;
    public isReadOnly: boolean|null;
    public syncToPronto: boolean|null;
    public lastSyncDate: string|null;
    public isRemoved: boolean|null;
    public serviceTypeId: number|null;
    public format: BlockTemplateFormat|null;
    public archived: boolean|null;
    // @Ignore()
    public serviceTypeGuid: string|null;

    // @Ignore()
    public globalGuid: string|null;

    public signatureRequired: boolean|null;

    public constructor(init?: Partial<Template>) { (Object as any).assign(this, init); }
}
(Template as unknown)[immerable] = true;

export class QuickStartWizardTemplateOptionsResponse
{
    public simple: Template|null;
    public advanced: Template|null;

    public constructor(init?: Partial<QuickStartWizardTemplateOptionsResponse>) { (Object as any).assign(this, init); }
}
(QuickStartWizardTemplateOptionsResponse as unknown)[immerable] = true;

export class ProntoInvoiceTemplate
{
    public id: string|null;
    public template: string|null;
    public itemTemplate: string|null;
    public timeStamp: string|null;

    public constructor(init?: Partial<ProntoInvoiceTemplate>) { (Object as any).assign(this, init); }
}
(ProntoInvoiceTemplate as unknown)[immerable] = true;

export class ProntoNetworkService
{
    public name: string|null;
    public stockId: string|null;
    public networkServiceId: string|null;
    public discipline: string|null;
    public serviceName: string|null;

    public constructor(init?: Partial<ProntoNetworkService>) { (Object as any).assign(this, init); }
}
(ProntoNetworkService as unknown)[immerable] = true;

export class ProntoCacheResponse
{
    public invoices: { [index:string]: ProntoInvoiceTemplate; }|null;
    public services: { [index:string]: ProntoNetworkService; }|null;

    public constructor(init?: Partial<ProntoCacheResponse>) { (Object as any).assign(this, init); }
}
(ProntoCacheResponse as unknown)[immerable] = true;

export class GetClinicDetailsResponse
{
    public clinicName: string|null;
    public addressLine1: string|null;
    public addressLine2: string|null;
    public addressLine3: string|null;
    public addressLine4: string|null;
    public postCode: string|null;
    public homeTelephone: string|null;
    public category: string|null;
    public previousSystem: string|null;
    public clinicCurrencySymbol: string|null;

    public constructor(init?: Partial<GetClinicDetailsResponse>) { (Object as any).assign(this, init); }
}
(GetClinicDetailsResponse as unknown)[immerable] = true;

export class ReferrerOverrideNetworkCharge
{
    public referrerId: string|null;
    public networkId: string|null;
    public overridingClinicReferralCharge: number|null;
    public isDefaultCharge: boolean|null;

    public constructor(init?: Partial<ReferrerOverrideNetworkCharge>) { (Object as any).assign(this, init); }
}
(ReferrerOverrideNetworkCharge as unknown)[immerable] = true;

export class GetClientPaymentDetailsResponse
{
    public cardExists: boolean|null;
    public cardName: string|null;
    public lastFourDigits: string|null;
    public expiryMonth: number|null;
    public expiryYear: number|null;
    public brand: string|null;

    public constructor(init?: Partial<GetClientPaymentDetailsResponse>) { (Object as any).assign(this, init); }
}
(GetClientPaymentDetailsResponse as unknown)[immerable] = true;

export class ProntoPaymentResponse
{
    public paymentDetails: GetClientPaymentDetailsResponse|null;

    public constructor(init?: Partial<ProntoPaymentResponse>) { (Object as any).assign(this, init); }
}
(ProntoPaymentResponse as unknown)[immerable] = true;

export class ProntoRegistrationResponse
{

    public constructor(init?: Partial<ProntoRegistrationResponse>) { (Object as any).assign(this, init); }
}
(ProntoRegistrationResponse as unknown)[immerable] = true;

export class License
{
    public clientID: number|null;
    public locationId: number|null;
    public expiryDate: string|null;
    public isTM3Connect: boolean|null;
    public isEClinic: boolean|null;
    public isPPM: boolean|null;
    public isGDS: boolean|null;
    public hasClass: boolean|null;
    public hasEnterprise: boolean|null;
    public hasHealthCode: boolean|null;
    public hasMultiDiscipline: boolean|null;
    public hasMultiLocation: boolean|null;
    public hasOnlinePatientBooking: boolean|null;
    public hasPostcode: boolean|null;
    public hasReferrals: boolean|null;
    public hasRemote: boolean|null;
    public hasRoomManager: boolean|null;
    public hasRoleManager: boolean|null;
    public hasOnlineReception: boolean|null;
    public hasOnlineReferralBookings: boolean|null;
    public hasStock: boolean|null;
    public hasTouch: boolean|null;
    public hasApi: boolean|null;
    public hasApiLimit: boolean|null;
    public dailyApiLimit: number|null;
    public monthlyApiLimit: number|null;
    public maxLocations: number|null;
    public maxUsers: number|null;
    public onlinePractitioners: number|null;
    public startDate: string|null;
    public touchMaxUsers: number|null;
    public hasPatientPortalBasic: boolean|null;
    public hasPatientPortalAdvanced: boolean|null;
    public hasOnlinePatient: boolean|null;
    public practitionerLicensing: boolean|null;
    public practitioners: number|null;
    public hasWebClinicalNotes: boolean|null;
    public isCancelling: boolean|null;
    public hasCustomStripeCommission: boolean|null;
    public customStripeCommissionRate: number|null;
    public hasCustomSquareCommission: boolean|null;
    public customSquareCommissionRate: number|null;
    public isEvaluating: boolean|null;
    public isProntoPortal: boolean|null;
    public isClick: boolean|null;
    public isClickPlus: boolean|null;
    public isCaseflow: boolean|null;
    public hasCustomClearAcceptCommission: boolean|null;
    public customClearAcceptCommissionRate: number|null;
    public isTM3Essentials: boolean|null;
    public bzProduct: string|null;
    public subscription: string|null;
    public emailRateLimitPerLicense: number|null;

    public constructor(init?: Partial<License>) { (Object as any).assign(this, init); }
}
(License as unknown)[immerable] = true;

export class StartTrialResponse
{
    public license: License|null;
    public url: string|null;
    public errorMessage: string|null;

    public constructor(init?: Partial<StartTrialResponse>) { (Object as any).assign(this, init); }
}
(StartTrialResponse as unknown)[immerable] = true;

export class ConfirmClientDowngradeToProntoResponse
{
    public success: boolean|null;
    public domain: string|null;
    public url: string|null;

    public constructor(init?: Partial<ConfirmClientDowngradeToProntoResponse>) { (Object as any).assign(this, init); }
}
(ConfirmClientDowngradeToProntoResponse as unknown)[immerable] = true;

export class PrescriptionDetails
{
    public id: number|null;
    public description: string|null;
    public dosage: string|null;
    public otherInstructions: string|null;
    public deliveryType: string|null;
    public dateIssued: string|null;
    public practitionerTitle: string|null;
    public practitionerForename: string|null;
    public practitionerSurname: string|null;
    public userName: string|null;
    public userFullName: string|null;
    // @Ignore()
    public practitionerName: string|null;

    // @Ignore()
    public issuedBy: string|null;

    public constructor(init?: Partial<PrescriptionDetails>) { (Object as any).assign(this, init); }
}
(PrescriptionDetails as unknown)[immerable] = true;

export class GetPatientPrescriptionsResponse
{
    public prescriptions: PrescriptionDetails[]|null;
    public prescriptionPrintPath: string|null;

    public constructor(init?: Partial<GetPatientPrescriptionsResponse>) { (Object as any).assign(this, init); }
}
(GetPatientPrescriptionsResponse as unknown)[immerable] = true;

export class PrescriptionSummary
{
    public description: string|null;
    public createdAt: string|null;
    public prescriber: string|null;

    public constructor(init?: Partial<PrescriptionSummary>) { (Object as any).assign(this, init); }
}
(PrescriptionSummary as unknown)[immerable] = true;

export class GetPatientPrescriptionsSummaryResponse
{
    public count: number|null;
    public latest: PrescriptionSummary|null;

    public constructor(init?: Partial<GetPatientPrescriptionsSummaryResponse>) { (Object as any).assign(this, init); }
}
(GetPatientPrescriptionsSummaryResponse as unknown)[immerable] = true;

export class CreateNonRxPrescriptionsResponse
{
    public prescriptionId: number|null;
    public prescriptionPrintPath: string|null;

    public constructor(init?: Partial<CreateNonRxPrescriptionsResponse>) { (Object as any).assign(this, init); }
}
(CreateNonRxPrescriptionsResponse as unknown)[immerable] = true;

export class AddLocationResponse
{
    public currentLocations: number|null;
    public licensedLocations: number|null;
    public canAddLocation: boolean|null;

    public constructor(init?: Partial<AddLocationResponse>) { (Object as any).assign(this, init); }
}
(AddLocationResponse as unknown)[immerable] = true;

export class SignatureRxResponse
{
    public signatureRxIntegrationCode: string|null;

    public constructor(init?: Partial<SignatureRxResponse>) { (Object as any).assign(this, init); }
}
(SignatureRxResponse as unknown)[immerable] = true;

export class CreatePrescriptionResponse
{
    public isSuccess: boolean|null;
    public message: string|null;

    public constructor(init?: Partial<CreatePrescriptionResponse>) { (Object as any).assign(this, init); }
}
(CreatePrescriptionResponse as unknown)[immerable] = true;

export class ICD9
{
    public id: number|null;
    public code: string|null;
    public description: string|null;
    public globalId: string|null;

    public constructor(init?: Partial<ICD9>) { (Object as any).assign(this, init); }
}
(ICD9 as unknown)[immerable] = true;

export class JobHistoryDto
{
    public createdAt: string|null;
    public failedAt: string|null;
    public exceptionType: string|null;
    public exceptionMessage: string|null;
    public exceptionDetails: string|null;
    public state: string|null;
    public reason: string|null;

    public constructor(init?: Partial<JobHistoryDto>) { (Object as any).assign(this, init); }
}
(JobHistoryDto as unknown)[immerable] = true;

export class JobDto
{
    public createdAt: string|null;
    public cron: string|null;
    public name: string|null;
    public nextExecution: string|null;
    public lastExecution: string|null;
    public lastJobId: string|null;
    public lastRecurring: JobDto|null;
    public type: string|null;
    public state: string|null;
    public history: JobHistoryDto[]|null;

    public constructor(init?: Partial<JobDto>) { (Object as any).assign(this, init); }
}
(JobDto as unknown)[immerable] = true;

export class FormReportResponse
{
    public id: number|null;
    public globalId: string|null;
    public templateId: string|null;
    public reportData: string|null;
    public dateSent: string|null;
    public lastEdited: string|null;
    public submissionDate: string|null;
    public completionDate: string|null;
    public cancellationDate: string|null;
    public declinedDate: string|null;
    public patientId: number|null;
    public caseId: number|null;
    public name: string|null;
    public status: number|null;
    public description: string|null;
    public type: string|null;
    public body: string|null;
    public recordedBy: number|null;
    public patientSubmitted: boolean|null;
    public format: BlockTemplateFormat|null;
    public signatureRequired: boolean|null;
    public signature: string|null;
    public userFullName: string|null;

    public constructor(init?: Partial<FormReportResponse>) { (Object as any).assign(this, init); }
}
(FormReportResponse as unknown)[immerable] = true;

export class FormTemplatesResponse
{
    public id: number|null;
    public name: string|null;
    public description: string|null;
    public type: string|null;
    public body: string|null;
    public globalId: string|null;
    public used: boolean|null;
    public smsTemplate: string|null;
    public emailTemplate: string|null;
    public archived: boolean|null;
    public format: BlockTemplateFormat|null;
    public signatureRequired: boolean|null;

    public constructor(init?: Partial<FormTemplatesResponse>) { (Object as any).assign(this, init); }
}
(FormTemplatesResponse as unknown)[immerable] = true;

export class PatientReport implements IHasId
{
    public id: number|null;
    public globalId: string|null;
    public templateId: string|null;
    public reportData: string|null;
    public dateSent: string|null;
    public lastEdited: string|null;
    public submissionDate: string|null;
    public completionDate: string|null;
    public cancellationDate: string|null;
    public declinedDate: string|null;
    public patientId: number|null;
    public caseId: number|null;
    public status: number|null;
    public recordedBy: number|null;
    public notificationType: number|null;
    public signature: string|null;
    public signedBy: number|null;

    public constructor(init?: Partial<PatientReport>) { (Object as any).assign(this, init); }
}
(PatientReport as unknown)[immerable] = true;

export class ClassesResponse
{
    public weeklyClasses: { [index:string]: ClassSessionWithDetails[]; }|null;

    public constructor(init?: Partial<ClassesResponse>) { (Object as any).assign(this, init); }
}
(ClassesResponse as unknown)[immerable] = true;

export class PatientClass
{
    public sessionId: number|null;
    public name: string|null;
    public description: string|null;
    public practitionerForename: string|null;
    public practitionerSurname: string|null;
    // @Ignore()
    public practitionerName: string|null;

    public status: string|null;
    public locationName: string|null;
    public startDate: string|null;
    public endDate: string|null;

    public constructor(init?: Partial<PatientClass>) { (Object as any).assign(this, init); }
}
(PatientClass as unknown)[immerable] = true;

export class Point
{
    public x: number|null;
    public y: number|null;

    public constructor(init?: Partial<Point>) { (Object as any).assign(this, init); }
}
(Point as unknown)[immerable] = true;

export class GraphData
{
    public label: string|null;
    public values: Point[]|null;

    public constructor(init?: Partial<GraphData>) { (Object as any).assign(this, init); }
}
(GraphData as unknown)[immerable] = true;

export class PieChartSegment
{
    public label: string|null;
    public value: number|null;

    public constructor(init?: Partial<PieChartSegment>) { (Object as any).assign(this, init); }
}
(PieChartSegment as unknown)[immerable] = true;

export class PieChartData
{
    public segments: PieChartSegment[]|null;

    public constructor(init?: Partial<PieChartData>) { (Object as any).assign(this, init); }
}
(PieChartData as unknown)[immerable] = true;

export class TopClients
{
    public name: string|null;
    public type: string|null;
    public total: number|null;

    public constructor(init?: Partial<TopClients>) { (Object as any).assign(this, init); }
}
(TopClients as unknown)[immerable] = true;

export class DashboardResponse
{
    public dnas: GraphData[]|null;
    public cancellations: GraphData[]|null;
    public allAppointments: GraphData[]|null;
    public newPatients: GraphData[]|null;
    public turnover: GraphData[]|null;
    public appointmentShare: PieChartData|null;
    public newPatientByType: PieChartData|null;
    public topClients: TopClients[]|null;
    public debt: Object|null;
    public appointmentStats: Object|null;
    public dnaTotal: Object|null;

    public constructor(init?: Partial<DashboardResponse>) { (Object as any).assign(this, init); }
}
(DashboardResponse as unknown)[immerable] = true;

export class Timeline
{
    public id: number|null;
    public userId: number|null;
    public userName: string|null;
    public title: string|null;
    public body: string|null;
    public icon: string|null;
    public isPriority: boolean|null;
    public requiresAcknowledgement: boolean|null;
    public colour: string|null;
    public date: string|null;
    public type: TimelineType|null;
    public subType: string|null;
    public linkedObjectType: TimelineLinkedObjectType|null;
    public linkedObjectId: number|null;
    public contextObjectType: TimelineContextObjectType|null;
    public contextDescription: string|null;
    public contextId: number|null;
    public totalRows: number|null;
    public documentPath: string|null;
    public documentName: string|null;
    public documentFilePath: string|null;

    public constructor(init?: Partial<Timeline>) { (Object as any).assign(this, init); }
}
(Timeline as unknown)[immerable] = true;

export class OnlineConsentResponse extends OnlineConsent
{

    public constructor(init?: Partial<OnlineConsentResponse>) { super(init); (Object as any).assign(this, init); }
}
(OnlineConsentResponse as unknown)[immerable] = true;

export class ClinicalReportingFieldMap
{
    public name: string|null;
    public map: string[]|null;

    public constructor(init?: Partial<ClinicalReportingFieldMap>) { (Object as any).assign(this, init); }
}
(ClinicalReportingFieldMap as unknown)[immerable] = true;

export class ClinicalReportingFieldResponse
{
    public fields: { [index:string]: ReportingField[]; }|null;
    public mappings: { [index:string]: ClinicalReportingFieldMap; }|null;

    public constructor(init?: Partial<ClinicalReportingFieldResponse>) { (Object as any).assign(this, init); }
}
(ClinicalReportingFieldResponse as unknown)[immerable] = true;

export class ClinicalMyTemplatesResponse
{
    public id: number|null;
    public name: string|null;
    public description: string|null;
    public type: string|null;
    public body: string|null;
    public globalId: string|null;
    public used: boolean|null;
    public background: boolean|null;
    public isDefault: boolean|null;
    public isFirst: boolean|null;
    public isFollow: boolean|null;
    public isReadOnly: boolean|null;
    public serviceTypeId: number|null;
    public archived: boolean|null;
    public signatureRequired: boolean|null;

    public constructor(init?: Partial<ClinicalMyTemplatesResponse>) { (Object as any).assign(this, init); }
}
(ClinicalMyTemplatesResponse as unknown)[immerable] = true;

export class Lookup implements IHasId, IHasGlobalGuid
{
    public id: number|null;
    public name: string|null;
    public value: string|null;
    public order: number|null;
    public globalGuid: string|null;

    public constructor(init?: Partial<Lookup>) { (Object as any).assign(this, init); }
}
(Lookup as unknown)[immerable] = true;

export class ConfigResponse
{
    public id: number|null;
    public description: string|null;
    public value: string|null;

    public constructor(init?: Partial<ConfigResponse>) { (Object as any).assign(this, init); }
}
(ConfigResponse as unknown)[immerable] = true;

export class PractitionerResponse
{

    public constructor(init?: Partial<PractitionerResponse>) { (Object as any).assign(this, init); }
}
(PractitionerResponse as unknown)[immerable] = true;

export class CustomLookupResponse
{
    public id: number|null;
    public name: string|null;
    public value: string|null;
    public globalId: string|null;
    public alternates: string[]|null;
    public groupId: number|null;
    public serviceTypeId: number|null;

    public constructor(init?: Partial<CustomLookupResponse>) { (Object as any).assign(this, init); }
}
(CustomLookupResponse as unknown)[immerable] = true;

export class ClinicalTemplatesResponse
{
    public templateMappings: { [index:string]: string; }|null;
    public templates: { [index:string]: Template; }|null;

    public constructor(init?: Partial<ClinicalTemplatesResponse>) { (Object as any).assign(this, init); }
}
(ClinicalTemplatesResponse as unknown)[immerable] = true;

export class TemplateResponse
{
    public id: number|null;
    public body: string|null;
    public name: string|null;
    public archived: boolean|null;
    public isReadOnly: boolean|null;
    public signatureRequired: boolean|null;

    public constructor(init?: Partial<TemplateResponse>) { (Object as any).assign(this, init); }
}
(TemplateResponse as unknown)[immerable] = true;

export class ClickAccountPaymentsStatsResponse
{
    public unreconciledPayments: number|null;
    public partReconciledPayments: number|null;

    public constructor(init?: Partial<ClickAccountPaymentsStatsResponse>) { (Object as any).assign(this, init); }
}
(ClickAccountPaymentsStatsResponse as unknown)[immerable] = true;

export class ClickAccountInvoiceStatsResponse
{
    public unpaidInvoices: number|null;
    public partPaidInvoices: number|null;
    public accountBalance: number|null;

    public constructor(init?: Partial<ClickAccountInvoiceStatsResponse>) { (Object as any).assign(this, init); }
}
(ClickAccountInvoiceStatsResponse as unknown)[immerable] = true;

export class ClickAccountUninvoicedChargesCountResponse
{
    public uninvoicedCharges: number|null;

    public constructor(init?: Partial<ClickAccountUninvoicedChargesCountResponse>) { (Object as any).assign(this, init); }
}
(ClickAccountUninvoicedChargesCountResponse as unknown)[immerable] = true;

export class CasePrintingStats
{
    public image: number|null;
    public consultation: number|null;

    public constructor(init?: Partial<CasePrintingStats>) { (Object as any).assign(this, init); }
}
(CasePrintingStats as unknown)[immerable] = true;

export class HistoryResult
{
    public id: number|null;
    public type: string|null;
    public date: string|null;
    public data: Object|null;

    public constructor(init?: Partial<HistoryResult>) { (Object as any).assign(this, init); }
}
(HistoryResult as unknown)[immerable] = true;

export class CaseAuditDetails
{
    public auditUserName: string|null;
    public auditDate: string|null;
    public auditNotes: string|null;

    public constructor(init?: Partial<CaseAuditDetails>) { (Object as any).assign(this, init); }
}
(CaseAuditDetails as unknown)[immerable] = true;

export class CasePrintingResponse
{
    public stats: CasePrintingStats|null;
    public details: CaseWithCustomerPractitionerLocationDetails|null;
    public templates: { [index:string]: { [index:string]: string; }; }|null;
    public content: HistoryResult[]|null;
    public postCloseNotes: PostCloseNotesWithUser[]|null;
    public closedUser: string|null;
    public closedDate: string|null;
    public auditDetails: CaseAuditDetails|null;
    public scores: CasePrintingScore<ClinicalScoreEntry>[]|null;
    public goals: CasePrintingGoal<GoalEntry>[]|null;

    public constructor(init?: Partial<CasePrintingResponse>) { (Object as any).assign(this, init); }
}
(CasePrintingResponse as unknown)[immerable] = true;

export class CaseReportTemplate
{
    public type: number|null;
    public mode: string|null;
    public title: string|null;
    public template: string|null;
    public sections: string[]|null;
    public mandatoryFieldOverrides: { [index:string]: { [index:string]: boolean; }; }|null;
    public customLists: { [index:string]: { [index:string]: string; }; }|null;
    public lists: { [index:string]: NestedLookupDto; }|null;

    public constructor(init?: Partial<CaseReportTemplate>) { (Object as any).assign(this, init); }
}
(CaseReportTemplate as unknown)[immerable] = true;

export class CaseReportSectionTemplate
{
    public id: string|null;
    public name: string|null;
    public body: string|null;
    public timeStamp: string|null;
    public bookerId: string|null;

    public constructor(init?: Partial<CaseReportSectionTemplate>) { (Object as any).assign(this, init); }
}
(CaseReportSectionTemplate as unknown)[immerable] = true;

export class CaseReportSearchResponse
{
    public referralStatus: number|null;
    public bookerName: string|null;
    public bookerId: string|null;
    public treatments: HistoryResult[]|null;
    public attachments: AttachmentFile[]|null;
    public allowed: { [index:string]: string; }|null;
    public reports: { [index:string]: CaseReport; }|null;
    public templates: { [index:string]: CaseReportTemplate; }|null;
    public sections: { [index:string]: CaseReportSectionTemplate; }|null;
    public linkAppointmentsToReports: boolean|null;

    public constructor(init?: Partial<CaseReportSearchResponse>) { (Object as any).assign(this, init); }
}
(CaseReportSearchResponse as unknown)[immerable] = true;

export class CaseDashboardResponse
{
    public appointmentCount: number|null;
    public appointmentStartTime: string|null;
    public appointmentsWithoutConsultations: number|null;
    public auth: string|null;
    public bodySiteText: string|null;
    public closed: boolean|null;
    public customerId: number|null;
    public dateOfAdmission: string|null;
    public diagnosis: string|null;
    public diagnosisCode: string|null;
    public dischargeDate: string|null;
    public firstAppointmentId: number|null;
    public id: number|null;
    public incompleteNotes: boolean|null;
    public name: string|null;
    public numberOfAppointments: number|null;
    public unclosedConsultations: number|null;
    public status: number|null;
    public lastConsultationDate: string|null;

    public constructor(init?: Partial<CaseDashboardResponse>) { (Object as any).assign(this, init); }
}
(CaseDashboardResponse as unknown)[immerable] = true;

export class Alert implements IHasId
{
    public id: number|null;
    public userId: number|null;
    public createdByUserId: number|null;
    public discriminatorType: string|null;
    public objectId: number|null;
    public title: string|null;
    public notes: string|null;
    public createdDateTime: string|null;
    public startDateTime: string|null;
    public requiresAcknowledgement: boolean|null;
    public complete: boolean|null;
    public expiryDateTime: string|null;
    public diaryDateTime: string|null;
    public includeInMyWork: boolean|null;
    public forYourEyesOnly: boolean|null;
    public flagType: number|null;
    public serviceTypeId: number|null;
    // @Ignore()
    public future: boolean|null;

    public constructor(init?: Partial<Alert>) { (Object as any).assign(this, init); }
}
(Alert as unknown)[immerable] = true;

export class AutoSaveResult
{
    public flag: boolean|null;
    public alert: Alert|null;
    public question: Object|null;

    public constructor(init?: Partial<AutoSaveResult>) { (Object as any).assign(this, init); }
}
(AutoSaveResult as unknown)[immerable] = true;

export class CaseDropDownResposne
{
    public id: number|null;
    public bodySite: string|null;
    public admissionDate: string|null;
    public dischargeDate: string|null;
    public description: string|null;
    public customerId: number|null;
    public serviceTypeId: number|null;
    public locationId: number|null;

    public constructor(init?: Partial<CaseDropDownResposne>) { (Object as any).assign(this, init); }
}
(CaseDropDownResposne as unknown)[immerable] = true;

export class CustomerBackgroundResponse
{
    public id: number|null;
    public customerId: number|null;
    public data: { [index:string]: Object; }|null;
    public modifiedBy: number|null;
    public lastModified: string|null;
    public templateId: string|null;
    public userFullName: string|null;
    public highlight: { [index:string]: number[]; }|null;

    public constructor(init?: Partial<CustomerBackgroundResponse>) { (Object as any).assign(this, init); }
}
(CustomerBackgroundResponse as unknown)[immerable] = true;

export interface IPatientInfoResponse
{
    id: number|null;
    responseType: string|null;
    date: string|null;
    pinned: boolean|null;
    description: string|null;
    title: string|null;
    serviceTypeId: number|null;
    customerId: number|null;
}

export class DiagnosisCodeTempResponse
{
    public key: string|null;
    public type: string|null;
    public json: string|null;

    public constructor(init?: Partial<DiagnosisCodeTempResponse>) { (Object as any).assign(this, init); }
}
(DiagnosisCodeTempResponse as unknown)[immerable] = true;

export class AssessmentResult
{
    public id: number|null;
    public treatmentId: number|null;
    public type: string|null;
    public title: string|null;
    public notes: string|null;
    public date: string|null;

    public constructor(init?: Partial<AssessmentResult>) { (Object as any).assign(this, init); }
}
(AssessmentResult as unknown)[immerable] = true;

export class CaseConsultationItem
{
    public id: number|null;
    public title: string|null;
    public templateId: string|null;
    public date: string|null;
    public type: ConsultationItemType|null;
    public data: { [index:string]: Object; }|null;
    public highlights: { [index:string]: number[]; }|null;

    public constructor(init?: Partial<CaseConsultationItem>) { (Object as any).assign(this, init); }
}
(CaseConsultationItem as unknown)[immerable] = true;

export interface ICascade
{
    data: { [index:string]: Object; }|null;
}

export class ScoreEntryResponse
{
    public id: number|null;
    public scoreId: number|null;
    public score: number|null;
    public dateAdded: string|null;
    public patientSubmitted: boolean|null;

    public constructor(init?: Partial<ScoreEntryResponse>) { (Object as any).assign(this, init); }
}
(ScoreEntryResponse as unknown)[immerable] = true;

export class ScoreResponse implements IHasId
{
    public id: number|null;
    public title: string|null;
    public dateAdded: string|null;
    public dateCompleted: string|null;
    public caseId: number|null;
    public entries: ScoreEntryResponse[]|null;
    public min: number|null;
    public max: number|null;
    public settingId: number|null;
    public isPsfs: boolean|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ScoreResponse>) { (Object as any).assign(this, init); }
}
(ScoreResponse as unknown)[immerable] = true;

export class ScoreSearchResponse
{
    public order: string[]|null;
    public scores: { [index:string]: ScoreResponse; }|null;

    public constructor(init?: Partial<ScoreSearchResponse>) { (Object as any).assign(this, init); }
}
(ScoreSearchResponse as unknown)[immerable] = true;

export class GoalEntryResponse
{
    public id: number|null;
    public notes: string|null;
    public goalId: number|null;
    public completionPercentage: number|null;
    public dateAdded: string|null;
    public patientSubmitted: boolean|null;

    public constructor(init?: Partial<GoalEntryResponse>) { (Object as any).assign(this, init); }
}
(GoalEntryResponse as unknown)[immerable] = true;

export class GoalResponse implements IHasId
{
    public id: number|null;
    public title: string|null;
    public dateAdded: string|null;
    public dateCompleted: string|null;
    public averaged: boolean|null;
    public caseId: number|null;
    public entries: GoalEntryResponse[]|null;
    public isPsfs: boolean|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GoalResponse>) { (Object as any).assign(this, init); }
}
(GoalResponse as unknown)[immerable] = true;

export class GoalSearchResponse
{
    public order: string[]|null;
    public goals: { [index:string]: GoalResponse; }|null;

    public constructor(init?: Partial<GoalSearchResponse>) { (Object as any).assign(this, init); }
}
(GoalSearchResponse as unknown)[immerable] = true;

export class SMSBulkActionResponse
{

    public constructor(init?: Partial<SMSBulkActionResponse>) { (Object as any).assign(this, init); }
}
(SMSBulkActionResponse as unknown)[immerable] = true;

export class EmailBulkActionResponse
{

    public constructor(init?: Partial<EmailBulkActionResponse>) { (Object as any).assign(this, init); }
}
(EmailBulkActionResponse as unknown)[immerable] = true;

export class ContactBulkActionResponse
{

    public constructor(init?: Partial<ContactBulkActionResponse>) { (Object as any).assign(this, init); }
}
(ContactBulkActionResponse as unknown)[immerable] = true;

export class FormBulkActionResponse
{

    public constructor(init?: Partial<FormBulkActionResponse>) { (Object as any).assign(this, init); }
}
(FormBulkActionResponse as unknown)[immerable] = true;

export class TagBulkActionResponse
{

    public constructor(init?: Partial<TagBulkActionResponse>) { (Object as any).assign(this, init); }
}
(TagBulkActionResponse as unknown)[immerable] = true;

export class MailChimpSubscriptionBulkActionResponse
{

    public constructor(init?: Partial<MailChimpSubscriptionBulkActionResponse>) { (Object as any).assign(this, init); }
}
(MailChimpSubscriptionBulkActionResponse as unknown)[immerable] = true;

export class AutomationJob implements IHasGuidId
{
    public id: string|null;
    public createdAt: string|null;
    public dueAt: string|null;
    public executedAt: string|null;
    public isComplete: boolean|null;
    public isError: boolean|null;
    public isActive: boolean|null;
    public errorMessage: string|null;
    public hangfireJobId: string|null;
    public entityType: AutomationEventEntityType|null;
    public actionType: EventActionType|null;
    public entityId: number|null;
    public name: string|null;
    public patientName: string|null;
    public isBulkAction: boolean|null;
    public automationJobTriggerUserId: number|null;

    public constructor(init?: Partial<AutomationJob>) { (Object as any).assign(this, init); }
}
(AutomationJob as unknown)[immerable] = true;

export class WebinarResponse
{
    public id: number|null;
    public title: string|null;
    public date: string|null;
    public text: string|null;
    public src: string|null;

    public constructor(init?: Partial<WebinarResponse>) { (Object as any).assign(this, init); }
}
(WebinarResponse as unknown)[immerable] = true;

export class SimpleUser
{
    public id: number|null;
    public name: string|null;
    public fullName: string|null;
    public type: string|null;
    public globalGuid: string|null;

    public constructor(init?: Partial<SimpleUser>) { (Object as any).assign(this, init); }
}
(SimpleUser as unknown)[immerable] = true;

export class PublicKeyCredentialDescriptor
{
    public type: PublicKeyCredentialType|null;
    public id: string|null;

    public constructor(init?: Partial<PublicKeyCredentialDescriptor>) { (Object as any).assign(this, init); }
}
(PublicKeyCredentialDescriptor as unknown)[immerable] = true;

export enum UserVerificationRequirement
{
    Required = 'required',
    Preferred = 'preferred',
    Discouraged = 'discouraged',
}

export class Fido2ResponseBase
{
    public status: string|null;
    public errorMessage: string|null;

    public constructor(init?: Partial<Fido2ResponseBase>) { (Object as any).assign(this, init); }
}

export class AssertionVerificationResult extends Fido2ResponseBase
{
    public credentialId: string|null;
    public counter: number|null;

    public constructor(init?: Partial<AssertionVerificationResult>) { super(init); (Object as any).assign(this, init); }
}
(AssertionVerificationResult as unknown)[immerable] = true;

export class Fido2User
{
    public name: string|null;
    public id: string|null;
    public displayName: string|null;

    public constructor(init?: Partial<Fido2User>) { (Object as any).assign(this, init); }
}
(Fido2User as unknown)[immerable] = true;

export class AttestationVerificationSuccess extends AssertionVerificationResult
{
    public publicKey: string|null;
    public user: Fido2User|null;
    public credType: string|null;
    public aaGuid: string|null;
    public attestationCertificate: X509Certificate2|null;
    public attestationCertificateChain: X509Certificate2[]|null;

    public constructor(init?: Partial<AttestationVerificationSuccess>) { super(init); (Object as any).assign(this, init); }
}
(AttestationVerificationSuccess as unknown)[immerable] = true;

export class CredentialMakeResult extends Fido2ResponseBase
{
    public result: AttestationVerificationSuccess|null;

    public constructor(init?: Partial<CredentialMakeResult>) { super(init); (Object as any).assign(this, init); }
}

export class LicenseDetailsResponse
{
    public license: License|null;

    public constructor(init?: Partial<LicenseDetailsResponse>) { (Object as any).assign(this, init); }
}
(LicenseDetailsResponse as unknown)[immerable] = true;

export class LicenceModule
{
    public name: string|null;
    public description: string|null;
    public dependencies: LicenceModule[]|null;

    public constructor(init?: Partial<LicenceModule>) { (Object as any).assign(this, init); }
}
(LicenceModule as unknown)[immerable] = true;

export class ModularLicence
{
    public name: string|null;
    public description: string|null;
    public number: string|null;
    public type: string|null;
    public modules: LicenceModule[]|null;

    public constructor(init?: Partial<ModularLicence>) { (Object as any).assign(this, init); }
}
(ModularLicence as unknown)[immerable] = true;

export class CustomAttributeDto
{
    public id: string|null;
    public name: string|null;
    public type: string|null;
    public typeFriendlyName: string|null;

    public constructor(init?: Partial<CustomAttributeDto>) { (Object as any).assign(this, init); }
}
(CustomAttributeDto as unknown)[immerable] = true;

export class ConfigureCustomAttributeDto extends CustomAttributeDto
{
    public inUse: boolean|null;

    public constructor(init?: Partial<ConfigureCustomAttributeDto>) { super(init); (Object as any).assign(this, init); }
}
(ConfigureCustomAttributeDto as unknown)[immerable] = true;

export class GetCustomAttributeListsResponse
{
    public id: string|null;
    public niceName: string|null;
    public values: ConfigureCustomAttributeDto[]|null;

    public constructor(init?: Partial<GetCustomAttributeListsResponse>) { (Object as any).assign(this, init); }
}
(GetCustomAttributeListsResponse as unknown)[immerable] = true;

export class CustomAttributes implements IHasGuidId, IHasGlobalGuid
{
    public id: string|null;
    public name: string|null;
    public typeId: string|null;
    // @Ignore()
    public globalGuid: string|null;

    public constructor(init?: Partial<CustomAttributes>) { (Object as any).assign(this, init); }
}
(CustomAttributes as unknown)[immerable] = true;

export enum TokenStatus
{
    PotentialChange = 'PotentialChange',
    AwaitingToken = 'AwaitingToken',
    Available = 'Available',
    Expired = 'Expired',
}

export class TokenSearchResponse
{
    public id: string|null;
    public customerId: number|null;
    public pan: string|null;
    public token: string|null;
    public merchant: string|null;
    public expiryDate: string|null;
    public tokenStatus: TokenStatus|null;

    public constructor(init?: Partial<TokenSearchResponse>) { (Object as any).assign(this, init); }
}
(TokenSearchResponse as unknown)[immerable] = true;

export class TokenRegisterResponse
{
    public id: string|null;
    public customerId: number|null;
    public pan: string|null;
    public token: string|null;
    public merchant: string|null;
    public expiryDate: string|null;

    public constructor(init?: Partial<TokenRegisterResponse>) { (Object as any).assign(this, init); }
}
(TokenRegisterResponse as unknown)[immerable] = true;

export enum AppointmentBillingType
{
    None = 'None',
    CaseflowManaged = 'CaseflowManaged',
    ClinicManaged = 'ClinicManaged',
}

export class AppointmentDetailsResponse
{
    public id: number|null;
    public locationId: number|null;
    public bookingMethod: string|null;
    public bookedByName: string|null;
    public firstAppointment: boolean|null;
    public groupName: string|null;
    public authId: number|null;
    public authCode: string|null;
    public caseId: number|null;
    public casePractitionerId: number|null;
    public prontoAuditId: string|null;
    public prontoAppointmentId: string|null;
    public prontoServiceId: string|null;
    public meta: { [index:string]: Object; }|null;
    public isVideo: boolean|null;
    public videoCode: string|null;
    public discountCodeId: string|null;
    public discountCodeAppliedDate: string|null;
    public discountCodeAdvance: boolean|null;
    public videoLink: string|null;
    public videoMeetingParticipantJoinUrl: string|null;
    public videoMeetingPassword: string|null;
    public authMaxTreatments: number|null;
    public authMaxValue: number|null;
    public authValueRemaining: number|null;
    public authStartDate: string|null;
    public authExpiryDate: string|null;
    public authLeft: number|null;
    public reminderDate: string|null;
    public reminderType: string|null;
    public videoMeetingHostJoinUrl: string|null;
    public videoMeetingProvider: VideoMeetingProvider|null;
    public videoMeetingId: string|null;
    public caseReference: string|null;
    public stockId: string|null;
    public stockReference: string|null;
    public stockTotalPrice: string|null;
    public casePractitioner: string|null;
    public caseBodySite: string|null;
    public caseDateOfAdmission: string|null;
    public caseFirstAppointmentId: number|null;
    public caseNumberOfAppointments: number|null;
    public classSessionId: number|null;
    public isFirstAppointmentCase: boolean|null;
    public stockDescription: string|null;
    public batchNo: number|null;
    public startDateTime: string|null;
    public endDateTime: string|null;
    public roomId: number|null;
    public practitionerId: number|null;
    public type: string|null;
    public patient: RestrictedCustomerDetails|null;
    public name: string|null;
    public prepaymentStatus: string|null;
    public appointmentBillingType: AppointmentBillingType|null;

    public constructor(init?: Partial<AppointmentDetailsResponse>) { (Object as any).assign(this, init); }
}
(AppointmentDetailsResponse as unknown)[immerable] = true;

export class AppointmentCreateClickCaseResponse
{
    public caseId: number|null;

    public constructor(init?: Partial<AppointmentCreateClickCaseResponse>) { (Object as any).assign(this, init); }
}
(AppointmentCreateClickCaseResponse as unknown)[immerable] = true;

export class Tm3BookingAudit
{
    public id: string|null;
    public userId: number|null;
    public appointmentId: string|null;
    public appointmentStartDateTime: string|null;
    public appointmentBookingDateTime: string|null;
    public appointmentCustomerId: string|null;
    public customerReference: string|null;
    public bookingType: string|null;
    public serviceId: string|null;
    public referrerReference: string|null;
    public locationId: string|null;
    public targetId: string|null;
    public bookerId: string|null;
    public referralStatus: number|null;
    public auditClash: boolean|null;
    public triageReport: string|null;
    public initialReport: string|null;
    public rfatReport: string|null;
    public dischargeReport: string|null;
    public needsAction: boolean|null;
    public appointments: ReferralAppointment[]|null;
    public authorisations: ReferralAuthorisation[]|null;
    public serviceCharges: { [index:string]: ServiceCharge; }|null;
    public workflowId: number|null;
    public reminderSentType: number|null;
    public initialReportSubmissionDueDate: string|null;
    public firstReminderSentDate: string|null;
    public finalReminderSentDate: string|null;
    public expiredReminderSentDate: string|null;
    public referrerAlwaysRequiresAuthorisations: boolean|null;

    public constructor(init?: Partial<Tm3BookingAudit>) { (Object as any).assign(this, init); }
}
(Tm3BookingAudit as unknown)[immerable] = true;

export class AppointmentBookingInfoResponse
{
    public customer: GeneralCustomerResponse|null;
    public defaultCharge: StockResponse|null;
    public authCodes: TreatmentAuthResponse[]|null;
    public prePaid: StockResponse[]|null;
    public cases: AppointmentCaseResponse[]|null;
    public prontoBookings: Tm3BookingAudit[]|null;
    public meta: { [index:string]: Object; }|null;

    public constructor(init?: Partial<AppointmentBookingInfoResponse>) { (Object as any).assign(this, init); }
}
(AppointmentBookingInfoResponse as unknown)[immerable] = true;

export class CreateTemporaryAppointmentResponse
{
    public id: number|null;
    public backgroundJobId: string|null;

    public constructor(init?: Partial<CreateTemporaryAppointmentResponse>) { (Object as any).assign(this, init); }
}
(CreateTemporaryAppointmentResponse as unknown)[immerable] = true;

export class AppointmentPrepaidIncomeResponse
{
    public merchantReference: string|null;
    public data: { [index:string]: string; }|null;
    public paymentIntentId: string|null;
    public isPrepayment: boolean|null;

    public constructor(init?: Partial<AppointmentPrepaidIncomeResponse>) { (Object as any).assign(this, init); }
}
(AppointmentPrepaidIncomeResponse as unknown)[immerable] = true;

export class CaseAlertFlagsResponse
{
    public quickPicks: Lookup[]|null;
    public id: number|null;
    public description: string|null;
    public value: string|null;

    public constructor(init?: Partial<CaseAlertFlagsResponse>) { (Object as any).assign(this, init); }
}
(CaseAlertFlagsResponse as unknown)[immerable] = true;

export class GetAllAdvancedSearchFiltersResponse
{
    public existingFilterResults: SearchFilter[]|null;
    public searchConditions: SearchFilterCondition[]|null;

    public constructor(init?: Partial<GetAllAdvancedSearchFiltersResponse>) { (Object as any).assign(this, init); }
}
(GetAllAdvancedSearchFiltersResponse as unknown)[immerable] = true;

export class VaultSessionResponse
{
    public sessionToken: string|null;

    public constructor(init?: Partial<VaultSessionResponse>) { (Object as any).assign(this, init); }
}
(VaultSessionResponse as unknown)[immerable] = true;

export class GetInitialRegistrationSessionTokenResponse extends VaultSessionResponse
{

    public constructor(init?: Partial<GetInitialRegistrationSessionTokenResponse>) { super(init); (Object as any).assign(this, init); }
}
(GetInitialRegistrationSessionTokenResponse as unknown)[immerable] = true;

export enum TrackingCategoryStatus
{
    Active = 'Active',
    Archived = 'Archived',
    Deleted = 'Deleted',
}

export class AccountingTrackingCategory
{
    public trackingCategoryID: string|null;
    public name: string|null;
    public status: TrackingCategoryStatus|null;

    public constructor(init?: Partial<AccountingTrackingCategory>) { (Object as any).assign(this, init); }
}
(AccountingTrackingCategory as unknown)[immerable] = true;

export class AccountingSystemProviderInfo
{
    public displayName: string|null;
    public accountingSystemName: AccountingSystemProviderName|null;
    public imageUrl: string|null;
    public serviceId: string|null;

    public constructor(init?: Partial<AccountingSystemProviderInfo>) { (Object as any).assign(this, init); }
}
(AccountingSystemProviderInfo as unknown)[immerable] = true;

export class AllAccountingConfigAndSettings
{
    public accountingSettings: AccountingSettingInfo[]|null;
    public allowedAccountingIntegrations: AccountingSystemProviderInfo[]|null;

    public constructor(init?: Partial<AllAccountingConfigAndSettings>) { (Object as any).assign(this, init); }
}
(AllAccountingConfigAndSettings as unknown)[immerable] = true;

export enum AccountingPaymentType
{
    Overpayment = 'Overpayment',
    Prepayment = 'Prepayment',
    Refund = 'Refund',
}

export class IncomingAccountingPaymentResponse
{
    public accountingPaymentType: AccountingPaymentType|null;
    public paymentDate: string|null;
    public totalAmount: number|null;
    public incomingPaymentId: string|null;
    public paymentMethod: string|null;
    public invoiceAllocationAmount: number|null;
    public remainingAmount: number|null;
    public paymentStatus: string|null;

    public constructor(init?: Partial<IncomingAccountingPaymentResponse>) { (Object as any).assign(this, init); }
}
(IncomingAccountingPaymentResponse as unknown)[immerable] = true;

export enum AccountingApiSyncState
{
    Initiated = 'Initiated',
    Success = 'Success',
    Failure = 'Failure',
    RateLimit = 'RateLimit',
    PayFailure = 'PayFailure',
}

export enum InvoiceTransactionEvent
{
    None = 'None',
    NewInvoiceCreate = 'NewInvoiceCreate',
    InvoiceUpdate = 'InvoiceUpdate',
    InvoiceDelete = 'InvoiceDelete',
    InvoiceTransfer = 'InvoiceTransfer',
    InvoiceChange = 'InvoiceChange',
    UseCharge = 'UseCharge',
    CreateCharges = 'CreateCharges',
    ChargeRemove = 'ChargeRemove',
    ChargeDelete = 'ChargeDelete',
    ChargeUpdate = 'ChargeUpdate',
}

export enum PaymentTransactionEvent
{
    None = 'None',
    PaymentCreate = 'PaymentCreate',
    PaymentUpdate = 'PaymentUpdate',
    PaymentDelete = 'PaymentDelete',
    PaymentReconcile = 'PaymentReconcile',
    MultiplePaymentsPerInvoiceReconcile = 'MultiplePaymentsPerInvoiceReconcile',
    PaymentUpdateReconciliation = 'PaymentUpdateReconciliation',
    PaymentUnReconcile = 'PaymentUnReconcile',
    PaymentRefund = 'PaymentRefund',
}

export class InvoiceWithAccountingSystemInfo extends Invoice
{
    public invoiceId: number|null;
    public systemId: string|null;
    public systemName: AccountingSystemProviderName|null;
    public systemInvoiceStatus: string|null;
    public accountingSystemInvoiceId: string|null;

    public constructor(init?: Partial<InvoiceWithAccountingSystemInfo>) { super(init); (Object as any).assign(this, init); }
}
(InvoiceWithAccountingSystemInfo as unknown)[immerable] = true;

export class IncomeWithAccountingSystemInfo extends Income
{
    public incomeId: number|null;
    public systemId: string|null;
    public systemName: AccountingSystemProviderName|null;
    public accountingSystemPaymentId: string|null;
    public accountingPaymentType: AccountingPaymentType|null;
    public systemPaymentStatus: string|null;

    public constructor(init?: Partial<IncomeWithAccountingSystemInfo>) { super(init); (Object as any).assign(this, init); }
}
(IncomeWithAccountingSystemInfo as unknown)[immerable] = true;

export class BillingItemWithAccountingSystemInfo extends BillingItem
{
    public billingItemId: number|null;
    public systemId: string|null;
    public systemName: AccountingSystemProviderName|null;
    public accountingSystemLineItemId: string|null;
    public accountingSystemCreditNoteId: string|null;
    public creditNoteAllocationId: string|null;

    public constructor(init?: Partial<BillingItemWithAccountingSystemInfo>) { super(init); (Object as any).assign(this, init); }
}
(BillingItemWithAccountingSystemInfo as unknown)[immerable] = true;

export class InvoicePayment implements IHasId
{
    public id: number|null;
    public invoiceId: number|null;
    public paymentId: number|null;
    public refundId: number|null;
    public amount: number|null;
    public paymentLocationID: number|null;

    public constructor(init?: Partial<InvoicePayment>) { (Object as any).assign(this, init); }
}
(InvoicePayment as unknown)[immerable] = true;

export class IncomeWithInvoicePayment extends InvoicePayment
{
    public paymentMethod: string|null;
    public otherPaymentMethod: string|null;
    public date: string|null;
    public reference: string|null;
    public paidBy: string|null;
    public notes: string|null;
    public cardType: string|null;
    public cardNumber: string|null;
    public expiry: string|null;
    public chequeNumber: string|null;
    public migrated: boolean|null;
    public paymentAmount: number|null;
    public transferred: string|null;
    public lodgementReference: string|null;
    public merchantReference: string|null;
    public status: string|null;
    public accountingSystemInvoiceId: string|null;
    public accountingSystemPaymentId: string|null;

    public constructor(init?: Partial<IncomeWithInvoicePayment>) { super(init); (Object as any).assign(this, init); }
}
(IncomeWithInvoicePayment as unknown)[immerable] = true;

export class InvoicePaymentWithAccountingSystemInfo extends IncomeWithInvoicePayment
{
    public invoicePaymentId: number|null;
    public systemId: string|null;
    public systemName: AccountingSystemProviderName|null;
    public accountingSystemAllocationId: string|null;

    public constructor(init?: Partial<InvoicePaymentWithAccountingSystemInfo>) { super(init); (Object as any).assign(this, init); }
}
(InvoicePaymentWithAccountingSystemInfo as unknown)[immerable] = true;

export class AccountingTransactionSyncJobRequest
{
    public batchId: string|null;
    public invoiceId: number|null;
    public transferredInvoiceId: number|null;
    public invoiceEvent: InvoiceTransactionEvent|null;
    public paymentId: number|null;
    public refundPaymentId: number|null;
    public paymentEvent: PaymentTransactionEvent|null;
    public paymentType: AccountingPaymentType|null;
    public chargeIdToRemove: number|null;
    public invoicesToReconcile: number[]|null;
    public multiplePaymentsToReconcile: number[]|null;
    public invoiceToDelete: InvoiceWithAccountingSystemInfo|null;
    public paymentToDelete: IncomeWithAccountingSystemInfo|null;
    public chargeToDelete: BillingItemWithAccountingSystemInfo|null;
    public isCreditTypeBillingItem: boolean|null;
    public billingItemCategory: string|null;
    public creditNoteIdToReconcile: number|null;
    public invoicePaymentsToUnReconcile: InvoicePaymentWithAccountingSystemInfo[]|null;
    public subTransactionProcess: AccountingTransactionSyncJobRequest|null;

    public constructor(init?: Partial<AccountingTransactionSyncJobRequest>) { (Object as any).assign(this, init); }
}
(AccountingTransactionSyncJobRequest as unknown)[immerable] = true;

export class AccountingApiSyncHistory implements IHasId
{
    public id: number|null;
    public batchId: string|null;
    public syncDateTime: string|null;
    public systemName: AccountingSystemProviderName|null;
    public apiSyncState: AccountingApiSyncState|null;
    public transactionDto: AccountingTransactionSyncJobRequest|null;
    public invoiceId: number|null;
    public paymentId: number|null;
    public invoiceEvent: InvoiceTransactionEvent|null;
    public paymentEvent: PaymentTransactionEvent|null;
    public requestUrl: string|null;
    public requestDescription: string|null;
    public requestPayload: string|null;
    public requestDuration: number|null;
    public statusCode: string|null;
    public responsePayload: string|null;
    public error: string|null;

    public constructor(init?: Partial<AccountingApiSyncHistory>) { (Object as any).assign(this, init); }
}
(AccountingApiSyncHistory as unknown)[immerable] = true;

export class AccountingApiSyncHistorySearchResponse extends AccountingApiSyncHistory
{

    public constructor(init?: Partial<AccountingApiSyncHistorySearchResponse>) { super(init); (Object as any).assign(this, init); }
}
(AccountingApiSyncHistorySearchResponse as unknown)[immerable] = true;

export class PhioConfigResponse
{
    public baseUrl: string|null;
    public accountName: string|null;
    public email: string|null;

    public constructor(init?: Partial<PhioConfigResponse>) { (Object as any).assign(this, init); }
}
(PhioConfigResponse as unknown)[immerable] = true;

export class SubscriptionResponse
{
    public id: number|null;
    public status: SubscriptionStatus|null;
    public startDate: string|null;
    public expiryDate: string|null;
    public name: string|null;
    public packageId: string|null;
    public totalExVat: number|null;
    public vatRate: number|null;
    public totalIncVat: number|null;
    public locationId: number|null;
    public locationName: string|null;
    public practitionerForename: string|null;
    public practitionerSurname: string|null;
    public practitionerName: string|null;
    public customerForename: string|null;
    public customerSurname: string|null;
    public customerName: string|null;
    public customer: CustomerLiteDto|null;
    public practitionerId: number|null;
    public nextDue: string|null;
    public subscriptionInterval: number|null;
    public subscriptionIntervalUnit: SubscriptionRecurrenceInterval|null;
    public earliestAllowedCancellationDate: string|null;
    public lastRunOn: string|null;
    public bundles: PackageBundleResponse[]|null;
    public customerId: number|null;
    public invoiceStatus: string|null;
    public invoiceStatusText: string|null;

    public constructor(init?: Partial<SubscriptionResponse>) { (Object as any).assign(this, init); }
}
(SubscriptionResponse as unknown)[immerable] = true;

export class SubscriptionHistoryResponse
{
    public billingItemItemId: number|null;
    public billingItemTotal: number|null;
    public invoiceId: number|null;
    public invoiceStatus: string|null;
    public paymentMethod: string|null;
    public billingItemDate: string|null;
    public invoiceDate: string|null;
    public fullyPaidDate: string|null;
    public invoiceReference: string|null;
    public invoiceStatusName: string|null;

    public constructor(init?: Partial<SubscriptionHistoryResponse>) { (Object as any).assign(this, init); }
}
(SubscriptionHistoryResponse as unknown)[immerable] = true;

export class SquareOAuthResponse
{
    public success: boolean|null;
    public errorMessage: string|null;

    public constructor(init?: Partial<SquareOAuthResponse>) { (Object as any).assign(this, init); }
}
(SquareOAuthResponse as unknown)[immerable] = true;

export class SquareOAuthPermissionsResponse
{
    public permissions: string[]|null;

    public constructor(init?: Partial<SquareOAuthPermissionsResponse>) { (Object as any).assign(this, init); }
}
(SquareOAuthPermissionsResponse as unknown)[immerable] = true;

export class BasicCardDetailsResponse
{
    public cardExists: boolean|null;
    public last4: string|null;

    public constructor(init?: Partial<BasicCardDetailsResponse>) { (Object as any).assign(this, init); }
}
(BasicCardDetailsResponse as unknown)[immerable] = true;

export class FullCardDetailsResponse extends CardDetails
{
    public cardExists: boolean|null;

    public constructor(init?: Partial<FullCardDetailsResponse>) { super(init); (Object as any).assign(this, init); }
}
(FullCardDetailsResponse as unknown)[immerable] = true;

export class DeleteCardDetailsResponse
{
    public success: boolean|null;

    public constructor(init?: Partial<DeleteCardDetailsResponse>) { (Object as any).assign(this, init); }
}
(DeleteCardDetailsResponse as unknown)[immerable] = true;

export class ExcludedStockInfo
{
    public stockId: number|null;
    public classTypeId: number|null;
    public packageId: string|null;
    public name: string|null;
    public onlineId: string|null;

    public constructor(init?: Partial<ExcludedStockInfo>) { (Object as any).assign(this, init); }
}
(ExcludedStockInfo as unknown)[immerable] = true;

export class PackageResponseBase
{
    public id: number|null;
    public reference: string|null;
    public totalPrice: number|null;
    public description: string|null;
    public appointmentLength: number|null;
    public groupLocationLocationId: number|null;
    public locationId: number|null;
    public colour: number|null;
    public online: boolean|null;
    public onlineGuid: string|null;
    public inUse: boolean|null;
    public priceExVAT: number|null;
    public vatRate: number|null;
    public vatAmount: number|null;
    public costAmount: number|null;
    public costVATRate: number|null;
    public costExVAT: number|null;
    public costVATAmount: number|null;
    public longDescription: string|null;
    public ledgerCode: string|null;
    public category: string|null;
    public level: number|null;
    public minimumLevel: number|null;
    public displayInPriceList: boolean|null;
    public totalWorth: number|null;
    public supplierId: number|null;
    public serviceTypeId: number|null;
    public isPrivateCharge: boolean|null;
    public stockIsCancel: boolean|null;
    public stockIsFirst: boolean|null;
    public stockIsFollowUp: boolean|null;
    public stockIsDNA: boolean|null;
    public isMultiple: boolean|null;
    public groupName: string|null;
    public overrides: StockOverrideResponse[]|null;
    public colourCss: string|null;
    public validForDaysFromPurchase: number|null;
    public isSubscriptionType: boolean|null;
    public subscriptionInterval: number|null;
    public subscriptionIntervalUnit: SubscriptionRecurrenceInterval|null;
    public hasMinimumTerm: boolean|null;
    public minimumTermValue: number|null;
    public minimumTermInterval: number|null;
    public minimumTermIntervalUnit: SubscriptionRecurrenceInterval|null;
    public hasMaximumTerm: boolean|null;
    public maximumTermValue: number|null;
    public maximumTermInterval: number|null;
    public maximumTermIntervalUnit: SubscriptionRecurrenceInterval|null;
    public onePerCustomer: boolean|null;
    public newCustomersOnly: boolean|null;
    public allowDiscountCodes: boolean|null;
    public hasValidityPeriod: boolean|null;
    public validFrom: string|null;
    public validTo: string|null;
    public termsAndConditionsFormId: string|null;
    public updateExistingSubscriptionsToUseNewBundles: boolean|null;
    public urlSlug: string|null;
    public imageName: string|null;
    public ledgerCodeOverrides: AccountingStockLedgerLookup[]|null;
    public legderCodeAccountId: string|null;
    public creditAmount: number|null;
    public packageType: PackageType|null;
    public excludedStock: ExcludedStockInfo[]|null;
    public excludedClasses: ExcludedStockInfo[]|null;
    public allExcludedClassNames: string[]|null;
    public restrictToPrivateCharges: boolean|null;

    public constructor(init?: Partial<PackageResponseBase>) { (Object as any).assign(this, init); }
}
(PackageResponseBase as unknown)[immerable] = true;

export class PackageResponse extends PackageResponseBase implements IPrivateOnlyCharge
{
    public bundles: PackageBundleResponse[]|null;
    public expirationValue: number|null;
    public quantityThreshold: number|null;
    public used: number|null;

    public constructor(init?: Partial<PackageResponse>) { super(init); (Object as any).assign(this, init); }
}
(PackageResponse as unknown)[immerable] = true;

export class OnlineAppointmentHistoryResult
{
    public appointmentId: number|null;
    public classAttendanceId: number|null;
    public isCourse: number|null;
    public startDateTime: string|null;
    public endDateTime: string|null;
    public status: number|null;
    public locationName: string|null;
    public onlineGuid: string|null;
    public locationGuid: string|null;
    public title: string|null;
    public forename: string|null;
    public surname: string|null;
    public practitionerName: string|null;
    public totalPrice: number|null;
    public overridePrice: number|null;
    public name: string|null;
    public type: string|null;
    public day: number|null;
    public prePaidId: number|null;
    public serviceId: string|null;
    public canCancel: boolean|null;
    public videoMeetingProvider: VideoMeetingProvider|null;
    public videoMeetingParticipantJoinUrl: string|null;
    public isVideo: boolean|null;
    public videoCode: string|null;
    public isCaseflow: boolean|null;
    // @Ignore()
    public isConnectService: boolean|null;

    public bookingMethod: string|null;
    public billingItemId: number|null;

    public constructor(init?: Partial<OnlineAppointmentHistoryResult>) { (Object as any).assign(this, init); }
}
(OnlineAppointmentHistoryResult as unknown)[immerable] = true;

export class ClassAttendanceResponse
{
    public id: number|null;
    public attendeeId: number|null;
    public hasAttended: boolean|null;
    public dna: boolean|null;
    public hasBilled: boolean|null;
    public hasPaid: boolean|null;
    public sessionId: number|null;
    public invoiceId: number|null;
    public invoiceStatus: string|null;
    public billingItemId: number|null;
    public prePaidId: number|null;
    public prePaymentIncomeId: number|null;
    public customer: CustomerLiteDto|null;
    public customerId: number|null;
    public customerForename: string|null;
    public customerSurname: string|null;
    public customerName: string|null;
    public treatmentId: number|null;
    public treatmentClosed: boolean|null;
    public caseClosed: boolean|null;
    public treatmentClosedDate: string|null;
    public caseClosedDate: string|null;
    public isTemp: boolean|null;
    public bookingMethod: string|null;
    public hasCreditAvailable: boolean|null;
    public customerEmail: string|null;
    public customerMobileTelephone: string|null;
    public customerSMSEnabled: boolean|null;
    public canCommunicate: boolean|null;
    public isCancelled: boolean|null;
    public classTypeId: number|null;
    public owesCredit: boolean|null;

    public constructor(init?: Partial<ClassAttendanceResponse>) { (Object as any).assign(this, init); }
}
(ClassAttendanceResponse as unknown)[immerable] = true;

export class WaitingListWithDetails extends WaitingList
{
    public stockDescription: string|null;
    public appointmentLength: number|null;
    public onlineGuid: string|null;
    public classTypeName: string|null;
    public startDateTime: string|null;
    public endDateTime: string|null;
    public appointmentStatus: number|null;
    public customerTitle: string|null;
    public customerForename: string|null;
    public customerSurname: string|null;
    public customerName: string|null;
    public mobileTelephone: string|null;
    public email: string|null;
    public smsEnabled: boolean|null;
    public canCommunicate: boolean|null;
    public appointmentId: number|null;

    public constructor(init?: Partial<WaitingListWithDetails>) { super(init); (Object as any).assign(this, init); }
}
(WaitingListWithDetails as unknown)[immerable] = true;

export class ClassSessionBaseResponse
{
    public id: number|null;
    public courseId: number|null;
    public startDateTime: string|null;
    public endDateTime: string|null;
    public appointmentId: number|null;
    public classTypeId: number|null;
    public locationName: string|null;
    public roomName: string|null;
    public locationId: number|null;
    public roomId: number|null;
    public practitionerId: number|null;
    public gender: string|null;
    public practitionerOnlineGuid: string|null;
    public minAttendees: number|null;
    public maxAttendees: number|null;
    public isAvailableOnline: boolean|null;
    public type: ClassTypeResponse|null;
    public attendance: ClassAttendanceResponse[]|null;
    public cancelled: ClassAttendanceResponse[]|null;
    public enrolledCustomerIds: number[]|null;
    public waitingListEnrolled: WaitingListWithDetails[]|null;
    public appointmentStatus: number|null;
    public practitionerTitle: string|null;
    public practitionerForename: string|null;
    public practitionerSurname: string|null;
    public practitionerName: string|null;
    public isVideo: boolean|null;
    public videoMeetingParticipantJoinUrl: string|null;
    public videoMeetingHostJoinUrl: string|null;
    public videoMeetingProvider: VideoMeetingProvider|null;

    public constructor(init?: Partial<ClassSessionBaseResponse>) { (Object as any).assign(this, init); }
}
(ClassSessionBaseResponse as unknown)[immerable] = true;

export class CourseAttendeeResponse
{
    public id: number|null;
    public customerId: number|null;
    public name: string|null;
    public hasBilled: boolean|null;
    public hasPaid: boolean|null;
    public courseId: number|null;
    public courseSessionId: number|null;
    public invoiceId: number|null;
    public billingItemId: number|null;
    public prePaidId: number|null;
    public invoiceStatus: string|null;
    public customerForename: string|null;
    public customerSurname: string|null;
    public customerName: string|null;
    public customerEmail: string|null;
    public customerMobileTelephone: string|null;
    public customerSMSEnabled: boolean|null;
    public canCommunicate: boolean|null;

    public constructor(init?: Partial<CourseAttendeeResponse>) { (Object as any).assign(this, init); }
}
(CourseAttendeeResponse as unknown)[immerable] = true;

export class CourseResponse
{
    public id: number|null;
    public online: boolean|null;
    public startDate: string|null;
    public type: ClassTypeResponse|null;
    public sessions: ClassSessionBaseResponse[]|null;
    public courseAttendees: CourseAttendeeResponse[]|null;
    public totalAttendance: number|null;
    public waitingListEnrolled: WaitingListWithDetails[]|null;
    public locationName: string|null;
    public roomName: string|null;
    public locationId: number|null;
    public practitionerId: number|null;
    public roomId: number|null;
    public minAttendees: number|null;
    public maxAttendees: number|null;
    public locationGuid: string|null;
    public classTypeId: number|null;
    public practitionerName: string|null;

    public constructor(init?: Partial<CourseResponse>) { (Object as any).assign(this, init); }
}
(CourseResponse as unknown)[immerable] = true;

export class WaitingListResponse
{
    public lists: { [index:string]: WaitingListWithDetails[]; }|null;

    public constructor(init?: Partial<WaitingListResponse>) { (Object as any).assign(this, init); }
}
(WaitingListResponse as unknown)[immerable] = true;

export class OnlineLocationDto
{
    public id: number|null;
    public name: string|null;
    public addressLine1: string|null;
    public addressLine2: string|null;
    public addressLine3: string|null;
    public addressLine4: string|null;
    public addressLine5: string|null;
    public postCode: string|null;
    public address: string|null;
    public telephone: string|null;
    public email: string|null;
    public web: string|null;
    public fax: string|null;
    public status: number|null;
    public onlineGuid: string|null;
    public facilities: string|null;
    public locationLat: number|null;
    public locationLong: number|null;
    public latLong: number[]|null;
    public hasCoordinates: boolean|null;
    public isMainLocation: boolean|null;
    public merchantReference: string|null;

    public constructor(init?: Partial<OnlineLocationDto>) { (Object as any).assign(this, init); }
}
(OnlineLocationDto as unknown)[immerable] = true;

export class OnlineWorkflowCaseDetails
{
    public id: number|null;
    public maxTreatments: number|null;
    public usedTreatments: number|null;
    public groupId: number|null;
    public creationDate: string|null;
    public locationId: string|null;
    public productId: string|null;
    public productServiceId: string|null;
    public capturePointServiceId: string|null;
    public connectServiceId: string|null;
    public isFollowUp: boolean|null;
    public code: string|null;
    public canBook: boolean|null;
    public canBookFirstAppointment: boolean|null;

    public constructor(init?: Partial<OnlineWorkflowCaseDetails>) { (Object as any).assign(this, init); }
}
(OnlineWorkflowCaseDetails as unknown)[immerable] = true;

export class BusinessCategoryResponse
{
    public isMatch: boolean|null;
    public reason: string|null;
    public categories: OnlineServiceCategory[]|null;
    public services: OnlineClinicService[]|null;

    public constructor(init?: Partial<BusinessCategoryResponse>) { (Object as any).assign(this, init); }
}
(BusinessCategoryResponse as unknown)[immerable] = true;

export class MyDiaryResponse
{
    public appointments: OnlineAppointmentHistoryResult[]|null;
    public classes: OnlineAppointmentHistoryResult[]|null;
    public courses: CourseResponse[]|null;
    public waitingLists: WaitingListResponse|null;
    public additionalLocations: OnlineLocationDto[]|null;
    public workflowCases: OnlineWorkflowCaseDetails[]|null;
    public customerId: number|null;
    public services: BusinessCategoryResponse|null;

    public constructor(init?: Partial<MyDiaryResponse>) { (Object as any).assign(this, init); }
}
(MyDiaryResponse as unknown)[immerable] = true;

export class AppointmentSummary
{
    public startDateTime: string|null;
    public endDateTime: string|null;
    public locationName: string|null;
    public locationAddress1: string|null;
    public locationAddress2: string|null;
    public locationEmail: string|null;
    public email: string|null;
    public reference: string|null;
    public practitionerId: number|null;
    public locationId: number|null;
    public id: number|null;
    public mobileNumber: string|null;
    public customerId: number|null;
    public smsEnabled: boolean|null;
    public status: number|null;
    public stockId: number|null;
    public isNetworkBooking: boolean|null;

    public constructor(init?: Partial<AppointmentSummary>) { (Object as any).assign(this, init); }
}
(AppointmentSummary as unknown)[immerable] = true;

export class OnlinePatientFormResponse
{
    public lookups: LookupResponse[]|null;
    public nestedLists: NestedLookup[]|null;
    public id: number|null;
    public globalId: string|null;
    public templateId: string|null;
    public reportData: string|null;
    public submissionDate: string|null;
    public completionDate: string|null;
    public lastEditedDate: string|null;
    public lastEdited: string|null;
    public patientId: number|null;
    public caseId: number|null;
    public status: number|null;
    public templateName: string|null;
    public templateDescription: string|null;
    public templateBody: string|null;
    public templateType: string|null;
    public psfs: Psfs[]|null;
    public templateFormat: BlockTemplateFormat|null;

    public constructor(init?: Partial<OnlinePatientFormResponse>) { (Object as any).assign(this, init); }
}
(OnlinePatientFormResponse as unknown)[immerable] = true;

export class OnlineCancellationOptions
{
    public chargeApplies: boolean|null;
    public isPrePaid: boolean|null;
    public isCreditBasedPackage: boolean|null;
    public prePaidId: number|null;
    public totalPaid: number|null;
    public cancellationCreditCharge: number|null;
    public cancellationCharge: number|null;
    public cancellationChargeExVat: number|null;
    public stockId: number|null;

    public constructor(init?: Partial<OnlineCancellationOptions>) { (Object as any).assign(this, init); }
}
(OnlineCancellationOptions as unknown)[immerable] = true;

export class OnlineCancellationOptionsResponse
{
    public cancellationOptions: OnlineCancellationOptions|null;
    public cardDetails: CardDetails|null;
    public cancellationReasons: string[]|null;

    public constructor(init?: Partial<OnlineCancellationOptionsResponse>) { (Object as any).assign(this, init); }
}
(OnlineCancellationOptionsResponse as unknown)[immerable] = true;

export class OnlineInvoiceBillingItem
{
    public itemPrice: number|null;
    public description: string|null;

    public constructor(init?: Partial<OnlineInvoiceBillingItem>) { (Object as any).assign(this, init); }
}
(OnlineInvoiceBillingItem as unknown)[immerable] = true;

export class OnlineInvoice
{
    public id: number|null;
    public price: number|null;
    public date: string|null;
    public location: string|null;
    public addressLine1: string|null;
    public addressLine2: string|null;
    public addressLine3: string|null;
    public addressLine4: string|null;
    public postCode: string|null;
    public isReceipt: boolean|null;
    public items: OnlineInvoiceBillingItem[]|null;

    public constructor(init?: Partial<OnlineInvoice>) { (Object as any).assign(this, init); }
}
(OnlineInvoice as unknown)[immerable] = true;

export class OnlineInvoiceListResponse
{
    public receipts: OnlineInvoice[]|null;

    public constructor(init?: Partial<OnlineInvoiceListResponse>) { (Object as any).assign(this, init); }
}
(OnlineInvoiceListResponse as unknown)[immerable] = true;

export class CreditBasedPackagePrePaidInfo extends PrePaid implements IPrivateOnlyCharge
{
    public stockOnlineGuid: string|null;
    public restrictToPrivateCharges: boolean|null;
    public excludedClassTypes: ExcludedStockInfo[]|null;
    public excludedStock: ExcludedStockInfo[]|null;
    public packageName: string|null;

    public constructor(init?: Partial<CreditBasedPackagePrePaidInfo>) { super(init); (Object as any).assign(this, init); }
}
(CreditBasedPackagePrePaidInfo as unknown)[immerable] = true;

export class OnlinePaymentDetailsResponse
{
    public cardDetails: CardDetails|null;
    public packages: PackageResponse[]|null;
    public creditBasedPackagesAvailable: CreditBasedPackagePrePaidInfo[]|null;
    public hasCredit: boolean|null;
    public creditsAvailable: number|null;
    public hasPrePaid: boolean|null;
    public hasFutureCredit: boolean|null;
    public stockCreditValue: number|null;

    public constructor(init?: Partial<OnlinePaymentDetailsResponse>) { (Object as any).assign(this, init); }
}
(OnlinePaymentDetailsResponse as unknown)[immerable] = true;

export class PackageBundleStatusResponse
{
    public quantity: number|null;
    public used: number|null;
    public total: number|null;
    public type: PackageBundleItemType|null;
    public items: PackageBundleItemResponse[]|null;
    public packageId: string|null;

    public constructor(init?: Partial<PackageBundleStatusResponse>) { (Object as any).assign(this, init); }
}
(PackageBundleStatusResponse as unknown)[immerable] = true;

export class CustomerPackagesResponse
{
    public id: string|null;
    public imageName: string|null;
    public colour: number|null;
    public colourCss: string|null;
    public description: string|null;
    public totalPrice: number|null;
    public bundles: PackageBundleStatusResponse[]|null;
    public expiryDate: string|null;
    public isSubscription: boolean|null;
    public prePaidId: number|null;
    public billingItemId: number|null;
    public urlSlug: string|null;
    public status: PrePaidStatus|null;
    public validForDaysFromPurchase: number|null;
    public packageType: PackageType|null;
    public creditAmount: number|null;
    public creditsUsed: number|null;
    public excludedStock: ExcludedStockInfo[]|null;
    public excludedClasses: ExcludedStockInfo[]|null;
    public allExcludedClassNames: string[]|null;

    public constructor(init?: Partial<CustomerPackagesResponse>) { (Object as any).assign(this, init); }
}
(CustomerPackagesResponse as unknown)[immerable] = true;

export class CustomerSubscriptionResponse extends CustomerPackagesResponse
{
    public subscriptionId: number|null;
    public ableToCancel: boolean|null;
    public subscriptionStatus: SubscriptionStatus|null;
    public subscriptionInterval: number|null;
    public earliestAllowedCancellationDate: string|null;
    public subscriptionIntervalUnit: SubscriptionRecurrenceInterval|null;

    public constructor(init?: Partial<CustomerSubscriptionResponse>) { super(init); (Object as any).assign(this, init); }
}
(CustomerSubscriptionResponse as unknown)[immerable] = true;

export class OnlineMyPackagesResponse
{
    public packages: CustomerPackagesResponse[]|null;
    public subscriptions: CustomerSubscriptionResponse[]|null;

    public constructor(init?: Partial<OnlineMyPackagesResponse>) { (Object as any).assign(this, init); }
}
(OnlineMyPackagesResponse as unknown)[immerable] = true;

export class BuyPackageResponse
{
    public success: boolean|null;

    public constructor(init?: Partial<BuyPackageResponse>) { (Object as any).assign(this, init); }
}
(BuyPackageResponse as unknown)[immerable] = true;

export class ToursModel
{
    public homeScreenTour1: boolean|null;
    public diaryWorkingTimeTour1: boolean|null;
    public diaryCreateTour1: boolean|null;
    public diaryEditTour1: boolean|null;
    public diaryCompleteTour1: boolean|null;
    public diaryEventTour1: boolean|null;
    public invoiceWizardTour1: boolean|null;
    public licenseAgreement: boolean|null;
    public previewNewUx: boolean|null;
    public licenseAgreement0419: boolean|null;
    public seenWelcomeScreen: boolean|null;

    public constructor(init?: Partial<ToursModel>) { (Object as any).assign(this, init); }
}
(ToursModel as unknown)[immerable] = true;

export class User implements IHasId, IHasGlobalGuid
{
    public id: number|null;
    public name: string|null;
    public fullName: string|null;
    public current: boolean|null;
    public temporaryPassword: string|null;
    public migrated: boolean|null;
    public email: string|null;
    public online: boolean|null;
    public type: string|null;
    public typeId: number|null;
    public salt: string|null;
    public passwordHash: string|null;
    public locationId: number|null;
    // @Ignore()
    public locationGuid: string|null;

    public practitionerId: number|null;
    // @Ignore()
    public practitionerGuid: string|null;

    public position: string|null;
    public mobileNumber: string|null;
    public permissionId: number|null;
    // @Ignore()
    public permissionGuid: string|null;

    public passwordScore: number|null;
    public passwordExpiry: string|null;
    public tours: ToursModel|null;
    public saltBytes: string|null;
    public version: number|null;
    public status: number|null;
    // @Ignore()
    public onlineGuid: string|null;

    public globalGuid: string|null;
    public level: string|null;
    public verified: boolean|null;
    public avatar: string|null;
    public firstName: string|null;
    public lastName: string|null;
    public twoFactorSecret: string|null;
    public signatureRxIntegrationCode: string|null;
    public pinHash: string|null;
    public signature: string|null;

    public constructor(init?: Partial<User>) { (Object as any).assign(this, init); }
}
(User as unknown)[immerable] = true;

export class OnlineReportTemplateItem
{
    public id: string|null;
    public body: string|null;
    public name: string|null;
    public serviceTypeId: number|null;

    public constructor(init?: Partial<OnlineReportTemplateItem>) { (Object as any).assign(this, init); }
}
(OnlineReportTemplateItem as unknown)[immerable] = true;

export class CaseflowTemplate
{
    public id: string|null;
    public name: string|null;
    public type: string|null;
    public groupGlobalId: string|null;
    public isActive: boolean|null;
    public isRemoved: boolean|null;
    public mandatoryFieldOverrides: { [index:string]: { [index:string]: boolean; }; }|null;
    public labelOverrides: { [index:string]: { [index:string]: string; }; }|null;
    public customLists: { [index:string]: { [index:string]: string; }; }|null;
    public sections: OnlineReportTemplateItem[]|null;
    public saveSections: string[]|null;
    public lists: { [index:string]: NestedLookup; }|null;
    public allowsAttachments: boolean|null;
    public requiresAttachment: boolean|null;
    public attachmentPromptText: string|null;
    public serviceTypeId: string|null;

    public constructor(init?: Partial<CaseflowTemplate>) { (Object as any).assign(this, init); }
}
(CaseflowTemplate as unknown)[immerable] = true;

export class OnlineCaseflowFormResponse
{
    public lookups: LookupResponse[]|null;
    public nestedLists: NestedLookup[]|null;
    public productId: string|null;
    public template: CaseflowTemplate|null;

    public constructor(init?: Partial<OnlineCaseflowFormResponse>) { (Object as any).assign(this, init); }
}
(OnlineCaseflowFormResponse as unknown)[immerable] = true;

export enum WorkflowContactType
{
    Patient = 'Patient',
    Contact = 'Contact',
    GroupContact = 'GroupContact',
    NetworkLocation = 'NetworkLocation',
    NetworkClinician = 'NetworkClinician',
    Practitioner = 'Practitioner',
    Location = 'Location',
    Group = 'Group',
}

export class OnlineRole
{
    public id: string|null;
    public role: WorkflowContactType|null;
    public name: string|null;
    public stream: string|null;
    public canRefer: boolean|null;
    public isFinancial: boolean|null;
    public isAdministrative: boolean|null;
    public isClinical: boolean|null;
    public isClinicalAdmin: boolean|null;

    public constructor(init?: Partial<OnlineRole>) { (Object as any).assign(this, init); }
}
(OnlineRole as unknown)[immerable] = true;

export class OnlineCaseflowContact extends MedicalContactResponse
{
    public canRefer: boolean|null;
    public isFinancial: boolean|null;
    public isAdmin: boolean|null;
    public isClinical: boolean|null;
    public role: string|null;
    public roleDescription: string|null;
    public groupName: string|null;
    public groupId: number|null;

    public constructor(init?: Partial<OnlineCaseflowContact>) { super(init); (Object as any).assign(this, init); }
}
(OnlineCaseflowContact as unknown)[immerable] = true;

export class OnlineCategoryResponse
{
    public categories: OnlineServiceCategory[]|null;
    public services: OnlineClinicService[]|null;

    public constructor(init?: Partial<OnlineCategoryResponse>) { (Object as any).assign(this, init); }
}
(OnlineCategoryResponse as unknown)[immerable] = true;

export class OnlinePractitionerDto
{
    public id: string|null;
    public pId: number|null;
    public title: string|null;
    public forename: string|null;
    public surname: string|null;
    public name: string|null;
    public locationId: string|null;
    public practitionerId: string|null;
    public gender: string|null;
    public responseStatus: ResponseStatus|null;

    public constructor(init?: Partial<OnlinePractitionerDto>) { (Object as any).assign(this, init); }
}
(OnlinePractitionerDto as unknown)[immerable] = true;

export class OnlineInitialResponse extends OnlineCategoryResponse
{
    public locations: OnlineLocationDto[]|null;
    public practitioners: OnlinePractitionerDto[]|null;
    public sections: OnlineSection[]|null;
    public packages: PackageResponse[]|null;
    public lookups: Lookup[]|null;
    public isWaitingListEnabled: boolean|null;
    public isCaseflow: boolean|null;
    public isMfaEnabled: boolean|null;

    public constructor(init?: Partial<OnlineInitialResponse>) { super(init); (Object as any).assign(this, init); }
}
(OnlineInitialResponse as unknown)[immerable] = true;

export class AvailabilitySession
{
    public date: string|null;
    public locationId: string|null;
    public practitionerId: string|null;

    public constructor(init?: Partial<AvailabilitySession>) { (Object as any).assign(this, init); }
}
(AvailabilitySession as unknown)[immerable] = true;

export class LocationFacility
{
    public id: string|null;
    public name: string|null;
    public icon: string|null;

    public constructor(init?: Partial<LocationFacility>) { (Object as any).assign(this, init); }
}
(LocationFacility as unknown)[immerable] = true;

export class OnlineNetworkLocation
{
    public distance: number|null;
    public locationBusinessId: string|null;
    public locationId: string|null;
    public name: string|null;
    public publicDisplayName: string|null;
    public networkId: string|null;
    public networkName: string|null;
    public latLong: string|null;
    public hasCoordinates: boolean|null;
    public address: string|null;
    public addressLine1: string|null;
    public addressLine2: string|null;
    public locationProntoStatus: string|null;
    public telephone: string|null;
    public locationFacilities: LocationFacility[]|null;

    public constructor(init?: Partial<OnlineNetworkLocation>) { (Object as any).assign(this, init); }
}
(OnlineNetworkLocation as unknown)[immerable] = true;

export class AppointmentDto
{
    public id: number|null;
    public startDateTime: string|null;
    public endDateTime: string|null;
    public name: string|null;
    public customerId: string|null;
    public practitionerId: number|null;
    public practitionerGuid: string|null;
    public locationId: number|null;
    public locationGuid: string|null;
    public status: number|null;
    public type: string|null;
    public reference: string|null;
    public roomId: number|null;
    public stockId: string|null;
    public caseId: number|null;
    public groupId: number|null;
    public bookedBy: number|null;
    public authId: number|null;
    public serviceTypeId: number|null;
    public firstAppointment: boolean|null;
    public bookingMethod: string|null;
    public bookingDateTime: string|null;
    public completedTime: string|null;
    public duration: number|null;
    public comment: string|null;
    public appointmentType: AppointmentType|null;
    public backgroundJobId: string|null;
    public videoCode: string|null;

    public constructor(init?: Partial<AppointmentDto>) { (Object as any).assign(this, init); }
}
(AppointmentDto as unknown)[immerable] = true;

export enum RegistrationStatus
{
    New = 0,
    QuickRegister = 1,
    Default = 2,
    NotAllowed = 3,
    MfaChallenge = 4,
    Exists = -1,
}

export class GetUserByEmailOrMobileResponse
{
    public status: RegistrationStatus|null;
    public statusCode: number|null;

    public constructor(init?: Partial<GetUserByEmailOrMobileResponse>) { (Object as any).assign(this, init); }
}
(GetUserByEmailOrMobileResponse as unknown)[immerable] = true;

export class OnlineRegisterValidationResponse
{
    public emailValid: boolean|null;
    public mobileNumberValid: boolean|null;
    public message: string|null;

    public constructor(init?: Partial<OnlineRegisterValidationResponse>) { (Object as any).assign(this, init); }
}
(OnlineRegisterValidationResponse as unknown)[immerable] = true;

export class OnlineWaitingListReservationConfirmResponse
{
    public startDateTime: string|null;
    public endDateTime: string|null;
    public stockId: string|null;
    public courseId: number|null;
    public classSessionId: number|null;
    public hasClassSessionId: boolean|null;
    public stockDescription: string|null;
    public classTypeName: string|null;
    public bookingDateTime: string|null;
    public reservationEndDateTime: string|null;
    public duration: number|null;
    public appointmentId: number|null;
    public locationName: string|null;
    public locationId: number|null;
    public practitionerId: number|null;
    public appointmentStatus: number|null;
    public practitionerTitle: string|null;
    public practitionerForename: string|null;
    public practitionerSurname: string|null;
    public practitionerName: string|null;
    public isExpired: boolean|null;
    public customerTitle: string|null;
    public customerForename: string|null;
    public customerSurname: string|null;
    public customerName: string|null;
    public waitingListStatus: WaitingListStatus|null;
    public waitingListSubStatus: WaitingListSubStatus|null;
    public waitingListType: WaitingListType|null;
    public courseSessions: ClassSessionBaseResponse[]|null;
    public totalPrice: number|null;
    public priceExVAT: number|null;
    public linkedToAppointmentId: number|null;
    public waitingListPaid: boolean|null;

    public constructor(init?: Partial<OnlineWaitingListReservationConfirmResponse>) { (Object as any).assign(this, init); }
}
(OnlineWaitingListReservationConfirmResponse as unknown)[immerable] = true;

export class ChasedPaymentDTO
{
    public paymentUrlCode: string|null;
    public paymentAmount: number|null;
    public paymentStatus: number|null;
    public locationId: number|null;
    public customerId: number|null;

    public constructor(init?: Partial<ChasedPaymentDTO>) { (Object as any).assign(this, init); }
}
(ChasedPaymentDTO as unknown)[immerable] = true;

export class GetSquareCustomerDetailsResponse
{
    public addressLines: string[]|null;
    public familyName: string|null;
    public givenName: string|null;
    public email: string|null;
    public country: string|null;
    public phone: string|null;
    public region: string|null;
    public city: string|null;

    public constructor(init?: Partial<GetSquareCustomerDetailsResponse>) { (Object as any).assign(this, init); }
}
(GetSquareCustomerDetailsResponse as unknown)[immerable] = true;

export enum OnlineAutoLoginAuthenticationResult
{
    Success = 'Success',
    Fail = 'Fail',
    AccessCodeDoesntMatch = 'AccessCodeDoesntMatch',
    TokenDoesNotMatch = 'TokenDoesNotMatch',
    AccessCodeNotProvided = 'AccessCodeNotProvided',
    Expired = 'Expired',
    Redirect = 'Redirect',
}

export class MsBillingItemResponse implements IHasId
{
    public id: number|null;
    public date: string|null;
    public description: string|null;
    public totalExVAT: number|null;
    public quantity: number|null;
    public itemPrice: number|null;
    public vatRate: number|null;
    public totalVAT: number|null;
    public total: number|null;

    public constructor(init?: Partial<MsBillingItemResponse>) { (Object as any).assign(this, init); }
}
(MsBillingItemResponse as unknown)[immerable] = true;

export class MsInvoiceResponse
{
    public id: number|null;
    public reference: string|null;
    public addressTo: string|null;
    public addressLine1: string|null;
    public addressLine2: string|null;
    public addressLine3: string|null;
    public addressLine4: string|null;
    public addressLine5: string|null;
    public postCode: string|null;
    public date: string|null;
    public dueDate: string|null;
    public fullyPaidDate: string|null;
    public totalExcludingVAT: number|null;
    public vatAmount: number|null;
    public grandTotal: number|null;
    public amountPaid: number|null;
    public status: string|null;
    public paymentMethod: string|null;
    public locationId: number|null;
    public currencySymbol: string|null;
    public vatNumber: string|null;
    public salesStatus: string|null;
    public purchaseOrderNumber: string|null;
    public billingItems: MsBillingItemResponse[]|null;
    public payments: Income[]|null;
    public isBespoke: boolean|null;
    public creditNoteAmount: number|null;

    public constructor(init?: Partial<MsInvoiceResponse>) { (Object as any).assign(this, init); }
}
(MsInvoiceResponse as unknown)[immerable] = true;

export class Tm3License implements IHasId
{
    public id: number|null;
    public noOfDiarys: number|null;
    public modules: string[]|null;
    public firstDiaryMonthly: number|null;
    public additionalDiaryMonthly: number|null;
    public firstDiaryMonthlyOverride: number|null;
    public additionalDiaryMonthlyOverride: number|null;
    public totalMonthly: number|null;
    public totalMonthlyPreDiscount: number|null;
    public totalMonthlyOverride: number|null;
    public totalMonthlyVatAmount: number|null;
    public creationDate: string|null;

    public constructor(init?: Partial<Tm3License>) { (Object as any).assign(this, init); }
}
(Tm3License as unknown)[immerable] = true;

export class GetClientPricingResponse
{
    public basePrice: number|null;
    public additionalPrice: number|null;
    public basePriceWithVAT: number|null;
    public additionalPriceWithVAT: number|null;
    public vatRate: number|null;
    public smsRate: number|null;
    public downgrading: number|null;
    public upgrading: number|null;

    public constructor(init?: Partial<GetClientPricingResponse>) { (Object as any).assign(this, init); }
}
(GetClientPricingResponse as unknown)[immerable] = true;

export class ConfirmClientSignUpResponse
{
    public success: boolean|null;

    public constructor(init?: Partial<ConfirmClientSignUpResponse>) { (Object as any).assign(this, init); }
}
(ConfirmClientSignUpResponse as unknown)[immerable] = true;

export class SaveClientPaymentDetailsResponse
{
    public clientSecret: string|null;

    public constructor(init?: Partial<SaveClientPaymentDetailsResponse>) { (Object as any).assign(this, init); }
}
(SaveClientPaymentDetailsResponse as unknown)[immerable] = true;

export class ClickPPCDetailsResponse
{
    public telehealthRate: number|null;
    public smsRate: number|null;
    public cardCommission: string|null;
    public formsRate: number|null;

    public constructor(init?: Partial<ClickPPCDetailsResponse>) { (Object as any).assign(this, init); }
}
(ClickPPCDetailsResponse as unknown)[immerable] = true;

export class ClickUpgradeDetailsResponse
{
    public upfront: number|null;
    public monthly: number|null;
    public cardCommission: string|null;

    public constructor(init?: Partial<ClickUpgradeDetailsResponse>) { (Object as any).assign(this, init); }
}
(ClickUpgradeDetailsResponse as unknown)[immerable] = true;

export class ClickTrialResponse
{
    public success: boolean|null;

    public constructor(init?: Partial<ClickTrialResponse>) { (Object as any).assign(this, init); }
}
(ClickTrialResponse as unknown)[immerable] = true;

export class ClickDowngradeResponse
{
    public success: boolean|null;

    public constructor(init?: Partial<ClickDowngradeResponse>) { (Object as any).assign(this, init); }
}
(ClickDowngradeResponse as unknown)[immerable] = true;

export class ClientDowngradeToSingleLicenseResponse
{
    public success: boolean|null;

    public constructor(init?: Partial<ClientDowngradeToSingleLicenseResponse>) { (Object as any).assign(this, init); }
}
(ClientDowngradeToSingleLicenseResponse as unknown)[immerable] = true;

export class ClientNoLongerWantsToCancelResponse
{
    public success: boolean|null;

    public constructor(init?: Partial<ClientNoLongerWantsToCancelResponse>) { (Object as any).assign(this, init); }
}
(ClientNoLongerWantsToCancelResponse as unknown)[immerable] = true;

export class ConfirmClientCancellationResponse
{
    public success: boolean|null;

    public constructor(init?: Partial<ConfirmClientCancellationResponse>) { (Object as any).assign(this, init); }
}
(ConfirmClientCancellationResponse as unknown)[immerable] = true;

export class MSCurrencyResponse
{
    public currencySymbol: string|null;
    public locationId: number|null;

    public constructor(init?: Partial<MSCurrencyResponse>) { (Object as any).assign(this, init); }
}
(MSCurrencyResponse as unknown)[immerable] = true;

export class MSSubscriptionResponse
{
    public date: string|null;

    public constructor(init?: Partial<MSSubscriptionResponse>) { (Object as any).assign(this, init); }
}
(MSSubscriptionResponse as unknown)[immerable] = true;

export class CreditAutoTopUpAmountResponse
{
    public number: number|null;

    public constructor(init?: Partial<CreditAutoTopUpAmountResponse>) { (Object as any).assign(this, init); }
}
(CreditAutoTopUpAmountResponse as unknown)[immerable] = true;

export class SMSOrderHistoryResponse
{

    public constructor(init?: Partial<SMSOrderHistoryResponse>) { (Object as any).assign(this, init); }
}
(SMSOrderHistoryResponse as unknown)[immerable] = true;

export class BundleOption
{
    public number: number|null;
    public totalExVAT: number|null;
    public vatAmount: number|null;
    public total: number|null;
    public bundleType: string|null;

    public constructor(init?: Partial<BundleOption>) { (Object as any).assign(this, init); }
}
(BundleOption as unknown)[immerable] = true;

export class SMSBundleOptionsResponse
{
    public bundles: BundleOption[]|null;
    public remaining: number|null;

    public constructor(init?: Partial<SMSBundleOptionsResponse>) { (Object as any).assign(this, init); }
}
(SMSBundleOptionsResponse as unknown)[immerable] = true;

export class ExtraSystemCreditResponse
{
    public amountPurchased: number|null;
    public purchaseDate: string|null;
    public amountRemaining: number|null;
    public expiryDate: string|null;

    public constructor(init?: Partial<ExtraSystemCreditResponse>) { (Object as any).assign(this, init); }
}
(ExtraSystemCreditResponse as unknown)[immerable] = true;

export class SystemCreditBundleOptionsResponse
{
    public bundles: BundleOption[]|null;
    public remaining: number|null;
    public total: number|null;
    public extras: ExtraSystemCreditResponse[]|null;

    public constructor(init?: Partial<SystemCreditBundleOptionsResponse>) { (Object as any).assign(this, init); }
}
(SystemCreditBundleOptionsResponse as unknown)[immerable] = true;

export class CreditOrderHistoryResponse
{

    public constructor(init?: Partial<CreditOrderHistoryResponse>) { (Object as any).assign(this, init); }
}
(CreditOrderHistoryResponse as unknown)[immerable] = true;

export class PayPerClickDetail
{
    public id: number|null;
    public date: string|null;
    public itemType: string|null;
    public itemId: number|null;
    public itemGuid: string|null;
    public userId: number|null;
    public practitionerId: number|null;
    public locationId: number|null;
    public locationName: string|null;
    public practitionerName: string|null;
    public userName: string|null;
    public includedInAllowance: boolean|null;
    public itemReference: string|null;
    public content: string|null;
    public value: number|null;

    public constructor(init?: Partial<PayPerClickDetail>) { (Object as any).assign(this, init); }
}
(PayPerClickDetail as unknown)[immerable] = true;

export class PayPerClickStats
{
    public activePractitioners: number|null;
    public paygPractitioners: number|null;
    public appointments: number|null;
    public paygAppointments: number|null;
    public classes: number|null;
    public paygClasses: number|null;
    public systemCredits: number|null;

    public constructor(init?: Partial<PayPerClickStats>) { (Object as any).assign(this, init); }
}
(PayPerClickStats as unknown)[immerable] = true;

export class PayPerClickStatsResponse
{
    public thisMonth: PayPerClickStats|null;
    public lastMonth: PayPerClickStats|null;

    public constructor(init?: Partial<PayPerClickStatsResponse>) { (Object as any).assign(this, init); }
}
(PayPerClickStatsResponse as unknown)[immerable] = true;

export class UnrestrictedUserResponse
{
    public unrestricted: number[]|null;

    public constructor(init?: Partial<UnrestrictedUserResponse>) { (Object as any).assign(this, init); }
}
(UnrestrictedUserResponse as unknown)[immerable] = true;

export class DiaryAnalysisReport
{
    public locationStatus: number|null;
    public locationName: string|null;
    // @Ignore()
    public practitionerName: string|null;

    public practitionerTitle: string|null;
    public practitionerForename: string|null;
    public practitionerSurname: string|null;
    public practitionerStatus: number|null;
    // @Ignore()
    public appointmentClassification: string|null;

    public groupId: number|null;
    public groupName: string|null;
    public roomDescription: string|null;
    // @Ignore()
    public patientName: string|null;

    public customerTitle: string|null;
    public customerForename: string|null;
    public customerSurname: string|null;
    public email: string|null;
    public dateOfBirth: string|null;
    public ageGrouping: string|null;
    public startDateTime: string|null;
    public appointmentName: string|null;
    // @Ignore()
    public details: string|null;

    public notes: string|null;
    public appointmentStatus: AppointmentStatus|null;
    public stockDescription: string|null;
    public isFirstAppointment: boolean|null;
    // @Ignore()
    public appointmentDescription: string|null;

    // @Ignore()
    public treatmentType: string|null;

    public appointmentType: string|null;
    // @Ignore()
    public diaryEventCategory: string|null;

    public bookingMethod: string|null;
    public bookingMethodText: string|null;
    public reason: string|null;
    // @Ignore()
    public cancellationReason: string|null;

    public username: string|null;
    // @Ignore()
    public bookedBy: string|null;

    public stockId: number|null;
    public projectedIncome: number|null;
    public authLeft: number|null;
    public _cancelMethod: string|null;
    // @Ignore()
    public cancelMethod: string|null;

    public _lastActionDateTime: string|null;
    // @Ignore()
    public lastActionDateTime: string|null;

    public _lastActionUser: string|null;
    // @Ignore()
    public lastActionUser: string|null;

    public _prepaymentStatus: string|null;
    // @Ignore()
    public prepaymentStatus: string|null;

    public _recallStatus: string|null;
    // @Ignore()
    public recallStatus: string|null;

    public constructor(init?: Partial<DiaryAnalysisReport>) { (Object as any).assign(this, init); }
}
(DiaryAnalysisReport as unknown)[immerable] = true;

export class DiaryAnalysisResponse
{
    public results: DiaryAnalysisReport[]|null;
    public total: number|null;
    public totals: { [index:string]: number; }|null;

    public constructor(init?: Partial<DiaryAnalysisResponse>) { (Object as any).assign(this, init); }
}
(DiaryAnalysisResponse as unknown)[immerable] = true;

export class NonReturningReportResponse
{
    public customerReference: string|null;
    public customerName: string|null;
    public totalAppointments: number|null;
    public lastAppointmentDate: string|null;
    public totalCharges: number|null;
    public practitionerName: string|null;
    public practitionerId: number|null;
    public locationName: string|null;
    public locationId: number|null;

    public constructor(init?: Partial<NonReturningReportResponse>) { (Object as any).assign(this, init); }
}
(NonReturningReportResponse as unknown)[immerable] = true;

export enum TrafficAttendance
{
    High = 'High',
    Low = 'Low',
}

export class TrafficReportResponse
{
    public customerId: number|null;
    public accountId: number|null;
    public patientName: string|null;
    public totalAppointments: number|null;
    public booked: number|null;
    public completed: number|null;
    public dna: number|null;
    public cancelled: number|null;
    public totalClasses: number|null;
    public billedClient: number|null;
    public billedGroup: number|null;
    public attendance: TrafficAttendance|null;
    public totalClassAttendance: number|null;
    public totalEvents: number|null;
    public bookingMethod: string|null;

    public constructor(init?: Partial<TrafficReportResponse>) { (Object as any).assign(this, init); }
}
(TrafficReportResponse as unknown)[immerable] = true;

export class AutopayReportResult
{
    public customerTitle: string|null;
    public customerForename: string|null;
    public customerSurname: string|null;
    // @Ignore()
    public customerName: string|null;

    public nextDue: string|null;
    public homeTelephone: string|null;
    public workTelephone: string|null;
    public mobileTelephone: string|null;
    public name: string|null;
    public totalIncVat: number|null;
    public status: SubscriptionStatus|null;
    // @Ignore()
    public number: string|null;

    public locationId: number|null;
    public locationName: string|null;
    public practitionerId: number|null;
    public practitionerTitle: string|null;
    public practitionerForename: string|null;
    public practitionerSurname: string|null;
    // @Ignore()
    public practitionerName: string|null;

    public expiresSoon: boolean|null;
    public hasStripe: boolean|null;
    public cardExpiresSoon: boolean|null;
    public expiryYear: number|null;
    public expiryMonth: number|null;
    public stripeCustomerId: string|null;
    public packageId: string|null;

    public constructor(init?: Partial<AutopayReportResult>) { (Object as any).assign(this, init); }
}
(AutopayReportResult as unknown)[immerable] = true;

export class GetSettingsResponse extends OnlineSettings
{
    public connectUrl: string|null;

    public constructor(init?: Partial<GetSettingsResponse>) { super(init); (Object as any).assign(this, init); }
}
(GetSettingsResponse as unknown)[immerable] = true;

export class CanDeleteImageResponse
{
    public isLogo: boolean|null;
    public isOffer: boolean|null;
    public isTitle: boolean|null;
    public packages: string[]|null;
    public categories: string[]|null;
    public services: string[]|null;

    public constructor(init?: Partial<CanDeleteImageResponse>) { (Object as any).assign(this, init); }
}
(CanDeleteImageResponse as unknown)[immerable] = true;

export class BusinessSettingsIdResponse
{
    public settingsId: number|null;

    public constructor(init?: Partial<BusinessSettingsIdResponse>) { (Object as any).assign(this, init); }
}
(BusinessSettingsIdResponse as unknown)[immerable] = true;

export enum Gender
{
    Unspecified = 'Unspecified',
    Male = 'Male',
    Female = 'Female',
}

export class ClassSearchResult
{
    public id: number|null;
    public appointmentId: number|null;
    public courseId: number|null;
    public classTypeId: number|null;
    public stockId: number|null;
    public startDateTime: string|null;
    public endDateTime: string|null;
    public status: number|null;
    public locationId: number|null;
    public locationName: string|null;
    public onlineGuid: string|null;
    public price: number|null;
    public priceExVat: number|null;
    public creditValue: number|null;
    public practitionerId: number|null;
    public practitionerForename: string|null;
    public practitionerSurname: string|null;
    public practitionerName: string|null;
    public practitionerGender: string|null;
    // @Ignore()
    public practGender: Gender|null;

    public isCourse: boolean|null;
    public name: string|null;
    public defaultMinAttendees: number|null;
    public defaultMaxAttendees: number|null;
    public stockOnlineGuid: string|null;
    public waitingListEnrolled: WaitingListWithDetails[]|null;
    public practitionerOnlineGuid: string|null;
    public isAttending: boolean|null;
    public courseSessionIndex: number|null;
    public courseTotalSessions: number|null;
    public serviceId: string|null;

    public constructor(init?: Partial<ClassSearchResult>) { (Object as any).assign(this, init); }
}
(ClassSearchResult as unknown)[immerable] = true;

export class ClassTypeBase implements IHasId
{
    public id: number|null;
    public name: string|null;
    public description: string|null;
    public imageUrl: string|null;
    public isCourse: boolean|null;
    public termsAndConditionsFormId: string|null;
    public colour: number|null;
    public defaultSessionLength: number|null;
    public defaultMinAttendees: number|null;
    public defaultMaxAttendees: number|null;
    public isAvailableOnline: boolean|null;
    public cancellationChargeApplies: boolean|null;
    public cancellationHours: number|null;
    public cancellationStockId: number|null;
    public isCurrent: boolean|null;
    public isFavourite: boolean|null;
    public serviceTypeId: number|null;
    public isVideo: boolean|null;

    public constructor(init?: Partial<ClassTypeBase>) { (Object as any).assign(this, init); }
}

export class ClassType extends ClassTypeBase
{
    public lateTransferChargeApplies: boolean|null;
    public lateTransferHours: number|null;
    public allowPayPerSession: boolean|null;
    public stockId: number|null;
    public numberOfSessions: number|null;

    public constructor(init?: Partial<ClassType>) { super(init); (Object as any).assign(this, init); }
}
(ClassType as unknown)[immerable] = true;

export class ClassSearchResponse
{
    public classes: ClassSearchResult[]|null;
    public locationIds: string[]|null;
    public attendance: { [index:number]: number; }|null;
    public classInfo: ClassType|null;
    public courseAppointmentDates: { [index:number]: string[]; }|null;

    public constructor(init?: Partial<ClassSearchResponse>) { (Object as any).assign(this, init); }
}
(ClassSearchResponse as unknown)[immerable] = true;

export class SimilarClass
{
    public classSessionId: number|null;
    public startDateTime: string|null;

    public constructor(init?: Partial<SimilarClass>) { (Object as any).assign(this, init); }
}
(SimilarClass as unknown)[immerable] = true;

// @DataContract
export class ConvertSessionToTokenResponse
{
    // @DataMember(Order=1)
    public meta: { [index:string]: string; }|null;

    // @DataMember(Order=2)
    public accessToken: string|null;

    // @DataMember(Order=3)
    public refreshToken: string|null;

    // @DataMember(Order=4)
    public responseStatus: ResponseStatus|null;

    public constructor(init?: Partial<ConvertSessionToTokenResponse>) { (Object as any).assign(this, init); }
}
(ConvertSessionToTokenResponse as unknown)[immerable] = true;

export class ZoomSaveStateResponse
{
    public apiKey: string|null;
    public redirectUri: string|null;

    public constructor(init?: Partial<ZoomSaveStateResponse>) { (Object as any).assign(this, init); }
}
(ZoomSaveStateResponse as unknown)[immerable] = true;

export enum ZoomUserType
{
    Basic = 1,
    Licensed = 2,
    OnPrem = 3,
}

export class ZoomUser
{
    public id: string|null;
    public firstName: string|null;
    public lastName: string|null;
    public email: string|null;
    public type: ZoomUserType|null;
    public status: string|null;
    public pmi: number|null;
    public timezone: string|null;
    public dept: string|null;
    public createdAt: string|null;
    public lastLoginTime: string|null;
    public lastClientVersion: string|null;
    public groupIds: string[]|null;
    public verified: number|null;
    public accountId: string|null;
    public fullName: string|null;

    public constructor(init?: Partial<ZoomUser>) { (Object as any).assign(this, init); }
}
(ZoomUser as unknown)[immerable] = true;

export class ZoomReauthResponse extends ZoomSaveStateResponse
{
    public isInvalid: boolean|null;

    public constructor(init?: Partial<ZoomReauthResponse>) { super(init); (Object as any).assign(this, init); }
}
(ZoomReauthResponse as unknown)[immerable] = true;

export class WaitingListByIdResponse extends WaitingList
{

    public constructor(init?: Partial<WaitingListByIdResponse>) { super(init); (Object as any).assign(this, init); }
}
(WaitingListByIdResponse as unknown)[immerable] = true;

export class WaitingListStateHistory implements IHasId
{
    public id: number|null;
    public waitingListId: number|null;
    public customerId: number|null;
    public description: string|null;
    public listType: WaitingListType|null;
    public stockId: number|null;
    public classTypeId: number|null;
    public temporaryClassSessionId: number|null;
    public temporaryCourseId: number|null;
    public temporaryAppointmentId: number|null;
    public status: WaitingListStatus|null;
    public subStatus: WaitingListSubStatus|null;
    public notificationType: WaitingListNotificationType|null;
    public dateUpdated: string|null;
    public startDateTime: string|null;
    public pauseUntilDateTime: string|null;

    public constructor(init?: Partial<WaitingListStateHistory>) { (Object as any).assign(this, init); }
}
(WaitingListStateHistory as unknown)[immerable] = true;

export class WaitingListStateHistoryResponse extends WaitingListStateHistory
{

    public constructor(init?: Partial<WaitingListStateHistoryResponse>) { super(init); (Object as any).assign(this, init); }
}
(WaitingListStateHistoryResponse as unknown)[immerable] = true;

export class AllowedIP implements IHasId
{
    public id: number|null;
    public address: string|null;

    public constructor(init?: Partial<AllowedIP>) { (Object as any).assign(this, init); }
}
(AllowedIP as unknown)[immerable] = true;

export class AllowedIPResponse
{
    public allowed: AllowedIP[]|null;

    public constructor(init?: Partial<AllowedIPResponse>) { (Object as any).assign(this, init); }
}
(AllowedIPResponse as unknown)[immerable] = true;

export class EmbeddableDashboardToken
{
    public token: string|null;

    public constructor(init?: Partial<EmbeddableDashboardToken>) { (Object as any).assign(this, init); }
}
(EmbeddableDashboardToken as unknown)[immerable] = true;

export class SystemLog implements IHasId
{
    public id: number|null;
    public description: string|null;
    public requestId: string|null;
    public requestUrl: string|null;
    public requestMethod: string|null;
    public requestPayload: string|null;
    public responseStatus: string|null;
    public responsePayload: string|null;
    public date: string|null;
    public exception: string|null;
    public duration: number|null;
    public customerId: number|null;
    public objectId: number|null;
    public objectType: string|null;

    public constructor(init?: Partial<SystemLog>) { (Object as any).assign(this, init); }
}
(SystemLog as unknown)[immerable] = true;

export class SystemLogWithCustomerName extends SystemLog
{
    public name: string|null;
    public forename: string|null;
    public surname: string|null;

    public constructor(init?: Partial<SystemLogWithCustomerName>) { super(init); (Object as any).assign(this, init); }
}
(SystemLogWithCustomerName as unknown)[immerable] = true;

export class SquareGetDeviceCodeResponse
{
    public code: string|null;

    public constructor(init?: Partial<SquareGetDeviceCodeResponse>) { (Object as any).assign(this, init); }
}
(SquareGetDeviceCodeResponse as unknown)[immerable] = true;

export class TerminalPairingResponse
{
    public deviceCode: string|null;
    public paired: boolean|null;

    public constructor(init?: Partial<TerminalPairingResponse>) { (Object as any).assign(this, init); }
}
(TerminalPairingResponse as unknown)[immerable] = true;

export class Terminal implements IHasId
{
    public id: number|null;
    public merchantId: string|null;
    public locationId: number|null;
    public deviceCode: string|null;
    public name: string|null;
    public pairedAt: string|null;
    public inUse: boolean|null;
    public provider: PaymentProviderName|null;

    public constructor(init?: Partial<Terminal>) { (Object as any).assign(this, init); }
}
(Terminal as unknown)[immerable] = true;

export class SquareTerminalPaymentResponse
{
    public checkoutId: string|null;

    public constructor(init?: Partial<SquareTerminalPaymentResponse>) { (Object as any).assign(this, init); }
}
(SquareTerminalPaymentResponse as unknown)[immerable] = true;

export class StripeTerminalPairResponse
{
    public success: boolean|null;

    public constructor(init?: Partial<StripeTerminalPairResponse>) { (Object as any).assign(this, init); }
}
(StripeTerminalPairResponse as unknown)[immerable] = true;

export class ChangeCardResponse
{
    public details: CardDetails|null;
    public paymentMethodId: string|null;
    public clientSecret: string|null;
    public paymentIntentId: string|null;

    public constructor(init?: Partial<ChangeCardResponse>) { (Object as any).assign(this, init); }
}
(ChangeCardResponse as unknown)[immerable] = true;

export class ClearAcceptConfigResponse
{
    public scriptUrl: string|null;
    public scriptSri: string|null;
    public componentScriptUrl: string|null;
    public componentScriptSri: string|null;

    public constructor(init?: Partial<ClearAcceptConfigResponse>) { (Object as any).assign(this, init); }
}
(ClearAcceptConfigResponse as unknown)[immerable] = true;

export class ApiCredentials implements IHasGuidId
{
    public id: string|null;
    public secret: string|null;
    public createdDate: string|null;
    public expiryDate: string|null;
    public cancelledDate: string|null;
    public notes: string|null;
    public isSoftDeleted: boolean|null;
    public isOutboundOnly: boolean|null;
    // @Ignore()
    public isValid: boolean|null;

    public userId: number|null;

    public constructor(init?: Partial<ApiCredentials>) { (Object as any).assign(this, init); }
}
(ApiCredentials as unknown)[immerable] = true;

// @Flags()
export enum CreditProductType
{
    Class = 0,
    Course = 1,
    Appointment = 2,
}

// @Flags()
export enum CreditTransactionType
{
    Purchase = 0,
    Refund = 1,
    CancellationCharge = 2,
}

export class CreditBasedPackageLineItemsResponse
{
    public id: string|null;
    public stockName: string|null;
    public productType: CreditProductType|null;
    public credits: number|null;
    public date: string|null;
    public practitionerTitle: string|null;
    public practitionerFirstName: string|null;
    public practitionerSurname: string|null;
    public startDateTime: string|null;
    public transactionType: CreditTransactionType|null;
    public locationName: string|null;

    public constructor(init?: Partial<CreditBasedPackageLineItemsResponse>) { (Object as any).assign(this, init); }
}
(CreditBasedPackageLineItemsResponse as unknown)[immerable] = true;

export class ClickBillResponse
{
    public invoiceId: number|null;
    public invoiceStatus: string|null;
    public serviceName: string|null;
    public serviceTotalPrice: string|null;

    public constructor(init?: Partial<ClickBillResponse>) { (Object as any).assign(this, init); }
}
(ClickBillResponse as unknown)[immerable] = true;

export class ClickDownloadInvoiceResponse
{
    public invoiceId: number|null;
    public pdfReceipt: string|null;

    public constructor(init?: Partial<ClickDownloadInvoiceResponse>) { (Object as any).assign(this, init); }
}
(ClickDownloadInvoiceResponse as unknown)[immerable] = true;

export class ClickCreatePaymentResponse
{
    public paymentId: number|null;
    public pdfReceipt: string|null;

    public constructor(init?: Partial<ClickCreatePaymentResponse>) { (Object as any).assign(this, init); }
}
(ClickCreatePaymentResponse as unknown)[immerable] = true;

export class ClickCommunicationResponse
{
    public subject: string|null;
    public to: string[]|null;
    public cc: string[]|null;
    public attachments: AttachmentGroup|null;
    public messageBody: string|null;

    public constructor(init?: Partial<ClickCommunicationResponse>) { (Object as any).assign(this, init); }
}
(ClickCommunicationResponse as unknown)[immerable] = true;

export class CreateClassResponse
{
    public success: boolean|null;
    public clashes: string[]|null;
    public session: ClassSessionBaseResponse|null;

    public constructor(init?: Partial<CreateClassResponse>) { (Object as any).assign(this, init); }
}
(CreateClassResponse as unknown)[immerable] = true;

export class GetDesktopClassResponse
{
    public name: string|null;
    public maxAttendees: number|null;

    public constructor(init?: Partial<GetDesktopClassResponse>) { (Object as any).assign(this, init); }
}
(GetDesktopClassResponse as unknown)[immerable] = true;

export enum AddingAttendeeResponse
{
    SpaceAvailable = 'SpaceAvailable',
    SessionFull = 'SessionFull',
    AlreadyRegistered = 'AlreadyRegistered',
    PreviouslyCancelled = 'PreviouslyCancelled',
}

export class AddingAttendeeToSessionErrors
{
    public classSessionId: number|null;
    public startDateTime: string|null;
    public endDateTime: string|null;
    public availability: AddingAttendeeResponse|null;
    public errorMessage: string|null;
    public isSessionInThePast: boolean|null;

    public constructor(init?: Partial<AddingAttendeeToSessionErrors>) { (Object as any).assign(this, init); }
}
(AddingAttendeeToSessionErrors as unknown)[immerable] = true;

export class AddStudentToClassSessionResponse implements IClassFinanceResponse
{
    public invoiceId: number|null;
    public paymentId: number|null;
    public clashMode: ClashMode|null;
    public errors: AddingAttendeeToSessionErrors[]|null;
    public hasErrors: boolean|null;
    public hasSessionFullErrors: boolean|null;
    public isAlreadyOnWaitingList: boolean|null;
    public hasSessionsInThePastErrors: boolean|null;
    public hasSpacesAvailable: boolean|null;
    public success: boolean|null;
    public customerId: number|null;

    public constructor(init?: Partial<AddStudentToClassSessionResponse>) { (Object as any).assign(this, init); }
}
(AddStudentToClassSessionResponse as unknown)[immerable] = true;

export class EditClassResponse
{
    public success: boolean|null;
    public clashes: ClassSessionBaseResponse[]|null;
    public session: ClassSessionBaseResponse|null;

    public constructor(init?: Partial<EditClassResponse>) { (Object as any).assign(this, init); }
}
(EditClassResponse as unknown)[immerable] = true;

export class PayForClassResponse implements IClassFinanceResponse
{
    public invoiceId: number|null;
    public paymentId: number|null;
    public prePaidId: number|null;
    public billingItemId: number|null;

    public constructor(init?: Partial<PayForClassResponse>) { (Object as any).assign(this, init); }
}
(PayForClassResponse as unknown)[immerable] = true;

export class ClassCommunicationResponse
{
    public customerId: number|null;
    public customerEmail: string|null;
    public customerMobileTelephone: string|null;
    public customerSMSEnabled: boolean|null;
    public title: string|null;
    public forename: string|null;
    public surname: string|null;
    // @Ignore()
    public name: string|null;

    public constructor(init?: Partial<ClassCommunicationResponse>) { (Object as any).assign(this, init); }
}
(ClassCommunicationResponse as unknown)[immerable] = true;

export class PrePaidItemsForClassResponse
{
    public packageName: string|null;
    public totalPrice: number|null;
    public itemDescription: string|null;
    public itemsLeft: number|null;
    public id: number|null;

    public constructor(init?: Partial<PrePaidItemsForClassResponse>) { (Object as any).assign(this, init); }
}
(PrePaidItemsForClassResponse as unknown)[immerable] = true;

export class ClassesPrePaidCreditsResp
{
    public packageName: string|null;
    public quantity: number|null;
    public used: number|null;
    public id: number|null;

    public constructor(init?: Partial<ClassesPrePaidCreditsResp>) { (Object as any).assign(this, init); }
}
(ClassesPrePaidCreditsResp as unknown)[immerable] = true;

export class AddStudentToCourseResponse implements IClassFinanceResponse
{
    public result: CourseResponse|null;
    public invoiceId: number|null;
    public paymentId: number|null;
    public errors: AddingAttendeeToSessionErrors[]|null;
    public clashMode: ClashMode|null;
    public hasErrors: boolean|null;
    public hasSessionFullErrors: boolean|null;
    public isAlreadyOnWaitingList: boolean|null;
    public hasSpacesAvailableInAllSessions: boolean|null;
    public success: boolean|null;

    public constructor(init?: Partial<AddStudentToCourseResponse>) { (Object as any).assign(this, init); }
}
(AddStudentToCourseResponse as unknown)[immerable] = true;

export class EditCourseResponse
{
    public success: boolean|null;
    public clashes: ClassSessionBaseResponse[]|null;
    public course: CourseResponse|null;

    public constructor(init?: Partial<EditCourseResponse>) { (Object as any).assign(this, init); }
}
(EditCourseResponse as unknown)[immerable] = true;

export class CreateCourseResponse
{
    public success: boolean|null;
    public clashes: string[]|null;
    public session: ClassSessionBaseResponse|null;

    public constructor(init?: Partial<CreateCourseResponse>) { (Object as any).assign(this, init); }
}
(CreateCourseResponse as unknown)[immerable] = true;

export class RemoveStudentFromClassResponse implements IClassFinanceResponse
{
    public invoiceId: number|null;
    public paymentId: number|null;
    public billingItemId: number|null;

    public constructor(init?: Partial<RemoveStudentFromClassResponse>) { (Object as any).assign(this, init); }
}
(RemoveStudentFromClassResponse as unknown)[immerable] = true;

export class SMRTokenResponse
{
    public token: string;
    public companyName: string;

    public constructor(init?: Partial<SMRTokenResponse>) { (Object as any).assign(this, init); }
}
(SMRTokenResponse as unknown)[immerable] = true;

export class RepairtimeType
{
    public vrm: string;
    public madeFrom: string;
    public madeUntil: string;
    public repairMake: string;
    public repairModel: string;
    public output: number|null;
    public repairtimeTypeId: string;
    public rootNodeId: string;
    public type: string;
    public make: string;
    public model: string;
    public bhp: number|null;
    public vin: string;
    public regDate: string|null;
    public category: string;
    public technicalTypeId: number|null;
    public id: string;

    public constructor(init?: Partial<RepairtimeType>) { (Object as any).assign(this, init); }
}
(RepairtimeType as unknown)[immerable] = true;

export class MenuNodes
{
    public id: string;
    public awNumber: string;
    public description: string;
    public hasInfoGroups: boolean|null;
    public hasSubnodes: boolean|null;
    public order: number|null;
    public time: number|null;
    public subNodes: MenuNodes[] = [];
    public parent: string;
    public isStory: boolean|null;
    public filter: string;
    public image: string;
    public title: string;

    public constructor(init?: Partial<MenuNodes>) { (Object as any).assign(this, init); }
}
(MenuNodes as unknown)[immerable] = true;

export class SmartLink
{
    public filter: string;
    public id1: number|null;
    public id2: string;
    public operation: string;
    public text: string[] = [];

    public constructor(init?: Partial<SmartLink>) { (Object as any).assign(this, init); }
}
(SmartLink as unknown)[immerable] = true;

export class ServiceTask
{
    public id: string;
    public description: string;
    public isSection: boolean|null;
    public seq: number|null;
    public time: number|null;
    public isMandatory: boolean|null;
    public remark: string;
    public isAdditional: boolean|null;
    public genArtNumbers: string[] = [];
    public smartLinks: SmartLink[] = [];
    public longDescription: string[] = [];

    public constructor(init?: Partial<ServiceTask>) { (Object as any).assign(this, init); }
}
(ServiceTask as unknown)[immerable] = true;

export class TableData
{
    public rows: TableDataCell[][] = [];

    public constructor(init?: Partial<TableData>) { (Object as any).assign(this, init); }
}
(TableData as unknown)[immerable] = true;

export class AdjustmentData
{
    public id: string;
    public image: string;
    public title: string;
    public isTitle: boolean|null;
    public order: number|null;
    public remark: string;
    public unit: string;
    public value: string;
    public subAdjustments: AdjustmentData[] = [];
    public hasLink: boolean|null;
    public linkId: string;
    public linkPath: string;
    public tableData: TableData;

    public constructor(init?: Partial<AdjustmentData>) { (Object as any).assign(this, init); }
}
(AdjustmentData as unknown)[immerable] = true;

export class LocationData
{
    public id: number|null;
    public description: string;
    public image: string;
    public subImage: string;
    public order: number|null;
    public location: string;
    public type: string;
    public value: string;
    public name: string;
    public quality: string;
    public temperature: string;
    public viscosity: string;
    public items: LocationData[] = [];

    public constructor(init?: Partial<LocationData>) { (Object as any).assign(this, init); }
}
(LocationData as unknown)[immerable] = true;

export class Component
{
    public componentId: string;
    public description: string;
    public diagnostics: string;
    public extraInfoAvailable: boolean|null;
    public extraInfoPath: string;
    public functionData: string;
    public groupId: number|null;
    public infoAvailable: boolean|null;
    public pictureMimeDataName: string;
    public scope1MimeDataName: string;
    public scope2MimeDataName: string;
    public specifications: string;

    public constructor(init?: Partial<Component>) { (Object as any).assign(this, init); }
}
(Component as unknown)[immerable] = true;

export class MarkerLocation
{
    public arrow: number|null;
    public location: string;
    public managementComponentId: string;
    public x: number|null;
    public y: number|null;
    public height: number|null;
    public width: number|null;
    public pinsBetweenPinsForScope1: string;
    public pinsToGroundForScope1: string;
    public pinsToGroundForScope2: string;
    public image: string;
    public component: Component;

    public constructor(init?: Partial<MarkerLocation>) { (Object as any).assign(this, init); }
}
(MarkerLocation as unknown)[immerable] = true;

export class StoryInfo
{
    public image: string;
    public description: string;
    public order: number|null;
    public isTitle: boolean|null;
    public remark: string;
    public issueDate: string;
    public oeCode: string;
    public type: string;
    public details: StoryInfo[] = [];
    public wiring: MarkerLocation[] = [];
    public physical: MarkerLocation[] = [];

    public constructor(init?: Partial<StoryInfo>) { (Object as any).assign(this, init); }
}
(StoryInfo as unknown)[immerable] = true;

export class NetworkItem
{
    public title: string;
    public subTitle: string;
    public signalID: number|null;
    public groupID: number|null;
    public typeID: number|null;
    public componentID: number|null;
    public order: number|null;
    public in: NetworkItem[] = [];
    public out: NetworkItem[] = [];
    public instance: NetworkItem[] = [];

    public constructor(init?: Partial<NetworkItem>) { (Object as any).assign(this, init); }
}
(NetworkItem as unknown)[immerable] = true;

export class WireData
{
    public pinNumber: string;
    public wireColour1: string;
    public pinName: string;
    public wireColour2: string;
    public name: string;
    public description: string;
    public systemTypeID: number|null;
    public componentID: number|null;
    public id: string;

    public constructor(init?: Partial<WireData>) { (Object as any).assign(this, init); }
}
(WireData as unknown)[immerable] = true;

export class DiagnosisTableValues
{
    public value1: string;
    public value2: string;

    public constructor(init?: Partial<DiagnosisTableValues>) { (Object as any).assign(this, init); }
}
(DiagnosisTableValues as unknown)[immerable] = true;

export class DiagnosisTable
{
    public header: DiagnosisTableValues;
    public rows: DiagnosisTableValues[] = [];

    public constructor(init?: Partial<DiagnosisTable>) { (Object as any).assign(this, init); }
}
(DiagnosisTable as unknown)[immerable] = true;

export class DiagnosisData
{
    public title: string;
    public question: string;
    public no: DiagnosisData;
    public yes: DiagnosisData;
    public multimeterVars: string;
    public image: string;
    public table: DiagnosisTable;
    public type: string;
    public traceImage: string;

    public constructor(init?: Partial<DiagnosisData>) { (Object as any).assign(this, init); }
}
(DiagnosisData as unknown)[immerable] = true;

export class NetworkData
{
    public title: string;
    public image: string;
    public componentImageID: string;
    public wires: WireData[] = [];
    public diagnosis: DiagnosisData[] = [];

    public constructor(init?: Partial<NetworkData>) { (Object as any).assign(this, init); }
}
(NetworkData as unknown)[immerable] = true;

export class FaultComponent
{
    public componentId: number|null;
    public typeID: number|null;
    public description: string;
    public diagnostics: string;
    public extraInfoAvailable: boolean|null;
    public extraInfoPath: string;
    public functionData: string;
    public groupID: number|null;
    public infoAvailable: boolean|null;
    public pictureMimeDataName: string;
    public scope1MimeDataName: string;
    public scope2MimeDataName: string;
    public specifications: string;
    public status: string;

    public constructor(init?: Partial<FaultComponent>) { (Object as any).assign(this, init); }
}
(FaultComponent as unknown)[immerable] = true;

export class FaultCodes
{
    public faultCode: string;
    public faultCodeAlt: string;
    public name: string;
    public description: string;
    public components: FaultComponent[] = [];

    public constructor(init?: Partial<FaultCodes>) { (Object as any).assign(this, init); }
}
(FaultCodes as unknown)[immerable] = true;

export class DropDownItem
{
    public id: number|null;
    public fullName: string;
    public name: string;
    public madeFrom: string;
    public madeUntil: string;
    public image: string;
    public engineCode: string;
    public output: string;
    public label: string;
    public value: string;

    public constructor(init?: Partial<DropDownItem>) { (Object as any).assign(this, init); }
}
(DropDownItem as unknown)[immerable] = true;

export class JobSheetAdvancedSearchResponse
{
    public id: number|null;
    public status: WorkSheetStatus|null;
    public reference: string;
    public date: string|null;
    public vehicleId: number|null;
    public customerId: number|null;
    public vehicleRegistration: string;
    public customerTitle: string;
    public customerForename: string;
    public customerSurname: string;
    public total: number|null;
    public vehicleRegistrationOrigin: string;

    public constructor(init?: Partial<JobSheetAdvancedSearchResponse>) { (Object as any).assign(this, init); }
}
(JobSheetAdvancedSearchResponse as unknown)[immerable] = true;

export class PartsCatalogueResponse
{
    public id: number|null;
    public serviceId: number|null;
    public serviceName: string;
    public accountName: string;
    public username: string;
    public password: string;
    public encPassword: string;

    public constructor(init?: Partial<PartsCatalogueResponse>) { (Object as any).assign(this, init); }
}
(PartsCatalogueResponse as unknown)[immerable] = true;

export class VehicleRemindersSettings implements IHasId
{
    public id: number|null;
    public name: string;
    public locked: boolean|null;
    public createdDate: string|null;
    public active: boolean|null;
    public leadDays1: number|null;
    public leadDays2: number|null;
    public leadDays3: number|null;
    public leadDays4: number|null;
    public leadDays5: number|null;
    public leadDays1TemplateName: string|null;
    public leadDays2TemplateName: string|null;
    public leadDays3TemplateName: string|null;
    public leadDays4TemplateName: string|null;
    public leadDays5TemplateName: string|null;

    public constructor(init?: Partial<VehicleRemindersSettings>) { (Object as any).assign(this, init); }
}
(VehicleRemindersSettings as unknown)[immerable] = true;

export class VehicleRemindersResponse extends VehicleRemindersSettings
{

    public constructor(init?: Partial<VehicleRemindersResponse>) { super(init); (Object as any).assign(this, init); }
}
(VehicleRemindersResponse as unknown)[immerable] = true;

export class VehicleAdvancedSearchResponse implements IHasId
{
    public id: number|null;
    public registrationNumber: string;
    public make: string;
    public model: string;
    public vin: string;
    public nextServiceDue: string|null;
    public nextMOTDue: string|null;
    public customerId: number|null;
    public forename: string;
    public surname: string;
    public homeTelephone: string;
    public workTelephone: string;
    public mobileTelephone: string;
    public email: string;
    public registrationOrigin: string;
    // @Ignore()
    public customerName: string;

    // @Ignore()
    public number: string;

    public constructor(init?: Partial<VehicleAdvancedSearchResponse>) { (Object as any).assign(this, init); }
}
(VehicleAdvancedSearchResponse as unknown)[immerable] = true;

export class VehicleResponse
{
    public id: number|null;
    public customerId: number|null;
    public registrationNumber: string|null;
    public make: string|null;
    public model: string|null;
    public engineCC: string|null;
    public vin: string|null;
    public engine: string|null;
    public nextServiceDue: string|null;
    public nextMOTDue: string|null;
    public dateOfRegistration: string|null;
    public yearOfManufacture: string|null;
    public designGrossWeight: string|null;
    public notes: string|null;
    public colour: string|null;
    public fuelType: string|null;
    public lastMileage: number|null;
    public lastMileageDate: string|null;
    public lastMileageUnit: string|null;
    public originalRegistrationNumber: string|null;
    public paintCode: string|null;
    public status: string|null;
    public taxDueDate: string|null;
    public dateOfManufacture: string|null;
    public ulezCompliant: boolean|null;
    public transmission: string|null;
    public data: JsonField|null;
    public customer: GeneralCustomerResponse;
    public isElectric: boolean|null;
    public invoiceId: number|null;
    public locationId: number|null;
    public emailReminders: boolean|null;
    public smsReminders: boolean|null;
    public registrationOrigin: string;
    public motHistory: MOTHistoryResponse|null;

    public constructor(init?: Partial<VehicleResponse>) { (Object as any).assign(this, init); }
}
(VehicleResponse as unknown)[immerable] = true;

export class VehicleGuardResponse
{
    public appointments: number|null;
    public jobsheets: number|null;

    public constructor(init?: Partial<VehicleGuardResponse>) { (Object as any).assign(this, init); }
}
(VehicleGuardResponse as unknown)[immerable] = true;

export class VehicleRemindersDetailsResponse extends VehicleRemindersDetails
{
    public name: string;

    public constructor(init?: Partial<VehicleRemindersDetailsResponse>) { super(init); (Object as any).assign(this, init); }
}
(VehicleRemindersDetailsResponse as unknown)[immerable] = true;

export class VRMVehicleResponse
{
    public id: number|null;
    public registrationNumber: string|null;
    public make: string|null;
    public model: string|null;
    public engineCC: string|null;
    public vin: string|null;
    public engine: string|null;
    public transmission: string|null;
    public nextMOTDue: string|null;
    public dateOfRegistration: string|null;
    public yearOfManufacture: string|null;
    public designGrossWeight: string|null;
    public colour: string|null;
    public fuelType: string|null;
    public lastMileage: string|null;
    public lastMileageDate: string|null;
    public lastMileageUnit: string|null;
    public originalRegistrationNumber: string|null;
    public taxDueDate: string|null;
    public data: JsonField|null;
    public isElectric: boolean|null;
    public vehicleBlurb: string;
    public existingVehicle: boolean|null;
    public registrationOrigin: string;
    public motHistory: MOTHistoryResponse|null;

    public constructor(init?: Partial<VRMVehicleResponse>) { (Object as any).assign(this, init); }
}
(VRMVehicleResponse as unknown)[immerable] = true;

export class WorkSheetAdvancedSearchResponse
{
    public id: number|null;
    public status: WorkSheetStatus|null;
    public reference: string;
    public date: string|null;
    public vehicleId: number|null;
    public customerId: number|null;
    public vehicleRegistration: string;
    public customerTitle: string;
    public customerForename: string;
    public customerSurname: string;
    public total: number|null;
    public appointmentId: number|null;
    public invoiceId: number|null;
    public type: WorkSheetType|null;
    public registrationOrigin: string;
    public name: string;
    public customerIsBusiness: boolean|null;

    public constructor(init?: Partial<WorkSheetAdvancedSearchResponse>) { (Object as any).assign(this, init); }
}
(WorkSheetAdvancedSearchResponse as unknown)[immerable] = true;

export class WorkSheetItemResponse
{
    public id: string|null;
    public date: string|null;
    public sheetId: number|null;
    public stockId: number|null;
    public description: string;
    public price: number|null;
    public priceExVat: number|null;
    public vatRate: number|null;
    public quantity: number|null;
    public totalVat: number|null;
    public totalExVat: number|null;
    public total: number|null;
    public ledgerCode: string;
    public category: string;
    public parentId: number|null;
    public sequence: number|null;
    public packageSequence: number|null;
    public packageId: string|null;
    public isPackageItem: boolean|null;
    public isHeader: boolean|null;
    public orderArticleCode: string;
    public basketId: string;
    public orderId: string;
    public orderStatus: WorkSheetOrderStatus|null;
    public orderServiceId: number|null;

    public constructor(init?: Partial<WorkSheetItemResponse>) { (Object as any).assign(this, init); }
}
(WorkSheetItemResponse as unknown)[immerable] = true;

export class PartsOrderResponse
{
    public message: string;
    public token: string;
    public url: string;
    public orderNumber: string;

    public constructor(init?: Partial<PartsOrderResponse>) { (Object as any).assign(this, init); }
}
(PartsOrderResponse as unknown)[immerable] = true;

export class BasketItem
{
    public articleCode: string;
    public articleDesc: string;
    public qty: string;
    public price: string;

    public constructor(init?: Partial<BasketItem>) { (Object as any).assign(this, init); }
}
(BasketItem as unknown)[immerable] = true;

export class GetPartsOrderResponse
{
    public account: string;
    public basketID: string;
    public vrm: string;
    public makeModel: string;
    public basket: BasketItem[] = [];

    public constructor(init?: Partial<GetPartsOrderResponse>) { (Object as any).assign(this, init); }
}
(GetPartsOrderResponse as unknown)[immerable] = true;

export class StripeResponseBase
{
    public statusCode: HttpStatusCode|null;
    public headers: HttpResponseHeaders|null;
    public date: string|null;
    public idempotencyKey: string|null;
    public requestId: string|null;

    public constructor(init?: Partial<StripeResponseBase>) { (Object as any).assign(this, init); }
}

export class StripeResponse extends StripeResponseBase
{
    public content: string|null;

    public constructor(init?: Partial<StripeResponse>) { super(init); (Object as any).assign(this, init); }
}
(StripeResponse as unknown)[immerable] = true;

export interface IStripeEntity
{
    stripeResponse: StripeResponse|null;
}

export interface IHasId
{
    id: string|null;
}

export interface IHasMetadata
{
    metadata: { [index:string]: string; }|null;
}

export interface IHasObject
{
    object: string|null;
}

export class CustomerResponse
{

    public constructor(init?: Partial<CustomerResponse>) { (Object as any).assign(this, init); }
}
(CustomerResponse as unknown)[immerable] = true;

export interface IHasUsers
{
    users: UserActivations[]|null;
}

export class ClinicalScore implements IHasId
{
    public id: number|null;
    public title: string|null;
    public dateAdded: string|null;
    public dateCompleted: string|null;
    public caseId: number|null;
    public settingId: number|null;

    public constructor(init?: Partial<ClinicalScore>) { (Object as any).assign(this, init); }
}
(ClinicalScore as unknown)[immerable] = true;

export class CasePrintingScore<T> extends ClinicalScore
{
    public entries: T[]|null;

    public constructor(init?: Partial<CasePrintingScore<T>>) { super(init); (Object as any).assign(this, init); }
}

export class Goal implements IHasId
{
    public id: number|null;
    public title: string|null;
    public dateAdded: string|null;
    public dateCompleted: string|null;
    public caseId: number|null;
    public settingId: number|null;
    public averaged: boolean|null;

    public constructor(init?: Partial<Goal>) { (Object as any).assign(this, init); }
}
(Goal as unknown)[immerable] = true;

export class CasePrintingGoal<T> extends Goal
{
    public entries: T[]|null;

    public constructor(init?: Partial<CasePrintingGoal<T>>) { super(init); (Object as any).assign(this, init); }
}

export class Fido2 implements IFido2
{

    public constructor(init?: Partial<Fido2>) { (Object as any).assign(this, init); }
}
(Fido2 as unknown)[immerable] = true;

export interface IPrivateOnlyCharge
{
    restrictToPrivateCharges: boolean|null;
}

export interface IClassFinanceResponse
{
    invoiceId: number|null;
    paymentId: number|null;
}

export enum NumericFilterConditions
{
    IsEqualTo = 'IsEqualTo',
    IsNotEqualTo = 'IsNotEqualTo',
    IsBetween = 'IsBetween',
    IsNotBetween = 'IsNotBetween',
    IsLessThan = 'IsLessThan',
    IsLessThanOrEqual = 'IsLessThanOrEqual',
    IsGreaterThan = 'IsGreaterThan',
    IsGreaterThanOrEqual = 'IsGreaterThanOrEqual',
}

export class NumericSearch<T>
{
    public selectedFilterOption: NumericFilterConditions|null;
    public numericRangeValue: NumericRange<T>|null;

    public constructor(init?: Partial<NumericSearch<T>>) { (Object as any).assign(this, init); }
}

export enum NetworkServiceType
{
    Appointment = 'Appointment',
    Cancellation = 'Cancellation',
    DNA = 'DNA',
}

export class BillingItemResponse
{

    public constructor(init?: Partial<BillingItemResponse>) { (Object as any).assign(this, init); }
}

export class AudienceMember
{
    public id: number|null;
    public num: number|null;
    public homeTelephone: string|null;
    public workTelephone: string|null;
    public mobileTelephone: string|null;
    public email: string|null;
    public addressLine1: string|null;
    public addressLine2: string|null;
    public addressLine3: string|null;
    public addressLine4: string|null;
    public addressLine5: string|null;
    public postCode: string|null;
    public title: string|null;
    public forename: string|null;
    public surname: string|null;
    public emailConsent: boolean|null;

    public constructor(init?: Partial<AudienceMember>) { (Object as any).assign(this, init); }
}
(AudienceMember as unknown)[immerable] = true;

export class DataPoint
{
    public period: string|null;
    public date: string|null;
    public referral: number|null;
    public reception: number|null;
    public online: number|null;

    public constructor(init?: Partial<DataPoint>) { (Object as any).assign(this, init); }
}
(DataPoint as unknown)[immerable] = true;

export class ClassSessionWithDetails
{
    public sessionId: number|null;
    public name: string|null;
    public description: string|null;
    public practitionerForename: string|null;
    public practitionerSurname: string|null;
    // @Ignore()
    public practitionerName: string|null;

    public startDate: string|null;
    public endDate: string|null;
    public isVideo: boolean|null;
    public videoMeetingPassword: string|null;
    public videoMeetingParticipantJoinUrl: string|null;
    public videoMeetingId: string|null;
    public videoMeetingHostJoinUrl: string|null;
    public videoMeetingProvider: VideoMeetingProvider|null;
    public classCapacity: number|null;
    public minAttendees: number|null;
    public totalAttendees: number|null;
    public appointmentStatus: number|null;
    public colour: number|null;
    public hexColour: string|null;
    public roomName: string|null;
    public locationName: string|null;

    public constructor(init?: Partial<ClassSessionWithDetails>) { (Object as any).assign(this, init); }
}
(ClassSessionWithDetails as unknown)[immerable] = true;

export class ReportingField
{
    public name: string|null;
    public field: string|null;
    public type: string|null;

    public constructor(init?: Partial<ReportingField>) { (Object as any).assign(this, init); }
}
(ReportingField as unknown)[immerable] = true;

export class ClinicalScoreEntry implements IHasId
{
    public id: number|null;
    public scoreId: number|null;
    public score: number|null;
    public dateAdded: string|null;
    public patientSubmitted: boolean|null;
    public objectType: string|null;
    public objectId: number|null;

    public constructor(init?: Partial<ClinicalScoreEntry>) { (Object as any).assign(this, init); }
}
(ClinicalScoreEntry as unknown)[immerable] = true;

export class GoalEntry implements IHasId
{
    public id: number|null;
    public notes: string|null;
    public goalId: number|null;
    public completionPercentage: number|null;
    public dateAdded: string|null;
    public patientSubmitted: boolean|null;
    public objectType: string|null;
    public objectId: number|null;

    public constructor(init?: Partial<GoalEntry>) { (Object as any).assign(this, init); }
}
(GoalEntry as unknown)[immerable] = true;

export interface IFido2
{
}

export class NumericRange<T>
{
    public from: string|null;
    public to: string|null;

    public constructor(init?: Partial<NumericRange<T>>) { (Object as any).assign(this, init); }
}

export class TableDataCell
{
    public value: string;
    public isHeader: boolean|null;

    public constructor(init?: Partial<TableDataCell>) { (Object as any).assign(this, init); }
}
(TableDataCell as unknown)[immerable] = true;

export class ResponseBase<T>
{
    // @ApiMember(ExcludeInSchema=true)
    public responseStatus: ResponseStatus|null;

    /** @description This will be returned when there is a single result available. (e.g. get single object by id) */
    // @ApiMember(Description="This will be returned when there is a single result available. (e.g. get single object by id)")
    public result: DigitalPrescriptionDMDResponse|null;

    /** @description This will be returned when there is a multiple results available (e.g. search or listing requests). */
    // @ApiMember(Description="This will be returned when there is a multiple results available (e.g. search or listing requests).")
    public results: DigitalPrescriptionDMDResponse[]|null;

    /** @description This will be returned when there is a multiple results available (e.g. search or listing requests). */
    // @ApiMember(Description="This will be returned when there is a multiple results available (e.g. search or listing requests).")
    public total: number|null;

    /** @description This will be return the amount of skipped rows when paginating */
    // @ApiMember(Description="This will be return the amount of skipped rows when paginating")
    public skip: number|null;

    public constructor(init?: Partial<ResponseBase<T>>) { (Object as any).assign(this, init); }
}

export class ZodSchemasResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ZodSchemasResponse>) { (Object as any).assign(this, init); }
}

export class HttpResult
{
    public responseText: string|null;
    public responseStream: string|null;
    public fileInfo: FileInfo|null;
    public virtualFile: IVirtualFile|null;
    public contentType: string|null;
    public headers: { [index:string]: string; }|null;
    public cookies: Cookie[]|null;
    public eTag: string|null;
    public age: string|null;
    public maxAge: string|null;
    public expires: string|null;
    public lastModified: string|null;
    public cacheControl: CacheControl|null;
    public resultScope: Func<IDisposable>|null;
    public allowsPartialResponse: boolean|null;
    public options: { [index:string]: string; }|null;
    public status: number|null;
    public statusCode: HttpStatusCode|null;
    public statusDescription: string|null;
    public response: Object|null;
    public responseFilter: IContentTypeWriter|null;
    public requestContext: IRequest|null;
    public view: string|null;
    public template: string|null;
    public paddingLength: number|null;
    public isPartialRequest: boolean|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<HttpResult>) { (Object as any).assign(this, init); }
}
(HttpResult as unknown)[immerable] = true;

// @DataContract
export class AuthenticateResponse implements IHasSessionId, IHasBearerToken
{
    // @DataMember(Order=1)
    public userId: string|null;

    // @DataMember(Order=2)
    public sessionId: string|null;

    // @DataMember(Order=3)
    public userName: string|null;

    // @DataMember(Order=4)
    public displayName: string|null;

    // @DataMember(Order=5)
    public referrerUrl: string|null;

    // @DataMember(Order=6)
    public bearerToken: string|null;

    // @DataMember(Order=7)
    public refreshToken: string|null;

    // @DataMember(Order=8)
    public refreshTokenExpiry: string|null;

    // @DataMember(Order=9)
    public profileUrl: string|null;

    // @DataMember(Order=10)
    public roles: string[]|null;

    // @DataMember(Order=11)
    public permissions: string[]|null;

    // @DataMember(Order=12)
    public authProvider: string|null;

    // @DataMember(Order=13)
    public responseStatus: ResponseStatus|null;

    // @DataMember(Order=14)
    public meta: { [index:string]: string; }|null;

    public constructor(init?: Partial<AuthenticateResponse>) { (Object as any).assign(this, init); }
}
(AuthenticateResponse as unknown)[immerable] = true;

// @Route("/tours/skip")
export class ToursResponse
{
    public homeScreenTour1: boolean|null;
    public diaryWorkingTimeTour1: boolean|null;
    public diaryCreateTour1: boolean|null;
    public diaryEditTour1: boolean|null;
    public diaryCompleteTour1: boolean|null;
    public diaryEventTour1: boolean|null;
    public invoiceWizardTour1: boolean|null;
    public licenseAgreement: boolean|null;
    public licenseAgreement0419: boolean|null;
    public seenWelcomeScreen: boolean|null;
    public previewNewUx: boolean|null;

    public constructor(init?: Partial<ToursResponse>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ToursResponse'; }
    public getMethod() { return 'PUT'; }
    public createResponse() {}
}
(ToursResponse as unknown)[immerable] = true;

export class OnlineCustomerDto implements IReturn<ResponseBase<T>>
{
    public title: string|null;
    public forename: string|null;
    public surname: string|null;
    public dateOfBirth: string|null;
    public homeTelephone: string|null;
    public workTelephone: string|null;
    public mobileTelephone: string|null;
    public gender: string|null;
    public email: string|null;
    public addressLine1: string|null;
    public addressLine2: string|null;
    public addressLine3: string|null;
    public addressLine4: string|null;
    public addressLine5: string|null;
    public postCode: string|null;
    public id: number|null;
    public group: OnlineGroupDto|null;
    public canBookAppointments: boolean|null;
    public practitionerGuid: string|null;
    public locationGuid: string|null;
    public groupReference: string|null;
    public excludedPackages: string[]|null;
    public lastAppointmentPractitionerGuid: string|null;
    public overridePayAtClinic: boolean|null;

    public constructor(init?: Partial<OnlineCustomerDto>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineCustomerDto'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(OnlineCustomerDto as unknown)[immerable] = true;

export class CurrentUser extends AuthenticateResponse
{
    public id: string|null;
    public name: string|null;
    public email: string|null;
    public mobileNumber: string|null;
    public clientId: number|null;
    public userType: string|null;
    public isAuthenticated: boolean|null;
    public isEvaluating: boolean|null;
    public settings: { [index:string]: Object; }|null;
    public practitioner: GeneralPractitionerResponse|null;
    public location: LocationResponse|null;
    public roleId: number|null;
    public practitionerId: number|null;
    public tM2UserName: string|null;
    public roleName: string|null;
    public userPermissionId: number|null;
    public tours: ToursResponse|null;
    public departments: number[]|null;
    public customer: OnlineCustomerDto|null;
    public userGlobalGuid: string|null;
    public hasTrialExpired: boolean|null;
    public needsVerified: boolean|null;
    public twoFactorSetup: boolean|null;
    public twoFactorRequired: boolean|null;
    public twoFactorAuthenticated: boolean|null;
    public hasPassKey: boolean|null;
    public twoFactorAllowSms: boolean|null;
    public avatar: string|null;
    public signatureRxIntegrationCode: string|null;
    public pinHash: string|null;
    public signature: string|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<CurrentUser>) { super(init); (Object as any).assign(this, init); }
}
(CurrentUser as unknown)[immerable] = true;

// @DataContract
export class FilesListingResponse
{
    // @DataMember(Order=1)
    public directory: FolderResult|null;

    // @DataMember(Order=2)
    public file: File|null;

    // @DataMember(Order=3)
    public responseStatus: ResponseStatus|null;

    public constructor(init?: Partial<FilesListingResponse>) { (Object as any).assign(this, init); }
}
(FilesListingResponse as unknown)[immerable] = true;

export class CaseImagingResponse
{
    public images: { [index:string]: CaseImagingResult; }|null;
    public custom: { [index:string]: CaseImagingResult; }|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<CaseImagingResponse>) { (Object as any).assign(this, init); }
}
(CaseImagingResponse as unknown)[immerable] = true;

export class SmsResponse
{
    public success: svcResponse|null;
    public message: string|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<SmsResponse>) { (Object as any).assign(this, init); }
}
(SmsResponse as unknown)[immerable] = true;

export class SmsConsentReponse
{
    public hasConsent: boolean|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<SmsConsentReponse>) { (Object as any).assign(this, init); }
}
(SmsConsentReponse as unknown)[immerable] = true;

export class ContactRecentResponse
{
    public contactsCount: number|null;
    public document: File|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ContactRecentResponse>) { (Object as any).assign(this, init); }
}
(ContactRecentResponse as unknown)[immerable] = true;

export class PatientNextAppoimentResponse
{
    public nextAppointment: AppointmentResponse|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<PatientNextAppoimentResponse>) { (Object as any).assign(this, init); }
}
(PatientNextAppoimentResponse as unknown)[immerable] = true;

export class PatientRecentResponse
{
    public nextAppointment: AppointmentResponse|null;
    public contact: MedicalContactResponse|null;
    public contactsCount: number|null;
    public bookedCount: number|null;
    public cancelledCount: number|null;
    public dnaCount: number|null;
    public completedCount: number|null;
    public auths: TreatmentAuthResponse[]|null;
    public futureAuths: TreatmentAuthResponse[]|null;
    public transactions: TransactionItemResponse[]|null;
    public cases: CaseSearchResponse[]|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<PatientRecentResponse>) { (Object as any).assign(this, init); }
}
(PatientRecentResponse as unknown)[immerable] = true;

export class RecentDocumentResponse
{
    public document: File|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<RecentDocumentResponse>) { (Object as any).assign(this, init); }
}
(RecentDocumentResponse as unknown)[immerable] = true;

export class DiaryDefaultDataForUserResponse
{
    public currentLocation: LocationResponse|null;
    public currentPractitioner: GeneralPractitionerResponse|null;
    public currentRoom: RoomResponse|null;
    public practitioners: GeneralPractitionerResponse[]|null;
    public locations: LocationResponse[]|null;
    public rooms: RoomResponse[]|null;
    public practitionerLocations: PractitionerLocation[]|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DiaryDefaultDataForUserResponse>) { (Object as any).assign(this, init); }
}
(DiaryDefaultDataForUserResponse as unknown)[immerable] = true;

export class DiaryStatsResponse
{
    public booked: number|null;
    public complete: number|null;
    public cancel: number|null;
    public other: number|null;
    public class: number|null;
    public dna: number|null;
    public total: number|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DiaryStatsResponse>) { (Object as any).assign(this, init); }
}
(DiaryStatsResponse as unknown)[immerable] = true;

export class CalculateWorkingTimesResponse
{
    public workingTime: string|null;
    public lastestEndDate: string|null;
    public totalSessions: number|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<CalculateWorkingTimesResponse>) { (Object as any).assign(this, init); }
}
(CalculateWorkingTimesResponse as unknown)[immerable] = true;

export class Account implements IHasId, IHasGlobalGuid
{
    public id: number|null;
    public accountType: string|null;
    public name: string|null;
    public accountTypeId: number|null;
    // @Ignore()
    public accountTypeGuid: string|null;

    public balanceInvoiced: number|null;
    public balanceOwed: number|null;
    public transferred: string|null;
    // @Ignore()
    public uninvoicedCharges: number|null;

    public globalGuid: string|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<Account>) { (Object as any).assign(this, init); }
}
(Account as unknown)[immerable] = true;

export class AccountExportResponse
{
    public exportId: number|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<AccountExportResponse>) { (Object as any).assign(this, init); }
}
(AccountExportResponse as unknown)[immerable] = true;

export class TransferResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<TransferResponse>) { (Object as any).assign(this, init); }
}
(TransferResponse as unknown)[immerable] = true;

export class ResponseEnhancerBase<T>
{
    public db: IClientDbAccess|null;
    public hangfireJobQueueService: IHangfireJobQueueService|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ResponseEnhancerBase<T>>) { (Object as any).assign(this, init); }
}

// @DataContract
export class DeleteResponse
{
    // @DataMember(Order=1)
    public success: boolean|null;

    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteResponse>) { (Object as any).assign(this, init); }
}
(DeleteResponse as unknown)[immerable] = true;

// @DataContract
export class CopyResponse
{
    // @DataMember(Order=1)
    public success: boolean|null;

    // @DataMember(Order=2)
    public isGlobal: boolean|null;

    // @DataMember(Order=3)
    public renamedFiles: { [index:string]: string; }|null;

    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<CopyResponse>) { (Object as any).assign(this, init); }
}
(CopyResponse as unknown)[immerable] = true;

// @DataContract
export class CreateFolderResponse
{
    // @DataMember(Order=1)
    public success: boolean|null;

    // @DataMember(Order=2)
    public folderName: string|null;

    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<CreateFolderResponse>) { (Object as any).assign(this, init); }
}
(CreateFolderResponse as unknown)[immerable] = true;

// @DataContract
export class RenameResponse
{
    // @DataMember(Order=1)
    public success: boolean|null;

    // @DataMember(Order=2)
    public fileName: string|null;

    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<RenameResponse>) { (Object as any).assign(this, init); }
}
(RenameResponse as unknown)[immerable] = true;

// @DataContract
export class MoveResponse
{
    // @DataMember(Order=1)
    public success: boolean|null;

    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<MoveResponse>) { (Object as any).assign(this, init); }
}
(MoveResponse as unknown)[immerable] = true;

// @DataContract
export class UploadResult
{
    // @DataMember(Order=1)
    public paths: string[]|null;

    // @DataMember(Order=2)
    public uploadErrors: string[]|null;

    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<UploadResult>) { (Object as any).assign(this, init); }
}
(UploadResult as unknown)[immerable] = true;

// @DataContract
export class UploadTempResult
{
    // @DataMember(Order=1)
    public id: string|null;

    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<UploadTempResult>) { (Object as any).assign(this, init); }
}
(UploadTempResult as unknown)[immerable] = true;

export class AttachmentSummaryResponse
{
    public files: Attachment[]|null;
    public templates: Attachment[]|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<AttachmentSummaryResponse>) { (Object as any).assign(this, init); }
}
(AttachmentSummaryResponse as unknown)[immerable] = true;

export class RecentFileResponse
{
    // @DataMember(Order=1)
    public file: File|null;

    // @DataMember(Order=2)
    public responseStatus: ResponseStatus|null;

    public constructor(init?: Partial<RecentFileResponse>) { (Object as any).assign(this, init); }
}
(RecentFileResponse as unknown)[immerable] = true;

// @DataContract
export class FileResponse
{
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus|null;

    // @DataMember(Order=2)
    public contents: string|null;

    // @DataMember(Order=3)
    public contentLength: number|null;

    public constructor(init?: Partial<FileResponse>) { (Object as any).assign(this, init); }
}
(FileResponse as unknown)[immerable] = true;

export class FolderTree
{
    public folders: FolderTree[]|null;
    public files: File[]|null;
    public name: string|null;
    public path: string|null;
    public fileCount: number|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<FolderTree>) { (Object as any).assign(this, init); }
}
(FolderTree as unknown)[immerable] = true;

export class GroupFurtherDetailsResponse
{
    public location: string|null;
    public balanceOwed: number|null;
    public balanceInvoiced: number|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GroupFurtherDetailsResponse>) { (Object as any).assign(this, init); }
}
(GroupFurtherDetailsResponse as unknown)[immerable] = true;

export class GroupRecentResponse
{
    public contactsCount: number|null;
    public transactions: TransactionItemResponse[]|null;
    public accountBalance: number|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GroupRecentResponse>) { (Object as any).assign(this, init); }
}
(GroupRecentResponse as unknown)[immerable] = true;

export class LocationStockResponse
{
    public locations: LocResponse[]|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<LocationStockResponse>) { (Object as any).assign(this, init); }
}
(LocationStockResponse as unknown)[immerable] = true;

export class PhysiotecPractitioner implements IHasId
{
    public id: number|null;
    public practitionerId: number|null;
    public userName: string|null;
    public password: string|null;
    public status: string|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<PhysiotecPractitioner>) { (Object as any).assign(this, init); }
}
(PhysiotecPractitioner as unknown)[immerable] = true;

// @Route("/pronto-my-clinic-url")
export class ProntoMyClinicRequest implements IReturn<ProntoMyClinicRequest>
{
    public result: string|null;

    public constructor(init?: Partial<ProntoMyClinicRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProntoMyClinicRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ProntoMyClinicRequest(); }
}
(ProntoMyClinicRequest as unknown)[immerable] = true;

export class Room implements IHasId, IHasGlobalGuid
{
    public id: number|null;
    public description: string|null;
    public locationId: number|null;
    // @Ignore()
    public locationGuid: string|null;

    public status: boolean|null;
    public colour: number|null;
    public discriminatorType: string|null;
    public globalGuid: string|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<Room>) { (Object as any).assign(this, init); }
}
(Room as unknown)[immerable] = true;

export class SecurityStatsResponse
{
    public stats: SecurityStat[]|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<SecurityStatsResponse>) { (Object as any).assign(this, init); }
}
(SecurityStatsResponse as unknown)[immerable] = true;

export class StockReorderResponse
{
    public results: StockReorder[]|null;
    public totals: { [index:string]: number; }|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<StockReorderResponse>) { (Object as any).assign(this, init); }
}
(StockReorderResponse as unknown)[immerable] = true;

export class StockSalesResponse
{
    public results: StockSales[]|null;
    public totals: { [index:string]: number; }|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<StockSalesResponse>) { (Object as any).assign(this, init); }
}
(StockSalesResponse as unknown)[immerable] = true;

export class InvoiceAnalysisResponse
{
    public results: InvoiceAnalysisReport[]|null;
    public totals: { [index:string]: number; }|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<InvoiceAnalysisResponse>) { (Object as any).assign(this, init); }
}
(InvoiceAnalysisResponse as unknown)[immerable] = true;

export class IncomeAnalysisResponse
{
    public results: IncomeAnalysisReport[]|null;
    public totals: { [index:string]: number; }|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<IncomeAnalysisResponse>) { (Object as any).assign(this, init); }
}
(IncomeAnalysisResponse as unknown)[immerable] = true;

export class ExpenditureMonthSummaryResponse
{
    public results: ExpenditureMonthSummary[]|null;
    public totals: { [index:string]: number; }|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ExpenditureMonthSummaryResponse>) { (Object as any).assign(this, init); }
}
(ExpenditureMonthSummaryResponse as unknown)[immerable] = true;

export class ExpenditureAnalysisResponse
{
    public results: ExpenditureAnalysisReportDto[]|null;
    public totals: { [index:string]: number; }|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ExpenditureAnalysisResponse>) { (Object as any).assign(this, init); }
}
(ExpenditureAnalysisResponse as unknown)[immerable] = true;

export class AgedDebtorsResponse
{
    public results: AgedDebtors[]|null;
    public totals: { [index:string]: number; }|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<AgedDebtorsResponse>) { (Object as any).assign(this, init); }
}
(AgedDebtorsResponse as unknown)[immerable] = true;

export class DebtorsByAccountResponse
{
    public results: DebtorsByAccount[]|null;
    public totals: { [index:string]: number; }|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DebtorsByAccountResponse>) { (Object as any).assign(this, init); }
}
(DebtorsByAccountResponse as unknown)[immerable] = true;

export class DebtorsOnADateResponse
{
    public results: DebtorsOnADate[]|null;
    public totals: { [index:string]: number; }|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DebtorsOnADateResponse>) { (Object as any).assign(this, init); }
}
(DebtorsOnADateResponse as unknown)[immerable] = true;

export class ChargeAnalysisResponse
{
    public results: ChargesAnalysisReport[]|null;
    public totals: { [index:string]: number; }|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ChargeAnalysisResponse>) { (Object as any).assign(this, init); }
}
(ChargeAnalysisResponse as unknown)[immerable] = true;

export class AdmissionsAnalysisReportResponse
{
    public results: AdmissionsAnalysisReport[]|null;
    public total: number|null;
    public totals: { [index:string]: number; }|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<AdmissionsAnalysisReportResponse>) { (Object as any).assign(this, init); }
}
(AdmissionsAnalysisReportResponse as unknown)[immerable] = true;

export class CasesDueForReviewReportResponse
{
    public results: CasesDueForReviewReport[]|null;
    public total: number|null;
    public totals: { [index:string]: number; }|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<CasesDueForReviewReportResponse>) { (Object as any).assign(this, init); }
}
(CasesDueForReviewReportResponse as unknown)[immerable] = true;

export class LapsedPatientsReportResponse
{
    public results: LapsedPatientsReport[]|null;
    public totals: { [index:string]: number; }|null;
    public total: number|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<LapsedPatientsReportResponse>) { (Object as any).assign(this, init); }
}
(LapsedPatientsReportResponse as unknown)[immerable] = true;

export class ClientBirthdayResponse
{
    public results: ClientBirthdayReport[]|null;
    public totals: { [index:string]: number; }|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ClientBirthdayResponse>) { (Object as any).assign(this, init); }
}
(ClientBirthdayResponse as unknown)[immerable] = true;

export class Location implements IHasId, ILocationId, IHasGlobalGuid
{
    public id: number|null;
    public name: string|null;
    public addressLine1: string|null;
    public addressLine2: string|null;
    public addressLine3: string|null;
    public addressLine4: string|null;
    public addressLine5: string|null;
    public postCode: string|null;
    public telephone: string|null;
    public email: string|null;
    public web: string|null;
    public fax: string|null;
    public status: number|null;
    public onlineGuid: string|null;
    public dnaStockId: number|null;
    public cancelStockId: number|null;
    // @Ignore()
    public dnaStockGuid: string|null;

    // @Ignore()
    public cancelStockGuid: string|null;

    public isNetworkLocation: boolean|null;
    public isTemplateLocation: boolean|null;
    public directions: string|null;
    public services: string|null;
    public region: string|null;
    public reminderTemplateEmail_TM3: string|null;
    public reminderTemplateSMS_TM3: string|null;
    public facilities: string|null;
    public locationLong: number|null;
    public locationLat: number|null;
    public hasCoordinates: boolean|null;
    public isMainLocation: boolean|null;
    // @Ignore()
    public fullAddressMultiLine: string|null;

    // @Ignore()
    public locationId: number|null;

    // @Ignore()
    public globalGuid: string|null;

    /** @description For ClearAccept, this is the Location's Merchant Site ID */
    public merchantReference: string|null;
    public trackingCategory: string|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<Location>) { (Object as any).assign(this, init); }
}
(Location as unknown)[immerable] = true;

export class DiagnosisCode implements IHasId
{
    public id: number|null;
    public text: string|null;
    public bodySite: string|null;
    public mapping: string|null;
    public serviceTypeId: number|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DiagnosisCode>) { (Object as any).assign(this, init); }
}
(DiagnosisCode as unknown)[immerable] = true;

export class ClinicalSettingsFlagsResponse
{
    public flags: ConfigResponse[]|null;
    public flagValues: CustomListItemResponse[]|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ClinicalSettingsFlagsResponse>) { (Object as any).assign(this, init); }
}
(ClinicalSettingsFlagsResponse as unknown)[immerable] = true;

// @Route("/client/sms/settings")
export class ClientSmsSettings implements IReturn<ClientSmsSettings>
{
    public clientId: number|null;
    public fromMode: FromMode|null;
    public fromText: string|null;
    public fromNumber: string|null;
    public returnEmail: string|null;
    public fromNumbers: string[]|null;

    public constructor(init?: Partial<ClientSmsSettings>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClientSmsSettings'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ClientSmsSettings(); }
}
(ClientSmsSettings as unknown)[immerable] = true;

// @Route("/client/sms/settings/code")
export class ClientCodeRequest implements IReturn<ClientCodeRequest>
{
    public clientId: number|null;
    public code: string|null;

    public constructor(init?: Partial<ClientCodeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClientCodeRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ClientCodeRequest(); }
}
(ClientCodeRequest as unknown)[immerable] = true;

export class CaseAuditResponse
{
    public caseClosed: boolean|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<CaseAuditResponse>) { (Object as any).assign(this, init); }
}
(CaseAuditResponse as unknown)[immerable] = true;

// @Route("/cases/{Id}", "PUT")
// @Route("/cases/", "POST")
export class CaseDetailsDto implements IReturn<CaseDetailsDto>, ILocationIds, IServiceTypeId
{
    public id: number|null;
    public case: CaseWithCustomerPractitionerLocationDetails|null;
    public serviceTypeId: number|null;
    public graphics: GraphicResult[]|null;
    public images: ImageResult[]|null;
    public other: CaseSummaryResult[]|null;
    public linked: CaseSummaryResult[]|null;
    public stats: Object|null;
    public recentModalities: ConsultationItem[]|null;
    public recentAssessments: ConsultationItem[]|null;
    public postCloseNotes: PostCloseNotesWithUser[]|null;
    public appointmentId: number|null;
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;
    public meta: { [index:string]: Object; }|null;
    public availableGoals: CaseScoreGoalResponse[]|null;
    public availableScores: CaseScoreGoalResponse[]|null;
    public viewed: boolean|null;

    public constructor(init?: Partial<CaseDetailsDto>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseDetailsDto'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CaseDetailsDto(); }
}
(CaseDetailsDto as unknown)[immerable] = true;

export class ClinicalCacheResponse
{
    public practitioners: { [index:number]: string; }|null;
    public medicalContacts: { [index:number]: string; }|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ClinicalCacheResponse>) { (Object as any).assign(this, init); }
}
(ClinicalCacheResponse as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/consultation/{TreatmentId}/items", "POST")
// @Route("/cases/{CaseId}/consultation/{TreatmentId}/items/{Id}", "GET, PUT, DELETE")
export class ConsultationItemRequest implements IReturn<ConsultationItemRequest>, ISecurityId
{
    public id: number|null;
    public caseId: number|null;
    public treatmentId: number|null;
    public templateId: string|null;
    public title: string|null;
    public date: string|null;
    public type: ConsultationItemType|null;
    public data: { [index:string]: Object; }|null;
    public securityId: number|null;

    public constructor(init?: Partial<ConsultationItemRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ConsultationItemRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ConsultationItemRequest(); }
}
(ConsultationItemRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/consultation/{TreatmentId}/items", "POST")
export class ConsultationAssessmentItemRequest implements IReturn<ConsultationAssessmentItemRequest>, ISecurityId
{
    public id: number|null;
    public caseId: number|null;
    public treatmentId: number|null;
    public templateId: string|null;
    public title: string|null;
    public date: string|null;
    public type: ConsultationItemType|null;
    public data: { [index:string]: Object; }|null;
    public securityId: number|null;

    public constructor(init?: Partial<ConsultationAssessmentItemRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ConsultationAssessmentItemRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ConsultationAssessmentItemRequest(); }
}
(ConsultationAssessmentItemRequest as unknown)[immerable] = true;

export class ClinicalDiagram implements IHasId
{
    public id: number|null;
    public caseId: number|null;
    public treatmentId: number|null;
    public closedUser: string|null;
    public dateTime: string|null;
    public closedDateTime: string|null;
    public closedUserId: number|null;
    public value: { [index:string]: Object; }[]|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ClinicalDiagram>) { (Object as any).assign(this, init); }
}
(ClinicalDiagram as unknown)[immerable] = true;

export class TreatmentResult extends Treatment
{
    public practitioner: string|null;
    public practitionerNameWithAwards: string|null;
    public assessments: AssessmentResult[]|null;
    public items: CaseConsultationItem[]|null;
    public hexColour: string|null;
    public postCloseNotes: PostCloseNotesWithUser[]|null;
    public createdByUserName: string|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<TreatmentResult>) { super(init); (Object as any).assign(this, init); }
}
(TreatmentResult as unknown)[immerable] = true;

export class AssertionOptions extends Fido2ResponseBase
{
    public challenge: string|null;
    public timeout: number|null;
    public rpId: string|null;
    public allowCredentials: PublicKeyCredentialDescriptor[]|null;
    public userVerification: UserVerificationRequirement|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<AssertionOptions>) { super(init); (Object as any).assign(this, init); }
}
(AssertionOptions as unknown)[immerable] = true;

export class CaseAlertSearchResponse extends ResponseBase<AlertResponse>
{
    public customerHasAlertsFromMultipleCases: boolean|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<CaseAlertSearchResponse>) { super(init); (Object as any).assign(this, init); }
}
(CaseAlertSearchResponse as unknown)[immerable] = true;

export class AlertDialogResponse extends Alert
{
    public alertForPerson: string|null;
    public alertForDate: string|null;
    public alertExpiryDate: string|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<AlertDialogResponse>) { super(init); (Object as any).assign(this, init); }
}
(AlertDialogResponse as unknown)[immerable] = true;

export class OAuthCallbackResponse
{
    public idToken: string|null;
    public accessToken: string|null;
    public refreshToken: string|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<OAuthCallbackResponse>) { (Object as any).assign(this, init); }
}
(OAuthCallbackResponse as unknown)[immerable] = true;

export class OnlineSettingsResponse
{
    public isVHG: boolean|null;
    public isSiteLive: boolean|null;
    public siteTitle: string|null;
    public title: string|null;
    public logoUrl: string|null;
    public appIconUrl: string|null;
    public customColourPrimary: string|null;
    public customColourSecondary: string|null;
    public customColourNav: string|null;
    public customColourNavText: string|null;
    public message: string|null;
    public skin: string|null;
    public confirmSubject: string|null;
    public confirmFrom: string|null;
    public connectEnabled: boolean|null;
    public cancellationPolicy: string|null;
    public termsAndConditions: string|null;
    public privacyPolicy: string|null;
    public license: License|null;
    public clinical: boolean|null;
    public payments: boolean|null;
    public classes: boolean|null;
    public registerProvisional: boolean|null;
    public allowClassBooking: boolean|null;
    public allowRegister: boolean|null;
    public allowPayAtClinic: boolean|null;
    public currency: string|null;
    public googleTrackingId: string|null;
    public googleTagManagerContainerId: string|null;
    public dobRequired: boolean|null;
    public stripeEnabled: boolean|null;
    public squareEnabled: boolean|null;
    public stripeApiKey: string|null;
    public squareApplicationId: string|null;
    public isSquareSandboxMode: boolean|null;
    public showSiteTitle: boolean|null;
    public useExtraAddressLine: boolean|null;
    public labels: DynamicLabelResponse[]|null;
    public videoIntegration: string|null;
    public hasZoomPro: boolean|null;
    public stripeAccount: string|null;
    public saveCardMessage: string|null;
    public clearAcceptEnabled: boolean|null;
    public recaptchaSiteKey: string|null;
    public recaptchaEnabled: boolean|null;
    public allowWaitingListPayments: boolean|null;
    public connectJuneAnalyticsWriteKey: string|null;
    public useAllDeliveryMethodsForAccessCode: boolean|null;
    public unauthenticatedMessage: string|null;
    public applePayEnabled: boolean|null;
    public currencyCode: string|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<OnlineSettingsResponse>) { (Object as any).assign(this, init); }
}
(OnlineSettingsResponse as unknown)[immerable] = true;

export class AppointmentSearchResponse
{
    public locationIds: string[]|null;
    public responseStatus: ResponseStatus|null;
    public appointments: AppointmentSearchResult[]|null;
    public latestAppointmentDate: string|null;
    public earliestAppointmentDate: string|null;
    public practitionerIds: string[]|null;
    public practitionerGenders: string[]|null;

    public constructor(init?: Partial<AppointmentSearchResponse>) { (Object as any).assign(this, init); }
}
(AppointmentSearchResponse as unknown)[immerable] = true;

export class ReserveAppointmentResponse
{
    public appointment: AppointmentDto|null;
    public backgroundJobId: string|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ReserveAppointmentResponse>) { (Object as any).assign(this, init); }
}
(ReserveAppointmentResponse as unknown)[immerable] = true;

export class OnlineAutoLoginVerifyCodeResponse
{
    public onlineAutoLoginAuthenticationResult: OnlineAutoLoginAuthenticationResult|null;
    public response: AuthenticateResponse|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<OnlineAutoLoginVerifyCodeResponse>) { (Object as any).assign(this, init); }
}
(OnlineAutoLoginVerifyCodeResponse as unknown)[immerable] = true;

export class StripeOAuthResponse
{
    public accountId: string|null;
    public redirectUrl: string|null;
    public error: string|null;
    public errorMessage: string|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<StripeOAuthResponse>) { (Object as any).assign(this, init); }
}
(StripeOAuthResponse as unknown)[immerable] = true;

export class ZoomLinkToTM3Response
{
    public status: HttpStatusCode|null;
    public redirectUri: string|null;
    public message: string|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ZoomLinkToTM3Response>) { (Object as any).assign(this, init); }
}
(ZoomLinkToTM3Response as unknown)[immerable] = true;

export class WorkSheetResponse
{
    public id: number|null;
    public status: WorkSheetStatus|null;
    public date: string|null;
    public addressedTo: string;
    public mileage: number|null;
    public mechanicId: number|null;
    public locationId: number|null;
    public appointmentId: number|null;
    public adviserId: number|null;
    public reference: string;
    public total: number|null;
    public invoiceId: number|null;
    public vehicle: VehicleResponse;
    public customer: GeneralCustomerResponse;
    public type: WorkSheetType|null;
    public items: WorkSheetItemResponse[] = [];
    public printPath: string;
    public idClonedFrom: number|null;
    public dueDate: string|null;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<WorkSheetResponse>) { (Object as any).assign(this, init); }
}
(WorkSheetResponse as unknown)[immerable] = true;

export class EstimateResponse extends WorkSheetResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<EstimateResponse>) { super(init); (Object as any).assign(this, init); }
}
(EstimateResponse as unknown)[immerable] = true;

// @DataContract
export class AssignRolesResponse
{
    // @DataMember(Order=1)
    public allRoles: string[]|null;

    // @DataMember(Order=2)
    public allPermissions: string[]|null;

    // @DataMember(Order=3)
    public meta: { [index:string]: string; }|null;

    // @DataMember(Order=4)
    public responseStatus: ResponseStatus|null;

    public constructor(init?: Partial<AssignRolesResponse>) { (Object as any).assign(this, init); }
}
(AssignRolesResponse as unknown)[immerable] = true;

// @DataContract
export class UnAssignRolesResponse
{
    // @DataMember(Order=1)
    public allRoles: string[]|null;

    // @DataMember(Order=2)
    public allPermissions: string[]|null;

    // @DataMember(Order=3)
    public meta: { [index:string]: string; }|null;

    // @DataMember(Order=4)
    public responseStatus: ResponseStatus|null;

    public constructor(init?: Partial<UnAssignRolesResponse>) { (Object as any).assign(this, init); }
}
(UnAssignRolesResponse as unknown)[immerable] = true;

// @DataContract
export class GetAccessTokenResponse
{
    // @DataMember(Order=1)
    public accessToken: string|null;

    // @DataMember(Order=2)
    public meta: { [index:string]: string; }|null;

    // @DataMember(Order=3)
    public responseStatus: ResponseStatus|null;

    public constructor(init?: Partial<GetAccessTokenResponse>) { (Object as any).assign(this, init); }
}
(GetAccessTokenResponse as unknown)[immerable] = true;

export class DigitalPrescriptionDMDRequest implements IReturn<ResponseBase<DigitalPrescriptionDMDResponse>>
{
    public term: string|null;

    public constructor(init?: Partial<DigitalPrescriptionDMDRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DigitalPrescriptionDMDRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<DigitalPrescriptionDMDResponse>(); }
}
(DigitalPrescriptionDMDRequest as unknown)[immerable] = true;

// @Route("/validation")
export class GetZodSchemasRequest implements IReturn<ZodSchemasResponse>
{

    public constructor(init?: Partial<GetZodSchemasRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetZodSchemasRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ZodSchemasResponse(); }
}

export class GetTwilioRoom implements IReturn<ResponseBase<TwilioRoomResponse>>
{
    public appointmentId: number|null;

    public constructor(init?: Partial<GetTwilioRoom>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTwilioRoom'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<TwilioRoomResponse>(); }
}
(GetTwilioRoom as unknown)[immerable] = true;

export class TwilioReminderRequest implements IReturn<ResponseBase<boolean>>
{
    public videoCode: string|null;

    public constructor(init?: Partial<TwilioReminderRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TwilioReminderRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(TwilioReminderRequest as unknown)[immerable] = true;

export class GetTwilioOnlineRoom implements IReturn<ResponseBase<TwilioRoomResponse>>
{
    public videoCode: string|null;

    public constructor(init?: Partial<GetTwilioOnlineRoom>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTwilioOnlineRoom'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<TwilioRoomResponse>(); }
}
(GetTwilioOnlineRoom as unknown)[immerable] = true;

// @Route("/square/webhook")
export class SquareWebhookRequest implements IReturn<HttpResult>
{
    public merchant_id: string|null;
    public type: string|null;
    public event_id: string|null;
    public created_at: string|null;
    public data: SquareWebhookData|null;

    public constructor(init?: Partial<SquareWebhookRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SquareWebhookRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new HttpResult(); }
}
(SquareWebhookRequest as unknown)[immerable] = true;

// @Route("/worldpay/notification")
export class WorldPayNotificationRequest
{
    public requestStream: string|null;

    public constructor(init?: Partial<WorldPayNotificationRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WorldPayNotificationRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(WorldPayNotificationRequest as unknown)[immerable] = true;

// @Route("/worldpay/dns/flush")
export class WorldPayFlushDnsCacheRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<WorldPayFlushDnsCacheRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WorldPayFlushDnsCacheRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(WorldPayFlushDnsCacheRequest as unknown)[immerable] = true;

export class WorldPayChargeTokenRequest implements IReturn<ResponseBase<WorldPayResponse>>
{
    public reference: string|null;
    public amount: number|null;
    public customerId: number|null;

    public constructor(init?: Partial<WorldPayChargeTokenRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WorldPayChargeTokenRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<WorldPayResponse>(); }
}
(WorldPayChargeTokenRequest as unknown)[immerable] = true;

export class WorldPayRefundRequest implements IReturn<ResponseBase<WorldPayResponse>>
{
    public incomeId: number|null;
    public reference: string|null;
    public amount: number|null;

    public constructor(init?: Partial<WorldPayRefundRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WorldPayRefundRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<WorldPayResponse>(); }
}
(WorldPayRefundRequest as unknown)[immerable] = true;

export class WorldPayHostedPaymentPageRequest implements IReturn<ResponseBase<WorldPayResponse>>
{
    public customerId: number|null;
    public amount: number|null;
    public reference: string|null;

    public constructor(init?: Partial<WorldPayHostedPaymentPageRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WorldPayHostedPaymentPageRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<WorldPayResponse>(); }
}
(WorldPayHostedPaymentPageRequest as unknown)[immerable] = true;

export class WorldPayWaitingTokenRequest implements IReturn<ResponseBase<T>>
{
    public orderCode: string|null;
    public customerId: number|null;

    public constructor(init?: Partial<WorldPayWaitingTokenRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WorldPayWaitingTokenRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(WorldPayWaitingTokenRequest as unknown)[immerable] = true;

export class StripeOnboardRequest
{
    public code: string|null;

    public constructor(init?: Partial<StripeOnboardRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StripeOnboardRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(StripeOnboardRequest as unknown)[immerable] = true;

export class StripeTerminalLocationsRequest implements IReturn<ResponseBase<StripeTerminalLocationsResponse>>
{
    public terminalLocationId: string|null;

    public constructor(init?: Partial<StripeTerminalLocationsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StripeTerminalLocationsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<StripeTerminalLocationsResponse>(); }
}
(StripeTerminalLocationsRequest as unknown)[immerable] = true;

// @Route("/autopay")
export class AutoPayRequest implements IReturn<ResponseBase<T>>
{
    public invoiceIds: number[]|null;
    public appointmentId: number|null;

    public constructor(init?: Partial<AutoPayRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AutoPayRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(AutoPayRequest as unknown)[immerable] = true;

// @Route("/autopay/cancel")
export class CancelChaseRequest
{
    public invoiceId: number|null;
    public appointmentId: number|null;

    public constructor(init?: Partial<CancelChaseRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CancelChaseRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(CancelChaseRequest as unknown)[immerable] = true;

// @Route("/autopay/resend")
export class ResendChaseEmailRequest
{
    public invoiceId: number|null;
    public appointmentId: number|null;

    public constructor(init?: Partial<ResendChaseEmailRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ResendChaseEmailRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(ResendChaseEmailRequest as unknown)[immerable] = true;

export class GetDiscountCodesRequest implements IReturn<ResponseBase<DiscountCodeDto>>
{
    public appointmentDate: string|null;
    public getInUseFlag: boolean|null;
    public discountCodeId: string|null;

    public constructor(init?: Partial<GetDiscountCodesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDiscountCodesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<DiscountCodeDto>(); }
}
(GetDiscountCodesRequest as unknown)[immerable] = true;

// @Route("/applicablediscountcodes/{InvoiceId}", "GET")
export class GetApplicableDiscountCodes implements IReturn<ResponseBase<DiscountCodeDto>>
{
    public invoiceId: number|null;

    public constructor(init?: Partial<GetApplicableDiscountCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetApplicableDiscountCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<DiscountCodeDto>(); }
}
(GetApplicableDiscountCodes as unknown)[immerable] = true;

// @Route("/getDiscountCodesBillingItem", "POST")
export class GetDiscountCodeBillingItem implements IReturn<ResponseBase<BillingItem>>
{
    public billingItem: BillingItem|null;
    public discountCodeId: string|null;

    public constructor(init?: Partial<GetDiscountCodeBillingItem>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDiscountCodeBillingItem'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<BillingItem>(); }
}
(GetDiscountCodeBillingItem as unknown)[immerable] = true;

// @Route("/diary/eventtypes", "GET, POST, DELETE")
export class DiaryEventTypesDto implements IReturn<ResponseBase<DiaryEventTypesDto>>
{
    public id: number|null;
    public name: string|null;
    public colour: string|null;

    public constructor(init?: Partial<DiaryEventTypesDto>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DiaryEventTypesDto'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<DiaryEventTypesDto>(); }
}
(DiaryEventTypesDto as unknown)[immerable] = true;

// @Route("/files/referrer-logo/{Path*}")
export class ClickReferrerLogoRequest implements IReturn<HttpResult>
{
    public path: string|null;

    public constructor(init?: Partial<ClickReferrerLogoRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickReferrerLogoRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new HttpResult(); }
}
(ClickReferrerLogoRequest as unknown)[immerable] = true;

export class AddressSearchRequest implements IReturn<ResponseBase<AddressFindResponse>>
{
    public term: string|null;
    public container: string|null;

    public constructor(init?: Partial<AddressSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AddressSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<AddressFindResponse>(); }
}
(AddressSearchRequest as unknown)[immerable] = true;

export class AddressRetrieveRequest implements IReturn<ResponseBase<AddressRetrieveResponse>>
{
    public id: string|null;

    public constructor(init?: Partial<AddressRetrieveRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AddressRetrieveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<AddressRetrieveResponse>(); }
}
(AddressRetrieveRequest as unknown)[immerable] = true;

// @Route("/reminder/data")
export class ReminderDataRequest implements ILocationId
{
    public isEmail: boolean|null;
    public practitionerIds: number[]|null;
    public locationId: number|null;
    public appointmentId: number|null;
    public day: string|null;

    public constructor(init?: Partial<ReminderDataRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReminderDataRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(ReminderDataRequest as unknown)[immerable] = true;

// @Route("/reminder/last")
export class LastReminderRequest
{

    public constructor(init?: Partial<LastReminderRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LastReminderRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(LastReminderRequest as unknown)[immerable] = true;

// @Route("/reminder/send")
export class ReminderSendRequest implements ILocationId
{
    public sendSms: boolean|null;
    public sendEmail: boolean|null;
    public appointmentIds: number[]|null;
    public locationId: number|null;
    public forceSend: boolean|null;

    public constructor(init?: Partial<ReminderSendRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReminderSendRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(ReminderSendRequest as unknown)[immerable] = true;

// @Route("/user/first/verify")
export class FirstUserVerifyRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<FirstUserVerifyRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FirstUserVerifyRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(FirstUserVerifyRequest as unknown)[immerable] = true;

// @Route("/user/email/verify")
export class EmailVerificationRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<EmailVerificationRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EmailVerificationRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(EmailVerificationRequest as unknown)[immerable] = true;

// @Route("/user/auto/login")
export class AutoLoginRequest implements IReturn<CurrentUser>
{
    public token: string|null;

    public constructor(init?: Partial<AutoLoginRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AutoLoginRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CurrentUser(); }
}
(AutoLoginRequest as unknown)[immerable] = true;

// @Route("/user/auto/redirect")
export class AutoRedirectRequest implements IReturn<string>
{
    public password: string|null;
    public verificationCode: string|null;

    public constructor(init?: Partial<AutoRedirectRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AutoRedirectRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return ''; }
}
(AutoRedirectRequest as unknown)[immerable] = true;

// @Route("/permissions/rules", "GET")
export class JsonPermissionRuleRequest implements IReturn<ResponseBase<string>>
{

    public constructor(init?: Partial<JsonPermissionRuleRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'JsonPermissionRuleRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<string>(); }
}
(JsonPermissionRuleRequest as unknown)[immerable] = true;

// @Route("/permissions/all", "GET")
export class JsonPermissionRequest implements IReturn<ResponseBase<JsonPermissionResponse>>
{

    public constructor(init?: Partial<JsonPermissionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'JsonPermissionRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<JsonPermissionResponse>(); }
}
(JsonPermissionRequest as unknown)[immerable] = true;

// @Route("/permissions/roles", "GET")
export class JsonPermissionGetRequest implements IReturn<ResponseBase<JsonPermissionGetResponse>>
{

    public constructor(init?: Partial<JsonPermissionGetRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'JsonPermissionGetRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<JsonPermissionGetResponse>(); }
}
(JsonPermissionGetRequest as unknown)[immerable] = true;

// @Route("/permissions/roles/rename", "POST")
export class JsonPermissionRenameRequest implements IReturn<ResponseBase<T>>
{
    public id: number|null;
    public shortDescription: string|null;
    public newRoleName: string|null;

    public constructor(init?: Partial<JsonPermissionRenameRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'JsonPermissionRenameRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(JsonPermissionRenameRequest as unknown)[immerable] = true;

// @Route("/permissions/roles/update", "POST")
export class JsonPermissionUpdateRequest implements IReturn<ResponseBase<T>>
{
    public id: number|null;
    public shortDescription: string|null;
    public jsonPermissions: string|null;

    public constructor(init?: Partial<JsonPermissionUpdateRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'JsonPermissionUpdateRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(JsonPermissionUpdateRequest as unknown)[immerable] = true;

// @Route("/permissions/roles/clone", "POST")
export class JsonPermissionCloneRequest implements IReturn<ResponseBase<T>>
{
    public id: number|null;
    public shortDescription: string|null;

    public constructor(init?: Partial<JsonPermissionCloneRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'JsonPermissionCloneRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(JsonPermissionCloneRequest as unknown)[immerable] = true;

// @Route("/permissions/roles/add", "POST")
export class JsonPermissionAddRequest implements IReturn<ResponseBase<T>>
{
    public shortDescription: string|null;

    public constructor(init?: Partial<JsonPermissionAddRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'JsonPermissionAddRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(JsonPermissionAddRequest as unknown)[immerable] = true;

// @Route("/permissions/roles/delete", "POST")
export class JsonPermissionDeleteRequest implements IReturn<ResponseBase<T>>
{
    public id: number|null;
    public shortDescription: string|null;

    public constructor(init?: Partial<JsonPermissionDeleteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'JsonPermissionDeleteRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(JsonPermissionDeleteRequest as unknown)[immerable] = true;

// @Route("/users/all")
export class AllUsersLocationRequest extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<UsersSearchResponse>>
{
    public username: string|null;
    public status: boolean|null;
    public fullname: string|null;
    public practitioner: number|null;

    public constructor(init?: Partial<AllUsersLocationRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'AllUsersLocationRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<UsersSearchResponse>(); }
}
(AllUsersLocationRequest as unknown)[immerable] = true;

// @Route("/users/allWorkflowUsers")
export class AllWorkflowUsersLocationRequest implements IReturn<ResponseBase<UsersSearchResponse>>, ILocationIds
{
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;
    public username: string|null;
    public status: boolean|null;
    public fullname: string|null;
    public practitioner: number|null;
    public term: string|null;
    public sort: QueryField[]|null;
    public skip: number|null;
    public take: number|null;

    public constructor(init?: Partial<AllWorkflowUsersLocationRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AllWorkflowUsersLocationRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<UsersSearchResponse>(); }
}
(AllWorkflowUsersLocationRequest as unknown)[immerable] = true;

// @Route("/user/email/{Id}", "GET")
export class UserEmailRequest implements ISecurityId
{
    public id: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<UserEmailRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UserEmailRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(UserEmailRequest as unknown)[immerable] = true;

// @Route("/user/email/reset")
export class UserEmailReset implements IReturn<ResponseBase<boolean>>
{
    public id: number|null;
    public email: string|null;
    public saveEmail: boolean|null;

    public constructor(init?: Partial<UserEmailReset>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UserEmailReset'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(UserEmailReset as unknown)[immerable] = true;

export class UserResetRequest implements IReturn<ResponseBase<boolean>>, ILocationId
{
    public mode: ResetMode|null;
    public id: number|null;
    public customerId: number|null;
    public locationId: number|null;
    public codeForExistingSecret: string|null;

    public constructor(init?: Partial<UserResetRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UserResetRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(UserResetRequest as unknown)[immerable] = true;

// @Route("/users/allUsersWithRoles")
export class UsersWithRolesRequest implements IReturn<UserRoleLocationWithDetails[]>, ILocationIds
{
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;

    public constructor(init?: Partial<UsersWithRolesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UsersWithRolesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Array<UserRoleLocationWithDetails>(); }
}
(UsersWithRolesRequest as unknown)[immerable] = true;

export class UsersExportRequest implements IReturn<ResponseBase<string>>, ILocationIds
{
    public query: AllUsersLocationRequest|null;
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;

    public constructor(init?: Partial<UsersExportRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UsersExportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<string>(); }
}
(UsersExportRequest as unknown)[immerable] = true;

// @Route("/users/{Id}", "GET")
export class UserRequest implements IReturn<ResponseBase<UsersSearchResponse>>, ISecurityId
{
    public id: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<UserRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UserRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<UsersSearchResponse>(); }
}
(UserRequest as unknown)[immerable] = true;

// @Route("/users/{UserId}/locations", "GET")
export class UserLocationsRequest implements IReturn<ResponseBase<UserLocationsResponse>>, ISecurityId
{
    public userId: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<UserLocationsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UserLocationsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<UserLocationsResponse>(); }
}
(UserLocationsRequest as unknown)[immerable] = true;

// @Route("/users/{Id}/permissions", "GET")
export class UserPermissionRequest implements IReturn<ResponseBase<JsonPermission>>, ISecurityId
{
    public id: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<UserPermissionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UserPermissionRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<JsonPermission>(); }
}
(UserPermissionRequest as unknown)[immerable] = true;

// @Route("/users")
export class UserSaveRequest implements IReturn<ResponseBase<number>>, ILocationId
{
    public id: number|null;
    public name: string|null;
    public fullName: string|null;
    public firstName: string|null;
    public lastName: string|null;
    public current: boolean|null;
    public email: string|null;
    public mobileNumber: string|null;
    public position: string|null;
    public pword: string|null;
    public locationId: number|null;
    public practitionerId: number|null;
    public migrated: boolean|null;
    public practitionerTitle: string|null;
    public practitionerForename: string|null;
    public practitionerSurname: string|null;
    public avatar: string|null;
    public locations: UserRoleLocationDto[]|null;
    public accessiblePractitioners: number[]|null;
    public departments: number[]|null;
    public globalGuid: string|null;

    public constructor(init?: Partial<UserSaveRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UserSaveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<number>(); }
}
(UserSaveRequest as unknown)[immerable] = true;

// @Route("/businessprofile/{Id}", "GET")
export class BusinessProfileRequest implements IReturn<ResponseBase<BusinessProfileResponse>>
{
    public id: number|null;
    public businessName: string|null;
    public tradingName: string|null;
    public description: string|null;
    public termsAndConditions: string|null;
    public privacyPolicy: string|null;
    public cancellationPolicy: string|null;

    public constructor(init?: Partial<BusinessProfileRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BusinessProfileRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<BusinessProfileResponse>(); }
}
(BusinessProfileRequest as unknown)[immerable] = true;

// @Route("/businessprofile", "POST")
// @Route("/businessprofile/{Id}", "GET")
export class BusinessProfilePostRequest extends BusinessProfileRequest implements IReturn<ResponseBase<BusinessProfileResponse>>
{

    public constructor(init?: Partial<BusinessProfilePostRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BusinessProfilePostRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<BusinessProfileResponse>(); }
}
(BusinessProfilePostRequest as unknown)[immerable] = true;

// @Route("/businessprofile/{Id}", "PUT")
// @Route("/businessprofile/{Id}", "GET")
export class BusinessProfilePutRequest extends BusinessProfileRequest implements IReturn<ResponseBase<BusinessProfileResponse>>
{

    public constructor(init?: Partial<BusinessProfilePutRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BusinessProfilePutRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<BusinessProfileResponse>(); }
}
(BusinessProfilePutRequest as unknown)[immerable] = true;

// @Route("/businessprofile", "GET")
export class BusinessProfileGetRequest implements IReturn<ResponseBase<BusinessProfileResponse>>
{

    public constructor(init?: Partial<BusinessProfileGetRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BusinessProfileGetRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<BusinessProfileResponse>(); }
}
(BusinessProfileGetRequest as unknown)[immerable] = true;

// @Route("/extraction/status", "GET")
export class ExtractionStatusRequest implements IReturn<ResponseBase<ExtractionResponse>>
{

    public constructor(init?: Partial<ExtractionStatusRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExtractionStatusRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ExtractionResponse>(); }
}
(ExtractionStatusRequest as unknown)[immerable] = true;

// @Route("/extraction/begin", "POST")
export class ExtractionRequest implements IReturn<ResponseBase<ExtractionResponse>>
{
    public outOfHours: boolean|null;

    public constructor(init?: Partial<ExtractionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExtractionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ExtractionResponse>(); }
}
(ExtractionRequest as unknown)[immerable] = true;

// @Route("/download/util", "GET")
export class DownloadUtilRequest
{
    public os: string|null;

    public constructor(init?: Partial<DownloadUtilRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DownloadUtilRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(DownloadUtilRequest as unknown)[immerable] = true;

// @Route("/cxx/files")
export class CancellationFileExtract implements IReturn<FilesListingResponse>, IHasPath
{
    public safeRoot: string|null;
    // @DataMember(Order=1)
    public path: string|null;

    // @DataMember(Order=2)
    public recursive: boolean|null;

    // @DataMember(Order=3)
    public createDirectoryIfNotExists: boolean|null;

    public constructor(init?: Partial<CancellationFileExtract>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CancellationFileExtract'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FilesListingResponse(); }
}
(CancellationFileExtract as unknown)[immerable] = true;

// @Route("/cases/{id}/imaging")
export class CaseImagingRequest implements IReturn<CaseImagingResponse>, ISecurityId
{
    public id: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<CaseImagingRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseImagingRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CaseImagingResponse(); }
}
(CaseImagingRequest as unknown)[immerable] = true;

export class CommandBarPatientRequest extends CommandBarRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<CommandBarPatientRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CommandBarPatientRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(CommandBarPatientRequest as unknown)[immerable] = true;

export class CommandBarGroupRequest extends CommandBarRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<CommandBarGroupRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CommandBarGroupRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(CommandBarGroupRequest as unknown)[immerable] = true;

export class CommandBarContactRequest extends CommandBarRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<CommandBarContactRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CommandBarContactRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(CommandBarContactRequest as unknown)[immerable] = true;

export class CommandBarInvoiceRequest extends CommandBarRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<CommandBarInvoiceRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CommandBarInvoiceRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(CommandBarInvoiceRequest as unknown)[immerable] = true;

export class CommandBarPaymentRequest extends CommandBarRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<CommandBarPaymentRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CommandBarPaymentRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(CommandBarPaymentRequest as unknown)[immerable] = true;

// @Route("/mergefields")
export class MergeFieldsRequest
{
    public type: string|null;
    public webSafe: boolean|null;

    public constructor(init?: Partial<MergeFieldsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MergeFieldsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(MergeFieldsRequest as unknown)[immerable] = true;

export class GetCustomMergeFields implements IReturn<ResponseBase<MergeFieldMappingDto>>
{
    public mergeFieldTypes: MergeFieldType[]|null;

    public constructor(init?: Partial<GetCustomMergeFields>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCustomMergeFields'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<MergeFieldMappingDto>(); }
}
(GetCustomMergeFields as unknown)[immerable] = true;

export class GetCustomMergeField implements IReturn<ResponseBase<MergeFieldMappingDto>>
{
    public id: string|null;

    public constructor(init?: Partial<GetCustomMergeField>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCustomMergeField'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<MergeFieldMappingDto>(); }
}
(GetCustomMergeField as unknown)[immerable] = true;

export class SaveCustomMergeField implements IReturn<ResponseBase<MergeFieldMappingDto>>
{
    public mergeFieldMapping: MergeFieldMappingDto|null;

    public constructor(init?: Partial<SaveCustomMergeField>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveCustomMergeField'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<MergeFieldMappingDto>(); }
}
(SaveCustomMergeField as unknown)[immerable] = true;

export class GetCustomFieldMappings implements IReturn<ResponseBase<{ [index:string]: string[]; }>>
{

    public constructor(init?: Partial<GetCustomFieldMappings>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCustomFieldMappings'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<{ [index:string]: string[]; }>(); }
}
(GetCustomFieldMappings as unknown)[immerable] = true;

// @Route("/batchInvoiceMergeData")
export class BatchInvoiceMergeDataRequest implements IReturn<BatchMergeDataResponse[]>, ISecurityIds
{
    public ids: BatchInvoiceMergeDataRequestObject[]|null;
    public securityIds: number[]|null;

    public constructor(init?: Partial<BatchInvoiceMergeDataRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BatchInvoiceMergeDataRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Array<BatchMergeDataResponse>(); }
}
(BatchInvoiceMergeDataRequest as unknown)[immerable] = true;

// @Route("/batchMergeData")
export class BatchMergeDataRequest implements IReturn<BatchMergeDataResponse[]>, ISecurityIds, ISecurityType
{
    public ids: BatchMergeDataRequestObject[]|null;
    public securityIds: number[]|null;
    public securityType: string|null;

    public constructor(init?: Partial<BatchMergeDataRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BatchMergeDataRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Array<BatchMergeDataResponse>(); }
}
(BatchMergeDataRequest as unknown)[immerable] = true;

// @Route("/mergedatawithcontact/{Type}/{Id}/{ContactId}/{Path*}")
// @Route("/mergedata/{Type}/{Id}/{Path*}")
export class MergeDataRequest implements IHasPath, ISecurityId, ISecurityType, IFilterServiceTypeManually, IDepartmentIds, IAllowedDepartmentIds
{
    public id: number|null;
    public type: string|null;
    public path: string|null;
    public safeRoot: string|null;
    public contactId: number|null;
    public appointmentId: number|null;
    public securityId: number|null;
    public securityType: string|null;
    public onlineUrl: string|null;
    public validFor: number|null;
    public departmentIds: number[]|null;
    public allowedDepartmentIds: number[]|null;
    public isOnline: boolean|null;
    public fallbackCustomerId: number|null;
    public chaseId: string|null;
    public waitingListId: string|null;

    public constructor(init?: Partial<MergeDataRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MergeDataRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(MergeDataRequest as unknown)[immerable] = true;

// @Route("/contactmergecheck", "POST")
export class ContactMergeCheckRequest implements IReturn<ResponseBase<ContactMergeCheckResponse>>, IHasPath, ISecurityId, ISecurityType
{
    public mode: string|null;
    public id: string|null;
    public templateName: string|null;
    public path: string|null;
    public safeRoot: string|null;
    public securityId: number|null;
    public securityType: string|null;

    public constructor(init?: Partial<ContactMergeCheckRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ContactMergeCheckRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ContactMergeCheckResponse>(); }
}
(ContactMergeCheckRequest as unknown)[immerable] = true;

// @Route("/communication/sms")
export class SmsSendRequest implements IReturn<SmsResponse>, ISecurityId, ISecurityType
{
    public recipient: string|null;
    public source: string|null;
    public object: Object|null;
    public objectType: string|null;
    public objectId: number|null;
    public skipFileSave: boolean|null;
    public template: string|null;
    public securityId: number|null;
    public securityType: string|null;
    public isOnline: boolean|null;
    public smsType: string|null;
    public metadata: { [index:string]: string; }|null;

    public constructor(init?: Partial<SmsSendRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SmsSendRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SmsResponse(); }
}
(SmsSendRequest as unknown)[immerable] = true;

// @Route("/communication/consent/{Mode}/{Id}")
export class SmsConsentCheck implements IReturn<SmsConsentReponse>
{
    public id: number|null;
    public mode: string|null;

    public constructor(init?: Partial<SmsConsentCheck>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SmsConsentCheck'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SmsConsentReponse(); }
}
(SmsConsentCheck as unknown)[immerable] = true;

// @Route("/customer/contacts", "GET")
// @Route("/customer/contacts/{Id}", "GET")
export class MedicalContactRequest implements IReturn<ResponseBase<MedicalContactResponse>>, ISecurityId
{
    public skip: number|null;
    public take: number|null;
    public id: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<MedicalContactRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MedicalContactRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<MedicalContactResponse>(); }
}
(MedicalContactRequest as unknown)[immerable] = true;

// @Route("/customer/contacts/linked")
// @Route("/customer/contacts/linked/{CustomerId}")
export class LinkedPatientsRequest implements IReturn<ResponseBase<GeneralCustomerResponse>>, ICustomerId
{
    public customerId: number|null;

    public constructor(init?: Partial<LinkedPatientsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LinkedPatientsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<GeneralCustomerResponse>(); }
}
(LinkedPatientsRequest as unknown)[immerable] = true;

// @Route("/contact/recent/{Id}", "GET")
export class ContactRecentRequest implements IReturn<ContactRecentResponse>, IHasPath, ISecurityId
{
    public id: number|null;
    public path: string|null;
    public safeRoot: string|null;
    public securityId: number|null;

    public constructor(init?: Partial<ContactRecentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ContactRecentRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ContactRecentResponse(); }
}
(ContactRecentRequest as unknown)[immerable] = true;

// @Route("/contacts/linkedCustomers/")
// @Route("/contacts/linkedCustomers/{ContactId}")
export class ContactsLinkedPatients implements IReturn<ResponseBase<GeneralCustomerResponse>>, ISecurityId, IFilterServiceTypeManually
{
    public contactId: number|null;
    public securityId: number|null;
    public sort: QueryField[]|null;

    public constructor(init?: Partial<ContactsLinkedPatients>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ContactsLinkedPatients'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<GeneralCustomerResponse>(); }
}
(ContactsLinkedPatients as unknown)[immerable] = true;

// @Route("/customers/contactsave")
export class MedicalContactSaveRequest implements IReturn<ResponseBase<MedicalContactResponse>>, ILocationId
{
    public id: number|null;
    public current: boolean|null;
    public category: string|null;
    public title: string|null;
    public forename: string|null;
    public surname: string|null;
    public businessName: string|null;
    public addressLine1: string|null;
    public addressLine2: string|null;
    public addressLine3: string|null;
    public addressLine4: string|null;
    public addressLine5: string|null;
    public mobile: string|null;
    public postCode: string|null;
    public telephone: string|null;
    public altTelephone1: string|null;
    public altTelephone2: string|null;
    public fax: string|null;
    public email: string|null;
    public web: string|null;
    public locationId: number|null;
    public locationName: string|null;
    public providerNumber: string|null;

    public constructor(init?: Partial<MedicalContactSaveRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MedicalContactSaveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<MedicalContactResponse>(); }
}
(MedicalContactSaveRequest as unknown)[immerable] = true;

// @Route("/customers/{CustomerId}")
// @Route("/customers")
export class CustomerRequest implements IReturn<ResponseBase<GeneralCustomerResponse>>, ICustomerId, IGet
{
    public customerId: number|null;
    public includeDiaryMetaData: boolean|null;

    public constructor(init?: Partial<CustomerRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomerRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<GeneralCustomerResponse>(); }
}
(CustomerRequest as unknown)[immerable] = true;

export class CustomerLiteRequest implements IReturn<ResponseBase<CustomerLiteDto>>, ICustomerId
{
    public customerId: number|null;

    public constructor(init?: Partial<CustomerLiteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomerLiteRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<CustomerLiteDto>(); }
}
(CustomerLiteRequest as unknown)[immerable] = true;

// @Route("/customer/save/consent")
export class CustomerSaveConsentRequest implements IReturn<ResponseBase<Object>>, ILocationId, ICustomerId
{
    public id: number|null;
    public locationId: number|null;
    public customerId: number|null;
    public emailConsent: boolean|null;
    public smsConsent: boolean|null;
    public phoneConsent: boolean|null;
    public givenConsent: boolean|null;

    public constructor(init?: Partial<CustomerSaveConsentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomerSaveConsentRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<Object>(); }
}
(CustomerSaveConsentRequest as unknown)[immerable] = true;

// @Route("/customer/batch/consent")
export class CustomerBatchConsentRequest implements IReturn<ResponseBase<CustomerBatchConsentResponse>>
{
    public consent: boolean|null;
    public customerIds: number[]|null;

    public constructor(init?: Partial<CustomerBatchConsentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomerBatchConsentRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CustomerBatchConsentResponse>(); }
}
(CustomerBatchConsentRequest as unknown)[immerable] = true;

export class CustomerEmailDuplicateCheck implements IReturn<ResponseBase<Customer>>, ILocationId
{
    public locationId: number|null;
    public email: string|null;
    public customerId: number|null;

    public constructor(init?: Partial<CustomerEmailDuplicateCheck>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomerEmailDuplicateCheck'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<Customer>(); }
}
(CustomerEmailDuplicateCheck as unknown)[immerable] = true;

// @Route("/customer/save")
export class CustomerSaveRequest implements IReturn<ResponseBase<CustomerSaveResponse>>, ILocationId
{
    public id: number|null;
    public reference: string|null;
    public forename: string|null;
    public surname: string|null;
    public title: string|null;
    public gender: string|null;
    public addressLine1: string|null;
    public addressLine2: string|null;
    public addressLine3: string|null;
    public addressLine4: string|null;
    public addressLine5: string|null;
    public postCode: string|null;
    public invoiceAddressLine1: string|null;
    public invoiceAddressLine2: string|null;
    public invoiceAddressLine3: string|null;
    public invoiceAddressLine4: string|null;
    public invoiceAddressLine5: string|null;
    public invoicePostCode: string|null;
    public registrationDate: string|null;
    public homeTelephone: string|null;
    public workTelephone: string|null;
    public mobileTelephone: string|null;
    public stripeToken: string|null;
    public stripeCustomerId: string|null;
    public cardName: string|null;
    public lastFourDigits: string|null;
    public expiryMonth: number|null;
    public expiryYear: number|null;
    public brand: string|null;
    public isNewCard: boolean|null;
    public isDeletingCard: boolean|null;
    public elementType: string|null;
    public cardID: number|null;
    public email: string|null;
    public dateOfBirth: string|null;
    public locationName: string|null;
    public practitionerTitle: string|null;
    public practitionerForename: string|null;
    public practitionerSurname: string|null;
    public locationId: number|null;
    public practitionerId: number|null;
    public practitionerName: string|null;
    public groupName: string|null;
    public groupId: number|null;
    public patientGroup: string|null;
    public accountId: number|null;
    public status: number|null;
    public insuranceNumber: string|null;
    public groupReference: string|null;
    public smsEnabled: boolean|null;
    public defaultCharge: string|null;
    public invoicePeriod: string|null;
    public useInvoiceAddress: boolean|null;
    public enquiry: string|null;
    public category: string|null;
    public employer: string|null;
    public height: number|null;
    public weight: number|null;
    public hospitalNumber: string|null;
    public niNumber: string|null;
    public medication: string|null;
    public previousInjuries: string|null;
    public alternativeRef1: string|null;
    public lastAppointmentDate: string|null;
    public alternativeRef2: string|null;
    public alternativeRef3: string|null;
    public alternativeRef4: string|null;
    public notes: string|null;
    public billTo: string|null;
    public online: boolean|null;
    public cardNo: string|null;
    public invoiceFrequency: number|null;
    public invoiceDeadline: string|null;
    public consent: string|null;
    public forceSave: boolean|null;
    public customerId: number|null;
    public emailConsent: boolean|null;
    public smsConsent: boolean|null;
    public phoneConsent: boolean|null;
    public givenConsent: boolean|null;
    public updateAnyway: boolean|null;
    public paymentMethodId: string|null;
    public mailChimpEnabled: boolean|null;
    public flag: string|null;
    public medicareCardNo: string|null;
    public irn: string|null;
    public dvaNumber: string|null;
    public tags: string[]|null;
    public overridePayAtClinic: boolean|null;
    public isBusiness: boolean|null;

    public constructor(init?: Partial<CustomerSaveRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomerSaveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CustomerSaveResponse>(); }
}
(CustomerSaveRequest as unknown)[immerable] = true;

// @Route("/customer/sms/change")
export class ChangeCustomerSmsEnabled implements IReturn<Customer>, ILocationIds
{
    public id: number|null;
    public smsEnabled: boolean|null;
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;

    public constructor(init?: Partial<ChangeCustomerSmsEnabled>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ChangeCustomerSmsEnabled'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Customer(); }
}
(ChangeCustomerSmsEnabled as unknown)[immerable] = true;

// @Route("/patient/nextappointment/{CustomerId}")
export class PatientNextAppoimentRequest implements IReturn<PatientNextAppoimentResponse>, ICustomerId
{
    public customerId: number|null;

    public constructor(init?: Partial<PatientNextAppoimentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientNextAppoimentRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientNextAppoimentResponse(); }
}
(PatientNextAppoimentRequest as unknown)[immerable] = true;

// @Route("/patient/recent/{CustomerId}")
export class PatientRecentRequest implements IReturn<PatientRecentResponse>, IHasPath, ICustomerId, IFilterServiceTypeManually
{
    public customerId: number|null;
    public path: string|null;
    public safeRoot: string|null;

    public constructor(init?: Partial<PatientRecentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientRecentRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientRecentResponse(); }
}
(PatientRecentRequest as unknown)[immerable] = true;

// @Route("/patient/recentDocument/{CustomerId}")
export class RecentDocumentRequest implements IReturn<RecentDocumentResponse>, IHasPath, ICustomerId
{
    public customerId: number|null;
    public path: string|null;
    public safeRoot: string|null;

    public constructor(init?: Partial<RecentDocumentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RecentDocumentRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new RecentDocumentResponse(); }
}
(RecentDocumentRequest as unknown)[immerable] = true;

// @Route("/customer/contacts/medical/{CustomerId}")
// @Route("/customer/contacts/medical")
export class CustomerMedicalContactsRequest implements IReturn<ResponseBase<MedicalContactResponse>>, ICustomerId
{
    public customerId: number|null;

    public constructor(init?: Partial<CustomerMedicalContactsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomerMedicalContactsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<MedicalContactResponse>(); }
}
(CustomerMedicalContactsRequest as unknown)[immerable] = true;

// @Route("/customer/contacts/joined/{CustomerId}")
// @Route("/customer/contacts/joined")
export class JoinedContactsRequest implements IReturn<ResponseBase<JoinedContactResponse>>, ICustomerId
{
    public customerId: number|null;
    public term: string|null;
    public skip: number|null;
    public take: number|null;
    public sort: QueryField[]|null;

    public constructor(init?: Partial<JoinedContactsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'JoinedContactsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<JoinedContactResponse>(); }
}
(JoinedContactsRequest as unknown)[immerable] = true;

// @Route("/customer/contacts/medical/default")
export class DefaultMedicalContactRequest implements IReturn<ResponseBase<boolean>>, ICustomerId
{
    public customerId: number|null;
    public contactId: number|null;

    public constructor(init?: Partial<DefaultMedicalContactRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DefaultMedicalContactRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(DefaultMedicalContactRequest as unknown)[immerable] = true;

// @Route("/customer/contacts/medical/contactable")
export class ContactableMedicalContactRequest implements IReturn<ResponseBase<boolean>>, ICustomerId
{
    public customerId: number|null;
    public contactId: number|null;

    public constructor(init?: Partial<ContactableMedicalContactRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ContactableMedicalContactRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ContactableMedicalContactRequest as unknown)[immerable] = true;

// @Route("/customer/contacts/patient/{CustomerId}")
// @Route("/customer/contacts/patient")
export class CustomerPatientContactsRequest implements IReturn<ResponseBase<MedicalContactResponse>>, ICustomerId
{
    public customerId: number|null;

    public constructor(init?: Partial<CustomerPatientContactsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomerPatientContactsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<MedicalContactResponse>(); }
}
(CustomerPatientContactsRequest as unknown)[immerable] = true;

// @Route("/customer/contacts/relationship")
export class PatientContactRelationshipRequest implements IReturn<ResponseBase<boolean>>, ICustomerId
{
    public customerId: number|null;
    public contactId: number|null;
    public relationship: string|null;

    public constructor(init?: Partial<PatientContactRelationshipRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientContactRelationshipRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(PatientContactRelationshipRequest as unknown)[immerable] = true;

// @Route("/customer/contacts/patient/default")
export class DefaultPatientContactRequest implements IReturn<ResponseBase<boolean>>, ICustomerId
{
    public customerId: number|null;
    public contactId: number|null;

    public constructor(init?: Partial<DefaultPatientContactRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DefaultPatientContactRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(DefaultPatientContactRequest as unknown)[immerable] = true;

// @Route("/patient/delete")
export class DeleteCustomerRequest implements IReturn<ResponseBase<boolean>>, ICustomerId
{
    public customerId: number|null;
    public isProvisional: boolean|null;

    public constructor(init?: Partial<DeleteCustomerRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteCustomerRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(DeleteCustomerRequest as unknown)[immerable] = true;

// @Route("/patient/linkpatient")
export class LinkCustomerRequest implements IReturn<ResponseBase<boolean>>, ICustomerId
{
    public customerId: number|null;
    public existingPatientId: number|null;

    public constructor(init?: Partial<LinkCustomerRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LinkCustomerRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(LinkCustomerRequest as unknown)[immerable] = true;

// @Route("/patient/makereal")
export class MakeCustomerRealRequest implements IReturn<ResponseBase<boolean>>, ICustomerId
{
    public customerId: number|null;

    public constructor(init?: Partial<MakeCustomerRealRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MakeCustomerRealRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(MakeCustomerRealRequest as unknown)[immerable] = true;

// @Route("/customer/contacts/medical/remove")
export class RemoveMedicalContactRequest implements IReturn<ResponseBase<boolean>>, ICustomerId
{
    public customerId: number|null;
    public contactId: number|null;

    public constructor(init?: Partial<RemoveMedicalContactRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RemoveMedicalContactRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(RemoveMedicalContactRequest as unknown)[immerable] = true;

// @Route("/customer/contacts/patient/remove")
export class RemovePatientContactRequest implements IReturn<ResponseBase<boolean>>, ICustomerId
{
    public customerId: number|null;
    public contactId: number|null;

    public constructor(init?: Partial<RemovePatientContactRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RemovePatientContactRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(RemovePatientContactRequest as unknown)[immerable] = true;

// @Route("/customer/contacts/addTo")
export class CustomerContactAddRequest implements IReturn<ResponseBase<boolean>>, ICustomerId
{
    public customerId: number|null;
    public contactId: number|null;

    public constructor(init?: Partial<CustomerContactAddRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomerContactAddRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(CustomerContactAddRequest as unknown)[immerable] = true;

// @Route("/customer/patientcon/addTo")
export class CustomerPatientContactAddRequest implements IReturn<ResponseBase<boolean>>, ICustomerId
{
    public customerId: number|null;
    public contactId: number|null;
    public relationship: string|null;

    public constructor(init?: Partial<CustomerPatientContactAddRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomerPatientContactAddRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(CustomerPatientContactAddRequest as unknown)[immerable] = true;

// @Route("/finances/account")
// @Route("/finances/account/{CustomerId}")
export class AccountStatementRequest implements IReturn<ResponseBase<AccountStatementResponse>>, ILocationIds
{
    public sort: QueryField[]|null;
    public customerId: number|null;
    public date: DateRange|null;
    public skip: number|null;
    public take: number|null;
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;

    public constructor(init?: Partial<AccountStatementRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AccountStatementRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<AccountStatementResponse>(); }
}
(AccountStatementRequest as unknown)[immerable] = true;

// @Route("/finances/account/groups")
// @Route("/finances/account/groups/{CustomerId}")
export class GroupAccountStatementRequest implements IReturn<ResponseBase<GroupAccountStatementResponse>>, ILocationIds
{
    public sort: QueryField[]|null;
    public customerId: number|null;
    public date: DateRange|null;
    public skip: number|null;
    public take: number|null;
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;

    public constructor(init?: Partial<GroupAccountStatementRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GroupAccountStatementRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<GroupAccountStatementResponse>(); }
}
(GroupAccountStatementRequest as unknown)[immerable] = true;

// @Route("/invoices/{InvoiceId}/billingitems")
// @Route("/billing/items")
export class BillingItemsRequest implements IReturn<ResponseBase<BillingItemsResponse>>, ILocationIds
{
    public sort: QueryField[]|null;
    public customerId: number|null;
    public invoiceId: number|null;
    public skip: number|null;
    public take: number|null;
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;
    public hideDiscountItems: boolean|null;

    public constructor(init?: Partial<BillingItemsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BillingItemsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<BillingItemsResponse>(); }
}
(BillingItemsRequest as unknown)[immerable] = true;

// @Route("/billing/items/group")
export class GroupBillingItemsRequest implements IReturn<ResponseBase<BillingItemsResponse>>, ILocationId
{
    public sort: QueryField[]|null;
    public customerId: number|null;
    public invoiceId: number|null;
    public skip: number|null;
    public take: number|null;
    public locationId: number|null;
    public hideDiscountItems: boolean|null;

    public constructor(init?: Partial<GroupBillingItemsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GroupBillingItemsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<BillingItemsResponse>(); }
}
(GroupBillingItemsRequest as unknown)[immerable] = true;

// @Route("/customer/prepaidStock")
export class PrePaidStockRequest implements IReturn<ResponseBase<StockResponse>>, ICustomerId
{
    public customerId: number|null;

    public constructor(init?: Partial<PrePaidStockRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PrePaidStockRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<StockResponse>(); }
}
(PrePaidStockRequest as unknown)[immerable] = true;

// @Route("/billing/item/prepaid")
export class PrePaidItemRequest implements IReturn<ResponseBase<PrePaidItems>>, ICustomerId
{
    public customerId: number|null;
    public billingItemId: number|null;
    public skip: number|null;
    public take: number|null;
    public sort: QueryField[]|null;

    public constructor(init?: Partial<PrePaidItemRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PrePaidItemRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<PrePaidItems>(); }
}
(PrePaidItemRequest as unknown)[immerable] = true;

// @Route("/billing/item/prepaid/add")
export class PrePaidItemAddRequest implements IReturn<ResponseBase<boolean>>, ICustomerId
{
    public accountId: number|null;
    public clientId: number|null;
    public stockId: number|null;
    public customerId: number|null;
    public billingItemId: number|null;
    public quantity: number|null;
    public classTypeId: number|null;
    public expiryDate: string|null;
    public type: PackageBundleItemType|null;

    public constructor(init?: Partial<PrePaidItemAddRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PrePaidItemAddRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(PrePaidItemAddRequest as unknown)[immerable] = true;

// @Route("/billing/item/prepaid/action")
export class PrePaidItemDeleteRequest implements IReturn<ResponseBase<boolean>>
{
    public prePaidId: number|null;
    public markAsRemoved: boolean|null;
    public incrementUsage: boolean|null;
    public updateQuantityAndUsage: boolean|null;
    public quantity: number|null;
    public used: number|null;

    public constructor(init?: Partial<PrePaidItemDeleteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PrePaidItemDeleteRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(PrePaidItemDeleteRequest as unknown)[immerable] = true;

// @Route("/billing/item/prepaid/edit")
export class PrePaidItemsExpiryDateRequest implements IReturn<ResponseBase<boolean>>
{
    public billingItemId: number|null;
    public expiryDate: string|null;

    public constructor(init?: Partial<PrePaidItemsExpiryDateRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PrePaidItemsExpiryDateRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(PrePaidItemsExpiryDateRequest as unknown)[immerable] = true;

// @Route("/invoices/{InvoiceId}/payments")
export class InvoicePaymentsRequest implements IReturn<ResponseBase<InvoicePaymentsResponse>>, IInvoiceId, ISecurityId
{
    public invoiceId: number|null;
    public skip: number|null;
    public take: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<InvoicePaymentsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InvoicePaymentsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<InvoicePaymentsResponse>(); }
}
(InvoicePaymentsRequest as unknown)[immerable] = true;

// @Route("/customers/contactsearch/", "POST")
// @Route("/customers/contactsearch/{CustomerId}", "POST")
export class ContactQuickSearchRequest implements IReturn<ResponseBase<MedicalContactResponse>>, ILocationId
{
    public skip: number|null;
    public take: number|null;
    public term: string|null;
    public customerId: number|null;
    public locationId: number|null;

    public constructor(init?: Partial<ContactQuickSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ContactQuickSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<MedicalContactResponse>(); }
}
(ContactQuickSearchRequest as unknown)[immerable] = true;

// @Route("/click/contact-search", "POST")
// @Route("/click/contact-search/{CustomerId}", "POST")
export class ClickContactQuickSearchRequest implements IReturn<ResponseBase<ClickContactSearchResult>>, ILocationIds, IFilterServiceTypeManually
{
    public filterId: number|null;
    public term: string|null;
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;

    public constructor(init?: Partial<ClickContactQuickSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickContactQuickSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClickContactSearchResult>(); }
}
(ClickContactQuickSearchRequest as unknown)[immerable] = true;

// @Route("/customers/contactsearch/patient", "POST")
// @Route("/customers/contactsearch/patient/{CustomerId}", "POST")
export class ContactPatientQuickSearchRequest implements IReturn<ResponseBase<GeneralCustomerResponse>>, ICustomerId, ILocationIds, IFilterServiceTypeManually
{
    public startIdx: number|null;
    public endIdx: number|null;
    public realOnly: boolean|null;
    public includeDeceased: boolean|null;
    public term: string|null;
    public customerId: number|null;
    public sort: QueryField[]|null;
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;

    public constructor(init?: Partial<ContactPatientQuickSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ContactPatientQuickSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<GeneralCustomerResponse>(); }
}
(ContactPatientQuickSearchRequest as unknown)[immerable] = true;

// @Route("/customers/export/csv")
export class CustomerAdvancedSearchExportCSVRequest implements IReturn<string>, ILocationIds
{
    public customHeaders: CustomerCSVHeaderOverrides|null;
    public query: CustomerAdvancedSearchRequest|null;
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;

    public constructor(init?: Partial<CustomerAdvancedSearchExportCSVRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomerAdvancedSearchExportCSVRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return ''; }
}
(CustomerAdvancedSearchExportCSVRequest as unknown)[immerable] = true;

// @Route("/customers/count")
export class PatientCountRequest implements IReturn<ResponseBase<number>>
{

    public constructor(init?: Partial<PatientCountRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientCountRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<number>(); }
}
(PatientCountRequest as unknown)[immerable] = true;

// @Route("/medicalContacts/count")
export class MedicalContactCountRequest implements IReturn<ResponseBase<number>>
{

    public constructor(init?: Partial<MedicalContactCountRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MedicalContactCountRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<number>(); }
}
(MedicalContactCountRequest as unknown)[immerable] = true;

// @Route("/customers/searchProvisionalPatients")
export class ProvisionalPatientsRequest implements IReturn<ResponseBase<GeneralCustomerResponse>>, ILocationIds
{
    public locationIds: number[]|null;
    public status: number|null;
    public provisional: boolean|null;
    public requestLocationIds: number[]|null;

    public constructor(init?: Partial<ProvisionalPatientsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProvisionalPatientsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<GeneralCustomerResponse>(); }
}
(ProvisionalPatientsRequest as unknown)[immerable] = true;

// @Route("/customers/potentialProvisionalMatches/{CustomerId}")
export class PotentialProvisionalMatchesRequest implements IReturn<ResponseBase<GeneralCustomerResponse>>, ICustomerId, ILocationIds, IFilterServiceTypeManually
{
    public customerId: number|null;
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;

    public constructor(init?: Partial<PotentialProvisionalMatchesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PotentialProvisionalMatchesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<GeneralCustomerResponse>(); }
}
(PotentialProvisionalMatchesRequest as unknown)[immerable] = true;

export class GetPotentialMatchesRequest implements IReturn<ResponseBase<GeneralCustomerResponse>>, ILocationIds, IFilterServiceTypeManually
{
    public title: string|null;
    public forename: string|null;
    public surname: string|null;
    public postCode: string|null;
    public email: string|null;
    public mobileTelephone: string|null;
    public dateOfBirth: string|null;
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;

    public constructor(init?: Partial<GetPotentialMatchesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPotentialMatchesRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<GeneralCustomerResponse>(); }
}
(GetPotentialMatchesRequest as unknown)[immerable] = true;

// @Route("/contacts/search")
export class MedicalContactsAdvancedSearchRequest extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<MedicalContactResponse>>
{
    public surname: string|null;
    public status: boolean|null;
    public address: string|null;
    public forename: string|null;
    public locationId: number|null;
    public locationMulti: number[]|null;
    public businessName: string|null;

    public constructor(init?: Partial<MedicalContactsAdvancedSearchRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'MedicalContactsAdvancedSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<MedicalContactResponse>(); }
}
(MedicalContactsAdvancedSearchRequest as unknown)[immerable] = true;

// @Route("/contacts/export/csv")
export class MedicalContactsAdvancedSearchExportCSVRequest implements IReturn<string>, ILocationIds
{
    public customHeaders: MedicalContactsCSVHeaderOverrides|null;
    public query: MedicalContactsAdvancedSearchRequest|null;
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;

    public constructor(init?: Partial<MedicalContactsAdvancedSearchExportCSVRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MedicalContactsAdvancedSearchExportCSVRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return ''; }
}
(MedicalContactsAdvancedSearchExportCSVRequest as unknown)[immerable] = true;

export class TreatmentAuthCountRequest implements IReturn<number>
{

    public constructor(init?: Partial<TreatmentAuthCountRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TreatmentAuthCountRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return 0; }
}
(TreatmentAuthCountRequest as unknown)[immerable] = true;

// @Route("/patient/{CustomerId}/authCodes")
export class TreatmentAuthRequest implements IReturn<ResponseBase<TreatmentAuthResponse>>, ICustomerId, IDepartmentIds
{
    public sort: QueryField[]|null;
    public skip: number|null;
    public take: number|null;
    public customerId: number|null;
    public departmentIds: number[]|null;

    public constructor(init?: Partial<TreatmentAuthRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TreatmentAuthRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<TreatmentAuthResponse>(); }
}
(TreatmentAuthRequest as unknown)[immerable] = true;

export class ClickCustomerNotesCheckRequest implements IReturn<ResponseBase<ClickCustomerNotesCheckResponse>>
{
    public customerId: number|null;

    public constructor(init?: Partial<ClickCustomerNotesCheckRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickCustomerNotesCheckRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ClickCustomerNotesCheckResponse>(); }
}
(ClickCustomerNotesCheckRequest as unknown)[immerable] = true;

export class ClickCustomerCreateCaseRequest implements IReturn<ResponseBase<ClickCustomerNotesCheckResponse>>
{
    public customerId: number|null;

    public constructor(init?: Partial<ClickCustomerCreateCaseRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickCustomerCreateCaseRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClickCustomerNotesCheckResponse>(); }
}
(ClickCustomerCreateCaseRequest as unknown)[immerable] = true;

// @Route("/appointment/cases/{CustomerId}")
export class AppointmentCaseRequest implements IReturn<ResponseBase<AppointmentCaseResponse>>, ILocationIds, IServiceTypeId
{
    public customerId: number|null;
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;
    public serviceTypeId: number|null;

    public constructor(init?: Partial<AppointmentCaseRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AppointmentCaseRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<AppointmentCaseResponse>(); }
}
(AppointmentCaseRequest as unknown)[immerable] = true;

// @Route("/appointment/auths")
export class AppointmentAuthCode implements IReturn<ResponseBase<TreatmentAuthResponse>>, ICustomerId, IServiceTypeId
{
    public customerId: number|null;
    public existingAuthId: number|null;
    public serviceTypeId: number|null;

    public constructor(init?: Partial<AppointmentAuthCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AppointmentAuthCode'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<TreatmentAuthResponse>(); }
}
(AppointmentAuthCode as unknown)[immerable] = true;

export class TreatmentAuthByIdRequest implements IReturn<ResponseBase<T>>
{
    public authId: number|null;

    public constructor(init?: Partial<TreatmentAuthByIdRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TreatmentAuthByIdRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(TreatmentAuthByIdRequest as unknown)[immerable] = true;

// @Route("/authcode/{AuthId}")
// @Route("/authcode")
export class TreatmentAuthIdRequest implements IReturn<ResponseBase<TreatmentAuthResponse>>, ILocationId, IFilterServiceTypeManually, IGet
{
    public skip: number|null;
    public take: number|null;
    public authId: number|null;
    public locationId: number|null;

    public constructor(init?: Partial<TreatmentAuthIdRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TreatmentAuthIdRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<TreatmentAuthResponse>(); }
}
(TreatmentAuthIdRequest as unknown)[immerable] = true;

// @Route("/authcode/delete")
// @Route("/authcode/delete/{AuthId}")
export class TreatmentAuthDeleteRequest implements IReturn<ResponseBase<boolean>>, ILocationId, IFilterServiceTypeManually
{
    public authId: number|null;
    public locationId: number|null;

    public constructor(init?: Partial<TreatmentAuthDeleteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TreatmentAuthDeleteRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(TreatmentAuthDeleteRequest as unknown)[immerable] = true;

// @Route("/authcode/save/")
export class TreatmentAuthSave implements IReturn<ResponseBase<TreatmentAuthResponse>>, ICustomerId, IFilterServiceTypeManually
{
    public id: number|null;
    public authCode: string|null;
    public expired: string|null;
    public maxTreatments: number|null;
    public maxValue: number|null;
    public expiryDate: string|null;
    public usedTreatments: number|null;
    public usedValue: number|null;
    public usedFor: string|null;
    public startDate: string|null;
    public groupId: number|null;
    public caseId: number|null;
    public customerId: number|null;
    public serviceTypeId: number|null;
    public contactId: number|null;

    public constructor(init?: Partial<TreatmentAuthSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TreatmentAuthSave'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<TreatmentAuthResponse>(); }
}
(TreatmentAuthSave as unknown)[immerable] = true;

// @Route("/customer/sar/status/{customerId}")
export class SarStatusRequest implements IReturn<ResponseBase<string>>, ICustomerId
{
    public customerId: number|null;

    public constructor(init?: Partial<SarStatusRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SarStatusRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<string>(); }
}
(SarStatusRequest as unknown)[immerable] = true;

// @Route("/customer/sar/delete")
export class SarDeleteRequest implements IReturn<ResponseBase<boolean>>, ICustomerId
{
    public customerId: number|null;
    public deleteFile: boolean|null;

    public constructor(init?: Partial<SarDeleteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SarDeleteRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(SarDeleteRequest as unknown)[immerable] = true;

// @Route("/customer/sar/download/{customerId}")
export class SarDownloadRequest implements IReturn<ResponseBase<Object>>, ICustomerId
{
    public customerId: number|null;

    public constructor(init?: Partial<SarDownloadRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SarDownloadRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<Object>(); }
}
(SarDownloadRequest as unknown)[immerable] = true;

// @Route("/customerservice/all")
export class CustomerServiceRequest implements IReturn<ResponseBase<CustomerServiceResponse>>
{

    public constructor(init?: Partial<CustomerServiceRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomerServiceRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<CustomerServiceResponse>(); }
}
(CustomerServiceRequest as unknown)[immerable] = true;

// @Route("/customerservice/save")
export class CustomerServiceUpdate implements IReturn<ResponseBase<CustomerServiceResponse>>
{
    public id: number|null;
    public customerSecurityLevel: number|null;
    public customerSecurityKeyWord: string|null;

    public constructor(init?: Partial<CustomerServiceUpdate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomerServiceUpdate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CustomerServiceResponse>(); }
}
(CustomerServiceUpdate as unknown)[immerable] = true;

// @Route("/patient/log")
// @Route("/patient/log/{LogId}")
export class PatientLogRequest implements IReturn<ResponseBase<PatientLogResponse>>, ILocationId, IFilterServiceTypeManually
{
    public skip: number|null;
    public take: number|null;
    public logId: number|null;
    public locationId: number|null;

    public constructor(init?: Partial<PatientLogRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientLogRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<PatientLogResponse>(); }
}
(PatientLogRequest as unknown)[immerable] = true;

// @Route("/patient/log/delete")
// @Route("/patient/log/delete/{LogId}")
export class PatientLogDeleteRequest implements IReturn<ResponseBase<Patientlog>>, ILocationId, IFilterServiceTypeManually
{
    public logId: number|null;
    public locationId: number|null;

    public constructor(init?: Partial<PatientLogDeleteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientLogDeleteRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<Patientlog>(); }
}
(PatientLogDeleteRequest as unknown)[immerable] = true;

// @Route("/patient/infoLog/{CustomerId}")
export class PatientInfoLogRequest implements IReturn<ResponseBase<PatientInfoLogResponse>>, ICustomerId, IDepartmentIds
{
    public skip: number|null;
    public take: number|null;
    public customerId: number|null;
    public departmentIds: number[]|null;

    public constructor(init?: Partial<PatientInfoLogRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientInfoLogRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<PatientInfoLogResponse>(); }
}
(PatientInfoLogRequest as unknown)[immerable] = true;

// @Route("/patient/infoLogsave/")
export class PatientLogSave implements IReturn<ResponseBase<PatientLogResponse>>, ICustomerId, IFilterServiceTypeManually
{
    public id: number|null;
    public customerId: number|null;
    public dateTime: string|null;
    public entry: string|null;
    public serviceTypeId: number|null;

    public constructor(init?: Partial<PatientLogSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientLogSave'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<PatientLogResponse>(); }
}
(PatientLogSave as unknown)[immerable] = true;

// @Route("/diary")
export class DiaryRequest implements IReturn<DiaryDefaultDataForUserResponse>
{

    public constructor(init?: Partial<DiaryRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DiaryRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new DiaryDefaultDataForUserResponse(); }
}
(DiaryRequest as unknown)[immerable] = true;

export class DiaryListExportCSVRequest extends DiaryListBase implements IReturn<ResponseBase<string>>
{

    public constructor(init?: Partial<DiaryListExportCSVRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'DiaryListExportCSVRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<string>(); }
}
(DiaryListExportCSVRequest as unknown)[immerable] = true;

// @Route("/diary/stats")
export class DiaryAppointmentStatsRequest implements IReturn<DiaryStatsResponse>, ILocationId, IHasAutoRefresh
{
    public startDate: string|null;
    public endDate: string|null;
    public locationIds: number[]|null;
    public practitionerIds: number[]|null;
    public roomIds: number[]|null;
    public locationId: number|null;
    public autoRefresh: boolean|null;

    public constructor(init?: Partial<DiaryAppointmentStatsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DiaryAppointmentStatsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new DiaryStatsResponse(); }
}
(DiaryAppointmentStatsRequest as unknown)[immerable] = true;

// @Route("/diary/nonWorkingDays")
export class DiaryHolidayRequest implements IReturn<NonWorkingDate[]>, ILocationId
{
    public startDate: string|null;
    public endDate: string|null;
    public locationIds: number[]|null;
    public practitionerIds: number[]|null;
    public locationId: number|null;

    public constructor(init?: Partial<DiaryHolidayRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DiaryHolidayRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Array<NonWorkingDate>(); }
}
(DiaryHolidayRequest as unknown)[immerable] = true;

// @Route("/diary/nonWorkingDays/all")
export class DiaryAllHolidaysRequest implements IReturn<NonWorkingDateResponse[]>, ILocationId
{
    public locationIds: number[]|null;
    public practitionerIds: number[]|null;
    public locationId: number|null;

    public constructor(init?: Partial<DiaryAllHolidaysRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DiaryAllHolidaysRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Array<NonWorkingDateResponse>(); }
}
(DiaryAllHolidaysRequest as unknown)[immerable] = true;

// @Route("/diary/nonWorkingDays/save")
export class DiaryAddHolidayRequest implements IReturn<NonWorkingDateResponse[]>, ILocationId
{
    public date: string|null;
    public locationId: number|null;
    public endDate: string|null;
    public title: string|null;

    public constructor(init?: Partial<DiaryAddHolidayRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DiaryAddHolidayRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Array<NonWorkingDateResponse>(); }
}
(DiaryAddHolidayRequest as unknown)[immerable] = true;

// @Route("/diary/nonWorkingDays/remove")
export class DiaryRemoveHolidayRequest implements IReturn<NonWorkingDateResponse[]>, ILocationId
{
    public id: number|null;
    public locationId: number|null;

    public constructor(init?: Partial<DiaryRemoveHolidayRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DiaryRemoveHolidayRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Array<NonWorkingDateResponse>(); }
}
(DiaryRemoveHolidayRequest as unknown)[immerable] = true;

// @Route("/diary/sessions")
export class DiarySessionRequest implements IReturn<DiarySessionResponse[]>, ILocationId
{
    public startDate: string|null;
    public endDate: string|null;
    public locationIds: number[]|null;
    public practitionerIds: number[]|null;
    public roomIds: number[]|null;
    public locationId: number|null;

    public constructor(init?: Partial<DiarySessionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DiarySessionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Array<DiarySessionResponse>(); }
}
(DiarySessionRequest as unknown)[immerable] = true;

// @Route("/diary/schedule")
export class ScheduleRequest implements IReturn<ResponseBase<ScheduleResponse>>, ILocationIds, IHasAutoRefresh
{
    public date: string|null;
    public isWeek: boolean|null;
    public showWeekends: boolean|null;
    public withoutSessions: boolean|null;
    public location: number|null;
    public mode: ResourceMode|null;
    public locationIds: number[]|null;
    public resourceIds: number[]|null;
    public requestLocationIds: number[]|null;
    public autoRefresh: boolean|null;

    public constructor(init?: Partial<ScheduleRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ScheduleRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ScheduleResponse>(); }
}
(ScheduleRequest as unknown)[immerable] = true;

// @Route("/diary/schedule")
export class MonthlyScheduleRequest implements IReturn<ResponseBase<MonthlyScheduleResponse>>, ILocationIds, IHasAutoRefresh
{
    public date: string|null;
    public location: number|null;
    public mode: ResourceMode|null;
    public locationIds: number[]|null;
    public resourceIds: number[]|null;
    public requestLocationIds: number[]|null;
    public autoRefresh: boolean|null;
    public showCancellations: boolean|null;

    public constructor(init?: Partial<MonthlyScheduleRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MonthlyScheduleRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<MonthlyScheduleResponse>(); }
}
(MonthlyScheduleRequest as unknown)[immerable] = true;

export class OccurrenceRequest implements IReturn<ResponseBase<T>>
{
    public batchNo: number|null;
    public type: string|null;
    public typeId: number|null;

    public constructor(init?: Partial<OccurrenceRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OccurrenceRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(OccurrenceRequest as unknown)[immerable] = true;

// @Route("/session/move", "POST")
export class SessionMoveRequest
{
    public id: number|null;
    public isSpecial: boolean|null;
    public startDateTime: string|null;
    public endDateTime: string|null;

    public constructor(init?: Partial<SessionMoveRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SessionMoveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(SessionMoveRequest as unknown)[immerable] = true;

// @Route("/session/update", "POST")
export class SessionUpdateRequest implements IReturn<ResponseBase<{ [index:string]: ScheduleSession[]; }>>
{
    public id: number|null;
    public isSpecial: boolean|null;
    public startDateTime: string|null;
    public endDateTime: string|null;
    public online: boolean|null;
    public usedFor: string|null;
    public colour: string|null;
    public roomId: number|null;
    public practitionerId: number|null;
    public applyToAllSubsequent: boolean|null;
    public locationId: number|null;
    public multiUsedFor: string[]|null;
    public isOnline: boolean|null;
    public skillRestrictions: string[]|null;

    public constructor(init?: Partial<SessionUpdateRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SessionUpdateRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<{ [index:string]: ScheduleSession[]; }>(); }
}
(SessionUpdateRequest as unknown)[immerable] = true;

// @Route("/session/delete", "POST")
export class SessionDeleteRequest implements IReturn<ResponseBase<{ [index:string]: ScheduleSession[]; }>>, ISecurityId
{
    public id: number|null;
    public securityId: number|null;
    public isSpecial: boolean|null;
    public all: boolean|null;
    public includePast: boolean|null;

    public constructor(init?: Partial<SessionDeleteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SessionDeleteRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<{ [index:string]: ScheduleSession[]; }>(); }
}
(SessionDeleteRequest as unknown)[immerable] = true;

// @Route("/session/create", "POST")
export class SessionCreateRequest implements IReturn<ResponseBase<{ [index:string]: ScheduleSession[]; }>>, ILocationId
{
    public yesToWarnings: boolean|null;
    public excludeWarnings: boolean|null;
    public startDateTime: string|null;
    public endDateTime: string|null;
    public locationId: number|null;
    public practitionerId: number|null;
    public duration: number|null;
    public online: boolean|null;
    public usedFor: string|null;
    public roomId: number|null;
    public colour: string|null;
    public recurrenceInterval: RecurrenceType|null;
    public customDuration: number|null;
    public customFreq: number|null;
    public customInterval: string|null;
    public excludeNonWorkingDays: boolean|null;
    public multiUsedFor: string[]|null;
    public skillRestrictions: string[]|null;

    public constructor(init?: Partial<SessionCreateRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SessionCreateRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<{ [index:string]: ScheduleSession[]; }>(); }
}
(SessionCreateRequest as unknown)[immerable] = true;

export class CalculateWorkingTimesRequest implements IReturn<CalculateWorkingTimesResponse>
{
    public locationId: number|null;

    public constructor(init?: Partial<CalculateWorkingTimesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CalculateWorkingTimesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CalculateWorkingTimesResponse(); }
}
(CalculateWorkingTimesRequest as unknown)[immerable] = true;

// @Route("/patient/{CustomerId}/account")
export class PatientAccountRequest implements IReturn<Account>, ICustomerId
{
    public customerId: number|null;

    public constructor(init?: Partial<PatientAccountRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientAccountRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Account(); }
}
(PatientAccountRequest as unknown)[immerable] = true;

// @Route("/account/{AccountId}/payments")
export class AccountPaymentsRequest implements IReturn<ResponseBase<PaymentsResponse>>, ILocationId
{
    public skip: number|null;
    public take: number|null;
    public accountId: number|null;
    public invoiceId: number|null;
    public locationId: number|null;

    public constructor(init?: Partial<AccountPaymentsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AccountPaymentsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<PaymentsResponse>(); }
}
(AccountPaymentsRequest as unknown)[immerable] = true;

// @Route("/account/{AccountId}/billedItems")
export class AccountBilledItemsRequest implements IReturn<ResponseBase<BillingItemWithNamesAuth>>, ILocationId
{
    public take: number|null;
    public skip: number|null;
    public accountId: number|null;
    public invoiceId: number|null;
    public locationId: number|null;
    public auditId: string|null;

    public constructor(init?: Partial<AccountBilledItemsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AccountBilledItemsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<BillingItemWithNamesAuth>(); }
}
(AccountBilledItemsRequest as unknown)[immerable] = true;

// @Route("/finances/export/preview/charges")
export class AccountsExportChargesPreviewRequest implements IReturn<ResponseBase<AccountsExportChargesPreviewResponse>>, ILocationId
{
    public locationId: number|null;
    public date: DateRange|null;

    public constructor(init?: Partial<AccountsExportChargesPreviewRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AccountsExportChargesPreviewRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<AccountsExportChargesPreviewResponse>(); }
}
(AccountsExportChargesPreviewRequest as unknown)[immerable] = true;

// @Route("/finances/export/preview/payments")
export class AccountsExportPaymentsPreviewRequest implements IReturn<ResponseBase<AccountsExportPaymentsPreviewResponse>>, ILocationId
{
    public locationId: number|null;
    public date: DateRange|null;

    public constructor(init?: Partial<AccountsExportPaymentsPreviewRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AccountsExportPaymentsPreviewRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<AccountsExportPaymentsPreviewResponse>(); }
}
(AccountsExportPaymentsPreviewRequest as unknown)[immerable] = true;

// @Route("/finances/export/charges")
export class AccountsExportChargesRequest implements IReturn<AccountExportResponse>, ILocationId
{
    public locationId: number|null;
    public date: DateRange|null;

    public constructor(init?: Partial<AccountsExportChargesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AccountsExportChargesRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AccountExportResponse(); }
}
(AccountsExportChargesRequest as unknown)[immerable] = true;

// @Route("/finances/export/payments")
export class AccountsExportPaymentsRequest implements IReturn<AccountExportResponse>, ILocationId
{
    public locationId: number|null;
    public date: DateRange|null;

    public constructor(init?: Partial<AccountsExportPaymentsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AccountsExportPaymentsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AccountExportResponse(); }
}
(AccountsExportPaymentsRequest as unknown)[immerable] = true;

// @Route("/finances/export/charges/{Id}/{LocationId}/{Mode}")
export class AccountsChargesExportRequest implements IReturn<Object>, ILocationId
{
    public id: number|null;
    public mode: string|null;
    public locationId: number|null;
    public exportDate: string|null;

    public constructor(init?: Partial<AccountsChargesExportRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AccountsChargesExportRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Object(); }
}
(AccountsChargesExportRequest as unknown)[immerable] = true;

// @Route("/finances/export/payments/{Id}/{LocationId}/{Mode}")
export class AccountsPaymentsExportRequest implements IReturn<Object>, ILocationId
{
    public id: number|null;
    public mode: string|null;
    public locationId: number|null;
    public exportDate: string|null;

    public constructor(init?: Partial<AccountsPaymentsExportRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AccountsPaymentsExportRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Object(); }
}
(AccountsPaymentsExportRequest as unknown)[immerable] = true;

export class AccountExportHistoryRequest implements IReturn<ResponseBase<AccountExportHistoryResponse>>
{
    public fromDate: string|null;
    public toDate: string|null;
    public type: string|null;

    public constructor(init?: Partial<AccountExportHistoryRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AccountExportHistoryRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<AccountExportHistoryResponse>(); }
}
(AccountExportHistoryRequest as unknown)[immerable] = true;

// @Route("/billingItem/{Id}", "GET")
export class BillingItemRequest implements IReturn<ResponseBase<BillingItem>>, ILocationIds
{
    public id: number|null;
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;

    public constructor(init?: Partial<BillingItemRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BillingItemRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<BillingItem>(); }
}
(BillingItemRequest as unknown)[immerable] = true;

// @Route("/billingItem", "POST")
// @Route("/billingItem/{Id}", "PUT")
export class BillingItemSaveRequest implements IReturn<ResponseBase<BillingItem>>, ILocationId
{
    public accountId: number|null;
    public customerId: number|null;
    public practitionerId: number|null;
    public appointmentId: number|null;
    public locationId: number|null;
    public invoiceId: number|null;
    public accountName: string|null;
    public stockId: number|null;
    public date: string|null;
    public description: string|null;
    public total: number|null;
    public isPaid: boolean|null;
    public isMigrated: boolean|null;
    public totalExVat: number|null;
    public quantity: number|null;
    public price: number|null;
    public vatRate: number|null;
    public totalVat: number|null;
    public id: number|null;
    public category: string|null;
    public ledgerCode: string|null;
    public accountsExportId: number|null;

    public constructor(init?: Partial<BillingItemSaveRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BillingItemSaveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<BillingItem>(); }
}
(BillingItemSaveRequest as unknown)[immerable] = true;

// @Route("/charges/count", "GET")
export class ChargeCountRequest implements IReturn<number>, ILocationIds
{
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;

    public constructor(init?: Partial<ChargeCountRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ChargeCountRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return 0; }
}
(ChargeCountRequest as unknown)[immerable] = true;

// @Route("/charges/search")
export class ChargesSearchRequest extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<GroupBillingItemsResponse>>, IChargeSearchRequest
{
    public invoicePeriod: InvoicePeriod|null;
    public mode: ChargeSearchMode|null;
    public groupIds: number[]|null;
    public invoicedStatus: InvoicedStatusToInclude|null;
    public date: DateRange|null;
    public addressTo: string|null;
    public description: string|null;
    public amount: CurrencyRange|null;
    public locked: boolean|null;
    public displayDiscountCodes: boolean|null;

    public constructor(init?: Partial<ChargesSearchRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ChargesSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<GroupBillingItemsResponse>(); }
}
(ChargesSearchRequest as unknown)[immerable] = true;

// @Route("/finances/invoices/prepare-all", "POST")
export class InvoiceAllGroupingRequest implements IReturn<ResponseBase<InvoiceGroupingResponse>>, ILocationId, ILocationIds
{
    public searchData: ChargesSearchRequest|null;
    public locationId: number|null;
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;

    public constructor(init?: Partial<InvoiceAllGroupingRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InvoiceAllGroupingRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<InvoiceGroupingResponse>(); }
}
(InvoiceAllGroupingRequest as unknown)[immerable] = true;

// @Route("/charges/search/ids")
export class ChargeIdsSearchRequest implements IReturn<number[]>, IChargeSearchRequest
{
    public sort: QueryField[]|null;
    public invoicePeriod: InvoicePeriod|null;
    public mode: ChargeSearchMode|null;
    public invoicedStatus: InvoicedStatusToInclude|null;
    public groupIds: number[]|null;
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;
    public date: DateRange|null;
    public addressTo: string|null;
    public description: string|null;
    public amount: CurrencyRange|null;
    public term: string|null;
    public locked: boolean|null;
    public displayDiscountCodes: boolean|null;

    public constructor(init?: Partial<ChargeIdsSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ChargeIdsSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Array<number>(); }
}
(ChargeIdsSearchRequest as unknown)[immerable] = true;

// @Route("/finances/invoices/prepare", "POST")
export class InvoiceGroupingRequest implements IReturn<ResponseBase<InvoiceGroupingResponse>>, ILocationId
{
    public chargeIds: number[]|null;
    public locationId: number|null;

    public constructor(init?: Partial<InvoiceGroupingRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InvoiceGroupingRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<InvoiceGroupingResponse>(); }
}
(InvoiceGroupingRequest as unknown)[immerable] = true;

// @Route("/finances/invoices/generate", "POST")
export class InvoiceWizardRequest implements IReturn<ResponseBase<InvoiceWizardResponse>>, ILocationId
{
    public chargeGroups: ChargeGroup[]|null;
    public date: string|null;
    public batch: InvoiceBatch|null;
    public locationId: number|null;

    public constructor(init?: Partial<InvoiceWizardRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InvoiceWizardRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<InvoiceWizardResponse>(); }
}
(InvoiceWizardRequest as unknown)[immerable] = true;

// @Route("/debt/search")
export class DebtAdvancedSearchRequest extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<DebtsResponse>>
{
    public reference: string|null;
    public status: string|null;
    public account: string|null;
    public accountName: string|null;
    public debtStatus: string[]|null;
    public invoiceStatus: string|null;

    public constructor(init?: Partial<DebtAdvancedSearchRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'DebtAdvancedSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<DebtsResponse>(); }
}
(DebtAdvancedSearchRequest as unknown)[immerable] = true;

// @Route("/expenditure")
// @Route("/expenditure/{Id}")
export class ExpenditureRequest implements IReturn<ResponseBase<ExpenditureResponse>>, ISecurityId
{
    public id: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<ExpenditureRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExpenditureRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ExpenditureResponse>(); }
}
(ExpenditureRequest as unknown)[immerable] = true;

// @Route("/expenditures/count")
export class ExpenditureCountRequest implements IReturn<number>
{

    public constructor(init?: Partial<ExpenditureCountRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExpenditureCountRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return 0; }
}
(ExpenditureCountRequest as unknown)[immerable] = true;

// @Route("/expenditure/search")
export class ExpenditureAdvancedSearchRequest extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<ExpenditureResponse>>
{
    public category: string|null;
    public date: DateRange|null;

    public constructor(init?: Partial<ExpenditureAdvancedSearchRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ExpenditureAdvancedSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ExpenditureResponse>(); }
}
(ExpenditureAdvancedSearchRequest as unknown)[immerable] = true;

// @Route("/expenditure/save")
export class ExpenditureSaveRequest implements IReturn<ResponseBase<ExpenditureResponse>>, ILocationId
{
    public id: number|null;
    public date: string|null;
    public description: string|null;
    public reference: string|null;
    public amountExVAT: number|null;
    public vatRate: number|null;
    public vatAmount: number|null;
    public total: number|null;
    public category: string|null;
    public supplierId: number|null;
    public name: string|null;
    public locationId: number|null;
    public otherPaymentMethod: string|null;
    public chequeNumber: string|null;
    public cardType: string|null;
    public recur: RecurrenceType|null;
    public recurFor: number|null;

    public constructor(init?: Partial<ExpenditureSaveRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExpenditureSaveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ExpenditureResponse>(); }
}
(ExpenditureSaveRequest as unknown)[immerable] = true;

// @Route("/expenditure/delete/{Id}")
// @Route("/expenditure/delete")
export class ExpenditureDeleteRequest implements IReturn<ResponseBase<boolean>>, ISecurityId
{
    public id: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<ExpenditureDeleteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExpenditureDeleteRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ExpenditureDeleteRequest as unknown)[immerable] = true;

// @Route("/invoice/{id}", "GET")
export class InvoicesRequest implements IReturn<ResponseBase<InvoicesResponse>>, ISecurityId
{
    public id: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<InvoicesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InvoicesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<InvoicesResponse>(); }
}
(InvoicesRequest as unknown)[immerable] = true;

// @Route("/invoice", "POST")
// @Route("/invoice/{id}", "PUT")
export class InvoiceSaveRequest implements IReturn<ResponseBase<InvoicesResponse>>, ISecurityId
{
    public id: number|null;
    public status: string|null;
    public reference: string|null;
    public date: string|null;
    public dueDate: string|null;
    public fullyPaidDate: string|null;
    public grandTotal: number|null;
    public amountPaid: number|null;
    public customerId: number|null;
    public locationId: number|null;
    public accountId: number|null;
    public addressTo: string|null;
    public addressLine1: string|null;
    public addressLine2: string|null;
    public addressLine3: string|null;
    public addressLine4: string|null;
    public addressLine5: string|null;
    public postCode: string|null;
    public reminder: string|null;
    public secondReminder: string|null;
    public totalExcludingVat: number|null;
    public vatAmount: number|null;
    public batchId: number|null;
    public notes: string|null;
    public accountType: string|null;
    public accountTypeId: number|null;
    public securityId: number|null;
    public purchaseOrderNumber: string|null;
    public meta: { [index:string]: Object; }|null;
    public medicalContactId: number|null;
    public referralDate: string|null;

    public constructor(init?: Partial<InvoiceSaveRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InvoiceSaveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<InvoicesResponse>(); }
}
(InvoiceSaveRequest as unknown)[immerable] = true;

// @Route("/invoice/{id}/acknowledge", "POST")
export class ProntoInvoiceAcknowledgeRequest implements IReturn<ResponseBase<T>>, ISecurityId
{
    public id: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<ProntoInvoiceAcknowledgeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProntoInvoiceAcknowledgeRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(ProntoInvoiceAcknowledgeRequest as unknown)[immerable] = true;

export class ProntoInvoiceResubmitRequest implements IReturn<ResponseBase<T>>, ISecurityId
{
    public id: number|null;
    public templateId: string|null;
    public securityId: number|null;

    public constructor(init?: Partial<ProntoInvoiceResubmitRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProntoInvoiceResubmitRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(ProntoInvoiceResubmitRequest as unknown)[immerable] = true;

export class ProntoQueriedInvoiceEditRequest implements IReturn<ResponseBase<T>>, ISecurityId
{
    public id: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<ProntoQueriedInvoiceEditRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProntoQueriedInvoiceEditRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(ProntoQueriedInvoiceEditRequest as unknown)[immerable] = true;

// @Route("/invoices/count")
export class InvoiceCountRequest implements IReturn<number>
{

    public constructor(init?: Partial<InvoiceCountRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InvoiceCountRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return 0; }
}
(InvoiceCountRequest as unknown)[immerable] = true;

// @Route("/invoice/delete/{Id}", "DELETE")
export class InvoiceDeleteRequest implements IReturn<boolean>, ILocationId, ISecurityId
{
    public id: number|null;
    public locationId: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<InvoiceDeleteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InvoiceDeleteRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return false; }
}
(InvoiceDeleteRequest as unknown)[immerable] = true;

// @Route("/invoice/{id}/change", "POST")
export class InvoiceChangeRequest implements IReturn<ResponseBase<boolean>>, ISecurityId
{
    public id: number|null;
    public type: string|null;
    public changeToId: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<InvoiceChangeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InvoiceChangeRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(InvoiceChangeRequest as unknown)[immerable] = true;

// @Route("/invoices/payments/{id}")
export class InvoicePaymentRequest implements IReturn<ResponseBase<InvoicePaymentsResponse>>, ILocationId
{
    public id: number|null;
    public amount: number|null;
    public locationId: number|null;

    public constructor(init?: Partial<InvoicePaymentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InvoicePaymentRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<InvoicePaymentsResponse>(); }
}
(InvoicePaymentRequest as unknown)[immerable] = true;

// @Route("/invoice/{InvoiceId}/usePayment", "POST")
export class InvoiceUsePaymentRequest implements IReturn<ResponseBase<InvoicePaymentsResponse>>, IInvoiceId, ILocationId
{
    public invoiceId: number|null;
    public paymentId: number|null;
    public amount: number|null;
    public locationId: number|null;
    public emailReceipt: boolean|null;
    public receiptTemplate: string|null;
    public customerId: number|null;
    public forceApply: boolean|null;
    public isPaymentCreatedFromInvoice: boolean|null;

    public constructor(init?: Partial<InvoiceUsePaymentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InvoiceUsePaymentRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<InvoicePaymentsResponse>(); }
}
(InvoiceUsePaymentRequest as unknown)[immerable] = true;

// @Route("/invoice/{InvoiceId}/useCharge")
export class InvoiceUseBillingItemRequest implements IReturn<ResponseBase<boolean>>, IInvoiceId, ILocationId
{
    public id: number|null;
    public invoiceId: number|null;
    public locationId: number|null;

    public constructor(init?: Partial<InvoiceUseBillingItemRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InvoiceUseBillingItemRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(InvoiceUseBillingItemRequest as unknown)[immerable] = true;

// @Route("/invoice/{InvoiceId}/removeReconcilitation/{Id}")
export class InvoiceRemoveReconciliationRequest implements IReturn<ResponseBase<boolean>>, IInvoiceId, ILocationId
{
    public id: number|null;
    public invoiceId: number|null;
    public locationId: number|null;

    public constructor(init?: Partial<InvoiceRemoveReconciliationRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InvoiceRemoveReconciliationRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(InvoiceRemoveReconciliationRequest as unknown)[immerable] = true;

// @Route("/invoice/{InvoiceId}/removeCharge/{Id}")
export class InvoiceRemoveChargeRequest implements IReturn<ResponseBase<boolean>>, IInvoiceId, ISecurityId
{
    public id: number|null;
    public invoiceId: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<InvoiceRemoveChargeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InvoiceRemoveChargeRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(InvoiceRemoveChargeRequest as unknown)[immerable] = true;

// @Route("/invoice/{InvoiceId}/deletePayment/{Id}")
export class InvoiceDeletePaymentRequest implements IReturn<ResponseBase<boolean>>, IInvoiceId, ISecurityId
{
    public id: number|null;
    public invoiceId: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<InvoiceDeletePaymentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InvoiceDeletePaymentRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(InvoiceDeletePaymentRequest as unknown)[immerable] = true;

// @Route("/invoice/removeAllReconciliations/{InvoiceId}")
export class InvoiceRemoveAllReconciliationsRequest implements IReturn<ResponseBase<boolean>>, IInvoiceId, ISecurityId
{
    public invoiceId: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<InvoiceRemoveAllReconciliationsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InvoiceRemoveAllReconciliationsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(InvoiceRemoveAllReconciliationsRequest as unknown)[immerable] = true;

// @Route("/invoice/{InvoiceId}/createCharges")
export class CreateChargesRequest implements IReturn<ResponseBase<TransactionResponse>>, IInvoiceId, ILocationId
{
    public charges: Charge[]|null;
    public invoiceId: number|null;
    public locationId: number|null;

    public constructor(init?: Partial<CreateChargesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateChargesRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<TransactionResponse>(); }
}
(CreateChargesRequest as unknown)[immerable] = true;

// @Route("/invoice/{InvoiceId}/createCharge")
export class CreateChargeRequest implements IReturn<ResponseBase<TransactionResponse>>, IInvoiceId, ILocationId
{
    public charge: Charge|null;
    public invoiceId: number|null;
    public locationId: number|null;

    public constructor(init?: Partial<CreateChargeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateChargeRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<TransactionResponse>(); }
}
(CreateChargeRequest as unknown)[immerable] = true;

// @Route("/invoice/search")
export class InvoicesAdvancedSearchRequest extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<InvoicesResponse>>
{
    public reference: string|null;
    public addressTo: string|null;
    public date: DateRange|null;
    public dueDate: DateRange|null;
    public amount: CurrencyRange|null;
    public locked: boolean|null;
    public status: string|null;
    public batchId: number|null;
    public accountId: number|null;
    public accountType: string|null;
    public registrationNumber: string|null;

    public constructor(init?: Partial<InvoicesAdvancedSearchRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'InvoicesAdvancedSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<InvoicesResponse>(); }
}
(InvoicesAdvancedSearchRequest as unknown)[immerable] = true;

// @Route("/invoice/batch")
export class InvoiceBatchRequest implements IReturn<ResponseBase<InvoiceBatchResponse>>, ILocationId
{
    public id: number|null;
    public locationId: number|null;

    public constructor(init?: Partial<InvoiceBatchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InvoiceBatchRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<InvoiceBatchResponse>(); }
}
(InvoiceBatchRequest as unknown)[immerable] = true;

// @Route("/groups/account")
// @Route("/groups/account/{GroupId}")
export class GroupsAccountSearchRequest implements IReturn<ResponseBase<GroupsAccountSearchResponse>>, ILocationId
{
    public skip: number|null;
    public take: number|null;
    public groupId: number|null;
    public customerId: number|null;
    public date: DateRange|null;
    public sort: QueryField[]|null;
    public locationId: number|null;

    public constructor(init?: Partial<GroupsAccountSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GroupsAccountSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<GroupsAccountSearchResponse>(); }
}
(GroupsAccountSearchRequest as unknown)[immerable] = true;

// @Route("/groups/billing")
// @Route("/groups/billing/{GroupId}")
export class GroupsBillingItemSearchRequest implements IReturn<ResponseBase<GroupBillingItemsResponse>>, ILocationId
{
    public skip: number|null;
    public take: number|null;
    public groupId: number|null;
    public sort: QueryField[]|null;
    public locationId: number|null;

    public constructor(init?: Partial<GroupsBillingItemSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GroupsBillingItemSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<GroupBillingItemsResponse>(); }
}
(GroupsBillingItemSearchRequest as unknown)[immerable] = true;

// @Route("/invoice/{InvoiceId}/deleteBillingItem/{Id}")
// @Route("/billingItem/delete/{Id}")
export class BillingItemDeleteRequest implements IReturn<ResponseBase<boolean>>, ILocationId, ISecurityId
{
    public id: number|null;
    public locationId: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<BillingItemDeleteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BillingItemDeleteRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(BillingItemDeleteRequest as unknown)[immerable] = true;

// @Route("/invoice/{InvoiceId}/transactions")
export class TransactionRequest implements IReturn<ResponseBase<TransactionResponse>>, IInvoiceId, ISecurityId
{
    public invoiceId: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<TransactionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TransactionRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<TransactionResponse>(); }
}
(TransactionRequest as unknown)[immerable] = true;

// @Route("/invoice/medipass/{InvoiceId}")
export class InvoiceMedipassRequest implements IInvoiceId, ISecurityId
{
    public invoiceId: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<InvoiceMedipassRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InvoiceMedipassRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(InvoiceMedipassRequest as unknown)[immerable] = true;

// @Route("/invoice/transfer")
export class TransferRequest implements IReturn<TransferResponse>, IInvoiceId, ISecurityId
{
    public invoice: Invoice|null;
    public item: Charge|null;
    public newInvoice: boolean|null;
    public useCredit: boolean|null;
    public invoiceId: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<TransferRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TransferRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TransferResponse(); }
}
(TransferRequest as unknown)[immerable] = true;

export class ClickInvoiceUseChargesRequest implements IReturn<ResponseBase<boolean>>, ILocationId
{
    public chargeIds: number[]|null;
    public invoiceId: number|null;
    public locationId: number|null;

    public constructor(init?: Partial<ClickInvoiceUseChargesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickInvoiceUseChargesRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ClickInvoiceUseChargesRequest as unknown)[immerable] = true;

// @Route("/payment/{Id}", "GET")
export class GetPaymentRequest implements IReturn<ResponseBase<PaymentDetailsResponse>>, ISecurityId
{
    public id: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<GetPaymentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPaymentRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<PaymentDetailsResponse>(); }
}
(GetPaymentRequest as unknown)[immerable] = true;

// @Route("/payments/count")
export class PaymentCountRequest implements IReturn<number>
{

    public constructor(init?: Partial<PaymentCountRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PaymentCountRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return 0; }
}
(PaymentCountRequest as unknown)[immerable] = true;

// @Route("/payment", "POST")
export class CreatePaymentRequest extends Income implements IReturn<number>
{
    public emailReceipt: boolean|null;
    public receiptTemplate: string|null;
    public isPaymentCreatedFromInvoice: boolean|null;

    public constructor(init?: Partial<CreatePaymentRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CreatePaymentRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return 0; }
}
(CreatePaymentRequest as unknown)[immerable] = true;

// @Route("/payment/{Id}", "PUT")
export class SavePaymentRequest extends Income implements IReturn<ResponseBase<PaymentResponse>>
{

    public constructor(init?: Partial<SavePaymentRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SavePaymentRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<PaymentResponse>(); }
}
(SavePaymentRequest as unknown)[immerable] = true;

// @Route("/payment/{Id}", "DELETE")
export class DeletePaymentRequest implements IReturn<boolean>, ISecurityId
{
    public id: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<DeletePaymentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeletePaymentRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return false; }
}
(DeletePaymentRequest as unknown)[immerable] = true;

export class VoidPaymentRequest implements IReturn<boolean>, ISecurityId
{
    public id: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<VoidPaymentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'VoidPaymentRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return false; }
}
(VoidPaymentRequest as unknown)[immerable] = true;

// @Route("/payment/{Id}/refund", "POST")
export class PaymentRefundRequest extends Income implements IReturn<ResponseBase<PaymentResponse>>
{
    public paymentId: number|null;
    public unreconcile: boolean|null;

    public constructor(init?: Partial<PaymentRefundRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'PaymentRefundRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<PaymentResponse>(); }
}
(PaymentRefundRequest as unknown)[immerable] = true;

// @Route("/payment/{Id}/reconcile", "POST")
export class PaymentReconciliationRequest implements IReturn<ResponseBase<ReconciliationResponse>>, ISecurityId
{
    public id: number|null;
    public securityId: number|null;
    public reconciliations: ReconciliationResponse[]|null;

    public constructor(init?: Partial<PaymentReconciliationRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PaymentReconciliationRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ReconciliationResponse>(); }
}
(PaymentReconciliationRequest as unknown)[immerable] = true;

// @Route("/payment/search")
export class PaymentAdvancedSearchRequest extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<PaymentResponse>>
{
    public reference: string|null;
    public paymentMethod: string|null;
    public lodgementReference: string|null;
    public status: string|null;
    public refunds: boolean|null;
    public amount: CurrencyRange|null;
    public date: DateRange|null;
    public receivedAtLocationIds: number[]|null;
    public locked: boolean|null;
    public accountId: number|null;

    public constructor(init?: Partial<PaymentAdvancedSearchRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'PaymentAdvancedSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<PaymentResponse>(); }
}
(PaymentAdvancedSearchRequest as unknown)[immerable] = true;

// @Route("/appointment/cancellationreason")
export class CancellationReasonRequest implements IReturn<ResponseBase<CancellationReasonResponse>>, ISecurityId
{
    public appointmentId: number|null;
    public securityId: number|null;
    public reason: string|null;
    public deleteCase: boolean|null;
    public updateAuths: boolean|null;

    public constructor(init?: Partial<CancellationReasonRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CancellationReasonRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CancellationReasonResponse>(); }
}
(CancellationReasonRequest as unknown)[immerable] = true;

// @Route("/quickbill/{Id}/{Mode}")
// @Route("/quickbill/{Id}/{Mode}/{Status}")
// @Route("/quickbill/{Id}/{Mode}/Pronto/{BookingAuditId}")
export class QuickBillRequest implements IReturn<ResponseEnhancerBase<QuickBillResponse>>
{
    public id: number|null;
    public mode: QuickBillMode|null;
    public status: number|null;
    public billToPatient: boolean|null;
    public bookingAuditId: string|null;

    public constructor(init?: Partial<QuickBillRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QuickBillRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseEnhancerBase<QuickBillResponse>(); }
}
(QuickBillRequest as unknown)[immerable] = true;

// @Route("/quickbill/medipass")
export class QuickBillMedipassRequest implements IReturn<ResponseBase<QuickbillMedipassResponse>>, ILocationId, ICustomerId
{
    public customerId: number|null;
    public locationId: number|null;
    public appointmentId: number|null;
    public groupInvoiceId: number|null;
    public amount: number|null;

    public constructor(init?: Partial<QuickBillMedipassRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QuickBillMedipassRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<QuickbillMedipassResponse>(); }
}
(QuickBillMedipassRequest as unknown)[immerable] = true;

// @Route("/quickbill/prepaid")
export class QuickBillPrePaidRequest implements IReturn<ResponseBase<AppointmentPrePaidResponse>>, ILocationIds, ICustomerId
{
    public id: number|null;
    public securityId: number|null;
    public appointmentStatus: number|null;
    public appointmentId: number|null;
    public customerId: number|null;
    public deleteCase: boolean|null;
    public creditFee: number|null;
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;
    public prePaidType: EPrePaidType|null;

    public constructor(init?: Partial<QuickBillPrePaidRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QuickBillPrePaidRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<AppointmentPrePaidResponse>(); }
}
(QuickBillPrePaidRequest as unknown)[immerable] = true;

// @Route("/quickpay")
export class QuickPayRequest implements IReturn<ResponseBase<QuickBillCompleteResponse>>, ISecurityId
{
    public id: number|null;
    public securityId: number|null;
    public payments: QuickPayment[]|null;
    public invoices: Invoice[]|null;
    public billingItems: BillingItem[]|null;
    public appointmentStatus: number|null;
    public appointmentId: number|null;
    public deleteCase: boolean|null;
    public reminderSent: boolean|null;
    public cardToken: string|null;
    public isMyClinicIntegration: boolean|null;
    public locationId: number|null;
    public furtherPaymentsAfterUsingPrepaid: boolean|null;

    public constructor(init?: Partial<QuickPayRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QuickPayRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<QuickBillCompleteResponse>(); }
}
(QuickPayRequest as unknown)[immerable] = true;

// @Route("/files/", "DELETE")
// @Route("/delete", "POST")
// @DataContract
export class DeleteRequest implements IReturn<DeleteResponse>, IHasPath
{
    // @DataMember(Order=1)
    public path: string|null;

    // @DataMember(Order=2)
    public isGlobal: boolean|null;

    public constructor(init?: Partial<DeleteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new DeleteResponse(); }
}
(DeleteRequest as unknown)[immerable] = true;

// @Route("/communications/copy")
// @Route("/copy")
// @DataContract
export class CopyRequest implements IReturn<CopyResponse>, IHasPath, IHasNewPath, IPost
{
    // @DataMember(Order=1)
    public path: string|null;

    // @DataMember(Order=2)
    public newName: string|null;

    // @DataMember(Order=3)
    public moveFilesIfExists: boolean|null;

    // @DataMember(Order=4)
    public isGlobal: boolean|null;

    public constructor(init?: Partial<CopyRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CopyRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CopyResponse(); }
}
(CopyRequest as unknown)[immerable] = true;

// @Route("/createFolder")
// @DataContract
export class CreateFolderRequest implements IReturn<CreateFolderResponse>, IHasPath, IHasNewPath
{
    // @DataMember(Order=1)
    public path: string|null;

    // @DataMember(Order=2)
    public newName: string|null;

    public constructor(init?: Partial<CreateFolderRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateFolderRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateFolderResponse(); }
}
(CreateFolderRequest as unknown)[immerable] = true;

// @Route("/communications/rename")
// @Route("/rename")
// @DataContract
export class RenameRequest implements IReturn<RenameResponse>, IHasNewPath, IHasPath
{
    // @DataMember(Order=1)
    public path: string|null;

    // @DataMember(Order=2)
    public newName: string|null;

    // @DataMember(Order=3)
    public overwrite: boolean|null;

    // @DataMember(Order=4)
    public isGlobal: boolean|null;

    public constructor(init?: Partial<RenameRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RenameRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RenameResponse(); }
}
(RenameRequest as unknown)[immerable] = true;

// @Route("/move")
// @DataContract
export class MoveRequest implements IReturn<MoveResponse>, IHasPath, IHasNewPath
{
    // @DataMember(Order=1)
    public path: string|null;

    // @DataMember(Order=2)
    public newName: string|null;

    public constructor(init?: Partial<MoveRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MoveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MoveResponse(); }
}
(MoveRequest as unknown)[immerable] = true;

// @Route("/folder/move")
// @DataContract
export class MoveFolderRequest implements IReturn<MoveResponse>, IHasPath, IHasNewPath
{
    // @DataMember(Order=1)
    public path: string|null;

    // @DataMember(Order=2)
    public newName: string|null;

    // @DataMember(Order=3)
    public isFolder: boolean|null;

    public constructor(init?: Partial<MoveFolderRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MoveFolderRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MoveResponse(); }
}
(MoveFolderRequest as unknown)[immerable] = true;

// @Route("/file", "POST")
// @DataContract
export class UploadFile implements IReturn<UploadResult>, IHasPath, ISecurityType, ISecurityId
{
    // @DataMember(Order=1)
    public path: string|null;

    // @DataMember(Order=2)
    public safeRoot: string|null;

    // @DataMember(Order=3)
    public httpRequest: IHttpRequest|null;

    // @DataMember(Order=4)
    public id: number|null;

    // @DataMember(Order=5)
    public mode: string|null;

    public constructor(init?: Partial<UploadFile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UploadFile'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UploadResult(); }
}
(UploadFile as unknown)[immerable] = true;

// @Route("/tempfile", "POST")
// @DataContract
export class UploadTempFile implements IReturn<UploadTempResult>
{
    // @DataMember(Order=1)
    public id: string|null;

    public constructor(init?: Partial<UploadTempFile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UploadTempFile'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UploadTempResult(); }
}
(UploadTempFile as unknown)[immerable] = true;

export class PublishTempFolder implements IReturn<Object>
{
    // @DataMember(Order=1)
    public folderId: string|null;

    // @DataMember(Order=2)
    public subWorkflowId: number|null;

    // @DataMember(Order=3)
    public workflowId: number|null;

    // @DataMember(Order=4)
    public publishToReferralPortal: boolean|null;

    public constructor(init?: Partial<PublishTempFolder>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PublishTempFolder'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Object(); }
}
(PublishTempFolder as unknown)[immerable] = true;

// @Route("/attachments/summary", "POST")
export class AttachmentSummaryRequest implements IReturn<AttachmentSummaryResponse>
{
    public mode: string|null;
    public onlyReturnTemplates: boolean|null;
    public id: number|null;

    public constructor(init?: Partial<AttachmentSummaryRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AttachmentSummaryRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AttachmentSummaryResponse(); }
}
(AttachmentSummaryRequest as unknown)[immerable] = true;

// @Route("/attachments/upload", "POST")
// @DataContract
export class AttachmentUploadRequest implements IReturn<UploadResult>, IHasPath
{
    // @DataMember(Order=1)
    public path: string|null;

    // @DataMember(Order=2)
    public safeRoot: string|null;

    // @DataMember(Order=3)
    public httpRequest: IHttpRequest|null;

    // @DataMember(Order=4)
    public id: number|null;

    // @DataMember(Order=5)
    public mode: string|null;

    // @DataMember(Order=6)
    public targetFolder: string|null;

    // @DataMember(Order=7)
    public maxWidth: number|null;

    // @DataMember(Order=8)
    public maxHeight: number|null;

    public constructor(init?: Partial<AttachmentUploadRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AttachmentUploadRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UploadResult(); }
}
(AttachmentUploadRequest as unknown)[immerable] = true;

// @Route("/files/bypath/{Path*}", "GET, POST")
export class FileByPathRequest implements IReturn<HttpResult>, IHasPath
{
    public path: string|null;
    public isGlobal: boolean|null;
    public safeRoot: string|null;

    public constructor(init?: Partial<FileByPathRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FileByPathRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new HttpResult(); }
}
(FileByPathRequest as unknown)[immerable] = true;

// @Route("/file/recent", "GET")
// @DataContract
export class RecentFileRequest implements IReturn<RecentFileResponse>, IHasPath
{
    // @DataMember(Order=1)
    public path: string|null;

    // @DataMember(Order=2)
    public safeRoot: string|null;

    public constructor(init?: Partial<RecentFileRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RecentFileRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new RecentFileResponse(); }
}
(RecentFileRequest as unknown)[immerable] = true;

// @Route("/files/listing", "POST")
export class UrlLessFileListing implements IReturn<FilesListingResponse>, IHasPath
{
    public safeRoot: string|null;
    // @DataMember(Order=1)
    public path: string|null;

    // @DataMember(Order=2)
    public recursive: boolean|null;

    public constructor(init?: Partial<UrlLessFileListing>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UrlLessFileListing'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FilesListingResponse(); }
}
(UrlLessFileListing as unknown)[immerable] = true;

// @Route("/file/get", "POST")
// @DataContract
export class UrlLessFileRequest implements IReturn<FileResponse>, IHasPath
{
    // @DataMember(Order=1)
    public path: string|null;

    // @DataMember(Order=2)
    public responseStatus: ResponseStatus|null;

    // @DataMember(Order=3)
    public textMode: boolean|null;

    public constructor(init?: Partial<UrlLessFileRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UrlLessFileRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FileResponse(); }
}
(UrlLessFileRequest as unknown)[immerable] = true;

// @Route("/communications/letter")
// @Route("/files/{Path*}")
// @Route("/files")
// @DataContract
export class FileListing implements IReturn<FilesListingResponse>, IHasPath
{
    // @DataMember(Order=1)
    public path: string|null;

    // @DataMember(Order=2)
    public recursive: boolean|null;

    // @DataMember(Order=3)
    public createDirectoryIfNotExists: boolean|null;

    // @DataMember(Order=4)
    public foldersToIgnore: string|null;

    public constructor(init?: Partial<FileListing>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FileListing'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FilesListingResponse(); }
}
(FileListing as unknown)[immerable] = true;

// @Route("/tempfilelisting/{Id}", "POST")
export class GetTempFileListing implements IReturn<FilesListingResponse>
{
    public id: string|null;

    public constructor(init?: Partial<GetTempFileListing>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTempFileListing'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FilesListingResponse(); }
}
(GetTempFileListing as unknown)[immerable] = true;

// @Route("/removetempfile/{Id}/{FileName}", "POST")
export class RemoveTempFile
{
    public id: string|null;
    public fileName: string|null;

    public constructor(init?: Partial<RemoveTempFile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RemoveTempFile'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(RemoveTempFile as unknown)[immerable] = true;

// @Route("/file", "GET")
// @Route("/file/{Path*}", "GET")
// @DataContract
export class FileRequest implements IReturn<FileResponse>, IHasPath
{
    // @DataMember(Order=1)
    public path: string|null;

    // @DataMember(Order=2)
    public responseStatus: ResponseStatus|null;

    // @DataMember(Order=3)
    public textMode: boolean|null;

    // @DataMember(Order=4)
    public isGlobal: boolean|null;

    public constructor(init?: Partial<FileRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FileRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FileResponse(); }
}
(FileRequest as unknown)[immerable] = true;

// @Route("/download/{Path*}", "GET")
// @DataContract
export class DownloadFileRequest implements IHasPath, IGet
{
    // @DataMember(Order=1)
    public path: string|null;

    // @DataMember(Order=2)
    public isGlobal: boolean|null;

    public constructor(init?: Partial<DownloadFileRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DownloadFileRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(DownloadFileRequest as unknown)[immerable] = true;

// @Route("/file/view/{Path*}", "HEAD, GET")
// @DataContract
export class ViewFileRequest implements IHasPath
{
    // @DataMember(Order=1)
    public path: string|null;

    // @DataMember(Order=2)
    public isGlobal: boolean|null;

    public constructor(init?: Partial<ViewFileRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ViewFileRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(ViewFileRequest as unknown)[immerable] = true;

// @Route("/download/batch")
// @DataContract
export class DownloadBatchFileRequest implements IHasPaths
{
    // @DataMember(Order=1)
    public paths: DownloadBatchRequestObject[]|null;

    // @DataMember(Order=2)
    public isGlobal: boolean|null;

    public constructor(init?: Partial<DownloadBatchFileRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DownloadBatchFileRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(DownloadBatchFileRequest as unknown)[immerable] = true;

// @Route("/email/download/{Path*}", "GET")
// @DataContract
export class DownloadEmailRequest implements IHasPath
{
    // @DataMember(Order=1)
    public path: string|null;

    public constructor(init?: Partial<DownloadEmailRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DownloadEmailRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(DownloadEmailRequest as unknown)[immerable] = true;

// @Route("/email/attachment/{Path*}", "GET")
export class DownloadAttachmentRequest implements IHasPath
{
    public path: string|null;
    public safeRoot: string|null;
    public attachmentName: string|null;

    public constructor(init?: Partial<DownloadAttachmentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DownloadAttachmentRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(DownloadAttachmentRequest as unknown)[immerable] = true;

// @Route("/communications/documents/save", "POST")
// @DataContract
export class SaveDocument implements IReturn<boolean>, IHasPath, ISecurityId, ISecurityType
{
    // @DataMember(Order=1)
    public text: string|null;

    // @DataMember(Order=2)
    public path: string|null;

    // @DataMember(Order=3)
    public action: string|null;

    // @DataMember(Order=4)
    public letterId: number|null;

    // @DataMember(Order=5)
    public title: string|null;

    // @DataMember(Order=6)
    public type: DocumentType|null;

    // @DataMember(Order=7)
    public rename: boolean|null;

    // @DataMember(Order=8)
    public oldPath: string|null;

    // @DataMember(Order=9)
    public objectId: number|null;

    // @DataMember(Order=10)
    public objectType: string|null;

    public constructor(init?: Partial<SaveDocument>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveDocument'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return false; }
}
(SaveDocument as unknown)[immerable] = true;

// @Route("/managementreportfiles/{Id}")
export class ManagementReportDocumentFileListing implements IReturn<FolderTree>, ISecurityId, IGet
{
    public id: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<ManagementReportDocumentFileListing>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ManagementReportDocumentFileListing'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FolderTree(); }
}
(ManagementReportDocumentFileListing as unknown)[immerable] = true;

// @Route("/{Mode}/files/{Id}")
// @Route("/{Mode}/files/{Id}/{ExcludedFileTypes}")
// @Route("/{Mode}/files/{Id}/{ExcludedFileTypes}/{FoldersToIgnore}")
// @Route("/{Mode}/files/{Id}/{ExcludedFileTypes}/{FoldersToIgnore}/{Recursive}")
// @Route("/{Mode}/files/{Id}/{ExcludedFileTypes}/{FoldersToIgnore}/{Recursive}/{IgnoreFiles}")
export class DocumentFileListing implements IReturn<FolderTree>, ISecurityId, ISecurityType, IGet
{
    public id: number|null;
    public mode: string|null;
    public excludedFileTypes: string|null;
    public foldersToIgnore: string|null;
    public recursive: boolean|null;
    public ignoreFiles: boolean|null;
    public path: string|null;
    public skip: number|null;
    public take: number|null;
    public sort: QueryField[]|null;
    public securityId: number|null;
    public securityType: string|null;

    public constructor(init?: Partial<DocumentFileListing>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DocumentFileListing'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FolderTree(); }
}
(DocumentFileListing as unknown)[immerable] = true;

// @Route("/templates")
export class TemplatesRequest implements IReturn<FolderTree>
{
    public folder: string|null;
    public filter: string[]|null;
    public sortedByDate: boolean|null;

    public constructor(init?: Partial<TemplatesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TemplatesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FolderTree(); }
}
(TemplatesRequest as unknown)[immerable] = true;

// @Route("/charts")
export class ChartsRequest implements IReturn<FolderTree>
{
    public folder: string|null;
    public filter: string[]|null;

    public constructor(init?: Partial<ChartsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ChartsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FolderTree(); }
}
(ChartsRequest as unknown)[immerable] = true;

// @Route("/download/extraction/{Id}", "GET")
export class DownloadExtractionRequest
{
    public id: number|null;

    public constructor(init?: Partial<DownloadExtractionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DownloadExtractionRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(DownloadExtractionRequest as unknown)[immerable] = true;

export class UpdateDocumentListingRequest
{
    public fileName: string|null;
    public filePath: string|null;
    public description: string|null;

    public constructor(init?: Partial<UpdateDocumentListingRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateDocumentListingRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(UpdateDocumentListingRequest as unknown)[immerable] = true;

// @Route("/groups/locations/updateProviderNumber")
export class GroupLocationProviderNumberSaveRequest implements ISecurityId
{
    public providerNo: string|null;
    public id: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<GroupLocationProviderNumberSaveRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GroupLocationProviderNumberSaveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(GroupLocationProviderNumberSaveRequest as unknown)[immerable] = true;

// @Route("/groups")
// @Route("/groups/{Id}")
export class GroupRequest implements IReturn<ResponseBase<GroupResponse>>, ISecurityId
{
    public skip: number|null;
    public take: number|null;
    public id: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<GroupRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GroupRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<GroupResponse>(); }
}
(GroupRequest as unknown)[immerable] = true;

// @Route("/groups/count")
export class GroupCountRequest implements IReturn<ResponseBase<number>>
{

    public constructor(init?: Partial<GroupCountRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GroupCountRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<number>(); }
}
(GroupCountRequest as unknown)[immerable] = true;

// @Route("/group/further/{Id}")
export class GroupFurtherDetailsRequest implements IReturn<GroupFurtherDetailsResponse>, ILocationId
{
    public id: number|null;
    public locationId: number|null;

    public constructor(init?: Partial<GroupFurtherDetailsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GroupFurtherDetailsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GroupFurtherDetailsResponse(); }
}
(GroupFurtherDetailsRequest as unknown)[immerable] = true;

// @Route("/group/recent/{Id}")
export class GroupRecentRequest implements IReturn<GroupRecentResponse>, ILocationId
{
    public id: number|null;
    public locationId: number|null;

    public constructor(init?: Partial<GroupRecentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GroupRecentRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GroupRecentResponse(); }
}
(GroupRecentRequest as unknown)[immerable] = true;

// @Route("/group/recentDocument/{GroupId}")
export class RecentGroupDocumentRequest implements IReturn<Object>, IHasPath, ILocationId
{
    public groupId: number|null;
    public path: string|null;
    public safeRoot: string|null;
    public locationId: number|null;

    public constructor(init?: Partial<RecentGroupDocumentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RecentGroupDocumentRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Object(); }
}
(RecentGroupDocumentRequest as unknown)[immerable] = true;

// @Route("/groups/search")
export class GroupsAdvancedSearchRequest extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<GroupResponse>>
{
    public name: string|null;
    public status: boolean|null;
    public classification: string|null;

    public constructor(init?: Partial<GroupsAdvancedSearchRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GroupsAdvancedSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<GroupResponse>(); }
}
(GroupsAdvancedSearchRequest as unknown)[immerable] = true;

// @Route("/groups/export/csv")
export class GroupsAdvancedSearchExportCSVRequest implements IReturn<string>, ILocationIds
{
    public customHeaders: GroupsCSVHeaderOverrides|null;
    public query: GroupsAdvancedSearchRequest|null;
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;

    public constructor(init?: Partial<GroupsAdvancedSearchExportCSVRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GroupsAdvancedSearchExportCSVRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return ''; }
}
(GroupsAdvancedSearchExportCSVRequest as unknown)[immerable] = true;

// @Route("/group/contacts/search")
// @Route("/group/contacts/search/{GroupId}")
export class GroupContactsSearchRequest implements IReturn<ResponseBase<MedicalContactResponse>>, ILocationId
{
    public groupId: number|null;
    public locationId: number|null;

    public constructor(init?: Partial<GroupContactsSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GroupContactsSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<MedicalContactResponse>(); }
}
(GroupContactsSearchRequest as unknown)[immerable] = true;

// @Route("/group/contactsearch", "POST")
// @Route("/group/contactsearch/{GroupId}", "POST")
export class GroupContactQuickSearchRequest implements IReturn<ResponseBase<MedicalContactResponse>>, ISecurityId
{
    public skip: number|null;
    public take: number|null;
    public groupId: number|null;
    public securityId: number|null;
    public searchString: string|null;

    public constructor(init?: Partial<GroupContactQuickSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GroupContactQuickSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<MedicalContactResponse>(); }
}
(GroupContactQuickSearchRequest as unknown)[immerable] = true;

// @Route("/group/linked/{GroupId}", "POST")
// @Route("/group/linked", "POST")
export class LinkedPatientRequest implements IReturn<ResponseBase<GeneralCustomerResponse>>, ISecurityId, IFilterServiceTypeManually
{
    public groupId: number|null;
    public skip: number|null;
    public take: number|null;
    public sort: QueryField[]|null;
    public securityId: number|null;

    public constructor(init?: Partial<LinkedPatientRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LinkedPatientRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<GeneralCustomerResponse>(); }
}
(LinkedPatientRequest as unknown)[immerable] = true;

// @Route("/group/save", "POST")
export class SaveGroupRequest implements IReturn<ResponseBase<GroupResponse>>
{
    public id: number|null;
    public name: string|null;
    public contact: string|null;
    public addressLine1: string|null;
    public addressLine2: string|null;
    public addressLine3: string|null;
    public addressLine4: string|null;
    public addressLine5: string|null;
    public address: string|null;
    public postCode: string|null;
    public telephone: string|null;
    public fax: string|null;
    public web: string|null;
    public email: string|null;
    public locationName: string|null;
    public locationId: number|null;
    public balanceOwed: number|null;
    public showReferrals: boolean|null;
    public groupInvoices: string|null;
    public addressTo: string|null;
    public invoicePeriod: string|null;
    public contractNumber: string|null;
    public accountId: number|null;
    public profileId: number|null;
    public invoiceFrequency: number|null;
    public invoiceWPID: number|null;
    public showVAT: boolean|null;
    public authorisationCode: string|null;
    public defaultMaxTreatments: number|null;
    public classification: string|null;
    public cancellationHours: number|null;
    public paysForDNA: boolean|null;
    public paysForCancel: boolean|null;
    public notificationEmail: string|null;
    public abbreviationPrefix: string|null;
    public online: boolean|null;
    public firstId: number|null;
    public followUpId: number|null;
    public cancelId: number|null;
    public dnaId: number|null;
    public tm3InvoiceTemplate: string|null;
    public meta: { [index:string]: Object; }|null;
    public dueDaysOverride: number|null;
    public isDistributor: boolean|null;
    public distributorGroupId: number|null;
    public groupInvoiceByStockId: boolean|null;
    public useInvoicePaymentTerms: boolean|null;
    public invoicePaymentTerms: string|null;
    public onlineGuid: string|null;
    public billDistributor: boolean|null;
    public minorUpperAgeLimit: number|null;
    public adolescentUpperAgeLimit: number|null;
    public medipassFunder: string|null;
    public medipassFunderCode: string|null;
    public isVatExempt: boolean|null;
    public financialAddress: string|null;
    public vatExemptionNumber: string|null;
    public vatExemptionExpiryDate: string|null;
    public allowedEmails: string|null;
    public authorisationExpiryInDays: number|null;
    public authorisationExpiryTriggerInDays: number|null;
    public remainingAuthorisationThreshold: number|null;

    public constructor(init?: Partial<SaveGroupRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveGroupRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<GroupResponse>(); }
}
(SaveGroupRequest as unknown)[immerable] = true;

// @Route("/group/location/search")
// @Route("/group/location/search/{GroupId}")
export class GroupLocationSearchRequest implements IReturn<LocationStockResponse>, ILocationId
{
    public groupId: number|null;
    public locationId: number|null;

    public constructor(init?: Partial<GroupLocationSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GroupLocationSearchRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new LocationStockResponse(); }
}
(GroupLocationSearchRequest as unknown)[immerable] = true;

// @Route("/group/new/stock/", "POST")
export class LocationNewStockRequest
{
    public groupId: number|null;
    public locationId: number|null;

    public constructor(init?: Partial<LocationNewStockRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LocationNewStockRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(LocationNewStockRequest as unknown)[immerable] = true;

// @Route("/group/stockType/add/", "POST")
export class UpdateDnaCancelStockRequest implements IReturn<Group>, ISecurityId
{
    public groupId: number|null;
    public stockType: string|null;
    public stock: StockLocationItem[]|null;
    public securityId: number|null;

    public constructor(init?: Partial<UpdateDnaCancelStockRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateDnaCancelStockRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Group(); }
}
(UpdateDnaCancelStockRequest as unknown)[immerable] = true;

// @Route("/group/new/location/{id}")
export class LocationNewLocationRequest implements IReturn<Location[]>, ILocationIds
{
    public id: number|null;
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;

    public constructor(init?: Partial<LocationNewLocationRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LocationNewLocationRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Array<Location>(); }
}
(LocationNewLocationRequest as unknown)[immerable] = true;

// @Route("/group/add/stock/all", "POST")
export class AddAllStockToGroupRequest implements IReturn<ResponseBase<boolean>>, ILocationId
{
    public groupId: number|null;
    public stockToAdd: number[]|null;
    public stockToRemove: number[]|null;
    public locationId: number|null;
    public serviceTypeId: number|null;

    public constructor(init?: Partial<AddAllStockToGroupRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AddAllStockToGroupRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(AddAllStockToGroupRequest as unknown)[immerable] = true;

// @Route("/group/select/stock", "POST")
export class ChangeStockOnGroupRequest implements IReturn<ResponseBase<boolean>>, ILocationId
{
    public groupId: number|null;
    public stockId: number|null;
    public locationId: number|null;
    public stockType: string|null;

    public constructor(init?: Partial<ChangeStockOnGroupRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ChangeStockOnGroupRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ChangeStockOnGroupRequest as unknown)[immerable] = true;

// @Route("/group/add/location", "POST")
export class AddLocationToGroupRequest implements IReturn<LocationStockResponse>
{
    public groupId: number|null;
    public firstId: number|null;
    public followUpId: number|null;
    public cancelId: number|null;
    public dnaId: number|null;
    public locationId: number|null;
    public serviceTypeId: number|null;

    public constructor(init?: Partial<AddLocationToGroupRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AddLocationToGroupRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new LocationStockResponse(); }
}
(AddLocationToGroupRequest as unknown)[immerable] = true;

// @Route("/group/delete/location", "POST")
export class RemoveLocationfromGroupRequest implements ILocationId
{
    public groupId: number|null;
    public locationId: number|null;

    public constructor(init?: Partial<RemoveLocationfromGroupRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RemoveLocationfromGroupRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(RemoveLocationfromGroupRequest as unknown)[immerable] = true;

// @Route("/group/change/stock", "POST")
export class ChangeStockfromGroupRequest implements IReturn<ResponseBase<boolean>>, ILocationId
{
    public groupId: number|null;
    public stockToAddId: number|null;
    public stockToRemoveId: number|null;
    public locationId: number|null;
    public stockType: string|null;

    public constructor(init?: Partial<ChangeStockfromGroupRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ChangeStockfromGroupRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ChangeStockfromGroupRequest as unknown)[immerable] = true;

// @Route("/group/settings/{Id}", "GET")
export class GroupSettingsRequest implements IReturn<ResponseBase<GroupServiceTypeOptionsResponse>>, ILocationId
{
    public id: number|null;
    public locationId: number|null;

    public constructor(init?: Partial<GroupSettingsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GroupSettingsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<GroupServiceTypeOptionsResponse>(); }
}
(GroupSettingsRequest as unknown)[immerable] = true;

// @Route("/group/settings/customer")
export class GroupSettingsForCustomerRequest implements IReturn<ResponseBase<GroupServiceTypeOptionsResponse>>, IServiceTypeId
{
    public id: number|null;
    public customerId: number|null;
    public serviceTypeId: number|null;

    public constructor(init?: Partial<GroupSettingsForCustomerRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GroupSettingsForCustomerRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<GroupServiceTypeOptionsResponse>(); }
}
(GroupSettingsForCustomerRequest as unknown)[immerable] = true;

// @Route("/group/notificationTypes")
// @Route("/group/notifications/{Id}")
export class GroupNotificationsRequest implements IReturn<AppointmentEventBase[]>, ILocationId
{
    public id: number|null;
    public locationId: number|null;

    public constructor(init?: Partial<GroupNotificationsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GroupNotificationsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Array<AppointmentEventBase>(); }
}
(GroupNotificationsRequest as unknown)[immerable] = true;

// @Route("/group/profile")
// @Route("/group/profile/{Id}")
export class GroupProfileRequest implements IReturn<ResponseBase<GroupProfileDto>>, ISecurityId
{
    public id: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<GroupProfileRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GroupProfileRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<GroupProfileDto>(); }
}
(GroupProfileRequest as unknown)[immerable] = true;

// @Route("/group/settings/save", "POST")
export class GroupServiceTypeOptionsRequest implements IReturn<GroupServiceTypeOptions>, ISecurityId
{
    public id: number|null;
    public serviceTypeID: number|null;
    public groupID: number|null;
    public securityId: number|null;
    public useAuthCodes: boolean|null;
    public useDummyAuthCodes: boolean|null;
    public dummyCodePrefix: string|null;
    public cancelAffectsAuthCount: boolean|null;
    public dnaAffectsAuthCount: boolean|null;
    public authCodeGenerateMode: number|null;
    public authCodeGenerateAssess: number|null;
    public authCodeGenerateTreat: number|null;
    public authCodeGenerateAll: number|null;
    public cancelAlwaysAffectsAuthCount: boolean|null;
    public cancelAffectsAuthCountDays: number|null;

    public constructor(init?: Partial<GroupServiceTypeOptionsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GroupServiceTypeOptionsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GroupServiceTypeOptions(); }
}
(GroupServiceTypeOptionsRequest as unknown)[immerable] = true;

// @Route("/group/save/all", "POST")
export class SaveAllGroupRequest implements IReturn<ResponseBase<GroupResponse>>, ISecurityId
{
    public securityId: number|null;
    public groupId: number|null;
    public group: SaveGroupRequest|null;
    public settings: GroupServiceTypeOptionsRequest[]|null;
    public profile: GroupProfileDto|null;
    public notifications: NotificationSubscription[]|null;
    public chargesToRemove: GroupStockResponse[]|null;
    public chargesToUpdate: GroupStockResponse[]|null;
    public locationsToUpdate: LocResponse[]|null;
    public locationsToRemove: LocResponse[]|null;

    public constructor(init?: Partial<SaveAllGroupRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveAllGroupRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<GroupResponse>(); }
}
(SaveAllGroupRequest as unknown)[immerable] = true;

// @Route("/groups/current")
export class GroupCurrentRequest implements IReturn<ResponseBase<GroupResponse>>
{

    public constructor(init?: Partial<GroupCurrentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GroupCurrentRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<GroupResponse>(); }
}
(GroupCurrentRequest as unknown)[immerable] = true;

export class ClickGroupServicesRequest implements IReturn<ResponseBase<GroupStockResponse>>
{
    public skip: number|null;
    public take: number|null;
    public sort: QueryField[]|null;
    public groupId: number|null;

    public constructor(init?: Partial<ClickGroupServicesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickGroupServicesRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<GroupStockResponse>(); }
}
(ClickGroupServicesRequest as unknown)[immerable] = true;

// @Route("/healthcode/getbusinesses")
export class GetBusinessesRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<GetBusinessesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetBusinessesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(GetBusinessesRequest as unknown)[immerable] = true;

// @Route("/healthcode/addbusiness")
export class AddBusinessRequest
{
    public businesses: AddBusinessModel[]|null;

    public constructor(init?: Partial<AddBusinessRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AddBusinessRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(AddBusinessRequest as unknown)[immerable] = true;

// @Route("/healthcode/getallisc")
export class GetAllIscRequest
{

    public constructor(init?: Partial<GetAllIscRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAllIscRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(GetAllIscRequest as unknown)[immerable] = true;

// @Route("/healthcode/searchisc")
export class SearchIscRequest
{
    public term: string|null;

    public constructor(init?: Partial<SearchIscRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SearchIscRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(SearchIscRequest as unknown)[immerable] = true;

// @Route("/healthcode/business/providercodes")
export class GetProviderCodesRequest
{
    public provideCodeOption: number|null;
    public groupId: number|null;
    public skip: number|null;
    public take: number|null;

    public constructor(init?: Partial<GetProviderCodesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetProviderCodesRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(GetProviderCodesRequest as unknown)[immerable] = true;

// @Route("/healthcode/business/{id}")
export class GetBusinessDetailsRequest
{
    public id: number|null;

    public constructor(init?: Partial<GetBusinessDetailsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetBusinessDetailsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(GetBusinessDetailsRequest as unknown)[immerable] = true;

// @Route("/healthcode/login/update")
export class UpdateHealthcodeLoginDetailRequest
{
    public username: string|null;
    public password: string|null;

    public constructor(init?: Partial<UpdateHealthcodeLoginDetailRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateHealthcodeLoginDetailRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(UpdateHealthcodeLoginDetailRequest as unknown)[immerable] = true;

// @Route("/healthcode/business/update")
export class UpdateBusinessDetailRequest
{
    public id: number|null;
    public locationId: number|null;
    public property: string|null;
    public value: Object|null;

    public constructor(init?: Partial<UpdateBusinessDetailRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateBusinessDetailRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(UpdateBusinessDetailRequest as unknown)[immerable] = true;

// @Route("/healthcode/business/update/providercode")
export class UpdateBusinessProviderCodeRequest
{
    public id: number|null;
    public groupId: number|null;
    public providerNoOption: number|null;
    public providerNo: string|null;

    public constructor(init?: Partial<UpdateBusinessProviderCodeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateBusinessProviderCodeRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(UpdateBusinessProviderCodeRequest as unknown)[immerable] = true;

// @Route("/healthcode/stockitem/update")
export class UpdateStockItemDetailRequest
{
    public id: number|null;
    public property: string|null;
    public value: string|null;

    public constructor(init?: Partial<UpdateStockItemDetailRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateStockItemDetailRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(UpdateStockItemDetailRequest as unknown)[immerable] = true;

// @Route("/healthcode/invoices/export/validate")
export class ValidateExportRequest implements IReturn<ResponseBase<ExportIssueResponse>>, ILocationIds
{
    public startDate: string|null;
    public endDate: string|null;
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;

    public constructor(init?: Partial<ValidateExportRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateExportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ExportIssueResponse>(); }
}
(ValidateExportRequest as unknown)[immerable] = true;

// @Route("/healthcode/invoices/export")
export class ExportHealthcodeInvoicesRequest implements ILocationIds
{
    public startDate: string|null;
    public endDate: string|null;
    public toExport: number[]|null;
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;
    public upload: boolean|null;

    public constructor(init?: Partial<ExportHealthcodeInvoicesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExportHealthcodeInvoicesRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(ExportHealthcodeInvoicesRequest as unknown)[immerable] = true;

// @Route("/healthcode/invoices/exportstatus")
export class GetInvoiceExportStatusRequest
{

    public constructor(init?: Partial<GetInvoiceExportStatusRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInvoiceExportStatusRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(GetInvoiceExportStatusRequest as unknown)[immerable] = true;

// @Route("/healthcode/invoices/uploadedfiles/{Type*}")
export class GetUploadedFilesListRequest implements IReturn<ResponseBase<ExportedInvoiceFileResponse>>
{
    // @DataMember(Order=1)
    public type: string|null;

    public constructor(init?: Partial<GetUploadedFilesListRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetUploadedFilesListRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ExportedInvoiceFileResponse>(); }
}
(GetUploadedFilesListRequest as unknown)[immerable] = true;

// @Route("/healthcode/invoices/download/{Filename}/{Type*}", "GET")
export class DownloadHealthcodeFileRequest
{
    public filename: string|null;
    public type: string|null;

    public constructor(init?: Partial<DownloadHealthcodeFileRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DownloadHealthcodeFileRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(DownloadHealthcodeFileRequest as unknown)[immerable] = true;

// @Route("/healthcode/invoices/download/delete", "POST")
export class DeleteHealthcodeFileRequest implements IReturn<ResponseBase<T>>
{
    public filename: string|null;
    public type: string|null;

    public constructor(init?: Partial<DeleteHealthcodeFileRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteHealthcodeFileRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(DeleteHealthcodeFileRequest as unknown)[immerable] = true;

// @Route("/healthcode/invoices/uploadremittance", "POST")
// @DataContract
export class UploadRemittanceRequest
{

    public constructor(init?: Partial<UploadRemittanceRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UploadRemittanceRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(UploadRemittanceRequest as unknown)[immerable] = true;

// @Route("/healthcode/invoices/importstatus")
export class GetInvoiceImportStatusRequest
{

    public constructor(init?: Partial<GetInvoiceImportStatusRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInvoiceImportStatusRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(GetInvoiceImportStatusRequest as unknown)[immerable] = true;

// @Route("/healthcode/invoices/runningjob")
export class GetRunningBackgroundJobRequest
{

    public constructor(init?: Partial<GetRunningBackgroundJobRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetRunningBackgroundJobRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(GetRunningBackgroundJobRequest as unknown)[immerable] = true;

// @Route("/healthcode/invoices/importsummary")
export class GetInvoiceImportSummaryRequest implements IReturn<ResponseBase<HealthcodeImportSummaryResponse>>
{

    public constructor(init?: Partial<GetInvoiceImportSummaryRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInvoiceImportSummaryRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<HealthcodeImportSummaryResponse>(); }
}
(GetInvoiceImportSummaryRequest as unknown)[immerable] = true;

// @Route("/healthcode/invoices/validationsummary")
export class GetInvoiceValidationSummaryRequest implements IReturn<ResponseBase<ExportIssueResponse>>
{

    public constructor(init?: Partial<GetInvoiceValidationSummaryRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInvoiceValidationSummaryRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ExportIssueResponse>(); }
}
(GetInvoiceValidationSummaryRequest as unknown)[immerable] = true;

// @Route("/healthcode/invoices/exportsummary")
export class GetInvoiceExportSummaryRequest implements IReturn<ResponseBase<HealthcodeExportSummaryResponse>>
{

    public constructor(init?: Partial<GetInvoiceExportSummaryRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInvoiceExportSummaryRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<HealthcodeExportSummaryResponse>(); }
}
(GetInvoiceExportSummaryRequest as unknown)[immerable] = true;

// @Route("/healthcode/businesstocks", "POST")
export class BusinessStocksRequest
{
    public sortBy: string|null;
    public skip: number|null;
    public take: number|null;
    public sortDir: string|null;
    public groupId: number|null;

    public constructor(init?: Partial<BusinessStocksRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BusinessStocksRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(BusinessStocksRequest as unknown)[immerable] = true;

export class MailChimpLoginRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<MailChimpLoginRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MailChimpLoginRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(MailChimpLoginRequest as unknown)[immerable] = true;

// @Route("/mailchimp/pushallemails")
export class PushAllEmailsRequest implements IReturn<ResponseBase<T>>
{
    public listId: string|null;

    public constructor(init?: Partial<PushAllEmailsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PushAllEmailsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(PushAllEmailsRequest as unknown)[immerable] = true;

// @Route("/mailchimp/lists")
export class GetMailchimpListRequest implements IReturn<ResponseBase<AudiencesResponse>>
{

    public constructor(init?: Partial<GetMailchimpListRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMailchimpListRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<AudiencesResponse>(); }
}
(GetMailchimpListRequest as unknown)[immerable] = true;

// @Route("/mailchimp/sync-progress/{ListId}", "GET")
export class GetMailchimpSyncProgressRequest
{
    public listId: string|null;

    public constructor(init?: Partial<GetMailchimpSyncProgressRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMailchimpSyncProgressRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(GetMailchimpSyncProgressRequest as unknown)[immerable] = true;

// @Route("/mailchimp/sync-summary/{ListId}", "GET")
export class GetMailChimpSyncSummary
{
    public listId: string|null;

    public constructor(init?: Partial<GetMailChimpSyncSummary>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMailChimpSyncSummary'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(GetMailChimpSyncSummary as unknown)[immerable] = true;

// @Route("/mailchimp/sync-duplicates/{ListId}", "GET")
export class GetMailChimpSyncDuplicates
{
    public listId: string|null;

    public constructor(init?: Partial<GetMailChimpSyncDuplicates>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMailChimpSyncDuplicates'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(GetMailChimpSyncDuplicates as unknown)[immerable] = true;

// @Route("/mailchimp/sync-log/{ListId}", "GET")
export class GetMailchimpPushAllEmailsLog
{
    public listId: string|null;

    public constructor(init?: Partial<GetMailchimpPushAllEmailsLog>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMailchimpPushAllEmailsLog'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(GetMailchimpPushAllEmailsLog as unknown)[immerable] = true;

// @Route("/mailchimp/duplicates/{CustomerId}")
export class GetDuplicateRequest
{
    public customerId: number|null;

    public constructor(init?: Partial<GetDuplicateRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDuplicateRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(GetDuplicateRequest as unknown)[immerable] = true;

// @Route("/mailchimp/duplicates", "POST")
export class DuplicatesRequest implements IReturn<ResponseBase<MailChimpDuplicatesResponse>>
{
    public customerIds: number[]|null;

    public constructor(init?: Partial<DuplicatesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DuplicatesRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<MailChimpDuplicatesResponse>(); }
}
(DuplicatesRequest as unknown)[immerable] = true;

// @Route("/mailchimp/subscriptions-lists/{CustomerId}", "GET")
export class GetSubscriptionListsRequest
{
    public customerId: number|null;

    public constructor(init?: Partial<GetSubscriptionListsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSubscriptionListsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(GetSubscriptionListsRequest as unknown)[immerable] = true;

// @Route("/mailchimp/subscribecustomertolist")
export class SubscribeCustomerToListRequest
{
    public customerId: number|null;
    public mailchimpListId: string|null;

    public constructor(init?: Partial<SubscribeCustomerToListRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SubscribeCustomerToListRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(SubscribeCustomerToListRequest as unknown)[immerable] = true;

// @Route("/mailchimp/unsubscribecustomerfromlist")
export class UnSubscribeCustomerFromListRequest
{
    public customerId: number|null;
    public mailchimpListId: string|null;

    public constructor(init?: Partial<UnSubscribeCustomerFromListRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UnSubscribeCustomerFromListRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(UnSubscribeCustomerFromListRequest as unknown)[immerable] = true;

// @Route("/mailchimp/unsubscribecustomerfromalllists")
export class UnSubscribeCustomerFromAllListsRequest
{
    public customerId: number|null;

    public constructor(init?: Partial<UnSubscribeCustomerFromAllListsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UnSubscribeCustomerFromAllListsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(UnSubscribeCustomerFromAllListsRequest as unknown)[immerable] = true;

// @Route("/mailchimp/subscribecustomerstolist")
export class SubscribeCustomersToListRequest implements IReturn<ResponseBase<boolean>>
{
    public customerIds: number[]|null;
    public mailchimpListId: string|null;

    public constructor(init?: Partial<SubscribeCustomersToListRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SubscribeCustomersToListRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(SubscribeCustomersToListRequest as unknown)[immerable] = true;

// @Route("/mailchimp/statistic/{ListId}")
export class SyncStatisticRequest
{
    public listId: string|null;

    public constructor(init?: Partial<SyncStatisticRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SyncStatisticRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(SyncStatisticRequest as unknown)[immerable] = true;

// @Route("/mailchimp/unsync-audience/{ListId}")
export class UnsyncAudienceRequest
{
    public listId: string|null;

    public constructor(init?: Partial<UnsyncAudienceRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UnsyncAudienceRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(UnsyncAudienceRequest as unknown)[immerable] = true;

export class PostcodeLookupRequest implements IReturn<ResponseBase<PostcodeLookupResponse>>
{
    public houseNumber: string|null;
    public postcode: string|null;

    public constructor(init?: Partial<PostcodeLookupRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostcodeLookupRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<PostcodeLookupResponse>(); }
}
(PostcodeLookupRequest as unknown)[immerable] = true;

// @Route("/physiotec-practitioners", "GET")
// @Route("/physiotec-practitioner/{Id}", "GET")
export class PhysiotecPractitionerGetRequest implements IReturn<ResponseBase<PhysiotecPractitioner>>
{
    public id: number|null;

    public constructor(init?: Partial<PhysiotecPractitionerGetRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PhysiotecPractitionerGetRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<PhysiotecPractitioner>(); }
}
(PhysiotecPractitionerGetRequest as unknown)[immerable] = true;

// @Route("/physiotec-practitioners", "POST")
// @Route("/physiotec-practitioner/{Id}", "POST")
export class PhysiotecPractitionerPostRequest implements IReturn<ResponseBase<Object>>
{
    public id: number|null;
    public preexisting: boolean|null;

    public constructor(init?: Partial<PhysiotecPractitionerPostRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PhysiotecPractitionerPostRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<Object>(); }
}
(PhysiotecPractitionerPostRequest as unknown)[immerable] = true;

// @Route("/physiotec-practitioner/{Id}/credentials")
export class PhysiotecPractitionerCredentialsRequest implements IReturn<PhysiotecPractitioner>
{
    public id: number|null;

    public constructor(init?: Partial<PhysiotecPractitionerCredentialsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PhysiotecPractitionerCredentialsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PhysiotecPractitioner(); }
}
(PhysiotecPractitionerCredentialsRequest as unknown)[immerable] = true;

// @Route("/discipline/{PractitionerId}")
export class PractitionerDisciplineRequest implements IReturn<CustomListItemResponse[]>, ISecurityId
{
    public practitionerId: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<PractitionerDisciplineRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PractitionerDisciplineRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Array<CustomListItemResponse>(); }
}
(PractitionerDisciplineRequest as unknown)[immerable] = true;

// @Route("/discipline/save")
export class DisciplineSave implements IReturn<CustomListItemResponse[]>, ISecurityId
{
    public practitionerId: number|null;
    public securityId: number|null;
    public disciplines: CustomListItemResponse[]|null;

    public constructor(init?: Partial<DisciplineSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DisciplineSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Array<CustomListItemResponse>(); }
}
(DisciplineSave as unknown)[immerable] = true;

// @Route("/practitioner/group/{PractitionerId}")
export class PractitionerGroupRequest implements IReturn<ResponseBase<PractitionerGroupResponse>>, ISecurityId
{
    public skip: number|null;
    public take: number|null;
    public practitionerId: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<PractitionerGroupRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PractitionerGroupRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<PractitionerGroupResponse>(); }
}
(PractitionerGroupRequest as unknown)[immerable] = true;

// @Route("/practitioner/group/save/")
export class ProviderSave implements IReturn<ResponseBase<PractitionerGroupResponse>>, ISecurityId
{
    public id: number|null;
    public groupId: number|null;
    public providerNo: string|null;
    public practitionerId: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<ProviderSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProviderSave'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<PractitionerGroupResponse>(); }
}
(ProviderSave as unknown)[immerable] = true;

// @Route("/practitioners/group/all/{PractitionerId}")
export class PractitionersGroupAllRequest implements IReturn<ResponseBase<GroupLocationsResponse>>, ISecurityId
{
    public skip: number|null;
    public take: number|null;
    public practitionerId: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<PractitionersGroupAllRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PractitionersGroupAllRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<GroupLocationsResponse>(); }
}
(PractitionersGroupAllRequest as unknown)[immerable] = true;

// @Route("/practitioner/group/remove/")
export class ProviderRemove implements IReturn<ResponseBase<PractitionerGroupResponse>>, ISecurityId
{
    public id: number|null;
    public groupId: number|null;
    public providerNo: string|null;
    public groupName: string|null;
    public practitionerId: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<ProviderRemove>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProviderRemove'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<PractitionerGroupResponse>(); }
}
(ProviderRemove as unknown)[immerable] = true;

// @Route("/practitioners")
// @Route("/practitioners/{Id}")
export class PractitionerRequest implements IReturn<ResponseBase<GeneralPractitionerResponse>>, IGet
{
    public id: number|null;

    public constructor(init?: Partial<PractitionerRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PractitionerRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<GeneralPractitionerResponse>(); }
}
(PractitionerRequest as unknown)[immerable] = true;

// @Route("/practitioners")
// @Route("/practitioners/onlineId/{Id}")
export class PractitionerByOnlineIdRequest implements IReturn<ResponseBase<GeneralPractitionerResponse>>
{
    public id: string|null;

    public constructor(init?: Partial<PractitionerByOnlineIdRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PractitionerByOnlineIdRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<GeneralPractitionerResponse>(); }
}
(PractitionerByOnlineIdRequest as unknown)[immerable] = true;

// @Route("/locations/all/practitioners")
export class PractitionersAtAllLocationsRequest implements IReturn<ResponseBase<PractitionerLocation>>
{

    public constructor(init?: Partial<PractitionersAtAllLocationsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PractitionersAtAllLocationsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<PractitionerLocation>(); }
}
(PractitionersAtAllLocationsRequest as unknown)[immerable] = true;

// @Route("/practitioners/allowed/add/{LocationId}")
export class AddPractitionerRequest implements IReturn<ResponseBase<AddPractitionerResponse>>, ILocationId
{
    public locationId: number|null;

    public constructor(init?: Partial<AddPractitionerRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AddPractitionerRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<AddPractitionerResponse>(); }
}
(AddPractitionerRequest as unknown)[immerable] = true;

// @Route("/practitioners/allPractitioners")
export class AllPractitionersAllRequest implements IReturn<ResponseBase<MinimalPractitioner>>, ILocationIds
{
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;

    public constructor(init?: Partial<AllPractitionersAllRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AllPractitionersAllRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<MinimalPractitioner>(); }
}
(AllPractitionersAllRequest as unknown)[immerable] = true;

// @Route("/practitioners/count")
export class PractitionerCountRequest implements IReturn<number>
{

    public constructor(init?: Partial<PractitionerCountRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PractitionerCountRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return 0; }
}
(PractitionerCountRequest as unknown)[immerable] = true;

// @Route("/practitioners/onlineId")
export class UserIdByPractitionerOnlineIdRequest implements IReturn<ResponseBase<number>>
{
    public practitionerOnlineId: string|null;

    public constructor(init?: Partial<UserIdByPractitionerOnlineIdRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UserIdByPractitionerOnlineIdRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<number>(); }
}
(UserIdByPractitionerOnlineIdRequest as unknown)[immerable] = true;

// @Route("/practitioner/updatePractitionerPatients")
export class UpdatePractitionersPatientsByLocation implements IReturn<boolean>, ISecurityId
{
    public updatedPracsByLocation: PractitionerLocationPair[]|null;
    public id: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<UpdatePractitionersPatientsByLocation>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdatePractitionersPatientsByLocation'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return false; }
}
(UpdatePractitionersPatientsByLocation as unknown)[immerable] = true;

export class LinkPractitionerToZoomUser implements IReturn<ResponseBase<T>>
{
    public id: number|null;
    public zoomUserId: string|null;

    public constructor(init?: Partial<LinkPractitionerToZoomUser>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LinkPractitionerToZoomUser'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(LinkPractitionerToZoomUser as unknown)[immerable] = true;

// @Route("/locations/{id}/practitioners")
export class PractitionersAtLocationRequest implements IReturn<ResponseBase<MinimalPractitioner>>
{
    public id: number|null;

    public constructor(init?: Partial<PractitionersAtLocationRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PractitionersAtLocationRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<MinimalPractitioner>(); }
}
(PractitionersAtLocationRequest as unknown)[immerable] = true;

// @Route("/practitioner/patients/count")
// @Route("/practitioner/patients/count/{id}")
export class PractitionerPatientsCount implements IReturn<ResponseBase<{ [index:number]: number; }>>, ISecurityId
{
    public id: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<PractitionerPatientsCount>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PractitionerPatientsCount'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<{ [index:number]: number; }>(); }
}
(PractitionerPatientsCount as unknown)[immerable] = true;

// @Route("/practitioner/recentDocument")
// @Route("/practitioner/recentDocument/{PractitionerId}")
export class RecentPractitionerDocumentRequest implements IReturn<RecentDocumentResponse>, IHasPath, ISecurityId
{
    public practitionerId: number|null;
    public securityId: number|null;
    public path: string|null;
    public safeRoot: string|null;

    public constructor(init?: Partial<RecentPractitionerDocumentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RecentPractitionerDocumentRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new RecentDocumentResponse(); }
}
(RecentPractitionerDocumentRequest as unknown)[immerable] = true;

// @Route("/practitioner/save")
export class PractitionerSaveRequest implements IReturn<ResponseBase<GeneralPractitionerResponse>>, ILocationId
{
    public id: number|null;
    public name: string|null;
    public code: string|null;
    public fullAddress: string|null;
    public locationName: string|null;
    public title: string|null;
    public forename: string|null;
    public surname: string|null;
    public gender: string|null;
    public addressLine1: string|null;
    public addressLine2: string|null;
    public addressLine3: string|null;
    public addressLine4: string|null;
    public addressLine5: string|null;
    public postCode: string|null;
    public telephone: string|null;
    public mobile: string|null;
    public homeTelephone: string|null;
    public email: string|null;
    public fax: string|null;
    public web: string|null;
    public online: boolean|null;
    public status: number|null;
    public setInactiveDate: string|null;
    public type: string|null;
    public contractNumber: string|null;
    public onlineGuid: string|null;
    public defaultLocationId: number|null;
    public regNumber: string|null;
    public commissionFlatRate: number|null;
    public commissionPercent: number|null;
    public employmentStatus: string|null;
    public taxNo: string|null;
    public firstId: number|null;
    public followupId: number|null;
    public locationId: number|null;
    public serviceTypeId: number|null;
    public enabledForAllServices: boolean|null;

    public constructor(init?: Partial<PractitionerSaveRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PractitionerSaveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<GeneralPractitionerResponse>(); }
}
(PractitionerSaveRequest as unknown)[immerable] = true;

// @Route("/practitioner/locs/save")
export class PractitionersLocationsSave implements IReturn<PracStockLoc[]>, ISecurityId
{
    public practitionerId: number|null;
    public securityId: number|null;
    public locationId: number|null;
    public practitionerServiceStockFirstStockId: number|null;
    public practitionerServiceStockFollowupStockId: number|null;
    public code: string|null;

    public constructor(init?: Partial<PractitionersLocationsSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PractitionersLocationsSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Array<PracStockLoc>(); }
}
(PractitionersLocationsSave as unknown)[immerable] = true;

// @Route("/practitioner/locs/code/save", "POST")
export class PractitionersLocationsCodeSave implements IReturn<ResponseBase<PracStockLoc>>, ISecurityId
{
    public practitionerId: number|null;
    public securityId: number|null;
    public locationId: number|null;
    public code: string|null;

    public constructor(init?: Partial<PractitionersLocationsCodeSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PractitionersLocationsCodeSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<PracStockLoc>(); }
}
(PractitionersLocationsCodeSave as unknown)[immerable] = true;

// @Route("/practitioner/locs/delete")
export class PractitionersLocationsDelete implements IReturn<PracStockLoc[]>, ILocationId, ISecurityId
{
    public practitionerId: number|null;
    public locationId: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<PractitionersLocationsDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PractitionersLocationsDelete'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Array<PracStockLoc>(); }
}
(PractitionersLocationsDelete as unknown)[immerable] = true;

// @Route("/practitioners/locs/all")
// @Route("/practitioners/locs/all/{Id}")
export class PracLocationsWithStock implements IReturn<PracStockLoc[]>, ISecurityId
{
    public id: number|null;
    public securityId: number|null;
    public sort: QueryField[]|null;

    public constructor(init?: Partial<PracLocationsWithStock>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PracLocationsWithStock'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Array<PracStockLoc>(); }
}
(PracLocationsWithStock as unknown)[immerable] = true;

// @Route("/practitioner/new/location/{id}")
export class NewLocationPractitionersRequest implements IReturn<Location[]>, ILocationIds
{
    public id: number|null;
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;

    public constructor(init?: Partial<NewLocationPractitionersRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'NewLocationPractitionersRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Array<Location>(); }
}
(NewLocationPractitionersRequest as unknown)[immerable] = true;

// @Route("/practitioners/diaryOrder")
export class PractitionerDiaryOrderRequest implements IReturn<ResponseBase<CustomListItemResponse>>
{
    public diaryOrder: CustomListItemResponse[]|null;

    public constructor(init?: Partial<PractitionerDiaryOrderRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PractitionerDiaryOrderRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<CustomListItemResponse>(); }
}
(PractitionerDiaryOrderRequest as unknown)[immerable] = true;

export class GetDiaryPractitioners implements IReturn<ResponseBase<PractitionerDiaryOrderResponse>>
{

    public constructor(init?: Partial<GetDiaryPractitioners>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDiaryPractitioners'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<PractitionerDiaryOrderResponse>(); }
}
(GetDiaryPractitioners as unknown)[immerable] = true;

// @Route("/practitionersWithLocations")
export class GetPractitionersWithLocationsRequest implements IReturn<ResponseBase<GeneralPractitionerResponse>>, IGet
{

    public constructor(init?: Partial<GetPractitionersWithLocationsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPractitionersWithLocationsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<GeneralPractitionerResponse>(); }
}
(GetPractitionersWithLocationsRequest as unknown)[immerable] = true;

// @Route("/practitioner/status/update")
export class PractitionerStatusUpdateRequest implements ILocationId
{
    public updates: PractitionerStatusUpdate[]|null;
    public locationId: number|null;
    public newLicensesAmount: number|null;

    public constructor(init?: Partial<PractitionerStatusUpdateRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PractitionerStatusUpdateRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(PractitionerStatusUpdateRequest as unknown)[immerable] = true;

export class SavePractitionerSkillRequest extends PractitionerSkillBaseRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<SavePractitionerSkillRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SavePractitionerSkillRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(SavePractitionerSkillRequest as unknown)[immerable] = true;

export class DeletePractitionerSkillRequest extends PractitionerSkillBaseRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<DeletePractitionerSkillRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'DeletePractitionerSkillRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(DeletePractitionerSkillRequest as unknown)[immerable] = true;

export class CreateSkillRequest implements IReturn<ResponseBase<T>>
{
    public name: string|null;

    public constructor(init?: Partial<CreateSkillRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateSkillRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(CreateSkillRequest as unknown)[immerable] = true;

export class DeleteSkillRequest implements IReturn<ResponseBase<T>>
{
    public id: string|null;

    public constructor(init?: Partial<DeleteSkillRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteSkillRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(DeleteSkillRequest as unknown)[immerable] = true;

export class SkillRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<SkillRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SkillRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(SkillRequest as unknown)[immerable] = true;

export class PractitionerSkillsRequest implements IReturn<ResponseBase<SkillResponse>>
{
    public practitionerId: number|null;

    public constructor(init?: Partial<PractitionerSkillsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PractitionerSkillsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<SkillResponse>(); }
}
(PractitionerSkillsRequest as unknown)[immerable] = true;

export class PractitionerUpdateFieldBulkActionRequest extends PractitionerBulkActionBaseRequest implements IReturn<ResponseBase<UpdateFieldBulkActionResponse>>
{
    public field: BulkUpdateField|null;
    public value: string|null;

    public constructor(init?: Partial<PractitionerUpdateFieldBulkActionRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'PractitionerUpdateFieldBulkActionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<UpdateFieldBulkActionResponse>(); }
}
(PractitionerUpdateFieldBulkActionRequest as unknown)[immerable] = true;

export class MyBookingsRequest implements IReturn<ResponseBase<MyBookingsResponse>>
{
    public skip: number|null;
    public take: number|null;
    public fromDate: string|null;
    public toDate: string|null;
    public type: string|null;
    public reference: string|null;
    public term: string|null;
    public referrer: string|null;
    public practitioner: string|null;
    public status: number|null;
    public statuses: number[]|null;
    public sortColumn: string|null;
    public sortDirection: string|null;
    public referralOnly: boolean|null;
    public customerId: number|null;
    public workflowId: number|null;
    public showAppointmentsInthePast: boolean|null;
    public showNewAuths: boolean|null;
    public showRequiresIAReportSubmission: boolean|null;
    public showNewNotes: boolean|null;
    public showAuthsRevoked: boolean|null;

    public constructor(init?: Partial<MyBookingsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MyBookingsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<MyBookingsResponse>(); }
}
(MyBookingsRequest as unknown)[immerable] = true;

export class BookingAuditsExportRequest implements IReturn<ResponseBase<string>>
{
    public skip: number|null;
    public take: number|null;

    public constructor(init?: Partial<BookingAuditsExportRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BookingAuditsExportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<string>(); }
}
(BookingAuditsExportRequest as unknown)[immerable] = true;

export class SingleBookingAuditRequest implements IReturn<ResponseBase<SingleBookingAuditResponse>>
{
    public id: string|null;

    public constructor(init?: Partial<SingleBookingAuditRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SingleBookingAuditRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<SingleBookingAuditResponse>(); }
}
(SingleBookingAuditRequest as unknown)[immerable] = true;

export class LinkableAppointmentsRequest implements IReturn<ResponseBase<AppointmentResponse>>
{
    public id: string|null;

    public constructor(init?: Partial<LinkableAppointmentsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LinkableAppointmentsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<AppointmentResponse>(); }
}
(LinkableAppointmentsRequest as unknown)[immerable] = true;

export class LinkAppointmentsToReferralRequest implements IReturn<ResponseBase<boolean>>
{
    public auditId: string|null;
    public appointments: AppointmentResponse[]|null;

    public constructor(init?: Partial<LinkAppointmentsToReferralRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LinkAppointmentsToReferralRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(LinkAppointmentsToReferralRequest as unknown)[immerable] = true;

export class MyClinicSummaryRequest implements IReturn<ResponseBase<MyClinicSummaryResponse>>
{

    public constructor(init?: Partial<MyClinicSummaryRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MyClinicSummaryRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<MyClinicSummaryResponse>(); }
}
(MyClinicSummaryRequest as unknown)[immerable] = true;

export class ReferralAppointmentRequest extends ReferralAppointment implements IReturn<ResponseBase<ReferralAppointment>>
{
    public auditId: string|null;
    public yesToWarnings: boolean|null;
    public bookingAudit: BookingAuditResponse|null;

    public constructor(init?: Partial<ReferralAppointmentRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralAppointmentRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ReferralAppointment>(); }
}
(ReferralAppointmentRequest as unknown)[immerable] = true;

export class ReportSearchRequest implements IReturn<ResponseBase<ReportSearchResponse>>
{
    public id: string|null;
    public bookerId: string|null;
    public templateId: string|null;

    public constructor(init?: Partial<ReportSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReportSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ReportSearchResponse>(); }
}
(ReportSearchRequest as unknown)[immerable] = true;

export class EditReportRequest implements IReturn<ResponseBase<ReferralReport>>
{
    public id: string|null;

    public constructor(init?: Partial<EditReportRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EditReportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ReferralReport>(); }
}
(EditReportRequest as unknown)[immerable] = true;

export class DraftReportRequest extends ReferralReport implements IReturn<ResponseBase<ReferralReport>>
{

    public constructor(init?: Partial<DraftReportRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'DraftReportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ReferralReport>(); }
}
(DraftReportRequest as unknown)[immerable] = true;

export class SubmitReportRequest extends ReferralReport implements IReturn<ResponseBase<SubmitReportResponse>>
{
    public appointmentsToLock: string[]|null;
    public isSubmittedFromMyClinic: boolean|null;
    public prontoIntegrationEnabled: boolean|null;
    public linkInvoicesToReports: boolean|null;
    public bookingAuditResponse: BookingAuditResponse|null;

    public constructor(init?: Partial<SubmitReportRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SubmitReportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<SubmitReportResponse>(); }
}
(SubmitReportRequest as unknown)[immerable] = true;

export class ProntoInvoiceSearchRequest implements IReturn<ResponseBase<ProntoInvoiceSearchResponse>>
{
    public id: string|null;
    public auditId: string|null;
    public isRequestFromQuickBill: boolean|null;

    public constructor(init?: Partial<ProntoInvoiceSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProntoInvoiceSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ProntoInvoiceSearchResponse>(); }
}
(ProntoInvoiceSearchRequest as unknown)[immerable] = true;

export class ProntoInvoiceRequest extends ProntoInvoice implements IReturn<ResponseBase<MyClinicInvoiceResponse>>
{
    public submittedFromTM3: boolean|null;

    public constructor(init?: Partial<ProntoInvoiceRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ProntoInvoiceRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<MyClinicInvoiceResponse>(); }
}
(ProntoInvoiceRequest as unknown)[immerable] = true;

export class ProntoInvoiceSubmitRequest extends ProntoInvoice implements IReturn<ResponseBase<MyClinicInvoiceResponse>>
{

    public constructor(init?: Partial<ProntoInvoiceSubmitRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ProntoInvoiceSubmitRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<MyClinicInvoiceResponse>(); }
}
(ProntoInvoiceSubmitRequest as unknown)[immerable] = true;

export class ProntoInvoiceEditRequest extends ProntoInvoice implements IReturn<ResponseBase<MyClinicInvoiceResponse>>
{

    public constructor(init?: Partial<ProntoInvoiceEditRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ProntoInvoiceEditRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<MyClinicInvoiceResponse>(); }
}
(ProntoInvoiceEditRequest as unknown)[immerable] = true;

// @Route("/referral/file/{Path*}", "GET")
export class ReferralAttachmentPathRequest implements IReturn<HttpResult>
{
    public path: string|null;

    public constructor(init?: Partial<ReferralAttachmentPathRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralAttachmentPathRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new HttpResult(); }
}
(ReferralAttachmentPathRequest as unknown)[immerable] = true;

export class GetClickAppointmentsLinkableToProntoReferralRequest implements IReturn<ResponseBase<ClickLinkableAppointment>>
{
    public customerId: number|null;

    public constructor(init?: Partial<GetClickAppointmentsLinkableToProntoReferralRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetClickAppointmentsLinkableToProntoReferralRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClickLinkableAppointment>(); }
}
(GetClickAppointmentsLinkableToProntoReferralRequest as unknown)[immerable] = true;

export class RejectNewReferralRequest implements IReturn<ResponseBase<boolean>>
{
    public id: string|null;

    public constructor(init?: Partial<RejectNewReferralRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RejectNewReferralRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(RejectNewReferralRequest as unknown)[immerable] = true;

export class AcceptNewReferralRequest implements IReturn<ResponseBase<boolean>>
{
    public id: string|null;

    public constructor(init?: Partial<AcceptNewReferralRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AcceptNewReferralRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(AcceptNewReferralRequest as unknown)[immerable] = true;

export class MyClinicWhoReceivesBookingsRequest implements IReturn<ResponseBase<MyClinicWhoReceivesBookingsResponse>>
{
    public firstTimeSetup: boolean|null;

    public constructor(init?: Partial<MyClinicWhoReceivesBookingsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MyClinicWhoReceivesBookingsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<MyClinicWhoReceivesBookingsResponse>(); }
}
(MyClinicWhoReceivesBookingsRequest as unknown)[immerable] = true;

export class ProntoNetworkSettingsRequest implements IReturn<ResponseBase<ProntoNetworkSettingsResponse>>
{

    public constructor(init?: Partial<ProntoNetworkSettingsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProntoNetworkSettingsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ProntoNetworkSettingsResponse>(); }
}
(ProntoNetworkSettingsRequest as unknown)[immerable] = true;

export class MyClinicSettingsRequest extends ClinicSettings implements IReturn<ResponseBase<ClientWhoReceivesBookingsResponse>>
{
    // @Ignore()
    public clinicId: string|null;

    // @Ignore()
    public accountName: string|null;

    public constructor(init?: Partial<MyClinicSettingsRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'MyClinicSettingsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClientWhoReceivesBookingsResponse>(); }
}
(MyClinicSettingsRequest as unknown)[immerable] = true;

export class MyClinicAuthorizationsRequest implements IReturn<ResponseBase<ClientWhoReceivesBookingsResponse>>
{
    public bookerId: string|null;
    public clinicEnabled: boolean|null;
    public provisionals: boolean|null;

    public constructor(init?: Partial<MyClinicAuthorizationsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MyClinicAuthorizationsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClientWhoReceivesBookingsResponse>(); }
}
(MyClinicAuthorizationsRequest as unknown)[immerable] = true;

export class ClinicActivatedOrDeactivatedEmailRequest implements IReturn<ResponseBase<boolean>>
{
    public bookerId: string|null;
    public clinicId: string|null;
    public enabled: boolean|null;

    public constructor(init?: Partial<ClinicActivatedOrDeactivatedEmailRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClinicActivatedOrDeactivatedEmailRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ClinicActivatedOrDeactivatedEmailRequest as unknown)[immerable] = true;

export class LinkUpGroupRequest implements IReturn<ResponseBase<boolean>>
{
    public groups: GroupLinker[]|null;

    public constructor(init?: Partial<LinkUpGroupRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LinkUpGroupRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(LinkUpGroupRequest as unknown)[immerable] = true;

export class RemoveServiceRequest implements IReturn<ResponseBase<boolean>>
{
    public id: string|null;

    public constructor(init?: Partial<RemoveServiceRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RemoveServiceRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(RemoveServiceRequest as unknown)[immerable] = true;

export class ProntoStockRequest extends ProntoStockDto implements IReturn<ResponseBase<ProntoStockDto>>
{

    public constructor(init?: Partial<ProntoStockRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ProntoStockRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ProntoStockDto>(); }
}
(ProntoStockRequest as unknown)[immerable] = true;

export class SaveServiceRequest extends ClinicService implements IReturn<ResponseBase<ClinicService>>
{
    public targetId: string|null;

    public constructor(init?: Partial<SaveServiceRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveServiceRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<ClinicService>(); }
}
(SaveServiceRequest as unknown)[immerable] = true;

export class ProntoPortalCardExpiryRequest
{
    public daysDiff: number|null;
    public lockDate: string|null;

    public constructor(init?: Partial<ProntoPortalCardExpiryRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProntoPortalCardExpiryRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(ProntoPortalCardExpiryRequest as unknown)[immerable] = true;

export class ProntoPortalCardDetailsSaveRequest
{

    public constructor(init?: Partial<ProntoPortalCardDetailsSaveRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProntoPortalCardDetailsSaveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(ProntoPortalCardDetailsSaveRequest as unknown)[immerable] = true;

// @Route("/reports/clinic-reports/{id}", "GET")
export class ClinicReportsRequestById implements IReturn<ResponseBase<ReportsResponse>>
{
    public id: string|null;

    public constructor(init?: Partial<ClinicReportsRequestById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClinicReportsRequestById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ReportsResponse>(); }
}
(ClinicReportsRequestById as unknown)[immerable] = true;

// @Route("/reports/clinic-reports/save", "POST")
export class ClinicReportsSaveRequest implements IReturn<ResponseBase<ReportsResponse>>
{
    public reportId: string|null;
    public name: string|null;
    public description: string|null;
    public data: string|null;

    public constructor(init?: Partial<ClinicReportsSaveRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClinicReportsSaveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ReportsResponse>(); }
}
(ClinicReportsSaveRequest as unknown)[immerable] = true;

// @Route("/reports/clinic-reports/delete")
export class ClinicReportsDeleteRequest
{
    public reportId: string|null;

    public constructor(init?: Partial<ClinicReportsDeleteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClinicReportsDeleteRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(ClinicReportsDeleteRequest as unknown)[immerable] = true;

// @Route("/reports")
export class ReportsRequest implements IReturn<ResponseBase<ReportsResponse>>
{

    public constructor(init?: Partial<ReportsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReportsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ReportsResponse>(); }
}
(ReportsRequest as unknown)[immerable] = true;

// @Route("/reports/bespoke")
export class GetBespokeReports implements IReturn<FolderTree>
{

    public constructor(init?: Partial<GetBespokeReports>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetBespokeReports'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FolderTree(); }
}
(GetBespokeReports as unknown)[immerable] = true;

// @Route("/reports/{ReportId}/favourite")
export class ReportsFavouriteRequest
{
    public reportId: string|null;

    public constructor(init?: Partial<ReportsFavouriteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReportsFavouriteRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(ReportsFavouriteRequest as unknown)[immerable] = true;

// @Route("/reports/{ReportId}/deleteFavourite")
export class ReportsDeleteFavouriteRequest
{
    public reportId: string|null;

    public constructor(init?: Partial<ReportsDeleteFavouriteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReportsDeleteFavouriteRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(ReportsDeleteFavouriteRequest as unknown)[immerable] = true;

// @Route("/rooms", "GET")
// @Route("/rooms/{Id}", "GET,PUT,DELETE")
export class RoomsRequest implements IReturn<ResponseBase<RoomResponse>>, ILocationId, ISecurityId
{
    public id: number|null;
    public description: string|null;
    public locationId: number|null;
    public status: boolean|null;
    public hexColour: string|null;
    public colour: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<RoomsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RoomsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<RoomResponse>(); }
}
(RoomsRequest as unknown)[immerable] = true;

// @Route("/rooms", "PUT")
export class EditRoomsRequest implements IReturn<ResponseBase<RoomResponse>>, ILocationId, ISecurityId
{
    public id: number|null;
    public description: string|null;
    public locationId: number|null;
    public status: boolean|null;
    public hexColour: string|null;
    public colour: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<EditRoomsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EditRoomsRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<RoomResponse>(); }
}
(EditRoomsRequest as unknown)[immerable] = true;

// @Route("/rooms", "POST")
export class CreateRoomsRequest implements IReturn<Room>, ILocationId, ISecurityId
{
    public id: number|null;
    public description: string|null;
    public locationId: number|null;
    public status: boolean|null;
    public hexColour: string|null;
    public colour: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<CreateRoomsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateRoomsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Room(); }
}
(CreateRoomsRequest as unknown)[immerable] = true;

// @Route("/rooms/search", "POST")
export class RoomSearchRequest extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<RoomResponse>>
{
    public description: string|null;
    public status: boolean|null;

    public constructor(init?: Partial<RoomSearchRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'RoomSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<RoomResponse>(); }
}
(RoomSearchRequest as unknown)[immerable] = true;

// @Route("/rooms/search")
// @Route("/rooms/list")
export class RoomsListRequest implements IReturn<Room[]>, ILocationId
{
    public locationId: number|null;

    public constructor(init?: Partial<RoomsListRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RoomsListRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Array<Room>(); }
}
(RoomsListRequest as unknown)[immerable] = true;

// @Route("/rooms/count")
export class RoomCountRequest implements IReturn<number>
{

    public constructor(init?: Partial<RoomCountRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RoomCountRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return 0; }
}
(RoomCountRequest as unknown)[immerable] = true;

// @Route("/diary/rooms/{LocationId}")
export class DiaryRoomsRequest implements IReturn<ResponseBase<RoomResponse>>, ILocationId
{
    public locationId: number|null;

    public constructor(init?: Partial<DiaryRoomsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DiaryRoomsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<RoomResponse>(); }
}
(DiaryRoomsRequest as unknown)[immerable] = true;

// @Route("/reporting-fields-service", "POST")
export class ReportingFieldLookupDto implements IReturn<ResponseBase<ReportingFieldLookupDto>>
{
    public id: string|null;
    public objectType: string|null;
    public displayName: string|null;
    public fieldName: string|null;
    public fieldType: string|null;
    public propagate: boolean|null;

    public constructor(init?: Partial<ReportingFieldLookupDto>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReportingFieldLookupDto'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ReportingFieldLookupDto>(); }
}
(ReportingFieldLookupDto as unknown)[immerable] = true;

// @Route("/reporting-fields-service", "GET")
export class GetReportingFieldLookup implements IReturn<ResponseBase<ReportingFieldLookupDto>>
{
    public id: string|null;

    public constructor(init?: Partial<GetReportingFieldLookup>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetReportingFieldLookup'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ReportingFieldLookupDto>(); }
}
(GetReportingFieldLookup as unknown)[immerable] = true;

export class StockUpdateFieldBulkActionRequest extends StockBulkActionBaseRequest implements IReturn<ResponseBase<UpdateFieldBulkActionResponse>>
{
    public field: BulkUpdateField|null;
    public value: string|null;

    public constructor(init?: Partial<StockUpdateFieldBulkActionRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'StockUpdateFieldBulkActionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<UpdateFieldBulkActionResponse>(); }
}
(StockUpdateFieldBulkActionRequest as unknown)[immerable] = true;

// @Route("/stock/{StockId}")
export class StockRequest extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<StockWithLocationResponse>>, IGet, IDepartmentIds
{
    public stockId: number|null;
    public departmentIds: number[]|null;

    public constructor(init?: Partial<StockRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'StockRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<StockWithLocationResponse>(); }
}
(StockRequest as unknown)[immerable] = true;

// @Route("/stock/location/{LocationId}")
export class StockAtLocationRequest implements IReturn<ResponseBase<StockAtLocationResponse>>, ILocationId
{
    public locationId: number|null;
    public term: string|null;

    public constructor(init?: Partial<StockAtLocationRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StockAtLocationRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<StockAtLocationResponse>(); }
}
(StockAtLocationRequest as unknown)[immerable] = true;

// @Route("/pricing/groups")
export class StockPricingGroupsRequest
{

    public constructor(init?: Partial<StockPricingGroupsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StockPricingGroupsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(StockPricingGroupsRequest as unknown)[immerable] = true;

// @Route("/stocksave/")
export class StockSave implements IReturn<ResponseBase<StockWithLocationResponse>>, ILocationIds, IDepartmentIds
{
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;
    public id: number|null;
    public reference: string|null;
    public totalPrice: number|null;
    public description: string|null;
    public appointmentLength: number|null;
    public groupLocationLocationId: number|null;
    public locationId: number|null;
    public onlineGuid: string|null;
    public colourCss: string|null;
    public inUse: boolean|null;
    public priceExVAT: number|null;
    public vatRate: number|null;
    public vatAmount: number|null;
    public costAmount: number|null;
    public costVATRate: number|null;
    public costExVAT: number|null;
    public costVATAmount: number|null;
    public longDescription: string|null;
    public ledgerCode: string|null;
    public category: string|null;
    public level: number|null;
    public minimumLevel: number|null;
    public displayInPriceList: boolean|null;
    public isPrivateCharge: boolean|null;
    public isMultiple: boolean|null;
    public isClass: boolean|null;
    public serviceTypeId: number|null;
    public migrated: boolean|null;
    public supplierId: number|null;
    public stockIsCancel: boolean|null;
    public stockIsFirst: boolean|null;
    public stockIsFollowUp: boolean|null;
    public stockIsDNA: boolean|null;
    public isVideo: boolean|null;
    public managementFee: boolean|null;
    public online: boolean|null;
    public templateSetId: number|null;
    public classification: string|null;
    public tags: string[]|null;
    public overrides: StockOverrideResponse[]|null;
    public ledgerCodeOverrides: AccountingStockLedgerLookup[]|null;
    public legderCodeAccountId: string|null;
    public groupName: string|null;
    public image: string|null;
    public cancellationCharge: number|null;
    public didNotAttendCharge: number|null;
    public notes: string|null;
    public colour: number|null;
    public departmentIds: number[]|null;
    public specialismId: string|null;
    // @Ignore()
    public templateSetName: string|null;

    // @Ignore()
    public bookingEmail: string|null;

    // @Ignore()
    public bookingSMS: string|null;

    // @Ignore()
    public cancellationEmail: string|null;

    // @Ignore()
    public cancellationSMS: string|null;

    // @Ignore()
    public reminderEmail: string|null;

    // @Ignore()
    public reminderSMS: string|null;

    // @Ignore()
    public showOnline: boolean|null;

    // @Ignore()
    public imgSrc: string|null;

    // @Ignore()
    public fullDescription: string|null;

    // @Ignore()
    public linkedServiceId: string|null;

    // @Ignore()
    public onlineCategory: string|null;

    public credits: number|null;
    public eligibleForTaxExemption: boolean|null;

    public constructor(init?: Partial<StockSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StockSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<StockWithLocationResponse>(); }
}
(StockSave as unknown)[immerable] = true;

// @Route("/all/stock/all")
export class AllStockAllRequest implements IReturn<ResponseBase<StockListResponse>>, ILocationIds
{
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;

    public constructor(init?: Partial<AllStockAllRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AllStockAllRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<StockListResponse>(); }
}
(AllStockAllRequest as unknown)[immerable] = true;

// @Route("/stock/templateSets")
export class StockExistingTemplateSetsRequest
{

    public constructor(init?: Partial<StockExistingTemplateSetsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StockExistingTemplateSetsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(StockExistingTemplateSetsRequest as unknown)[immerable] = true;

// @Route("/stock/categories")
export class StockOnlineCategoriesRequest implements IReturn<ResponseBase<StockOnlineCategoryResponse>>
{

    public constructor(init?: Partial<StockOnlineCategoriesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StockOnlineCategoriesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<StockOnlineCategoryResponse>(); }
}
(StockOnlineCategoriesRequest as unknown)[immerable] = true;

// @Route("/categorystocksave/")
export class StockWithCategoryRequest implements IReturn<ResponseBase<StockWithCategoryResponse>>, ILocationIds, IDepartmentIds
{
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;
    public departmentIds: number[]|null;
    public excludedLocations: string[]|null;
    public stock: StockSave|null;
    public isAvailableOnline: boolean|null;

    public constructor(init?: Partial<StockWithCategoryRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StockWithCategoryRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<StockWithCategoryResponse>(); }
}
(StockWithCategoryRequest as unknown)[immerable] = true;

// @Route("/all/stock")
export class StockExportRequest extends AllStockRequest implements IReturn<ResponseBase<StockWithLocationResponse>>
{

    public constructor(init?: Partial<StockExportRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'StockExportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<StockWithLocationResponse>(); }
}
(StockExportRequest as unknown)[immerable] = true;

// @Route("/suppliers")
export class SupplierRequest implements IReturn<ResponseBase<T>>
{
    public id: number|null;

    public constructor(init?: Partial<SupplierRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SupplierRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(SupplierRequest as unknown)[immerable] = true;

export class SupplierSaveRequest implements IReturn<ResponseBase<SupplierResponse>>, ILocationId
{
    public id: number|null;
    public reference: string|null;
    public name: string|null;
    public contact: string|null;
    public current: boolean|null;
    public email: string|null;
    public telephone: string|null;
    public web: string|null;
    public locationId: number|null;
    public addressLine1: string|null;
    public addressLine2: string|null;
    public addressLine3: string|null;
    public addressLine4: string|null;
    public addressLine5: string|null;
    public postCode: string|null;
    public accountNo: string|null;
    public vatNumber: string|null;

    public constructor(init?: Partial<SupplierSaveRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SupplierSaveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<SupplierResponse>(); }
}
(SupplierSaveRequest as unknown)[immerable] = true;

export class SuppliersAdvancedSearchRequest extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<SupplierResponse>>
{
    public status: boolean|null;
    public address: string|null;
    public reference: string|null;
    public locationId: number|null;
    public locationMulti: number[]|null;
    public name: string|null;
    public accountNo: string|null;

    public constructor(init?: Partial<SuppliersAdvancedSearchRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SuppliersAdvancedSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<SupplierResponse>(); }
}
(SuppliersAdvancedSearchRequest as unknown)[immerable] = true;

// @Route("/audit/search")
export class AuditSearchRequest extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<AuditResponse>>
{
    public customerId: number|null;
    public objectId: number|null;
    public objectType: string|null;
    public action: string|null;
    public actionDetail: string|null;
    public user: string|null;
    public date: DateRange|null;

    public constructor(init?: Partial<AuditSearchRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'AuditSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<AuditResponse>(); }
}
(AuditSearchRequest as unknown)[immerable] = true;

// @Route("/audit/add")
export class AuditAddRequest implements IReturn<ResponseBase<boolean>>
{
    public objectId: number|null;
    public customerId: number|null;
    public objectType: string|null;
    public action: string|null;
    public actionDetail: string|null;

    public constructor(init?: Partial<AuditAddRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AuditAddRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(AuditAddRequest as unknown)[immerable] = true;

// @Route("/cache/load", "POST")
export class CacheRequest implements IReturn<ResponseBase<CacheResponse>>
{
    public cachedUserId: number|null;
    public keys: { [index:string]: string; }|null;

    public constructor(init?: Partial<CacheRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CacheRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CacheResponse>(); }
}
(CacheRequest as unknown)[immerable] = true;

export class LookupCacheRequest extends SingleCacheRequest implements IReturn<ResponseBase<LookupCacheResponse>>
{

    public constructor(init?: Partial<LookupCacheRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'LookupCacheRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<LookupCacheResponse>(); }
}
(LookupCacheRequest as unknown)[immerable] = true;

// @Route("/sys/dictionary/all", "Get")
export class DictionaryRequestAll implements IReturn<ResponseBase<SystemDictionary>>
{

    public constructor(init?: Partial<DictionaryRequestAll>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DictionaryRequestAll'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<SystemDictionary>(); }
}
(DictionaryRequestAll as unknown)[immerable] = true;

// @Route("/settings/labels/save")
export class DynamicLabelUpdate implements IReturn<ResponseBase<DynamicLabelResponse>>
{
    public labels: LabelItem[]|null;

    public constructor(init?: Partial<DynamicLabelUpdate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DynamicLabelUpdate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<DynamicLabelResponse>(); }
}
(DynamicLabelUpdate as unknown)[immerable] = true;

// @Route("/extended/notes")
// @Route("/extended/notes/{NoteId}")
export class ExtendedNotesRequest implements IReturn<ResponseBase<ExtendedNotesResponse>>, ISecurityLocator, IDepartmentIds
{
    public skip: number|null;
    public take: number|null;
    public noteId: number|null;
    public departmentIds: number[]|null;

    public constructor(init?: Partial<ExtendedNotesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExtendedNotesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ExtendedNotesResponse>(); }
}
(ExtendedNotesRequest as unknown)[immerable] = true;

// @Route("/extended/notes/delete", "POST")
export class ExtendedNotesDeleteRequest implements IReturn<ResponseBase<boolean>>, ILocationId, IFilterServiceTypeManually, ISecurityType
{
    public id: number|null;
    public locationId: number|null;
    public type: string|null;
    public securityType: string|null;

    public constructor(init?: Partial<ExtendedNotesDeleteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExtendedNotesDeleteRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ExtendedNotesDeleteRequest as unknown)[immerable] = true;

// @Route("/group/notes/{Id}", "GET")
export class GroupExtendedNotesRequest implements IReturn<ResponseBase<ExtendedNotesResponse>>, ILocationId
{
    public skip: number|null;
    public take: number|null;
    public id: number|null;
    public locationId: number|null;

    public constructor(init?: Partial<GroupExtendedNotesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GroupExtendedNotesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ExtendedNotesResponse>(); }
}
(GroupExtendedNotesRequest as unknown)[immerable] = true;

// @Route("/medicalcontact/notes/{ContactId}", "GET")
export class MedicalContactExtendedNotesRequest implements IReturn<ResponseBase<ExtendedNotesResponse>>, ILocationId
{
    public skip: number|null;
    public take: number|null;
    public contactId: number|null;
    public locationId: number|null;

    public constructor(init?: Partial<MedicalContactExtendedNotesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MedicalContactExtendedNotesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ExtendedNotesResponse>(); }
}
(MedicalContactExtendedNotesRequest as unknown)[immerable] = true;

// @Route("/practitioner/notes/{PractitionerId}")
export class PractitionerExtendedNotesRequest implements IReturn<ResponseBase<ExtendedNotesWithUserName>>, ISecurityId
{
    public skip: number|null;
    public take: number|null;
    public practitionerId: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<PractitionerExtendedNotesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PractitionerExtendedNotesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ExtendedNotesWithUserName>(); }
}
(PractitionerExtendedNotesRequest as unknown)[immerable] = true;

// @Route("/extended/notesave/")
export class ExtendedNotesSave implements IReturn<ResponseBase<ExtendedNotesResponse>>, ISecurityId, ISecurityType, IFilterServiceTypeManually, ISecurityGuid
{
    public id: number|null;
    public type: string|null;
    public typeId: string|null;
    public icon: string|null;
    public colour: string|null;
    public typeGuid: string|null;
    public title: string|null;
    public entry: string|null;
    public noteType: string|null;
    public lastModified: string|null;
    public lockMode: string|null;
    public lockValue: number|null;
    public alert: boolean|null;
    public securityId: number|null;
    public securityType: string|null;
    public serviceTypeId: number|null;
    public securityGuid: string|null;
    public acknowledgementRequired: boolean|null;
    public alertExpiryDate: string|null;
    public alertStartDate: string|null;
    public contextObjectType: TimelineContextObjectType|null;
    public contextId: number|null;
    public linkedObjectType: TimelineLinkedObjectType|null;
    public linkedObjectId: number|null;
    public printOnDocument: boolean|null;

    public constructor(init?: Partial<ExtendedNotesSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExtendedNotesSave'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<ExtendedNotesResponse>(); }
}
(ExtendedNotesSave as unknown)[immerable] = true;

export class MultiExtendedNotesSave
{
    public linkedObjectId: number|null;
    public notes: ExtendedNotesSave[]|null;

    public constructor(init?: Partial<MultiExtendedNotesSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MultiExtendedNotesSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(MultiExtendedNotesSave as unknown)[immerable] = true;

// @Route("/locks/clear")
export class LockClearRequest
{

    public constructor(init?: Partial<LockClearRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LockClearRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(LockClearRequest as unknown)[immerable] = true;

// @Route("/lock/request")
export class LockObtainRequest implements IReturnVoid
{
    public objectType: string|null;
    public objectId: number|null;

    public constructor(init?: Partial<LockObtainRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LockObtainRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(LockObtainRequest as unknown)[immerable] = true;

// @Route("/lock/release")
export class LockReleaseRequest
{
    public objectType: string|null;
    public objectId: number|null;

    public constructor(init?: Partial<LockReleaseRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LockReleaseRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(LockReleaseRequest as unknown)[immerable] = true;

// @Route("/lock/release/user")
export class LockReleaseByUserRequest
{

    public constructor(init?: Partial<LockReleaseByUserRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LockReleaseByUserRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(LockReleaseByUserRequest as unknown)[immerable] = true;

// @Route("/lock/same")
export class LockSameRequest
{
    public id: number|null;
    public type: string|null;
    public startDateTime: string|null;
    public endDateTime: string|null;
    public status: number|null;
    public practitionerId: number|null;
    public locationId: number|null;
    public roomId: number|null;
    public name: string|null;
    public description: string|null;

    public constructor(init?: Partial<LockSameRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LockSameRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(LockSameRequest as unknown)[immerable] = true;

// @Route("/lookup")
export class LookupRequest implements IReturn<ResponseBase<LookupResponse>>
{
    public lookUpType: string|null;

    public constructor(init?: Partial<LookupRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LookupRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<LookupResponse>(); }
}
(LookupRequest as unknown)[immerable] = true;

// @Route("/lookups/all")
export class AllLookupRequest implements IReturn<ResponseBase<LookupResponse>>, ILocationIds
{
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;

    public constructor(init?: Partial<AllLookupRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AllLookupRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<LookupResponse>(); }
}
(AllLookupRequest as unknown)[immerable] = true;

export class NestedLookupsFromTemplateRequest implements IReturn<ResponseBase<NestedLookupResponse>>
{
    public templateId: string|null;

    public constructor(init?: Partial<NestedLookupsFromTemplateRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'NestedLookupsFromTemplateRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<NestedLookupResponse>(); }
}
(NestedLookupsFromTemplateRequest as unknown)[immerable] = true;

// @Route("/lookups/regional")
export class RegionalLookupRequest implements IReturn<ResponseBase<RegionalLookup>>
{

    public constructor(init?: Partial<RegionalLookupRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegionalLookupRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<RegionalLookup>(); }
}
(RegionalLookupRequest as unknown)[immerable] = true;

// @Route("/lookups/add")
export class AddLookupItem implements IReturn<ResponseBase<LookupResponse>>, ILocationId
{
    public lookupId: number|null;
    public name: string|null;
    public value: string|null;
    public locationId: number|null;

    public constructor(init?: Partial<AddLookupItem>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AddLookupItem'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<LookupResponse>(); }
}
(AddLookupItem as unknown)[immerable] = true;

// @Route("/lookups/delete")
export class DeleteLookupItem implements IReturn<ResponseBase<LookupResponse>>
{
    public name: string|null;
    public value: string|null;

    public constructor(init?: Partial<DeleteLookupItem>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteLookupItem'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<LookupResponse>(); }
}
(DeleteLookupItem as unknown)[immerable] = true;

// @Route("/lookups/{Id}")
export class LookupItem implements IReturn<ResponseBase<LookupResponse>>
{
    public id: number|null;
    public name: string|null;
    public value: string|null;

    public constructor(init?: Partial<LookupItem>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LookupItem'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<LookupResponse>(); }
}
(LookupItem as unknown)[immerable] = true;

// @Route("/patterns", "GET")
export class PatternRequest implements IReturn<ResponseBase<{ [index:string]: string; }>>
{

    public constructor(init?: Partial<PatternRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatternRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<{ [index:string]: string; }>(); }
}
(PatternRequest as unknown)[immerable] = true;

// @Route("/security-stats")
export class SecurityStatsRequest implements IReturn<SecurityStatsResponse>
{

    public constructor(init?: Partial<SecurityStatsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SecurityStatsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SecurityStatsResponse(); }
}
(SecurityStatsRequest as unknown)[immerable] = true;

// @Route("/system/message", "GET")
export class SystemMessageRequest
{

    public constructor(init?: Partial<SystemMessageRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemMessageRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(SystemMessageRequest as unknown)[immerable] = true;

// @Route("/system/message/acknowledge", "POST")
export class AcknowledgeSystemMessageRequest
{
    public messageIds: number[]|null;

    public constructor(init?: Partial<AcknowledgeSystemMessageRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AcknowledgeSystemMessageRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(AcknowledgeSystemMessageRequest as unknown)[immerable] = true;

// @Route("/sys/labels/all")
export class DynamicLblRequest
{

    public constructor(init?: Partial<DynamicLblRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DynamicLblRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}

// @Route("/task/{Id}")
export class TaskRequest implements IReturn<ResponseBase<TaskResponse>>, ILocationId, ISecurityId
{
    public id: number|null;
    public ids: number[]|null;
    public locationId: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<TaskRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TaskRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<TaskResponse>(); }
}
(TaskRequest as unknown)[immerable] = true;

// @Route("/tasks/current/{LocationId}", "GET")
export class AllCurrentTasksRequest implements IReturn<TaskForUser[]>, ILocationId
{
    public locationId: number|null;

    public constructor(init?: Partial<AllCurrentTasksRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AllCurrentTasksRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Array<TaskForUser>(); }
}
(AllCurrentTasksRequest as unknown)[immerable] = true;

// @Route("/tasks/availableUsers", "GET")
export class TasksAvailableUsers implements IReturn<UserRoleLocationWithUserName[]>, ILocationIds
{
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;

    public constructor(init?: Partial<TasksAvailableUsers>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TasksAvailableUsers'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Array<UserRoleLocationWithUserName>(); }
}
(TasksAvailableUsers as unknown)[immerable] = true;

// @Route("/user/{Id}/tasks")
export class UserTaskRequest implements IReturn<ResponseBase<TaskResponse>>, ISecurityId
{
    public id: number|null;
    public startDate: string|null;
    public endDate: string|null;
    public securityId: number|null;
    public autoRefresh: boolean|null;

    public constructor(init?: Partial<UserTaskRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UserTaskRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<TaskResponse>(); }
}
(UserTaskRequest as unknown)[immerable] = true;

// @Route("/task", "POST")
// @Route("/task/{Id}", "PUT")
export class TaskSaveRequest extends TaskForUser implements IReturn<ResponseBase<TaskResponse>>
{

    public constructor(init?: Partial<TaskSaveRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TaskSaveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<TaskResponse>(); }
}
(TaskSaveRequest as unknown)[immerable] = true;

// @Route("/user/tasks/search", "POST")
export class UserTasksSearchRequest implements IReturn<ResponseBase<T>>, ISecurityId
{
    public term: string|null;
    public id: number|null;
    public securityId: number|null;
    public includeFuture: boolean|null;
    public showCompleted: boolean|null;
    public skip: number|null;
    public take: number|null;

    public constructor(init?: Partial<UserTasksSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UserTasksSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(UserTasksSearchRequest as unknown)[immerable] = true;

export class TrialCancellationRequest implements IReturn<ResponseBase<boolean>>
{
    public comments: string|null;

    public constructor(init?: Partial<TrialCancellationRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TrialCancellationRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(TrialCancellationRequest as unknown)[immerable] = true;

// @Route("/subdomain/clientId")
export class CorrectSubdomainRequest
{
    public clientId: string|null;
    public email: string|null;

    public constructor(init?: Partial<CorrectSubdomainRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CorrectSubdomainRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(CorrectSubdomainRequest as unknown)[immerable] = true;

// @Route("/settings/clinical/scores-goals/search", "POST")
export class ScoresGoalsSettingsSearchRequest implements IReturn<ResponseBase<ScoresGoalsSettingsResponse>>
{

    public constructor(init?: Partial<ScoresGoalsSettingsSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ScoresGoalsSettingsSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ScoresGoalsSettingsResponse>(); }
}
(ScoresGoalsSettingsSearchRequest as unknown)[immerable] = true;

// @Route("/settings/clinical/scores-goals/{Id}", "GET")
export class ScoresGoalsSettingsGetRequest implements IReturn<ResponseBase<ScoresGoalsSettingsResponse>>
{
    public id: number|null;

    public constructor(init?: Partial<ScoresGoalsSettingsGetRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ScoresGoalsSettingsGetRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ScoresGoalsSettingsResponse>(); }
}
(ScoresGoalsSettingsGetRequest as unknown)[immerable] = true;

// @Route("/settings/clinical/scores-goals/", "POST")
export class ScoresGoalsSettingsPostRequest extends ScoresGoalsSettingsRequest implements IReturn<ResponseBase<ScoresGoalsSettingsResponse>>
{

    public constructor(init?: Partial<ScoresGoalsSettingsPostRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ScoresGoalsSettingsPostRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ScoresGoalsSettingsResponse>(); }
}
(ScoresGoalsSettingsPostRequest as unknown)[immerable] = true;

// @Route("/settings/clinical/scores-goals/{Id}", "PUT")
export class ScoresGoalsSettingsPutRequest extends ScoresGoalsSettingsRequest implements IReturn<ResponseBase<ScoresGoalsSettingsResponse>>
{

    public constructor(init?: Partial<ScoresGoalsSettingsPutRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ScoresGoalsSettingsPutRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<ScoresGoalsSettingsResponse>(); }
}
(ScoresGoalsSettingsPutRequest as unknown)[immerable] = true;

// @Route("/settings/clinical/scores-goals/{Id}", "DELETE")
export class ScoresGoalsSettingsDeleteRequest implements IReturn<ResponseBase<boolean>>
{
    public id: number|null;

    public constructor(init?: Partial<ScoresGoalsSettingsDeleteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ScoresGoalsSettingsDeleteRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ScoresGoalsSettingsDeleteRequest as unknown)[immerable] = true;

export class AdjustNumberOfDiariesRequest implements IReturn<ResponseBase<T>>
{
    public numberOfDiaries: number|null;

    public constructor(init?: Partial<AdjustNumberOfDiariesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdjustNumberOfDiariesRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(AdjustNumberOfDiariesRequest as unknown)[immerable] = true;

export class GetDomainsRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<GetDomainsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDomainsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(GetDomainsRequest as unknown)[immerable] = true;

export class GetDomainsAuthenticationStatusRequest implements IReturn<ResponseBase<DomainAuthenticationStatusResponse>>
{
    public domains: string[]|null;

    public constructor(init?: Partial<GetDomainsAuthenticationStatusRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDomainsAuthenticationStatusRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<DomainAuthenticationStatusResponse>(); }
}
(GetDomainsAuthenticationStatusRequest as unknown)[immerable] = true;

export class AuthenticateDomainRequest implements IReturn<ResponseBase<AuthenticateDomainResponse>>
{
    public domain: string|null;
    public id: number|null;

    public constructor(init?: Partial<AuthenticateDomainRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AuthenticateDomainRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<AuthenticateDomainResponse>(); }
}
(AuthenticateDomainRequest as unknown)[immerable] = true;

export class ValidateDomainRequest implements IReturn<ResponseBase<ValidateDomainResponse>>
{
    public id: number|null;

    public constructor(init?: Partial<ValidateDomainRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateDomainRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ValidateDomainResponse>(); }
}
(ValidateDomainRequest as unknown)[immerable] = true;

export class DMARCWarningRequest implements IReturn<ResponseBase<boolean>>
{

    public constructor(init?: Partial<DMARCWarningRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DMARCWarningRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(DMARCWarningRequest as unknown)[immerable] = true;

export class DMARCAcknowledgementRequest implements IReturnVoid
{

    public constructor(init?: Partial<DMARCAcknowledgementRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DMARCAcknowledgementRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(DMARCAcknowledgementRequest as unknown)[immerable] = true;

// @Route("/reports/finances/stock-reorder")
export class StockReorderRequest extends BaseParamsForAllReports implements IReturn<StockReorderResponse>
{
    public minimumLevel: number|null;
    public stockDescription: string|null;
    public supplier: string|null;
    public stockStatuses: string[]|null;
    public reorders: string|null;

    public constructor(init?: Partial<StockReorderRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'StockReorderRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new StockReorderResponse(); }
}
(StockReorderRequest as unknown)[immerable] = true;

// @Route("/reports/finances/stock-sales")
export class StockSalesRequest extends BaseParamsForAllReports implements IReturn<StockSalesResponse>
{
    public reportDate: string|null;
    public stockDescription: string|null;
    public ageGroupings: string[]|null;

    public constructor(init?: Partial<StockSalesRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'StockSalesRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new StockSalesResponse(); }
}
(StockSalesRequest as unknown)[immerable] = true;

// @Route("/reports/finances/invoice-analysis")
export class InvoiceAnalysisRequest extends BaseParamsForAllReports implements IReturn<InvoiceAnalysisResponse>
{
    public accountTypes: string[]|null;
    public invoiceStatuses: string[]|null;

    public constructor(init?: Partial<InvoiceAnalysisRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'InvoiceAnalysisRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new InvoiceAnalysisResponse(); }
}
(InvoiceAnalysisRequest as unknown)[immerable] = true;

// @Route("/reports/finances/income-analysis")
export class IncomeAnalysisRequest extends BaseParamsForAllReports implements IReturn<IncomeAnalysisResponse>
{
    public accountTypes: string[]|null;
    public paymentMethods: string[]|null;
    public incomeStatuses: string[]|null;

    public constructor(init?: Partial<IncomeAnalysisRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IncomeAnalysisRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new IncomeAnalysisResponse(); }
}
(IncomeAnalysisRequest as unknown)[immerable] = true;

// @Route("/reports/finances/expenditure-month-summary")
export class ExpenditureMonthSummaryRequest extends BaseParamsForAllReports implements IReturn<ExpenditureMonthSummaryResponse>
{

    public constructor(init?: Partial<ExpenditureMonthSummaryRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ExpenditureMonthSummaryRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ExpenditureMonthSummaryResponse(); }
}
(ExpenditureMonthSummaryRequest as unknown)[immerable] = true;

// @Route("/reports/finances/expenditure-analysis", "POST")
export class ExpenditureAnalysisRequest extends BaseParamsForAllReports implements IReturn<ExpenditureAnalysisResponse>
{
    public expenditureCategory: string[]|null;
    public expenditureOtherPaymentMethods: string[]|null;

    public constructor(init?: Partial<ExpenditureAnalysisRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ExpenditureAnalysisRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ExpenditureAnalysisResponse(); }
}
(ExpenditureAnalysisRequest as unknown)[immerable] = true;

// @Route("/reports/finances/aged-debtors")
export class AgedDebtorsReportRequest extends BaseParamsForAllReports implements IReturn<AgedDebtorsResponse>
{
    public invoiceStatuses: string[]|null;
    public invoiceAges: string[]|null;

    public constructor(init?: Partial<AgedDebtorsReportRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'AgedDebtorsReportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AgedDebtorsResponse(); }
}
(AgedDebtorsReportRequest as unknown)[immerable] = true;

// @Route("/reports/finances/debtors-by-account")
export class DebtorsByAccountRequest extends BaseParamsForAllReports implements IReturn<DebtorsByAccountResponse>
{
    public invoiceStatusNames: string[]|null;
    public accountTypeNames: string[]|null;

    public constructor(init?: Partial<DebtorsByAccountRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'DebtorsByAccountRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new DebtorsByAccountResponse(); }
}
(DebtorsByAccountRequest as unknown)[immerable] = true;

// @Route("/reports/finances/debtors-on-a-date")
export class DebtorsOnADateReportRequest extends BaseParamsForAllReports implements IReturn<DebtorsOnADateResponse>
{
    public invoiceStatusOnDates: string[]|null;
    public accountTypes: string[]|null;

    public constructor(init?: Partial<DebtorsOnADateReportRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'DebtorsOnADateReportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new DebtorsOnADateResponse(); }
}
(DebtorsOnADateReportRequest as unknown)[immerable] = true;

// @Route("/reports/finances/charge-analysis")
export class ChargesAnalysisReportRequest extends BaseParamsForAllReports implements IReturn<ChargeAnalysisResponse>
{
    public accountTypes: string[]|null;
    public chargeDescription: string|null;
    public billedItemCategories: string[]|null;
    public accountName: string|null;
    public useAccountingDate: boolean|null;
    public invoiceStatus: InvoiceStatus|null;

    public constructor(init?: Partial<ChargesAnalysisReportRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ChargesAnalysisReportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ChargeAnalysisResponse(); }
}
(ChargesAnalysisReportRequest as unknown)[immerable] = true;

// @Route("/reports/diary/practitioner-availability")
export class PractitionerAvailabilityReportRequest extends BaseParamsForAllReports implements IReturn<ResponseBase<PractitionerAvailabilityReportResponse>>
{

    public constructor(init?: Partial<PractitionerAvailabilityReportRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'PractitionerAvailabilityReportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<PractitionerAvailabilityReportResponse>(); }
}
(PractitionerAvailabilityReportRequest as unknown)[immerable] = true;

// @Route("/reports/clinical/admissions-analysis")
export class AdmissionsAnalysisReportRequest extends BaseParamsForAllReports implements IReturn<AdmissionsAnalysisReportResponse>
{
    public bodySite: string[]|null;
    public categories: string[]|null;
    public ageGrouping: string[]|null;
    public medicalContact: string|null;

    public constructor(init?: Partial<AdmissionsAnalysisReportRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'AdmissionsAnalysisReportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AdmissionsAnalysisReportResponse(); }
}
(AdmissionsAnalysisReportRequest as unknown)[immerable] = true;

// @Route("/reports/clinical/average-treatments")
export class AverageTreatmentsReportRequest extends BaseParamsForAllReports implements IReturn<ResponseBase<AverageTreatmentsReportResponse>>
{
    public groupByItems: string|null;

    public constructor(init?: Partial<AverageTreatmentsReportRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'AverageTreatmentsReportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<AverageTreatmentsReportResponse>(); }
}
(AverageTreatmentsReportRequest as unknown)[immerable] = true;

// @Route("/reports/clinical/cases-due-for-review")
export class CasesDueForReviewReportRequest extends BaseParamsForAllReports implements IReturn<CasesDueForReviewReportResponse>
{
    public reviewDate: DateRange|null;
    public medicalContact: string|null;

    public constructor(init?: Partial<CasesDueForReviewReportRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CasesDueForReviewReportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CasesDueForReviewReportResponse(); }
}
(CasesDueForReviewReportRequest as unknown)[immerable] = true;

// @Route("/reports/clinical/current-case-load")
export class CurrentCaseLoadReportRequest extends BaseParamsForAllReports implements IReturn<ResponseBase<CurrentCaseLoadReportResponse>>
{
    public bodySite: string[]|null;
    public businesses: string|null;
    public diagnosis: string|null;
    public showFutureAppointments: number|null;
    public medicalContact: string|null;

    public constructor(init?: Partial<CurrentCaseLoadReportRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CurrentCaseLoadReportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CurrentCaseLoadReportResponse>(); }
}
(CurrentCaseLoadReportRequest as unknown)[immerable] = true;

// @Route("/reports/clinical/discharge-analysis")
export class DischargeAnalysisReportRequest extends BaseParamsForAllReports implements IReturn<ResponseBase<DischargeAnalysisReportResponse>>
{
    public bodySite: string[]|null;
    public businesses: string|null;
    public patientName: string|null;
    public diagnosis: string|null;
    public ageGrouping: string[]|null;

    public constructor(init?: Partial<DischargeAnalysisReportRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'DischargeAnalysisReportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<DischargeAnalysisReportResponse>(); }
}
(DischargeAnalysisReportRequest as unknown)[immerable] = true;

// @Route("/reports/clinical/lapsed-patients")
export class LapsedPatientsReportRequest extends BaseParamsForAllReports implements IReturn<LapsedPatientsReportResponse>
{
    public showRemainingAuths: number|null;
    public bodySite: string[]|null;
    public diagnosisCode: string[]|null;
    public remainingAuthorisation: RemainingAuthorisationOption|null;

    public constructor(init?: Partial<LapsedPatientsReportRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'LapsedPatientsReportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new LapsedPatientsReportResponse(); }
}
(LapsedPatientsReportRequest as unknown)[immerable] = true;

// @Route("/reports/clients/client-analysis")
export class ClientAnalysisReportRequest extends BaseParamsForAllReports implements IReturn<ResponseBase<ClientAnalysisResponse>>
{
    public gender: string[]|null;
    public ageGrouping: string[]|null;
    public businesses: string[]|null;
    public enquirySources: string[]|null;
    public showFutureAppointments: number|null;

    public constructor(init?: Partial<ClientAnalysisReportRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ClientAnalysisReportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClientAnalysisResponse>(); }
}
(ClientAnalysisReportRequest as unknown)[immerable] = true;

// @Route("/reports/clients/client-birthdays")
export class ClientBirthdayReportRequest extends BaseParamsForAllReports implements IReturn<ClientBirthdayResponse>
{
    public filterLastAppointmentDate: boolean|null;
    public range: DatePartRange|null;
    public contactMethods: number|null;

    public constructor(init?: Partial<ClientBirthdayReportRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ClientBirthdayReportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ClientBirthdayResponse(); }
}
(ClientBirthdayReportRequest as unknown)[immerable] = true;

// @Route("/reports/clients/client-tracking")
export class ClientTrackingReportRequest extends BaseParamsForAllReports implements IReturn<ResponseBase<ClientTrackingResponse>>
{
    public omitPatientsThatDontNeedAction: boolean|null;
    public businesses: string|null;
    public ageGrouping: string[]|null;

    public constructor(init?: Partial<ClientTrackingReportRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ClientTrackingReportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClientTrackingResponse>(); }
}
(ClientTrackingReportRequest as unknown)[immerable] = true;

export class ClickReferrerImagePathRequest implements IReturn<ResponseBase<ClickReferrerImagePath>>
{
    public referrerId: string|null;

    public constructor(init?: Partial<ClickReferrerImagePathRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickReferrerImagePathRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClickReferrerImagePath>(); }
}
(ClickReferrerImagePathRequest as unknown)[immerable] = true;

// @Route("/register/click")
export class ClickRegistrationRequest extends RegistrationRequest implements IReturn<ResponseBase<string>>
{

    public constructor(init?: Partial<ClickRegistrationRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickRegistrationRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<string>(); }
}
(ClickRegistrationRequest as unknown)[immerable] = true;

// @Route("/subdomain/exists")
export class TM3SubdomainExistsRequest implements IReturn<ResponseBase<boolean>>
{
    public subdomain: string|null;

    public constructor(init?: Partial<TM3SubdomainExistsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TM3SubdomainExistsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(TM3SubdomainExistsRequest as unknown)[immerable] = true;

export class QuickStartWizardSendEnquiryEmailRequest implements IReturn<ResponseBase<boolean>>
{
    public locationId: number|null;
    public type: EnquiryType|null;

    public constructor(init?: Partial<QuickStartWizardSendEnquiryEmailRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QuickStartWizardSendEnquiryEmailRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(QuickStartWizardSendEnquiryEmailRequest as unknown)[immerable] = true;

export class QuickStartWizardToggleGroupStocksRequest implements IReturn<ResponseBase<T>>
{
    public id: number|null;

    public constructor(init?: Partial<QuickStartWizardToggleGroupStocksRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QuickStartWizardToggleGroupStocksRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(QuickStartWizardToggleGroupStocksRequest as unknown)[immerable] = true;

export class QuickStartWizardGetGroupRequest implements IReturn<ResponseBase<QuickStartWizardGroupResponse>>
{
    public id: number|null;

    public constructor(init?: Partial<QuickStartWizardGetGroupRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QuickStartWizardGetGroupRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<QuickStartWizardGroupResponse>(); }
}
(QuickStartWizardGetGroupRequest as unknown)[immerable] = true;

export class QuickStartWizardGetGroupsRequest implements IReturn<ResponseBase<QuickStartWizardGroupResponse>>
{

    public constructor(init?: Partial<QuickStartWizardGetGroupsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QuickStartWizardGetGroupsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<QuickStartWizardGroupResponse>(); }
}
(QuickStartWizardGetGroupsRequest as unknown)[immerable] = true;

export class QuickStartWizardSaveGroupRequest implements IReturn<ResponseBase<QuickStartWizardGroupResponse>>
{
    public email: string|null;
    public name: string|null;
    public id: number|null;
    public useAuthCode: boolean|null;
    public locationId: number|null;
    public firstStockId: number|null;
    public followupStockId: number|null;
    public otherStocks: QuickStartWizardGroupStock[]|null;

    public constructor(init?: Partial<QuickStartWizardSaveGroupRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QuickStartWizardSaveGroupRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<QuickStartWizardGroupResponse>(); }
}
(QuickStartWizardSaveGroupRequest as unknown)[immerable] = true;

export class QuickStartWizardPractitionersRequest implements IReturn<ResponseBase<QuickStartWizardPractitionerResponse>>
{
    public id: number|null;

    public constructor(init?: Partial<QuickStartWizardPractitionersRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QuickStartWizardPractitionersRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<QuickStartWizardPractitionerResponse>(); }
}
(QuickStartWizardPractitionersRequest as unknown)[immerable] = true;

export class QuickStartWizardGetPractitionerRequest implements IReturn<ResponseBase<QuickStartWizardPractitionerResponse>>
{
    public id: number|null;

    public constructor(init?: Partial<QuickStartWizardGetPractitionerRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QuickStartWizardGetPractitionerRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<QuickStartWizardPractitionerResponse>(); }
}
(QuickStartWizardGetPractitionerRequest as unknown)[immerable] = true;

export class QuickStartWizardSavePractitionerRequest implements IReturn<ResponseBase<number>>
{
    public id: number|null;
    public title: string|null;
    public gender: string|null;
    public forename: string|null;
    public surname: string|null;
    public email: string|null;
    public mobile: string|null;
    public firstStockId: number|null;
    public followupStockId: number|null;
    public locations: number[]|null;
    public onlineGuid: string|null;
    public isActive: boolean|null;

    public constructor(init?: Partial<QuickStartWizardSavePractitionerRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QuickStartWizardSavePractitionerRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<number>(); }
}
(QuickStartWizardSavePractitionerRequest as unknown)[immerable] = true;

export class QuickStartWizardUpdateDisciplineRequest implements IReturn<ResponseBase<boolean>>
{
    public disciplineName: string|null;

    public constructor(init?: Partial<QuickStartWizardUpdateDisciplineRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QuickStartWizardUpdateDisciplineRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(QuickStartWizardUpdateDisciplineRequest as unknown)[immerable] = true;

export class QuickStartWizardGetDisciplineRequest implements IReturn<ResponseBase<ServiceType>>
{

    public constructor(init?: Partial<QuickStartWizardGetDisciplineRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QuickStartWizardGetDisciplineRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ServiceType>(); }
}
(QuickStartWizardGetDisciplineRequest as unknown)[immerable] = true;

export class QuickStartWizardGetStocksRequest implements IReturn<ResponseBase<QuickStartWizardGetStocksResponse>>
{

    public constructor(init?: Partial<QuickStartWizardGetStocksRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QuickStartWizardGetStocksRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<QuickStartWizardGetStocksResponse>(); }
}
(QuickStartWizardGetStocksRequest as unknown)[immerable] = true;

export class QuickStartWizardSaveStocksRequest implements IReturn<ResponseBase<QuickStartWizardStock>>
{
    public reference: string|null;
    public description: string|null;
    public totalPrice: number|null;
    public appointmentLength: number|null;
    public id: number|null;

    public constructor(init?: Partial<QuickStartWizardSaveStocksRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QuickStartWizardSaveStocksRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<QuickStartWizardStock>(); }
}
(QuickStartWizardSaveStocksRequest as unknown)[immerable] = true;

export class QuickStartWizardStockReminderRequest implements IReturn<ResponseBase<boolean>>
{
    public reminderDate: string|null;

    public constructor(init?: Partial<QuickStartWizardStockReminderRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QuickStartWizardStockReminderRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(QuickStartWizardStockReminderRequest as unknown)[immerable] = true;

export class QuickStartWizardSelectTemplatePackRequest implements IReturn<ResponseBase<boolean>>
{
    public selectedPack: TemplatePackOptions|null;

    public constructor(init?: Partial<QuickStartWizardSelectTemplatePackRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QuickStartWizardSelectTemplatePackRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(QuickStartWizardSelectTemplatePackRequest as unknown)[immerable] = true;

export class QuickStartWizardTemplateOptionsRequest implements IReturn<ResponseBase<QuickStartWizardTemplateOptionsResponse>>
{
    public type: string|null;

    public constructor(init?: Partial<QuickStartWizardTemplateOptionsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QuickStartWizardTemplateOptionsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<QuickStartWizardTemplateOptionsResponse>(); }
}
(QuickStartWizardTemplateOptionsRequest as unknown)[immerable] = true;

// @Route("/pronto/cache/load", "POST")
export class ProntoCacheRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<ProntoCacheRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProntoCacheRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(ProntoCacheRequest as unknown)[immerable] = true;

export class GetClinicDetailsRequest implements IReturn<ResponseBase<GetClinicDetailsResponse>>
{

    public constructor(init?: Partial<GetClinicDetailsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetClinicDetailsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<GetClinicDetailsResponse>(); }
}
(GetClinicDetailsRequest as unknown)[immerable] = true;

export class SubmitClinicDetailsRequest implements IReturn<ResponseBase<boolean>>
{
    public clinicName: string|null;
    public addressLine1: string|null;
    public addressLine2: string|null;
    public addressLine3: string|null;
    public addressLine4: string|null;
    public postCode: string|null;
    public homeTelephone: string|null;
    public category: string|null;
    public previousSystem: string|null;
    public clinicCurrencySymbol: string|null;

    public constructor(init?: Partial<SubmitClinicDetailsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SubmitClinicDetailsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(SubmitClinicDetailsRequest as unknown)[immerable] = true;

export class GetNetworksRequest implements IReturn<ResponseBase<ProntoNetworkDto[]>>
{

    public constructor(init?: Partial<GetNetworksRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetNetworksRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ProntoNetworkDto[]>(); }
}
(GetNetworksRequest as unknown)[immerable] = true;

export class GetDisciplinesRequest implements IReturn<ResponseBase<ProntoDisciplineDto[]>>
{
    public networkId: string|null;

    public constructor(init?: Partial<GetDisciplinesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDisciplinesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ProntoDisciplineDto[]>(); }
}
(GetDisciplinesRequest as unknown)[immerable] = true;

export class GetReferrersRequest implements IReturn<ResponseBase<ClientWhoBooks[]>>
{

    public constructor(init?: Partial<GetReferrersRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetReferrersRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ClientWhoBooks[]>(); }
}
(GetReferrersRequest as unknown)[immerable] = true;

export class GetReferralCharge implements IReturn<ResponseBase<ProntoStockDto[]>>
{

    public constructor(init?: Partial<GetReferralCharge>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetReferralCharge'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ProntoStockDto[]>(); }
}
(GetReferralCharge as unknown)[immerable] = true;

export class GetReferrersLocations implements IReturn<ResponseBase<LocationDto[]>>
{

    public constructor(init?: Partial<GetReferrersLocations>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetReferrersLocations'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<LocationDto[]>(); }
}
(GetReferrersLocations as unknown)[immerable] = true;

export class GetReferralChargeOverrides implements IReturn<ResponseBase<ReferrerOverrideNetworkCharge[]>>
{
    public networkId: string|null;
    public referrerIds: string[]|null;

    public constructor(init?: Partial<GetReferralChargeOverrides>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetReferralChargeOverrides'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ReferrerOverrideNetworkCharge[]>(); }
}
(GetReferralChargeOverrides as unknown)[immerable] = true;

export class GetProntoPaymentDetailsRequest implements IReturn<ResponseBase<ProntoPaymentResponse>>
{
    public networkId: string|null;
    public referrerIds: string[]|null;

    public constructor(init?: Partial<GetProntoPaymentDetailsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetProntoPaymentDetailsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ProntoPaymentResponse>(); }
}
(GetProntoPaymentDetailsRequest as unknown)[immerable] = true;

export class ProntoRegistrationRequest implements IReturn<ResponseBase<ProntoRegistrationResponse>>
{
    public discountCode: string|null;
    public targetId: string|null;
    public networkId: string|null;
    public clinicServices: ClinicServiceSetupDto[]|null;
    public referrers: string[]|null;
    public referrerIds: string[]|null;
    public isOnline: boolean|null;
    public autoActivate: boolean|null;
    public incrementDiscountCode: boolean|null;

    public constructor(init?: Partial<ProntoRegistrationRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProntoRegistrationRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ProntoRegistrationResponse>(); }
}
(ProntoRegistrationRequest as unknown)[immerable] = true;

export class StartTrialRequest implements IReturn<ResponseBase<StartTrialResponse>>
{

    public constructor(init?: Partial<StartTrialRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StartTrialRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<StartTrialResponse>(); }
}
(StartTrialRequest as unknown)[immerable] = true;

export class StartSubscriptionRequest implements IReturn<ResponseBase<StartTrialResponse>>
{

    public constructor(init?: Partial<StartSubscriptionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StartSubscriptionRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<StartTrialResponse>(); }
}
(StartSubscriptionRequest as unknown)[immerable] = true;

export class ClientDowngradeToProntoOnlyRequest implements IReturn<ResponseBase<ConfirmClientDowngradeToProntoResponse>>
{

    public constructor(init?: Partial<ClientDowngradeToProntoOnlyRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClientDowngradeToProntoOnlyRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ConfirmClientDowngradeToProntoResponse>(); }
}
(ClientDowngradeToProntoOnlyRequest as unknown)[immerable] = true;

export class GetPatientPrescriptionsRequest implements IReturn<ResponseBase<GetPatientPrescriptionsResponse>>
{
    public customerId: number|null;
    public take: number|null;

    public constructor(init?: Partial<GetPatientPrescriptionsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPatientPrescriptionsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<GetPatientPrescriptionsResponse>(); }
}
(GetPatientPrescriptionsRequest as unknown)[immerable] = true;

export class GetPatientPrescriptionsSummaryRequest implements IReturn<ResponseBase<GetPatientPrescriptionsSummaryResponse>>
{
    public customerId: number|null;

    public constructor(init?: Partial<GetPatientPrescriptionsSummaryRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPatientPrescriptionsSummaryRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<GetPatientPrescriptionsSummaryResponse>(); }
}
(GetPatientPrescriptionsSummaryRequest as unknown)[immerable] = true;

// @Route("/prescription/create/nonrx", "POST")
export class CreateNonRxPrescriptionsRequest implements IReturn<ResponseBase<CreateNonRxPrescriptionsResponse>>
{
    public vpid: string|null;
    // @Required()
    public description: string;

    // @Required()
    public quantity: string;

    // @Required()
    public directions: string;

    public action: string|null;
    public customerId: number|null;

    public constructor(init?: Partial<CreateNonRxPrescriptionsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateNonRxPrescriptionsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CreateNonRxPrescriptionsResponse>(); }
}
(CreateNonRxPrescriptionsRequest as unknown)[immerable] = true;

// @Route("/locations/allowed/add/{LocationId}")
export class AddLocationRequest implements IReturn<ResponseBase<AddLocationResponse>>, ILocationId
{
    public locationId: number|null;

    public constructor(init?: Partial<AddLocationRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AddLocationRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<AddLocationResponse>(); }
}
(AddLocationRequest as unknown)[immerable] = true;

// @Route("/locations/all", "GET")
export class AllLocationRequest implements IReturn<ResponseBase<LocationResponse>>, ILocationIds, IGet
{
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;

    public constructor(init?: Partial<AllLocationRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AllLocationRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<LocationResponse>(); }
}
(AllLocationRequest as unknown)[immerable] = true;

// @Route("/locations/search", "POST")
export class LocationSearchRequest extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<Location>>
{
    public name: string|null;
    public status: number|null;

    public constructor(init?: Partial<LocationSearchRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'LocationSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<Location>(); }
}
(LocationSearchRequest as unknown)[immerable] = true;

// @Route("/locations/search/ids", "POST")
export class LocationsSearchIdsRequest implements IReturn<ResponseBase<Location>>, ILocationIds
{
    public ids: number[]|null;
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;

    public constructor(init?: Partial<LocationsSearchIdsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LocationsSearchIdsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<Location>(); }
}
(LocationsSearchIdsRequest as unknown)[immerable] = true;

export class LocationsExportRequest implements IReturn<ResponseBase<string>>, ILocationIds
{
    public query: LocationSearchRequest|null;
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;

    public constructor(init?: Partial<LocationsExportRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LocationsExportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<string>(); }
}
(LocationsExportRequest as unknown)[immerable] = true;

// @Route("/locations/{LocationId}", "GET")
export class LocationGetRequest implements IReturn<ResponseBase<LocationResponse>>, ILocationId
{
    public locationId: number|null;
    public sort: QueryField[]|null;
    public skip: number|null;
    public take: number|null;

    public constructor(init?: Partial<LocationGetRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LocationGetRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<LocationResponse>(); }
}
(LocationGetRequest as unknown)[immerable] = true;

// @Route("/locations/facilities", "GET")
export class GetFacilitiesListRequest implements IReturn<ResponseBase<LocationFacilities>>
{

    public constructor(init?: Partial<GetFacilitiesListRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetFacilitiesListRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<LocationFacilities>(); }
}
(GetFacilitiesListRequest as unknown)[immerable] = true;

// @Route("/locations/save", "POST")
export class LocationPostRequest implements IReturn<Location>
{
    public id: number|null;
    public name: string|null;
    public addressLine1: string|null;
    public addressLine2: string|null;
    public addressLine3: string|null;
    public addressLine4: string|null;
    public addressLine5: string|null;
    public postCode: string|null;
    public telephone: string|null;
    public fax: string|null;
    public email: string|null;
    public web: string|null;
    public dnaStockId: number|null;
    public cancelStockId: number|null;
    public dnaAmount: number|null;
    public cancelAmount: number|null;
    public status: string|null;
    public directions: string|null;
    public reminderTemplateEmail_TM3: string|null;
    public reminderTemplateSMS_TM3: string|null;
    public facilities: LocationFacilities|null;
    public onlineGuid: string|null;

    public constructor(init?: Partial<LocationPostRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LocationPostRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Location(); }
}
(LocationPostRequest as unknown)[immerable] = true;

// @Route("/exercise/{CustomerId}/{PractitionerId}")
export class ExercisePrescriberRequest implements ICustomerId
{
    public customerId: number|null;
    public practitionerId: number|null;

    public constructor(init?: Partial<ExercisePrescriberRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExercisePrescriberRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(ExercisePrescriberRequest as unknown)[immerable] = true;

// @Route("/wibbi/{CustomerId}/{PractitionerId}")
export class PhysiotecRequest implements ICustomerId
{
    public customerId: number|null;
    public practitionerId: number|null;

    public constructor(init?: Partial<PhysiotecRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PhysiotecRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(PhysiotecRequest as unknown)[immerable] = true;

// @Route("/physiotools/{CustomerId}/{PractitionerId}")
export class PhysiotoolsRequest implements ICustomerId
{
    public customerId: number|null;
    public practitionerId: number|null;

    public constructor(init?: Partial<PhysiotoolsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PhysiotoolsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(PhysiotoolsRequest as unknown)[immerable] = true;

// @Route("/physitrack/{CustomerId}/{PractitionerId}")
export class PhysitrackRequest implements ICustomerId
{
    public customerId: number|null;
    public practitionerId: number|null;

    public constructor(init?: Partial<PhysitrackRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PhysitrackRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(PhysitrackRequest as unknown)[immerable] = true;

// @Route("/salaso/{CustomerId}/{PractitionerId}", "GET")
export class SalasoRequest implements ICustomerId
{
    public customerId: number|null;
    public practitionerId: number|null;

    public constructor(init?: Partial<SalasoRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SalasoRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(SalasoRequest as unknown)[immerable] = true;

// @Route("/signaturerx/integration")
export class SignatureRxRequest implements IReturn<ResponseBase<SignatureRxResponse>>
{
    public signatureRxIntegrationCode: string|null;

    public constructor(init?: Partial<SignatureRxRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SignatureRxRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<SignatureRxResponse>(); }
}
(SignatureRxRequest as unknown)[immerable] = true;

export class CreatePrescriptionRequest implements IReturn<ResponseBase<CreatePrescriptionResponse>>
{
    // @Required()
    public action: PrescriptionActions;

    public vpid: string|null;
    // @Required()
    public description: string;

    // @Required()
    public quantity: string;

    // @Required()
    public directions: string;

    // @Required()
    public securePin: string;

    public customerId: number|null;

    public constructor(init?: Partial<CreatePrescriptionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreatePrescriptionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CreatePrescriptionResponse>(); }
}
(CreatePrescriptionRequest as unknown)[immerable] = true;

// @Route("/icd9/search", "POST")
export class ICD9SearchRequest implements IReturn<ResponseBase<ICD9>>
{

    public constructor(init?: Partial<ICD9SearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ICD9SearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ICD9>(); }
}
(ICD9SearchRequest as unknown)[immerable] = true;

// @Route("/system/{Password}/jobs/")
export class HangfireRequest implements IReturn<ResponseBase<JobDto>>
{
    public password: string|null;
    public skip: number|null;
    public take: number|null;
    public recurring: boolean|null;

    public constructor(init?: Partial<HangfireRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'HangfireRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<JobDto>(); }
}
(HangfireRequest as unknown)[immerable] = true;

export class FormByGuidRequest implements IReturn<ResponseBase<FormReportResponse>>
{
    public globalId: string|null;

    public constructor(init?: Partial<FormByGuidRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FormByGuidRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<FormReportResponse>(); }
}
(FormByGuidRequest as unknown)[immerable] = true;

// @Route("/form/reports/{PatientId}")
export class FormReportsRequest implements IReturn<ResponseBase<FormReportResponse>>
{
    public patientId: number|null;
    public includeClinical: boolean|null;
    public take: number|null;
    public onlyRequiringAction: boolean|null;

    public constructor(init?: Partial<FormReportsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FormReportsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<FormReportResponse>(); }
}
(FormReportsRequest as unknown)[immerable] = true;

export class DeleteFormTemplateRequest implements IReturn<ResponseBase<boolean>>
{
    public id: number|null;

    public constructor(init?: Partial<DeleteFormTemplateRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteFormTemplateRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(DeleteFormTemplateRequest as unknown)[immerable] = true;

export class ArchiveFormTemplateRequest implements IReturn<ResponseBase<boolean>>
{
    public id: number|null;

    public constructor(init?: Partial<ArchiveFormTemplateRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ArchiveFormTemplateRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ArchiveFormTemplateRequest as unknown)[immerable] = true;

// @Route("/form/templates", "Post")
export class FormTemplatesRequest implements IReturn<ResponseBase<FormTemplatesResponse>>
{
    public types: string[]|null;

    public constructor(init?: Partial<FormTemplatesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FormTemplatesRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<FormTemplatesResponse>(); }
}
(FormTemplatesRequest as unknown)[immerable] = true;

// @Route("/form/template/editor/{Id}")
export class FormTemplateEditorRequest
{
    public id: number|null;

    public constructor(init?: Partial<FormTemplateEditorRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FormTemplateEditorRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(FormTemplateEditorRequest as unknown)[immerable] = true;

// @Route("/form/submit")
export class SubmitFormRequest implements IReturn<boolean>
{
    public recordedBy: number|null;
    public templateId: string|null;
    public globalId: string|null;
    public reportData: string|null;
    public updates: Update[]|null;
    public patientId: number|null;
    public caseId: number|null;

    public constructor(init?: Partial<SubmitFormRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SubmitFormRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return false; }
}
(SubmitFormRequest as unknown)[immerable] = true;

// @Route("/form/complete")
export class CompleteFormRequest implements IReturn<boolean>
{
    public id: string|null;
    public patientId: number|null;
    public templateId: string|null;
    public caseId: number|null;
    public updates: Update[]|null;
    public reportData: string|null;
    public signature: string|null;

    public constructor(init?: Partial<CompleteFormRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CompleteFormRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return false; }
}
(CompleteFormRequest as unknown)[immerable] = true;

export class PinUnlockRequest implements IReturn<ResponseBase<boolean>>
{
    public pin: string|null;
    public unlock: boolean|null;

    public constructor(init?: Partial<PinUnlockRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PinUnlockRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(PinUnlockRequest as unknown)[immerable] = true;

// @Route("/form/send")
export class SendFormRequest implements IReturn<boolean>
{
    public patientId: number|null;
    public templateId: string|null;
    public caseId: number|null;
    public type: string|null;
    public globalId: string|null;
    public isNew: boolean|null;

    public constructor(init?: Partial<SendFormRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendFormRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return false; }
}
(SendFormRequest as unknown)[immerable] = true;

// @Route("/form/cancel")
export class CancelFormRequest implements IReturn<boolean>
{
    public id: string|null;

    public constructor(init?: Partial<CancelFormRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CancelFormRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return false; }
}
(CancelFormRequest as unknown)[immerable] = true;

// @Route("/form/communication")
export class UpdateCommunicationTemplate implements IReturn<boolean>
{
    public templateId: string|null;
    public smsTemplate: string|null;
    public emailTemplate: string|null;

    public constructor(init?: Partial<UpdateCommunicationTemplate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateCommunicationTemplate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return false; }
}
(UpdateCommunicationTemplate as unknown)[immerable] = true;

export class UpdateFormStatusRequest implements IReturn<ResponseBase<T>>
{
    public status: FormStatus|null;
    public id: number|null;

    public constructor(init?: Partial<UpdateFormStatusRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateFormStatusRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(UpdateFormStatusRequest as unknown)[immerable] = true;

// @Route("/form/decline")
export class DeclineFormRequest implements IReturn<boolean>
{
    public id: string|null;

    public constructor(init?: Partial<DeclineFormRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeclineFormRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return false; }
}
(DeclineFormRequest as unknown)[immerable] = true;

// @Route("/diary/classes", "POST")
export class ClassesRequest implements IReturn<ResponseBase<ClassesResponse>>
{
    public fromDate: string|null;
    public showWeekends: boolean|null;

    public constructor(init?: Partial<ClassesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClassesRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClassesResponse>(); }
}
(ClassesRequest as unknown)[immerable] = true;

// @Route("/diary/classes/filter", "POST")
export class FilterClassesRequest implements IReturn<ResponseBase<ClassesResponse>>
{
    public fromDate: string|null;
    public classTypeIds: number[]|null;
    public courseTypeIds: number[]|null;
    public locationIds: number[]|null;
    public practitionerIds: number[]|null;
    public hideCancellations: boolean|null;
    public showWeekends: boolean|null;

    public constructor(init?: Partial<FilterClassesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FilterClassesRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClassesResponse>(); }
}
(FilterClassesRequest as unknown)[immerable] = true;

export class PatientClassesRequest
{
    public patientId: number|null;

    public constructor(init?: Partial<PatientClassesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientClassesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(PatientClassesRequest as unknown)[immerable] = true;

// @Route("/patient/prepaid/classes/{PatientId}", "POST")
export class PatientPrePaidClassRequest implements IReturn<ResponseBase<PatientClass>>
{
    public patientId: number|null;
    public prePaidItemIds: number[]|null;
    public skip: number|null;
    public take: number|null;
    public sort: QueryField[]|null;

    public constructor(init?: Partial<PatientPrePaidClassRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientPrePaidClassRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<PatientClass>(); }
}
(PatientPrePaidClassRequest as unknown)[immerable] = true;

// @Route("/dashboard")
export class DashboardRequest implements IReturn<ResponseBase<DashboardResponse>>, IFilterServiceTypeManually
{

    public constructor(init?: Partial<DashboardRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DashboardRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<DashboardResponse>(); }
}
(DashboardRequest as unknown)[immerable] = true;

// @Route("/dashboard/list")
export class DashboardListRequest
{
    public startDate: string|null;
    public endDate: string|null;
    public locationIds: number[]|null;
    public practitionerIds: number[]|null;
    public roomIds: number[]|null;

    public constructor(init?: Partial<DashboardListRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DashboardListRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(DashboardListRequest as unknown)[immerable] = true;

export class TimelineRequest extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<Timeline>>, ISecurityLocator
{
    public mode: FileAreaType|null;
    public id: number|null;
    public types: TimelineType[]|null;
    public subTypes: string[]|null;
    public linkedObjectTypes: TimelineLinkedObjectType[]|null;
    public contexts: TimelineContextObjectType[]|null;
    public context: TimelineContextObjectType|null;
    public contextId: number|null;
    public linkedObjectType: TimelineLinkedObjectType|null;
    public linkedObjectId: number|null;
    public securityLocator: Func<Object, IClientDbAccess, SecurityDto>|null;

    public constructor(init?: Partial<TimelineRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TimelineRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<Timeline>(); }
}
(TimelineRequest as unknown)[immerable] = true;

// @Route("/customer/anonymise")
export class AnonymiseCustomerRequest implements IReturn<ResponseBase<boolean>>, ICustomerId
{
    public id: number|null;
    public customerId: number|null;

    public constructor(init?: Partial<AnonymiseCustomerRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AnonymiseCustomerRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(AnonymiseCustomerRequest as unknown)[immerable] = true;

export class CustomerUpcomingAppointmentRequest implements IReturn<ResponseBase<number>>, ICustomerId, IFilterServiceTypeManually
{
    public customerId: number|null;

    public constructor(init?: Partial<CustomerUpcomingAppointmentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomerUpcomingAppointmentRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<number>(); }
}
(CustomerUpcomingAppointmentRequest as unknown)[immerable] = true;

// @Route("/customer/appointments/{CustomerId}")
// @Route("/customer/appointments/{CustomerId}/{CaseId}")
export class CustomerAppointmentRequest implements IReturn<ResponseBase<AppointmentResponse>>, ICustomerId, IFilterServiceTypeManually
{
    public customerId: number|null;
    public appointmentId: number|null;
    public prePaidItemIds: number[]|null;
    public caseId: number|null;
    public skip: number|null;
    public take: number|null;
    public sort: QueryField[]|null;

    public constructor(init?: Partial<CustomerAppointmentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomerAppointmentRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<AppointmentResponse>(); }
}
(CustomerAppointmentRequest as unknown)[immerable] = true;

// @Route("/download/patient")
export class DownloadPatientRequest implements ICustomerId
{
    public customerId: number|null;
    public requestDate: string|null;
    public demographic: boolean|null;
    public clinical: boolean|null;
    public financial: boolean|null;
    public documents: boolean|null;
    public forms: boolean|null;
    public full: boolean|null;

    public constructor(init?: Partial<DownloadPatientRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DownloadPatientRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(DownloadPatientRequest as unknown)[immerable] = true;

// @Route("/patient/{Id}/cases")
export class PatientCaseSearchRequest implements IReturn<ResponseBase<CaseSearchResponse>>, ILocationId
{
    public skip: number|null;
    public take: number|null;
    public id: number|null;
    public sort: QueryField[]|null;
    public locationId: number|null;

    public constructor(init?: Partial<PatientCaseSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientCaseSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CaseSearchResponse>(); }
}
(PatientCaseSearchRequest as unknown)[immerable] = true;

// @Route("/consent", "GET")
export class OnlineConsentRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<OnlineConsentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineConsentRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(OnlineConsentRequest as unknown)[immerable] = true;

// @Route("/consent/change", "POST")
export class OnlineConsentChangeRequest extends OnlineConsent implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<OnlineConsentChangeRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineConsentChangeRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(OnlineConsentChangeRequest as unknown)[immerable] = true;

// @Route("/batchEmail")
export class CustomBatchEmailRequest implements ISecurityIds
{
    public ids: BatchEmailRequestObject[]|null;
    public template: string|null;
    public contactId: number|null;
    public securityIds: number[]|null;

    public constructor(init?: Partial<CustomBatchEmailRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomBatchEmailRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(CustomBatchEmailRequest as unknown)[immerable] = true;

// @Route("/payment/emailReceipt")
export class PaymentReceiptRequest implements ISecurityId
{
    public id: number|null;
    public securityId: number|null;
    public mode: string|null;
    public template: string|null;

    public constructor(init?: Partial<PaymentReceiptRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PaymentReceiptRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(PaymentReceiptRequest as unknown)[immerable] = true;

// @Route("/quickbill/email")
export class QuickBillEmailRequest implements ISecurityId, ISecurityType
{
    public id: number|null;
    public securityId: number|null;
    public type: string|null;
    public securityType: string|null;

    public constructor(init?: Partial<QuickBillEmailRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QuickBillEmailRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(QuickBillEmailRequest as unknown)[immerable] = true;

// @Route("/email")
export class CustomEmailRequest implements ISecurityId, ISecurityType
{
    public to: string[]|null;
    public from: string|null;
    public cc: string[]|null;
    public bcc: string[]|null;
    public subject: string|null;
    public message: string|null;
    public type: string|null;
    public typeId: number|null;
    public medicalContactId: number|null;
    public fileName: string|null;
    public attachments: AttachmentGroup|null;
    public logMessage: string|null;
    public createLog: boolean|null;
    public createDocumentHistory: boolean|null;
    public securityId: number|null;
    public securityType: string|null;
    public calendar: string|null;
    public isOnline: boolean|null;
    public fallbackCustomerId: number|null;
    public typeGuid: string|null;
    public locationId: number|null;

    public constructor(init?: Partial<CustomEmailRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomEmailRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(CustomEmailRequest as unknown)[immerable] = true;

// @Route("/ccl/{ClientID}")
export class ClearCachedLicenseRequest implements IReturn<Object>
{
    public clientID: string|null;

    public constructor(init?: Partial<ClearCachedLicenseRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClearCachedLicenseRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Object(); }
}
(ClearCachedLicenseRequest as unknown)[immerable] = true;

// @Route("/ccp/{ClientID}")
export class ClearCachedPermissionsRequest implements IReturn<Object>
{
    public clientID: string|null;

    public constructor(init?: Partial<ClearCachedPermissionsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClearCachedPermissionsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Object(); }
}
(ClearCachedPermissionsRequest as unknown)[immerable] = true;

// @Route("/ccc/{ClientID}")
export class ClearCachedConfigRequest implements IReturn<Object>
{
    public clientID: string|null;

    public constructor(init?: Partial<ClearCachedConfigRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClearCachedConfigRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Object(); }
}
(ClearCachedConfigRequest as unknown)[immerable] = true;

// @Route("/ccwt/{ClientID}")
export class ClearCachedWebTemplatesRequest implements IReturn<Object>
{
    public clientID: string|null;

    public constructor(init?: Partial<ClearCachedWebTemplatesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClearCachedWebTemplatesRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Object(); }
}
(ClearCachedWebTemplatesRequest as unknown)[immerable] = true;

// @Route("/ccwr/{ClientID}")
export class ClearCachedWebReportsRequest implements IReturn<Object>
{
    public clientID: string|null;

    public constructor(init?: Partial<ClearCachedWebReportsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClearCachedWebReportsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Object(); }
}
(ClearCachedWebReportsRequest as unknown)[immerable] = true;

// @Route("/config/clear/{ClientId}/{Key}")
export class ClearCachedConfig implements IReturn<Object>
{
    public key: string|null;
    public clientId: string|null;

    public constructor(init?: Partial<ClearCachedConfig>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClearCachedConfig'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Object(); }
}
(ClearCachedConfig as unknown)[immerable] = true;

// @Route("/ccek/{ClientID}")
export class ClearCachedExtractionKeyRequest implements IReturn<Object>
{
    public clientID: string|null;

    public constructor(init?: Partial<ClearCachedExtractionKeyRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClearCachedExtractionKeyRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Object(); }
}
(ClearCachedExtractionKeyRequest as unknown)[immerable] = true;

// @Route("/hangfire/trigger/{Code}/{Job}")
export class HangfireJobTrigger implements IReturn<Object>
{
    public job: string|null;
    public code: string|null;

    public constructor(init?: Partial<HangfireJobTrigger>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'HangfireJobTrigger'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Object(); }
}
(HangfireJobTrigger as unknown)[immerable] = true;

// @Route("/ccj/{ClientId}")
export class ClearCachedJobsRequest implements IReturn<Object>
{
    public clientID: string|null;

    public constructor(init?: Partial<ClearCachedJobsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClearCachedJobsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Object(); }
}
(ClearCachedJobsRequest as unknown)[immerable] = true;

// @Route("/clinical/settings/labels")
export class ClinicalLabelRequest
{

    public constructor(init?: Partial<ClinicalLabelRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClinicalLabelRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(ClinicalLabelRequest as unknown)[immerable] = true;

// @Route("/clinical/settings/reportingfields")
export class ClinicalReportingFieldRequest implements IReturn<ResponseBase<ClinicalReportingFieldResponse>>
{

    public constructor(init?: Partial<ClinicalReportingFieldRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClinicalReportingFieldRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ClinicalReportingFieldResponse>(); }
}
(ClinicalReportingFieldRequest as unknown)[immerable] = true;

// @Route("/clinical/settings/diagnosisCodes", "GET")
export class ClinicalSettingsDiagnosisRequest implements IReturn<ResponseBase<CustomListItemResponse>>
{
    public text: string|null;
    public bodySite: string|null;
    public mapping: string|null;

    public constructor(init?: Partial<ClinicalSettingsDiagnosisRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClinicalSettingsDiagnosisRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<CustomListItemResponse>(); }
}
(ClinicalSettingsDiagnosisRequest as unknown)[immerable] = true;

// @Route("/clinical/settings/diagnosisCodes", "POST")
export class ClinicalSettingsDiagnosisRequestPost implements IReturn<DiagnosisCode>
{
    public text: string|null;
    public bodySite: string|null;
    public mapping: string|null;
    public serviceTypeId: number|null;

    public constructor(init?: Partial<ClinicalSettingsDiagnosisRequestPost>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClinicalSettingsDiagnosisRequestPost'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new DiagnosisCode(); }
}
(ClinicalSettingsDiagnosisRequestPost as unknown)[immerable] = true;

// @Route("/clinical/settings/diagnosisCodes/delete")
export class ClinicalSettingsDeleteDiagnosisRequest implements IReturnVoid
{
    public text: string|null;
    public bodySite: string|null;

    public constructor(init?: Partial<ClinicalSettingsDeleteDiagnosisRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClinicalSettingsDeleteDiagnosisRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(ClinicalSettingsDeleteDiagnosisRequest as unknown)[immerable] = true;

// @Route("/clinical/settings/mytemplates")
// @Route("/clinical/settings/mytemplates/{Id}")
export class ClinicalMyTemplatesRequest implements IReturn<ResponseBase<ClinicalMyTemplatesResponse>>, ILocationId
{
    public id: number|null;
    public name: string|null;
    public description: string|null;
    public type: string|null;
    public body: string|null;
    public summary: string|null;
    public globalId: string|null;
    public locationId: number|null;
    public serviceTypeId: number|null;
    public format: BlockTemplateFormat|null;
    public signatureRequired: boolean|null;

    public constructor(init?: Partial<ClinicalMyTemplatesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClinicalMyTemplatesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ClinicalMyTemplatesResponse>(); }
}
(ClinicalMyTemplatesRequest as unknown)[immerable] = true;

// @Route("/clinical/settings/mytemplates/delete")
export class ClinicalMyTemplatesDeleteRequest implements IReturn<ResponseBase<ClinicalMyTemplatesResponse>>, ILocationId
{
    public id: number|null;
    public locationId: number|null;

    public constructor(init?: Partial<ClinicalMyTemplatesDeleteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClinicalMyTemplatesDeleteRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClinicalMyTemplatesResponse>(); }
}
(ClinicalMyTemplatesDeleteRequest as unknown)[immerable] = true;

// @Route("/clinical/settings/mytemplates/default")
export class ClinicalMyTemplatesDefaultRequest implements IReturn<ResponseBase<ClinicalMyTemplatesResponse>>, ILocationId
{
    public globalId: string|null;
    public serviceTypeId: number|null;
    public type: string|null;
    public isFirst: boolean|null;
    public locationId: number|null;

    public constructor(init?: Partial<ClinicalMyTemplatesDefaultRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClinicalMyTemplatesDefaultRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClinicalMyTemplatesResponse>(); }
}
(ClinicalMyTemplatesDefaultRequest as unknown)[immerable] = true;

// @Route("/clinical/settings/mytemplates/clone/{Id}")
export class ClinicalMyTemplatesCloneRequest implements IReturn<ResponseBase<ClinicalMyTemplatesResponse>>
{
    public id: number|null;

    public constructor(init?: Partial<ClinicalMyTemplatesCloneRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClinicalMyTemplatesCloneRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ClinicalMyTemplatesResponse>(); }
}
(ClinicalMyTemplatesCloneRequest as unknown)[immerable] = true;

// @Route("/clinical/settings/flags/used", "GET")
export class UsedFlagsRequest implements IReturn<ResponseBase<Lookup>>
{

    public constructor(init?: Partial<UsedFlagsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UsedFlagsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<Lookup>(); }
}
(UsedFlagsRequest as unknown)[immerable] = true;

// @Route("/clinical/settings/flags", "GET")
export class ClinicalSettingsFlagsRequest implements IReturn<ClinicalSettingsFlagsResponse>
{
    public colour: string|null;
    public title: string|null;

    public constructor(init?: Partial<ClinicalSettingsFlagsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClinicalSettingsFlagsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ClinicalSettingsFlagsResponse(); }
}
(ClinicalSettingsFlagsRequest as unknown)[immerable] = true;

// @Route("/clinical/settings/flags", "POST")
export class ClinicalSettingsFlagsRequestPost implements IReturn<ResponseBase<boolean>>
{
    public colour: string|null;
    public title: string|null;

    public constructor(init?: Partial<ClinicalSettingsFlagsRequestPost>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClinicalSettingsFlagsRequestPost'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ClinicalSettingsFlagsRequestPost as unknown)[immerable] = true;

// @Route("/clinical/settings/flags/acknowledge")
export class ClinicalSettingsAcknowledgeFlagsRequest implements IReturn<ResponseBase<string>>, ILocationId
{
    public colour: string|null;
    public locationId: number|null;

    public constructor(init?: Partial<ClinicalSettingsAcknowledgeFlagsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClinicalSettingsAcknowledgeFlagsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<string>(); }
}
(ClinicalSettingsAcknowledgeFlagsRequest as unknown)[immerable] = true;

// @Route("/integrations", "GET")
export class ClinicalSettingsIntegrationsRequest implements IReturn<ResponseBase<SystemConfig>>
{

    public constructor(init?: Partial<ClinicalSettingsIntegrationsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClinicalSettingsIntegrationsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<SystemConfig>(); }
}
(ClinicalSettingsIntegrationsRequest as unknown)[immerable] = true;

// @Route("/integrations", "POST")
export class ClinicalSettingsIntegrationsRequestPost implements IReturn<ResponseBase<boolean>>
{
    public settingsToUpdate: SystemConfig[]|null;

    public constructor(init?: Partial<ClinicalSettingsIntegrationsRequestPost>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClinicalSettingsIntegrationsRequestPost'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ClinicalSettingsIntegrationsRequestPost as unknown)[immerable] = true;

// @Route("/integrations/physitrack")
export class ClinicalSettingsPhysitrackIntegrationRequest implements IReturn<ResponseBase<PractitionerResponse>>
{

    public constructor(init?: Partial<ClinicalSettingsPhysitrackIntegrationRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClinicalSettingsPhysitrackIntegrationRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<PractitionerResponse>(); }
}
(ClinicalSettingsPhysitrackIntegrationRequest as unknown)[immerable] = true;

// @Route("/clinical/settings/fixconvertedimages")
export class ClinicalSettingsFixConvertedImagesRequest implements IReturn<ResponseBase<boolean>>
{
    public email: string|null;

    public constructor(init?: Partial<ClinicalSettingsFixConvertedImagesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClinicalSettingsFixConvertedImagesRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ClinicalSettingsFixConvertedImagesRequest as unknown)[immerable] = true;

// @Route("/clinical/settings/mytemplates/hide")
export class ClinicalMyTemplatesHideRequest implements IReturn<ResponseBase<ClinicalMyTemplatesResponse>>
{
    public id: number|null;
    public archived: boolean|null;

    public constructor(init?: Partial<ClinicalMyTemplatesHideRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClinicalMyTemplatesHideRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<ClinicalMyTemplatesResponse>(); }
}
(ClinicalMyTemplatesHideRequest as unknown)[immerable] = true;

// @Route("/lookups/nested/search", "POST")
export class CustomLookupSearchRequest implements IReturn<ResponseBase<CustomLookupResponse>>
{
    public term: string|null;
    public terms: string[]|null;

    public constructor(init?: Partial<CustomLookupSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomLookupSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CustomLookupResponse>(); }
}
(CustomLookupSearchRequest as unknown)[immerable] = true;

// @Route("/lookups/nested", "POST")
// @Route("/lookups/nested/{Id}", "GET, PUT, DELETE")
export class CustomLookupRequest implements IReturn<ResponseBase<CustomLookupResponse>>
{
    public id: number|null;
    public name: string|null;
    public value: string|null;
    public alternates: string[]|null;
    public groupId: number|null;
    public serviceTypeId: number|null;

    public constructor(init?: Partial<CustomLookupRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomLookupRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CustomLookupResponse>(); }
}
(CustomLookupRequest as unknown)[immerable] = true;

export class CustomLookupsPutRequest implements IReturn<ResponseBase<boolean>>
{
    public lookups: CustomLookupRequest[]|null;

    public constructor(init?: Partial<CustomLookupsPutRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomLookupsPutRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(CustomLookupsPutRequest as unknown)[immerable] = true;

// @Route("/lookups/nested/alternates")
export class AlternateLookupRequest implements IReturn<ResponseBase<{ [index:string]: { [index:string]: string; }; }>>
{

    public constructor(init?: Partial<AlternateLookupRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AlternateLookupRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<{ [index:string]: { [index:string]: string; }; }>(); }
}
(AlternateLookupRequest as unknown)[immerable] = true;

// @Route("/system/keepalive", "POST")
export class KeepAliveRequest implements IReturn<ResponseBase<boolean>>
{

    public constructor(init?: Partial<KeepAliveRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'KeepAliveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(KeepAliveRequest as unknown)[immerable] = true;

// @Route("/sso")
export class SsoRequest
{
    public sso: string|null;
    public sig: string|null;

    public constructor(init?: Partial<SsoRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SsoRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(SsoRequest as unknown)[immerable] = true;

// @Route("/clinical/templates", "GET")
export class ClinicalTemplateRequest implements IReturn<ResponseBase<ClinicalTemplatesResponse>>
{

    public constructor(init?: Partial<ClinicalTemplateRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClinicalTemplateRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ClinicalTemplatesResponse>(); }
}
(ClinicalTemplateRequest as unknown)[immerable] = true;

// @Route("/templates/type", "POST")
// @Route("/templates/type/{Type}", "POST")
export class TemplatesByTypeRequest implements IReturn<ResponseBase<Template>>
{
    public type: string|null;
    public types: string[]|null;

    public constructor(init?: Partial<TemplatesByTypeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TemplatesByTypeRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<Template>(); }
}
(TemplatesByTypeRequest as unknown)[immerable] = true;

export class TemplateRequest implements IReturn<ResponseBase<TemplateResponse>>
{
    public id: number|null;

    public constructor(init?: Partial<TemplateRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TemplateRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<TemplateResponse>(); }
}
(TemplateRequest as unknown)[immerable] = true;

export class SaveTemplateRequest implements IReturn<ResponseBase<boolean>>
{
    public id: number|null;
    public body: string|null;
    public name: string|null;
    public signatureRequired: boolean|null;

    public constructor(init?: Partial<SaveTemplateRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveTemplateRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(SaveTemplateRequest as unknown)[immerable] = true;

export class ClickAccountPaymentsStatsRequest implements IReturn<ResponseBase<ClickAccountPaymentsStatsResponse>>
{
    public accountId: number|null;

    public constructor(init?: Partial<ClickAccountPaymentsStatsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickAccountPaymentsStatsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClickAccountPaymentsStatsResponse>(); }
}
(ClickAccountPaymentsStatsRequest as unknown)[immerable] = true;

export class ClickAccountInvoiceStatsRequest implements IReturn<ResponseBase<ClickAccountInvoiceStatsResponse>>
{
    public accountId: number|null;

    public constructor(init?: Partial<ClickAccountInvoiceStatsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickAccountInvoiceStatsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClickAccountInvoiceStatsResponse>(); }
}
(ClickAccountInvoiceStatsRequest as unknown)[immerable] = true;

export class ClickAccountUninvoicedChargesCountRequest implements IReturn<ResponseBase<ClickAccountUninvoicedChargesCountResponse>>
{
    public accountId: number|null;

    public constructor(init?: Partial<ClickAccountUninvoicedChargesCountRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickAccountUninvoicedChargesCountRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClickAccountUninvoicedChargesCountResponse>(); }
}
(ClickAccountUninvoicedChargesCountRequest as unknown)[immerable] = true;

export class ClickAccountBusinessUninvoicedChargesCountRequest implements IReturn<ResponseBase<ClickAccountUninvoicedChargesCountResponse>>
{
    public accountId: number|null;

    public constructor(init?: Partial<ClickAccountBusinessUninvoicedChargesCountRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickAccountBusinessUninvoicedChargesCountRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClickAccountUninvoicedChargesCountResponse>(); }
}
(ClickAccountBusinessUninvoicedChargesCountRequest as unknown)[immerable] = true;

export class ClickAccountBusinessInvoiceStatsRequest implements IReturn<ResponseBase<ClickAccountInvoiceStatsResponse>>
{
    public accountId: number|null;

    public constructor(init?: Partial<ClickAccountBusinessInvoiceStatsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickAccountBusinessInvoiceStatsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClickAccountInvoiceStatsResponse>(); }
}
(ClickAccountBusinessInvoiceStatsRequest as unknown)[immerable] = true;

// @Route("/cases/{Id}/print", "POST")
export class CasePrintingRequest implements IReturn<ResponseBase<CasePrintingResponse>>, ISecurityId, IFilterServiceTypeManually
{
    public id: number|null;
    public locationIds: number[]|null;
    public items: CasePrintingItem[]|null;
    public goals: number[]|null;
    public scores: number[]|null;
    public discharge: boolean|null;
    public pmh: boolean|null;
    public securityId: number|null;

    public constructor(init?: Partial<CasePrintingRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CasePrintingRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CasePrintingResponse>(); }
}
(CasePrintingRequest as unknown)[immerable] = true;

// @Route("/cases/{id}/reports/search", "GET")
export class CaseReportSearchRequest implements IReturn<ResponseBase<CaseReportSearchResponse>>, ILocationIds, ISecurityId
{
    public id: number|null;
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;
    public securityId: number|null;

    public constructor(init?: Partial<CaseReportSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseReportSearchRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<CaseReportSearchResponse>(); }
}
(CaseReportSearchRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/reports", "POST")
// @Route("/cases/{CaseId}/reports/{Id}", "PUT")
export class CaseReportRequest extends CaseReport implements IReturn<ResponseBase<CaseReport>>, IHasCaseId, ISecurityId
{
    public caseId: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<CaseReportRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseReportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CaseReport>(); }
}
(CaseReportRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/reports/{Id}/submit", "POST")
export class CaseReportSubmitRequest extends CaseReport implements IReturn<ResponseBase<CaseReport>>, IHasCaseId, ISecurityId
{
    public caseId: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<CaseReportSubmitRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseReportSubmitRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CaseReport>(); }
}
(CaseReportSubmitRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/reports/{Id}/clone", "POST")
export class CaseReportCloneRequest extends CaseReport implements IReturn<ResponseBase<Object>>, IHasCaseId, ISecurityId
{
    public caseId: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<CaseReportCloneRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseReportCloneRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<Object>(); }
}
(CaseReportCloneRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/reports/{Id}/acknowledge", "POST")
export class CaseReportAcknowledgeRequest implements IReturn<Object>, ISecurityId
{
    public id: string|null;
    public caseId: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<CaseReportAcknowledgeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseReportAcknowledgeRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Object(); }
}
(CaseReportAcknowledgeRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/attachments/{Name}", "GET")
export class CaseReportAttachmentRequest implements IReturn<Object>, ISecurityId
{
    public name: string|null;
    public caseId: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<CaseReportAttachmentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseReportAttachmentRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Object(); }
}
(CaseReportAttachmentRequest as unknown)[immerable] = true;

// @Route("/cases/dashboard/search")
export class CaseDashboardSearchRequest implements IReturn<ResponseBase<CaseDashboardResponse>>, ILocationIds, IFilterServiceTypeManually
{
    public skip: number|null;
    public take: number|null;
    public awaiting: boolean|null;
    public inTreatment: boolean|null;
    public noNotes: boolean|null;
    public practitionerId: number|null;
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;

    public constructor(init?: Partial<CaseDashboardSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseDashboardSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CaseDashboardResponse>(); }
}
(CaseDashboardSearchRequest as unknown)[immerable] = true;

// @Route("/cases/search")
export class CaseSearchRequest extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<CaseSearchResponse>>
{
    public admittedBetweenDates: DateRange|null;
    public dischargedBetweenDates: DateRange|null;
    public bodySites: string[]|null;
    public diagnosisCode: string[]|null;
    public practitionerIds: number[]|null;
    public id: number|null;
    public businessIds: number[]|null;
    public statuses: number[]|null;
    public name: string|null;
    public searchApplied: boolean|null;
    public userIsPractitioner: boolean|null;
    public dashboardRequest: boolean|null;
    public initialLoad: boolean|null;

    public constructor(init?: Partial<CaseSearchRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CaseSearchResponse>(); }
}
(CaseSearchRequest as unknown)[immerable] = true;

// @Route("/case/{Id}/audit", "POST")
export class CaseAudit implements IReturn<CaseAuditResponse>, ILocationIds, ISecurityId
{
    public id: number|null;
    public userId: number|null;
    public note: string|null;
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;
    public securityId: number|null;

    public constructor(init?: Partial<CaseAudit>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseAudit'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CaseAuditResponse(); }
}
(CaseAudit as unknown)[immerable] = true;

// @Route("/cases/{Id}/autosave", "POST")
export class CaseAutoSaveRequest implements IReturn<AutoSaveResult[]>, ILocationIds
{
    public id: number|null;
    public updates: AutoSaveUpdate[]|null;
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;

    public constructor(init?: Partial<CaseAutoSaveRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseAutoSaveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Array<AutoSaveResult>(); }
}
(CaseAutoSaveRequest as unknown)[immerable] = true;

// @Route("/cases/{Id}/close", "POST")
export class CaseCloseRequest implements IReturn<AutoSaveResult[]>, ILocationIds
{
    public id: number|null;
    public updates: AutoSaveUpdate[]|null;
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;

    public constructor(init?: Partial<CaseCloseRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseCloseRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Array<AutoSaveResult>(); }
}
(CaseCloseRequest as unknown)[immerable] = true;

// @Route("/cases/{Id}/delete", "POST")
export class CaseDeleteRequest implements IReturn<ResponseBase<boolean>>, ILocationIds
{
    public id: number|null;
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;

    public constructor(init?: Partial<CaseDeleteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseDeleteRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(CaseDeleteRequest as unknown)[immerable] = true;

// @Route("/cases/{Id}/delete", "POST")
export class CaseUnlinkAndDelete extends CaseDeleteRequest implements IReturn<ResponseBase<boolean>>
{

    public constructor(init?: Partial<CaseUnlinkAndDelete>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseUnlinkAndDelete'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(CaseUnlinkAndDelete as unknown)[immerable] = true;

// @Route("/cases/{Id}/update", "POST")
export class CaseUpdateRequest implements IReturnVoid, ILocationIds
{
    public id: number|null;
    public updates: AutoSaveUpdate[]|null;
    public lastModified: string|null;
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;

    public constructor(init?: Partial<CaseUpdateRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseUpdateRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(CaseUpdateRequest as unknown)[immerable] = true;

// @Route("/cases/{Id}/discharge", "POST")
export class CaseDischargeRequest implements IReturn<ResponseBase<string>>, ILocationIds
{
    public id: number|null;
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;

    public constructor(init?: Partial<CaseDischargeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseDischargeRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<string>(); }
}
(CaseDischargeRequest as unknown)[immerable] = true;

export class CaseIsTaxExempt implements IReturn<ResponseBase<boolean>>
{
    public appointmentId: number|null;
    public caseId: number|null;

    public constructor(init?: Partial<CaseIsTaxExempt>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseIsTaxExempt'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(CaseIsTaxExempt as unknown)[immerable] = true;

// @Route("/cases/{Id}/highlight", "POST")
export class CaseHighlightRequest implements IReturn<ResponseBase<boolean>>, ILocationIds
{
    public id: number|null;
    public type: string|null;
    public highlights: { [index:string]: number[]; }|null;
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;

    public constructor(init?: Partial<CaseHighlightRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseHighlightRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(CaseHighlightRequest as unknown)[immerable] = true;

// @Route("/cases/{Id}", "GET")
export class CaseGetRequest implements IReturn<CaseDetailsDto>, ISecurityId
{
    public id: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<CaseGetRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseGetRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CaseDetailsDto(); }
}
(CaseGetRequest as unknown)[immerable] = true;

export class CaseUpdateTaxStatus implements IReturn<ResponseBase<boolean>>
{
    public caseId: number|null;
    public taxExempt: boolean|null;
    public justification: string|null;

    public constructor(init?: Partial<CaseUpdateTaxStatus>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseUpdateTaxStatus'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(CaseUpdateTaxStatus as unknown)[immerable] = true;

// @Route("/cases/new", "GET")
export class CaseNewRequest implements IReturn<CaseDetailsDto>, ILocationIds
{
    public patientId: number|null;
    public appointmentId: number|null;
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;

    public constructor(init?: Partial<CaseNewRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseNewRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CaseDetailsDto(); }
}
(CaseNewRequest as unknown)[immerable] = true;

// @Route("/cases/{Id}/upgrade")
export class CaseUpgradeRequest implements IReturn<ResponseBase<boolean>>, ILocationIds
{
    public id: number|null;
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;

    public constructor(init?: Partial<CaseUpgradeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseUpgradeRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(CaseUpgradeRequest as unknown)[immerable] = true;

// @Route("/cases/{id}/history")
export class CaseHistoryRequest implements IReturn<ResponseBase<HistoryResult>>, ISecurityId
{
    public id: number|null;
    public securityId: number|null;
    public formStatus: FormStatus[]|null;

    public constructor(init?: Partial<CaseHistoryRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseHistoryRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<HistoryResult>(); }
}
(CaseHistoryRequest as unknown)[immerable] = true;

// @Route("/case/{CustomerId}")
// @Route("/case")
export class CaseDropdownRequest implements IReturn<ResponseBase<CaseDropDownResposne>>, ILocationIds
{
    public skip: number|null;
    public take: number|null;
    public customerId: number|null;
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;

    public constructor(init?: Partial<CaseDropdownRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseDropdownRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<CaseDropDownResposne>(); }
}
(CaseDropdownRequest as unknown)[immerable] = true;

// @Route("/case/reviewDate")
export class CaseReviewDateRequest implements IReturn<ResponseBase<boolean>>, ILocationIds
{
    public caseId: number|null;
    public reviewDate: string|null;
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;

    public constructor(init?: Partial<CaseReviewDateRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseReviewDateRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(CaseReviewDateRequest as unknown)[immerable] = true;

// @Route("/case/{CaseId}/notes/add")
export class PostCloseNotesRequest implements IReturn<ResponseBase<PostCloseNotesWithUser>>, ISecurityId
{
    public id: number|null;
    public caseId: number|null;
    public securityId: number|null;
    public treatmentId: number|null;
    public userId: number|null;
    public notes: string|null;
    public date: string|null;
    public type: string|null;

    public constructor(init?: Partial<PostCloseNotesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostCloseNotesRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<PostCloseNotesWithUser>(); }
}
(PostCloseNotesRequest as unknown)[immerable] = true;

// @Route("/case/customers/{CustomerId}/{CaseId}")
export class CaseCustomerRequest implements IReturn<ResponseBase<GeneralCustomerResponse>>, ISecurityId
{
    public customerId: number|null;
    public caseId: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<CaseCustomerRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseCustomerRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<GeneralCustomerResponse>(); }
}
(CaseCustomerRequest as unknown)[immerable] = true;

// @Route("/casecheck/appt")
export class AppointmentCheck implements IReturn<ResponseBase<boolean>>
{
    public caseId: number|null;
    public appointmentId: number|null;

    public constructor(init?: Partial<AppointmentCheck>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AppointmentCheck'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(AppointmentCheck as unknown)[immerable] = true;

// @Route("/cases/{Id}/background", "GET, POST")
export class CaseBackgroundRequest implements IReturn<ResponseBase<CustomerBackgroundResponse>>, ISecurityId
{
    public id: number|null;
    public data: { [index:string]: Object; }|null;
    public securityId: number|null;

    public constructor(init?: Partial<CaseBackgroundRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseBackgroundRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<CustomerBackgroundResponse>(); }
}
(CaseBackgroundRequest as unknown)[immerable] = true;

// @Route("/customer/{CustomerId}/background", "GET, POST")
export class CustomerBackgroundRequest implements IReturn<ResponseBase<CustomerBackgroundResponse>>, ICustomerId
{
    public customerId: number|null;
    public data: { [index:string]: Object; }|null;

    public constructor(init?: Partial<CustomerBackgroundRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomerBackgroundRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<CustomerBackgroundResponse>(); }
}
(CustomerBackgroundRequest as unknown)[immerable] = true;

// @Route("/background/{Id}/highlight", "POST")
export class BackgroundHighlightRequest implements IReturn<ResponseBase<boolean>>, ILocationIds
{
    public id: number|null;
    public highlights: { [index:string]: number[]; }|null;
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;

    public constructor(init?: Partial<BackgroundHighlightRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BackgroundHighlightRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(BackgroundHighlightRequest as unknown)[immerable] = true;

// @Route("/cases/cache/all", "GET")
export class ClinicalCacheRequest implements IReturn<ClinicalCacheResponse>
{

    public constructor(init?: Partial<ClinicalCacheRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClinicalCacheRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ClinicalCacheResponse(); }
}
(ClinicalCacheRequest as unknown)[immerable] = true;

// @Route("/clinical/logs/{CustomerId}/{CaseId}")
// @Route("/clinical/logs/{CustomerId}/{CaseId}/{Id}")
export class ClinicalLogRequest implements IReturn<ResponseBase<IPatientInfoResponse>>, ICustomerId, IDepartmentIds
{
    public id: number|null;
    public customerId: number|null;
    public caseId: number|null;
    public departmentIds: number[]|null;

    public constructor(init?: Partial<ClinicalLogRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClinicalLogRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<IPatientInfoResponse>(); }
}
(ClinicalLogRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/consultation/{TreatmentId}/items/{Id}/highlight", "POST")
export class ConsultationItemHighlightRequest implements IReturn<ResponseBase<boolean>>, ISecurityId
{
    public id: number|null;
    public caseId: number|null;
    public treatmentId: number|null;
    public highlights: { [index:string]: number[]; }|null;
    public securityId: number|null;

    public constructor(init?: Partial<ConsultationItemHighlightRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ConsultationItemHighlightRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ConsultationItemHighlightRequest as unknown)[immerable] = true;

// @Route("/diagnosiscodes/all")
export class DiagnosisCodeRequest implements IReturn<ResponseBase<CustomListItemResponse>>
{

    public constructor(init?: Partial<DiagnosisCodeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DiagnosisCodeRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<CustomListItemResponse>(); }
}
(DiagnosisCodeRequest as unknown)[immerable] = true;

// @Route("/diagnosiscodes/allVals")
// @Route("/diagnosiscodes/lookupVals")
export class DiagnosisCodeLookupRequest implements IReturn<ResponseBase<DiagnosisCodeTempResponse>>
{

    public constructor(init?: Partial<DiagnosisCodeLookupRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DiagnosisCodeLookupRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<DiagnosisCodeTempResponse>(); }
}
(DiagnosisCodeLookupRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/diagram", "POST")
// @Route("/cases/{CaseId}/diagram/{Id}", "PUT, DELETE")
export class DiagramRequest implements IReturn<ClinicalDiagram>, ISecurityId
{
    public id: number|null;
    public caseId: number|null;
    public securityId: number|null;
    public treatmentId: number|null;
    public dateTime: string|null;
    public value: { [index:string]: Object; }[]|null;

    public constructor(init?: Partial<DiagramRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DiagramRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ClinicalDiagram(); }
}
(DiagramRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/diagram/{Id}/lock", "PUT")
export class DiagramLockRequest implements IReturn<ClinicalDiagram>, ISecurityId
{
    public id: number|null;
    public caseId: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<DiagramLockRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DiagramLockRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ClinicalDiagram(); }
}
(DiagramLockRequest as unknown)[immerable] = true;

export class CreatePsfsRequest implements IReturn<ResponseBase<Psfs[]>>
{
    public caseId: number|null;
    public activities: NewPsfs[]|null;
    public hasInitialValues: boolean|null;

    public constructor(init?: Partial<CreatePsfsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreatePsfsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<Psfs[]>(); }
}
(CreatePsfsRequest as unknown)[immerable] = true;

export class UpdatePsfsRequest implements IReturn<ResponseBase<Psfs[]>>
{
    public caseId: number|null;
    public psfs: Psfs[]|null;
    public activities: NewPsfs[]|null;

    public constructor(init?: Partial<UpdatePsfsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdatePsfsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<Psfs[]>(); }
}
(UpdatePsfsRequest as unknown)[immerable] = true;

export class GetTreatmentRequest implements IReturn<ResponseBase<Treatment>>, ISecurityLocator
{
    public id: number|null;
    public securityLocator: Func<Object, IClientDbAccess, SecurityDto>|null;

    public constructor(init?: Partial<GetTreatmentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTreatmentRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<Treatment>(); }
}
(GetTreatmentRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/consultation", "POST")
// @Route("/cases/{CaseId}/consultation/{Id}", "PUT, DELETE")
export class TreatmentAutoSaveRequest implements IReturn<TreatmentResult>, ISecurityId
{
    public id: number|null;
    public appointmentId: number|null;
    public caseId: number|null;
    public details: TreatmentDetails|null;
    public treatment: string|null;
    public locationId: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<TreatmentAutoSaveRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TreatmentAutoSaveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TreatmentResult(); }
}
(TreatmentAutoSaveRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/consultation/{Id}", "POST")
export class TreatmentSaveRequest implements IReturn<ResponseBase<boolean>>, ISecurityId
{
    public id: number|null;
    public caseId: number|null;
    public lock: boolean|null;
    public updates: DynamicUpdate[]|null;
    public securityId: number|null;

    public constructor(init?: Partial<TreatmentSaveRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TreatmentSaveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(TreatmentSaveRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/consultation/{Id}/highlight", "POST")
export class TreatmentHighlightRequest implements IReturn<ResponseBase<boolean>>, ISecurityId
{
    public id: number|null;
    public caseId: number|null;
    public highlights: { [index:string]: number[]; }|null;
    public securityId: number|null;

    public constructor(init?: Partial<TreatmentHighlightRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TreatmentHighlightRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(TreatmentHighlightRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/scores/{ScoreId}/entry", "POST")
export class ScoreEntryPostRequest extends ScoreEntryRequest implements IReturn<ResponseBase<ScoreEntryResponse>>
{

    public constructor(init?: Partial<ScoreEntryPostRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ScoreEntryPostRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ScoreEntryResponse>(); }
}
(ScoreEntryPostRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/scores/{ScoreId}/entry/{Id}", "PUT")
export class ScoreEntryPutRequest extends ScoreEntryRequest implements IReturn<ResponseBase<ScoreEntryResponse>>
{

    public constructor(init?: Partial<ScoreEntryPutRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ScoreEntryPutRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<ScoreEntryResponse>(); }
}
(ScoreEntryPutRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/scores/{ScoreId}/entry/{Id}", "DELETE")
export class ScoreEntryDeleteRequest implements IReturn<ResponseBase<boolean>>, ISecurityId
{
    public id: number|null;
    public caseId: number|null;
    public securityId: number|null;
    public scoreId: number|null;

    public constructor(init?: Partial<ScoreEntryDeleteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ScoreEntryDeleteRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ScoreEntryDeleteRequest as unknown)[immerable] = true;

// @Route("/scores/available", "POST")
export class AvailableScoresRequest implements IReturn<ResponseBase<CaseScoreGoalResponse>>
{
    public isFree: boolean|null;

    public constructor(init?: Partial<AvailableScoresRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AvailableScoresRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CaseScoreGoalResponse>(); }
}
(AvailableScoresRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/scores/search", "POST")
export class ScoreSearchRequest implements IReturn<ResponseBase<ScoreSearchResponse>>, ISecurityId
{
    public caseId: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<ScoreSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ScoreSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ScoreSearchResponse>(); }
}
(ScoreSearchRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/scores/order", "POST")
export class ScoreOrderRequest implements IReturn<ResponseBase<boolean>>, ISecurityId
{
    public caseId: number|null;
    public securityId: number|null;
    public order: number[]|null;

    public constructor(init?: Partial<ScoreOrderRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ScoreOrderRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ScoreOrderRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/scores/{Id}", "POST")
export class ScoreGetRequest implements IReturn<ScoreResponse>, ISecurityId
{
    public id: number|null;
    public caseId: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<ScoreGetRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ScoreGetRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ScoreResponse(); }
}
(ScoreGetRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/scores", "POST")
export class ScorePostRequest extends ScoreRequest implements IReturn<ResponseBase<ScoreResponse>>
{

    public constructor(init?: Partial<ScorePostRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ScorePostRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ScoreResponse>(); }
}
(ScorePostRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/scores/{Id}", "PUT")
export class ScorePutRequest extends ScoreRequest implements IReturn<ResponseBase<ScoreResponse>>
{

    public constructor(init?: Partial<ScorePutRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ScorePutRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<ScoreResponse>(); }
}
(ScorePutRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/score/{Id}/", "DELETE")
export class ScoreDeleteRequest extends ScoreRequest implements IReturn<ResponseBase<ScoreResponse>>
{

    public constructor(init?: Partial<ScoreDeleteRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ScoreDeleteRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ResponseBase<ScoreResponse>(); }
}
(ScoreDeleteRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/goals/{GoalId}/entry", "POST")
export class GoalEntryPostRequest extends GoalEntryRequest implements IReturn<ResponseBase<GoalEntryResponse>>, ILocationId
{

    public constructor(init?: Partial<GoalEntryPostRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GoalEntryPostRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<GoalEntryResponse>(); }
}
(GoalEntryPostRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/goals/{GoalId}/entry/{Id}", "PUT")
export class GoalEntryPutRequest extends GoalEntryRequest implements IReturn<ResponseBase<GoalEntryResponse>>, ILocationId
{

    public constructor(init?: Partial<GoalEntryPutRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GoalEntryPutRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<GoalEntryResponse>(); }
}
(GoalEntryPutRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/goals/{GoalId}/entry/{Id}", "DELETE")
export class GoalEntryDeleteRequest implements IReturn<ResponseBase<boolean>>, ISecurityId
{
    public id: number|null;
    public caseId: number|null;
    public securityId: number|null;
    public goalId: number|null;

    public constructor(init?: Partial<GoalEntryDeleteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GoalEntryDeleteRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(GoalEntryDeleteRequest as unknown)[immerable] = true;

// @Route("/goals/available", "POST")
export class AvailableGoalsRequest implements IReturn<ResponseBase<CaseScoreGoalResponse>>
{

    public constructor(init?: Partial<AvailableGoalsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AvailableGoalsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CaseScoreGoalResponse>(); }
}
(AvailableGoalsRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/goals/search", "POST")
export class GoalSearchRequest implements IReturn<ResponseBase<GoalSearchResponse>>, ISecurityId
{
    public caseId: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<GoalSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GoalSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<GoalSearchResponse>(); }
}
(GoalSearchRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/goals/order", "POST")
export class GoalOrderRequest implements IReturn<ResponseBase<boolean>>, ISecurityId
{
    public caseId: number|null;
    public securityId: number|null;
    public order: number[]|null;

    public constructor(init?: Partial<GoalOrderRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GoalOrderRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(GoalOrderRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/goals/{Id}", "GET")
export class GoalsGetRequest implements IReturn<GoalResponse>, ILocationId, ISecurityId
{
    public id: number|null;
    public caseId: number|null;
    public securityId: number|null;
    public locationId: number|null;

    public constructor(init?: Partial<GoalsGetRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GoalsGetRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GoalResponse(); }
}
(GoalsGetRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/goals", "POST")
export class GoalPostRequest extends GoalRequest implements IReturn<ResponseBase<GoalResponse>>, ILocationId
{

    public constructor(init?: Partial<GoalPostRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GoalPostRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<GoalResponse>(); }
}
(GoalPostRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/goals/{Id}", "PUT")
export class GoalPutRequest extends GoalRequest implements IReturn<ResponseBase<GoalResponse>>, ILocationId
{

    public constructor(init?: Partial<GoalPutRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GoalPutRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<GoalResponse>(); }
}
(GoalPutRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/goals/{Id}", "DELETE")
export class GoalDeleteRequest extends GoalRequest implements IReturn<ResponseBase<GoalResponse>>
{
    public settingId: number|null;

    public constructor(init?: Partial<GoalDeleteRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GoalDeleteRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ResponseBase<GoalResponse>(); }
}
(GoalDeleteRequest as unknown)[immerable] = true;

export class BulkUpdateFieldRequest implements IReturn<ResponseBase<T>>
{
    public recordType: BulkActionRecordType|null;

    public constructor(init?: Partial<BulkUpdateFieldRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BulkUpdateFieldRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(BulkUpdateFieldRequest as unknown)[immerable] = true;

export class DiarySMSBulkActionRequest extends DiaryBulkActionBaseRequest implements IReturn<ResponseBase<SMSBulkActionResponse>>
{
    public templateNames: string[]|null;

    public constructor(init?: Partial<DiarySMSBulkActionRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'DiarySMSBulkActionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<SMSBulkActionResponse>(); }
}
(DiarySMSBulkActionRequest as unknown)[immerable] = true;

export class DiaryEmailBulkActionRequest extends DiaryBulkActionBaseRequest implements IReturn<ResponseBase<EmailBulkActionResponse>>
{
    public templateNames: string[]|null;

    public constructor(init?: Partial<DiaryEmailBulkActionRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'DiaryEmailBulkActionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<EmailBulkActionResponse>(); }
}
(DiaryEmailBulkActionRequest as unknown)[immerable] = true;

export class DiaryContactBulkActionRequest extends DiaryBulkActionBaseRequest implements IReturn<ResponseBase<ContactBulkActionResponse>>
{
    public customMessage: string|null;

    public constructor(init?: Partial<DiaryContactBulkActionRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'DiaryContactBulkActionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ContactBulkActionResponse>(); }
}
(DiaryContactBulkActionRequest as unknown)[immerable] = true;

export class DiaryFormBulkActionRequest extends DiaryBulkActionBaseRequest implements IReturn<ResponseBase<FormBulkActionResponse>>
{
    public formTemplateIds: string[]|null;

    public constructor(init?: Partial<DiaryFormBulkActionRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'DiaryFormBulkActionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<FormBulkActionResponse>(); }
}
(DiaryFormBulkActionRequest as unknown)[immerable] = true;

export class DiaryTagBulkActionRequest extends DiaryBulkActionBaseRequest implements IReturn<ResponseBase<TagBulkActionResponse>>
{
    public tags: string[]|null;
    public tagActionType: TagActionType|null;

    public constructor(init?: Partial<DiaryTagBulkActionRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'DiaryTagBulkActionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<TagBulkActionResponse>(); }
}
(DiaryTagBulkActionRequest as unknown)[immerable] = true;

export class CustomerSMSBulkActionRequest extends CustomerBulkActionBaseRequest implements IReturn<ResponseBase<SMSBulkActionResponse>>
{
    public templateNames: string[]|null;

    public constructor(init?: Partial<CustomerSMSBulkActionRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomerSMSBulkActionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<SMSBulkActionResponse>(); }
}
(CustomerSMSBulkActionRequest as unknown)[immerable] = true;

export class CustomerEmailBulkActionRequest extends CustomerBulkActionBaseRequest implements IReturn<ResponseBase<EmailBulkActionResponse>>
{
    public templateNames: string[]|null;

    public constructor(init?: Partial<CustomerEmailBulkActionRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomerEmailBulkActionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<EmailBulkActionResponse>(); }
}
(CustomerEmailBulkActionRequest as unknown)[immerable] = true;

export class CustomerFormBulkActionRequest extends CustomerBulkActionBaseRequest implements IReturn<ResponseBase<FormBulkActionResponse>>
{
    public formTemplateIds: string[]|null;

    public constructor(init?: Partial<CustomerFormBulkActionRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomerFormBulkActionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<FormBulkActionResponse>(); }
}
(CustomerFormBulkActionRequest as unknown)[immerable] = true;

export class CustomerTagBulkActionRequest extends CustomerBulkActionBaseRequest implements IReturn<ResponseBase<TagBulkActionResponse>>
{
    public tags: string[]|null;
    public tagActionType: TagActionType|null;

    public constructor(init?: Partial<CustomerTagBulkActionRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomerTagBulkActionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<TagBulkActionResponse>(); }
}
(CustomerTagBulkActionRequest as unknown)[immerable] = true;

export class CustomerContactBulkActionRequest extends CustomerBulkActionBaseRequest implements IReturn<ResponseBase<ContactBulkActionResponse>>
{
    public customMessage: string|null;

    public constructor(init?: Partial<CustomerContactBulkActionRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomerContactBulkActionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ContactBulkActionResponse>(); }
}
(CustomerContactBulkActionRequest as unknown)[immerable] = true;

export class MailChimpSubscriptionBulkActionRequest extends CustomerBulkActionBaseRequest implements IReturn<ResponseBase<MailChimpSubscriptionBulkActionResponse>>
{
    public audienceIds: string[]|null;

    public constructor(init?: Partial<MailChimpSubscriptionBulkActionRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'MailChimpSubscriptionBulkActionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<MailChimpSubscriptionBulkActionResponse>(); }
}
(MailChimpSubscriptionBulkActionRequest as unknown)[immerable] = true;

export class GetAllAutomationEvents extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<AutomationEvent>>
{
    public showAll: boolean|null;

    public constructor(init?: Partial<GetAllAutomationEvents>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAllAutomationEvents'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<AutomationEvent>(); }
}
(GetAllAutomationEvents as unknown)[immerable] = true;

export class GetAutomationEvent implements IReturn<ResponseBase<AutomationEvent>>
{
    public id: string|null;

    public constructor(init?: Partial<GetAutomationEvent>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAutomationEvent'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<AutomationEvent>(); }
}
(GetAutomationEvent as unknown)[immerable] = true;

export class SaveAutomationEvent extends AutomationEvent implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<SaveAutomationEvent>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveAutomationEvent'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(SaveAutomationEvent as unknown)[immerable] = true;

export class GetAllAutomationJobs implements IReturn<ResponseBase<AutomationJob>>
{
    public skip: number|null;
    public take: number|null;
    public sort: QueryField[]|null;

    public constructor(init?: Partial<GetAllAutomationJobs>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAllAutomationJobs'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<AutomationJob>(); }
}
(GetAllAutomationJobs as unknown)[immerable] = true;

export class ToggleAutomationJobStatus implements IReturn<ResponseBase<AutomationJob>>
{
    public id: string|null;
    public isActive: boolean|null;

    public constructor(init?: Partial<ToggleAutomationJobStatus>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ToggleAutomationJobStatus'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<AutomationJob>(); }
}
(ToggleAutomationJobStatus as unknown)[immerable] = true;

export class CloneAutomationRequest implements IReturn<ResponseBase<string>>
{
    public id: string|null;

    public constructor(init?: Partial<CloneAutomationRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CloneAutomationRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<string>(); }
}
(CloneAutomationRequest as unknown)[immerable] = true;

export class ArchiveAutomationRequest implements IReturn<ResponseBase<boolean>>
{
    public id: string|null;
    public archiveAutomation: boolean|null;

    public constructor(init?: Partial<ArchiveAutomationRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ArchiveAutomationRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ArchiveAutomationRequest as unknown)[immerable] = true;

export class GetAllTags implements IReturn<ResponseBase<Tag>>
{
    public skip: number|null;
    public take: number|null;
    public showAll: boolean|null;
    public sort: QueryField[]|null;

    public constructor(init?: Partial<GetAllTags>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAllTags'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<Tag>(); }
}
(GetAllTags as unknown)[immerable] = true;

export class GetTag implements IReturn<ResponseBase<Tag>>
{
    public id: string|null;

    public constructor(init?: Partial<GetTag>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTag'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<Tag>(); }
}
(GetTag as unknown)[immerable] = true;

export class SaveTag extends Tag implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<SaveTag>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveTag'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(SaveTag as unknown)[immerable] = true;

// @Route("/webinars")
export class WebinarRequest implements IReturn<ResponseBase<WebinarResponse>>
{

    public constructor(init?: Partial<WebinarRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WebinarRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<WebinarResponse>(); }
}
(WebinarRequest as unknown)[immerable] = true;

// @Route("/training")
export class TrainingRequest
{

    public constructor(init?: Partial<TrainingRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TrainingRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(TrainingRequest as unknown)[immerable] = true;

// @Route("/user/current", "GET")
export class GetCurrentUser implements IReturn<CurrentUser>
{

    public constructor(init?: Partial<GetCurrentUser>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCurrentUser'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CurrentUser(); }
}
(GetCurrentUser as unknown)[immerable] = true;

// @Route("/user/location/change", "Post")
// @Route("/user/location/change/{Id}", "Post")
export class ChangeLoggedInLocation implements IReturn<CurrentUser>
{
    public id: number|null;

    public constructor(init?: Partial<ChangeLoggedInLocation>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ChangeLoggedInLocation'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CurrentUser(); }
}
(ChangeLoggedInLocation as unknown)[immerable] = true;

// @Route("/user/all", "GET")
export class AllUsersRequest implements IReturn<SimpleUser[]>, ILocationIds
{
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;

    public constructor(init?: Partial<AllUsersRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AllUsersRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Array<SimpleUser>(); }
}
(AllUsersRequest as unknown)[immerable] = true;

// @Route("/user/current/roles", "GET")
export class UserRolesRequest
{

    public constructor(init?: Partial<UserRolesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UserRolesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(UserRolesRequest as unknown)[immerable] = true;

// @Route("/user/verify/{Code}", "GET")
export class VerifyCode implements IReturn<CurrentUser>
{
    public code: string|null;

    public constructor(init?: Partial<VerifyCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'VerifyCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CurrentUser(); }
}
(VerifyCode as unknown)[immerable] = true;

// @Route("/user/reset", "Post")
export class ResetPassword implements IReturn<ResponseBase<boolean>>
{
    public email: string|null;

    public constructor(init?: Partial<ResetPassword>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ResetPassword'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ResetPassword as unknown)[immerable] = true;

// @Route("/user/changePassword", "Post")
export class ChangePassword implements IReturn<CurrentUser>
{
    public code: string|null;
    public confirmPassword: string|null;
    public newPassword: string|null;
    public score: number|null;

    public constructor(init?: Partial<ChangePassword>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ChangePassword'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CurrentUser(); }
}
(ChangePassword as unknown)[immerable] = true;

// @Route("/user/password/change", "Post")
export class ChangePasswordRequest implements IReturn<ResponseBase<T>>
{
    public oldPassword: string|null;
    public newPassword: string|null;
    public score: number|null;

    public constructor(init?: Partial<ChangePasswordRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ChangePasswordRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(ChangePasswordRequest as unknown)[immerable] = true;

export class ChangePINRequest implements IReturn<ResponseBase<string>>
{
    public password: string|null;
    public pin: string|null;

    public constructor(init?: Partial<ChangePINRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ChangePINRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<string>(); }
}
(ChangePINRequest as unknown)[immerable] = true;

export class ChangeSignatureRequest implements IReturn<ResponseBase<string>>
{
    public signature: string|null;

    public constructor(init?: Partial<ChangeSignatureRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ChangeSignatureRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<string>(); }
}
(ChangeSignatureRequest as unknown)[immerable] = true;

// @Route("/logout/soon")
export class LogoutSoonRequest implements IHasAutoRefresh
{
    public autoRefresh: boolean|null;

    public constructor(init?: Partial<LogoutSoonRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LogoutSoonRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(LogoutSoonRequest as unknown)[immerable] = true;

// @Route("/logout/now")
export class LogoutNowRequest
{

    public constructor(init?: Partial<LogoutNowRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LogoutNowRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(LogoutNowRequest as unknown)[immerable] = true;

export class GetAssertionOptions implements IReturn<AssertionOptions>
{
    public username: string|null;
    public userVerification: string|null;

    public constructor(init?: Partial<GetAssertionOptions>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAssertionOptions'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AssertionOptions(); }
}
(GetAssertionOptions as unknown)[immerable] = true;

export class MakeAssertionRequest implements IReturn<ResponseBase<boolean>>
{
    public id: string|null;
    public rawId: string|null;
    public response: AssertionResponse|null;
    public type: PublicKeyCredentialType|null;
    public extensions: AuthenticationExtensionsClientOutputs|null;

    public constructor(init?: Partial<MakeAssertionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MakeAssertionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(MakeAssertionRequest as unknown)[immerable] = true;

export class MakeCredentialsOptionsRequest implements IReturn<HttpResult>
{
    public username: string|null;
    public displayName: string|null;
    public attType: string|null;
    public authType: string|null;
    public residentKey: string|null;
    public userVerification: string|null;

    public constructor(init?: Partial<MakeCredentialsOptionsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MakeCredentialsOptionsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new HttpResult(); }
}
(MakeCredentialsOptionsRequest as unknown)[immerable] = true;

export class RegisterCredentialWithServerRequest implements IReturn<ResponseBase<CredentialMakeResult>>
{
    public id: string|null;
    public rawId: string|null;
    public type: PublicKeyCredentialType|null;
    public response: ResponseData|null;
    public extensions: AuthenticationExtensionsClientOutputs|null;

    public constructor(init?: Partial<RegisterCredentialWithServerRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegisterCredentialWithServerRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CredentialMakeResult>(); }
}
(RegisterCredentialWithServerRequest as unknown)[immerable] = true;

// @Route("/license")
export class LicenseRequest implements IReturn<ResponseBase<LicenseDetailsResponse>>
{

    public constructor(init?: Partial<LicenseRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LicenseRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<LicenseDetailsResponse>(); }
}
(LicenseRequest as unknown)[immerable] = true;

export class ModularFeaturesRequest implements IReturn<ResponseBase<ModularLicence>>
{

    public constructor(init?: Partial<ModularFeaturesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ModularFeaturesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ModularLicence>(); }
}
(ModularFeaturesRequest as unknown)[immerable] = true;

// @Route("/modular-licence")
export class LicenceModulesRequest implements IReturn<string>
{

    public constructor(init?: Partial<LicenceModulesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LicenceModulesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return ''; }
}
(LicenceModulesRequest as unknown)[immerable] = true;

export class TwoFactorVerify implements IReturn<ResponseBase<boolean>>
{
    public code: string|null;
    public remember: boolean|null;

    public constructor(init?: Partial<TwoFactorVerify>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TwoFactorVerify'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(TwoFactorVerify as unknown)[immerable] = true;

export class TwoFactorRequestCode implements IReturn<ResponseBase<boolean>>
{
    public setupNew: boolean|null;

    public constructor(init?: Partial<TwoFactorRequestCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TwoFactorRequestCode'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(TwoFactorRequestCode as unknown)[immerable] = true;

export class TwoFactorUpdateSecret implements IReturn<ResponseBase<boolean>>
{
    public secret: string|null;
    public codeForExistingSecret: string|null;

    public constructor(init?: Partial<TwoFactorUpdateSecret>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TwoFactorUpdateSecret'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(TwoFactorUpdateSecret as unknown)[immerable] = true;

// @Route("/{HandlerName}/webhook")
// @Route("/webhook/{HandlerName}/{Other*}")
export class InboundWebHookRequest implements IReturn<HttpResult>
{
    public handlerName: string|null;
    public other: string|null;
    public requestStream: string|null;

    public constructor(init?: Partial<InboundWebHookRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InboundWebHookRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new HttpResult(); }
}
(InboundWebHookRequest as unknown)[immerable] = true;

export class GetCustomAttributes implements IReturn<ResponseBase<CustomAttributeDto>>
{
    public types: string[]|null;

    public constructor(init?: Partial<GetCustomAttributes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCustomAttributes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<CustomAttributeDto>(); }
}
(GetCustomAttributes as unknown)[immerable] = true;

export class GetCustomAttributeLists implements IReturn<GetCustomAttributeListsResponse[]>
{

    public constructor(init?: Partial<GetCustomAttributeLists>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCustomAttributeLists'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Array<GetCustomAttributeListsResponse>(); }
}
(GetCustomAttributeLists as unknown)[immerable] = true;

export class GetAssignedAttributes implements IReturn<ResponseBase<T>>
{
    public objectId: number|null;
    public objectGuid: string|null;
    public objectType: string|null;
    public customAttributeTypes: string[]|null;

    public constructor(init?: Partial<GetAssignedAttributes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAssignedAttributes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(GetAssignedAttributes as unknown)[immerable] = true;

// @Route("/updatecustomattributes", "POST")
export class UpdateCustomAttributeRequest implements IReturnVoid
{
    public objectId: number|null;
    public objectGuid: string|null;
    public objectType: string|null;
    public attributes: AssignedCustomAttributeDto[]|null;

    public constructor(init?: Partial<UpdateCustomAttributeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateCustomAttributeRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(UpdateCustomAttributeRequest as unknown)[immerable] = true;

export class CreateNewCustomAttributeRequest implements IReturn<ResponseBase<CustomAttributes>>
{
    public typeId: string|null;
    public name: string|null;

    public constructor(init?: Partial<CreateNewCustomAttributeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateNewCustomAttributeRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CustomAttributes>(); }
}
(CreateNewCustomAttributeRequest as unknown)[immerable] = true;

export class DeleteCustomAttributeRequest implements IReturnVoid
{
    public typeId: string|null;
    public name: string|null;

    public constructor(init?: Partial<DeleteCustomAttributeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteCustomAttributeRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(DeleteCustomAttributeRequest as unknown)[immerable] = true;

export class TokenSearchRequest implements IReturn<ResponseBase<TokenSearchResponse>>
{
    public customerId: number|null;

    public constructor(init?: Partial<TokenSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TokenSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<TokenSearchResponse>(); }
}
(TokenSearchRequest as unknown)[immerable] = true;

// @Route("/finances/token/register", "POST")
export class TokenRegisterRequest implements IReturn<ResponseBase<T>>
{
    public customerId: number|null;
    public pan: string|null;
    public token: string|null;
    public merchant: string|null;
    public expiryDate: string|null;

    public constructor(init?: Partial<TokenRegisterRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TokenRegisterRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(TokenRegisterRequest as unknown)[immerable] = true;

export class TokenDeleteRequest implements IReturn<ResponseBase<boolean>>, ICustomerId
{
    public customerId: number|null;

    public constructor(init?: Partial<TokenDeleteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TokenDeleteRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(TokenDeleteRequest as unknown)[immerable] = true;

export class EnableApplePayRequest implements IReturn<ResponseBase<boolean>>
{

    public constructor(init?: Partial<EnableApplePayRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EnableApplePayRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(EnableApplePayRequest as unknown)[immerable] = true;

// @Route("/settings/multidiscipline/servicetype/{Id}")
export class ServiceTypeRequest implements IReturn<ResponseBase<ServiceTypeResponse>>
{
    public id: number|null;

    public constructor(init?: Partial<ServiceTypeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ServiceTypeRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ServiceTypeResponse>(); }
}
(ServiceTypeRequest as unknown)[immerable] = true;

// @Route("/settings/multidiscipline/servicetype/search")
export class ServiceTypeSearch implements IReturn<ResponseBase<ServiceTypeResponse>>
{
    public isCurrent: boolean|null;

    public constructor(init?: Partial<ServiceTypeSearch>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ServiceTypeSearch'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ServiceTypeResponse>(); }
}
(ServiceTypeSearch as unknown)[immerable] = true;

export class ServiceTypeSave implements IReturn<ResponseBase<ServiceTypeResponse>>
{
    public id: number|null;
    public name: string|null;
    public isCurrent: boolean|null;
    public clinicalAccessMode: AccessMode|null;
    public patientAccessMode: AccessMode|null;
    public usesScores: boolean|null;
    public usesGoals: boolean|null;
    public usesImages: boolean|null;
    public labelOverrides: { [index:string]: string; }|null;
    public listOverrides: { [index:string]: string; }|null;
    public configOverrides: { [index:string]: string; }|null;
    public workflowAccessMode: AccessMode|null;
    public globalGuid: string|null;

    public constructor(init?: Partial<ServiceTypeSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ServiceTypeSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ServiceTypeResponse>(); }
}
(ServiceTypeSave as unknown)[immerable] = true;

// @Route("/appointments/{Id}", "GET")
export class AppointmentGetRequest implements IReturn<ResponseBase<AppointmentDetailsResponse>>, ILocationIds, IFilterServiceTypeManually
{
    public skip: number|null;
    public take: number|null;
    public id: number|null;
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;

    public constructor(init?: Partial<AppointmentGetRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AppointmentGetRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<AppointmentDetailsResponse>(); }
}
(AppointmentGetRequest as unknown)[immerable] = true;

// @Route("/appointment/update", "POST")
export class AppointmentPutRequest implements IReturn<ResponseBase<{ [index:string]: ScheduleAppointment[]; }>>, ILocationIds
{
    public id: number|null;
    public startDateTime: string|null;
    public endDateTime: string|null;
    public resourceMode: string|null;
    public yesToWarnings: boolean|null;
    public apptType: string|null;
    public practitionerId: number|null;
    public roomId: number|null;
    public caseId: number|null;
    public locationId: number|null;
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;
    public resendConfirmations: boolean|null;
    public reminderType: string|null;

    public constructor(init?: Partial<AppointmentPutRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AppointmentPutRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<{ [index:string]: ScheduleAppointment[]; }>(); }
}
(AppointmentPutRequest as unknown)[immerable] = true;

// @Route("/appointment/delete", "POST")
export class AppointmentDeleteRequest implements IReturn<ResponseBase<{ [index:string]: ScheduleAppointment[]; }>>, ISecurityId
{
    public id: number|null;
    public securityId: number|null;
    public all: boolean|null;
    public includePast: boolean|null;
    public backgroundJobId: string|null;

    public constructor(init?: Partial<AppointmentDeleteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AppointmentDeleteRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<{ [index:string]: ScheduleAppointment[]; }>(); }
}
(AppointmentDeleteRequest as unknown)[immerable] = true;

// @Route("/appointment/book", "POST")
export class AppointmentBookRequest implements IReturn<ResponseBase<{ [index:string]: ScheduleAppointment[]; }>>, ILocationId
{
    public id: number|null;
    public tempId: number|null;
    public startDateTime: string|null;
    public endDateTime: string|null;
    public locationId: number|null;
    public practitionerId: number|null;
    public roomId: number|null;
    public groupId: number|null;
    public authId: number|null;
    public customerId: number|null;
    public firstAppointment: boolean|null;
    public stockType: DefaultStockTypes|null;
    public apptType: string|null;
    public stockId: number|null;
    public colour: number|null;
    public comment: string|null;
    public name: string|null;
    public duration: number|null;
    public resourceMode: string|null;
    public recurrenceInterval: RecurrenceType|null;
    public yesToWarnings: boolean|null;
    public excludeWarnings: boolean|null;
    public excludeNonWorkingDays: boolean|null;
    public status: number|null;
    public hexColour: string|null;
    public moved: boolean|null;
    public caseId: number|null;
    public bodySite: string|null;
    public bookingMethod: string|null;
    public reminderType: string|null;
    public reminderDate: string|null;
    public stockColour: number|null;
    public customDuration: number|null;
    public customFreq: number|null;
    public customInterval: string|null;
    public resendConfirmations: boolean|null;
    public meta: { [index:string]: Object; }|null;
    public updatePatientGroupToo: boolean|null;
    public prontoAuditId: string|null;
    public prontoServiceId: string|null;
    public prontoAppointmentId: string|null;
    public isProntoReferralBooking: boolean|null;
    public serviceTypeId: number|null;
    public discountCodeId: string|null;
    public discountCodeAppliedDate: string|null;
    public discountCodeAdvance: boolean|null;
    public customer: CustomerSaveRequest|null;
    public authCode: TreatmentAuthResponse|null;
    public customerGroupReference: string|null;
    public customerInsuranceNumber: string|null;
    public isVideo: boolean|null;
    public addToWaitingList: boolean|null;
    public videoCode: string|null;
    public videoLink: string|null;
    public videoMeetingHostJoinUrl: string|null;
    public videoMeetingParticipantJoinUrl: string|null;
    public videoMeetingPassword: string|null;
    public videoMeetingProvider: VideoMeetingProvider|null;
    public videoMeetingId: string|null;
    public prepaymentType: PrepaymentType|null;
    public batchNo: number|null;
    public backgroundJobId: string|null;
    public stockSpecialismId: string|null;

    public constructor(init?: Partial<AppointmentBookRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AppointmentBookRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<{ [index:string]: ScheduleAppointment[]; }>(); }
}
(AppointmentBookRequest as unknown)[immerable] = true;

// @Route("/appointment/{Id}/case", "POST")
export class AppointmentCreateClickCaseRequest implements IReturn<ResponseBase<AppointmentCreateClickCaseResponse>>
{
    public appointmentId: number|null;

    public constructor(init?: Partial<AppointmentCreateClickCaseRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AppointmentCreateClickCaseRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<AppointmentCreateClickCaseResponse>(); }
}
(AppointmentCreateClickCaseRequest as unknown)[immerable] = true;

// @Route("/appointment/{id}/linkToCase/{caseId}", "POST")
export class LinkAppointmentToCaseRequest implements IReturn<ResponseBase<boolean>>, ISecurityId
{
    public id: number|null;
    public caseId: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<LinkAppointmentToCaseRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LinkAppointmentToCaseRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(LinkAppointmentToCaseRequest as unknown)[immerable] = true;

// @Route("/appointment/{Id}/case", "POST")
export class CreateCaseFromAppointmentPostRequest implements IReturn<ResponseBase<number>>
{
    public id: number|null;

    public constructor(init?: Partial<CreateCaseFromAppointmentPostRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateCaseFromAppointmentPostRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<number>(); }
}
(CreateCaseFromAppointmentPostRequest as unknown)[immerable] = true;

// @Route("/appointments/other", "POST")
export class CustomerOtherAppointmentsRequest implements IReturn<ResponseBase<{ [index:string]: Object; }[]>>, ICustomerId
{
    public customerId: number|null;
    public startDateTime: string|null;
    public appointmentId: number|null;

    public constructor(init?: Partial<CustomerOtherAppointmentsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomerOtherAppointmentsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<{ [index:string]: Object; }[]>(); }
}
(CustomerOtherAppointmentsRequest as unknown)[immerable] = true;

// @Route("/appointment/alerts", "GET")
export class AppointmentAlertsRequest implements IReturn<ResponseBase<AlertResponse>>, ISecurityId
{
    public appointmentId: number|null;
    public customerId: number|null;
    public securityId: number|null;

    public constructor(init?: Partial<AppointmentAlertsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AppointmentAlertsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<AlertResponse>(); }
}
(AppointmentAlertsRequest as unknown)[immerable] = true;

export class AppointmentBookingInfoRequest implements IReturn<ResponseBase<AppointmentBookingInfoResponse>>, ICustomerId, ILocationId
{
    public caseId: number|null;
    public customerId: number|null;
    public locationId: number|null;
    public serviceTypeId: number|null;
    public practitionerId: number|null;
    public groupId: number|null;
    public forceFollowup: boolean|null;
    public stockId: number|null;
    public skillRestrictions: string[]|null;

    public constructor(init?: Partial<AppointmentBookingInfoRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AppointmentBookingInfoRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<AppointmentBookingInfoResponse>(); }
}
(AppointmentBookingInfoRequest as unknown)[immerable] = true;

// @Route("/appointment/temporary/create", "POST")
export class CreateTemporaryAppointmentRequest implements IReturn<ResponseBase<CreateTemporaryAppointmentResponse>>, ILocationId
{
    public practitionerId: number|null;
    public locationId: number|null;
    public roomId: number|null;
    public startDateTime: string|null;
    public endDateTime: string|null;

    public constructor(init?: Partial<CreateTemporaryAppointmentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateTemporaryAppointmentRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CreateTemporaryAppointmentResponse>(); }
}
(CreateTemporaryAppointmentRequest as unknown)[immerable] = true;

// @Route("/appointment/temporary/update", "POST")
export class UpdateTemporaryAppointmentRequest implements IReturn<ResponseBase<T>>, ISecurityId
{
    public id: number|null;
    public startDateTime: string|null;
    public endDateTime: string|null;
    public securityId: number|null;

    public constructor(init?: Partial<UpdateTemporaryAppointmentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateTemporaryAppointmentRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(UpdateTemporaryAppointmentRequest as unknown)[immerable] = true;

// @Route("/appointment/temporary/confirm", "POST")
export class AppointmentConfirmTemporaryBookingRequest implements IReturn<ResponseBase<boolean>>, ISecurityId
{
    public id: number|null;
    public securityId: number|null;
    public customerId: number|null;
    public bookingMethod: string|null;
    public backgroundJobId: string|null;
    public treatmentAuthId: number|null;
    public groupId: number|null;

    public constructor(init?: Partial<AppointmentConfirmTemporaryBookingRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AppointmentConfirmTemporaryBookingRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(AppointmentConfirmTemporaryBookingRequest as unknown)[immerable] = true;

export class AppointmentPrepaidIncomeRequest implements IReturn<ResponseBase<AppointmentPrepaidIncomeResponse>>, ILocationId
{
    public id: number|null;
    public locationId: number|null;

    public constructor(init?: Partial<AppointmentPrepaidIncomeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AppointmentPrepaidIncomeRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<AppointmentPrepaidIncomeResponse>(); }
}
(AppointmentPrepaidIncomeRequest as unknown)[immerable] = true;

// @Route("/appointment/defaultStock")
export class GetDefaultStockRequest implements IReturn<ResponseBase<StockResponse>>, ICustomerId
{
    public practitionerId: number|null;
    public groupId: number|null;
    public customerId: number|null;
    public stockType: DefaultStockTypes|null;
    public locationId: number|null;
    public serviceTypeId: number|null;
    public forcePrivate: boolean|null;
    public skillRestrictions: string[]|null;

    public constructor(init?: Partial<GetDefaultStockRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDefaultStockRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<StockResponse>(); }
}
(GetDefaultStockRequest as unknown)[immerable] = true;

// @Route("/alert/complete/{Id}", "GET")
export class AlertCompleteRequest implements IReturn<ResponseBase<boolean>>, ISecurityLocator
{
    public id: number|null;

    public constructor(init?: Partial<AlertCompleteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AlertCompleteRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(AlertCompleteRequest as unknown)[immerable] = true;

// @Route("/alert/acknowledge", "POST")
// @Route("/alert/acknowledge/{Id}", "POST")
export class AlertAcknowledgeRequest implements IReturn<ResponseBase<boolean>>, ILocationIds
{
    public id: number|null;
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;

    public constructor(init?: Partial<AlertAcknowledgeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AlertAcknowledgeRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(AlertAcknowledgeRequest as unknown)[immerable] = true;

// @Route("/alert/forObject", "POST")
export class AlertSearchRequest implements IReturn<Alert[]>, ISecurityId, ISecurityType, IFilterServiceTypeManually, IAlertRequest
{
    public objectId: number|null;
    public discriminatorType: string|null;
    public securityId: number|null;
    public securityType: string|null;

    public constructor(init?: Partial<AlertSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AlertSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Array<Alert>(); }
}
(AlertSearchRequest as unknown)[immerable] = true;

// @Route("/alerts/clinical/flags")
export class CaseAlertFlagsRequest implements IReturn<ResponseBase<CaseAlertFlagsResponse>>
{

    public constructor(init?: Partial<CaseAlertFlagsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseAlertFlagsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<CaseAlertFlagsResponse>(); }
}
(CaseAlertFlagsRequest as unknown)[immerable] = true;

// @Route("/alerts/{Id}")
export class CaseAlertSearchRequest implements IReturn<CaseAlertSearchResponse>, ISecurityLocator, IDepartmentIds, IAlertRequest
{
    public id: number|null;
    public isPatientId: boolean|null;
    public securityId: number|null;
    public departmentIds: number[]|null;
    public securityLocator: Func<Object, IClientDbAccess, SecurityDto>|null;

    public constructor(init?: Partial<CaseAlertSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseAlertSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CaseAlertSearchResponse(); }
}
(CaseAlertSearchRequest as unknown)[immerable] = true;

// @Route("/alert/{Id}", "GET")
export class AlertGetRequest implements IReturn<AlertDialogResponse>, ILocationId, ISecurityLocator, IFilterServiceTypeManually
{
    public id: number|null;
    public locationId: number|null;
    public securityLocator: Func<Object, IClientDbAccess, SecurityDto>|null;

    public constructor(init?: Partial<AlertGetRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AlertGetRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AlertDialogResponse(); }
}
(AlertGetRequest as unknown)[immerable] = true;

// @Route("/alerts/{Id}/{DiscriminatorType}", "GET")
export class AlertsGetRequest implements IReturn<ResponseBase<AlertDialogResponse>>, ISecurityId, ISecurityType, IAlertRequest, IDepartmentIds
{
    public id: number|null;
    public discriminatorType: string|null;
    public securityId: number|null;
    public securityType: string|null;
    public departmentIds: number[]|null;

    public constructor(init?: Partial<AlertsGetRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AlertsGetRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<AlertDialogResponse>(); }
}
(AlertsGetRequest as unknown)[immerable] = true;

export class AlertsMultipleGetRequest implements IReturn<ResponseBase<AlertDialogResponse>>, IAlertRequest, IDepartmentIds
{
    public requestedAlerts: IdDescriminatorType[]|null;
    public departmentIds: number[]|null;

    public constructor(init?: Partial<AlertsMultipleGetRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AlertsMultipleGetRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<AlertDialogResponse>(); }
}
(AlertsMultipleGetRequest as unknown)[immerable] = true;

// @Route("/alert/{Id}", "PUT")
// @Route("/alert/save", "POST")
export class AlertPostRequest implements IReturn<ResponseBase<Alert>>, ILocationId, ISecurityId, ISecurityType, IAlertRequest, IFilterServiceTypeManually
{
    public id: number|null;
    public userId: number|null;
    public createdByUserId: number|null;
    public discriminatorType: string|null;
    public objectId: number|null;
    public title: string|null;
    public notes: string|null;
    public createdDateTime: string|null;
    public startDateTime: string|null;
    public requiresAcknowledgement: boolean|null;
    public complete: boolean|null;
    public expiryDateTime: string|null;
    public diaryDateTime: string|null;
    public includeInMyWork: boolean|null;
    public forYourEyesOnly: boolean|null;
    public flagType: number|null;
    public future: boolean|null;
    public alertForPerson: string|null;
    public alertForDate: string|null;
    public alertExpiryDate: string|null;
    public locationId: number|null;
    public serviceTypeId: number|null;
    public securityId: number|null;
    public securityType: string|null;

    public constructor(init?: Partial<AlertPostRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AlertPostRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<Alert>(); }
}
(AlertPostRequest as unknown)[immerable] = true;

// @Route("/alert/quickPicks", "PUT")
export class ClinicalQuickPickAlertPostRequest implements IReturn<CaseAlertSearchResponse>, ISecurityId, IFilterServiceTypeManually
{
    public quickPicks: Alert[]|null;
    public caseId: number|null;
    public alertGenre: string|null;
    public securityId: number|null;

    public constructor(init?: Partial<ClinicalQuickPickAlertPostRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClinicalQuickPickAlertPostRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new CaseAlertSearchResponse(); }
}
(ClinicalQuickPickAlertPostRequest as unknown)[immerable] = true;

export class GetAllAdvancedSearchFiltersRequest implements IReturn<ResponseBase<GetAllAdvancedSearchFiltersResponse>>
{
    public searchModule: SearchModuleEntityType|null;

    public constructor(init?: Partial<GetAllAdvancedSearchFiltersRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAllAdvancedSearchFiltersRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<GetAllAdvancedSearchFiltersResponse>(); }
}
(GetAllAdvancedSearchFiltersRequest as unknown)[immerable] = true;

export class AdvancedSearchSaveFilterRequest extends SearchFilter implements IReturn<ResponseBase<T>>
{
    public filterConditionsToSave: SearchFilterCondition[]|null;

    public constructor(init?: Partial<AdvancedSearchSaveFilterRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'AdvancedSearchSaveFilterRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(AdvancedSearchSaveFilterRequest as unknown)[immerable] = true;

export class AdvancedSearchDeleteFilterRequest implements IReturn<ResponseBase<boolean>>
{
    public id: string|null;

    public constructor(init?: Partial<AdvancedSearchDeleteFilterRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdvancedSearchDeleteFilterRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(AdvancedSearchDeleteFilterRequest as unknown)[immerable] = true;

export class GetInitialRegistrationSessionTokenRequest implements IReturn<ResponseBase<GetInitialRegistrationSessionTokenResponse>>
{
    public accountingSystemName: AccountingSystemProviderName|null;

    public constructor(init?: Partial<GetInitialRegistrationSessionTokenRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInitialRegistrationSessionTokenRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<GetInitialRegistrationSessionTokenResponse>(); }
}
(GetInitialRegistrationSessionTokenRequest as unknown)[immerable] = true;

export class DeactivateAccountingSystemRequest implements IReturn<ResponseBase<boolean>>
{

    public constructor(init?: Partial<DeactivateAccountingSystemRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeactivateAccountingSystemRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(DeactivateAccountingSystemRequest as unknown)[immerable] = true;

// @Route("/accounting/getLedgerAccountsInfo")
export class GetLedgerAccountsRequest implements IReturn<ResponseBase<LedgerAccountInfo[]>>
{

    public constructor(init?: Partial<GetLedgerAccountsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetLedgerAccountsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<LedgerAccountInfo[]>(); }
}
(GetLedgerAccountsRequest as unknown)[immerable] = true;

export class GetTaxRatesRequest implements IReturn<ResponseBase<TaxRateInfo[]>>
{

    public constructor(init?: Partial<GetTaxRatesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTaxRatesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<TaxRateInfo[]>(); }
}
(GetTaxRatesRequest as unknown)[immerable] = true;

// @Route("/accounting/getTrackingCategories")
export class GetTrackingCategories implements IReturn<ResponseBase<AccountingTrackingCategory[]>>
{

    public constructor(init?: Partial<GetTrackingCategories>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrackingCategories'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<AccountingTrackingCategory[]>(); }
}
(GetTrackingCategories as unknown)[immerable] = true;

// @Route("/accounting/updateLocationTrackingCategory")
export class UpdateLocationTrackingCategory implements IReturn<boolean>
{
    public locationId: number|null;
    public trackingCategory: string|null;

    public constructor(init?: Partial<UpdateLocationTrackingCategory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateLocationTrackingCategory'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return false; }
}
(UpdateLocationTrackingCategory as unknown)[immerable] = true;

export class GetAccountingSettingsInfoRequest implements IReturn<ResponseBase<AllAccountingConfigAndSettings>>
{

    public constructor(init?: Partial<GetAccountingSettingsInfoRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAccountingSettingsInfoRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<AllAccountingConfigAndSettings>(); }
}
(GetAccountingSettingsInfoRequest as unknown)[immerable] = true;

export class SaveAccountingSettingsInfoRequest implements IReturn<ResponseBase<AllAccountingConfigAndSettings>>
{
    public newAccountingSettings: AccountingSettingInfo|null;
    public isInitialSetup: boolean|null;
    public isReactivation: boolean|null;

    public constructor(init?: Partial<SaveAccountingSettingsInfoRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveAccountingSettingsInfoRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<AllAccountingConfigAndSettings>(); }
}
(SaveAccountingSettingsInfoRequest as unknown)[immerable] = true;

export class SyncPaymentUpdateFromXeroManuallyRequest implements IReturn<ResponseBase<IncomingAccountingPaymentResponse>>
{
    public paymentId: number|null;

    public constructor(init?: Partial<SyncPaymentUpdateFromXeroManuallyRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SyncPaymentUpdateFromXeroManuallyRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<IncomingAccountingPaymentResponse>(); }
}
(SyncPaymentUpdateFromXeroManuallyRequest as unknown)[immerable] = true;

export class AccountingApiSyncHistorySearchRequest extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<T>>
{
    public invoiceId: number|null;
    public paymentId: number|null;
    public status: string|null;

    public constructor(init?: Partial<AccountingApiSyncHistorySearchRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'AccountingApiSyncHistorySearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(AccountingApiSyncHistorySearchRequest as unknown)[immerable] = true;

export class GetAccountingApiSyncHistoryRequest implements IReturn<ResponseBase<T>>
{
    public id: number|null;

    public constructor(init?: Partial<GetAccountingApiSyncHistoryRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAccountingApiSyncHistoryRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(GetAccountingApiSyncHistoryRequest as unknown)[immerable] = true;

// @Route("/accounting/cacheApiDeckRequests", "POST")
export class CacheApiDeckRequest implements IReturn<ResponseBase<boolean>>
{

    public constructor(init?: Partial<CacheApiDeckRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CacheApiDeckRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(CacheApiDeckRequest as unknown)[immerable] = true;

// @Route("/oauth/start", "GET")
export class OAuthInitiateRequest implements IReturnVoid
{

    public constructor(init?: Partial<OAuthInitiateRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OAuthInitiateRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(OAuthInitiateRequest as unknown)[immerable] = true;

// @Route("/oauth/callback", "GET")
export class OAuthCallbackRequest implements IReturn<OAuthCallbackResponse>
{
    public code: string|null;
    public state: string|null;

    public constructor(init?: Partial<OAuthCallbackRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OAuthCallbackRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new OAuthCallbackResponse(); }
}
(OAuthCallbackRequest as unknown)[immerable] = true;

// @Route("/sys/config/all")
export class SysConfigRequest implements IReturn<ResponseBase<{ [index:string]: string; }>>
{

    public constructor(init?: Partial<SysConfigRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SysConfigRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<{ [index:string]: string; }>(); }
}
(SysConfigRequest as unknown)[immerable] = true;

// @Route("/sys/config/update")
export class ConfigUpdate implements IReturn<ResponseBase<{ [index:string]: string; }>>
{
    public id: number|null;
    public description: string|null;
    public value: string|null;

    public constructor(init?: Partial<ConfigUpdate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ConfigUpdate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<{ [index:string]: string; }>(); }
}
(ConfigUpdate as unknown)[immerable] = true;

export class BatchConfigUpdates implements IReturn<ResponseBase<{ [index:string]: string; }>>
{
    public updates: ConfigUpdate[]|null;

    public constructor(init?: Partial<BatchConfigUpdates>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BatchConfigUpdates'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<{ [index:string]: string; }>(); }
}
(BatchConfigUpdates as unknown)[immerable] = true;

// @Route("/test/error")
export class TestError
{

    public constructor(init?: Partial<TestError>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TestError'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(TestError as unknown)[immerable] = true;

// @Route("/locale")
export class LocaleRequest
{

    public constructor(init?: Partial<LocaleRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LocaleRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(LocaleRequest as unknown)[immerable] = true;

// @Route("/loginMode")
export class LoginModeRequest
{

    public constructor(init?: Partial<LoginModeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LoginModeRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(LoginModeRequest as unknown)[immerable] = true;

// @Route("/sys/config/features")
export class FeatureRequest implements IReturn<ResponseBase<{ [index:string]: string; }>>
{

    public constructor(init?: Partial<FeatureRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FeatureRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<{ [index:string]: string; }>(); }
}
(FeatureRequest as unknown)[immerable] = true;

export class GetPhioConfigRequest implements IReturn<ResponseBase<PhioConfigResponse>>
{

    public constructor(init?: Partial<GetPhioConfigRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPhioConfigRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<PhioConfigResponse>(); }
}
(GetPhioConfigRequest as unknown)[immerable] = true;

export class GetMediPassApiKeyRequest implements IReturn<ResponseBase<string>>
{

    public constructor(init?: Partial<GetMediPassApiKeyRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMediPassApiKeyRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<string>(); }
}
(GetMediPassApiKeyRequest as unknown)[immerable] = true;

// @Route("/healthz")
// @Route("/healthz/{clientId}")
export class HeartbeatRequest implements IReturn<ResponseBase<boolean>>
{
    public clientId: number|null;

    public constructor(init?: Partial<HeartbeatRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'HeartbeatRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(HeartbeatRequest as unknown)[immerable] = true;

export class GetSubscriptionRequest implements IReturn<ResponseBase<SubscriptionResponse>>
{
    public id: number|null;

    public constructor(init?: Partial<GetSubscriptionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSubscriptionRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<SubscriptionResponse>(); }
}
(GetSubscriptionRequest as unknown)[immerable] = true;

export class GetSubscriptionHistoryRequest implements IReturn<ResponseBase<SubscriptionHistoryResponse>>
{
    public id: number|null;

    public constructor(init?: Partial<GetSubscriptionHistoryRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSubscriptionHistoryRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<SubscriptionHistoryResponse>(); }
}
(GetSubscriptionHistoryRequest as unknown)[immerable] = true;

export class SubscriptionSearchRequest extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<SubscriptionResponse>>
{
    public id: number|null;
    public customerId: number|null;
    public invoiceStatus: string|null;
    public status: SubscriptionStatus|null;
    public amount: CurrencyRange|null;
    public lastRunOn: DateRange|null;
    public nextDue: DateRange|null;
    public startDate: DateRange|null;
    public expiryDate: DateRange|null;

    public constructor(init?: Partial<SubscriptionSearchRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SubscriptionSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<SubscriptionResponse>(); }
}
(SubscriptionSearchRequest as unknown)[immerable] = true;

export class CreateSubscriptionRequest implements IReturn<ResponseBase<SubscriptionResponse>>, ILocationId
{
    public customer: CustomerSaveRequest|null;
    public locationId: number|null;
    public practitionerId: number|null;
    public packageId: string|null;
    public startDate: string|null;
    public billingMode: SubscriptionBillingMode|null;
    public paymentMode: SubscriptionPaymentMode|null;
    public paymentMethod: SubscriptionPaymentMethod|null;
    public paymentMethodOther: string|null;
    public terminalPayment: TerminalPaymentDto|null;

    public constructor(init?: Partial<CreateSubscriptionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateSubscriptionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<SubscriptionResponse>(); }
}
(CreateSubscriptionRequest as unknown)[immerable] = true;

export class UpdateSubscriptionRequest implements IReturn<ResponseBase<SubscriptionResponse>>
{
    public id: number|null;
    public status: SubscriptionStatus|null;
    public startDate: string|null;
    public expiryDate: string|null;
    public name: string|null;
    public packageId: string|null;
    public totalExVat: number|null;
    public vatRate: number|null;
    public totalIncVat: number|null;
    public locationId: number|null;
    public practitionerId: number|null;
    public nextDue: string|null;
    public subscriptionInterval: number|null;
    public subscriptionIntervalUnit: SubscriptionRecurrenceInterval|null;
    public earliestAllowedCancellationDate: string|null;
    public bundles: PackageBundleResponse[]|null;

    public constructor(init?: Partial<UpdateSubscriptionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateSubscriptionRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<SubscriptionResponse>(); }
}
(UpdateSubscriptionRequest as unknown)[immerable] = true;

// @Route("/apple-developer-merchantid-domain-association")
export class SquareApplePayVerificationFileRequest implements IReturn<HttpResult>
{

    public constructor(init?: Partial<SquareApplePayVerificationFileRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SquareApplePayVerificationFileRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new HttpResult(); }
}
(SquareApplePayVerificationFileRequest as unknown)[immerable] = true;

// @Route("/square/redirect", "GET")
export class SquareRedirectRequest implements IReturn<HttpResult>
{
    public state: string|null;
    public code: string|null;
    public error: string|null;
    public error_Description: string|null;

    public constructor(init?: Partial<SquareRedirectRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SquareRedirectRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new HttpResult(); }
}
(SquareRedirectRequest as unknown)[immerable] = true;

export class SquareSaveStateRequest implements IReturn<ResponseBase<T>>
{
    public state: string|null;

    public constructor(init?: Partial<SquareSaveStateRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SquareSaveStateRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(SquareSaveStateRequest as unknown)[immerable] = true;

export class SquareIntegrationRequest implements IReturn<ResponseBase<SquareOAuthResponse>>
{
    public state: string|null;

    public constructor(init?: Partial<SquareIntegrationRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SquareIntegrationRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<SquareOAuthResponse>(); }
}
(SquareIntegrationRequest as unknown)[immerable] = true;

export class SquareDeAuthRequest implements IReturn<ResponseBase<SquareOAuthResponse>>
{

    public constructor(init?: Partial<SquareDeAuthRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SquareDeAuthRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<SquareOAuthResponse>(); }
}
(SquareDeAuthRequest as unknown)[immerable] = true;

export class SquareGetOAuthPermissionsRequest implements IReturn<ResponseBase<SquareOAuthPermissionsResponse>>
{

    public constructor(init?: Partial<SquareGetOAuthPermissionsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SquareGetOAuthPermissionsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<SquareOAuthPermissionsResponse>(); }
}
(SquareGetOAuthPermissionsRequest as unknown)[immerable] = true;

export class BasicCardDetailsRequest implements IReturn<ResponseBase<BasicCardDetailsResponse>>
{
    public customerId: number|null;

    public constructor(init?: Partial<BasicCardDetailsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BasicCardDetailsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<BasicCardDetailsResponse>(); }
}
(BasicCardDetailsRequest as unknown)[immerable] = true;

export class FullCardDetailsRequest implements IReturn<ResponseBase<FullCardDetailsResponse>>
{
    public customerId: number|null;

    public constructor(init?: Partial<FullCardDetailsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FullCardDetailsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<FullCardDetailsResponse>(); }
}
(FullCardDetailsRequest as unknown)[immerable] = true;

export class DeleteCardDetailsRequest implements IReturn<ResponseBase<DeleteCardDetailsResponse>>
{
    public customerId: number|null;

    public constructor(init?: Partial<DeleteCardDetailsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteCardDetailsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<DeleteCardDetailsResponse>(); }
}
(DeleteCardDetailsRequest as unknown)[immerable] = true;

export class GetPackageRequest implements IReturn<ResponseBase<PackageResponse>>
{
    public packageId: string|null;

    public constructor(init?: Partial<GetPackageRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPackageRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<PackageResponse>(); }
}
(GetPackageRequest as unknown)[immerable] = true;

export class PackagesSearchRequest implements IReturn<ResponseBase<PackageResponse>>
{
    public term: string|null;
    public includeNonCurrent: boolean|null;

    public constructor(init?: Partial<PackagesSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PackagesSearchRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<PackageResponse>(); }
}
(PackagesSearchRequest as unknown)[immerable] = true;

export class SavePackageRequest implements IReturn<ResponseBase<PackageResponse>>, IDepartmentIds, ILocationIds
{
    public id: number|null;
    public reference: string|null;
    public totalPrice: number|null;
    public description: string|null;
    public appointmentLength: number|null;
    public groupLocationLocationId: number|null;
    public locationId: number|null;
    public colour: number|null;
    public online: boolean|null;
    public onlineGuid: string|null;
    public inUse: boolean|null;
    public priceExVAT: number|null;
    public vatRate: number|null;
    public vatAmount: number|null;
    public costAmount: number|null;
    public costVATRate: number|null;
    public costExVAT: number|null;
    public costVATAmount: number|null;
    public longDescription: string|null;
    public ledgerCode: string|null;
    public ledgerCodeOverrides: AccountingStockLedgerLookup[]|null;
    public legderCodeAccountId: string|null;
    public category: string|null;
    public level: number|null;
    public minimumLevel: number|null;
    public displayInPriceList: boolean|null;
    public totalWorth: number|null;
    public supplierId: number|null;
    public serviceTypeId: number|null;
    public isPrivateCharge: boolean|null;
    public stockIsCancel: boolean|null;
    public stockIsFirst: boolean|null;
    public stockIsFollowUp: boolean|null;
    public stockIsDNA: boolean|null;
    public isMultiple: boolean|null;
    public groupName: string|null;
    public overrides: StockOverrideResponse[]|null;
    public validForDaysFromPurchase: number|null;
    public isSubscriptionType: boolean|null;
    public subscriptionInterval: number|null;
    public subscriptionIntervalUnit: SubscriptionRecurrenceInterval|null;
    public hasMinimumTerm: boolean|null;
    public minimumTermValue: number|null;
    public minimumTermInterval: number|null;
    public minimumTermIntervalUnit: SubscriptionRecurrenceInterval|null;
    public hasMaximumTerm: boolean|null;
    public maximumTermValue: number|null;
    public maximumTermInterval: number|null;
    public maximumTermIntervalUnit: SubscriptionRecurrenceInterval|null;
    public onePerCustomer: boolean|null;
    public newCustomersOnly: boolean|null;
    public allowDiscountCodes: boolean|null;
    public hasValidityPeriod: boolean|null;
    public validFrom: string|null;
    public validTo: string|null;
    public termsAndConditionsFormId: string|null;
    public updateExistingSubscriptionsToUseNewBundles: boolean|null;
    public bundles: PackageBundleResponse[]|null;
    public departmentIds: number[]|null;
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;
    public colourCss: string|null;
    public urlSlug: string|null;
    public imageName: string|null;
    public isCloning: boolean|null;
    public expirationValue: number|null;
    public quantityThreshold: number|null;
    public creditAmount: number|null;
    public excludedStockItemIds: number[]|null;
    public excludedClassTypeIds: number[]|null;
    public packageType: PackageType|null;
    public restrictToPrivateCharges: boolean|null;

    public constructor(init?: Partial<SavePackageRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SavePackageRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<PackageResponse>(); }
}
(SavePackageRequest as unknown)[immerable] = true;

export class MyDiaryRequest implements IReturn<ResponseBase<MyDiaryResponse>>
{
    public subWorkflowId: number|null;

    public constructor(init?: Partial<MyDiaryRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MyDiaryRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<MyDiaryResponse>(); }
}
(MyDiaryRequest as unknown)[immerable] = true;

export class OnlineGetExistingWaitingListsForCustomer implements IReturn<ResponseBase<WaitingListResponse>>
{
    public patientId: number|null;

    public constructor(init?: Partial<OnlineGetExistingWaitingListsForCustomer>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineGetExistingWaitingListsForCustomer'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<WaitingListResponse>(); }
}
(OnlineGetExistingWaitingListsForCustomer as unknown)[immerable] = true;

// @Route("/diary/waiting-lists/save", "POST")
export class SaveWaitingListRequest extends WaitingList implements IReturn<ResponseBase<boolean>>
{
    public days: number[]|null;
    public customer: CustomerSaveRequest|null;

    public constructor(init?: Partial<SaveWaitingListRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveWaitingListRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(SaveWaitingListRequest as unknown)[immerable] = true;

// @Route("/diary/waiting-lists/save", "POST")
export class OnlineSaveWaitingListRequest extends SaveWaitingListRequest implements IReturn<ResponseBase<boolean>>
{

    public constructor(init?: Partial<OnlineSaveWaitingListRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineSaveWaitingListRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(OnlineSaveWaitingListRequest as unknown)[immerable] = true;

// @Route("/diary/waiting-list/{Id}", "DELETE")
export class DeleteWaitingListRequest implements IReturn<ResponseBase<boolean>>
{
    public id: number|null;

    public constructor(init?: Partial<DeleteWaitingListRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteWaitingListRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(DeleteWaitingListRequest as unknown)[immerable] = true;

// @Route("/diary/waiting-list/{Id}", "DELETE")
export class OnlineDeleteWaitingListRequest extends DeleteWaitingListRequest implements IReturn<ResponseBase<boolean>>
{

    public constructor(init?: Partial<OnlineDeleteWaitingListRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineDeleteWaitingListRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(OnlineDeleteWaitingListRequest as unknown)[immerable] = true;

export class AppointmentConfirmRequest implements IReturn<ResponseBase<AppointmentSummary>>, IPut
{
    public selectedAppointment: AppointmentSearchResult|null;
    public offeredAppointment: AppointmentSearchResult|null;
    public customer: OnlineCustomerDto|null;
    public id: string|null;
    public prepaymentId: number|null;
    public usePrepayment: boolean|null;
    public paymentType: PaymentMode|null;
    public packageId: string|null;
    public stockId: string|null;
    public serviceId: string|null;
    public discountCodeId: string|null;
    public takePaymentRequest: TakePaymentRequest|null;
    public metadata: JsonField|null;
    public appointmentType: AppointmentType|null;
    public isFollowUp: boolean|null;
    public overrideProductServiceId: string|null;
    public workflowId: number|null;

    public constructor(init?: Partial<AppointmentConfirmRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AppointmentConfirmRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<AppointmentSummary>(); }
}
(AppointmentConfirmRequest as unknown)[immerable] = true;

export class OnlinePatientFormsRequest implements IReturn<ResponseBase<OnlinePatientFormResponse>>
{

    public constructor(init?: Partial<OnlinePatientFormsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlinePatientFormsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<OnlinePatientFormResponse>(); }
}
(OnlinePatientFormsRequest as unknown)[immerable] = true;

export class OnlineStripeDeleteCardRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<OnlineStripeDeleteCardRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineStripeDeleteCardRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(OnlineStripeDeleteCardRequest as unknown)[immerable] = true;

export class OnlineGetCardDetailsRequest implements IReturn<ResponseBase<CardDetails>>
{

    public constructor(init?: Partial<OnlineGetCardDetailsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineGetCardDetailsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<CardDetails>(); }
}
(OnlineGetCardDetailsRequest as unknown)[immerable] = true;

export class OnlineCancelBookingRequest implements IReturn<ResponseBase<boolean>>
{
    public appointmentId: number|null;
    public classAttendanceId: number|null;
    public cancellationReason: string|null;
    public payFee: boolean|null;
    public takePaymentRequest: TakePaymentRequest|null;

    public constructor(init?: Partial<OnlineCancelBookingRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineCancelBookingRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(OnlineCancelBookingRequest as unknown)[immerable] = true;

export class OnlineCancellationOptionsRequest implements IReturn<ResponseBase<OnlineCancellationOptionsResponse>>
{
    public appointmentId: number|null;
    public classAttendanceId: number|null;

    public constructor(init?: Partial<OnlineCancellationOptionsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineCancellationOptionsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<OnlineCancellationOptionsResponse>(); }
}
(OnlineCancellationOptionsRequest as unknown)[immerable] = true;

// @Route("/invoices/{CustomerId}", "GET")
export class OnlineInvoiceListRequest implements IReturn<ResponseBase<T>>
{
    public customerId: number|null;

    public constructor(init?: Partial<OnlineInvoiceListRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineInvoiceListRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(OnlineInvoiceListRequest as unknown)[immerable] = true;

// @Route("/invoice/download/{InvoiceId}")
// @Route("/receipt/download/{IncomeId}")
export class OnlineInvoiceDownloadRequest implements IReturn<HttpResult>
{
    public invoiceId: number|null;
    public incomeId: number|null;

    public constructor(init?: Partial<OnlineInvoiceDownloadRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineInvoiceDownloadRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new HttpResult(); }
}
(OnlineInvoiceDownloadRequest as unknown)[immerable] = true;

export class OnlineGetPaymentDetailsRequest implements IReturn<ResponseBase<OnlinePaymentDetailsResponse>>
{
    public stockId: string|null;
    public classTypeId: number|null;
    public courseTypeId: number|null;

    public constructor(init?: Partial<OnlineGetPaymentDetailsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineGetPaymentDetailsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<OnlinePaymentDetailsResponse>(); }
}
(OnlineGetPaymentDetailsRequest as unknown)[immerable] = true;

// @Route("/packages/list", "GET")
export class OnlineCustomerPackageRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<OnlineCustomerPackageRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineCustomerPackageRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(OnlineCustomerPackageRequest as unknown)[immerable] = true;

export class BuyPackageRequest implements IReturn<ResponseBase<T>>
{
    public packageId: string|null;
    public isSubscription: boolean|null;
    public saveCard: boolean|null;
    public isConnectCustomer: boolean|null;
    public takePaymentRequest: TakePaymentRequest|null;

    public constructor(init?: Partial<BuyPackageRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BuyPackageRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(BuyPackageRequest as unknown)[immerable] = true;

export class OnlinePasswordChangeRequest implements IReturn<ResponseBase<T>>
{
    public oldPassword: string|null;
    public newPassword: string|null;
    public passwordScore: number|null;

    public constructor(init?: Partial<OnlinePasswordChangeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlinePasswordChangeRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(OnlinePasswordChangeRequest as unknown)[immerable] = true;

export class OnlineUpdateSubscriptionRequest implements IReturn<ResponseBase<T>>
{
    public id: number|null;
    public status: SubscriptionStatus|null;

    public constructor(init?: Partial<OnlineUpdateSubscriptionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineUpdateSubscriptionRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(OnlineUpdateSubscriptionRequest as unknown)[immerable] = true;

export class GetAppointmentLocationsRequest implements IReturn<ResponseBase<T>>
{
    public serviceId: string|null;
    public overrideProductServiceId: string|null;
    public stockId: string|null;
    public locationId: string|null;

    public constructor(init?: Partial<GetAppointmentLocationsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAppointmentLocationsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(GetAppointmentLocationsRequest as unknown)[immerable] = true;

export class GetAuthAppointmentLocationsRequest extends GetAppointmentLocationsRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<GetAuthAppointmentLocationsRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAuthAppointmentLocationsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(GetAuthAppointmentLocationsRequest as unknown)[immerable] = true;

export class OnlineCaseflowFormRequest implements IReturn<ResponseBase<T>>
{
    public productId: string|null;

    public constructor(init?: Partial<OnlineCaseflowFormRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineCaseflowFormRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(OnlineCaseflowFormRequest as unknown)[immerable] = true;

export class OnlineCaseflowContactRoleRequest implements IReturn<ResponseBase<OnlineRole>>
{

    public constructor(init?: Partial<OnlineCaseflowContactRoleRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineCaseflowContactRoleRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<OnlineRole>(); }
}
(OnlineCaseflowContactRoleRequest as unknown)[immerable] = true;

export class OnlineCaseflowContactSearch implements IReturn<ResponseBase<OnlineCaseflowContact>>
{
    public skip: number|null;
    public take: number|null;
    public term: string|null;

    public constructor(init?: Partial<OnlineCaseflowContactSearch>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineCaseflowContactSearch'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<OnlineCaseflowContact>(); }
}
(OnlineCaseflowContactSearch as unknown)[immerable] = true;

export class ValidateDiscountCode implements IReturn<ResponseBase<DiscountCodeDto>>
{
    public discountCodeId: string|null;
    public code: string|null;
    public appointmentDate: string|null;
    public getInUseFlag: boolean|null;
    public enableForConnect: boolean|null;
    public stockId: string|null;
    public sessionCount: number|null;

    public constructor(init?: Partial<ValidateDiscountCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateDiscountCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<DiscountCodeDto>(); }
}
(ValidateDiscountCode as unknown)[immerable] = true;

export class OnlineSettingsRequest implements IReturn<OnlineSettingsResponse>
{
    public businessId: number|null;

    public constructor(init?: Partial<OnlineSettingsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineSettingsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new OnlineSettingsResponse(); }
}
(OnlineSettingsRequest as unknown)[immerable] = true;

export class OnlineCurrentUserRequest implements IReturn<ResponseBase<CurrentUser>>
{

    public constructor(init?: Partial<OnlineCurrentUserRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineCurrentUserRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<CurrentUser>(); }
}
(OnlineCurrentUserRequest as unknown)[immerable] = true;

export class OnlineInitialRequest implements IReturn<ResponseBase<OnlineInitialResponse>>
{

    public constructor(init?: Partial<OnlineInitialRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineInitialRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<OnlineInitialResponse>(); }
}
(OnlineInitialRequest as unknown)[immerable] = true;

export class ConnectValidateBusinessRouteRequest implements IReturn<ResponseBase<BusinessCategoryResponse>>
{
    public url: string|null;

    public constructor(init?: Partial<ConnectValidateBusinessRouteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ConnectValidateBusinessRouteRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<BusinessCategoryResponse>(); }
}
(ConnectValidateBusinessRouteRequest as unknown)[immerable] = true;

export class ConnectValidateAccessCodeRequest implements IReturn<ResponseBase<boolean>>
{
    public serviceId: string|null;
    public accessCode: string|null;

    public constructor(init?: Partial<ConnectValidateAccessCodeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ConnectValidateAccessCodeRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ConnectValidateAccessCodeRequest as unknown)[immerable] = true;

// @Route("/availablity/sessions", "POST")
export class GetOnlineSessions implements IReturn<ResponseBase<AvailabilitySession>>
{
    public from: string|null;
    public to: string|null;
    public locationId: string|null;

    public constructor(init?: Partial<GetOnlineSessions>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetOnlineSessions'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<AvailabilitySession>(); }
}
(GetOnlineSessions as unknown)[immerable] = true;

export class GetLocationOverridesRequest implements IReturn<ResponseBase<T>>
{
    public stockId: string|null;

    public constructor(init?: Partial<GetLocationOverridesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetLocationOverridesRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(GetLocationOverridesRequest as unknown)[immerable] = true;

export class GetCaseflowNetworkLocationsRequest extends GetAppointmentLocationsRequest implements IReturn<ResponseBase<T>>
{
    public latLong: string|null;
    public postCode: string|null;
    public skip: number|null;
    public take: number|null;

    public constructor(init?: Partial<GetCaseflowNetworkLocationsRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCaseflowNetworkLocationsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(GetCaseflowNetworkLocationsRequest as unknown)[immerable] = true;

export class GetOnlineDistinctAppointmentRequest implements IReturn<AppointmentSearchResponse>
{
    public from: string|null;
    public to: string|null;
    public appointmentLength: number|null;
    public locationIds: string[]|null;
    public serviceId: string|null;
    public stockId: string|null;
    public allowPast: boolean|null;
    public overrideProductServiceId: string|null;
    public isFollowUp: boolean|null;

    public constructor(init?: Partial<GetOnlineDistinctAppointmentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetOnlineDistinctAppointmentRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AppointmentSearchResponse(); }
}
(GetOnlineDistinctAppointmentRequest as unknown)[immerable] = true;

export class BookTempAppointmentRequest implements IReturn<ReserveAppointmentResponse>
{
    public practitionerGuid: string|null;
    public locationGuid: string|null;
    public roomId: number|null;
    public startDateTime: string|null;
    public endDateTime: string|null;
    public stockId: string|null;
    public serviceId: string|null;
    public appointmentType: AppointmentType|null;

    public constructor(init?: Partial<BookTempAppointmentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BookTempAppointmentRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ReserveAppointmentResponse(); }
}
(BookTempAppointmentRequest as unknown)[immerable] = true;

export class OnlineDeleteReservationRequest
{
    public appointmentId: number|null;

    public constructor(init?: Partial<OnlineDeleteReservationRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineDeleteReservationRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(OnlineDeleteReservationRequest as unknown)[immerable] = true;

export class GetUserByEmailOrMobile implements IReturn<ResponseBase<GetUserByEmailOrMobileResponse>>
{
    public term: string|null;
    public businessId: number|null;

    public constructor(init?: Partial<GetUserByEmailOrMobile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetUserByEmailOrMobile'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<GetUserByEmailOrMobileResponse>(); }
}
(GetUserByEmailOrMobile as unknown)[immerable] = true;

export class OnlineResetRequest implements IReturn<ResponseBase<boolean>>
{
    public userName: string|null;
    public recaptcha: string|null;

    public constructor(init?: Partial<OnlineResetRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineResetRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(OnlineResetRequest as unknown)[immerable] = true;

export class OnlineChangePasswordByReset implements IReturn<CurrentUser>
{
    public resetCode: string|null;
    public newPassword: string|null;
    public score: number|null;

    public constructor(init?: Partial<OnlineChangePasswordByReset>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineChangePasswordByReset'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CurrentUser(); }
}
(OnlineChangePasswordByReset as unknown)[immerable] = true;

export class OnlineLogoutRequest implements IReturn<ResponseBase<boolean>>
{

    public constructor(init?: Partial<OnlineLogoutRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineLogoutRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(OnlineLogoutRequest as unknown)[immerable] = true;

export class OnlineVerifyRequest implements IReturn<ResponseBase<OnlineCustomerDto>>
{
    public code: string|null;

    public constructor(init?: Partial<OnlineVerifyRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineVerifyRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<OnlineCustomerDto>(); }
}
(OnlineVerifyRequest as unknown)[immerable] = true;

export class OnlineRegisterRequest extends OnlineCustomerDto implements IReturn<ResponseBase<boolean>>
{
    public newPassword: string|null;
    public passwordScore: number|null;
    public givenConsent: boolean|null;
    public recaptcha: string|null;

    public constructor(init?: Partial<OnlineRegisterRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineRegisterRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(OnlineRegisterRequest as unknown)[immerable] = true;

export class OnlineRegisterValidationRequest implements IReturn<ResponseBase<OnlineRegisterValidationResponse>>
{
    public email: string|null;
    public mobileNumber: string|null;
    public businessId: number|null;

    public constructor(init?: Partial<OnlineRegisterValidationRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineRegisterValidationRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<OnlineRegisterValidationResponse>(); }
}
(OnlineRegisterValidationRequest as unknown)[immerable] = true;

// @Route("/online/files/bykey")
// @Route("/online/files/bykey/{Key}")
export class OnlineFileByKeyRequest implements IReturn<HttpResult>
{
    public key: string|null;

    public constructor(init?: Partial<OnlineFileByKeyRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineFileByKeyRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new HttpResult(); }
}
(OnlineFileByKeyRequest as unknown)[immerable] = true;

// @Route("/online/files/bypath/{Path}")
export class OnlineFileByPathRequest implements IReturn<HttpResult>
{
    public path: string|null;

    public constructor(init?: Partial<OnlineFileByPathRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineFileByPathRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new HttpResult(); }
}
(OnlineFileByPathRequest as unknown)[immerable] = true;

export class OnlineContentByKeyRequest implements IReturn<ResponseBase<string>>
{
    public key: string|null;

    public constructor(init?: Partial<OnlineContentByKeyRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineContentByKeyRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<string>(); }
}
(OnlineContentByKeyRequest as unknown)[immerable] = true;

export class AppointmentPaymentDetailsRequest implements IReturn<ResponseEnhancerBase<OnlinePaymentDetailsResponse>>
{
    public appointmentId: number|null;
    public totalPrice: number|null;

    public constructor(init?: Partial<AppointmentPaymentDetailsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AppointmentPaymentDetailsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseEnhancerBase<OnlinePaymentDetailsResponse>(); }
}
(AppointmentPaymentDetailsRequest as unknown)[immerable] = true;

export class OnlinePatientFormRequest implements IReturn<ResponseBase<OnlinePatientFormResponse>>
{
    public id: string|null;

    public constructor(init?: Partial<OnlinePatientFormRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlinePatientFormRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<OnlinePatientFormResponse>(); }
}
(OnlinePatientFormRequest as unknown)[immerable] = true;

export class OnlinePatientFormSubmit implements IReturn<ResponseBase<boolean>>
{
    public id: string|null;
    public reportData: string|null;
    public isDraft: boolean|null;
    public updates: Update[]|null;

    public constructor(init?: Partial<OnlinePatientFormSubmit>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlinePatientFormSubmit'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(OnlinePatientFormSubmit as unknown)[immerable] = true;

export class GetOnlineWaitingListReservedRequest implements IReturn<ResponseBase<OnlineWaitingListReservationConfirmResponse>>
{
    public waitingListGlobalId: string|null;

    public constructor(init?: Partial<GetOnlineWaitingListReservedRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetOnlineWaitingListReservedRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<OnlineWaitingListReservationConfirmResponse>(); }
}
(GetOnlineWaitingListReservedRequest as unknown)[immerable] = true;

export class ActionWaitingListReserveRequest implements IReturn<ResponseBase<boolean>>
{
    public waitingListGlobalId: string|null;
    public waitingListStatus: WaitingListStatus|null;
    public subStatus: WaitingListSubStatus|null;
    public notificationType: WaitingListNotificationType|null;
    public pauseUntilDateTime: string|null;
    public takePaymentRequest: TakePaymentRequest|null;
    public paymentType: number|null;
    public packageId: string|null;
    public discountCodeId: string|null;

    public constructor(init?: Partial<ActionWaitingListReserveRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ActionWaitingListReserveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ActionWaitingListReserveRequest as unknown)[immerable] = true;

export class OnlineSiteRequest implements IReturn<ResponseBase<boolean>>
{

    public constructor(init?: Partial<OnlineSiteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineSiteRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(OnlineSiteRequest as unknown)[immerable] = true;

export class GetChasedPaymentRequest implements IReturn<ResponseBase<ChasedPaymentDTO>>
{
    public id: string|null;

    public constructor(init?: Partial<GetChasedPaymentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetChasedPaymentRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ChasedPaymentDTO>(); }
}
(GetChasedPaymentRequest as unknown)[immerable] = true;

export class GetSquareCustomerDetailsRequest implements IReturn<ResponseBase<GetSquareCustomerDetailsResponse>>
{
    public customerId: number|null;

    public constructor(init?: Partial<GetSquareCustomerDetailsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSquareCustomerDetailsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<GetSquareCustomerDetailsResponse>(); }
}
(GetSquareCustomerDetailsRequest as unknown)[immerable] = true;

export class PayChasedPaymentRequest implements IReturn<ResponseBase<T>>
{
    public chaseSlug: string|null;
    public saveCard: boolean|null;
    public cardDetails: CardDetails|null;
    public takePaymentRequest: TakePaymentRequest|null;

    public constructor(init?: Partial<PayChasedPaymentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PayChasedPaymentRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(PayChasedPaymentRequest as unknown)[immerable] = true;

export class IsTwoFactorAuthRequired implements IReturn<boolean>
{
    public token: string|null;

    public constructor(init?: Partial<IsTwoFactorAuthRequired>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'IsTwoFactorAuthRequired'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return false; }
}
(IsTwoFactorAuthRequired as unknown)[immerable] = true;

export class OnlineAutoLoginCodeRequest implements IReturn<boolean>
{
    public token: string|null;

    public constructor(init?: Partial<OnlineAutoLoginCodeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineAutoLoginCodeRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return false; }
}
(OnlineAutoLoginCodeRequest as unknown)[immerable] = true;

export class OnlineAutoLoginVerifyCodeRequest implements IReturn<OnlineAutoLoginVerifyCodeResponse>
{
    public token: string|null;
    public accessCode: string|null;
    public password: string|null;

    public constructor(init?: Partial<OnlineAutoLoginVerifyCodeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineAutoLoginVerifyCodeRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new OnlineAutoLoginVerifyCodeResponse(); }
}
(OnlineAutoLoginVerifyCodeRequest as unknown)[immerable] = true;

export class OnlineRequestAccessCodeRequest implements IReturn<boolean>
{
    public email: string|null;
    public phoneNumber: string|null;

    public constructor(init?: Partial<OnlineRequestAccessCodeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineRequestAccessCodeRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return false; }
}
(OnlineRequestAccessCodeRequest as unknown)[immerable] = true;

export class ConnectFeatureFlagsRequest implements IReturn<ResponseBase<{ [index:string]: string; }>>
{

    public constructor(init?: Partial<ConnectFeatureFlagsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ConnectFeatureFlagsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<{ [index:string]: string; }>(); }
}
(ConnectFeatureFlagsRequest as unknown)[immerable] = true;

export class UsedLicenseRequest implements IReturn<ResponseBase<number>>
{

    public constructor(init?: Partial<UsedLicenseRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UsedLicenseRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<number>(); }
}
(UsedLicenseRequest as unknown)[immerable] = true;

export class MsInvoicesRequest implements IReturn<ResponseBase<MsInvoiceResponse>>
{
    public skip: number|null;
    public take: number|null;

    public constructor(init?: Partial<MsInvoicesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MsInvoicesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<MsInvoiceResponse>(); }
}
(MsInvoicesRequest as unknown)[immerable] = true;

export class MsInvoiceRequest implements IReturn<ResponseBase<MsInvoiceResponse>>
{
    public invoiceId: number|null;

    public constructor(init?: Partial<MsInvoiceRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MsInvoiceRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<MsInvoiceResponse>(); }
}
(MsInvoiceRequest as unknown)[immerable] = true;

export class CurrentLicenceQuoteRequest implements IReturn<ResponseBase<Tm3License>>
{

    public constructor(init?: Partial<CurrentLicenceQuoteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CurrentLicenceQuoteRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<Tm3License>(); }
}
(CurrentLicenceQuoteRequest as unknown)[immerable] = true;

export class MsClientResponse implements IReturn<ResponseBase<MsClientResponse>>
{
    public reference: string|null;
    public forename: string|null;
    public title: string|null;
    public surname: string|null;
    public email: string|null;
    public homeTelephone: string|null;
    public addressLine1: string|null;
    public addressLine2: string|null;
    public addressLine3: string|null;
    public addressLine4: string|null;
    public postCode: string|null;
    public invoiceAddressLine1: string|null;
    public invoiceAddressLine2: string|null;
    public invoiceAddressLine3: string|null;
    public invoiceAddressLine4: string|null;
    public invoicePostCode: string|null;
    public accountHolders: MsContact[]|null;
    public accountEmails: MsContact[]|null;
    public supportEmails: MsContact[]|null;
    public bzAccountManager: string|null;
    public bzAccountManagerEmail: string|null;
    public bzAccountManagerTelephone: string|null;
    public subscriptionMonthly: number|null;
    public subscriptionAnnual: number|null;
    public returnEmail: string|null;
    public useSMSCredits: boolean|null;
    public useSystemCredits: boolean|null;
    public locationID: number|null;

    public constructor(init?: Partial<MsClientResponse>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MsClientResponse'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<MsClientResponse>(); }
}
(MsClientResponse as unknown)[immerable] = true;

export class MsClientRequest implements IReturn<ResponseBase<MsClientResponse>>
{

    public constructor(init?: Partial<MsClientRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MsClientRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<MsClientResponse>(); }
}
(MsClientRequest as unknown)[immerable] = true;

export class GetClientPricing implements IReturn<ResponseBase<GetClientPricingResponse>>
{

    public constructor(init?: Partial<GetClientPricing>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetClientPricing'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<GetClientPricingResponse>(); }
}
(GetClientPricing as unknown)[immerable] = true;

export class ConfirmClientSignUp implements IReturn<ResponseBase<ConfirmClientSignUpResponse>>
{
    public noOfPractitioners: number|null;
    public paymentMethod: PaymentMethod|null;

    public constructor(init?: Partial<ConfirmClientSignUp>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ConfirmClientSignUp'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ConfirmClientSignUpResponse>(); }
}
(ConfirmClientSignUp as unknown)[immerable] = true;

export class ConfirmClickPlusSignUp implements IReturn<ResponseBase<ConfirmClientSignUpResponse>>
{
    public paymentMethod: PaymentMethod|null;

    public constructor(init?: Partial<ConfirmClickPlusSignUp>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ConfirmClickPlusSignUp'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ConfirmClientSignUpResponse>(); }
}
(ConfirmClickPlusSignUp as unknown)[immerable] = true;

export class GetClientPaymentDetailsRequest implements IReturn<ResponseBase<GetClientPaymentDetailsResponse>>
{

    public constructor(init?: Partial<GetClientPaymentDetailsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetClientPaymentDetailsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<GetClientPaymentDetailsResponse>(); }
}
(GetClientPaymentDetailsRequest as unknown)[immerable] = true;

export class SaveClientPaymentDetailsRequest implements IReturn<ResponseBase<SaveClientPaymentDetailsResponse>>
{
    public paymentMethod: PaymentMethod|null;

    public constructor(init?: Partial<SaveClientPaymentDetailsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveClientPaymentDetailsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<SaveClientPaymentDetailsResponse>(); }
}
(SaveClientPaymentDetailsRequest as unknown)[immerable] = true;

export class ClickPPCDetailsRequest implements IReturn<ResponseBase<ClickPPCDetailsResponse>>
{

    public constructor(init?: Partial<ClickPPCDetailsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickPPCDetailsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ClickPPCDetailsResponse>(); }
}
(ClickPPCDetailsRequest as unknown)[immerable] = true;

export class ClickUpgradeDetailsRequest implements IReturn<ResponseBase<ClickUpgradeDetailsResponse>>
{

    public constructor(init?: Partial<ClickUpgradeDetailsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickUpgradeDetailsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ClickUpgradeDetailsResponse>(); }
}
(ClickUpgradeDetailsRequest as unknown)[immerable] = true;

export class ClickTrialRequest implements IReturn<ResponseBase<ClickTrialResponse>>
{

    public constructor(init?: Partial<ClickTrialRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickTrialRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClickTrialResponse>(); }
}
(ClickTrialRequest as unknown)[immerable] = true;

export class ClickDowngradeRequest implements IReturn<ResponseBase<ClickDowngradeResponse>>
{

    public constructor(init?: Partial<ClickDowngradeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickDowngradeRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClickDowngradeResponse>(); }
}
(ClickDowngradeRequest as unknown)[immerable] = true;

export class ClientDowngradeToSingleLicenseRequest implements IReturn<ResponseBase<ClientDowngradeToSingleLicenseResponse>>
{
    public id: number|null;

    public constructor(init?: Partial<ClientDowngradeToSingleLicenseRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClientDowngradeToSingleLicenseRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClientDowngradeToSingleLicenseResponse>(); }
}
(ClientDowngradeToSingleLicenseRequest as unknown)[immerable] = true;

export class ClientNoLongerWantsToCancelRequest implements IReturn<ResponseBase<ClientNoLongerWantsToCancelResponse>>
{

    public constructor(init?: Partial<ClientNoLongerWantsToCancelRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClientNoLongerWantsToCancelRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClientNoLongerWantsToCancelResponse>(); }
}
(ClientNoLongerWantsToCancelRequest as unknown)[immerable] = true;

export class ConfirmClientCancellation implements IReturn<ResponseBase<ConfirmClientCancellationResponse>>
{
    public trialLapsed: boolean|null;
    public comments: string|null;

    public constructor(init?: Partial<ConfirmClientCancellation>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ConfirmClientCancellation'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ConfirmClientCancellationResponse>(); }
}
(ConfirmClientCancellation as unknown)[immerable] = true;

export class HasInvalidCardRequest implements IReturn<ResponseBase<boolean>>
{

    public constructor(init?: Partial<HasInvalidCardRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'HasInvalidCardRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(HasInvalidCardRequest as unknown)[immerable] = true;

export class MSCurrencyRequest implements IReturn<ResponseBase<MSCurrencyResponse>>
{

    public constructor(init?: Partial<MSCurrencyRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MSCurrencyRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<MSCurrencyResponse>(); }
}
(MSCurrencyRequest as unknown)[immerable] = true;

export class MSSubscriptionRequest implements IReturn<ResponseBase<MSSubscriptionResponse>>
{

    public constructor(init?: Partial<MSSubscriptionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MSSubscriptionRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<MSSubscriptionResponse>(); }
}
(MSSubscriptionRequest as unknown)[immerable] = true;

export class CreditAutoTopUpAmountRequest implements IReturn<ResponseBase<CreditAutoTopUpAmountResponse>>
{
    public bundleType: string|null;
    public number: number|null;

    public constructor(init?: Partial<CreditAutoTopUpAmountRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreditAutoTopUpAmountRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CreditAutoTopUpAmountResponse>(); }
}
(CreditAutoTopUpAmountRequest as unknown)[immerable] = true;

export class SMSOrderHistoryRequest implements IReturn<ResponseBase<SMSOrderHistoryResponse>>, IHasGuidId
{
    public id: string|null;

    public constructor(init?: Partial<SMSOrderHistoryRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SMSOrderHistoryRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<SMSOrderHistoryResponse>(); }
}
(SMSOrderHistoryRequest as unknown)[immerable] = true;

export class SMSBundlePurchaseRequest implements IReturn<ResponseBase<number>>
{
    public number: number|null;

    public constructor(init?: Partial<SMSBundlePurchaseRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SMSBundlePurchaseRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<number>(); }
}
(SMSBundlePurchaseRequest as unknown)[immerable] = true;

export class SMSBundleOptionsRequest implements IReturn<ResponseBase<SMSBundleOptionsResponse>>
{

    public constructor(init?: Partial<SMSBundleOptionsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SMSBundleOptionsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<SMSBundleOptionsResponse>(); }
}
(SMSBundleOptionsRequest as unknown)[immerable] = true;

export class SystemCreditBundleOptionsRequest implements IReturn<ResponseBase<SystemCreditBundleOptionsResponse>>
{

    public constructor(init?: Partial<SystemCreditBundleOptionsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemCreditBundleOptionsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<SystemCreditBundleOptionsResponse>(); }
}
(SystemCreditBundleOptionsRequest as unknown)[immerable] = true;

export class CreditOrderHistoryRequest implements IReturn<ResponseBase<CreditOrderHistoryResponse>>, IHasGuidId
{
    public id: string|null;

    public constructor(init?: Partial<CreditOrderHistoryRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreditOrderHistoryRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<CreditOrderHistoryResponse>(); }
}
(CreditOrderHistoryRequest as unknown)[immerable] = true;

export class CreditBundlePurchaseRequest implements IReturn<ResponseBase<number>>
{
    public number: number|null;

    public constructor(init?: Partial<CreditBundlePurchaseRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreditBundlePurchaseRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<number>(); }
}
(CreditBundlePurchaseRequest as unknown)[immerable] = true;

export class PayMSInvoiceRequest implements IReturn<ResponseBase<boolean>>
{
    public id: number|null;

    public constructor(init?: Partial<PayMSInvoiceRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PayMSInvoiceRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(PayMSInvoiceRequest as unknown)[immerable] = true;

export class DownloadMSInvoiceRequest implements IReturn<ResponseBase<string>>
{
    public invoiceId: number|null;

    public constructor(init?: Partial<DownloadMSInvoiceRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DownloadMSInvoiceRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<string>(); }
}
(DownloadMSInvoiceRequest as unknown)[immerable] = true;

export class PayPerClickDetailRequest implements IReturn<ResponseBase<T>>
{
    public skip: number|null;
    public take: number|null;
    public includedInAllowance: boolean|null;
    public isSystemCredit: boolean|null;

    public constructor(init?: Partial<PayPerClickDetailRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PayPerClickDetailRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(PayPerClickDetailRequest as unknown)[immerable] = true;

export class PayPerClickSMSDetailRequest implements IReturn<ResponseBase<T>>
{
    public itemType: ItemType|null;
    public skip: number|null;
    public take: number|null;
    public sort: QueryField[]|null;
    public fromDate: string|null;
    public toDate: string|null;

    public constructor(init?: Partial<PayPerClickSMSDetailRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PayPerClickSMSDetailRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(PayPerClickSMSDetailRequest as unknown)[immerable] = true;

export class PayPerClickStatsRequest implements IReturn<ResponseBase<PayPerClickStatsResponse>>
{

    public constructor(init?: Partial<PayPerClickStatsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PayPerClickStatsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<PayPerClickStatsResponse>(); }
}
(PayPerClickStatsRequest as unknown)[immerable] = true;

export class UnrestrictedUserRequest implements IReturn<ResponseBase<UnrestrictedUserResponse>>
{

    public constructor(init?: Partial<UnrestrictedUserRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UnrestrictedUserRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<UnrestrictedUserResponse>(); }
}
(UnrestrictedUserRequest as unknown)[immerable] = true;

export class AddUnrestrictedUserRequest implements IReturn<ResponseBase<UnrestrictedUserResponse>>
{
    public userId: number|null;

    public constructor(init?: Partial<AddUnrestrictedUserRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AddUnrestrictedUserRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<UnrestrictedUserResponse>(); }
}
(AddUnrestrictedUserRequest as unknown)[immerable] = true;

export class DeleteUnrestrictedUserRequest implements IReturn<ResponseBase<boolean>>
{
    public userId: number|null;

    public constructor(init?: Partial<DeleteUnrestrictedUserRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteUnrestrictedUserRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(DeleteUnrestrictedUserRequest as unknown)[immerable] = true;

// @Route("/reports/diary/appointment-analysis")
export class DiaryAnalysisReportRequest extends BaseParamsForAllReports implements IReturn<ResponseBase<DiaryAnalysisResponse>>
{
    public diaryEventCategories: string[]|null;
    public appointmentStatuses: number[]|null;
    public bookingMethods: string[]|null;
    public rooms: number[]|null;
    public ageCategory: string[]|null;
    public cancellationReasons: string[]|null;

    public constructor(init?: Partial<DiaryAnalysisReportRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'DiaryAnalysisReportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<DiaryAnalysisResponse>(); }
}
(DiaryAnalysisReportRequest as unknown)[immerable] = true;

export class NonReturningReportRequest extends BaseParamsForAllReports implements IReturn<ResponseBase<T>>
{
    public weekCount: number|null;

    public constructor(init?: Partial<NonReturningReportRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'NonReturningReportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(NonReturningReportRequest as unknown)[immerable] = true;

export class TrafficReportRequest extends BaseParamsForAllReports implements IReturn<ResponseBase<T>>
{
    public instructor: number[]|null;
    public paymentMethods: string[]|null;
    public orderBy: TrafficReportOrdering|null;

    public constructor(init?: Partial<TrafficReportRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TrafficReportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(TrafficReportRequest as unknown)[immerable] = true;

export class AutopayReportRequest extends BaseParamsForAllReports implements IReturn<ResponseBase<T>>
{
    public status: SubscriptionStatus[]|null;
    public cardsExpiringSoon: boolean|null;
    public upcomingRenewals: boolean|null;

    public constructor(init?: Partial<AutopayReportRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'AutopayReportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(AutopayReportRequest as unknown)[immerable] = true;

// @Route("/stripe/redirect", "GET")
export class StripeRedirectRequest
{
    public state: string|null;
    public code: string|null;
    public error: string|null;
    public error_Description: string|null;

    public constructor(init?: Partial<StripeRedirectRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StripeRedirectRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(StripeRedirectRequest as unknown)[immerable] = true;

export class StripeStateRequest
{
    public state: string|null;

    public constructor(init?: Partial<StripeStateRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StripeStateRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(StripeStateRequest as unknown)[immerable] = true;

export class StripeIntegrationRequest implements IReturn<StripeOAuthResponse>
{
    public state: string|null;

    public constructor(init?: Partial<StripeIntegrationRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StripeIntegrationRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new StripeOAuthResponse(); }
}
(StripeIntegrationRequest as unknown)[immerable] = true;

export class GetSettingsRequest implements IReturn<ResponseBase<GetSettingsResponse>>
{
    public id: number|null;
    public businessId: number|null;

    public constructor(init?: Partial<GetSettingsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSettingsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<GetSettingsResponse>(); }
}
(GetSettingsRequest as unknown)[immerable] = true;

export class PutSettingsRequest extends OnlineSettings implements IReturn<ResponseBase<OnlineSettings>>
{
    // @Ignore()
    public logo: string|null;

    public constructor(init?: Partial<PutSettingsRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'PutSettingsRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<OnlineSettings>(); }
}
(PutSettingsRequest as unknown)[immerable] = true;

export class GetCategoryAndServicesRequest implements IReturn<ResponseBase<OnlineCategoryResponse>>, IGet
{
    public businessId: number|null;

    public constructor(init?: Partial<GetCategoryAndServicesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCategoryAndServicesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<OnlineCategoryResponse>(); }
}
(GetCategoryAndServicesRequest as unknown)[immerable] = true;

export class PutServiceRequest extends OnlineClinicService implements IReturn<ResponseBase<OnlineClinicService>>, IPut
{
    public category: string|null;

    public constructor(init?: Partial<PutServiceRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'PutServiceRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<OnlineClinicService>(); }
}
(PutServiceRequest as unknown)[immerable] = true;

export class PutCategoryRequest extends OnlineServiceCategory implements IReturn<ResponseBase<OnlineServiceCategory>>, IPut
{

    public constructor(init?: Partial<PutCategoryRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'PutCategoryRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<OnlineServiceCategory>(); }
}
(PutCategoryRequest as unknown)[immerable] = true;

export class GetOnlineSectionRequest implements IReturn<ResponseBase<OnlineSection>>
{

    public constructor(init?: Partial<GetOnlineSectionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetOnlineSectionRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<OnlineSection>(); }
}
(GetOnlineSectionRequest as unknown)[immerable] = true;

export class PutSectionRequest extends OnlineSection implements IReturn<ResponseBase<OnlineSection>>
{

    public constructor(init?: Partial<PutSectionRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'PutSectionRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<OnlineSection>(); }
}
(PutSectionRequest as unknown)[immerable] = true;

export class DeleteSectionRequest implements IReturn<ResponseBase<T>>
{
    public id: number|null;

    public constructor(init?: Partial<DeleteSectionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteSectionRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(DeleteSectionRequest as unknown)[immerable] = true;

export class PutCategoriesRequest implements IReturn<ResponseBase<OnlineServiceCategory>>, IPut
{
    public categories: PutCategoryRequest[]|null;

    public constructor(init?: Partial<PutCategoriesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PutCategoriesRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<OnlineServiceCategory>(); }
}
(PutCategoriesRequest as unknown)[immerable] = true;

export class DeleteCategoryRequest implements IReturn<ResponseBase<T>>
{
    public id: string|null;
    public businessId: number|null;

    public constructor(init?: Partial<DeleteCategoryRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteCategoryRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(DeleteCategoryRequest as unknown)[immerable] = true;

export class PutSectionsRequest extends OnlineSection implements IReturn<ResponseBase<OnlineSection>>
{
    public sections: PutSectionRequest[]|null;

    public constructor(init?: Partial<PutSectionsRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'PutSectionsRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<OnlineSection>(); }
}
(PutSectionsRequest as unknown)[immerable] = true;

export class CanDeleteImageRequest implements IReturn<ResponseBase<CanDeleteImageResponse>>
{
    public filename: string|null;

    public constructor(init?: Partial<CanDeleteImageRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CanDeleteImageRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<CanDeleteImageResponse>(); }
}
(CanDeleteImageRequest as unknown)[immerable] = true;

export class GetBusinessSettingsIdRequest implements IReturn<ResponseBase<BusinessSettingsIdResponse>>
{
    public businessId: number|null;
    public currentSettingsId: number|null;

    public constructor(init?: Partial<GetBusinessSettingsIdRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetBusinessSettingsIdRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<BusinessSettingsIdResponse>(); }
}
(GetBusinessSettingsIdRequest as unknown)[immerable] = true;

export class RemoveBusinessSettingsIdRequest implements IReturn<ResponseBase<GetSettingsResponse>>
{
    public businessId: number|null;

    public constructor(init?: Partial<RemoveBusinessSettingsIdRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RemoveBusinessSettingsIdRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<GetSettingsResponse>(); }
}
(RemoveBusinessSettingsIdRequest as unknown)[immerable] = true;

export class SearchAllClassesRequest implements IReturn<ResponseBase<ClassSearchResponse>>
{
    public date: string|null;
    public locationGuid: string|null;
    public practitionerId: number|null;
    public serviceIds: string[]|null;
    public parentServiceId: string|null;

    public constructor(init?: Partial<SearchAllClassesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SearchAllClassesRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClassSearchResponse>(); }
}
(SearchAllClassesRequest as unknown)[immerable] = true;

export class FindSimilarTimedClassesRequest implements IReturn<ResponseBase<SimilarClass>>
{
    public classSessionId: number|null;
    public serviceId: string|null;

    public constructor(init?: Partial<FindSimilarTimedClassesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FindSimilarTimedClassesRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<SimilarClass>(); }
}
(FindSimilarTimedClassesRequest as unknown)[immerable] = true;

export class BookTempClassRequest extends BookingClassResponse implements IReturn<ResponseBase<T>>
{
    public isCourse: boolean|null;
    public classSessionId: number|null;
    public serviceId: string|null;
    public attendanceIds: number[]|null;
    public attendeeId: number|null;

    public constructor(init?: Partial<BookTempClassRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BookTempClassRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(BookTempClassRequest as unknown)[immerable] = true;

export class DeleteTempClassBookingRequest implements IReturnVoid
{
    public isCourse: boolean|null;
    public classAttendanceIds: number[]|null;
    public attendeeId: number|null;

    public constructor(init?: Partial<DeleteTempClassBookingRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteTempClassBookingRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() {}
}
(DeleteTempClassBookingRequest as unknown)[immerable] = true;

export class GetAllCoursesFromTypeRequest implements IReturn<ResponseBase<T>>
{
    public classTypeId: number|null;
    public serviceId: string|null;

    public constructor(init?: Partial<GetAllCoursesFromTypeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAllCoursesFromTypeRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(GetAllCoursesFromTypeRequest as unknown)[immerable] = true;

export class BookClassRequest implements IReturn<ResponseBase<T>>
{
    public classSessionId: number|null;
    public isCourse: boolean|null;
    public classAttendanceIds: number[]|null;
    public attendeeId: number|null;
    public paymentType: PaymentMode|null;
    public packageId: string|null;
    public prePaidId: number|null;
    public discountCodeId: string|null;
    public takePaymentRequest: TakePaymentRequest|null;

    public constructor(init?: Partial<BookClassRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BookClassRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(BookClassRequest as unknown)[immerable] = true;

/** @description Used to get a JWT Token and Refresh Token. */
// @Route("/token")
export class TokenRequest implements IReturn<ResponseBase<ConvertSessionToTokenResponse>>
{

    public constructor(init?: Partial<TokenRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TokenRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ConvertSessionToTokenResponse>(); }
}
(TokenRequest as unknown)[immerable] = true;

// @Route("/zoom/publicAuthorisationRedirect")
export class PublicAuthorisationRedirectRequest implements IReturn<HttpResult>
{
    public code: string|null;
    public stateId: string|null;

    public constructor(init?: Partial<PublicAuthorisationRedirectRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PublicAuthorisationRedirectRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new HttpResult(); }
}
(PublicAuthorisationRedirectRequest as unknown)[immerable] = true;

// @Route("/zoom", "POST")
export class PublicLinkToZoomRequest implements IReturn<ZoomLinkToTM3Response>
{
    public clientId: string|null;

    public constructor(init?: Partial<PublicLinkToZoomRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PublicLinkToZoomRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ZoomLinkToTM3Response(); }
}
(PublicLinkToZoomRequest as unknown)[immerable] = true;

export class SaveZoomStateRequest implements IReturn<ResponseBase<ZoomSaveStateResponse>>
{

    public constructor(init?: Partial<SaveZoomStateRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveZoomStateRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ZoomSaveStateResponse>(); }
}
(SaveZoomStateRequest as unknown)[immerable] = true;

export class CustomRedirectRequest
{
    public redirectUri: string|null;

    public constructor(init?: Partial<CustomRedirectRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomRedirectRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(CustomRedirectRequest as unknown)[immerable] = true;

// @Route("/zoom/authorisationRedirect")
export class AuthorisationRedirectRequest implements IReturn<HttpResult>
{
    public code: string|null;
    public stateId: string|null;

    public constructor(init?: Partial<AuthorisationRedirectRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AuthorisationRedirectRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new HttpResult(); }
}
(AuthorisationRedirectRequest as unknown)[immerable] = true;

export class GetZoomUsersRequest implements IReturn<ResponseBase<ZoomUser>>
{

    public constructor(init?: Partial<GetZoomUsersRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetZoomUsersRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ZoomUser>(); }
}
(GetZoomUsersRequest as unknown)[immerable] = true;

export class IsZoomIntegrationConfiguredRequest implements IReturn<ResponseBase<boolean>>
{

    public constructor(init?: Partial<IsZoomIntegrationConfiguredRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'IsZoomIntegrationConfiguredRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(IsZoomIntegrationConfiguredRequest as unknown)[immerable] = true;

export class UnlinkTm3FromZoomRequest implements IReturn<ResponseBase<boolean>>
{

    public constructor(init?: Partial<UnlinkTm3FromZoomRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UnlinkTm3FromZoomRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(UnlinkTm3FromZoomRequest as unknown)[immerable] = true;

export class AreZoomTokensValid implements IReturn<ResponseBase<ZoomReauthResponse>>
{

    public constructor(init?: Partial<AreZoomTokensValid>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AreZoomTokensValid'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ZoomReauthResponse>(); }
}
(AreZoomTokensValid as unknown)[immerable] = true;

export class WaitingListsRequest implements IReturn<ResponseBase<WaitingListResponse>>, ILocationIds
{
    public patientId: number|null;
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;

    public constructor(init?: Partial<WaitingListsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WaitingListsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<WaitingListResponse>(); }
}
(WaitingListsRequest as unknown)[immerable] = true;

export class WaitingListById implements IReturn<ResponseBase<WaitingListByIdResponse>>
{
    public id: number|null;

    public constructor(init?: Partial<WaitingListById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WaitingListById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<WaitingListByIdResponse>(); }
}
(WaitingListById as unknown)[immerable] = true;

export class WaitingListStateHistoryRequest implements IReturn<ResponseBase<WaitingListStateHistoryResponse[]>>
{
    public id: number|null;
    public customerId: number|null;

    public constructor(init?: Partial<WaitingListStateHistoryRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WaitingListStateHistoryRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<WaitingListStateHistoryResponse[]>(); }
}
(WaitingListStateHistoryRequest as unknown)[immerable] = true;

export class AllowedIPRequest implements IReturn<ResponseBase<AllowedIPResponse>>
{

    public constructor(init?: Partial<AllowedIPRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AllowedIPRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<AllowedIPResponse>(); }
}
(AllowedIPRequest as unknown)[immerable] = true;

export class AddAllowedIPRequest implements IReturn<ResponseBase<AllowedIPResponse>>
{
    public address: string|null;

    public constructor(init?: Partial<AddAllowedIPRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AddAllowedIPRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<AllowedIPResponse>(); }
}
(AddAllowedIPRequest as unknown)[immerable] = true;

export class DeleteAllowedIPRequest implements IReturn<ResponseBase<boolean>>
{
    public id: number|null;

    public constructor(init?: Partial<DeleteAllowedIPRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteAllowedIPRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(DeleteAllowedIPRequest as unknown)[immerable] = true;

// @Route("/sentry/{Action}/{ClientId}")
export class SentryApmRequest implements IReturn<ResponseBase<T>>
{
    public clientId: number|null;
    public action: SentryApmAction|null;

    public constructor(init?: Partial<SentryApmRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SentryApmRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(SentryApmRequest as unknown)[immerable] = true;

export class EmbeddableDashboardTokenRequest implements IReturn<ResponseBase<T>>
{
    public id: string|null;

    public constructor(init?: Partial<EmbeddableDashboardTokenRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EmbeddableDashboardTokenRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(EmbeddableDashboardTokenRequest as unknown)[immerable] = true;

export class ReferralPortalCurrentUserRequest implements IReturn<ResponseBase<CurrentUser>>
{

    public constructor(init?: Partial<ReferralPortalCurrentUserRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalCurrentUserRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<CurrentUser>(); }
}
(ReferralPortalCurrentUserRequest as unknown)[immerable] = true;

export class GetAllSystemLogRequest implements IReturn<ResponseBase<SystemLogWithCustomerName>>
{
    public skip: number|null;
    public take: number|null;
    public sort: QueryField[]|null;

    public constructor(init?: Partial<GetAllSystemLogRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAllSystemLogRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<SystemLogWithCustomerName>(); }
}
(GetAllSystemLogRequest as unknown)[immerable] = true;

export class SquareGetDeviceCodeRequest implements IReturn<ResponseBase<SquareGetDeviceCodeResponse>>
{
    public locationId: number|null;
    public name: string|null;

    public constructor(init?: Partial<SquareGetDeviceCodeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SquareGetDeviceCodeRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<SquareGetDeviceCodeResponse>(); }
}
(SquareGetDeviceCodeRequest as unknown)[immerable] = true;

export class ClearAcceptTerminalSaveRequest implements IReturn<ResponseBase<boolean>>
{
    public locationId: number|null;
    public name: string|null;
    public merchantId: string|null;
    public deviceCode: string|null;
    public inUse: boolean|null;

    public constructor(init?: Partial<ClearAcceptTerminalSaveRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClearAcceptTerminalSaveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ClearAcceptTerminalSaveRequest as unknown)[immerable] = true;

export class SquareUnpairTerminalRequest implements IReturn<ResponseBase<boolean>>
{
    public deviceCode: string|null;

    public constructor(init?: Partial<SquareUnpairTerminalRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SquareUnpairTerminalRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(SquareUnpairTerminalRequest as unknown)[immerable] = true;

export class TerminalPairCheckRequest implements IReturn<ResponseBase<TerminalPairingResponse>>
{
    public deviceCode: string|null;

    public constructor(init?: Partial<TerminalPairCheckRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TerminalPairCheckRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<TerminalPairingResponse>(); }
}
(TerminalPairCheckRequest as unknown)[immerable] = true;

export class TerminalListRequest implements IReturn<ResponseBase<Terminal[]>>
{

    public constructor(init?: Partial<TerminalListRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TerminalListRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<Terminal[]>(); }
}
(TerminalListRequest as unknown)[immerable] = true;

export class TerminalFailPairingRequest implements IReturn<ResponseBase<boolean>>
{
    public deviceCode: string|null;

    public constructor(init?: Partial<TerminalFailPairingRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TerminalFailPairingRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(TerminalFailPairingRequest as unknown)[immerable] = true;

export class SquareTerminalPaymentRequest implements IReturn<ResponseBase<SquareTerminalPaymentResponse>>
{
    public amount: number|null;
    public terminalId: string|null;
    public customerId: number|null;

    public constructor(init?: Partial<SquareTerminalPaymentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SquareTerminalPaymentRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<SquareTerminalPaymentResponse>(); }
}
(SquareTerminalPaymentRequest as unknown)[immerable] = true;

// @Route("/add-terminal-payment")
export class AddTerminalPaymentToInvoiceRequest implements IReturn<ResponseBase<boolean>>
{
    public invoiceId: number|null;
    public terminalPaymentDto: TerminalPaymentDto|null;

    public constructor(init?: Partial<AddTerminalPaymentToInvoiceRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AddTerminalPaymentToInvoiceRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(AddTerminalPaymentToInvoiceRequest as unknown)[immerable] = true;

export class GetPaymentFromTerminalDto implements IReturn<ResponseBase<Income>>
{
    public terminalPaymentDto: TerminalPaymentDto|null;

    public constructor(init?: Partial<GetPaymentFromTerminalDto>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPaymentFromTerminalDto'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<Income>(); }
}
(GetPaymentFromTerminalDto as unknown)[immerable] = true;

export class StripeTerminalPairRequest implements IReturn<ResponseBase<StripeTerminalPairResponse>>
{
    public locationId: number|null;
    public stripeLocationId: string|null;
    public terminalId: string|null;
    public deviceName: string|null;
    public pairingCode: string|null;

    public constructor(init?: Partial<StripeTerminalPairRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StripeTerminalPairRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<StripeTerminalPairResponse>(); }
}
(StripeTerminalPairRequest as unknown)[immerable] = true;

export class TerminalDeleteRequest implements IReturnVoid
{
    public terminalId: string|null;

    public constructor(init?: Partial<TerminalDeleteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TerminalDeleteRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(TerminalDeleteRequest as unknown)[immerable] = true;

export class CreatePaymentIntent
{
    public amount: number|null;
    public futureUsage: boolean|null;
    public paymentMethodId: string|null;

    public constructor(init?: Partial<CreatePaymentIntent>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreatePaymentIntent'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(CreatePaymentIntent as unknown)[immerable] = true;

export class OnlineStripeChangeCardRequest implements IReturn<ResponseBase<ChangeCardResponse>>
{
    public paymentMethodId: string|null;

    public constructor(init?: Partial<OnlineStripeChangeCardRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineStripeChangeCardRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<ChangeCardResponse>(); }
}
(OnlineStripeChangeCardRequest as unknown)[immerable] = true;

export class CreateChasePaymentIntent extends CreatePaymentIntent
{
    public paymentUrlCode: string|null;

    public constructor(init?: Partial<CreateChasePaymentIntent>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateChasePaymentIntent'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(CreateChasePaymentIntent as unknown)[immerable] = true;

export class CreateWaitingListPaymentIntent extends CreatePaymentIntent
{
    public waitingListUrlCode: string|null;

    public constructor(init?: Partial<CreateWaitingListPaymentIntent>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateWaitingListPaymentIntent'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(CreateWaitingListPaymentIntent as unknown)[immerable] = true;

export class SquareStartPaymentCaptureRequest extends TakePaymentRequest implements IReturn<ResponseBase<TakePaymentRequest>>
{
    public amount: number|null;
    public paymentUrlCode: string|null;
    public cardholderName: string|null;

    public constructor(init?: Partial<SquareStartPaymentCaptureRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SquareStartPaymentCaptureRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<TakePaymentRequest>(); }
}
(SquareStartPaymentCaptureRequest as unknown)[immerable] = true;

export class OnlineSquareChangeCardRequest implements IReturn<ResponseBase<ChangeCardResponse>>
{
    public tokenId: string|null;
    public cardholderName: string|null;
    public verificationToken: string|null;

    public constructor(init?: Partial<OnlineSquareChangeCardRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineSquareChangeCardRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<ChangeCardResponse>(); }
}
(OnlineSquareChangeCardRequest as unknown)[immerable] = true;

export class ClearAcceptSaveCardDetailsRequest implements IReturn<ResponseBase<boolean>>
{
    public takePaymentRequest: TakePaymentRequest|null;

    public constructor(init?: Partial<ClearAcceptSaveCardDetailsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClearAcceptSaveCardDetailsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ClearAcceptSaveCardDetailsRequest as unknown)[immerable] = true;

export class ClearAcceptRegisterInterest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<ClearAcceptRegisterInterest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClearAcceptRegisterInterest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(ClearAcceptRegisterInterest as unknown)[immerable] = true;

export class ClearAcceptConfigRequest implements IReturn<ResponseBase<ClearAcceptConfigResponse>>
{

    public constructor(init?: Partial<ClearAcceptConfigRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClearAcceptConfigRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ClearAcceptConfigResponse>(); }
}
(ClearAcceptConfigRequest as unknown)[immerable] = true;

export class ClearAcceptStartPaymentCaptureRequest implements IReturn<ResponseBase<TakePaymentRequest>>
{
    public amount: number|null;
    public locationId: number|null;
    public saveCard: boolean|null;
    public paymentUrlCode: string|null;
    public waitingListUrlCode: string|null;

    public constructor(init?: Partial<ClearAcceptStartPaymentCaptureRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClearAcceptStartPaymentCaptureRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<TakePaymentRequest>(); }
}
(ClearAcceptStartPaymentCaptureRequest as unknown)[immerable] = true;

export class UpdateAddressOnPaymentRequest implements IReturn<ResponseBase<boolean>>
{
    public takePaymentRequest: TakePaymentRequest|null;
    public paymentUrlCode: string|null;
    public amount: number|null;
    public customerId: number|null;
    public waitingListUrlCode: string|null;

    public constructor(init?: Partial<UpdateAddressOnPaymentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateAddressOnPaymentRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(UpdateAddressOnPaymentRequest as unknown)[immerable] = true;

export class StartTerminalPaymentRequest implements IReturn<ResponseBase<TerminalPaymentDto>>
{
    public amount: number|null;
    public terminalId: string|null;
    public customerId: number|null;
    public locationId: number|null;
    public receivedAtLocationId: number|null;
    public practitionerId: number|null;
    public invoiceId: number|null;

    public constructor(init?: Partial<StartTerminalPaymentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StartTerminalPaymentRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<TerminalPaymentDto>(); }
}
(StartTerminalPaymentRequest as unknown)[immerable] = true;

export class CancelTerminalCheckoutRequest implements IReturn<ResponseBase<boolean>>
{
    public terminalPayment: TerminalPaymentDto|null;

    public constructor(init?: Partial<CancelTerminalCheckoutRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CancelTerminalCheckoutRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(CancelTerminalCheckoutRequest as unknown)[immerable] = true;

export class TerminalPaymentStatusRequest implements IReturn<ResponseBase<TerminalPaymentDto>>
{
    public terminalPayment: TerminalPaymentDto|null;

    public constructor(init?: Partial<TerminalPaymentStatusRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TerminalPaymentStatusRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<TerminalPaymentDto>(); }
}
(TerminalPaymentStatusRequest as unknown)[immerable] = true;

export class StartVirtualTerminalPaymentCaptureRequest implements IReturn<ResponseBase<TakePaymentRequest>>
{
    public amount: number|null;
    public locationId: number|null;
    public customerId: number|null;
    public invoiceId: number|null;

    public constructor(init?: Partial<StartVirtualTerminalPaymentCaptureRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StartVirtualTerminalPaymentCaptureRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<TakePaymentRequest>(); }
}
(StartVirtualTerminalPaymentCaptureRequest as unknown)[immerable] = true;

export class CompleteVirtualTerminalPaymentCaptureRequest implements IReturn<ResponseBase<TakePaymentRequest>>
{
    public amount: number|null;
    public locationId: number|null;
    public customerId: number|null;
    public invoiceId: number|null;
    public takePaymentRequest: TakePaymentRequest|null;

    public constructor(init?: Partial<CompleteVirtualTerminalPaymentCaptureRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CompleteVirtualTerminalPaymentCaptureRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<TakePaymentRequest>(); }
}
(CompleteVirtualTerminalPaymentCaptureRequest as unknown)[immerable] = true;

export class CreateApiCredentials implements IReturn<ResponseBase<T>>
{
    public notes: string|null;

    public constructor(init?: Partial<CreateApiCredentials>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateApiCredentials'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(CreateApiCredentials as unknown)[immerable] = true;

export class RevokeApiCredentials implements IReturn<ResponseBase<T>>
{
    public id: string|null;

    public constructor(init?: Partial<RevokeApiCredentials>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RevokeApiCredentials'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(RevokeApiCredentials as unknown)[immerable] = true;

export class GetApiCredentials implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<GetApiCredentials>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetApiCredentials'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(GetApiCredentials as unknown)[immerable] = true;

export class GetCreditBasedPackageLineItems implements IReturn<ResponseBase<CreditBasedPackageLineItemsResponse>>
{
    public id: number|null;

    public constructor(init?: Partial<GetCreditBasedPackageLineItems>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCreditBasedPackageLineItems'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<CreditBasedPackageLineItemsResponse>(); }
}
(GetCreditBasedPackageLineItems as unknown)[immerable] = true;

export class ClickBillRequest implements IReturn<ResponseBase<ClickBillResponse>>
{
    public appointmentId: number|null;
    public useTerminalPayment: boolean|null;
    public requestViaPaymentProvider: boolean|null;
    public reminderToSetupPaymentProvider: boolean|null;
    public invoiceNow: boolean|null;
    public status: AppointmentStatus|null;
    public incomeId: number|null;

    public constructor(init?: Partial<ClickBillRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickBillRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClickBillResponse>(); }
}
(ClickBillRequest as unknown)[immerable] = true;

export class BlankInvoiceRequest implements IReturn<ResponseBase<number>>
{
    public accountId: number|null;

    public constructor(init?: Partial<BlankInvoiceRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BlankInvoiceRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<number>(); }
}
(BlankInvoiceRequest as unknown)[immerable] = true;

export class ClickInvoiceUsePaymentRequest extends ClickInvoiceReqBase implements IReturn<ResponseBase<T>>
{
    public paymentIds: number[]|null;

    public constructor(init?: Partial<ClickInvoiceUsePaymentRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickInvoiceUsePaymentRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(ClickInvoiceUsePaymentRequest as unknown)[immerable] = true;

export class ClickEmailInvoiceRequest extends ClickInvoiceReqBase implements IReturn<ResponseBase<boolean>>
{

    public constructor(init?: Partial<ClickEmailInvoiceRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickEmailInvoiceRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ClickEmailInvoiceRequest as unknown)[immerable] = true;

export class ClickDownloadInvoiceRequest extends ClickInvoiceReqBase implements IReturn<ResponseBase<ClickDownloadInvoiceResponse>>
{

    public constructor(init?: Partial<ClickDownloadInvoiceRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickDownloadInvoiceRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ClickDownloadInvoiceResponse>(); }
}
(ClickDownloadInvoiceRequest as unknown)[immerable] = true;

export class ClickInvoiceTransferRequest extends ClickInvoiceReqBase implements IReturn<ResponseBase<number>>
{
    public transferFullAmount: boolean|null;
    public charge: Charge|null;
    public useCredit: boolean|null;
    public shouldAutopay: boolean|null;

    public constructor(init?: Partial<ClickInvoiceTransferRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickInvoiceTransferRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<number>(); }
}
(ClickInvoiceTransferRequest as unknown)[immerable] = true;

export class ClickCreatePaymentForInvoiceRequest extends Income implements IReturn<ResponseBase<ClickCreatePaymentResponse>>
{
    public emailReceipt: boolean|null;
    public invoiceId: number|null;
    public reminderToSetupPaymentProvider: boolean|null;
    public downloadPDF: boolean|null;

    public constructor(init?: Partial<ClickCreatePaymentForInvoiceRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickCreatePaymentForInvoiceRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClickCreatePaymentResponse>(); }
}
(ClickCreatePaymentForInvoiceRequest as unknown)[immerable] = true;

export class ClickCreatePaymentRequest extends Income implements IReturn<ResponseBase<ClickCreatePaymentResponse>>
{
    public emailReceipt: boolean|null;
    public reminderToSetupPaymentProvider: boolean|null;
    public downloadPDF: boolean|null;
    public status: string|null;

    public constructor(init?: Partial<ClickCreatePaymentRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickCreatePaymentRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClickCreatePaymentResponse>(); }
}
(ClickCreatePaymentRequest as unknown)[immerable] = true;

export class ClickSendEmailReceiptRequest implements IReturn<ResponseBase<boolean>>
{
    public customerId: number|null;
    public groupId: number|null;
    public locationId: number|null;
    public paymentId: number|null;

    public constructor(init?: Partial<ClickSendEmailReceiptRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickSendEmailReceiptRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ClickSendEmailReceiptRequest as unknown)[immerable] = true;

export class ClickDownloadReceiptRequest extends ClickSendEmailReceiptRequest implements IReturn<ResponseBase<boolean>>
{

    public constructor(init?: Partial<ClickDownloadReceiptRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickDownloadReceiptRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ClickDownloadReceiptRequest as unknown)[immerable] = true;

export class ClickCommunicationRequest implements IReturn<ResponseBase<ClickCommunicationResponse>>
{
    public mode: CommunicationMode|null;
    public type: string|null;
    public typeId: number|null;

    public constructor(init?: Partial<ClickCommunicationRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickCommunicationRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ClickCommunicationResponse>(); }
}
(ClickCommunicationRequest as unknown)[immerable] = true;

export class GetClassSessionRequest implements IReturn<ResponseBase<ClassSessionBaseResponse>>
{
    public id: number|null;
    public appointmentId: number|null;

    public constructor(init?: Partial<GetClassSessionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetClassSessionRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ClassSessionBaseResponse>(); }
}
(GetClassSessionRequest as unknown)[immerable] = true;

export class CreateClassRequest implements IReturn<ResponseBase<CreateClassResponse>>
{
    public locationId: number|null;
    public roomId: number|null;
    public practitionerId: number|null;
    public isAvailableOnline: boolean|null;
    public classTypeId: number|null;
    public dateCreateMode: ClassDateCreationMode|null;
    public dayOfWeek: DayOfWeek|null;
    public startTime: string|null;
    public endTime: string|null;
    public sessionDuration: number|null;
    public recurrenceStartTime: string|null;
    public recurrenceEndTime: string|null;
    public recurForNWeeks: number|null;
    public customDates: string[]|null;
    public minAttendees: number|null;
    public maxAttendees: number|null;
    public serviceTypeId: number|null;
    public colour: number|null;
    public clashMode: ClashMode|null;
    public isVideo: boolean|null;
    public videoMeetingParticipantJoinUrl: string|null;
    public videoMeetingPassword: string|null;
    public videoMeetingProvider: VideoMeetingProvider|null;

    public constructor(init?: Partial<CreateClassRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateClassRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CreateClassResponse>(); }
}
(CreateClassRequest as unknown)[immerable] = true;

export class GetDesktopClassRequest implements IReturn<ResponseBase<GetDesktopClassResponse>>
{
    public id: number|null;

    public constructor(init?: Partial<GetDesktopClassRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDesktopClassRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<GetDesktopClassResponse>(); }
}
(GetDesktopClassRequest as unknown)[immerable] = true;

export class AddStudentToClassSessionRequest implements IReturn<ResponseBase<AddStudentToClassSessionResponse>>
{
    public sessionId: number|null;
    public customerId: number|null;
    public customer: CustomerSaveRequest|null;
    public billingMode: ClassBillingMode|null;
    public paymentMode: ClassPaymentMode|null;
    public stockIdForNewBillingItem: number|null;
    public cardToken: string|null;
    public appliesTo: SessionUpdateAppliesTo|null;
    public customSessionIds: number[]|null;
    public receivedAtLocationId: number|null;
    public emailReceipt: boolean|null;
    public emailInvoice: boolean|null;
    public addToWaitingListSessionIds: number[]|null;
    public updateAttendance: boolean|null;
    public clashMode: ClashMode|null;
    public terminalPaymentDto: TerminalPaymentDto|null;
    public prepaidId: number|null;

    public constructor(init?: Partial<AddStudentToClassSessionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AddStudentToClassSessionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<AddStudentToClassSessionResponse>(); }
}
(AddStudentToClassSessionRequest as unknown)[immerable] = true;

export class EditClassRequest implements IReturn<ResponseBase<EditClassResponse>>
{
    public sessionId: number|null;
    public editing: ClassEditType|null;
    public newValue: number|null;
    public duration: number|null;
    public newDate: string|null;
    public newStartDate: string|null;
    public newEndDate: string|null;
    public clashMode: ClashMode|null;
    public appliesTo: SessionUpdateAppliesTo|null;
    public customSessionIds: number[]|null;

    public constructor(init?: Partial<EditClassRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EditClassRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<EditClassResponse>(); }
}
(EditClassRequest as unknown)[immerable] = true;

export class CancelClassSessionRequest implements IReturn<ResponseBase<boolean>>
{
    public id: number|null;

    public constructor(init?: Partial<CancelClassSessionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CancelClassSessionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(CancelClassSessionRequest as unknown)[immerable] = true;

export class GetStudentOtherSessionsRequest implements IReturn<ResponseBase<ClassSessionBaseResponse>>
{
    public classTypeId: number|null;
    public customerId: number|null;

    public constructor(init?: Partial<GetStudentOtherSessionsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetStudentOtherSessionsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ClassSessionBaseResponse>(); }
}
(GetStudentOtherSessionsRequest as unknown)[immerable] = true;

export class PayForClassRequest implements IReturn<ResponseBase<PayForClassResponse>>
{
    public sessionId: number|null;
    public customerId: number|null;
    public billingMode: ClassBillingMode|null;
    public paymentMode: ClassPaymentMode|null;
    public stockIdForNewBillingItem: number|null;
    public updateAttendance: boolean|null;
    public cardToken: string|null;
    public receivedAtLocationId: number|null;
    public emailReceipt: boolean|null;
    public emailInvoice: boolean|null;
    public terminalPaymentDto: TerminalPaymentDto|null;
    public existingPrePaidId: number|null;

    public constructor(init?: Partial<PayForClassRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PayForClassRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<PayForClassResponse>(); }
}
(PayForClassRequest as unknown)[immerable] = true;

export class UseCreditRequest implements IReturn<ResponseBase<T>>
{
    public sessionId: number|null;
    public customerId: number|null;

    public constructor(init?: Partial<UseCreditRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UseCreditRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(UseCreditRequest as unknown)[immerable] = true;

export class RemoveStudentFromSessionRequest implements IReturn<ResponseBase<CourseResponse>>
{
    public sessionId: number|null;
    public appliesTo: SessionUpdateAppliesTo|null;
    public customSessionIds: number[]|null;
    public customerId: number|null;
    public cancellationFeeDue: boolean|null;
    public transferFeeDue: boolean|null;
    public transferToSessionId: number|null;
    public billingMode: ClassBillingMode|null;
    public paymentMode: ClassPaymentMode|null;
    public existingPrePaidId: number|null;
    public stockIdForNewBillingItem: number|null;
    public cardToken: string|null;
    public receivedAtLocationId: number|null;
    public emailInvoice: boolean|null;
    public emailReceipt: boolean|null;

    public constructor(init?: Partial<RemoveStudentFromSessionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RemoveStudentFromSessionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CourseResponse>(); }
}
(RemoveStudentFromSessionRequest as unknown)[immerable] = true;

export class GetClassSessionRequests implements IReturn<ResponseBase<ClassSessionBaseResponse>>
{
    public sessionId: number|null;

    public constructor(init?: Partial<GetClassSessionRequests>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetClassSessionRequests'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ClassSessionBaseResponse>(); }
}
(GetClassSessionRequests as unknown)[immerable] = true;

export class GetWeeklyClassSessionRequests implements IReturn<ResponseBase<ClassSessionBaseResponse>>
{
    public sessionId: number|null;

    public constructor(init?: Partial<GetWeeklyClassSessionRequests>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetWeeklyClassSessionRequests'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ClassSessionBaseResponse>(); }
}
(GetWeeklyClassSessionRequests as unknown)[immerable] = true;

export class MarkClassSessionAttendance implements IReturn<ResponseBase<boolean>>
{
    public sessionId: number|null;
    public customerId: number|null;
    public updateAttendance: boolean|null;

    public constructor(init?: Partial<MarkClassSessionAttendance>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MarkClassSessionAttendance'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(MarkClassSessionAttendance as unknown)[immerable] = true;

export class ClassCommunicationRequest implements IReturn<ResponseBase<ClassCommunicationResponse>>
{
    public id: number|null;
    public message: string|null;
    public userName: string|null;

    public constructor(init?: Partial<ClassCommunicationRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClassCommunicationRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClassCommunicationResponse>(); }
}
(ClassCommunicationRequest as unknown)[immerable] = true;

export class CustomerPrepaidRequestForClass implements IReturn<ResponseBase<PrePaidItemsForClassResponse>>
{
    public sessionDateTime: string|null;
    public customerId: number|null;
    public classTypeId: number|null;

    public constructor(init?: Partial<CustomerPrepaidRequestForClass>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomerPrepaidRequestForClass'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<PrePaidItemsForClassResponse>(); }
}
(CustomerPrepaidRequestForClass as unknown)[immerable] = true;

export class ClassesCustomerPrepaidCreditsReq implements IReturn<ResponseBase<ClassesPrePaidCreditsResp>>
{
    public sessionDateTime: string|null;
    public customerId: number|null;
    public classTypeId: number|null;

    public constructor(init?: Partial<ClassesCustomerPrepaidCreditsReq>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClassesCustomerPrepaidCreditsReq'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ClassesPrePaidCreditsResp>(); }
}
(ClassesCustomerPrepaidCreditsReq as unknown)[immerable] = true;

export class DeletePayAsYouGoClassRequest implements IReturn<ResponseBase<boolean>>
{
    public sessionId: number|null;

    public constructor(init?: Partial<DeletePayAsYouGoClassRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeletePayAsYouGoClassRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(DeletePayAsYouGoClassRequest as unknown)[immerable] = true;

export class ClassSessionMarkAllAttendanceRequest implements IReturn<ResponseBase<boolean>>
{
    public sessionId: number|null;
    public allAttended: boolean|null;

    public constructor(init?: Partial<ClassSessionMarkAllAttendanceRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClassSessionMarkAllAttendanceRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ClassSessionMarkAllAttendanceRequest as unknown)[immerable] = true;

export class SaveClassNotesToAttendee implements IReturn<ResponseBase<ClassSessionBaseResponse>>
{
    public data: { [index:string]: Object; }|null;
    public templateId: string|null;
    public customerId: number|null;
    public sessionId: number|null;

    public constructor(init?: Partial<SaveClassNotesToAttendee>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveClassNotesToAttendee'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClassSessionBaseResponse>(); }
}
(SaveClassNotesToAttendee as unknown)[immerable] = true;

export class GetClassTypeRequest implements IReturn<ResponseBase<ClassTypeResponse>>
{
    public id: number|null;

    public constructor(init?: Partial<GetClassTypeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetClassTypeRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ClassTypeResponse>(); }
}
(GetClassTypeRequest as unknown)[immerable] = true;

export class ClassTypesListRequest implements IReturn<ResponseBase<ClassTypeResponse>>
{
    public ids: number|null;

    public constructor(init?: Partial<ClassTypesListRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClassTypesListRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ClassTypeResponse>(); }
}
(ClassTypesListRequest as unknown)[immerable] = true;

export class ClassTypeSaveRequest implements IReturn<ResponseBase<ClassTypeResponse>>, IDepartmentIds, ILocationIds
{
    public id: number|null;
    public name: string|null;
    public description: string|null;
    public imageUrl: string|null;
    public termsAndConditionsFormId: string|null;
    public colour: number|null;
    public defaultSessionLength: number|null;
    public numberOfSessions: number|null;
    public defaultMinAttendees: number|null;
    public defaultMaxAttendees: number|null;
    public isCourse: boolean|null;
    public isAvailableOnline: boolean|null;
    public isCurrent: boolean|null;
    public isFavourite: boolean|null;
    public allowPayPerSession: boolean|null;
    public perSessionStockId: number|null;
    public perSessionPrice: number|null;
    public packagesToCreate: SavePackageRequest[]|null;
    public packagesToAdd: ClassPackageResponse[]|null;
    public packagesToRemove: ClassPackageResponse[]|null;
    public cancellationChargeApplies: boolean|null;
    public cancellationHours: number|null;
    public cancellationStockId: number|null;
    public cancellationPrice: number|null;
    public lateTransferChargeApplies: boolean|null;
    public lateTransferHours: number|null;
    public lateTransferStockId: number|null;
    public lateTransferPrice: number|null;
    public serviceTypeId: number|null;
    public colourCss: string|null;
    public departmentIds: number[]|null;
    public locationIds: number[]|null;
    public requestLocationIds: number[]|null;
    public isVideo: boolean|null;

    public constructor(init?: Partial<ClassTypeSaveRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClassTypeSaveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClassTypeResponse>(); }
}
(ClassTypeSaveRequest as unknown)[immerable] = true;

export class GetCourse implements IReturn<ResponseBase<CourseResponse>>
{
    public id: number|null;

    public constructor(init?: Partial<GetCourse>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCourse'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<CourseResponse>(); }
}
(GetCourse as unknown)[immerable] = true;

export class AddStudentToCourseRequest implements IReturn<ResponseBase<AddStudentToCourseResponse>>
{
    public courseId: number|null;
    public customerId: number|null;
    public customer: CustomerSaveRequest|null;
    public billingMode: CourseBillingMode|null;
    public paymentMode: ClassPaymentMode|null;
    public existingPrePaidId: number|null;
    public prePaidId: number|null;
    public stockIdForNewBillingItem: number|null;
    public cardToken: string|null;
    public receivedAtLocationId: number|null;
    public emailInvoice: boolean|null;
    public emailReceipt: boolean|null;
    public clashMode: ClashMode|null;
    public addToWaitingList: boolean|null;
    public sessionDateTime: string|null;
    public terminalPaymentDto: TerminalPaymentDto|null;

    public constructor(init?: Partial<AddStudentToCourseRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AddStudentToCourseRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<AddStudentToCourseResponse>(); }
}
(AddStudentToCourseRequest as unknown)[immerable] = true;

export class EditCourseRequest implements IReturn<ResponseBase<EditCourseResponse>>
{
    public courseId: number|null;
    public sessionId: number|null;
    public editing: ClassEditType|null;
    public newValue: number|null;
    public newDate: string|null;
    public appliesTo: CourseEditAppliesTo|null;
    public clashMode: ClashMode|null;
    public newStartDate: string|null;
    public newEndDate: string|null;
    public duration: number|null;

    public constructor(init?: Partial<EditCourseRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EditCourseRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<EditCourseResponse>(); }
}
(EditCourseRequest as unknown)[immerable] = true;

export class CreateCourseRequest implements IReturn<ResponseBase<CreateCourseResponse>>
{
    public locationId: number|null;
    public roomId: number|null;
    public practitionerId: number|null;
    public isAvailableOnline: boolean|null;
    public classTypeId: number|null;
    public dateCreateMode: ClassDateCreationMode|null;
    public dayOfWeek: DayOfWeek|null;
    public startTime: string|null;
    public endTime: string|null;
    public sessionDuration: number|null;
    public recurrenceStartTime: string|null;
    public recurrenceEndTime: string|null;
    public recurForNWeeks: number|null;
    public customDates: string[]|null;
    public minAttendees: number|null;
    public maxAttendees: number|null;
    public serviceTypeId: number|null;
    public colour: number|null;
    public clashMode: ClashMode|null;
    public isVideo: boolean|null;
    public videoMeetingParticipantJoinUrl: string|null;
    public videoMeetingPassword: string|null;
    public videoMeetingProvider: VideoMeetingProvider|null;

    public constructor(init?: Partial<CreateCourseRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateCourseRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CreateCourseResponse>(); }
}
(CreateCourseRequest as unknown)[immerable] = true;

export class SwapStudentCourseSessionRequest implements IReturn<ResponseBase<CourseResponse>>
{
    public customerId: number|null;
    public removeFromSessionId: number|null;
    public addToSessionId: number|null;
    public courseId: number|null;

    public constructor(init?: Partial<SwapStudentCourseSessionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SwapStudentCourseSessionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CourseResponse>(); }
}
(SwapStudentCourseSessionRequest as unknown)[immerable] = true;

export class CancelCourseSessionRequest implements IReturn<ResponseBase<boolean>>
{
    public id: number|null;

    public constructor(init?: Partial<CancelCourseSessionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CancelCourseSessionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(CancelCourseSessionRequest as unknown)[immerable] = true;

export class AddCourseSessionRequest implements IReturn<ResponseBase<CourseResponse>>
{
    public practitionerId: number|null;
    public roomId: number|null;
    public courseId: number|null;
    public startDateTime: string|null;
    public endDateTime: string|null;

    public constructor(init?: Partial<AddCourseSessionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AddCourseSessionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CourseResponse>(); }
}
(AddCourseSessionRequest as unknown)[immerable] = true;

export class GetPotentialSwapDates implements IReturn<ResponseBase<CourseResponse>>
{
    public courseTypeId: number|null;
    public sessionId: number|null;
    public courseId: number|null;

    public constructor(init?: Partial<GetPotentialSwapDates>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPotentialSwapDates'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<CourseResponse>(); }
}
(GetPotentialSwapDates as unknown)[immerable] = true;

export class PayForCourseRequest implements IReturn<ResponseBase<PayForClassResponse>>
{
    public courseId: number|null;
    public customerId: number|null;
    public billingMode: CourseBillingMode|null;
    public paymentMode: ClassPaymentMode|null;
    public existingPrePaidId: number|null;
    public stockIdForNewBillingItem: number|null;
    public cardToken: string|null;
    public sessionId: number|null;
    public updateAttendance: boolean|null;
    public receivedAtLocationId: number|null;
    public emailInvoice: boolean|null;
    public emailReceipt: boolean|null;
    public sessionDateTime: string|null;

    public constructor(init?: Partial<PayForCourseRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PayForCourseRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<PayForClassResponse>(); }
}
(PayForCourseRequest as unknown)[immerable] = true;

export class RemoveStudentFromCourseRequest implements IReturn<ResponseBase<RemoveStudentFromClassResponse>>
{
    public courseId: number|null;
    public customerId: number|null;
    public cancellationFeeDue: boolean|null;
    public billingMode: CourseBillingMode|null;
    public paymentMode: ClassPaymentMode|null;
    public stockIdForNewBillingItem: number|null;
    public cardToken: string|null;
    public receivedAtLocationId: number|null;
    public emailInvoice: boolean|null;
    public emailReceipt: boolean|null;

    public constructor(init?: Partial<RemoveStudentFromCourseRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RemoveStudentFromCourseRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<RemoveStudentFromClassResponse>(); }
}
(RemoveStudentFromCourseRequest as unknown)[immerable] = true;

export class MarkCourseSessionAttendance implements IReturn<ResponseBase<boolean>>
{
    public sessionId: number|null;
    public customerId: number|null;
    public updateAttendance: boolean|null;

    public constructor(init?: Partial<MarkCourseSessionAttendance>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MarkCourseSessionAttendance'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(MarkCourseSessionAttendance as unknown)[immerable] = true;

export class MarkCourseSessionDna implements IReturn<ResponseBase<boolean>>
{
    public sessionId: number|null;
    public customerId: number|null;
    public updateDna: boolean|null;

    public constructor(init?: Partial<MarkCourseSessionDna>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MarkCourseSessionDna'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(MarkCourseSessionDna as unknown)[immerable] = true;

export class CourseSessionMarkAllAttendanceRequest implements IReturn<ResponseBase<boolean>>
{
    public sessionId: number|null;
    public allAttended: boolean|null;

    public constructor(init?: Partial<CourseSessionMarkAllAttendanceRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CourseSessionMarkAllAttendanceRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(CourseSessionMarkAllAttendanceRequest as unknown)[immerable] = true;

export class DeleteCourseRequest implements IReturn<ResponseBase<boolean>>
{
    public courseId: number|null;

    public constructor(init?: Partial<DeleteCourseRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteCourseRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(DeleteCourseRequest as unknown)[immerable] = true;

export class CommandBarVehicleRequest extends CommandBarRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<CommandBarVehicleRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CommandBarVehicleRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(CommandBarVehicleRequest as unknown)[immerable] = true;

export class CommandBarJobSheetRequest extends CommandBarRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<CommandBarJobSheetRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CommandBarJobSheetRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(CommandBarJobSheetRequest as unknown)[immerable] = true;

export class CommandBarEstimateRequest extends CommandBarRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<CommandBarEstimateRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CommandBarEstimateRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(CommandBarEstimateRequest as unknown)[immerable] = true;

export class SMRBaseRequest implements IReturn<ResponseBase<T>>
{
    public sessionToken: string;
    public vrm: string;
    public countryCode: string;
    public lookupType: string;
    public companyName: string;

    public constructor(init?: Partial<SMRBaseRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SMRBaseRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(SMRBaseRequest as unknown)[immerable] = true;

// @Route("/gds/smr/svg", "GET")
export class SMRSVGRequest
{
    public uri: string;

    public constructor(init?: Partial<SMRSVGRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SMRSVGRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(SMRSVGRequest as unknown)[immerable] = true;

// @Route("/gds/smr/getvehicledata", "POST")
export class VehicleDataRequest extends SMRBaseRequest implements IReturn<ResponseBase<T>>
{
    public defaultCategory: string;

    public constructor(init?: Partial<VehicleDataRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'VehicleDataRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(VehicleDataRequest as unknown)[immerable] = true;

// @Route("/gds/smr/getrepairmenu", "POST")
export class GetRepairMenuRequest extends SMRBaseRequest implements IReturn<ResponseBase<T>>
{
    public repairTypeID: string;
    public nodeID: string;
    public searchTerm: string;
    public group: string;

    public constructor(init?: Partial<GetRepairMenuRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GetRepairMenuRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(GetRepairMenuRequest as unknown)[immerable] = true;

// @Route("/gds/smr/getrepairinfo", "POST")
export class GetRepairInfoRequest extends SMRBaseRequest implements IReturn<ResponseBase<T>>
{
    public repairTypeID: string;
    public nodeID: string;

    public constructor(init?: Partial<GetRepairInfoRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GetRepairInfoRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(GetRepairInfoRequest as unknown)[immerable] = true;

// @Route("/gds/smr/getservicemenu", "POST")
export class GetServiceMenuRequest extends SMRBaseRequest implements IReturn<ResponseBase<T>>
{
    public measurementType: string;

    public constructor(init?: Partial<GetServiceMenuRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GetServiceMenuRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(GetServiceMenuRequest as unknown)[immerable] = true;

// @Route("/gds/smr/getservicedetails", "POST")
export class GetServiceDetailsRequest extends SMRBaseRequest implements IReturn<ResponseBase<T>>
{
    public systemId: string;
    public periodIds: string[] = [];

    public constructor(init?: Partial<GetServiceDetailsRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GetServiceDetailsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(GetServiceDetailsRequest as unknown)[immerable] = true;

// @Route("/gds/smr/getprocedures", "POST")
export class GetProceduresRequest extends SMRBaseRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<GetProceduresRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GetProceduresRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(GetProceduresRequest as unknown)[immerable] = true;

// @Route("/gds/smr/getprocedureinfo", "POST")
export class GetProcedureInfoRequest extends SMRBaseRequest implements IReturn<ResponseBase<T>>
{
    public storyId: string;

    public constructor(init?: Partial<GetProcedureInfoRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GetProcedureInfoRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(GetProcedureInfoRequest as unknown)[immerable] = true;

// @Route("/gds/smr/getadjustments", "POST")
export class GetAdjustmentsRequest extends SMRBaseRequest implements IReturn<ResponseBase<T>>
{
    public groupType: string;

    public constructor(init?: Partial<GetAdjustmentsRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAdjustmentsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(GetAdjustmentsRequest as unknown)[immerable] = true;

// @Route("/gds/smr/getdrawings", "POST")
export class GetDrawingsRequest extends SMRBaseRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<GetDrawingsRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDrawingsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(GetDrawingsRequest as unknown)[immerable] = true;

// @Route("/gds/smr/getenginelocations", "POST")
export class GetEngineLocationsRequest extends SMRBaseRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<GetEngineLocationsRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GetEngineLocationsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(GetEngineLocationsRequest as unknown)[immerable] = true;

// @Route("/gds/smr/geteobdlocations", "POST")
export class GetEobdLocationsRequest extends SMRBaseRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<GetEobdLocationsRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GetEobdLocationsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(GetEobdLocationsRequest as unknown)[immerable] = true;

// @Route("/gds/smr/getfuselocations", "POST")
export class GetFuseLocationsRequest extends SMRBaseRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<GetFuseLocationsRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GetFuseLocationsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(GetFuseLocationsRequest as unknown)[immerable] = true;

// @Route("/gds/smr/getlubricants", "POST")
export class GetLubricantsRequest extends SMRBaseRequest implements IReturn<ResponseBase<T>>
{
    public group: string;

    public constructor(init?: Partial<GetLubricantsRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GetLubricantsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(GetLubricantsRequest as unknown)[immerable] = true;

// @Route("/gds/smr/getrecall", "POST")
export class GetRecallRequest extends SMRBaseRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<GetRecallRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GetRecallRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(GetRecallRequest as unknown)[immerable] = true;

// @Route("/gds/smr/getwiringmenu", "POST")
export class GetWiringMenuRequest extends SMRBaseRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<GetWiringMenuRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GetWiringMenuRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(GetWiringMenuRequest as unknown)[immerable] = true;

// @Route("/gds/smr/getwiringdata", "POST")
export class GetWiringDataRequest extends SMRBaseRequest implements IReturn<ResponseBase<T>>
{
    public systemId: string;

    public constructor(init?: Partial<GetWiringDataRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GetWiringDataRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(GetWiringDataRequest as unknown)[immerable] = true;

// @Route("/gds/smr/getmanagementmenu", "POST")
export class GetManagementMenuRequest extends SMRBaseRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<GetManagementMenuRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GetManagementMenuRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(GetManagementMenuRequest as unknown)[immerable] = true;

// @Route("/gds/smr/getmanagementdata", "POST")
export class GetManagementDataRequest extends SMRBaseRequest implements IReturn<ResponseBase<T>>
{
    public managementId: string;
    public section: string;

    public constructor(init?: Partial<GetManagementDataRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GetManagementDataRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(GetManagementDataRequest as unknown)[immerable] = true;

// @Route("/gds/smr/getsystems", "POST")
export class GetSystemsRequest extends SMRBaseRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<GetSystemsRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSystemsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(GetSystemsRequest as unknown)[immerable] = true;

// @Route("/gds/smr/getnetwork", "POST")
export class GetNetworkRequest extends SMRBaseRequest implements IReturn<ResponseBase<T>>
{
    public systemGroupId: string;
    public systemTypeId: string;

    public constructor(init?: Partial<GetNetworkRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GetNetworkRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(GetNetworkRequest as unknown)[immerable] = true;

// @Route("/gds/smr/getnetworkdata", "POST")
export class GetNetworkDataRequest extends SMRBaseRequest implements IReturn<ResponseBase<T>>
{
    public systemTypeId: string;
    public componentId: string;

    public constructor(init?: Partial<GetNetworkDataRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GetNetworkDataRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(GetNetworkDataRequest as unknown)[immerable] = true;

// @Route("/gds/smr/getfaultcodes", "POST")
export class GetFaultCodesRequest extends SMRBaseRequest implements IReturn<ResponseBase<T>>
{
    public faultCodes: string;

    public constructor(init?: Partial<GetFaultCodesRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GetFaultCodesRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(GetFaultCodesRequest as unknown)[immerable] = true;

// @Route("/gds/smr/getdiagnosis", "POST")
export class GetDiagnosisRequest extends SMRBaseRequest implements IReturn<ResponseBase<T>>
{
    public managementId: string;
    public pCode: string;

    public constructor(init?: Partial<GetDiagnosisRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDiagnosisRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(GetDiagnosisRequest as unknown)[immerable] = true;

// @Route("/gds/smr/getdiagnosissystem", "POST")
export class GetDiagnosisSystemRequest extends SMRBaseRequest implements IReturn<ResponseBase<T>>
{
    public faultCodes: string;

    public constructor(init?: Partial<GetDiagnosisSystemRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDiagnosisSystemRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(GetDiagnosisSystemRequest as unknown)[immerable] = true;

// @Route("/gds/smr/getmakes", "POST")
export class GetMakesRequest extends SMRBaseRequest implements IReturn<ResponseBase<T>>
{
    public level: string;
    public filter: string;
    public vehicleId: string;

    public constructor(init?: Partial<GetMakesRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMakesRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(GetMakesRequest as unknown)[immerable] = true;

// @Route("/gds/smr/gettimingbelt", "POST")
export class GetTimingBeltRequest extends SMRBaseRequest implements IReturn<ResponseBase<T>>
{
    public systemId: string;

    public constructor(init?: Partial<GetTimingBeltRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTimingBeltRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(GetTimingBeltRequest as unknown)[immerable] = true;

// @Route("/gds/smr/getitemintervals", "POST")
export class GetItemIntervalsRequest extends SMRBaseRequest implements IReturn<ResponseBase<T>>
{
    public systemId: string;

    public constructor(init?: Partial<GetItemIntervalsRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GetItemIntervalsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(GetItemIntervalsRequest as unknown)[immerable] = true;

// @Route("/gds/smr/subjectlist", "POST")
export class GetSubjectsRequest extends SMRBaseRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<GetSubjectsRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSubjectsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(GetSubjectsRequest as unknown)[immerable] = true;

export class JobSheetAdvancedSearchRequest extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<JobSheetAdvancedSearchResponse>>
{
    public vehicleId: number|null;
    public customerId: number|null;

    public constructor(init?: Partial<JobSheetAdvancedSearchRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'JobSheetAdvancedSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<JobSheetAdvancedSearchResponse>(); }
}
(JobSheetAdvancedSearchRequest as unknown)[immerable] = true;

export class CountJobSheetRequest implements IReturn<ResponseBase<number>>
{
    public vehicleId: number|null;
    public customerId: number|null;

    public constructor(init?: Partial<CountJobSheetRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CountJobSheetRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<number>(); }
}
(CountJobSheetRequest as unknown)[immerable] = true;

export class CreateInvoiceFromJobSheetRequest implements IReturn<ResponseBase<number>>
{
    public jobSheetId: number|null;

    public constructor(init?: Partial<CreateInvoiceFromJobSheetRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateInvoiceFromJobSheetRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<number>(); }
}
(CreateInvoiceFromJobSheetRequest as unknown)[immerable] = true;

export class CreateInvoiceFromWorksheetRequest implements IReturn<ResponseBase<number>>
{
    public worksheetId: number|null;
    public sheetType: WorkSheetType|null;

    public constructor(init?: Partial<CreateInvoiceFromWorksheetRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateInvoiceFromWorksheetRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<number>(); }
}
(CreateInvoiceFromWorksheetRequest as unknown)[immerable] = true;

export class JobsheetsExportRequest implements IReturn<string>
{
    public query: JobSheetAdvancedSearchRequest;

    public constructor(init?: Partial<JobsheetsExportRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'JobsheetsExportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return ''; }
}
(JobsheetsExportRequest as unknown)[immerable] = true;

export class GetPartsCatalogueRequest implements IReturn<ResponseBase<PartsCatalogueResponse>>
{
    public id: number|null;

    public constructor(init?: Partial<GetPartsCatalogueRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPartsCatalogueRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<PartsCatalogueResponse>(); }
}
(GetPartsCatalogueRequest as unknown)[immerable] = true;

export class UpdatePartsCatalogueRequest extends PartsCatalogueResponse implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<UpdatePartsCatalogueRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdatePartsCatalogueRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(UpdatePartsCatalogueRequest as unknown)[immerable] = true;

export class VehicleRemindersRequest implements IReturn<ResponseBase<VehicleRemindersResponse>>
{
    public id: number|null;

    public constructor(init?: Partial<VehicleRemindersRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'VehicleRemindersRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<VehicleRemindersResponse>(); }
}
(VehicleRemindersRequest as unknown)[immerable] = true;

export class GetVehicleReminderRequest implements IReturn<ResponseBase<VehicleRemindersResponse>>
{
    public id: number|null;

    public constructor(init?: Partial<GetVehicleReminderRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetVehicleReminderRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<VehicleRemindersResponse>(); }
}
(GetVehicleReminderRequest as unknown)[immerable] = true;

export class CreateVehicleRemindersRequest implements IReturn<ResponseBase<VehicleRemindersResponse>>
{
    public name: string;
    public createdDate: string|null;
    public locked: boolean|null;
    public active: boolean|null;
    public leadDays1: number|null;
    public leadDays2: number|null;
    public leadDays3: number|null;
    public leadDays4: number|null;
    public leadDays5: number|null;
    public leadDays1TemplateName: string|null;
    public leadDays2TemplateName: string|null;
    public leadDays3TemplateName: string|null;
    public leadDays4TemplateName: string|null;
    public leadDays5TemplateName: string|null;

    public constructor(init?: Partial<CreateVehicleRemindersRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateVehicleRemindersRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<VehicleRemindersResponse>(); }
}
(CreateVehicleRemindersRequest as unknown)[immerable] = true;

export class SaveVehicleRemindersRequest implements IReturn<ResponseBase<VehicleRemindersResponse>>
{
    public id: number|null;
    public name: string;
    public createdDate: string|null;
    public locked: boolean|null;
    public active: boolean|null;
    public leadDays1: number|null;
    public leadDays2: number|null;
    public leadDays3: number|null;
    public leadDays4: number|null;
    public leadDays5: number|null;
    public leadDays1TemplateName: string|null;
    public leadDays2TemplateName: string|null;
    public leadDays3TemplateName: string|null;
    public leadDays4TemplateName: string|null;
    public leadDays5TemplateName: string|null;

    public constructor(init?: Partial<SaveVehicleRemindersRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveVehicleRemindersRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<VehicleRemindersResponse>(); }
}
(SaveVehicleRemindersRequest as unknown)[immerable] = true;

export class DeleteVehicleRemindersRequest implements IReturn<ResponseBase<boolean>>, IHasId
{
    public id: number|null;

    public constructor(init?: Partial<DeleteVehicleRemindersRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteVehicleRemindersRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(DeleteVehicleRemindersRequest as unknown)[immerable] = true;

export class VehicleQuickSearchRequest implements IReturn<ResponseBase<VehicleAdvancedSearchResponse>>
{
    public searchTerm: string;
    public customerId: number|null;

    public constructor(init?: Partial<VehicleQuickSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'VehicleQuickSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<VehicleAdvancedSearchResponse>(); }
}
(VehicleQuickSearchRequest as unknown)[immerable] = true;

export class VehicleDuplicateCheckRequest implements IReturn<ResponseBase<VehicleAdvancedSearchResponse>>
{
    public registrationNumber: string;
    public customerId: number|null;

    public constructor(init?: Partial<VehicleDuplicateCheckRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'VehicleDuplicateCheckRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<VehicleAdvancedSearchResponse>(); }
}
(VehicleDuplicateCheckRequest as unknown)[immerable] = true;

export class VehicleAdvancedSearchRequest implements IReturn<ResponseBase<VehicleAdvancedSearchResponse>>
{
    public customerId: number|null;
    public registrationNumber: string;
    public make: string;
    public model: string;
    public nextServiceDue: string|null;
    public nextMOTDue: string|null;
    public customerName: string;
    public number: string;
    public take: number|null;
    public sort: QueryField[] = [];
    public skip: number|null;
    public filterConditions: SearchFilterCondition[] = [];

    public constructor(init?: Partial<VehicleAdvancedSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'VehicleAdvancedSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<VehicleAdvancedSearchResponse>(); }
}
(VehicleAdvancedSearchRequest as unknown)[immerable] = true;

export class VehicleRequest implements IReturn<ResponseBase<VehicleResponse>>
{
    public id: number|null;

    public constructor(init?: Partial<VehicleRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'VehicleRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<VehicleResponse>(); }
}
(VehicleRequest as unknown)[immerable] = true;

export class CreateVehicleRequest implements IReturn<ResponseBase<VehicleResponse>>
{
    public customerId: number|null;
    // @Required()
    public registrationNumber: string;

    public make: string;
    public model: string;
    public engineCC: string;
    public vin: string;
    public engine: string;
    public nextServiceDue: string|null;
    public nextMOTDue: string|null;
    public dateOfRegistration: string|null;
    public yearOfManufacture: string;
    public designGrossWeight: string;
    public notes: string;
    public colour: string;
    public fuelType: string;
    public lastMileage: number|null;
    public lastMileageDate: string|null;
    public lastMileageUnit: string;
    public originalRegistrationNumber: string;
    public paintCode: string;
    public status: string;
    public taxDueDate: string|null;
    public dateOfManufacture: string|null;
    public transmission: string|null;
    public ulezCompliant: boolean|null;
    public customer: CustomerSaveRequest;
    public data: JsonField;
    public locationId: number|null;
    public registrationOrigin: string;
    public reminders: VehicleRemindersDetails[] = [];
    public motHistory: MOTHistoryResponse;

    public constructor(init?: Partial<CreateVehicleRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateVehicleRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<VehicleResponse>(); }
}
(CreateVehicleRequest as unknown)[immerable] = true;

export class UpdateVehicleOwnerRequest implements IReturn<ResponseBase<T>>
{
    public customerId: number|null;
    public vehicleId: number|null;

    public constructor(init?: Partial<UpdateVehicleOwnerRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateVehicleOwnerRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(UpdateVehicleOwnerRequest as unknown)[immerable] = true;

export class SaveVehicleRequest implements IReturn<ResponseBase<VehicleResponse>>
{
    public id: number|null;
    public customerId: number|null;
    public registrationNumber: string;
    public make: string;
    public model: string;
    public engineCC: string;
    public vin: string;
    public engine: string;
    public nextServiceDue: string|null;
    public nextMOTDue: string|null;
    public dateOfRegistration: string|null;
    public yearOfManufacture: string;
    public designGrossWeight: string;
    public notes: string;
    public colour: string;
    public fuelType: string;
    public lastMileage: number|null;
    public lastMileageDate: string|null;
    public lastMileageUnit: string;
    public originalRegistrationNumber: string;
    public paintCode: string;
    public status: string;
    public taxDueDate: string|null;
    public dateOfManufacture: string|null;
    public transmission: string|null;
    public ulezCompliant: boolean|null;
    public customer: CustomerSaveRequest;
    public data: JsonField;
    public locationId: number|null;
    public emailReminders: boolean|null;
    public smsReminders: boolean|null;
    public registrationOrigin: string;
    public reminders: VehicleRemindersDetails[] = [];
    public motHistory: MOTHistoryResponse;

    public constructor(init?: Partial<SaveVehicleRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveVehicleRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<VehicleResponse>(); }
}
(SaveVehicleRequest as unknown)[immerable] = true;

// @Route("/vehicles/byreg")
export class VehicleByRegistrationRequest implements IReturn<ResponseBase<VehicleResponse>>
{
    public term: string;
    public startIdx: number|null;
    public endIdx: number|null;

    public constructor(init?: Partial<VehicleByRegistrationRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'VehicleByRegistrationRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<VehicleResponse>(); }
}
(VehicleByRegistrationRequest as unknown)[immerable] = true;

export class VehiclesForCustomerRequest implements IReturn<ResponseBase<T>>
{
    public customerId: number|null;

    public constructor(init?: Partial<VehiclesForCustomerRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'VehiclesForCustomerRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(VehiclesForCustomerRequest as unknown)[immerable] = true;

export class VehicleNotesAdvancedSearchRequest implements IReturn<ResponseBase<VehicleNote>>, IHasId
{
    public id: number|null;
    public take: number|null;
    public skip: number|null;
    public filterConditions: SearchFilterCondition[] = [];

    public constructor(init?: Partial<VehicleNotesAdvancedSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'VehicleNotesAdvancedSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<VehicleNote>(); }
}
(VehicleNotesAdvancedSearchRequest as unknown)[immerable] = true;

export class VehicleNoteRequest implements IReturn<ResponseBase<VehicleNote>>, IHasId
{
    public id: number|null;

    public constructor(init?: Partial<VehicleNoteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'VehicleNoteRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<VehicleNote>(); }
}
(VehicleNoteRequest as unknown)[immerable] = true;

export class SaveVehicleNoteRequest implements IReturn<ResponseBase<VehicleNote>>, IHasId
{
    public id: number|null;
    public vehicleId: number|null;
    public notes: string;
    public title: string;
    public lastModifyDateTime: string|null;
    public lastUserId: number|null;
    public alert: boolean|null;
    public securityLevel: number|null;

    public constructor(init?: Partial<SaveVehicleNoteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveVehicleNoteRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<VehicleNote>(); }
}
(SaveVehicleNoteRequest as unknown)[immerable] = true;

export class DeleteVehicleNoteRequest implements IReturn<ResponseBase<boolean>>, IHasId
{
    public id: number|null;

    public constructor(init?: Partial<DeleteVehicleNoteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteVehicleNoteRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(DeleteVehicleNoteRequest as unknown)[immerable] = true;

export class CountVehicleNoteRequest implements IReturn<ResponseBase<number>>
{
    public vehicleId: number|null;

    public constructor(init?: Partial<CountVehicleNoteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CountVehicleNoteRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<number>(); }
}
(CountVehicleNoteRequest as unknown)[immerable] = true;

export class DeleteVehicleRequest implements IReturn<ResponseBase<boolean>>, IHasId
{
    public id: number|null;

    public constructor(init?: Partial<DeleteVehicleRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteVehicleRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(DeleteVehicleRequest as unknown)[immerable] = true;

export class VehicleGuardRequest implements IReturn<ResponseBase<VehicleGuardResponse>>
{
    public id: number|null;

    public constructor(init?: Partial<VehicleGuardRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'VehicleGuardRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<VehicleGuardResponse>(); }
}
(VehicleGuardRequest as unknown)[immerable] = true;

export class VehicleGetExistingRequest implements IReturn<ResponseBase<VehicleResponse>>
{
    public registrationNumber: string;
    public id: number|null;

    public constructor(init?: Partial<VehicleGetExistingRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'VehicleGetExistingRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<VehicleResponse>(); }
}
(VehicleGetExistingRequest as unknown)[immerable] = true;

export class VehicleRemindersDetailsRequest implements IReturn<ResponseBase<VehicleRemindersDetailsResponse>>
{
    public id: number|null;

    public constructor(init?: Partial<VehicleRemindersDetailsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'VehicleRemindersDetailsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<VehicleRemindersDetailsResponse>(); }
}
(VehicleRemindersDetailsRequest as unknown)[immerable] = true;

export class VehiclesExportRequest implements IReturn<string>
{
    public query: VehicleAdvancedSearchRequest;

    public constructor(init?: Partial<VehiclesExportRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'VehiclesExportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return ''; }
}
(VehiclesExportRequest as unknown)[immerable] = true;

// @Route("/gds/vrmlookup", "POST")
export class VRMLookupRequest implements IReturn<ResponseBase<T>>
{
    public vrm: string;
    public countryCode: string;
    public taxMotOnly: boolean|null;
    public motHistoryOnly: boolean|null;

    public constructor(init?: Partial<VRMLookupRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'VRMLookupRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(VRMLookupRequest as unknown)[immerable] = true;

export class GetWorkSheetRequest implements IReturn<ResponseBase<WorkSheetResponse>>
{
    public id: number|null;

    public constructor(init?: Partial<GetWorkSheetRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetWorkSheetRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<WorkSheetResponse>(); }
}
(GetWorkSheetRequest as unknown)[immerable] = true;

export class WorksheetQuickSearchRequest extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<WorkSheetAdvancedSearchResponse>>
{
    public type: WorkSheetType|null;
    public vehicleId: number|null;
    public customerId: number|null;
    public worksheetId: number|null;

    public constructor(init?: Partial<WorksheetQuickSearchRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'WorksheetQuickSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<WorkSheetAdvancedSearchResponse>(); }
}
(WorksheetQuickSearchRequest as unknown)[immerable] = true;

export class WorksheetAdvancedSearchRequest extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<WorkSheetAdvancedSearchResponse>>
{
    public type: WorkSheetType|null;
    public vehicleId: number|null;
    public customerId: number|null;

    public constructor(init?: Partial<WorksheetAdvancedSearchRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'WorksheetAdvancedSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<WorkSheetAdvancedSearchResponse>(); }
}
(WorksheetAdvancedSearchRequest as unknown)[immerable] = true;

export class DeleteWorksheetRequest implements IReturn<ResponseBase<boolean>>
{
    public id: number|null;

    public constructor(init?: Partial<DeleteWorksheetRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteWorksheetRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(DeleteWorksheetRequest as unknown)[immerable] = true;

export class CountEstimateRequest implements IReturn<ResponseBase<number>>
{
    public vehicleId: number|null;
    public customerId: number|null;

    public constructor(init?: Partial<CountEstimateRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CountEstimateRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<number>(); }
}
(CountEstimateRequest as unknown)[immerable] = true;

export class CreateWorkSheetRequest extends WorkSheet implements IReturn<ResponseBase<T>>
{
    public vehicle: SaveVehicleRequest;
    public customer: CustomerSaveRequest;
    public items: WorkSheetItemExpanded[] = [];
    public dueDate: string|null;

    public constructor(init?: Partial<CreateWorkSheetRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateWorkSheetRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(CreateWorkSheetRequest as unknown)[immerable] = true;

export class GetWorksheetInvoiceByAppointmentId implements IReturn<ResponseBase<T>>
{
    public id: number|null;

    public constructor(init?: Partial<GetWorksheetInvoiceByAppointmentId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetWorksheetInvoiceByAppointmentId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(GetWorksheetInvoiceByAppointmentId as unknown)[immerable] = true;

export class ConvertWorksheetRequest implements IReturn<ResponseBase<boolean>>
{

    public constructor(init?: Partial<ConvertWorksheetRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ConvertWorksheetRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ConvertWorksheetRequest as unknown)[immerable] = true;

export class CloneWorkSheetRequest implements IReturn<WorkSheetResponse>
{

    public constructor(init?: Partial<CloneWorkSheetRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CloneWorkSheetRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new WorkSheetResponse(); }
}
(CloneWorkSheetRequest as unknown)[immerable] = true;

export class CreateInvoiceFromEstimateRequest implements IReturn<ResponseBase<number>>
{

    public constructor(init?: Partial<CreateInvoiceFromEstimateRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateInvoiceFromEstimateRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<number>(); }
}
(CreateInvoiceFromEstimateRequest as unknown)[immerable] = true;

export class SaveWorkSheetRequest extends CreateWorkSheetRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<SaveWorkSheetRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveWorkSheetRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(SaveWorkSheetRequest as unknown)[immerable] = true;

export class CreateEstimateFromJobSheetRequest extends CreateWorkSheetRequest implements IReturn<EstimateResponse>
{

    public constructor(init?: Partial<CreateEstimateFromJobSheetRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateEstimateFromJobSheetRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new EstimateResponse(); }
}
(CreateEstimateFromJobSheetRequest as unknown)[immerable] = true;

export class CreatePartsOrderRequest implements IReturn<ResponseBase<T>>
{
    public secretKey: string;
    public account: string;
    public parts360UserName: string;
    public password: string;
    public country: string;
    public vrm: string;

    public constructor(init?: Partial<CreatePartsOrderRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreatePartsOrderRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(CreatePartsOrderRequest as unknown)[immerable] = true;

export class GetPartsOrderRequest implements IReturn<ResponseBase<T>>
{
    public secretKey: string;
    public account: string;
    public parts360UserName: string;
    public token: string;
    public country: string;

    public constructor(init?: Partial<GetPartsOrderRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPartsOrderRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(GetPartsOrderRequest as unknown)[immerable] = true;

export class SubmitPartsOrderRequest implements IReturn<ResponseBase<T>>
{
    public secretKey: string;
    public customerId: string;
    public orderNumber: string;
    public vrm: string;
    public country: string;
    public products: SubmitProducts[] = [];

    public constructor(init?: Partial<SubmitPartsOrderRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SubmitPartsOrderRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(SubmitPartsOrderRequest as unknown)[immerable] = true;

export class EstimatesExportRequest implements IReturn<string>
{
    public query: WorksheetAdvancedSearchRequest;

    public constructor(init?: Partial<EstimatesExportRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EstimatesExportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return ''; }
}
(EstimatesExportRequest as unknown)[immerable] = true;

export class AddHaynesProWorkItemsRequest implements IReturn<ResponseBase<boolean>>
{
    public id: number|null;
    public type: string;
    public items: RepairTimeData[] = [];

    public constructor(init?: Partial<AddHaynesProWorkItemsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AddHaynesProWorkItemsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(AddHaynesProWorkItemsRequest as unknown)[immerable] = true;

/** @description Sign In */
// @Route("/auth", "GET,POST")
// @Route("/auth/{provider}", "GET,POST")
// @Api(Description="Sign In")
// @DataContract
export class Authenticate implements IReturn<AuthenticateResponse>, IPost
{
    /** @description AuthProvider, e.g. credentials */
    // @DataMember(Order=1)
    public provider: string|null;

    // @DataMember(Order=2)
    public userName: string|null;

    // @DataMember(Order=3)
    public password: string|null;

    // @DataMember(Order=4)
    public rememberMe: boolean|null;

    // @DataMember(Order=5)
    public accessToken: string|null;

    // @DataMember(Order=6)
    public accessTokenSecret: string|null;

    // @DataMember(Order=7)
    public returnUrl: string|null;

    // @DataMember(Order=8)
    public errorView: string|null;

    // @DataMember(Order=9)
    public meta: { [index:string]: string; }|null;

    public constructor(init?: Partial<Authenticate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'Authenticate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AuthenticateResponse(); }
}
(Authenticate as unknown)[immerable] = true;

// @Route("/assignroles", "POST")
// @DataContract
export class AssignRoles implements IReturn<AssignRolesResponse>, IPost
{
    // @DataMember(Order=1)
    public userName: string|null;

    // @DataMember(Order=2)
    public permissions: string[]|null;

    // @DataMember(Order=3)
    public roles: string[]|null;

    // @DataMember(Order=4)
    public meta: { [index:string]: string; }|null;

    public constructor(init?: Partial<AssignRoles>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AssignRoles'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AssignRolesResponse(); }
}
(AssignRoles as unknown)[immerable] = true;

// @Route("/unassignroles", "POST")
// @DataContract
export class UnAssignRoles implements IReturn<UnAssignRolesResponse>, IPost
{
    // @DataMember(Order=1)
    public userName: string|null;

    // @DataMember(Order=2)
    public permissions: string[]|null;

    // @DataMember(Order=3)
    public roles: string[]|null;

    // @DataMember(Order=4)
    public meta: { [index:string]: string; }|null;

    public constructor(init?: Partial<UnAssignRoles>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UnAssignRoles'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UnAssignRolesResponse(); }
}
(UnAssignRoles as unknown)[immerable] = true;

// @Route("/access-token")
// @DataContract
export class GetAccessToken implements IReturn<GetAccessTokenResponse>, IPost
{
    // @DataMember(Order=1)
    public refreshToken: string|null;

    // @DataMember(Order=2)
    public meta: { [index:string]: string; }|null;

    public constructor(init?: Partial<GetAccessToken>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAccessToken'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetAccessTokenResponse(); }
}
(GetAccessToken as unknown)[immerable] = true;

